
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0ba6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0ba6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("02ePV", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $006bb2427792c9b9$export$816aac48d41c2f81, (v) => $006bb2427792c9b9$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $006bb2427792c9b9$export$3bb88615cd12cb3b, (v) => $006bb2427792c9b9$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $006bb2427792c9b9$export$d46163d5c045f347, (v) => $006bb2427792c9b9$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $006bb2427792c9b9$export$8ee75c97f0333f15, (v) => $006bb2427792c9b9$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $006bb2427792c9b9$export$d1c113b83e1f881a, (v) => $006bb2427792c9b9$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $006bb2427792c9b9$export$ff78c4883554845d, (v) => $006bb2427792c9b9$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $006bb2427792c9b9$export$816aac48d41c2f81;
var $006bb2427792c9b9$export$3bb88615cd12cb3b;
var $006bb2427792c9b9$export$d46163d5c045f347;
var $006bb2427792c9b9$export$8ee75c97f0333f15;
var $006bb2427792c9b9$export$d1c113b83e1f881a;
var $006bb2427792c9b9$export$ff78c4883554845d;
'use strict';
$006bb2427792c9b9$export$816aac48d41c2f81 = 1;
$006bb2427792c9b9$export$3bb88615cd12cb3b = 4;
$006bb2427792c9b9$export$d46163d5c045f347 = 16;
$006bb2427792c9b9$export$8ee75c97f0333f15 = 1;
$006bb2427792c9b9$export$d1c113b83e1f881a = 536870912;
$006bb2427792c9b9$export$ff78c4883554845d = 0;

});

parcelRegister("8RuUj", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    'use strict';
    var aa = (parcelRequire("acw62")), ba = (parcelRequire("jRD9C")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = Symbol.for("react.element"), ha = Symbol.for("react.portal"), ia = Symbol.for("react.fragment"), ja = Symbol.for("react.strict_mode"), ka = Symbol.for("react.profiler"), la = Symbol.for("react.provider"), ma = Symbol.for("react.context"), na = Symbol.for("react.forward_ref"), oa = Symbol.for("react.suspense"), pa = Symbol.for("react.suspense_list"), qa = Symbol.for("react.memo"), ra = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var sa = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var ta = Symbol.iterator;
    function ua(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ta && a[ta] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function va(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ia:
                return "Fragment";
            case ha:
                return "Portal";
            case ka:
                return "Profiler";
            case ja:
                return "StrictMode";
            case oa:
                return "Suspense";
            case pa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ma:
                return (a.displayName || "Context") + ".Consumer";
            case la:
                return (a._context.displayName || "Context") + ".Provider";
            case na:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case qa:
                return b = a.displayName || null, null !== b ? b : va(a.type) || "Memo";
            case ra:
                b = a._payload;
                a = a._init;
                try {
                    return va(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return va(b);
            case 8:
                return b === ja ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function ya(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function za(a) {
        if (ya(a) !== a) throw Error(n(188));
    }
    function Aa(a) {
        var b = a.alternate;
        if (!b) {
            b = ya(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return za(e), a;
                    if (f === d) return za(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Ba(a) {
        a = Aa(a);
        return null !== a ? Ca(a) : null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ca(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Da(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Da(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac(a) {
        if (void 0 === $b) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            $b = b && b[1] || "";
        }
        return "\n" + $b + a;
    }
    var bc = !1;
    function cc(a, b) {
        if (!a || bc) return "";
        bc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            bc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? ac(a) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a) {
        return {
            current: a
        };
    }
    function x(a) {
        0 > fc || (a.current = ec[fc], ec[fc] = null, fc--);
    }
    function y(a, b) {
        fc++;
        ec[fc] = a.current;
        a.current = b;
    }
    var hc = {}, A = gc(hc), B = gc(!1), ic = hc;
    function jc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return hc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function C(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function kc() {
        x(B);
        x(A);
    }
    function lc(a, b, c) {
        if (A.current !== hc) throw Error(n(168));
        y(A, b);
        y(B, c);
    }
    function mc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, xa(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function nc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || hc;
        ic = A.current;
        y(A, a);
        y(B, B.current);
        return !0;
    }
    function oc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = mc(a, b, ic), d.__reactInternalMemoizedMergedChildContext = a, x(B), x(A), y(A, a)) : x(B);
        y(B, c);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (rc(a) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function wc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = vc(h) : (f &= g, 0 !== f && (d = vc(f)));
        } else g = c & ~e, 0 !== g ? d = vc(g) : 0 !== f && (d = vc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - qc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function xc(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function yc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - qc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = xc(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function zc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Bc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - qc(b);
        a[b] = c;
    }
    function Cc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - qc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Dc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - qc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var D = 0;
    function Ec(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba.unstable_scheduleCallback, Gc = ba.unstable_cancelCallback, Hc = ba.unstable_shouldYield, Ic = ba.unstable_requestPaint, E = ba.unstable_now, Jc = ba.unstable_ImmediatePriority, Kc = ba.unstable_UserBlockingPriority, Lc = ba.unstable_NormalPriority, Mc = ba.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a) {
        if (Oc && "function" === typeof Oc.onCommitFiberRoot) try {
            Oc.onCommitFiberRoot(Nc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Qc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = !1, Uc = !1;
    function Vc(a) {
        null === Sc ? Sc = [
            a
        ] : Sc.push(a);
    }
    function Wc(a) {
        Tc = !0;
        Vc(a);
    }
    function Xc() {
        if (!Uc && null !== Sc) {
            Uc = !0;
            var a = 0, b = D;
            try {
                var c = Sc;
                for(D = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Sc = null;
                Tc = !1;
            } catch (e) {
                throw null !== Sc && (Sc = Sc.slice(a + 1)), Fc(Jc, Xc), e;
            } finally{
                D = b, Uc = !1;
            }
        }
        return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a, b) {
        if (Rc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!dc.call(b, e) || !Rc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function $c(a) {
        switch(a.tag){
            case 5:
                return ac(a.type);
            case 16:
                return ac("Lazy");
            case 13:
                return ac("Suspense");
            case 19:
                return ac("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = cc(a.type, !1), a;
            case 11:
                return a = cc(a.type.render, !1), a;
            case 1:
                return a = cc(a.type, !0), a;
            default:
                return "";
        }
    }
    function ad(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var bd = gc(null), cd = null, dd = null, ed = null;
    function fd() {
        ed = dd = cd = null;
    }
    function gd(a, b, c) {
        Ta ? (y(bd, b._currentValue), b._currentValue = c) : (y(bd, b._currentValue2), b._currentValue2 = c);
    }
    function hd(a) {
        var b = bd.current;
        x(bd);
        Ta ? a._currentValue = b : a._currentValue2 = b;
    }
    function id(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function jd(a, b) {
        cd = a;
        ed = dd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (kd = !0), a.firstContext = null);
    }
    function ld(a) {
        var b = Ta ? a._currentValue : a._currentValue2;
        if (ed !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === dd) {
                if (null === cd) throw Error(n(308));
                dd = a;
                cd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else dd = dd.next = a;
        }
        return b;
    }
    var md = null, nd = !1;
    function od(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function pd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function qd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function rd(a, b) {
        var c = a.updateQueue;
        null !== c && (c = c.shared, null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = c.interleaved, null === a ? (b.next = b, null === md ? md = [
            c
        ] : md.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
    }
    function sd(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    function td(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ud(a, b, c, d) {
        var e = a.updateQueue;
        nd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var v = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var r = h.lane, z = h.eventTime;
                if ((d & r) === r) {
                    null !== m && (m = m.next = {
                        eventTime: z,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var q = a, N = h;
                        r = b;
                        z = c;
                        switch(N.tag){
                            case 1:
                                q = N.payload;
                                if ("function" === typeof q) {
                                    v = q.call(z, v, r);
                                    break a;
                                }
                                v = q;
                                break a;
                            case 3:
                                q.flags = q.flags & -65537 | 128;
                            case 0:
                                q = N.payload;
                                r = "function" === typeof q ? q.call(z, v, r) : q;
                                if (null === r || void 0 === r) break a;
                                v = ca({}, v, r);
                                break a;
                            case 2:
                                nd = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                        h
                    ] : r.push(h));
                } else z = {
                    eventTime: z,
                    lane: r,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = z, k = v) : m = m.next = z, g |= r;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = v);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            vd |= g;
            a.lanes = g;
            a.memoizedState = v;
        }
    }
    function wd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var xd = (new aa.Component).refs;
    function yd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var Bd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? ya(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = H(), d = zd(a), e = qd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            rd(a, e);
            b = Ad(a, d, c);
            null !== b && sd(b, a, d);
        }
    };
    function Cd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Zc(c, d) || !Zc(e, f) : !0;
    }
    function Dd(a, b, c) {
        var d = !1, e = hc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = ld(f) : (e = C(b) ? ic : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? jc(a, e) : hc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Bd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Ed(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Bd.enqueueReplaceState(b, b.state, null);
    }
    function Fd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = xd;
        od(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = ld(f) : (f = C(b) ? ic : A.current, e.context = jc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Bd.enqueueReplaceState(e, e.state, null), ud(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a, b) {
        Gd[Hd++] = Jd;
        Gd[Hd++] = Id;
        Id = a;
        Jd = b;
    }
    function Qd(a, b, c) {
        Kd[Ld++] = Nd;
        Kd[Ld++] = Od;
        Kd[Ld++] = Md;
        Md = a;
        var d = Nd;
        a = Od;
        var e = 32 - qc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - qc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            Nd = 1 << 32 - qc(b) + e | c << e | d;
            Od = f + a;
        } else Nd = 1 << f | c << e | d, Od = a;
    }
    function Rd(a) {
        null !== a.return && (Pd(a, 1), Qd(a, 1, 0));
    }
    function Sd(a) {
        for(; a === Id;)Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
        for(; a === Md;)Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I = !1, Vd = !1, Wd = null;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = Mb(b), !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = null, !0) : !1;
            case 13:
                b = Hb(b);
                if (null !== b) {
                    var c = null !== Md ? {
                        id: Nd,
                        overflow: Od
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = Yd(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    Td = a;
                    Ud = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function ae(a) {
        if (I) {
            var b = Ud;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    if ($d(a)) throw Error(n(418));
                    b = Lb(c);
                    var d = Td;
                    b && Zd(a, b) ? Xd(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, Td = a);
                }
            } else {
                if ($d(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                I = !1;
                Td = a;
            }
        }
    }
    function be(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Td = a;
    }
    function ce(a) {
        if (!p || a !== Td) return !1;
        if (!I) return be(a), I = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Xb(a.type) && !Oa(a.type, a.memoizedProps))) {
            var b = Ud;
            if (b) {
                if ($d(a)) {
                    for(a = Ud; a;)a = Lb(a);
                    throw Error(n(418));
                }
                for(; b;)Xd(a, b), b = Lb(b);
            }
        }
        be(a);
        if (13 === a.tag) {
            if (!p) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            Ud = Sb(a);
        } else Ud = Td ? Lb(a.stateNode) : null;
        return !0;
    }
    function de() {
        p && (Ud = Td = null, Vd = I = !1);
    }
    function ee(a) {
        null === Wd ? Wd = [
            a
        ] : Wd.push(a);
    }
    function fe(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    b === xd && (b = e.refs = {});
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function ge(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function he(a) {
        var b = a._init;
        return b(a._payload);
    }
    function ie(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = je(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = ke(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ia) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === ra && he(f) === b.type)) return d = e(b, c.props), d.ref = fe(a, b, c), d.return = a, d;
            d = le(c.type, c.key, c.props, null, a.mode, d);
            d.ref = fe(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = me(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = ne(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function v(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = ke("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case fa:
                        return c = le(b.type, b.key, b.props, null, a.mode, c), c.ref = fe(a, null, b), c.return = a, c;
                    case ha:
                        return b = me(b, a.mode, c), b.return = a, b;
                    case ra:
                        var d = b._init;
                        return v(a, d(b._payload), c);
                }
                if (Ea(b) || ua(b)) return b = ne(b, a.mode, c, null), b.return = a, b;
                ge(a, b);
            }
            return null;
        }
        function r(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case fa:
                        return c.key === e ? k(a, b, c, d) : null;
                    case ha:
                        return c.key === e ? l(a, b, c, d) : null;
                    case ra:
                        return e = c._init, r(a, b, e(c._payload), d);
                }
                if (Ea(c) || ua(c)) return null !== e ? null : m(a, b, c, d, null);
                ge(a, c);
            }
            return null;
        }
        function z(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case ha:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case ra:
                        var f = d._init;
                        return z(a, b, c, f(d._payload), e);
                }
                if (Ea(d) || ua(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                ge(b, d);
            }
            return null;
        }
        function q(e, g, h, k) {
            for(var l = null, m = null, w = g, u = g = 0, t = null; null !== w && u < h.length; u++){
                w.index > u ? (t = w, w = null) : t = w.sibling;
                var q = r(e, w, h[u], k);
                if (null === q) {
                    null === w && (w = t);
                    break;
                }
                a && w && null === q.alternate && b(e, w);
                g = f(q, g, u);
                null === m ? l = q : m.sibling = q;
                m = q;
                w = t;
            }
            if (u === h.length) return c(e, w), I && Pd(e, u), l;
            if (null === w) {
                for(; u < h.length; u++)w = v(e, h[u], k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
                I && Pd(e, u);
                return l;
            }
            for(w = d(e, w); u < h.length; u++)t = z(w, e, u, h[u], k), null !== t && (a && null !== t.alternate && w.delete(null === t.key ? u : t.key), g = f(t, g, u), null === m ? l = t : m.sibling = t, m = t);
            a && w.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function N(e, g, h, k) {
            var l = ua(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var w = l = null, m = g, u = g = 0, q = null, t = h.next(); null !== m && !t.done; u++, t = h.next()){
                m.index > u ? (q = m, m = null) : q = m.sibling;
                var V = r(e, m, t.value, k);
                if (null === V) {
                    null === m && (m = q);
                    break;
                }
                a && m && null === V.alternate && b(e, m);
                g = f(V, g, u);
                null === w ? l = V : w.sibling = V;
                w = V;
                m = q;
            }
            if (t.done) return c(e, m), I && Pd(e, u), l;
            if (null === m) {
                for(; !t.done; u++, t = h.next())t = v(e, t.value, k), null !== t && (g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
                I && Pd(e, u);
                return l;
            }
            for(m = d(e, m); !t.done; u++, t = h.next())t = z(m, e, u, t.value, k), null !== t && (a && null !== t.alternate && m.delete(null === t.key ? u : t.key), g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function da(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ia && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case fa:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ia) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === ra && he(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = fe(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ia ? (d = ne(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = le(f.type, f.key, f.props, null, a.mode, h), h.ref = fe(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case ha:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = me(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case ra:
                        return l = f._init, da(a, d, l(f._payload), h);
                }
                if (Ea(f)) return q(a, d, f, h);
                if (ua(f)) return N(a, d, f, h);
                ge(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = ke(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return da;
    }
    var oe = ie(!0), pe = ie(!1), qe = {}, re = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a) {
        if (a === qe) throw Error(n(174));
        return a;
    }
    function ve(a, b) {
        y(te, b);
        y(se, a);
        y(re, qe);
        a = Ga(b);
        x(re);
        y(re, a);
    }
    function we() {
        x(re);
        x(se);
        x(te);
    }
    function xe(a) {
        var b = ue(te.current), c = ue(re.current);
        b = Ha(c, a.type, b);
        c !== b && (y(se, a), y(re, b));
    }
    function ye(a) {
        se.current === a && (x(re), x(se));
    }
    var J = gc(0);
    function ze(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Ib(c) || Jb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ae = [];
    function Be() {
        for(var a = 0; a < Ae.length; a++){
            var b = Ae[a];
            Ta ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K = null, L = null, M = null, Fe = !1, Ge = !1, He = 0, Ie = 0;
    function O() {
        throw Error(n(321));
    }
    function Je(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Rc(a[c], b[c])) return !1;
        return !0;
    }
    function Ke(a, b, c, d, e, f) {
        Ee = f;
        K = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Ce.current = null === a || null === a.memoizedState ? Le : Me;
        a = c(d, e);
        if (Ge) {
            f = 0;
            do {
                Ge = !1;
                He = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                M = L = null;
                b.updateQueue = null;
                Ce.current = Ne;
                a = c(d, e);
            }while (Ge);
        }
        Ce.current = Oe;
        b = null !== L && null !== L.next;
        Ee = 0;
        M = L = K = null;
        Fe = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Pe() {
        var a = 0 !== He;
        He = 0;
        return a;
    }
    function Qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === M ? K.memoizedState = M = a : M = M.next = a;
        return M;
    }
    function Re() {
        if (null === L) {
            var a = K.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = L.next;
        var b = null === M ? K.memoizedState : M.next;
        if (null !== b) M = b, L = a;
        else {
            if (null === a) throw Error(n(310));
            L = a;
            a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                baseQueue: L.baseQueue,
                queue: L.queue,
                next: null
            };
            null === M ? K.memoizedState = M = a : M = M.next = a;
        }
        return M;
    }
    function Se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Te(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = L, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Ee & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var v = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = v, g = d) : k = k.next = v;
                    K.lanes |= m;
                    vd |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Rc(d, b.memoizedState) || (kd = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, K.lanes |= f, vd |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Ue(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Rc(f, b.memoizedState) || (kd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Ve() {}
    function We(a, b) {
        var c = K, d = Re(), e = b(), f = !Rc(d.memoizedState, e);
        f && (d.memoizedState = e, kd = !0);
        d = d.queue;
        Xe(Ye.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== M && M.memoizedState.tag & 1) {
            c.flags |= 2048;
            Ze(9, $e.bind(null, c, d, e, b), void 0, null);
            if (null === F) throw Error(n(349));
            0 !== (Ee & 30) || af(c, b, e);
        }
        return e;
    }
    function af(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function $e(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        bf(b) && Ad(a, 1, -1);
    }
    function Ye(a, b, c) {
        return c(function() {
            bf(b) && Ad(a, 1, -1);
        });
    }
    function bf(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Rc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function cf(a) {
        var b = Qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Se,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = df.bind(null, K, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ze(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function ef() {
        return Re().memoizedState;
    }
    function ff(a, b, c, d) {
        var e = Qe();
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function gf(a, b, c, d) {
        var e = Re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Je(d, g.deps)) {
                e.memoizedState = Ze(b, c, f, d);
                return;
            }
        }
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, f, d);
    }
    function hf(a, b) {
        return ff(8390656, 8, a, b);
    }
    function Xe(a, b) {
        return gf(2048, 8, a, b);
    }
    function jf(a, b) {
        return gf(4, 2, a, b);
    }
    function kf(a, b) {
        return gf(4, 4, a, b);
    }
    function lf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function mf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return gf(4, 4, lf.bind(null, b, a), c);
    }
    function nf() {}
    function of(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function qf(a, b) {
        var c = D;
        D = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = De.transition;
        De.transition = {};
        try {
            a(!1), b();
        } finally{
            D = c, De.transition = d;
        }
    }
    function rf() {
        return Re().memoizedState;
    }
    function sf(a, b, c) {
        var d = zd(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        tf(a) ? uf(b, c) : (vf(a, b, c), c = H(), a = Ad(a, d, c), null !== a && wf(a, b, d));
    }
    function df(a, b, c) {
        var d = zd(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (tf(a)) uf(b, e);
        else {
            vf(a, b, e);
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Rc(h, g)) return;
            } catch (k) {} finally{}
            c = H();
            a = Ad(a, d, c);
            null !== a && wf(a, b, d);
        }
    }
    function tf(a) {
        var b = a.alternate;
        return a === K || null !== b && b === K;
    }
    function uf(a, b) {
        Ge = Fe = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function vf(a, b, c) {
        null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = b.interleaved, null === a ? (c.next = c, null === md ? md = [
            b
        ] : md.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    var Oe = {
        readContext: ld,
        useCallback: O,
        useContext: O,
        useEffect: O,
        useImperativeHandle: O,
        useInsertionEffect: O,
        useLayoutEffect: O,
        useMemo: O,
        useReducer: O,
        useRef: O,
        useState: O,
        useDebugValue: O,
        useDeferredValue: O,
        useTransition: O,
        useMutableSource: O,
        useSyncExternalStore: O,
        useId: O,
        unstable_isNewReconciler: !1
    }, Le = {
        readContext: ld,
        useCallback: function(a, b) {
            Qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: ld,
        useEffect: hf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ff(4194308, 4, lf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ff(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ff(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, K, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Qe();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: cf,
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = cf(a), c = b[0], d = b[1];
            hf(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = cf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Qe().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = K, e = Qe();
            if (I) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === F) throw Error(n(349));
                0 !== (Ee & 30) || af(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            hf(Ye.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            Ze(9, $e.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Qe(), b = F.identifierPrefix;
            if (I) {
                var c = Od;
                var d = Nd;
                c = (d & ~(1 << 32 - qc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = He++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Ie++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Me = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Te,
        useRef: ef,
        useState: function() {
            return Te(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Te(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Te(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ne = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Ue,
        useRef: ef,
        useState: function() {
            return Ue(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Ue(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Ue(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        try {
            var c = "", d = b;
            do c += $c(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function yf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Bf || (Bf = !0, Cf = d);
            yf(a, b);
        };
        return c;
    }
    function Df(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                yf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            yf(a, b);
            "function" !== typeof d && (null === Ef ? Ef = new Set([
                this
            ]) : Ef.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Ff(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new zf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Gf.bind(null, a, b, c), b.then(a, a));
    }
    function Hf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function If(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = qd(-1, 1), b.tag = 2, rd(c, b))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    function Jf(a) {
        a.flags |= 4;
    }
    function Kf(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var Lf, Mf, Nf, Of;
    if (Ua) Lf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) La(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, Mf = function() {}, Nf = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = ue(re.current);
            c = Na(f, c, a, d, e, g);
            (b.updateQueue = c) && Jf(b);
        }
    }, Of = function(a, b, c, d) {
        c !== d && Jf(b);
    };
    else if (Va) {
        Lf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    La(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), La(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Lf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Pf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Pf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        Mf = function(a, b) {
            var c = b.stateNode;
            if (!Kf(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                Pf(d, b, !1, !1);
                c.pendingChildren = d;
                Jf(b);
                Bb(a, d);
            }
        };
        Nf = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = Kf(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = ue(re.current), l = null;
                g !== d && (l = Na(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ma(f, c, d, e, k) && Jf(b), b.stateNode = f, a ? Jf(b) : Lf(f, b, !1, !1));
            }
        };
        Of = function(a, b, c, d) {
            c !== d ? (a = ue(te.current), c = ue(re.current), b.stateNode = Pa(d, a, c, b), Jf(b)) : b.stateNode = a.stateNode;
        };
    } else Mf = function() {}, Nf = function() {}, Of = function() {};
    function Qf(a, b) {
        if (!I) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function P(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Rf(a, b, c) {
        var d = b.pendingProps;
        Sd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return P(b), null;
            case 1:
                return C(b.type) && kc(), P(b), null;
            case 3:
                d = b.stateNode;
                we();
                x(B);
                x(A);
                Be();
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) ce(b) ? Jf(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
                Mf(a, b);
                P(b);
                return null;
            case 5:
                ye(b);
                c = ue(te.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) Nf(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        P(b);
                        return null;
                    }
                    a = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(175));
                        a = Pb(b.stateNode, b.type, b.memoizedProps, c, a, b, !Vd);
                        b.updateQueue = a;
                        null !== a && Jf(b);
                    } else {
                        var f = Ka(e, d, c, a, b);
                        Lf(f, b, !1, !1);
                        b.stateNode = f;
                        Ma(f, e, d, c, a) && Jf(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                P(b);
                return null;
            case 6:
                if (a && null != b.stateNode) Of(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = ue(te.current);
                    c = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(176));
                        a = b.stateNode;
                        d = b.memoizedProps;
                        if (c = Qb(a, d, b, !Vd)) {
                            if (e = Td, null !== e) switch(f = 0 !== (e.mode & 1), e.tag){
                                case 3:
                                    Yb(e.stateNode.containerInfo, a, d, f);
                                    break;
                                case 5:
                                    Zb(e.type, e.memoizedProps, e.stateNode, a, d, f);
                            }
                        }
                        c && Jf(b);
                    } else b.stateNode = Pa(d, a, c, b);
                }
                P(b);
                return null;
            case 13:
                x(J);
                d = b.memoizedState;
                if (I && null !== Ud && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                    for(a = Ud; a;)a = Lb(a);
                    de();
                    b.flags |= 98560;
                    return b;
                }
                if (null !== d && null !== d.dehydrated) {
                    d = ce(b);
                    if (null === a) {
                        if (!d) throw Error(n(318));
                        if (!p) throw Error(n(344));
                        a = b.memoizedState;
                        a = null !== a ? a.dehydrated : null;
                        if (!a) throw Error(n(317));
                        Rb(a, b);
                    } else de(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    P(b);
                    return null;
                }
                null !== Wd && (Sf(Wd), Wd = null);
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                d = null !== d;
                c = !1;
                null === a ? ce(b) : c = null !== a.memoizedState;
                d && !c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (J.current & 1) ? 0 === Q && (Q = 3) : Tf()));
                null !== b.updateQueue && (b.flags |= 4);
                P(b);
                return null;
            case 4:
                return we(), Mf(a, b), null === a && Xa(b.stateNode.containerInfo), P(b), null;
            case 10:
                return hd(b.type._context), P(b), null;
            case 17:
                return C(b.type) && kc(), P(b), null;
            case 19:
                x(J);
                e = b.memoizedState;
                if (null === e) return P(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Qf(e, !1);
                    else {
                        if (0 !== Q || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = ze(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Qf(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(d = b.child; null !== d;)c = d, e = a, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = e, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, e = f.dependencies, c.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), d = d.sibling;
                                y(J, J.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && E() > Uf && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = ze(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Qf(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !I) return P(b), null;
                        } else 2 * E() - e.renderingStartTime > Uf && 1073741824 !== c && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = E(), b.sibling = null, a = J.current, y(J, d ? a & 1 | 2 : a & 1), b;
                P(b);
                return null;
            case 22:
            case 23:
                return Vf(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (Wf & 1073741824) && (P(b), Ua && b.subtreeFlags & 6 && (b.flags |= 8192)) : P(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = !1;
    function R(a, b, c, d) {
        b.child = null === a ? pe(b, null, c, d) : oe(b, a.child, c, d);
    }
    function Yf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        jd(b, e);
        d = Ke(a, b, c, d, f, e);
        c = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && c && Rd(b);
        b.flags |= 1;
        R(a, b, d, e);
        return b.child;
    }
    function $f(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !ag(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bg(a, b, f, d, e);
            a = le(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Zc;
            if (c(g, d) && a.ref === b.ref) return Zf(a, b, e);
        }
        b.flags |= 1;
        a = je(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function bg(a, b, c, d, e) {
        if (null !== a && Zc(a.memoizedProps, d) && a.ref === b.ref) {
            if (kd = !1, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (kd = !0);
            else return b.lanes = a.lanes, Zf(a, b, e);
        }
        return cg(a, b, c, d, e);
    }
    function dg(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, y(eg, Wf), Wf |= c;
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, d = null !== f ? f.baseLanes : c, y(eg, Wf), Wf |= d;
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null
            }, b.updateQueue = null, y(eg, Wf), Wf |= a, null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, y(eg, Wf), Wf |= d;
        R(a, b, e, c);
        return b.child;
    }
    function fg(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function cg(a, b, c, d, e) {
        var f = C(c) ? ic : A.current;
        f = jc(b, f);
        jd(b, e);
        c = Ke(a, b, c, d, f, e);
        d = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && d && Rd(b);
        b.flags |= 1;
        R(a, b, c, e);
        return b.child;
    }
    function gg(a, b, c, d, e) {
        if (C(c)) {
            var f = !0;
            nc(b);
        } else f = !1;
        jd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Dd(b, c, d), Fd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = ld(l) : (l = C(c) ? ic : A.current, l = jc(b, l));
            var m = c.getDerivedStateFromProps, v = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            v || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ed(b, g, d, l);
            nd = !1;
            var r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            k = b.memoizedState;
            h !== d || r !== k || B.current || nd ? ("function" === typeof m && (yd(b, c, m, d), k = b.memoizedState), (h = nd || Cd(b, c, h, d, r, k, l)) ? (v || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            pd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : ad(b.type, h);
            g.props = l;
            v = b.pendingProps;
            r = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = ld(k) : (k = C(c) ? ic : A.current, k = jc(b, k));
            var z = c.getDerivedStateFromProps;
            (m = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== v || r !== k) && Ed(b, g, d, k);
            nd = !1;
            r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            var q = b.memoizedState;
            h !== v || r !== q || B.current || nd ? ("function" === typeof z && (yd(b, c, z, d), q = b.memoizedState), (l = nd || Cd(b, c, l, d, r, q, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, q, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, q, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = q), g.props = d, g.state = q, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return hg(a, b, c, d, f, e);
    }
    function hg(a, b, c, d, e, f) {
        fg(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && oc(b, c, !1), Zf(a, b, f);
        d = b.stateNode;
        Xf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = oe(b, a.child, null, f), b.child = oe(b, null, h, f)) : R(a, b, h, f);
        b.memoizedState = d.state;
        e && oc(b, c, !0);
        return b.child;
    }
    function ig(a) {
        var b = a.stateNode;
        b.pendingContext ? lc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && lc(a, b.context, !1);
        ve(a, b.containerInfo);
    }
    function jg(a, b, c, d, e) {
        de();
        ee(e);
        b.flags |= 256;
        R(a, b, c, d);
        return b.child;
    }
    var kg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function lg(a) {
        return {
            baseLanes: a,
            cachePool: null
        };
    }
    function mg(a, b, c) {
        var d = b.pendingProps, e = J.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        y(J, e & 1);
        if (null === a) {
            ae(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Jb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            e = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, e = {
                mode: "hidden",
                children: e
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = ng(e, d, 0, null), a = ne(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = lg(c), b.memoizedState = kg, a) : og(b, e);
        }
        e = a.memoizedState;
        if (null !== e) {
            h = e.dehydrated;
            if (null !== h) {
                if (g) {
                    if (b.flags & 256) return b.flags &= -257, pg(a, b, c, Error(n(422)));
                    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                    f = d.fallback;
                    e = b.mode;
                    d = ng({
                        mode: "visible",
                        children: d.children
                    }, e, 0, null);
                    f = ne(f, e, c, null);
                    f.flags |= 2;
                    d.return = b;
                    f.return = b;
                    d.sibling = f;
                    b.child = d;
                    0 !== (b.mode & 1) && oe(b, a.child, null, c);
                    b.child.memoizedState = lg(c);
                    b.memoizedState = kg;
                    return f;
                }
                if (0 === (b.mode & 1)) b = pg(a, b, c, null);
                else if (Jb(h)) b = pg(a, b, c, Error(n(419)));
                else if (d = 0 !== (c & a.childLanes), kd || d) {
                    d = F;
                    if (null !== d) {
                        switch(c & -c){
                            case 4:
                                f = 2;
                                break;
                            case 16:
                                f = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                f = 32;
                                break;
                            case 536870912:
                                f = 268435456;
                                break;
                            default:
                                f = 0;
                        }
                        d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                        0 !== d && d !== e.retryLane && (e.retryLane = d, Ad(a, d, -1));
                    }
                    Tf();
                    b = pg(a, b, c, Error(n(421)));
                } else Ib(h) ? (b.flags |= 128, b.child = a.child, b = qg.bind(null, a), Kb(h, b), b = null) : (c = e.treeContext, p && (Ud = Ob(h), Td = b, I = !0, Wd = null, Vd = !1, null !== c && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c.id, Od = c.overflow, Md = b)), b = og(b, b.pendingProps.children), b.flags |= 4096);
                return b;
            }
            if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
                baseLanes: e.baseLanes | c,
                cachePool: null
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
            c = sg(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
            baseLanes: e.baseLanes | c,
            cachePool: null
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
        c = sg(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function og(a, b) {
        b = ng({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function sg(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = je(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 1) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (d = b.deletions, null === d ? (b.deletions = [
            a
        ], b.flags |= 16) : d.push(a));
        return b.child = c;
    }
    function rg(a, b, c, d, e) {
        var f = b.mode;
        a = a.child;
        var g = a.sibling, h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = je(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
        null !== g ? d = je(g, d) : (d = ne(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function pg(a, b, c, d) {
        null !== d && ee(d);
        oe(b, a.child, null, c);
        a = og(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function tg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        id(a.return, b, c);
    }
    function ug(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function vg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        R(a, b, d.children, c);
        d = J.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && tg(a, c, b);
                else if (19 === a.tag) tg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        y(J, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === ze(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                ug(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === ze(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                ug(b, !0, c, null, f);
                break;
            case "together":
                ug(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Zf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        vd |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = je(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = je(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function wg(a, b, c) {
        switch(b.tag){
            case 3:
                ig(b);
                de();
                break;
            case 5:
                xe(b);
                break;
            case 1:
                C(b.type) && nc(b);
                break;
            case 4:
                ve(b, b.stateNode.containerInfo);
                break;
            case 10:
                gd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return y(J, J.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return mg(a, b, c);
                    y(J, J.current & 1);
                    a = Zf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                y(J, J.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return vg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                y(J, J.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, dg(a, b, c);
        }
        return Zf(a, b, c);
    }
    function xg(a, b) {
        Sd(b);
        switch(b.tag){
            case 1:
                return C(b.type) && kc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return we(), x(B), x(A), Be(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ye(b), null;
            case 13:
                x(J);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    de();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return x(J), null;
            case 4:
                return we(), null;
            case 10:
                return hd(b.type._context), null;
            case 22:
            case 23:
                return Vf(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var yg = !1, zg = !1, Ag = "function" === typeof WeakSet ? WeakSet : Set, S = null;
    function Bg(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                T(a, b, d);
            }
            else c.current = null;
        }
    }
    function Cg(a, b, c) {
        try {
            c();
        } catch (d) {
            T(a, b, d);
        }
    }
    var Dg = !1;
    function Eg(a, b) {
        Ia(a.containerInfo);
        for(S = b; null !== S;)if (a = S, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, S = b;
        else for(; null !== S;){
            a = S;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : ad(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ua && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                T(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                S = b;
                break;
            }
            S = a.return;
        }
        c = Dg;
        Dg = !1;
        return c;
    }
    function Fg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Cg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Gg(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Hg(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Fa(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Ig(a, b, c) {
        if (Oc && "function" === typeof Oc.onCommitFiberUnmount) try {
            Oc.onCommitFiberUnmount(Nc, b);
        } catch (g) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var d = a = a.next;
                    do {
                        var e = d, f = e.destroy;
                        e = e.tag;
                        void 0 !== f && (0 !== (e & 2) ? Cg(b, c, f) : 0 !== (e & 4) && Cg(b, c, f));
                        d = d.next;
                    }while (d !== a);
                }
                break;
            case 1:
                Bg(b, c);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (g) {
                    T(b, c, g);
                }
                break;
            case 5:
                Bg(b, c);
                break;
            case 4:
                Ua ? Jg(a, b, c) : Va && Va && (b = b.stateNode.containerInfo, c = zb(b), Cb(b, c));
        }
    }
    function Kg(a, b, c) {
        for(var d = b;;)if (Ig(a, d, c), null === d.child || Ua && 4 === d.tag) {
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
            }
            d.sibling.return = d.return;
            d = d.sibling;
        } else d.child.return = d, d = d.child;
    }
    function Lg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Lg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Mg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Ng(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Mg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Og(a) {
        if (Ua) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Mg(b)) break a;
                    b = b.return;
                }
                throw Error(n(160));
            }
            var c = b;
            switch(c.tag){
                case 5:
                    b = c.stateNode;
                    c.flags & 32 && (sb(b), c.flags &= -33);
                    c = Ng(a);
                    Pg(a, c, b);
                    break;
                case 3:
                case 4:
                    b = c.stateNode.containerInfo;
                    c = Ng(a);
                    Qg(a, c, b);
                    break;
                default:
                    throw Error(n(161));
            }
        }
    }
    function Qg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Qg(a, b, c), a = a.sibling; null !== a;)Qg(a, b, c), a = a.sibling;
    }
    function Pg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Pg(a, b, c), a = a.sibling; null !== a;)Pg(a, b, c), a = a.sibling;
    }
    function Jg(a, b, c) {
        for(var d = b, e = !1, f, g;;){
            if (!e) {
                e = d.return;
                a: for(;;){
                    if (null === e) throw Error(n(160));
                    f = e.stateNode;
                    switch(e.tag){
                        case 5:
                            g = !1;
                            break a;
                        case 3:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                        case 4:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                    }
                    e = e.return;
                }
                e = !0;
            }
            if (5 === d.tag || 6 === d.tag) Kg(a, d, c), g ? rb(f, d.stateNode) : qb(f, d.stateNode);
            else if (18 === d.tag) g ? Wb(f, d.stateNode) : Vb(f, d.stateNode);
            else if (4 === d.tag) {
                if (null !== d.child) {
                    f = d.stateNode.containerInfo;
                    g = !0;
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
            } else if (Ig(a, d, c), null !== d.child) {
                d.child.return = d;
                d = d.child;
                continue;
            }
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
                4 === d.tag && (e = !1);
            }
            d.sibling.return = d.return;
            d = d.sibling;
        }
    }
    function Rg(a, b) {
        if (Ua) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Fg(3, b, b.return);
                    Gg(3, b);
                    Fg(5, b, b.return);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                    return;
                case 12:
                    return;
                case 13:
                    Sg(b);
                    return;
                case 19:
                    Sg(b);
                    return;
                case 17:
                    return;
            }
            throw Error(n(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Fg(3, b, b.return);
                Gg(3, b);
                Fg(5, b, b.return);
                return;
            case 12:
                return;
            case 13:
                Sg(b);
                return;
            case 19:
                Sg(b);
                return;
            case 3:
                p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                break;
            case 22:
            case 23:
                return;
        }
        a: if (Va) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(n(163));
        }
    }
    function Sg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Ag);
            b.forEach(function(b) {
                var d = Tg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Ug(a, b) {
        for(S = b; null !== S;){
            b = S;
            var c = b.deletions;
            if (null !== c) for(var d = 0; d < c.length; d++){
                var e = c[d];
                try {
                    var f = a;
                    Ua ? Jg(f, e, b) : Kg(f, e, b);
                    var g = e.alternate;
                    null !== g && (g.return = null);
                    e.return = null;
                } catch (wa) {
                    T(e, b, wa);
                }
            }
            c = b.child;
            if (0 !== (b.subtreeFlags & 12854) && null !== c) c.return = b, S = c;
            else for(; null !== S;){
                b = S;
                try {
                    var h = b.flags;
                    h & 32 && Ua && sb(b.stateNode);
                    if (h & 512) {
                        var k = b.alternate;
                        if (null !== k) {
                            var l = k.ref;
                            null !== l && ("function" === typeof l ? l(null) : l.current = null);
                        }
                    }
                    if (h & 8192) switch(b.tag){
                        case 13:
                            if (null !== b.memoizedState) {
                                var m = b.alternate;
                                if (null === m || null === m.memoizedState) Vg = E();
                            }
                            break;
                        case 22:
                            var v = null !== b.memoizedState, r = b.alternate, z = null !== r && null !== r.memoizedState;
                            c = b;
                            if (Ua) {
                                a: if (d = c, e = v, f = null, Ua) for(var q = d;;){
                                    if (5 === q.tag) {
                                        if (null === f) {
                                            f = q;
                                            var N = q.stateNode;
                                            e ? tb(N) : vb(q.stateNode, q.memoizedProps);
                                        }
                                    } else if (6 === q.tag) {
                                        if (null === f) {
                                            var da = q.stateNode;
                                            e ? ub(da) : wb(da, q.memoizedProps);
                                        }
                                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === d) && null !== q.child) {
                                        q.child.return = q;
                                        q = q.child;
                                        continue;
                                    }
                                    if (q === d) break;
                                    for(; null === q.sibling;){
                                        if (null === q.return || q.return === d) break a;
                                        f === q && (f = null);
                                        q = q.return;
                                    }
                                    f === q && (f = null);
                                    q.sibling.return = q.return;
                                    q = q.sibling;
                                }
                            }
                            if (v && !z && 0 !== (c.mode & 1)) {
                                S = c;
                                for(var t = c.child; null !== t;){
                                    for(c = S = t; null !== S;){
                                        d = S;
                                        var w = d.child;
                                        switch(d.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                Fg(4, d, d.return);
                                                break;
                                            case 1:
                                                Bg(d, d.return);
                                                var u = d.stateNode;
                                                if ("function" === typeof u.componentWillUnmount) {
                                                    var V = d.return;
                                                    try {
                                                        u.props = d.memoizedProps, u.state = d.memoizedState, u.componentWillUnmount();
                                                    } catch (wa) {
                                                        T(d, V, wa);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                Bg(d, d.return);
                                                break;
                                            case 22:
                                                if (null !== d.memoizedState) {
                                                    Wg(c);
                                                    continue;
                                                }
                                        }
                                        null !== w ? (w.return = d, S = w) : Wg(c);
                                    }
                                    t = t.sibling;
                                }
                            }
                    }
                    switch(h & 4102){
                        case 2:
                            Og(b);
                            b.flags &= -3;
                            break;
                        case 6:
                            Og(b);
                            b.flags &= -3;
                            Rg(b.alternate, b);
                            break;
                        case 4096:
                            b.flags &= -4097;
                            break;
                        case 4100:
                            b.flags &= -4097;
                            Rg(b.alternate, b);
                            break;
                        case 4:
                            Rg(b.alternate, b);
                    }
                } catch (wa) {
                    T(b, b.return, wa);
                }
                c = b.sibling;
                if (null !== c) {
                    c.return = b.return;
                    S = c;
                    break;
                }
                S = b.return;
            }
        }
    }
    function Xg(a, b, c) {
        S = a;
        Yg(a, b, c);
    }
    function Yg(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== S;){
            var e = S, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || yg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || zg;
                    h = yg;
                    var l = zg;
                    yg = g;
                    if ((zg = k) && !l) for(S = e; null !== S;)g = S, k = g.child, 22 === g.tag && null !== g.memoizedState ? Zg(e) : null !== k ? (k.return = g, S = k) : Zg(e);
                    for(; null !== f;)S = f, Yg(f, b, c), f = f.sibling;
                    S = e;
                    yg = h;
                    zg = l;
                }
                $g(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, S = f) : $g(a, b, c);
        }
    }
    function $g(a) {
        for(; null !== S;){
            var b = S;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            zg || Gg(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !zg) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : ad(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && wd(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Fa(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                wd(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (p && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Ub(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    zg || b.flags & 512 && Hg(b);
                } catch (v) {
                    T(b, b.return, v);
                }
            }
            if (b === a) {
                S = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Wg(a) {
        for(; null !== S;){
            var b = S;
            if (b === a) {
                S = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Zg(a) {
        for(; null !== S;){
            var b = S;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Gg(4, b);
                        } catch (k) {
                            T(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                T(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, g, k);
                        }
                }
            } catch (k) {
                T(b, b.return, k);
            }
            if (b === a) {
                S = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                S = h;
                break;
            }
            S = b.return;
        }
    }
    var ah = 0, bh = 1, ch = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var fh = Symbol.for;
        ah = fh("selector.component");
        bh = fh("selector.has_pseudo_class");
        ch = fh("selector.role");
        dh = fh("selector.test_id");
        eh = fh("selector.text");
    }
    function gh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function hh(a, b) {
        switch(b.$$typeof){
            case ah:
                if (a.type === b.value) return !0;
                break;
            case bh:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && hh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case ch:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case eh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case dh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ih(a) {
        switch(a.$$typeof){
            case ah:
                return "<" + (va(a.value) || "Unknown") + ">";
            case bh:
                return ":has(" + (ih(a) || "") + ")";
            case ch:
                return '[role="' + a.value + '"]';
            case eh:
                return '"' + a.value + '"';
            case dh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function jh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && hh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function kh(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        a = jh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U = ea.ReactCurrentBatchConfig, G = 0, F = null, W = null, X = 0, Wf = 0, eg = gc(0), Q = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y = null, Vg = 0, Uf = Infinity;
    function sh() {
        Uf = E() + 500;
    }
    var Bf = !1, Cf = null, Ef = null, th = !1, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H() {
        return 0 !== (G & 6) ? E() : -1 !== yh ? yh : yh = E();
    }
    function zd(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (G & 2) && 0 !== X) return X & -X;
        if (null !== Yc.transition) return 0 === zh && (a = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a), zh;
        a = D;
        return 0 !== a ? a : Ya();
    }
    function Ad(a, b, c) {
        if (50 < wh) throw wh = 0, xh = null, Error(n(185));
        var d = Ah(a, b);
        if (null === d) return null;
        Bc(d, b, c);
        if (0 === (G & 2) || d !== F) d === F && (0 === (G & 2) && (ph |= b), 4 === Q && Bh(d, X)), Z(d, c), 1 === b && 0 === G && 0 === (a.mode & 1) && (sh(), Tc && Xc());
        return d;
    }
    function Ah(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        var c = a.callbackNode;
        yc(a, b);
        var d = wc(a, a === F ? X : 0);
        if (0 === d) null !== c && Gc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Gc(c);
            if (1 === b) 0 === a.tag ? Wc(Ch.bind(null, a)) : Vc(Ch.bind(null, a)), $a ? ab(function() {
                0 === G && Xc();
            }) : Fc(Jc, Xc), c = null;
            else {
                switch(Ec(d)){
                    case 1:
                        c = Jc;
                        break;
                    case 4:
                        c = Kc;
                        break;
                    case 16:
                        c = Lc;
                        break;
                    case 536870912:
                        c = Mc;
                        break;
                    default:
                        c = Lc;
                }
                c = Dh(c, Eh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Eh(a, b) {
        yh = -1;
        zh = 0;
        if (0 !== (G & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Fh() && a.callbackNode !== c) return null;
        var d = wc(a, a === F ? X : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Gh(a, d);
        else {
            b = d;
            var e = G;
            G |= 2;
            var f = Hh();
            if (F !== a || X !== b) sh(), Ih(a, b);
            for(;;)try {
                Jh();
                break;
            } catch (h) {
                Kh(a, h);
            }
            fd();
            mh.current = f;
            G = e;
            null !== W ? b = 0 : (F = null, X = 0, b = Q);
        }
        if (0 !== b) {
            2 === b && (e = zc(a), 0 !== e && (d = e, b = Lh(a, e)));
            if (1 === b) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
            if (6 === b) Bh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Mh(e) && (b = Gh(a, d), 2 === b && (f = zc(a), 0 !== f && (d = f, b = Lh(a, f))), 1 === b)) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Nh(a, Y);
                        break;
                    case 3:
                        Bh(a, d);
                        if ((d & 130023424) === d && (b = Vg + 500 - E(), 10 < b)) {
                            if (0 !== wc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                H();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), b);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 4:
                        Bh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - qc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = E() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), d);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 5:
                        Nh(a, Y);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Z(a, E());
        return a.callbackNode === c ? Eh.bind(null, a) : null;
    }
    function Lh(a, b) {
        var c = rh;
        a.current.memoizedState.isDehydrated && (Ih(a, b).flags |= 256);
        a = Gh(a, b);
        2 !== a && (b = Y, Y = c, null !== b && Sf(b));
        return a;
    }
    function Sf(a) {
        null === Y ? Y = a : Y.push.apply(Y, a);
    }
    function Mh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Rc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Bh(a, b) {
        b &= ~qh;
        b &= ~ph;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - qc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Ch(a) {
        if (0 !== (G & 6)) throw Error(n(327));
        Fh();
        var b = wc(a, 0);
        if (0 === (b & 1)) return Z(a, E()), null;
        var c = Gh(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = zc(a);
            0 !== d && (b = d, c = Lh(a, d));
        }
        if (1 === c) throw c = oh, Ih(a, 0), Bh(a, b), Z(a, E()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Nh(a, Y);
        Z(a, E());
        return null;
    }
    function Oh(a) {
        null !== uh && 0 === uh.tag && 0 === (G & 6) && Fh();
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            if (U.transition = null, D = 1, a) return a();
        } finally{
            D = d, U.transition = c, G = b, 0 === (G & 6) && Xc();
        }
    }
    function Vf() {
        Wf = eg.current;
        x(eg);
    }
    function Ih(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Sa && (a.timeoutHandle = Sa, Ra(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            Sd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && kc();
                    break;
                case 3:
                    we();
                    x(B);
                    x(A);
                    Be();
                    break;
                case 5:
                    ye(d);
                    break;
                case 4:
                    we();
                    break;
                case 13:
                    x(J);
                    break;
                case 19:
                    x(J);
                    break;
                case 10:
                    hd(d.type._context);
                    break;
                case 22:
                case 23:
                    Vf();
            }
            c = c.return;
        }
        F = a;
        W = a = je(a.current, null);
        X = Wf = b;
        Q = 0;
        oh = null;
        qh = ph = vd = 0;
        Y = rh = null;
        if (null !== md) {
            for(b = 0; b < md.length; b++)if (c = md[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            md = null;
        }
        return a;
    }
    function Kh(a, b) {
        do {
            var c = W;
            try {
                fd();
                Ce.current = Oe;
                if (Fe) {
                    for(var d = K.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Fe = !1;
                }
                Ee = 0;
                M = L = K = null;
                Ge = !1;
                He = 0;
                nh.current = null;
                if (null === c || null === c.return) {
                    Q = 1;
                    oh = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = X;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, v = m.tag;
                        if (0 === (m.mode & 1) && (0 === v || 11 === v || 15 === v)) {
                            var r = m.alternate;
                            r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var z = Hf(g);
                        if (null !== z) {
                            z.flags &= -257;
                            If(z, g, h, f, b);
                            z.mode & 1 && Ff(f, l, b);
                            b = z;
                            k = l;
                            var q = b.updateQueue;
                            if (null === q) {
                                var N = new Set;
                                N.add(k);
                                b.updateQueue = N;
                            } else q.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Ff(f, l, b);
                                Tf();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (I && h.mode & 1) {
                        var da = Hf(g);
                        if (null !== da) {
                            0 === (da.flags & 65536) && (da.flags |= 256);
                            If(da, g, h, f, b);
                            ee(k);
                            break a;
                        }
                    }
                    f = k;
                    4 !== Q && (Q = 2);
                    null === rh ? rh = [
                        f
                    ] : rh.push(f);
                    k = xf(k, h);
                    h = g;
                    do {
                        switch(h.tag){
                            case 3:
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var t = Af(h, k, b);
                                td(h, t);
                                break a;
                            case 1:
                                f = k;
                                var w = h.type, u = h.stateNode;
                                if (0 === (h.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ef || !Ef.has(u)))) {
                                    h.flags |= 65536;
                                    b &= -b;
                                    h.lanes |= b;
                                    var V = Df(h, f, b);
                                    td(h, V);
                                    break a;
                                }
                        }
                        h = h.return;
                    }while (null !== h);
                }
                Ph(c);
            } catch (wa) {
                b = wa;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Hh() {
        var a = mh.current;
        mh.current = Oe;
        return null === a ? Oe : a;
    }
    function Tf() {
        if (0 === Q || 3 === Q || 2 === Q) Q = 4;
        null === F || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F, X);
    }
    function Gh(a, b) {
        var c = G;
        G |= 2;
        var d = Hh();
        F === a && X === b || Ih(a, b);
        for(;;)try {
            Qh();
            break;
        } catch (e) {
            Kh(a, e);
        }
        fd();
        G = c;
        mh.current = d;
        if (null !== W) throw Error(n(261));
        F = null;
        X = 0;
        return Q;
    }
    function Qh() {
        for(; null !== W;)Rh(W);
    }
    function Jh() {
        for(; null !== W && !Hc();)Rh(W);
    }
    function Rh(a) {
        var b = Sh(a.alternate, a, Wf);
        a.memoizedProps = a.pendingProps;
        null === b ? Ph(a) : W = b;
        nh.current = null;
    }
    function Ph(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Rf(c, b, Wf), null !== c) {
                    W = c;
                    return;
                }
            } else {
                c = xg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    W = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    Q = 6;
                    W = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === Q && (Q = 5);
    }
    function Nh(a, b) {
        var c = D, d = U.transition;
        try {
            U.transition = null, D = 1, Th(a, b, c);
        } finally{
            U.transition = d, D = c;
        }
        return null;
    }
    function Th(a, b, c) {
        do Fh();
        while (null !== uh);
        if (0 !== (G & 6)) throw Error(n(327));
        var d = a.finishedWork, e = a.finishedLanes;
        if (null === d) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (d === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = d.lanes | d.childLanes;
        Cc(a, f);
        a === F && (W = F = null, X = 0);
        0 === (d.subtreeFlags & 2064) && 0 === (d.flags & 2064) || th || (th = !0, Dh(Lc, function() {
            Fh();
            return null;
        }));
        f = 0 !== (d.flags & 15990);
        if (0 !== (d.subtreeFlags & 15990) || f) {
            f = U.transition;
            U.transition = null;
            var g = D;
            D = 1;
            var h = G;
            G |= 4;
            nh.current = null;
            Eg(a, d);
            Ug(a, d, e);
            Ja(a.containerInfo);
            a.current = d;
            Xg(d, a, e);
            Ic();
            G = h;
            D = g;
            U.transition = f;
        } else a.current = d;
        th && (th = !1, uh = a, vh = e);
        f = a.pendingLanes;
        0 === f && (Ef = null);
        Pc(d.stateNode, c);
        Z(a, E());
        if (null !== b) for(c = a.onRecoverableError, d = 0; d < b.length; d++)c(b[d]);
        if (Bf) throw Bf = !1, a = Cf, Cf = null, a;
        0 !== (vh & 1) && 0 !== a.tag && Fh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === xh ? wh++ : (wh = 0, xh = a) : wh = 0;
        Xc();
        return null;
    }
    function Fh() {
        if (null !== uh) {
            var a = Ec(vh), b = U.transition, c = D;
            try {
                U.transition = null;
                D = 16 > a ? 16 : a;
                if (null === uh) var d = !1;
                else {
                    a = uh;
                    uh = null;
                    vh = 0;
                    if (0 !== (G & 6)) throw Error(n(331));
                    var e = G;
                    G |= 4;
                    for(S = a.current; null !== S;){
                        var f = S, g = f.child;
                        if (0 !== (S.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(S = l; null !== S;){
                                        var m = S;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Fg(8, m, f);
                                        }
                                        var v = m.child;
                                        if (null !== v) v.return = m, S = v;
                                        else for(; null !== S;){
                                            m = S;
                                            var r = m.sibling, z = m.return;
                                            Lg(m);
                                            if (m === l) {
                                                S = null;
                                                break;
                                            }
                                            if (null !== r) {
                                                r.return = z;
                                                S = r;
                                                break;
                                            }
                                            S = z;
                                        }
                                    }
                                }
                                var q = f.alternate;
                                if (null !== q) {
                                    var N = q.child;
                                    if (null !== N) {
                                        q.child = null;
                                        do {
                                            var da = N.sibling;
                                            N.sibling = null;
                                            N = da;
                                        }while (null !== N);
                                    }
                                }
                                S = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, S = g;
                        else b: for(; null !== S;){
                            f = S;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Fg(9, f, f.return);
                            }
                            var t = f.sibling;
                            if (null !== t) {
                                t.return = f.return;
                                S = t;
                                break b;
                            }
                            S = f.return;
                        }
                    }
                    var w = a.current;
                    for(S = w; null !== S;){
                        g = S;
                        var u = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, S = u;
                        else b: for(g = w; null !== S;){
                            h = S;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Gg(9, h);
                                }
                            } catch (wa) {
                                T(h, h.return, wa);
                            }
                            if (h === g) {
                                S = null;
                                break b;
                            }
                            var V = h.sibling;
                            if (null !== V) {
                                V.return = h.return;
                                S = V;
                                break b;
                            }
                            S = h.return;
                        }
                    }
                    G = e;
                    Xc();
                    if (Oc && "function" === typeof Oc.onPostCommitFiberRoot) try {
                        Oc.onPostCommitFiberRoot(Nc, a);
                    } catch (wa) {}
                    d = !0;
                }
                return d;
            } finally{
                D = c, U.transition = b;
            }
        }
        return !1;
    }
    function Uh(a, b, c) {
        b = xf(c, b);
        b = Af(a, b, 1);
        rd(a, b);
        b = H();
        a = Ah(a, 1);
        null !== a && (Bc(a, 1, b), Z(a, b));
    }
    function T(a, b, c) {
        if (3 === a.tag) Uh(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                Uh(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ef || !Ef.has(d))) {
                    a = xf(c, a);
                    a = Df(b, a, 1);
                    rd(b, a);
                    a = H();
                    b = Ah(b, 1);
                    null !== b && (Bc(b, 1, a), Z(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Gf(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = H();
        a.pingedLanes |= a.suspendedLanes & c;
        F === a && (X & c) === c && (4 === Q || 3 === Q && (X & 130023424) === X && 500 > E() - Vg ? Ih(a, 0) : qh |= c);
        Z(a, b);
    }
    function Vh(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
        var c = H();
        a = Ah(a, b);
        null !== a && (Bc(a, b, c), Z(a, c));
    }
    function qg(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        Vh(a, c);
    }
    function Tg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        Vh(a, c);
    }
    var Sh;
    Sh = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || B.current) kd = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return kd = !1, wg(a, b, c);
                kd = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else kd = !1, I && 0 !== (b.flags & 1048576) && Qd(b, Jd, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                var e = jc(b, A.current);
                jd(b, c);
                e = Ke(null, b, d, a, e, c);
                var f = Pe();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, C(d) ? (f = !0, nc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, od(b), e.updater = Bd, b.stateNode = e, e._reactInternals = b, Fd(b, d, a, c), b = hg(null, b, d, !0, f, c)) : (b.tag = 0, I && f && Rd(b), R(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = Wh(d);
                    a = ad(d, a);
                    switch(e){
                        case 0:
                            b = cg(null, b, d, a, c);
                            break a;
                        case 1:
                            b = gg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Yf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = $f(null, b, d, ad(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), cg(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), gg(a, b, d, e, c);
            case 3:
                a: {
                    ig(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    pd(a, b);
                    ud(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (p && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Error(n(423));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Error(n(424));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else for(p && (Ud = Nb(b.stateNode.containerInfo), Td = b, I = !0, Wd = null, Vd = !1), c = pe(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        de();
                        if (d === e) {
                            b = Zf(a, b, c);
                            break a;
                        }
                        R(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return xe(b), null === a && ae(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Oa(d, e) ? g = null : null !== f && Oa(d, f) && (b.flags |= 32), fg(a, b), R(a, b, g, c), b.child;
            case 6:
                return null === a && ae(b), null;
            case 13:
                return mg(a, b, c);
            case 4:
                return ve(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = oe(b, null, d, c) : R(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), Yf(a, b, d, e, c);
            case 7:
                return R(a, b, b.pendingProps, c), b.child;
            case 8:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    gd(b, d, g);
                    if (null !== f) {
                        if (Rc(f.value, g)) {
                            if (f.children === e.children && !B.current) {
                                b = Zf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = qd(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        id(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                id(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    R(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, jd(b, c), e = ld(e), d = d(e), b.flags |= 1, R(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = ad(d, b.pendingProps), e = ad(d.type, e), $f(a, b, d, e, c);
            case 15:
                return bg(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, C(d) ? (a = !0, nc(b)) : a = !1, jd(b, c), Dd(b, d, e), Fd(b, d, e, c), hg(null, b, d, !0, a, c);
            case 19:
                return vg(a, b, c);
            case 22:
                return dg(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Dh(a, b) {
        return Fc(a, b);
    }
    function Xh(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new Xh(a, b, c, d);
    }
    function ag(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function Wh(a) {
        if ("function" === typeof a) return ag(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === na) return 11;
            if (a === qa) return 14;
        }
        return 2;
    }
    function je(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function le(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) ag(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ia:
                return ne(c.children, e, f, b);
            case ja:
                g = 8;
                e |= 8;
                break;
            case ka:
                return a = Yd(12, c, b, e | 2), a.elementType = ka, a.lanes = f, a;
            case oa:
                return a = Yd(13, c, b, e), a.elementType = oa, a.lanes = f, a;
            case pa:
                return a = Yd(19, c, b, e), a.elementType = pa, a.lanes = f, a;
            case sa:
                return ng(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case la:
                        g = 10;
                        break a;
                    case ma:
                        g = 9;
                        break a;
                    case na:
                        g = 11;
                        break a;
                    case qa:
                        g = 14;
                        break a;
                    case ra:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function ne(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ng(a, b, c, d) {
        a = Yd(22, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        a.stateNode = {};
        return a;
    }
    function ke(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function me(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function Yh(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Sa;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ac(0);
        this.expirationTimes = Ac(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ac(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        p && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a, b, c, d, e, f, g, h, k) {
        a = new Yh(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = Yd(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null
        };
        od(f);
        return a;
    }
    function $h(a) {
        if (!a) return hc;
        a = a._reactInternals;
        a: {
            if (ya(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (C(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (C(c)) return mc(a, c, b);
        }
        return b;
    }
    function ai(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Ba(b);
        return null === a ? null : a.stateNode;
    }
    function bi(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function ci(a, b) {
        bi(a, b);
        (a = a.alternate) && bi(a, b);
    }
    function di(a) {
        a = Ba(a);
        return null === a ? null : a.stateNode;
    }
    function ei() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = H();
            Ad(a, 134217728, b);
            ci(a, 134217728);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = H(), c = zd(a);
            Ad(a, c, b);
            ci(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = vc(b.pendingLanes);
                    0 !== c && (Dc(b, c | 1), Z(b, E()), 0 === (G & 6) && (sh(), Xc()));
                }
                break;
            case 13:
                var d = H();
                Oh(function() {
                    return Ad(a, 1, d);
                });
                ci(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = G;
        G |= 1;
        try {
            return a(b);
        } finally{
            G = c, 0 === G && (sh(), Tc && Xc());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: ah,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return Zh(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: bh,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = Zh(c, d, !0, a, e, f, g, h, k);
        a.context = $h(null);
        c = a.current;
        d = H();
        e = zd(c);
        f = qd(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        rd(c, f);
        a.current.lanes = e;
        Bc(a, e, d);
        Z(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ha,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: ch,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: dh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: eh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = D, c = U.transition;
        try {
            return U.transition = null, D = 16, a();
        } finally{
            D = b, U.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = D, g = U.transition;
        try {
            return U.transition = null, D = 1, a(b, c, d, e);
        } finally{
            D = f, U.transition = g, 0 === G && sh();
        }
    };
    exports.findAllNodes = kh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = kh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, v = k.y, r = v + k.height;
                if (d >= l && f >= v && e <= m && g <= r) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || r < f || v > g)) {
                    v > f && (k.height += v - f, k.y = f);
                    r < g && (k.height = g - v);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== v || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ai;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Aa(a);
        a = null !== a ? Da(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ai(a);
    };
    exports.flushControlled = function(a) {
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            U.transition = null, D = 1, a();
        } finally{
            D = d, U.transition = c, G = b, 0 === G && (sh(), Xc());
        }
    };
    exports.flushPassiveEffects = Fh;
    exports.flushSync = Oh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        b = jh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return D;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            gh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (hh(f, h) && (d.push(ih(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ih(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Fa(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ea.ReactCurrentDispatcher,
            findHostInstanceByFiber: di,
            findFiberByHostInstance: a.findFiberByHostInstance || ei,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.0.0-fc46dba67-20220329"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Nc = b.inject(a), Oc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = kh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = D;
        try {
            return D = a, b();
        } finally{
            D = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = H(), g = zd(e);
        c = $h(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = qd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        rd(e, b);
        a = Ad(e, g, f);
        null !== a && sd(a, e, g);
        return g;
    };
    return exports;
};

});
parcelRegister("jRD9C", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7iGcH"));

});
parcelRegister("7iGcH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $550af3a27577c496$export$c4744153514ff05d, (v) => $550af3a27577c496$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $550af3a27577c496$export$3e506c1ccc9cc1a7, (v) => $550af3a27577c496$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $550af3a27577c496$export$e26fe2ed2fa76875, (v) => $550af3a27577c496$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $550af3a27577c496$export$502329bbf4b505b1, (v) => $550af3a27577c496$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $550af3a27577c496$export$6e3807111c4874c4, (v) => $550af3a27577c496$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $550af3a27577c496$export$c27134553091fb3a, (v) => $550af3a27577c496$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $550af3a27577c496$export$33ee1acdc04fd2a2, (v) => $550af3a27577c496$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $550af3a27577c496$export$b00a404bbd5edef2, (v) => $550af3a27577c496$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $550af3a27577c496$export$8352ce38b91d0c62, (v) => $550af3a27577c496$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $550af3a27577c496$export$d66a1c1c77bd778b, (v) => $550af3a27577c496$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $550af3a27577c496$export$d3dfb8e4810cb555, (v) => $550af3a27577c496$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $550af3a27577c496$export$839f9183b0465a69, (v) => $550af3a27577c496$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $550af3a27577c496$export$72fdf0e06517287b, (v) => $550af3a27577c496$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $550af3a27577c496$export$4b844e58a3e414b4, (v) => $550af3a27577c496$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $550af3a27577c496$export$816d2913ae6b83b1, (v) => $550af3a27577c496$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $550af3a27577c496$export$61bcfe829111a1d0, (v) => $550af3a27577c496$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $550af3a27577c496$export$7ee8c9beb337bc3f, (v) => $550af3a27577c496$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $550af3a27577c496$export$b5836b71941fa3ed, (v) => $550af3a27577c496$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $550af3a27577c496$export$cf845f2c119da08a, (v) => $550af3a27577c496$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $550af3a27577c496$export$c4744153514ff05d;
var $550af3a27577c496$export$3e506c1ccc9cc1a7;
var $550af3a27577c496$export$e26fe2ed2fa76875;
var $550af3a27577c496$export$502329bbf4b505b1;
var $550af3a27577c496$export$6e3807111c4874c4;
var $550af3a27577c496$export$c27134553091fb3a;
var $550af3a27577c496$export$33ee1acdc04fd2a2;
var $550af3a27577c496$export$b00a404bbd5edef2;
var $550af3a27577c496$export$8352ce38b91d0c62;
var $550af3a27577c496$export$d66a1c1c77bd778b;
var $550af3a27577c496$export$d3dfb8e4810cb555;
var $550af3a27577c496$export$839f9183b0465a69;
var $550af3a27577c496$export$72fdf0e06517287b;
var $550af3a27577c496$export$4b844e58a3e414b4;
var $550af3a27577c496$export$816d2913ae6b83b1;
var $550af3a27577c496$export$61bcfe829111a1d0;
var $550af3a27577c496$export$7ee8c9beb337bc3f;
var $550af3a27577c496$export$b5836b71941fa3ed;
var $550af3a27577c496$export$cf845f2c119da08a;
'use strict';
function $550af3a27577c496$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $550af3a27577c496$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $550af3a27577c496$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $550af3a27577c496$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $550af3a27577c496$var$g(C, c)) n < e && 0 > $550af3a27577c496$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $550af3a27577c496$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $550af3a27577c496$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $550af3a27577c496$var$l = performance;
    $550af3a27577c496$export$c4744153514ff05d = function() {
        return $550af3a27577c496$var$l.now();
    };
} else {
    var $550af3a27577c496$var$p = Date, $550af3a27577c496$var$q = $550af3a27577c496$var$p.now();
    $550af3a27577c496$export$c4744153514ff05d = function() {
        return $550af3a27577c496$var$p.now() - $550af3a27577c496$var$q;
    };
}
var $550af3a27577c496$var$r = [], $550af3a27577c496$var$t = [], $550af3a27577c496$var$u = 1, $550af3a27577c496$var$v = null, $550af3a27577c496$var$y = 3, $550af3a27577c496$var$z = !1, $550af3a27577c496$var$A = !1, $550af3a27577c496$var$B = !1, $550af3a27577c496$var$D = "function" === typeof setTimeout ? setTimeout : null, $550af3a27577c496$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $550af3a27577c496$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $550af3a27577c496$var$G(a) {
    for(var b = $550af3a27577c496$var$h($550af3a27577c496$var$t); null !== b;){
        if (null === b.callback) $550af3a27577c496$var$k($550af3a27577c496$var$t);
        else if (b.startTime <= a) $550af3a27577c496$var$k($550af3a27577c496$var$t), b.sortIndex = b.expirationTime, $550af3a27577c496$var$f($550af3a27577c496$var$r, b);
        else break;
        b = $550af3a27577c496$var$h($550af3a27577c496$var$t);
    }
}
function $550af3a27577c496$var$H(a) {
    $550af3a27577c496$var$B = !1;
    $550af3a27577c496$var$G(a);
    if (!$550af3a27577c496$var$A) {
        if (null !== $550af3a27577c496$var$h($550af3a27577c496$var$r)) $550af3a27577c496$var$A = !0, $550af3a27577c496$var$I($550af3a27577c496$var$J);
        else {
            var b = $550af3a27577c496$var$h($550af3a27577c496$var$t);
            null !== b && $550af3a27577c496$var$K($550af3a27577c496$var$H, b.startTime - a);
        }
    }
}
function $550af3a27577c496$var$J(a, b) {
    $550af3a27577c496$var$A = !1;
    $550af3a27577c496$var$B && ($550af3a27577c496$var$B = !1, $550af3a27577c496$var$E($550af3a27577c496$var$L), $550af3a27577c496$var$L = -1);
    $550af3a27577c496$var$z = !0;
    var c = $550af3a27577c496$var$y;
    try {
        $550af3a27577c496$var$G(b);
        for($550af3a27577c496$var$v = $550af3a27577c496$var$h($550af3a27577c496$var$r); null !== $550af3a27577c496$var$v && (!($550af3a27577c496$var$v.expirationTime > b) || a && !$550af3a27577c496$var$M());){
            var d = $550af3a27577c496$var$v.callback;
            if ("function" === typeof d) {
                $550af3a27577c496$var$v.callback = null;
                $550af3a27577c496$var$y = $550af3a27577c496$var$v.priorityLevel;
                var e = d($550af3a27577c496$var$v.expirationTime <= b);
                b = $550af3a27577c496$export$c4744153514ff05d();
                "function" === typeof e ? $550af3a27577c496$var$v.callback = e : $550af3a27577c496$var$v === $550af3a27577c496$var$h($550af3a27577c496$var$r) && $550af3a27577c496$var$k($550af3a27577c496$var$r);
                $550af3a27577c496$var$G(b);
            } else $550af3a27577c496$var$k($550af3a27577c496$var$r);
            $550af3a27577c496$var$v = $550af3a27577c496$var$h($550af3a27577c496$var$r);
        }
        if (null !== $550af3a27577c496$var$v) var w = !0;
        else {
            var m = $550af3a27577c496$var$h($550af3a27577c496$var$t);
            null !== m && $550af3a27577c496$var$K($550af3a27577c496$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $550af3a27577c496$var$v = null, $550af3a27577c496$var$y = c, $550af3a27577c496$var$z = !1;
    }
}
var $550af3a27577c496$var$N = !1, $550af3a27577c496$var$O = null, $550af3a27577c496$var$L = -1, $550af3a27577c496$var$P = 5, $550af3a27577c496$var$Q = -1;
function $550af3a27577c496$var$M() {
    return $550af3a27577c496$export$c4744153514ff05d() - $550af3a27577c496$var$Q < $550af3a27577c496$var$P ? !1 : !0;
}
function $550af3a27577c496$var$R() {
    if (null !== $550af3a27577c496$var$O) {
        var a = $550af3a27577c496$export$c4744153514ff05d();
        $550af3a27577c496$var$Q = a;
        var b = !0;
        try {
            b = $550af3a27577c496$var$O(!0, a);
        } finally{
            b ? $550af3a27577c496$var$S() : ($550af3a27577c496$var$N = !1, $550af3a27577c496$var$O = null);
        }
    } else $550af3a27577c496$var$N = !1;
}
var $550af3a27577c496$var$S;
if ("function" === typeof $550af3a27577c496$var$F) $550af3a27577c496$var$S = function() {
    $550af3a27577c496$var$F($550af3a27577c496$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $550af3a27577c496$var$T = new MessageChannel, $550af3a27577c496$var$U = $550af3a27577c496$var$T.port2;
    $550af3a27577c496$var$T.port1.onmessage = $550af3a27577c496$var$R;
    $550af3a27577c496$var$S = function() {
        $550af3a27577c496$var$U.postMessage(null);
    };
} else $550af3a27577c496$var$S = function() {
    $550af3a27577c496$var$D($550af3a27577c496$var$R, 0);
};
function $550af3a27577c496$var$I(a) {
    $550af3a27577c496$var$O = a;
    $550af3a27577c496$var$N || ($550af3a27577c496$var$N = !0, $550af3a27577c496$var$S());
}
function $550af3a27577c496$var$K(a, b) {
    $550af3a27577c496$var$L = $550af3a27577c496$var$D(function() {
        a($550af3a27577c496$export$c4744153514ff05d());
    }, b);
}
$550af3a27577c496$export$3e506c1ccc9cc1a7 = 5;
$550af3a27577c496$export$e26fe2ed2fa76875 = 1;
$550af3a27577c496$export$502329bbf4b505b1 = 4;
$550af3a27577c496$export$6e3807111c4874c4 = 3;
$550af3a27577c496$export$c27134553091fb3a = null;
$550af3a27577c496$export$33ee1acdc04fd2a2 = 2;
$550af3a27577c496$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$550af3a27577c496$export$8352ce38b91d0c62 = function() {
    $550af3a27577c496$var$A || $550af3a27577c496$var$z || ($550af3a27577c496$var$A = !0, $550af3a27577c496$var$I($550af3a27577c496$var$J));
};
$550af3a27577c496$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $550af3a27577c496$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$550af3a27577c496$export$d3dfb8e4810cb555 = function() {
    return $550af3a27577c496$var$y;
};
$550af3a27577c496$export$839f9183b0465a69 = function() {
    return $550af3a27577c496$var$h($550af3a27577c496$var$r);
};
$550af3a27577c496$export$72fdf0e06517287b = function(a) {
    switch($550af3a27577c496$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $550af3a27577c496$var$y;
    }
    var c = $550af3a27577c496$var$y;
    $550af3a27577c496$var$y = b;
    try {
        return a();
    } finally{
        $550af3a27577c496$var$y = c;
    }
};
$550af3a27577c496$export$4b844e58a3e414b4 = function() {};
$550af3a27577c496$export$816d2913ae6b83b1 = function() {};
$550af3a27577c496$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $550af3a27577c496$var$y;
    $550af3a27577c496$var$y = a;
    try {
        return b();
    } finally{
        $550af3a27577c496$var$y = c;
    }
};
$550af3a27577c496$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $550af3a27577c496$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $550af3a27577c496$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $550af3a27577c496$var$f($550af3a27577c496$var$t, a), null === $550af3a27577c496$var$h($550af3a27577c496$var$r) && a === $550af3a27577c496$var$h($550af3a27577c496$var$t) && ($550af3a27577c496$var$B ? ($550af3a27577c496$var$E($550af3a27577c496$var$L), $550af3a27577c496$var$L = -1) : $550af3a27577c496$var$B = !0, $550af3a27577c496$var$K($550af3a27577c496$var$H, c - d))) : (a.sortIndex = e, $550af3a27577c496$var$f($550af3a27577c496$var$r, a), $550af3a27577c496$var$A || $550af3a27577c496$var$z || ($550af3a27577c496$var$A = !0, $550af3a27577c496$var$I($550af3a27577c496$var$J)));
    return a;
};
$550af3a27577c496$export$b5836b71941fa3ed = $550af3a27577c496$var$M;
$550af3a27577c496$export$cf845f2c119da08a = function(a) {
    var b = $550af3a27577c496$var$y;
    return function() {
        var c = $550af3a27577c496$var$y;
        $550af3a27577c496$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $550af3a27577c496$var$y = c;
        }
    };
};

});



parcelRegister("lJYlP", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $fd3c9d6b2ed943f6$export$c4744153514ff05d, (v) => $fd3c9d6b2ed943f6$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $fd3c9d6b2ed943f6$export$3e506c1ccc9cc1a7, (v) => $fd3c9d6b2ed943f6$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $fd3c9d6b2ed943f6$export$e26fe2ed2fa76875, (v) => $fd3c9d6b2ed943f6$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $fd3c9d6b2ed943f6$export$502329bbf4b505b1, (v) => $fd3c9d6b2ed943f6$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $fd3c9d6b2ed943f6$export$6e3807111c4874c4, (v) => $fd3c9d6b2ed943f6$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $fd3c9d6b2ed943f6$export$c27134553091fb3a, (v) => $fd3c9d6b2ed943f6$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $fd3c9d6b2ed943f6$export$33ee1acdc04fd2a2, (v) => $fd3c9d6b2ed943f6$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $fd3c9d6b2ed943f6$export$b00a404bbd5edef2, (v) => $fd3c9d6b2ed943f6$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $fd3c9d6b2ed943f6$export$8352ce38b91d0c62, (v) => $fd3c9d6b2ed943f6$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $fd3c9d6b2ed943f6$export$d66a1c1c77bd778b, (v) => $fd3c9d6b2ed943f6$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $fd3c9d6b2ed943f6$export$d3dfb8e4810cb555, (v) => $fd3c9d6b2ed943f6$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $fd3c9d6b2ed943f6$export$839f9183b0465a69, (v) => $fd3c9d6b2ed943f6$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $fd3c9d6b2ed943f6$export$72fdf0e06517287b, (v) => $fd3c9d6b2ed943f6$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $fd3c9d6b2ed943f6$export$4b844e58a3e414b4, (v) => $fd3c9d6b2ed943f6$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $fd3c9d6b2ed943f6$export$816d2913ae6b83b1, (v) => $fd3c9d6b2ed943f6$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $fd3c9d6b2ed943f6$export$61bcfe829111a1d0, (v) => $fd3c9d6b2ed943f6$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $fd3c9d6b2ed943f6$export$7ee8c9beb337bc3f, (v) => $fd3c9d6b2ed943f6$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $fd3c9d6b2ed943f6$export$b5836b71941fa3ed, (v) => $fd3c9d6b2ed943f6$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $fd3c9d6b2ed943f6$export$cf845f2c119da08a, (v) => $fd3c9d6b2ed943f6$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fd3c9d6b2ed943f6$export$c4744153514ff05d;
var $fd3c9d6b2ed943f6$export$3e506c1ccc9cc1a7;
var $fd3c9d6b2ed943f6$export$e26fe2ed2fa76875;
var $fd3c9d6b2ed943f6$export$502329bbf4b505b1;
var $fd3c9d6b2ed943f6$export$6e3807111c4874c4;
var $fd3c9d6b2ed943f6$export$c27134553091fb3a;
var $fd3c9d6b2ed943f6$export$33ee1acdc04fd2a2;
var $fd3c9d6b2ed943f6$export$b00a404bbd5edef2;
var $fd3c9d6b2ed943f6$export$8352ce38b91d0c62;
var $fd3c9d6b2ed943f6$export$d66a1c1c77bd778b;
var $fd3c9d6b2ed943f6$export$d3dfb8e4810cb555;
var $fd3c9d6b2ed943f6$export$839f9183b0465a69;
var $fd3c9d6b2ed943f6$export$72fdf0e06517287b;
var $fd3c9d6b2ed943f6$export$4b844e58a3e414b4;
var $fd3c9d6b2ed943f6$export$816d2913ae6b83b1;
var $fd3c9d6b2ed943f6$export$61bcfe829111a1d0;
var $fd3c9d6b2ed943f6$export$7ee8c9beb337bc3f;
var $fd3c9d6b2ed943f6$export$b5836b71941fa3ed;
var $fd3c9d6b2ed943f6$export$cf845f2c119da08a;
'use strict';
function $fd3c9d6b2ed943f6$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $fd3c9d6b2ed943f6$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $fd3c9d6b2ed943f6$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $fd3c9d6b2ed943f6$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $fd3c9d6b2ed943f6$var$g(C, c)) n < e && 0 > $fd3c9d6b2ed943f6$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $fd3c9d6b2ed943f6$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $fd3c9d6b2ed943f6$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $fd3c9d6b2ed943f6$var$l = performance;
    $fd3c9d6b2ed943f6$export$c4744153514ff05d = function() {
        return $fd3c9d6b2ed943f6$var$l.now();
    };
} else {
    var $fd3c9d6b2ed943f6$var$p = Date, $fd3c9d6b2ed943f6$var$q = $fd3c9d6b2ed943f6$var$p.now();
    $fd3c9d6b2ed943f6$export$c4744153514ff05d = function() {
        return $fd3c9d6b2ed943f6$var$p.now() - $fd3c9d6b2ed943f6$var$q;
    };
}
var $fd3c9d6b2ed943f6$var$r = [], $fd3c9d6b2ed943f6$var$t = [], $fd3c9d6b2ed943f6$var$u = 1, $fd3c9d6b2ed943f6$var$v = null, $fd3c9d6b2ed943f6$var$y = 3, $fd3c9d6b2ed943f6$var$z = !1, $fd3c9d6b2ed943f6$var$A = !1, $fd3c9d6b2ed943f6$var$B = !1, $fd3c9d6b2ed943f6$var$D = "function" === typeof setTimeout ? setTimeout : null, $fd3c9d6b2ed943f6$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $fd3c9d6b2ed943f6$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $fd3c9d6b2ed943f6$var$G(a) {
    for(var b = $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$t); null !== b;){
        if (null === b.callback) $fd3c9d6b2ed943f6$var$k($fd3c9d6b2ed943f6$var$t);
        else if (b.startTime <= a) $fd3c9d6b2ed943f6$var$k($fd3c9d6b2ed943f6$var$t), b.sortIndex = b.expirationTime, $fd3c9d6b2ed943f6$var$f($fd3c9d6b2ed943f6$var$r, b);
        else break;
        b = $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$t);
    }
}
function $fd3c9d6b2ed943f6$var$H(a) {
    $fd3c9d6b2ed943f6$var$B = !1;
    $fd3c9d6b2ed943f6$var$G(a);
    if (!$fd3c9d6b2ed943f6$var$A) {
        if (null !== $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$r)) $fd3c9d6b2ed943f6$var$A = !0, $fd3c9d6b2ed943f6$var$I($fd3c9d6b2ed943f6$var$J);
        else {
            var b = $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$t);
            null !== b && $fd3c9d6b2ed943f6$var$K($fd3c9d6b2ed943f6$var$H, b.startTime - a);
        }
    }
}
function $fd3c9d6b2ed943f6$var$J(a, b) {
    $fd3c9d6b2ed943f6$var$A = !1;
    $fd3c9d6b2ed943f6$var$B && ($fd3c9d6b2ed943f6$var$B = !1, $fd3c9d6b2ed943f6$var$E($fd3c9d6b2ed943f6$var$L), $fd3c9d6b2ed943f6$var$L = -1);
    $fd3c9d6b2ed943f6$var$z = !0;
    var c = $fd3c9d6b2ed943f6$var$y;
    try {
        $fd3c9d6b2ed943f6$var$G(b);
        for($fd3c9d6b2ed943f6$var$v = $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$r); null !== $fd3c9d6b2ed943f6$var$v && (!($fd3c9d6b2ed943f6$var$v.expirationTime > b) || a && !$fd3c9d6b2ed943f6$var$M());){
            var d = $fd3c9d6b2ed943f6$var$v.callback;
            if ("function" === typeof d) {
                $fd3c9d6b2ed943f6$var$v.callback = null;
                $fd3c9d6b2ed943f6$var$y = $fd3c9d6b2ed943f6$var$v.priorityLevel;
                var e = d($fd3c9d6b2ed943f6$var$v.expirationTime <= b);
                b = $fd3c9d6b2ed943f6$export$c4744153514ff05d();
                "function" === typeof e ? $fd3c9d6b2ed943f6$var$v.callback = e : $fd3c9d6b2ed943f6$var$v === $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$r) && $fd3c9d6b2ed943f6$var$k($fd3c9d6b2ed943f6$var$r);
                $fd3c9d6b2ed943f6$var$G(b);
            } else $fd3c9d6b2ed943f6$var$k($fd3c9d6b2ed943f6$var$r);
            $fd3c9d6b2ed943f6$var$v = $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$r);
        }
        if (null !== $fd3c9d6b2ed943f6$var$v) var w = !0;
        else {
            var m = $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$t);
            null !== m && $fd3c9d6b2ed943f6$var$K($fd3c9d6b2ed943f6$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $fd3c9d6b2ed943f6$var$v = null, $fd3c9d6b2ed943f6$var$y = c, $fd3c9d6b2ed943f6$var$z = !1;
    }
}
var $fd3c9d6b2ed943f6$var$N = !1, $fd3c9d6b2ed943f6$var$O = null, $fd3c9d6b2ed943f6$var$L = -1, $fd3c9d6b2ed943f6$var$P = 5, $fd3c9d6b2ed943f6$var$Q = -1;
function $fd3c9d6b2ed943f6$var$M() {
    return $fd3c9d6b2ed943f6$export$c4744153514ff05d() - $fd3c9d6b2ed943f6$var$Q < $fd3c9d6b2ed943f6$var$P ? !1 : !0;
}
function $fd3c9d6b2ed943f6$var$R() {
    if (null !== $fd3c9d6b2ed943f6$var$O) {
        var a = $fd3c9d6b2ed943f6$export$c4744153514ff05d();
        $fd3c9d6b2ed943f6$var$Q = a;
        var b = !0;
        try {
            b = $fd3c9d6b2ed943f6$var$O(!0, a);
        } finally{
            b ? $fd3c9d6b2ed943f6$var$S() : ($fd3c9d6b2ed943f6$var$N = !1, $fd3c9d6b2ed943f6$var$O = null);
        }
    } else $fd3c9d6b2ed943f6$var$N = !1;
}
var $fd3c9d6b2ed943f6$var$S;
if ("function" === typeof $fd3c9d6b2ed943f6$var$F) $fd3c9d6b2ed943f6$var$S = function() {
    $fd3c9d6b2ed943f6$var$F($fd3c9d6b2ed943f6$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $fd3c9d6b2ed943f6$var$T = new MessageChannel, $fd3c9d6b2ed943f6$var$U = $fd3c9d6b2ed943f6$var$T.port2;
    $fd3c9d6b2ed943f6$var$T.port1.onmessage = $fd3c9d6b2ed943f6$var$R;
    $fd3c9d6b2ed943f6$var$S = function() {
        $fd3c9d6b2ed943f6$var$U.postMessage(null);
    };
} else $fd3c9d6b2ed943f6$var$S = function() {
    $fd3c9d6b2ed943f6$var$D($fd3c9d6b2ed943f6$var$R, 0);
};
function $fd3c9d6b2ed943f6$var$I(a) {
    $fd3c9d6b2ed943f6$var$O = a;
    $fd3c9d6b2ed943f6$var$N || ($fd3c9d6b2ed943f6$var$N = !0, $fd3c9d6b2ed943f6$var$S());
}
function $fd3c9d6b2ed943f6$var$K(a, b) {
    $fd3c9d6b2ed943f6$var$L = $fd3c9d6b2ed943f6$var$D(function() {
        a($fd3c9d6b2ed943f6$export$c4744153514ff05d());
    }, b);
}
$fd3c9d6b2ed943f6$export$3e506c1ccc9cc1a7 = 5;
$fd3c9d6b2ed943f6$export$e26fe2ed2fa76875 = 1;
$fd3c9d6b2ed943f6$export$502329bbf4b505b1 = 4;
$fd3c9d6b2ed943f6$export$6e3807111c4874c4 = 3;
$fd3c9d6b2ed943f6$export$c27134553091fb3a = null;
$fd3c9d6b2ed943f6$export$33ee1acdc04fd2a2 = 2;
$fd3c9d6b2ed943f6$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$fd3c9d6b2ed943f6$export$8352ce38b91d0c62 = function() {
    $fd3c9d6b2ed943f6$var$A || $fd3c9d6b2ed943f6$var$z || ($fd3c9d6b2ed943f6$var$A = !0, $fd3c9d6b2ed943f6$var$I($fd3c9d6b2ed943f6$var$J));
};
$fd3c9d6b2ed943f6$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $fd3c9d6b2ed943f6$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$fd3c9d6b2ed943f6$export$d3dfb8e4810cb555 = function() {
    return $fd3c9d6b2ed943f6$var$y;
};
$fd3c9d6b2ed943f6$export$839f9183b0465a69 = function() {
    return $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$r);
};
$fd3c9d6b2ed943f6$export$72fdf0e06517287b = function(a) {
    switch($fd3c9d6b2ed943f6$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $fd3c9d6b2ed943f6$var$y;
    }
    var c = $fd3c9d6b2ed943f6$var$y;
    $fd3c9d6b2ed943f6$var$y = b;
    try {
        return a();
    } finally{
        $fd3c9d6b2ed943f6$var$y = c;
    }
};
$fd3c9d6b2ed943f6$export$4b844e58a3e414b4 = function() {};
$fd3c9d6b2ed943f6$export$816d2913ae6b83b1 = function() {};
$fd3c9d6b2ed943f6$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $fd3c9d6b2ed943f6$var$y;
    $fd3c9d6b2ed943f6$var$y = a;
    try {
        return b();
    } finally{
        $fd3c9d6b2ed943f6$var$y = c;
    }
};
$fd3c9d6b2ed943f6$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $fd3c9d6b2ed943f6$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $fd3c9d6b2ed943f6$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $fd3c9d6b2ed943f6$var$f($fd3c9d6b2ed943f6$var$t, a), null === $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$r) && a === $fd3c9d6b2ed943f6$var$h($fd3c9d6b2ed943f6$var$t) && ($fd3c9d6b2ed943f6$var$B ? ($fd3c9d6b2ed943f6$var$E($fd3c9d6b2ed943f6$var$L), $fd3c9d6b2ed943f6$var$L = -1) : $fd3c9d6b2ed943f6$var$B = !0, $fd3c9d6b2ed943f6$var$K($fd3c9d6b2ed943f6$var$H, c - d))) : (a.sortIndex = e, $fd3c9d6b2ed943f6$var$f($fd3c9d6b2ed943f6$var$r, a), $fd3c9d6b2ed943f6$var$A || $fd3c9d6b2ed943f6$var$z || ($fd3c9d6b2ed943f6$var$A = !0, $fd3c9d6b2ed943f6$var$I($fd3c9d6b2ed943f6$var$J)));
    return a;
};
$fd3c9d6b2ed943f6$export$b5836b71941fa3ed = $fd3c9d6b2ed943f6$var$M;
$fd3c9d6b2ed943f6$export$cf845f2c119da08a = function(a) {
    var b = $fd3c9d6b2ed943f6$var$y;
    return function() {
        var c = $fd3c9d6b2ed943f6$var$y;
        $fd3c9d6b2ed943f6$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $fd3c9d6b2ed943f6$var$y = c;
        }
    };
};

});

parcelRegister("2LLMu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Vector3", () => $204508e5b4b18960$export$64b5c384219d3699);
$parcel$export(module.exports, "VectorOps", () => $204508e5b4b18960$export$e2f642242c040d8f);
$parcel$export(module.exports, "Quaternion", () => $204508e5b4b18960$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "RotationOps", () => $204508e5b4b18960$export$824960640e91b57);
$parcel$export(module.exports, "SdpMatrix3", () => $204508e5b4b18960$export$a634d4178dd6cfce);
$parcel$export(module.exports, "SdpMatrix3Ops", () => $204508e5b4b18960$export$afeef1d10fc8a4f3);
$parcel$export(module.exports, "RigidBodyType", () => $204508e5b4b18960$export$9df1fa60cce90854);
$parcel$export(module.exports, "JointType", () => $204508e5b4b18960$export$d8c34c2371473e33);
$parcel$export(module.exports, "MotorModel", () => $204508e5b4b18960$export$9fe5861f16a3846f);
$parcel$export(module.exports, "JointAxesMask", () => $204508e5b4b18960$export$9fb152d4b46f94ce);
$parcel$export(module.exports, "CoefficientCombineRule", () => $204508e5b4b18960$export$5d7f3962eb4528af);
$parcel$export(module.exports, "FeatureType", () => $204508e5b4b18960$export$c40deacab7e2491c);
$parcel$export(module.exports, "ShapeType", () => $204508e5b4b18960$export$fc850f719b5599d5);
$parcel$export(module.exports, "HeightFieldFlags", () => $204508e5b4b18960$export$1a49384a8815c6a9);
$parcel$export(module.exports, "TriMeshFlags", () => $204508e5b4b18960$export$5dbdc437333f52f1);
$parcel$export(module.exports, "QueryFilterFlags", () => $204508e5b4b18960$export$39a39008025d4cb);
$parcel$export(module.exports, "ActiveEvents", () => $204508e5b4b18960$export$f28998d26d157fd3);
$parcel$export(module.exports, "ActiveHooks", () => $204508e5b4b18960$export$194d8ad9e2dc63e8);
$parcel$export(module.exports, "SolverFlags", () => $204508e5b4b18960$export$d50a7c063745a562);
$parcel$export(module.exports, "ActiveCollisionTypes", () => $204508e5b4b18960$export$822f84f0c1c58b2a);
$parcel$export(module.exports, "MassPropsMode", () => $204508e5b4b18960$export$9d99ce4bda7104cf);
$parcel$export(module.exports, "RigidBody", () => $204508e5b4b18960$export$41c0a739a32ac4d);
$parcel$export(module.exports, "RigidBodyDesc", () => $204508e5b4b18960$export$105dcb996a5d3c42);
$parcel$export(module.exports, "RigidBodySet", () => $204508e5b4b18960$export$bd569bf5451ee055);
$parcel$export(module.exports, "IntegrationParameters", () => $204508e5b4b18960$export$c22d4691787a8578);
$parcel$export(module.exports, "ImpulseJoint", () => $204508e5b4b18960$export$13616a6dfa0c261e);
$parcel$export(module.exports, "RevoluteImpulseJoint", () => $204508e5b4b18960$export$f21c6aedecbeb53d);
$parcel$export(module.exports, "PrismaticImpulseJoint", () => $204508e5b4b18960$export$ca91224fa01cc4c5);
$parcel$export(module.exports, "FixedImpulseJoint", () => $204508e5b4b18960$export$13a2c1429de97fd0);
$parcel$export(module.exports, "SpringImpulseJoint", () => $204508e5b4b18960$export$6a104d5406ced20);
$parcel$export(module.exports, "RopeImpulseJoint", () => $204508e5b4b18960$export$21cd30e53afbf3c1);
$parcel$export(module.exports, "SphericalImpulseJoint", () => $204508e5b4b18960$export$da358565907d92be);
$parcel$export(module.exports, "GenericImpulseJoint", () => $204508e5b4b18960$export$9c43d159fbe4a60);
$parcel$export(module.exports, "UnitImpulseJoint", () => $204508e5b4b18960$export$b6c446c752acb453);
$parcel$export(module.exports, "JointData", () => $204508e5b4b18960$export$9ad4996060073eaa);
$parcel$export(module.exports, "ImpulseJointSet", () => $204508e5b4b18960$export$7b6f816cee9f25f2);
$parcel$export(module.exports, "MultibodyJoint", () => $204508e5b4b18960$export$9f6b52d8d09f7b72);
$parcel$export(module.exports, "RevoluteMultibodyJoint", () => $204508e5b4b18960$export$e2bca3ac97ae239e);
$parcel$export(module.exports, "PrismaticMultibodyJoint", () => $204508e5b4b18960$export$1ac8e4ec1713e3da);
$parcel$export(module.exports, "FixedMultibodyJoint", () => $204508e5b4b18960$export$6984fd596a92ce33);
$parcel$export(module.exports, "SphericalMultibodyJoint", () => $204508e5b4b18960$export$b9ffb05588678855);
$parcel$export(module.exports, "UnitMultibodyJoint", () => $204508e5b4b18960$export$b677e6fe6c6cb994);
$parcel$export(module.exports, "MultibodyJointSet", () => $204508e5b4b18960$export$b6a38ee363602c2a);
$parcel$export(module.exports, "CCDSolver", () => $204508e5b4b18960$export$ffc4c782649f077);
$parcel$export(module.exports, "IslandManager", () => $204508e5b4b18960$export$129e66920a069ba5);
$parcel$export(module.exports, "BroadPhase", () => $204508e5b4b18960$export$d80423229f8b133);
$parcel$export(module.exports, "NarrowPhase", () => $204508e5b4b18960$export$f7b463e625571e2b);
$parcel$export(module.exports, "TempContactManifold", () => $204508e5b4b18960$export$7ac890e03fe91616);
$parcel$export(module.exports, "ShapeContact", () => $204508e5b4b18960$export$1d7ee127e07c91bb);
$parcel$export(module.exports, "PointProjection", () => $204508e5b4b18960$export$5e813b027a709134);
$parcel$export(module.exports, "PointColliderProjection", () => $204508e5b4b18960$export$fc779dece190555);
$parcel$export(module.exports, "Ray", () => $204508e5b4b18960$export$a186db52eed6d40e);
$parcel$export(module.exports, "RayIntersection", () => $204508e5b4b18960$export$292489680db6ed3f);
$parcel$export(module.exports, "RayColliderIntersection", () => $204508e5b4b18960$export$bc228139800bb3c);
$parcel$export(module.exports, "RayColliderHit", () => $204508e5b4b18960$export$f559542b3fef6583);
$parcel$export(module.exports, "ShapeCastHit", () => $204508e5b4b18960$export$2f19b12a78c879bd);
$parcel$export(module.exports, "ColliderShapeCastHit", () => $204508e5b4b18960$export$e46fe1533b6b9d13);
$parcel$export(module.exports, "Shape", () => $204508e5b4b18960$export$6428a7f2611ef1fa);
$parcel$export(module.exports, "Ball", () => $204508e5b4b18960$export$a83d7c3fa53790c9);
$parcel$export(module.exports, "Cuboid", () => $204508e5b4b18960$export$c8821cc685709b7b);
$parcel$export(module.exports, "RoundCuboid", () => $204508e5b4b18960$export$c87d2c121efe06ab);
$parcel$export(module.exports, "Capsule", () => $204508e5b4b18960$export$28bdb8fc07bf3804);
$parcel$export(module.exports, "Segment", () => $204508e5b4b18960$export$d53aa5c5ab432700);
$parcel$export(module.exports, "Polyline", () => $204508e5b4b18960$export$79f3ee03e63e7073);
$parcel$export(module.exports, "Triangle", () => $204508e5b4b18960$export$5a465592bfe74b48);
$parcel$export(module.exports, "RoundTriangle", () => $204508e5b4b18960$export$5d38c33920824fab);
$parcel$export(module.exports, "HalfSpace", () => $204508e5b4b18960$export$b774d5dd1a533096);
$parcel$export(module.exports, "TriMesh", () => $204508e5b4b18960$export$16df86f06e459b09);
$parcel$export(module.exports, "Heightfield", () => $204508e5b4b18960$export$fa360b5b58f475b7);
$parcel$export(module.exports, "ConvexPolyhedron", () => $204508e5b4b18960$export$7c637a75bc263948);
$parcel$export(module.exports, "RoundConvexPolyhedron", () => $204508e5b4b18960$export$f9ecc9020d30774f);
$parcel$export(module.exports, "Cylinder", () => $204508e5b4b18960$export$665c37f020fe48f9);
$parcel$export(module.exports, "RoundCylinder", () => $204508e5b4b18960$export$6fe70449556bd1bd);
$parcel$export(module.exports, "Cone", () => $204508e5b4b18960$export$22209bc4af3d3757);
$parcel$export(module.exports, "RoundCone", () => $204508e5b4b18960$export$fec6094316a593bd);
$parcel$export(module.exports, "PhysicsPipeline", () => $204508e5b4b18960$export$f3c42ca1c254a387);
$parcel$export(module.exports, "QueryPipeline", () => $204508e5b4b18960$export$636a60a98ff98f0b);
$parcel$export(module.exports, "SerializationPipeline", () => $204508e5b4b18960$export$b54bf36dd1f18c08);
$parcel$export(module.exports, "World", () => $204508e5b4b18960$export$812cd9544993280d);
$parcel$export(module.exports, "DebugRenderBuffers", () => $204508e5b4b18960$export$354e114f10103d2d);
$parcel$export(module.exports, "DebugRenderPipeline", () => $204508e5b4b18960$export$acdffcc934f6bc95);
$parcel$export(module.exports, "CharacterCollision", () => $204508e5b4b18960$export$d8a6c60ecc79c6a6);
$parcel$export(module.exports, "KinematicCharacterController", () => $204508e5b4b18960$export$ed5de7d26b924ce3);
$parcel$export(module.exports, "DynamicRayCastVehicleController", () => $204508e5b4b18960$export$563c60dbc0927729);
$parcel$export(module.exports, "ColliderSet", () => $204508e5b4b18960$export$8ec69bf37b303313);
$parcel$export(module.exports, "TempContactForceEvent", () => $204508e5b4b18960$export$cba99c196a0dcc61);
$parcel$export(module.exports, "EventQueue", () => $204508e5b4b18960$export$2fc6338444a158e6);
$parcel$export(module.exports, "Collider", () => $204508e5b4b18960$export$b7c6eef0ebb06133);
$parcel$export(module.exports, "ColliderDesc", () => $204508e5b4b18960$export$7d4cec221ee36947);
$parcel$export(module.exports, "init", () => $204508e5b4b18960$export$2cd8252107eb640b);
$parcel$export(module.exports, "version", () => $204508e5b4b18960$export$83d89fbfd8236492);
$parcel$export(module.exports, "default", () => $204508e5b4b18960$export$2e2bcd8739ae039);
let $204508e5b4b18960$var$A;
const $204508e5b4b18960$var$I = new Array(128).fill(void 0);
$204508e5b4b18960$var$I.push(void 0, null, !0, !1);
let $204508e5b4b18960$var$g = $204508e5b4b18960$var$I.length;
function $204508e5b4b18960$var$C(A) {
    $204508e5b4b18960$var$g === $204508e5b4b18960$var$I.length && $204508e5b4b18960$var$I.push($204508e5b4b18960$var$I.length + 1);
    const C = $204508e5b4b18960$var$g;
    return $204508e5b4b18960$var$g = $204508e5b4b18960$var$I[C], $204508e5b4b18960$var$I[C] = A, C;
}
function $204508e5b4b18960$var$B(A) {
    return $204508e5b4b18960$var$I[A];
}
function $204508e5b4b18960$var$Q(A) {
    const C = $204508e5b4b18960$var$B(A);
    return function(A) {
        A < 132 || ($204508e5b4b18960$var$I[A] = $204508e5b4b18960$var$g, $204508e5b4b18960$var$g = A);
    }(A), C;
}
function $204508e5b4b18960$var$E(A) {
    return null == A;
}
let $204508e5b4b18960$var$i = null;
function $204508e5b4b18960$var$D() {
    return null !== $204508e5b4b18960$var$i && 0 !== $204508e5b4b18960$var$i.byteLength || ($204508e5b4b18960$var$i = new Float64Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$i;
}
let $204508e5b4b18960$var$o = null;
function $204508e5b4b18960$var$G() {
    return null !== $204508e5b4b18960$var$o && 0 !== $204508e5b4b18960$var$o.byteLength || ($204508e5b4b18960$var$o = new Int32Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$o;
}
const $204508e5b4b18960$var$w = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8", {
    ignoreBOM: !0,
    fatal: !0
}) : {
    decode: ()=>{
        throw Error("TextDecoder not available");
    }
};
"undefined" != typeof TextDecoder && $204508e5b4b18960$var$w.decode();
let $204508e5b4b18960$var$S = null;
function $204508e5b4b18960$var$k(I, g) {
    return I >>>= 0, $204508e5b4b18960$var$w.decode((null !== $204508e5b4b18960$var$S && 0 !== $204508e5b4b18960$var$S.byteLength || ($204508e5b4b18960$var$S = new Uint8Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$S).subarray(I, I + g));
}
function $204508e5b4b18960$var$U(A, I) {
    if (!(A instanceof I)) throw new Error(`expected instance of ${I.name}`);
    return A.ptr;
}
let $204508e5b4b18960$var$a = null;
function $204508e5b4b18960$var$K() {
    return null !== $204508e5b4b18960$var$a && 0 !== $204508e5b4b18960$var$a.byteLength || ($204508e5b4b18960$var$a = new Float32Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$a;
}
let $204508e5b4b18960$var$h = 128;
function $204508e5b4b18960$var$J(A) {
    if (1 == $204508e5b4b18960$var$h) throw new Error("out of js stack");
    return $204508e5b4b18960$var$I[--$204508e5b4b18960$var$h] = A, $204508e5b4b18960$var$h;
}
function $204508e5b4b18960$var$y(A, I) {
    return A >>>= 0, $204508e5b4b18960$var$K().subarray(A / 4, A / 4 + I);
}
let $204508e5b4b18960$var$M = null;
function $204508e5b4b18960$var$N() {
    return null !== $204508e5b4b18960$var$M && 0 !== $204508e5b4b18960$var$M.byteLength || ($204508e5b4b18960$var$M = new Uint32Array($204508e5b4b18960$var$A.memory.buffer)), $204508e5b4b18960$var$M;
}
let $204508e5b4b18960$var$F = 0;
function $204508e5b4b18960$var$R(A, I) {
    const g = I(4 * A.length, 4) >>> 0;
    return $204508e5b4b18960$var$K().set(A, g / 4), $204508e5b4b18960$var$F = A.length, g;
}
function $204508e5b4b18960$var$q(A, I) {
    const g = I(4 * A.length, 4) >>> 0;
    return $204508e5b4b18960$var$N().set(A, g / 4), $204508e5b4b18960$var$F = A.length, g;
}
function $204508e5b4b18960$var$s(I, g) {
    try {
        return I.apply(this, g);
    } catch (I) {
        $204508e5b4b18960$var$A.__wbindgen_exn_store($204508e5b4b18960$var$C(I));
    }
}
Object.freeze({
    Dynamic: 0,
    0: "Dynamic",
    Fixed: 1,
    1: "Fixed",
    KinematicPositionBased: 2,
    2: "KinematicPositionBased",
    KinematicVelocityBased: 3,
    3: "KinematicVelocityBased"
}), Object.freeze({
    Vertex: 0,
    0: "Vertex",
    Edge: 1,
    1: "Edge",
    Face: 2,
    2: "Face",
    Unknown: 3,
    3: "Unknown"
});
const $204508e5b4b18960$var$c = Object.freeze({
    Ball: 0,
    0: "Ball",
    Cuboid: 1,
    1: "Cuboid",
    Capsule: 2,
    2: "Capsule",
    Segment: 3,
    3: "Segment",
    Polyline: 4,
    4: "Polyline",
    Triangle: 5,
    5: "Triangle",
    TriMesh: 6,
    6: "TriMesh",
    HeightField: 7,
    7: "HeightField",
    Compound: 8,
    8: "Compound",
    ConvexPolyhedron: 9,
    9: "ConvexPolyhedron",
    Cylinder: 10,
    10: "Cylinder",
    Cone: 11,
    11: "Cone",
    RoundCuboid: 12,
    12: "RoundCuboid",
    RoundTriangle: 13,
    13: "RoundTriangle",
    RoundCylinder: 14,
    14: "RoundCylinder",
    RoundCone: 15,
    15: "RoundCone",
    RoundConvexPolyhedron: 16,
    16: "RoundConvexPolyhedron",
    HalfSpace: 17,
    17: "HalfSpace"
}), $204508e5b4b18960$var$Y = Object.freeze({
    X: 0,
    0: "X",
    Y: 1,
    1: "Y",
    Z: 2,
    2: "Z",
    AngX: 3,
    3: "AngX",
    AngY: 4,
    4: "AngY",
    AngZ: 5,
    5: "AngZ"
});
Object.freeze({
    AccelerationBased: 0,
    0: "AccelerationBased",
    ForceBased: 1,
    1: "ForceBased"
});
const $204508e5b4b18960$var$l = Object.freeze({
    Revolute: 0,
    0: "Revolute",
    Fixed: 1,
    1: "Fixed",
    Prismatic: 2,
    2: "Prismatic",
    Rope: 3,
    3: "Rope",
    Spring: 4,
    4: "Spring",
    Spherical: 5,
    5: "Spherical",
    Generic: 6,
    6: "Generic"
});
class $204508e5b4b18960$var$H {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$H.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawbroadphase_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawbroadphase_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
}
class $204508e5b4b18960$var$L {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawccdsolver_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawccdsolver_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
}
class $204508e5b4b18960$var$t {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcharactercollision_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawcharactercollision_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    handle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.__wbg_ptr);
    }
    translationDeltaApplied() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    translationDeltaRemaining() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationDeltaRemaining(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    toi() {
        return $204508e5b4b18960$var$A.rawcharactercollision_toi(this.__wbg_ptr);
    }
    worldWitness1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    worldWitness2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldWitness2(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    worldNormal1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldNormal1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    worldNormal2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_worldNormal2(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
}
class $204508e5b4b18960$var$p {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$p.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcolliderset_free(I);
    }
    coTranslation(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coTranslation(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    coRotation(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coRotation(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    coSetTranslation(I, g, C, B) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetTranslation(this.__wbg_ptr, I, g, C, B);
    }
    coSetTranslationWrtParent(I, g, C, B) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetTranslationWrtParent(this.__wbg_ptr, I, g, C, B);
    }
    coSetRotation(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRotation(this.__wbg_ptr, I, g, C, B, Q);
    }
    coSetRotationWrtParent(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRotationWrtParent(this.__wbg_ptr, I, g, C, B, Q);
    }
    coIsSensor(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIsSensor(this.__wbg_ptr, I);
    }
    coShapeType(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coShapeType(this.__wbg_ptr, I);
    }
    coHalfspaceNormal(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coHalfspaceNormal(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    coHalfExtents(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coHalfExtents(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    coSetHalfExtents(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawcolliderset_coSetHalfExtents(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    coRadius(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coRadius(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetRadius(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRadius(this.__wbg_ptr, I, g);
    }
    coHalfHeight(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHalfHeight(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetHalfHeight(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetHalfHeight(this.__wbg_ptr, I, g);
    }
    coRoundRadius(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coRoundRadius(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetRoundRadius(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRoundRadius(this.__wbg_ptr, I, g);
    }
    coVertices(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coVertices(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            let Q;
            return 0 !== g && (Q = $204508e5b4b18960$var$y(g, C).slice(), $204508e5b4b18960$var$A.__wbindgen_free(g, 4 * C, 4)), Q;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coIndices(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coIndices(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            let Q;
            return 0 !== g && (Q = (function(A, I) {
                return A >>>= 0, $204508e5b4b18960$var$N().subarray(A / 4, A / 4 + I);
            })(g, C).slice(), $204508e5b4b18960$var$A.__wbindgen_free(g, 4 * C, 4)), Q;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coTriMeshFlags(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coTriMeshFlags(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            return 0 === g ? void 0 : C >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightFieldFlags(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightFieldFlags(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            return 0 === g ? void 0 : C >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightfieldHeights(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldHeights(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            let Q;
            return 0 !== g && (Q = $204508e5b4b18960$var$y(g, C).slice(), $204508e5b4b18960$var$A.__wbindgen_free(g, 4 * C, 4)), Q;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightfieldScale(I) {
        const g = $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldScale(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    coHeightfieldNRows(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldNRows(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            return 0 === g ? void 0 : C >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coHeightfieldNCols(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coHeightfieldNCols(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$G()[B / 4 + 1];
            return 0 === g ? void 0 : C >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coParent(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawcolliderset_coParent(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$D()[B / 8 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    coSetEnabled(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetEnabled(this.__wbg_ptr, I, g);
    }
    coIsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIsEnabled(this.__wbg_ptr, I);
    }
    coSetContactSkin(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetContactSkin(this.__wbg_ptr, I, g);
    }
    coContactSkin(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coContactSkin(this.__wbg_ptr, I);
    }
    coFriction(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coFriction(this.__wbg_ptr, I);
    }
    coRestitution(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coRestitution(this.__wbg_ptr, I);
    }
    coDensity(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coDensity(this.__wbg_ptr, I);
    }
    coMass(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coMass(this.__wbg_ptr, I);
    }
    coVolume(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coVolume(this.__wbg_ptr, I);
    }
    coCollisionGroups(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coCollisionGroups(this.__wbg_ptr, I) >>> 0;
    }
    coSolverGroups(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coSolverGroups(this.__wbg_ptr, I) >>> 0;
    }
    coActiveHooks(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coActiveHooks(this.__wbg_ptr, I) >>> 0;
    }
    coActiveCollisionTypes(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coActiveCollisionTypes(this.__wbg_ptr, I);
    }
    coActiveEvents(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coActiveEvents(this.__wbg_ptr, I) >>> 0;
    }
    coContactForceEventThreshold(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coContactForceEventThreshold(this.__wbg_ptr, I);
    }
    coContainsPoint(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA);
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coContainsPoint(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    coCastShape(I, g, C, B, Q, E, i, D, o) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(E, $204508e5b4b18960$var$DA);
        const G = $204508e5b4b18960$var$A.rawcolliderset_coCastShape(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, E.__wbg_ptr, i, D, o);
        return 0 === G ? void 0 : $204508e5b4b18960$var$EA.__wrap(G);
    }
    coCastCollider(I, g, C, B, Q, E, i) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
        const D = $204508e5b4b18960$var$A.rawcolliderset_coCastCollider(this.__wbg_ptr, I, g.__wbg_ptr, C, B.__wbg_ptr, Q, E, i);
        return 0 === D ? void 0 : $204508e5b4b18960$var$e.__wrap(D);
    }
    coIntersectsShape(I, g, C, B) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$gA);
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIntersectsShape(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr);
    }
    coContactShape(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$gA);
        const E = $204508e5b4b18960$var$A.rawcolliderset_coContactShape(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q);
        return 0 === E ? void 0 : $204508e5b4b18960$var$iA.__wrap(E);
    }
    coContactCollider(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawcolliderset_coContactCollider(this.__wbg_ptr, I, g, C);
        return 0 === B ? void 0 : $204508e5b4b18960$var$iA.__wrap(B);
    }
    coProjectPoint(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA);
        const B = $204508e5b4b18960$var$A.rawcolliderset_coProjectPoint(this.__wbg_ptr, I, g.__wbg_ptr, C);
        return $204508e5b4b18960$var$z.__wrap(B);
    }
    coIntersectsRay(I, g, C, B) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_coIntersectsRay(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B);
    }
    coCastRay(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        return $204508e5b4b18960$var$A.rawcolliderset_coCastRay(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B, Q);
    }
    coCastRayAndGetNormal(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const E = $204508e5b4b18960$var$A.rawcolliderset_coCastRayAndGetNormal(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B, Q);
        return 0 === E ? void 0 : $204508e5b4b18960$var$AA.__wrap(E);
    }
    coSetSensor(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetSensor(this.__wbg_ptr, I, g);
    }
    coSetRestitution(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRestitution(this.__wbg_ptr, I, g);
    }
    coSetFriction(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetFriction(this.__wbg_ptr, I, g);
    }
    coFrictionCombineRule(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coFrictionCombineRule(this.__wbg_ptr, I) >>> 0;
    }
    coSetFrictionCombineRule(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetFrictionCombineRule(this.__wbg_ptr, I, g);
    }
    coRestitutionCombineRule(I) {
        return $204508e5b4b18960$var$A.rawcolliderset_coRestitutionCombineRule(this.__wbg_ptr, I) >>> 0;
    }
    coSetRestitutionCombineRule(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetRestitutionCombineRule(this.__wbg_ptr, I, g);
    }
    coSetCollisionGroups(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetCollisionGroups(this.__wbg_ptr, I, g);
    }
    coSetSolverGroups(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetSolverGroups(this.__wbg_ptr, I, g);
    }
    coSetActiveHooks(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetActiveHooks(this.__wbg_ptr, I, g);
    }
    coSetActiveEvents(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetActiveEvents(this.__wbg_ptr, I, g);
    }
    coSetActiveCollisionTypes(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetActiveCollisionTypes(this.__wbg_ptr, I, g);
    }
    coSetShape(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawcolliderset_coSetShape(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    coSetContactForceEventThreshold(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetContactForceEventThreshold(this.__wbg_ptr, I, g);
    }
    coSetDensity(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetDensity(this.__wbg_ptr, I, g);
    }
    coSetMass(I, g) {
        $204508e5b4b18960$var$A.rawcolliderset_coSetMass(this.__wbg_ptr, I, g);
    }
    coSetMassProperties(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$A.rawcolliderset_coSetMassProperties(this.__wbg_ptr, I, g, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawcolliderset_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    len() {
        return $204508e5b4b18960$var$A.rawcolliderset_len(this.__wbg_ptr) >>> 0;
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_contains(this.__wbg_ptr, I);
    }
    createCollider(I, g, C, B, Q, E, i, o, w, S, k, a, K, h, J, y, M, N, F, R, q, s, c, Y, l) {
        try {
            const t = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(o, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(w, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(l, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$A.rawcolliderset_createCollider(t, this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q, E, i.__wbg_ptr, o.__wbg_ptr, w.__wbg_ptr, S, k, a, K, h, J, y, M, N, F, R, q, s, c, Y, l.__wbg_ptr);
            var H = $204508e5b4b18960$var$G()[t / 4 + 0], L = $204508e5b4b18960$var$D()[t / 8 + 1];
            return 0 === H ? void 0 : L;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    remove(I, g, C, B) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$m), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$A.rawcolliderset_remove(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B);
    }
    isHandleValid(I) {
        return 0 !== $204508e5b4b18960$var$A.rawcolliderset_contains(this.__wbg_ptr, I);
    }
    forEachColliderHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawcolliderset_forEachColliderHandle(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$e {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$e.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcollidershapecasthit_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.__wbg_ptr);
    }
    time_of_impact() {
        return $204508e5b4b18960$var$A.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
    }
    witness1() {
        const I = $204508e5b4b18960$var$A.rawcollidershapecasthit_witness1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    witness2() {
        const I = $204508e5b4b18960$var$A.rawcollidershapecasthit_witness2(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    normal1() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    normal2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationDeltaRemaining(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
}
class $204508e5b4b18960$var$r {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$r.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcontactforceevent_free(I);
    }
    collider1() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.__wbg_ptr);
    }
    collider2() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_collider2(this.__wbg_ptr);
    }
    total_force() {
        const I = $204508e5b4b18960$var$A.rawcontactforceevent_total_force(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    total_force_magnitude() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_total_force_magnitude(this.__wbg_ptr);
    }
    max_force_direction() {
        const I = $204508e5b4b18960$var$A.rawcontactforceevent_max_force_direction(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    max_force_magnitude() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_max_force_magnitude(this.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$d {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$d.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcontactmanifold_free(I);
    }
    normal() {
        const I = $204508e5b4b18960$var$A.rawcontactmanifold_normal(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    local_n1() {
        const I = $204508e5b4b18960$var$A.rawcontactmanifold_local_n1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    local_n2() {
        const I = $204508e5b4b18960$var$A.rawcontactmanifold_local_n2(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    subshape1() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_subshape1(this.__wbg_ptr) >>> 0;
    }
    subshape2() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_subshape2(this.__wbg_ptr) >>> 0;
    }
    num_contacts() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_num_contacts(this.__wbg_ptr) >>> 0;
    }
    contact_local_p1(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_contact_local_p1(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    contact_local_p2(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_contact_local_p2(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    contact_dist(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_dist(this.__wbg_ptr, I);
    }
    contact_fid1(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_fid1(this.__wbg_ptr, I) >>> 0;
    }
    contact_fid2(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_fid2(this.__wbg_ptr, I) >>> 0;
    }
    contact_impulse(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_impulse(this.__wbg_ptr, I);
    }
    contact_tangent_impulse_x(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_tangent_impulse_x(this.__wbg_ptr, I);
    }
    contact_tangent_impulse_y(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_contact_tangent_impulse_y(this.__wbg_ptr, I);
    }
    num_solver_contacts() {
        return $204508e5b4b18960$var$A.rawcontactmanifold_num_solver_contacts(this.__wbg_ptr) >>> 0;
    }
    solver_contact_point(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_point(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    solver_contact_dist(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_dist(this.__wbg_ptr, I);
    }
    solver_contact_friction(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_friction(this.__wbg_ptr, I);
    }
    solver_contact_restitution(I) {
        return $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_restitution(this.__wbg_ptr, I);
    }
    solver_contact_tangent_velocity(I) {
        const g = $204508e5b4b18960$var$A.rawcontactmanifold_solver_contact_tangent_velocity(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
}
class $204508e5b4b18960$var$T {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$T.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawcontactpair_free(I);
    }
    collider1() {
        return $204508e5b4b18960$var$A.rawcontactpair_collider1(this.__wbg_ptr);
    }
    collider2() {
        return $204508e5b4b18960$var$A.rawcontactpair_collider2(this.__wbg_ptr);
    }
    numContactManifolds() {
        return $204508e5b4b18960$var$A.rawcontactpair_numContactManifolds(this.__wbg_ptr) >>> 0;
    }
    contactManifold(I) {
        const g = $204508e5b4b18960$var$A.rawcontactpair_contactManifold(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$d.__wrap(g);
    }
}
class $204508e5b4b18960$var$O {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawdebugrenderpipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawdebugrenderpipeline_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    vertices() {
        return $204508e5b4b18960$var$Q($204508e5b4b18960$var$A.rawdebugrenderpipeline_vertices(this.__wbg_ptr));
    }
    colors() {
        return $204508e5b4b18960$var$Q($204508e5b4b18960$var$A.rawdebugrenderpipeline_colors(this.__wbg_ptr));
    }
    render(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$W), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$V), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$X), $204508e5b4b18960$var$A.rawdebugrenderpipeline_render(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$n {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$n.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawdeserializedworld_free(I);
    }
    takeGravity() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeGravity(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$DA.__wrap(I);
    }
    takeIntegrationParameters() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeIntegrationParameters(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$j.__wrap(I);
    }
    takeIslandManager() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeIslandManager(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$m.__wrap(I);
    }
    takeBroadPhase() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeBroadPhase(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$H.__wrap(I);
    }
    takeNarrowPhase() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeNarrowPhase(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$X.__wrap(I);
    }
    takeBodies() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeBodies(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$IA.__wrap(I);
    }
    takeColliders() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeColliders(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$p.__wrap(I);
    }
    takeImpulseJoints() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeImpulseJoints(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$W.__wrap(I);
    }
    takeMultibodyJoints() {
        const I = $204508e5b4b18960$var$A.rawdeserializedworld_takeMultibodyJoints(this.__wbg_ptr);
        return 0 === I ? void 0 : $204508e5b4b18960$var$V.__wrap(I);
    }
}
class $204508e5b4b18960$var$Z {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawdynamicraycastvehiclecontroller_free(I);
    }
    constructor(I){
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_new(I);
        return this.__wbg_ptr = g >>> 0, this;
    }
    current_vehicle_speed() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_current_vehicle_speed(this.__wbg_ptr);
    }
    chassis() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_chassis(this.__wbg_ptr);
    }
    index_up_axis() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_index_up_axis(this.__wbg_ptr) >>> 0;
    }
    set_index_up_axis(I) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_index_up_axis(this.__wbg_ptr, I);
    }
    index_forward_axis() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_index_forward_axis(this.__wbg_ptr) >>> 0;
    }
    set_index_forward_axis(I) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_index_forward_axis(this.__wbg_ptr, I);
    }
    add_wheel(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_add_wheel(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B, Q);
    }
    num_wheels() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_num_wheels(this.__wbg_ptr) >>> 0;
    }
    update_vehicle(g, C, B, Q, i, D, o) {
        try {
            $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$v), $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_update_vehicle(this.__wbg_ptr, g, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, $204508e5b4b18960$var$J(o));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    wheel_chassis_connection_point_cs(I) {
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_chassis_connection_point_cs(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    set_wheel_chassis_connection_point_cs(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_chassis_connection_point_cs(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    wheel_suspension_rest_length(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_suspension_rest_length(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_suspension_rest_length(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_suspension_rest_length(this.__wbg_ptr, I, g);
    }
    wheel_max_suspension_travel(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_max_suspension_travel(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_max_suspension_travel(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_max_suspension_travel(this.__wbg_ptr, I, g);
    }
    wheel_radius(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_radius(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_radius(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_radius(this.__wbg_ptr, I, g);
    }
    wheel_suspension_stiffness(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_suspension_stiffness(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_suspension_stiffness(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_suspension_stiffness(this.__wbg_ptr, I, g);
    }
    wheel_suspension_compression(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_suspension_compression(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_suspension_compression(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_suspension_compression(this.__wbg_ptr, I, g);
    }
    wheel_suspension_relaxation(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_suspension_relaxation(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_suspension_relaxation(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_suspension_relaxation(this.__wbg_ptr, I, g);
    }
    wheel_max_suspension_force(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_max_suspension_force(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_max_suspension_force(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_max_suspension_force(this.__wbg_ptr, I, g);
    }
    wheel_brake(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_brake(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_brake(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_brake(this.__wbg_ptr, I, g);
    }
    wheel_steering(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_steering(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_steering(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_steering(this.__wbg_ptr, I, g);
    }
    wheel_engine_force(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_engine_force(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_engine_force(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_engine_force(this.__wbg_ptr, I, g);
    }
    wheel_direction_cs(I) {
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_direction_cs(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    set_wheel_direction_cs(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_direction_cs(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    wheel_axle_cs(I) {
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_axle_cs(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    set_wheel_axle_cs(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_axle_cs(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    wheel_friction_slip(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_friction_slip(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_friction_slip(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_friction_slip(this.__wbg_ptr, I, g);
    }
    wheel_side_friction_stiffness(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_side_friction_stiffness(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    set_wheel_side_friction_stiffness(I, g) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_wheel_side_friction_stiffness(this.__wbg_ptr, I, g);
    }
    wheel_rotation(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_rotation(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    wheel_forward_impulse(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_forward_impulse(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    wheel_side_impulse(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_side_impulse(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    wheel_suspension_force(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_suspension_force(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    wheel_contact_normal_ws(I) {
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_contact_normal_ws(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    wheel_contact_point_ws(I) {
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_contact_point_ws(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    wheel_suspension_length(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_suspension_length(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$K()[B / 4 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    wheel_hard_point_ws(I) {
        const g = $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_hard_point_ws(this.__wbg_ptr, I);
        return 0 === g ? void 0 : $204508e5b4b18960$var$DA.__wrap(g);
    }
    wheel_is_in_contact(I) {
        return 0 !== $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_is_in_contact(this.__wbg_ptr, I);
    }
    wheel_ground_object(I) {
        try {
            const B = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_wheel_ground_object(B, this.__wbg_ptr, I);
            var g = $204508e5b4b18960$var$G()[B / 4 + 0], C = $204508e5b4b18960$var$D()[B / 8 + 1];
            return 0 === g ? void 0 : C;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$b {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_raweventqueue_free(I);
    }
    constructor(I){
        const g = $204508e5b4b18960$var$A.raweventqueue_new(I);
        return this.__wbg_ptr = g >>> 0, this;
    }
    drainCollisionEvents(g) {
        try {
            $204508e5b4b18960$var$A.raweventqueue_drainCollisionEvents(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    drainContactForceEvents(g) {
        try {
            $204508e5b4b18960$var$A.raweventqueue_drainContactForceEvents(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    clear() {
        $204508e5b4b18960$var$A.raweventqueue_clear(this.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$x {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$x.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawgenericjoint_free(I);
    }
    static generic(I, g, C, B) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const Q = $204508e5b4b18960$var$A.rawgenericjoint_generic(I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B);
        return 0 === Q ? void 0 : $204508e5b4b18960$var$x.__wrap(Q);
    }
    static spring(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$DA);
        const E = $204508e5b4b18960$var$A.rawgenericjoint_spring(I, g, C, B.__wbg_ptr, Q.__wbg_ptr);
        return $204508e5b4b18960$var$x.__wrap(E);
    }
    static rope(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const B = $204508e5b4b18960$var$A.rawgenericjoint_rope(I, g.__wbg_ptr, C.__wbg_ptr);
        return $204508e5b4b18960$var$x.__wrap(B);
    }
    static spherical(I, g) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA);
        const C = $204508e5b4b18960$var$A.rawgenericjoint_spherical(I.__wbg_ptr, g.__wbg_ptr);
        return $204508e5b4b18960$var$x.__wrap(C);
    }
    static prismatic(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const i = $204508e5b4b18960$var$A.rawgenericjoint_prismatic(I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$x.__wrap(i);
    }
    static fixed(I, g, C, B) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$gA);
        const Q = $204508e5b4b18960$var$A.rawgenericjoint_fixed(I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr);
        return $204508e5b4b18960$var$x.__wrap(Q);
    }
    static revolute(I, g, C) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const B = $204508e5b4b18960$var$A.rawgenericjoint_revolute(I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr);
        return 0 === B ? void 0 : $204508e5b4b18960$var$x.__wrap(B);
    }
}
class $204508e5b4b18960$var$W {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$W.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawimpulsejointset_free(I);
    }
    jointType(I) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointType(this.__wbg_ptr, I);
    }
    jointBodyHandle1(I) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointBodyHandle1(this.__wbg_ptr, I);
    }
    jointBodyHandle2(I) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointBodyHandle2(this.__wbg_ptr, I);
    }
    jointFrameX1(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointFrameX1(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    jointFrameX2(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointFrameX2(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    jointAnchor1(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointAnchor1(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    jointAnchor2(I) {
        const g = $204508e5b4b18960$var$A.rawimpulsejointset_jointAnchor2(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    jointSetAnchor1(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawimpulsejointset_jointSetAnchor1(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    jointSetAnchor2(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawimpulsejointset_jointSetAnchor2(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    jointContactsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawimpulsejointset_jointContactsEnabled(this.__wbg_ptr, I);
    }
    jointSetContactsEnabled(I, g) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointSetContactsEnabled(this.__wbg_ptr, I, g);
    }
    jointLimitsEnabled(I, g) {
        return 0 !== $204508e5b4b18960$var$A.rawimpulsejointset_jointLimitsEnabled(this.__wbg_ptr, I, g);
    }
    jointLimitsMin(I, g) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointLimitsMin(this.__wbg_ptr, I, g);
    }
    jointLimitsMax(I, g) {
        return $204508e5b4b18960$var$A.rawimpulsejointset_jointLimitsMax(this.__wbg_ptr, I, g);
    }
    jointSetLimits(I, g, C, B) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointSetLimits(this.__wbg_ptr, I, g, C, B);
    }
    jointConfigureMotorModel(I, g, C) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotorModel(this.__wbg_ptr, I, g, C);
    }
    jointConfigureMotorVelocity(I, g, C, B) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotorVelocity(this.__wbg_ptr, I, g, C, B);
    }
    jointConfigureMotorPosition(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotorPosition(this.__wbg_ptr, I, g, C, B, Q);
    }
    jointConfigureMotor(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$A.rawimpulsejointset_jointConfigureMotor(this.__wbg_ptr, I, g, C, B, Q, E);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawimpulsejointset_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    createJoint(I, g, C, B) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$x);
        return $204508e5b4b18960$var$A.rawimpulsejointset_createJoint(this.__wbg_ptr, I.__wbg_ptr, g, C, B);
    }
    remove(I, g) {
        $204508e5b4b18960$var$A.rawimpulsejointset_remove(this.__wbg_ptr, I, g);
    }
    len() {
        return $204508e5b4b18960$var$A.rawimpulsejointset_len(this.__wbg_ptr) >>> 0;
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawimpulsejointset_contains(this.__wbg_ptr, I);
    }
    forEachJointHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawimpulsejointset_forEachJointHandle(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    forEachJointAttachedToRigidBody(g, C) {
        try {
            $204508e5b4b18960$var$A.rawimpulsejointset_forEachJointAttachedToRigidBody(this.__wbg_ptr, g, $204508e5b4b18960$var$J(C));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$j {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$j.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawintegrationparameters_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawintegrationparameters_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    get dt() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.__wbg_ptr);
    }
    get erp() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_erp(this.__wbg_ptr);
    }
    get normalizedAllowedLinearError() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_current_vehicle_speed(this.__wbg_ptr);
    }
    get normalizedPredictionDistance() {
        return $204508e5b4b18960$var$A.rawcontactforceevent_max_force_magnitude(this.__wbg_ptr);
    }
    get numSolverIterations() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_numSolverIterations(this.__wbg_ptr) >>> 0;
    }
    get numAdditionalFrictionIterations() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_index_up_axis(this.__wbg_ptr) >>> 0;
    }
    get numInternalPgsIterations() {
        return $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_index_forward_axis(this.__wbg_ptr) >>> 0;
    }
    get minIslandSize() {
        return $204508e5b4b18960$var$A.rawimpulsejointset_len(this.__wbg_ptr) >>> 0;
    }
    get maxCcdSubsteps() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_maxCcdSubsteps(this.__wbg_ptr) >>> 0;
    }
    get lengthUnit() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_lengthUnit(this.__wbg_ptr);
    }
    set dt(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_dt(this.__wbg_ptr, I);
    }
    set erp(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_erp(this.__wbg_ptr, I);
    }
    set normalizedAllowedLinearError(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_normalizedAllowedLinearError(this.__wbg_ptr, I);
    }
    set normalizedPredictionDistance(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_normalizedPredictionDistance(this.__wbg_ptr, I);
    }
    set numSolverIterations(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_numSolverIterations(this.__wbg_ptr, I);
    }
    set numAdditionalFrictionIterations(I) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_index_up_axis(this.__wbg_ptr, I);
    }
    set numInternalPgsIterations(I) {
        $204508e5b4b18960$var$A.rawdynamicraycastvehiclecontroller_set_index_forward_axis(this.__wbg_ptr, I);
    }
    set minIslandSize(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_minIslandSize(this.__wbg_ptr, I);
    }
    set maxCcdSubsteps(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_maxCcdSubsteps(this.__wbg_ptr, I);
    }
    set lengthUnit(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_lengthUnit(this.__wbg_ptr, I);
    }
    switchToStandardPgsSolver() {
        $204508e5b4b18960$var$A.rawintegrationparameters_switchToStandardPgsSolver(this.__wbg_ptr);
    }
    switchToSmallStepsPgsSolver() {
        $204508e5b4b18960$var$A.rawintegrationparameters_switchToSmallStepsPgsSolver(this.__wbg_ptr);
    }
    switchToSmallStepsPgsSolverWithoutWarmstart() {
        $204508e5b4b18960$var$A.rawintegrationparameters_switchToSmallStepsPgsSolverWithoutWarmstart(this.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$m {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$m.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawislandmanager_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawislandmanager_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    forEachActiveRigidBodyHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawislandmanager_forEachActiveRigidBodyHandle(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$f {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawkinematiccharactercontroller_free(I);
    }
    constructor(I){
        const g = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_new(I);
        return this.__wbg_ptr = g >>> 0, this;
    }
    up() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    setUp(I) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setUp(this.__wbg_ptr, I.__wbg_ptr);
    }
    normalNudgeFactor() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_normalNudgeFactor(this.__wbg_ptr);
    }
    setNormalNudgeFactor(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setNormalNudgeFactor(this.__wbg_ptr, I);
    }
    offset() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.__wbg_ptr);
    }
    setOffset(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setOffset(this.__wbg_ptr, I);
    }
    slideEnabled() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_slideEnabled(this.__wbg_ptr);
    }
    setSlideEnabled(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setSlideEnabled(this.__wbg_ptr, I);
    }
    autostepMaxHeight() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepMaxHeight(C, this.__wbg_ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$K()[C / 4 + 1];
            return 0 === I ? void 0 : g;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    autostepMinWidth() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepMinWidth(C, this.__wbg_ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$K()[C / 4 + 1];
            return 0 === I ? void 0 : g;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    autostepIncludesDynamicBodies() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepIncludesDynamicBodies(this.__wbg_ptr);
        return 16777215 === I ? void 0 : 0 !== I;
    }
    autostepEnabled() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_autostepEnabled(this.__wbg_ptr);
    }
    enableAutostep(I, g, C) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_enableAutostep(this.__wbg_ptr, I, g, C);
    }
    disableAutostep() {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_disableAutostep(this.__wbg_ptr);
    }
    maxSlopeClimbAngle() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.__wbg_ptr);
    }
    setMaxSlopeClimbAngle(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setMaxSlopeClimbAngle(this.__wbg_ptr, I);
    }
    minSlopeSlideAngle() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_minSlopeSlideAngle(this.__wbg_ptr);
    }
    setMinSlopeSlideAngle(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_setMinSlopeSlideAngle(this.__wbg_ptr, I);
    }
    snapToGroundDistance() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawkinematiccharactercontroller_snapToGroundDistance(C, this.__wbg_ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$K()[C / 4 + 1];
            return 0 === I ? void 0 : g;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
    enableSnapToGround(I) {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_enableSnapToGround(this.__wbg_ptr, I);
    }
    disableSnapToGround() {
        $204508e5b4b18960$var$A.rawkinematiccharactercontroller_disableSnapToGround(this.__wbg_ptr);
    }
    snapToGroundEnabled() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_snapToGroundEnabled(this.__wbg_ptr);
    }
    computeColliderMovement(g, C, B, Q, i, D, o, G, w, S, k) {
        try {
            $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$v), $204508e5b4b18960$var$U(D, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computeColliderMovement(this.__wbg_ptr, g, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i, D.__wbg_ptr, o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, w, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, $204508e5b4b18960$var$J(k));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    computedMovement() {
        const I = $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedMovement(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    computedGrounded() {
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedGrounded(this.__wbg_ptr);
    }
    numComputedCollisions() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_numComputedCollisions(this.__wbg_ptr) >>> 0;
    }
    computedCollision(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$t);
        return 0 !== $204508e5b4b18960$var$A.rawkinematiccharactercontroller_computedCollision(this.__wbg_ptr, I, g.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$V {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$V.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawmultibodyjointset_free(I);
    }
    jointType(I) {
        return $204508e5b4b18960$var$A.rawmultibodyjointset_jointType(this.__wbg_ptr, I);
    }
    jointFrameX1(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointFrameX1(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    jointFrameX2(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointFrameX2(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    jointAnchor1(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointAnchor1(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    jointAnchor2(I) {
        const g = $204508e5b4b18960$var$A.rawmultibodyjointset_jointAnchor2(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    jointContactsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawmultibodyjointset_jointContactsEnabled(this.__wbg_ptr, I);
    }
    jointSetContactsEnabled(I, g) {
        $204508e5b4b18960$var$A.rawmultibodyjointset_jointSetContactsEnabled(this.__wbg_ptr, I, g);
    }
    jointLimitsEnabled(I, g) {
        return 0 !== $204508e5b4b18960$var$A.rawmultibodyjointset_jointLimitsEnabled(this.__wbg_ptr, I, g);
    }
    jointLimitsMin(I, g) {
        return $204508e5b4b18960$var$A.rawmultibodyjointset_jointLimitsMin(this.__wbg_ptr, I, g);
    }
    jointLimitsMax(I, g) {
        return $204508e5b4b18960$var$A.rawmultibodyjointset_jointLimitsMax(this.__wbg_ptr, I, g);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawmultibodyjointset_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    createJoint(I, g, C, B) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$x);
        return $204508e5b4b18960$var$A.rawmultibodyjointset_createJoint(this.__wbg_ptr, I.__wbg_ptr, g, C, B);
    }
    remove(I, g) {
        $204508e5b4b18960$var$A.rawmultibodyjointset_remove(this.__wbg_ptr, I, g);
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawmultibodyjointset_contains(this.__wbg_ptr, I);
    }
    forEachJointHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawmultibodyjointset_forEachJointHandle(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    forEachJointAttachedToRigidBody(g, C) {
        try {
            $204508e5b4b18960$var$A.rawmultibodyjointset_forEachJointAttachedToRigidBody(this.__wbg_ptr, g, $204508e5b4b18960$var$J(C));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$X {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$X.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawnarrowphase_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawnarrowphase_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    contact_pairs_with(I, g) {
        $204508e5b4b18960$var$A.rawnarrowphase_contact_pairs_with(this.__wbg_ptr, I, $204508e5b4b18960$var$C(g));
    }
    contact_pair(I, g) {
        const C = $204508e5b4b18960$var$A.rawnarrowphase_contact_pair(this.__wbg_ptr, I, g);
        return 0 === C ? void 0 : $204508e5b4b18960$var$T.__wrap(C);
    }
    intersection_pairs_with(I, g) {
        $204508e5b4b18960$var$A.rawnarrowphase_intersection_pairs_with(this.__wbg_ptr, I, $204508e5b4b18960$var$C(g));
    }
    intersection_pair(I, g) {
        return 0 !== $204508e5b4b18960$var$A.rawnarrowphase_intersection_pair(this.__wbg_ptr, I, g);
    }
}
class $204508e5b4b18960$var$P {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawphysicspipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawphysicspipeline_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    step(I, g, C, B, Q, E, i, D, o, G) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$j), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$m), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$H), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$X), $204508e5b4b18960$var$U(E, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(D, $204508e5b4b18960$var$W), $204508e5b4b18960$var$U(o, $204508e5b4b18960$var$V), $204508e5b4b18960$var$U(G, $204508e5b4b18960$var$L), $204508e5b4b18960$var$A.rawphysicspipeline_step(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, E.__wbg_ptr, i.__wbg_ptr, D.__wbg_ptr, o.__wbg_ptr, G.__wbg_ptr);
    }
    stepWithEvents(I, g, B, Q, E, i, D, o, G, w, S, k, a, K) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$j), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$m), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$H), $204508e5b4b18960$var$U(E, $204508e5b4b18960$var$X), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(D, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(o, $204508e5b4b18960$var$W), $204508e5b4b18960$var$U(G, $204508e5b4b18960$var$V), $204508e5b4b18960$var$U(w, $204508e5b4b18960$var$L), $204508e5b4b18960$var$U(S, $204508e5b4b18960$var$b), $204508e5b4b18960$var$A.rawphysicspipeline_stepWithEvents(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, E.__wbg_ptr, i.__wbg_ptr, D.__wbg_ptr, o.__wbg_ptr, G.__wbg_ptr, w.__wbg_ptr, S.__wbg_ptr, $204508e5b4b18960$var$C(k), $204508e5b4b18960$var$C(a), $204508e5b4b18960$var$C(K));
    }
}
class $204508e5b4b18960$var$u {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$u.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawpointcolliderprojection_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_colliderHandle(this.__wbg_ptr);
    }
    point() {
        const I = $204508e5b4b18960$var$A.rawpointcolliderprojection_point(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    isInside() {
        return 0 !== $204508e5b4b18960$var$A.rawpointcolliderprojection_isInside(this.__wbg_ptr);
    }
    featureType() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_featureType(this.__wbg_ptr);
    }
    featureId() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawpointcolliderprojection_featureId(C, this.__wbg_ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return 0 === I ? void 0 : g >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$z {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$z.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawpointprojection_free(I);
    }
    point() {
        const I = $204508e5b4b18960$var$A.rawpointprojection_point(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    isInside() {
        return 0 !== $204508e5b4b18960$var$A.rawpointprojection_isInside(this.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$v {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawquerypipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawquerypipeline_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    update(I, g) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$p), $204508e5b4b18960$var$A.rawquerypipeline_update(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr);
    }
    castRay(g, C, B, Q, i, D, o, G, w, S, k) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$DA);
            const a = $204508e5b4b18960$var$A.rawquerypipeline_castRay(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i, D, o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, $204508e5b4b18960$var$J(k));
            return 0 === a ? void 0 : $204508e5b4b18960$var$_.__wrap(a);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    castRayAndGetNormal(g, C, B, Q, i, D, o, G, w, S, k) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$DA);
            const a = $204508e5b4b18960$var$A.rawquerypipeline_castRayAndGetNormal(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i, D, o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, $204508e5b4b18960$var$J(k));
            return 0 === a ? void 0 : $204508e5b4b18960$var$$.__wrap(a);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    intersectionsWithRay(g, C, B, Q, i, D, o, G, w, S, k, a) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionsWithRay(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i, D, $204508e5b4b18960$var$J(o), G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, $204508e5b4b18960$var$J(a));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0, $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    intersectionWithShape(g, C, B, Q, i, o, w, S, k, a) {
        try {
            const M = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionWithShape(M, this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i.__wbg_ptr, o, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, $204508e5b4b18960$var$J(a));
            var K = $204508e5b4b18960$var$G()[M / 4 + 0], y = $204508e5b4b18960$var$D()[M / 8 + 1];
            return 0 === K ? void 0 : y;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16), $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    projectPoint(g, C, B, Q, i, D, o, G, w) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
            const S = $204508e5b4b18960$var$A.rawquerypipeline_projectPoint(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q, i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, !$204508e5b4b18960$var$E(o), $204508e5b4b18960$var$E(o) ? 0 : o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, $204508e5b4b18960$var$J(w));
            return 0 === S ? void 0 : $204508e5b4b18960$var$u.__wrap(S);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    projectPointAndGetFeature(g, C, B, Q, i, D, o, G) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
            const w = $204508e5b4b18960$var$A.rawquerypipeline_projectPointAndGetFeature(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q, !$204508e5b4b18960$var$E(i), $204508e5b4b18960$var$E(i) ? 0 : i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, !$204508e5b4b18960$var$E(o), $204508e5b4b18960$var$E(o) ? 0 : o, $204508e5b4b18960$var$J(G));
            return 0 === w ? void 0 : $204508e5b4b18960$var$u.__wrap(w);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    intersectionsWithPoint(g, C, B, Q, i, D, o, G, w) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionsWithPoint(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, $204508e5b4b18960$var$J(Q), i, !$204508e5b4b18960$var$E(D), $204508e5b4b18960$var$E(D) ? 0 : D, !$204508e5b4b18960$var$E(o), $204508e5b4b18960$var$E(o) ? 0 : o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, $204508e5b4b18960$var$J(w));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0, $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    castShape(g, C, B, Q, i, D, o, G, w, S, k, a, K, y) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(D, $204508e5b4b18960$var$QA);
            const M = $204508e5b4b18960$var$A.rawquerypipeline_castShape(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i.__wbg_ptr, D.__wbg_ptr, o, G, w, S, !$204508e5b4b18960$var$E(k), $204508e5b4b18960$var$E(k) ? 0 : k, !$204508e5b4b18960$var$E(a), $204508e5b4b18960$var$E(a) ? 0 : a, !$204508e5b4b18960$var$E(K), $204508e5b4b18960$var$E(K) ? 0 : K, $204508e5b4b18960$var$J(y));
            return 0 === M ? void 0 : $204508e5b4b18960$var$e.__wrap(M);
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    intersectionsWithShape(g, C, B, Q, i, D, o, G, w, S, k) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$A.rawquerypipeline_intersectionsWithShape(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, i.__wbg_ptr, $204508e5b4b18960$var$J(D), o, !$204508e5b4b18960$var$E(G), $204508e5b4b18960$var$E(G) ? 0 : G, !$204508e5b4b18960$var$E(w), $204508e5b4b18960$var$E(w) ? 0 : w, !$204508e5b4b18960$var$E(S), $204508e5b4b18960$var$E(S) ? 0 : S, $204508e5b4b18960$var$J(k));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0, $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    collidersWithAabbIntersectingAabb(g, C, B) {
        try {
            $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawquerypipeline_collidersWithAabbIntersectingAabb(this.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, $204508e5b4b18960$var$J(B));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
}
class $204508e5b4b18960$var$_ {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$_.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawraycolliderhit_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawcharactercollision_handle(this.__wbg_ptr);
    }
    timeOfImpact() {
        return $204508e5b4b18960$var$A.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$$ {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$$.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawraycolliderintersection_free(I);
    }
    colliderHandle() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_colliderHandle(this.__wbg_ptr);
    }
    normal() {
        const I = $204508e5b4b18960$var$A.rawcollidershapecasthit_witness1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    time_of_impact() {
        return $204508e5b4b18960$var$A.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
    }
    featureType() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_featureType(this.__wbg_ptr);
    }
    featureId() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawpointcolliderprojection_featureId(C, this.__wbg_ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return 0 === I ? void 0 : g >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$AA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$AA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawrayintersection_free(I);
    }
    normal() {
        const I = $204508e5b4b18960$var$A.rawcollidershapecasthit_witness1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    time_of_impact() {
        return $204508e5b4b18960$var$A.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
    }
    featureType() {
        return $204508e5b4b18960$var$A.rawpointcolliderprojection_featureType(this.__wbg_ptr);
    }
    featureId() {
        try {
            const C = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.rawpointcolliderprojection_featureId(C, this.__wbg_ptr);
            var I = $204508e5b4b18960$var$G()[C / 4 + 0], g = $204508e5b4b18960$var$G()[C / 4 + 1];
            return 0 === I ? void 0 : g >>> 0;
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
class $204508e5b4b18960$var$IA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$IA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawrigidbodyset_free(I);
    }
    rbTranslation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbTranslation(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbRotation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbRotation(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    rbSleep(I) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSleep(this.__wbg_ptr, I);
    }
    rbIsSleeping(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsSleeping(this.__wbg_ptr, I);
    }
    rbIsMoving(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsMoving(this.__wbg_ptr, I);
    }
    rbNextTranslation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbNextTranslation(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbNextRotation(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbNextRotation(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    rbSetTranslation(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetTranslation(this.__wbg_ptr, I, g, C, B, Q);
    }
    rbSetRotation(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetRotation(this.__wbg_ptr, I, g, C, B, Q, E);
    }
    rbSetLinvel(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbSetLinvel(this.__wbg_ptr, I, g.__wbg_ptr, C);
    }
    rbSetAngvel(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAngvel(this.__wbg_ptr, I, g.__wbg_ptr, C);
    }
    rbSetNextKinematicTranslation(I, g, C, B) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetNextKinematicTranslation(this.__wbg_ptr, I, g, C, B);
    }
    rbSetNextKinematicRotation(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetNextKinematicRotation(this.__wbg_ptr, I, g, C, B, Q);
    }
    rbRecomputeMassPropertiesFromColliders(I, g) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$p), $204508e5b4b18960$var$A.rawrigidbodyset_rbRecomputeMassPropertiesFromColliders(this.__wbg_ptr, I, g.__wbg_ptr);
    }
    rbSetAdditionalMass(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAdditionalMass(this.__wbg_ptr, I, g, C);
    }
    rbSetAdditionalMassProperties(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAdditionalMassProperties(this.__wbg_ptr, I, g, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, E);
    }
    rbLinvel(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbLinvel(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbAngvel(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbAngvel(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbLockTranslations(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbLockTranslations(this.__wbg_ptr, I, g, C);
    }
    rbSetEnabledTranslations(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetEnabledTranslations(this.__wbg_ptr, I, g, C, B, Q);
    }
    rbLockRotations(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbLockRotations(this.__wbg_ptr, I, g, C);
    }
    rbSetEnabledRotations(I, g, C, B, Q) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetEnabledRotations(this.__wbg_ptr, I, g, C, B, Q);
    }
    rbDominanceGroup(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbDominanceGroup(this.__wbg_ptr, I);
    }
    rbSetDominanceGroup(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetDominanceGroup(this.__wbg_ptr, I, g);
    }
    rbEnableCcd(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbEnableCcd(this.__wbg_ptr, I, g);
    }
    rbSetSoftCcdPrediction(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetSoftCcdPrediction(this.__wbg_ptr, I, g);
    }
    rbMass(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbMass(this.__wbg_ptr, I);
    }
    rbInvMass(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbInvMass(this.__wbg_ptr, I);
    }
    rbEffectiveInvMass(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbEffectiveInvMass(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbLocalCom(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbLocalCom(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbWorldCom(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbWorldCom(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbInvPrincipalInertiaSqrt(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbInvPrincipalInertiaSqrt(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbPrincipalInertiaLocalFrame(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbPrincipalInertiaLocalFrame(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$gA.__wrap(g);
    }
    rbPrincipalInertia(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbPrincipalInertia(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$DA.__wrap(g);
    }
    rbEffectiveWorldInvInertiaSqrt(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbEffectiveWorldInvInertiaSqrt(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$CA.__wrap(g);
    }
    rbEffectiveAngularInertia(I) {
        const g = $204508e5b4b18960$var$A.rawrigidbodyset_rbEffectiveAngularInertia(this.__wbg_ptr, I);
        return $204508e5b4b18960$var$CA.__wrap(g);
    }
    rbWakeUp(I) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbWakeUp(this.__wbg_ptr, I);
    }
    rbIsCcdEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsCcdEnabled(this.__wbg_ptr, I);
    }
    rbSoftCcdPrediction(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbSoftCcdPrediction(this.__wbg_ptr, I);
    }
    rbNumColliders(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbNumColliders(this.__wbg_ptr, I) >>> 0;
    }
    rbCollider(I, g) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbCollider(this.__wbg_ptr, I, g);
    }
    rbBodyType(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbBodyType(this.__wbg_ptr, I);
    }
    rbSetBodyType(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetBodyType(this.__wbg_ptr, I, g, C);
    }
    rbIsFixed(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsFixed(this.__wbg_ptr, I);
    }
    rbIsKinematic(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsKinematic(this.__wbg_ptr, I);
    }
    rbIsDynamic(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsDynamic(this.__wbg_ptr, I);
    }
    rbLinearDamping(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbLinearDamping(this.__wbg_ptr, I);
    }
    rbAngularDamping(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbAngularDamping(this.__wbg_ptr, I);
    }
    rbSetLinearDamping(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetLinearDamping(this.__wbg_ptr, I, g);
    }
    rbSetAngularDamping(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAngularDamping(this.__wbg_ptr, I, g);
    }
    rbSetEnabled(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetEnabled(this.__wbg_ptr, I, g);
    }
    rbIsEnabled(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_rbIsEnabled(this.__wbg_ptr, I);
    }
    rbGravityScale(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbGravityScale(this.__wbg_ptr, I);
    }
    rbSetGravityScale(I, g, C) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetGravityScale(this.__wbg_ptr, I, g, C);
    }
    rbResetForces(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbResetForces(this.__wbg_ptr, I, g);
    }
    rbResetTorques(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbResetTorques(this.__wbg_ptr, I, g);
    }
    rbAddForce(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbAddForce(this.__wbg_ptr, I, g.__wbg_ptr, C);
    }
    rbApplyImpulse(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbApplyImpulse(this.__wbg_ptr, I, g.__wbg_ptr, C);
    }
    rbAddTorque(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbAddTorque(this.__wbg_ptr, I, g.__wbg_ptr, C);
    }
    rbApplyTorqueImpulse(I, g, C) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbApplyTorqueImpulse(this.__wbg_ptr, I, g.__wbg_ptr, C);
    }
    rbAddForceAtPoint(I, g, C, B) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbAddForceAtPoint(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B);
    }
    rbApplyImpulseAtPoint(I, g, C, B) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$A.rawrigidbodyset_rbApplyImpulseAtPoint(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B);
    }
    rbAdditionalSolverIterations(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbAdditionalSolverIterations(this.__wbg_ptr, I) >>> 0;
    }
    rbSetAdditionalSolverIterations(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetAdditionalSolverIterations(this.__wbg_ptr, I, g);
    }
    rbUserData(I) {
        return $204508e5b4b18960$var$A.rawrigidbodyset_rbUserData(this.__wbg_ptr, I) >>> 0;
    }
    rbSetUserData(I, g) {
        $204508e5b4b18960$var$A.rawrigidbodyset_rbSetUserData(this.__wbg_ptr, I, g);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawrigidbodyset_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    createRigidBody(I, g, C, B, Q, E, i, D, o, G, w, S, k, a, K, h, J, y, M, N, F, R, q, s, c, Y) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(D, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(o, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(G, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(w, $204508e5b4b18960$var$gA);
        return $204508e5b4b18960$var$A.rawrigidbodyset_createRigidBody(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B, Q, E, i.__wbg_ptr, D.__wbg_ptr, o.__wbg_ptr, G.__wbg_ptr, w.__wbg_ptr, S, k, a, K, h, J, y, M, N, F, R, q, s, c, Y);
    }
    remove(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$m), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$W), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$V), $204508e5b4b18960$var$A.rawrigidbodyset_remove(this.__wbg_ptr, I, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr);
    }
    len() {
        return $204508e5b4b18960$var$A.rawcolliderset_len(this.__wbg_ptr) >>> 0;
    }
    contains(I) {
        return 0 !== $204508e5b4b18960$var$A.rawrigidbodyset_contains(this.__wbg_ptr, I);
    }
    forEachRigidBodyHandle(g) {
        try {
            $204508e5b4b18960$var$A.rawrigidbodyset_forEachRigidBodyHandle(this.__wbg_ptr, $204508e5b4b18960$var$J(g));
        } finally{
            $204508e5b4b18960$var$I[$204508e5b4b18960$var$h++] = void 0;
        }
    }
    propagateModifiedBodyPositionsToColliders(I) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$p), $204508e5b4b18960$var$A.rawrigidbodyset_propagateModifiedBodyPositionsToColliders(this.__wbg_ptr, I.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$gA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$gA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawrotation_free(I);
    }
    constructor(I, g, C, B){
        const Q = $204508e5b4b18960$var$A.rawrotation_new(I, g, C, B);
        return this.__wbg_ptr = Q >>> 0, this;
    }
    static identity() {
        const I = $204508e5b4b18960$var$A.rawrotation_identity();
        return $204508e5b4b18960$var$gA.__wrap(I);
    }
    get x() {
        return $204508e5b4b18960$var$A.rawrotation_x(this.__wbg_ptr);
    }
    get y() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.__wbg_ptr);
    }
    get z() {
        return $204508e5b4b18960$var$A.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
    }
    get w() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_erp(this.__wbg_ptr);
    }
}
class $204508e5b4b18960$var$CA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$CA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawsdpmatrix3_free(I);
    }
    elements() {
        return $204508e5b4b18960$var$Q($204508e5b4b18960$var$A.rawsdpmatrix3_elements(this.__wbg_ptr));
    }
}
class $204508e5b4b18960$var$BA {
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawserializationpipeline_free(I);
    }
    constructor(){
        const I = $204508e5b4b18960$var$A.rawserializationpipeline_new();
        return this.__wbg_ptr = I >>> 0, this;
    }
    serializeAll(I, g, C, B, E, i, D, o, G) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$j), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$m), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$H), $204508e5b4b18960$var$U(E, $204508e5b4b18960$var$X), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$IA), $204508e5b4b18960$var$U(D, $204508e5b4b18960$var$p), $204508e5b4b18960$var$U(o, $204508e5b4b18960$var$W), $204508e5b4b18960$var$U(G, $204508e5b4b18960$var$V);
        return $204508e5b4b18960$var$Q($204508e5b4b18960$var$A.rawserializationpipeline_serializeAll(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, E.__wbg_ptr, i.__wbg_ptr, D.__wbg_ptr, o.__wbg_ptr, G.__wbg_ptr));
    }
    deserializeAll(I) {
        const g = $204508e5b4b18960$var$A.rawserializationpipeline_deserializeAll(this.__wbg_ptr, $204508e5b4b18960$var$C(I));
        return 0 === g ? void 0 : $204508e5b4b18960$var$n.__wrap(g);
    }
}
class $204508e5b4b18960$var$QA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$QA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshape_free(I);
    }
    static cuboid(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawshape_cuboid(I, g, C);
        return $204508e5b4b18960$var$QA.__wrap(B);
    }
    static roundCuboid(I, g, C, B) {
        const Q = $204508e5b4b18960$var$A.rawshape_roundCuboid(I, g, C, B);
        return $204508e5b4b18960$var$QA.__wrap(Q);
    }
    static ball(I) {
        const g = $204508e5b4b18960$var$A.rawshape_ball(I);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    static halfspace(I) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA);
        const g = $204508e5b4b18960$var$A.rawshape_halfspace(I.__wbg_ptr);
        return $204508e5b4b18960$var$QA.__wrap(g);
    }
    static capsule(I, g) {
        const C = $204508e5b4b18960$var$A.rawshape_capsule(I, g);
        return $204508e5b4b18960$var$QA.__wrap(C);
    }
    static cylinder(I, g) {
        const C = $204508e5b4b18960$var$A.rawshape_cylinder(I, g);
        return $204508e5b4b18960$var$QA.__wrap(C);
    }
    static roundCylinder(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawshape_roundCylinder(I, g, C);
        return $204508e5b4b18960$var$QA.__wrap(B);
    }
    static cone(I, g) {
        const C = $204508e5b4b18960$var$A.rawshape_cone(I, g);
        return $204508e5b4b18960$var$QA.__wrap(C);
    }
    static roundCone(I, g, C) {
        const B = $204508e5b4b18960$var$A.rawshape_roundCone(I, g, C);
        return $204508e5b4b18960$var$QA.__wrap(B);
    }
    static polyline(I, g) {
        const C = $204508e5b4b18960$var$R(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$q(g, $204508e5b4b18960$var$A.__wbindgen_malloc), E = $204508e5b4b18960$var$F, i = $204508e5b4b18960$var$A.rawshape_polyline(C, B, Q, E);
        return $204508e5b4b18960$var$QA.__wrap(i);
    }
    static trimesh(I, g, C) {
        const B = $204508e5b4b18960$var$R(I, $204508e5b4b18960$var$A.__wbindgen_malloc), Q = $204508e5b4b18960$var$F, E = $204508e5b4b18960$var$q(g, $204508e5b4b18960$var$A.__wbindgen_malloc), i = $204508e5b4b18960$var$F, D = $204508e5b4b18960$var$A.rawshape_trimesh(B, Q, E, i, C);
        return $204508e5b4b18960$var$QA.__wrap(D);
    }
    static heightfield(I, g, C, B, Q) {
        const E = $204508e5b4b18960$var$R(C, $204508e5b4b18960$var$A.__wbindgen_malloc), i = $204508e5b4b18960$var$F;
        $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
        const D = $204508e5b4b18960$var$A.rawshape_heightfield(I, g, E, i, B.__wbg_ptr, Q);
        return $204508e5b4b18960$var$QA.__wrap(D);
    }
    static segment(I, g) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA);
        const C = $204508e5b4b18960$var$A.rawshape_segment(I.__wbg_ptr, g.__wbg_ptr);
        return $204508e5b4b18960$var$QA.__wrap(C);
    }
    static triangle(I, g, C) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const B = $204508e5b4b18960$var$A.rawshape_triangle(I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr);
        return $204508e5b4b18960$var$QA.__wrap(B);
    }
    static roundTriangle(I, g, C, B) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const Q = $204508e5b4b18960$var$A.rawshape_roundTriangle(I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B);
        return $204508e5b4b18960$var$QA.__wrap(Q);
    }
    static convexHull(I) {
        const g = $204508e5b4b18960$var$R(I, $204508e5b4b18960$var$A.__wbindgen_malloc), C = $204508e5b4b18960$var$F, B = $204508e5b4b18960$var$A.rawshape_convexHull(g, C);
        return 0 === B ? void 0 : $204508e5b4b18960$var$QA.__wrap(B);
    }
    static roundConvexHull(I, g) {
        const C = $204508e5b4b18960$var$R(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$A.rawshape_roundConvexHull(C, B, g);
        return 0 === Q ? void 0 : $204508e5b4b18960$var$QA.__wrap(Q);
    }
    static convexMesh(I, g) {
        const C = $204508e5b4b18960$var$R(I, $204508e5b4b18960$var$A.__wbindgen_malloc), B = $204508e5b4b18960$var$F, Q = $204508e5b4b18960$var$q(g, $204508e5b4b18960$var$A.__wbindgen_malloc), E = $204508e5b4b18960$var$F, i = $204508e5b4b18960$var$A.rawshape_convexMesh(C, B, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$QA.__wrap(i);
    }
    static roundConvexMesh(I, g, C) {
        const B = $204508e5b4b18960$var$R(I, $204508e5b4b18960$var$A.__wbindgen_malloc), Q = $204508e5b4b18960$var$F, E = $204508e5b4b18960$var$q(g, $204508e5b4b18960$var$A.__wbindgen_malloc), i = $204508e5b4b18960$var$F, D = $204508e5b4b18960$var$A.rawshape_roundConvexMesh(B, Q, E, i, C);
        return 0 === D ? void 0 : $204508e5b4b18960$var$QA.__wrap(D);
    }
    castShape(I, g, C, B, Q, E, i, D, o, G) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(E, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(i, $204508e5b4b18960$var$DA);
        const w = $204508e5b4b18960$var$A.rawshape_castShape(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, E.__wbg_ptr, i.__wbg_ptr, D, o, G);
        return 0 === w ? void 0 : $204508e5b4b18960$var$EA.__wrap(w);
    }
    intersectsShape(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA);
        return 0 !== $204508e5b4b18960$var$A.rawshape_intersectsShape(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr);
    }
    contactShape(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$QA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(Q, $204508e5b4b18960$var$gA);
        const i = $204508e5b4b18960$var$A.rawshape_contactShape(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q.__wbg_ptr, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$iA.__wrap(i);
    }
    containsPoint(I, g, C) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        return 0 !== $204508e5b4b18960$var$A.rawshape_containsPoint(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr);
    }
    projectPoint(I, g, C, B) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA);
        const Q = $204508e5b4b18960$var$A.rawshape_projectPoint(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B);
        return $204508e5b4b18960$var$z.__wrap(Q);
    }
    intersectsRay(I, g, C, B, Q) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
        return 0 !== $204508e5b4b18960$var$A.rawshape_intersectsRay(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q);
    }
    castRay(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
        return $204508e5b4b18960$var$A.rawshape_castRay(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q, E);
    }
    castRayAndGetNormal(I, g, C, B, Q, E) {
        $204508e5b4b18960$var$U(I, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(g, $204508e5b4b18960$var$gA), $204508e5b4b18960$var$U(C, $204508e5b4b18960$var$DA), $204508e5b4b18960$var$U(B, $204508e5b4b18960$var$DA);
        const i = $204508e5b4b18960$var$A.rawshape_castRayAndGetNormal(this.__wbg_ptr, I.__wbg_ptr, g.__wbg_ptr, C.__wbg_ptr, B.__wbg_ptr, Q, E);
        return 0 === i ? void 0 : $204508e5b4b18960$var$AA.__wrap(i);
    }
}
class $204508e5b4b18960$var$EA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$EA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshapecasthit_free(I);
    }
    time_of_impact() {
        return $204508e5b4b18960$var$A.rawrotation_x(this.__wbg_ptr);
    }
    witness1() {
        const I = $204508e5b4b18960$var$A.rawshapecasthit_witness1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    witness2() {
        const I = $204508e5b4b18960$var$A.rawcontactforceevent_total_force(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    normal1() {
        const I = $204508e5b4b18960$var$A.rawshapecasthit_normal1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    normal2() {
        const I = $204508e5b4b18960$var$A.rawshapecasthit_normal2(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
}
class $204508e5b4b18960$var$iA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$iA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawshapecontact_free(I);
    }
    distance() {
        return $204508e5b4b18960$var$A.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.__wbg_ptr);
    }
    point1() {
        const I = $204508e5b4b18960$var$A.rawpointprojection_point(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    point2() {
        const I = $204508e5b4b18960$var$A.rawcollidershapecasthit_witness1(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    normal1() {
        const I = $204508e5b4b18960$var$A.rawcollidershapecasthit_witness2(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    normal2() {
        const I = $204508e5b4b18960$var$A.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
}
class $204508e5b4b18960$var$DA {
    static __wrap(A) {
        A >>>= 0;
        const I = Object.create($204508e5b4b18960$var$DA.prototype);
        return I.__wbg_ptr = A, I;
    }
    __destroy_into_raw() {
        const A = this.__wbg_ptr;
        return this.__wbg_ptr = 0, A;
    }
    free() {
        const I = this.__destroy_into_raw();
        $204508e5b4b18960$var$A.__wbg_rawvector_free(I);
    }
    static zero() {
        const I = $204508e5b4b18960$var$A.rawvector_zero();
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    constructor(I, g, C){
        const B = $204508e5b4b18960$var$A.rawvector_new(I, g, C);
        return this.__wbg_ptr = B >>> 0, this;
    }
    get x() {
        return $204508e5b4b18960$var$A.rawrotation_x(this.__wbg_ptr);
    }
    set x(I) {
        $204508e5b4b18960$var$A.rawvector_set_x(this.__wbg_ptr, I);
    }
    get y() {
        return $204508e5b4b18960$var$A.rawintegrationparameters_dt(this.__wbg_ptr);
    }
    set y(I) {
        $204508e5b4b18960$var$A.rawintegrationparameters_set_dt(this.__wbg_ptr, I);
    }
    get z() {
        return $204508e5b4b18960$var$A.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
    }
    set z(I) {
        $204508e5b4b18960$var$A.rawvector_set_z(this.__wbg_ptr, I);
    }
    xyz() {
        const I = $204508e5b4b18960$var$A.rawvector_xyz(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    yxz() {
        const I = $204508e5b4b18960$var$A.rawvector_yxz(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    zxy() {
        const I = $204508e5b4b18960$var$A.rawvector_zxy(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    xzy() {
        const I = $204508e5b4b18960$var$A.rawvector_xzy(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    yzx() {
        const I = $204508e5b4b18960$var$A.rawvector_yzx(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
    zyx() {
        const I = $204508e5b4b18960$var$A.rawvector_zyx(this.__wbg_ptr);
        return $204508e5b4b18960$var$DA.__wrap(I);
    }
}
async function $204508e5b4b18960$var$oA(I) {
    if (void 0 !== $204508e5b4b18960$var$A) return $204508e5b4b18960$var$A;
    void 0 === I && (I = new URL("rapier_wasm3d_bg.wasm", "<deleted>"));
    const g = function() {
        const I = {
            wbg: {}
        };
        return I.wbg.__wbindgen_number_new = function(A) {
            return $204508e5b4b18960$var$C(A);
        }, I.wbg.__wbindgen_boolean_get = function(A) {
            const I = $204508e5b4b18960$var$B(A);
            return "boolean" == typeof I ? I ? 1 : 0 : 2;
        }, I.wbg.__wbindgen_object_drop_ref = function(A) {
            $204508e5b4b18960$var$Q(A);
        }, I.wbg.__wbindgen_number_get = function(A, I) {
            const g = $204508e5b4b18960$var$B(I), C = "number" == typeof g ? g : void 0;
            $204508e5b4b18960$var$D()[A / 8 + 1] = $204508e5b4b18960$var$E(C) ? 0 : C, $204508e5b4b18960$var$G()[A / 4 + 0] = !$204508e5b4b18960$var$E(C);
        }, I.wbg.__wbindgen_is_function = function(A) {
            return "function" == typeof $204508e5b4b18960$var$B(A);
        }, I.wbg.__wbg_rawraycolliderintersection_new = function(A) {
            return $204508e5b4b18960$var$C($204508e5b4b18960$var$$.__wrap(A));
        }, I.wbg.__wbg_rawcontactforceevent_new = function(A) {
            return $204508e5b4b18960$var$C($204508e5b4b18960$var$r.__wrap(A));
        }, I.wbg.__wbg_call_01734de55d61e11d = function() {
            return $204508e5b4b18960$var$s(function(A, I, g) {
                return $204508e5b4b18960$var$C($204508e5b4b18960$var$B(A).call($204508e5b4b18960$var$B(I), $204508e5b4b18960$var$B(g)));
            }, arguments);
        }, I.wbg.__wbg_call_4c92f6aec1e1d6e6 = function() {
            return $204508e5b4b18960$var$s(function(A, I, g, Q) {
                return $204508e5b4b18960$var$C($204508e5b4b18960$var$B(A).call($204508e5b4b18960$var$B(I), $204508e5b4b18960$var$B(g), $204508e5b4b18960$var$B(Q)));
            }, arguments);
        }, I.wbg.__wbg_call_776890ca77946e2f = function() {
            return $204508e5b4b18960$var$s(function(A, I, g, Q, E) {
                return $204508e5b4b18960$var$C($204508e5b4b18960$var$B(A).call($204508e5b4b18960$var$B(I), $204508e5b4b18960$var$B(g), $204508e5b4b18960$var$B(Q), $204508e5b4b18960$var$B(E)));
            }, arguments);
        }, I.wbg.__wbg_bind_60a9a80cada2f33c = function(A, I, g, Q) {
            return $204508e5b4b18960$var$C($204508e5b4b18960$var$B(A).bind($204508e5b4b18960$var$B(I), $204508e5b4b18960$var$B(g), $204508e5b4b18960$var$B(Q)));
        }, I.wbg.__wbg_buffer_085ec1f694018c4f = function(A) {
            return $204508e5b4b18960$var$C($204508e5b4b18960$var$B(A).buffer);
        }, I.wbg.__wbg_newwithbyteoffsetandlength_6da8e527659b86aa = function(A, I, g) {
            return $204508e5b4b18960$var$C(new Uint8Array($204508e5b4b18960$var$B(A), I >>> 0, g >>> 0));
        }, I.wbg.__wbg_new_8125e318e6245eed = function(A) {
            return $204508e5b4b18960$var$C(new Uint8Array($204508e5b4b18960$var$B(A)));
        }, I.wbg.__wbg_set_5cf90238115182c3 = function(A, I, g) {
            $204508e5b4b18960$var$B(A).set($204508e5b4b18960$var$B(I), g >>> 0);
        }, I.wbg.__wbg_length_72e2208bbc0efc61 = function(A) {
            return $204508e5b4b18960$var$B(A).length;
        }, I.wbg.__wbg_newwithbyteoffsetandlength_69193e31c844b792 = function(A, I, g) {
            return $204508e5b4b18960$var$C(new Float32Array($204508e5b4b18960$var$B(A), I >>> 0, g >>> 0));
        }, I.wbg.__wbg_set_6146c51d49a2c0df = function(A, I, g) {
            $204508e5b4b18960$var$B(A).set($204508e5b4b18960$var$B(I), g >>> 0);
        }, I.wbg.__wbg_length_d7327c75a759af37 = function(A) {
            return $204508e5b4b18960$var$B(A).length;
        }, I.wbg.__wbg_newwithlength_68d29ab115d0099c = function(A) {
            return $204508e5b4b18960$var$C(new Float32Array(A >>> 0));
        }, I.wbg.__wbindgen_throw = function(A, I) {
            throw new Error($204508e5b4b18960$var$k(A, I));
        }, I.wbg.__wbindgen_memory = function() {
            return $204508e5b4b18960$var$C($204508e5b4b18960$var$A.memory);
        }, I;
    }();
    ("string" == typeof I || "function" == typeof Request && I instanceof Request || "function" == typeof URL && I instanceof URL) && (I = fetch(I));
    const { instance: w, module: U } = await async function(A, I) {
        if ("function" == typeof Response && A instanceof Response) {
            if ("function" == typeof WebAssembly.instantiateStreaming) try {
                return await WebAssembly.instantiateStreaming(A, I);
            } catch (I) {
                if ("application/wasm" == A.headers.get("Content-Type")) throw I;
                console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", I);
            }
            const g = await A.arrayBuffer();
            return await WebAssembly.instantiate(g, I);
        }
        {
            const g = await WebAssembly.instantiate(A, I);
            return g instanceof WebAssembly.Instance ? {
                instance: g,
                module: A
            } : g;
        }
    }(await I, g);
    return function(I, g) {
        return $204508e5b4b18960$var$A = I.exports, $204508e5b4b18960$var$oA.__wbindgen_wasm_module = g, $204508e5b4b18960$var$a = null, $204508e5b4b18960$var$i = null, $204508e5b4b18960$var$o = null, $204508e5b4b18960$var$M = null, $204508e5b4b18960$var$S = null, $204508e5b4b18960$var$A;
    }(w, U);
}
class $204508e5b4b18960$export$64b5c384219d3699 {
    constructor(A, I, g){
        this.x = A, this.y = I, this.z = g;
    }
}
class $204508e5b4b18960$export$e2f642242c040d8f {
    static new(A, I, g) {
        return new $204508e5b4b18960$export$64b5c384219d3699(A, I, g);
    }
    static intoRaw(A) {
        return new $204508e5b4b18960$var$DA(A.x, A.y, A.z);
    }
    static zeros() {
        return $204508e5b4b18960$export$e2f642242c040d8f.new(0, 0, 0);
    }
    static fromRaw(A) {
        if (!A) return null;
        let I = $204508e5b4b18960$export$e2f642242c040d8f.new(A.x, A.y, A.z);
        return A.free(), I;
    }
    static copy(A, I) {
        A.x = I.x, A.y = I.y, A.z = I.z;
    }
}
class $204508e5b4b18960$export$23d6a54f0bbc85a3 {
    constructor(A, I, g, C){
        this.x = A, this.y = I, this.z = g, this.w = C;
    }
}
class $204508e5b4b18960$export$824960640e91b57 {
    static identity() {
        return new $204508e5b4b18960$export$23d6a54f0bbc85a3(0, 0, 0, 1);
    }
    static fromRaw(A) {
        if (!A) return null;
        let I = new $204508e5b4b18960$export$23d6a54f0bbc85a3(A.x, A.y, A.z, A.w);
        return A.free(), I;
    }
    static intoRaw(A) {
        return new $204508e5b4b18960$var$gA(A.x, A.y, A.z, A.w);
    }
    static copy(A, I) {
        A.x = I.x, A.y = I.y, A.z = I.z, A.w = I.w;
    }
}
class $204508e5b4b18960$export$a634d4178dd6cfce {
    constructor(A){
        this.elements = A;
    }
    get m11() {
        return this.elements[0];
    }
    get m12() {
        return this.elements[1];
    }
    get m21() {
        return this.m12;
    }
    get m13() {
        return this.elements[2];
    }
    get m31() {
        return this.m13;
    }
    get m22() {
        return this.elements[3];
    }
    get m23() {
        return this.elements[4];
    }
    get m32() {
        return this.m23;
    }
    get m33() {
        return this.elements[5];
    }
}
class $204508e5b4b18960$export$afeef1d10fc8a4f3 {
    static fromRaw(A) {
        const I = new $204508e5b4b18960$export$a634d4178dd6cfce(A.elements());
        return A.free(), I;
    }
}
var $204508e5b4b18960$export$9df1fa60cce90854, $204508e5b4b18960$export$d8c34c2371473e33, $204508e5b4b18960$export$9fe5861f16a3846f, $204508e5b4b18960$export$9fb152d4b46f94ce, $204508e5b4b18960$export$5d7f3962eb4528af, $204508e5b4b18960$export$c40deacab7e2491c, $204508e5b4b18960$export$fc850f719b5599d5, $204508e5b4b18960$export$1a49384a8815c6a9, $204508e5b4b18960$export$5dbdc437333f52f1, $204508e5b4b18960$export$39a39008025d4cb, $204508e5b4b18960$export$f28998d26d157fd3, $204508e5b4b18960$export$194d8ad9e2dc63e8, $204508e5b4b18960$export$d50a7c063745a562, $204508e5b4b18960$export$822f84f0c1c58b2a, $204508e5b4b18960$export$9d99ce4bda7104cf;
!function(A) {
    A[A.Dynamic = 0] = "Dynamic", A[A.Fixed = 1] = "Fixed", A[A.KinematicPositionBased = 2] = "KinematicPositionBased", A[A.KinematicVelocityBased = 3] = "KinematicVelocityBased";
}($204508e5b4b18960$export$9df1fa60cce90854 || ($204508e5b4b18960$export$9df1fa60cce90854 = {}));
class $204508e5b4b18960$export$41c0a739a32ac4d {
    constructor(A, I, g){
        this.rawSet = A, this.colliderSet = I, this.handle = g;
    }
    finalizeDeserialization(A) {
        this.colliderSet = A;
    }
    isValid() {
        return this.rawSet.contains(this.handle);
    }
    lockTranslations(A, I) {
        return this.rawSet.rbLockTranslations(this.handle, A, I);
    }
    lockRotations(A, I) {
        return this.rawSet.rbLockRotations(this.handle, A, I);
    }
    setEnabledTranslations(A, I, g, C) {
        return this.rawSet.rbSetEnabledTranslations(this.handle, A, I, g, C);
    }
    restrictTranslations(A, I, g, C) {
        this.setEnabledTranslations(A, I, g, C);
    }
    setEnabledRotations(A, I, g, C) {
        return this.rawSet.rbSetEnabledRotations(this.handle, A, I, g, C);
    }
    restrictRotations(A, I, g, C) {
        this.setEnabledRotations(A, I, g, C);
    }
    dominanceGroup() {
        return this.rawSet.rbDominanceGroup(this.handle);
    }
    setDominanceGroup(A) {
        this.rawSet.rbSetDominanceGroup(this.handle, A);
    }
    additionalSolverIterations() {
        return this.rawSet.rbAdditionalSolverIterations(this.handle);
    }
    setAdditionalSolverIterations(A) {
        this.rawSet.rbSetAdditionalSolverIterations(this.handle, A);
    }
    enableCcd(A) {
        this.rawSet.rbEnableCcd(this.handle, A);
    }
    setSoftCcdPrediction(A) {
        this.rawSet.rbSetSoftCcdPrediction(this.handle, A);
    }
    softCcdPrediction() {
        return this.rawSet.rbSoftCcdPrediction(this.handle);
    }
    translation() {
        let A = this.rawSet.rbTranslation(this.handle);
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A);
    }
    rotation() {
        let A = this.rawSet.rbRotation(this.handle);
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(A);
    }
    nextTranslation() {
        let A = this.rawSet.rbNextTranslation(this.handle);
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A);
    }
    nextRotation() {
        let A = this.rawSet.rbNextRotation(this.handle);
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(A);
    }
    setTranslation(A, I) {
        this.rawSet.rbSetTranslation(this.handle, A.x, A.y, A.z, I);
    }
    setLinvel(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbSetLinvel(this.handle, g, I), g.free();
    }
    gravityScale() {
        return this.rawSet.rbGravityScale(this.handle);
    }
    setGravityScale(A, I) {
        this.rawSet.rbSetGravityScale(this.handle, A, I);
    }
    setRotation(A, I) {
        this.rawSet.rbSetRotation(this.handle, A.x, A.y, A.z, A.w, I);
    }
    setAngvel(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbSetAngvel(this.handle, g, I), g.free();
    }
    setNextKinematicTranslation(A) {
        this.rawSet.rbSetNextKinematicTranslation(this.handle, A.x, A.y, A.z);
    }
    setNextKinematicRotation(A) {
        this.rawSet.rbSetNextKinematicRotation(this.handle, A.x, A.y, A.z, A.w);
    }
    linvel() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbLinvel(this.handle));
    }
    angvel() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbAngvel(this.handle));
    }
    mass() {
        return this.rawSet.rbMass(this.handle);
    }
    effectiveInvMass() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbEffectiveInvMass(this.handle));
    }
    invMass() {
        return this.rawSet.rbInvMass(this.handle);
    }
    localCom() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbLocalCom(this.handle));
    }
    worldCom() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbWorldCom(this.handle));
    }
    invPrincipalInertiaSqrt() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbInvPrincipalInertiaSqrt(this.handle));
    }
    principalInertia() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.rbPrincipalInertia(this.handle));
    }
    principalInertiaLocalFrame() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.rawSet.rbPrincipalInertiaLocalFrame(this.handle));
    }
    effectiveWorldInvInertiaSqrt() {
        return $204508e5b4b18960$export$afeef1d10fc8a4f3.fromRaw(this.rawSet.rbEffectiveWorldInvInertiaSqrt(this.handle));
    }
    effectiveAngularInertia() {
        return $204508e5b4b18960$export$afeef1d10fc8a4f3.fromRaw(this.rawSet.rbEffectiveAngularInertia(this.handle));
    }
    sleep() {
        this.rawSet.rbSleep(this.handle);
    }
    wakeUp() {
        this.rawSet.rbWakeUp(this.handle);
    }
    isCcdEnabled() {
        return this.rawSet.rbIsCcdEnabled(this.handle);
    }
    numColliders() {
        return this.rawSet.rbNumColliders(this.handle);
    }
    collider(A) {
        return this.colliderSet.get(this.rawSet.rbCollider(this.handle, A));
    }
    setEnabled(A) {
        this.rawSet.rbSetEnabled(this.handle, A);
    }
    isEnabled() {
        return this.rawSet.rbIsEnabled(this.handle);
    }
    bodyType() {
        return this.rawSet.rbBodyType(this.handle);
    }
    setBodyType(A, I) {
        return this.rawSet.rbSetBodyType(this.handle, A, I);
    }
    isSleeping() {
        return this.rawSet.rbIsSleeping(this.handle);
    }
    isMoving() {
        return this.rawSet.rbIsMoving(this.handle);
    }
    isFixed() {
        return this.rawSet.rbIsFixed(this.handle);
    }
    isKinematic() {
        return this.rawSet.rbIsKinematic(this.handle);
    }
    isDynamic() {
        return this.rawSet.rbIsDynamic(this.handle);
    }
    linearDamping() {
        return this.rawSet.rbLinearDamping(this.handle);
    }
    angularDamping() {
        return this.rawSet.rbAngularDamping(this.handle);
    }
    setLinearDamping(A) {
        this.rawSet.rbSetLinearDamping(this.handle, A);
    }
    recomputeMassPropertiesFromColliders() {
        this.rawSet.rbRecomputeMassPropertiesFromColliders(this.handle, this.colliderSet.raw);
    }
    setAdditionalMass(A, I) {
        this.rawSet.rbSetAdditionalMass(this.handle, A, I);
    }
    setAdditionalMassProperties(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), i = $204508e5b4b18960$export$824960640e91b57.intoRaw(C);
        this.rawSet.rbSetAdditionalMassProperties(this.handle, A, Q, E, i, B), Q.free(), E.free(), i.free();
    }
    setAngularDamping(A) {
        this.rawSet.rbSetAngularDamping(this.handle, A);
    }
    resetForces(A) {
        this.rawSet.rbResetForces(this.handle, A);
    }
    resetTorques(A) {
        this.rawSet.rbResetTorques(this.handle, A);
    }
    addForce(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbAddForce(this.handle, g, I), g.free();
    }
    applyImpulse(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbApplyImpulse(this.handle, g, I), g.free();
    }
    addTorque(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbAddTorque(this.handle, g, I), g.free();
    }
    applyTorqueImpulse(A, I) {
        const g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.rbApplyTorqueImpulse(this.handle, g, I), g.free();
    }
    addForceAtPoint(A, I, g) {
        const C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.rawSet.rbAddForceAtPoint(this.handle, C, B, g), C.free(), B.free();
    }
    applyImpulseAtPoint(A, I, g) {
        const C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.rawSet.rbApplyImpulseAtPoint(this.handle, C, B, g), C.free(), B.free();
    }
}
class $204508e5b4b18960$export$105dcb996a5d3c42 {
    constructor(A){
        this.enabled = !0, this.status = A, this.translation = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.rotation = $204508e5b4b18960$export$824960640e91b57.identity(), this.gravityScale = 1, this.linvel = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.mass = 0, this.massOnly = !1, this.centerOfMass = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.translationsEnabledX = !0, this.translationsEnabledY = !0, this.angvel = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.principalAngularInertia = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.angularInertiaLocalFrame = $204508e5b4b18960$export$824960640e91b57.identity(), this.translationsEnabledZ = !0, this.rotationsEnabledX = !0, this.rotationsEnabledY = !0, this.rotationsEnabledZ = !0, this.linearDamping = 0, this.angularDamping = 0, this.canSleep = !0, this.sleeping = !1, this.ccdEnabled = !1, this.softCcdPrediction = 0, this.dominanceGroup = 0, this.additionalSolverIterations = 0;
    }
    static dynamic() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Dynamic);
    }
    static kinematicPositionBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicPositionBased);
    }
    static kinematicVelocityBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicVelocityBased);
    }
    static fixed() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Fixed);
    }
    static newDynamic() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Dynamic);
    }
    static newKinematicPositionBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicPositionBased);
    }
    static newKinematicVelocityBased() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.KinematicVelocityBased);
    }
    static newStatic() {
        return new $204508e5b4b18960$export$105dcb996a5d3c42($204508e5b4b18960$export$9df1fa60cce90854.Fixed);
    }
    setDominanceGroup(A) {
        return this.dominanceGroup = A, this;
    }
    setAdditionalSolverIterations(A) {
        return this.additionalSolverIterations = A, this;
    }
    setEnabled(A) {
        return this.enabled = A, this;
    }
    setTranslation(A, I, g) {
        if ("number" != typeof A || "number" != typeof I || "number" != typeof g) throw TypeError("The translation components must be numbers.");
        return this.translation = {
            x: A,
            y: I,
            z: g
        }, this;
    }
    setRotation(A) {
        return $204508e5b4b18960$export$824960640e91b57.copy(this.rotation, A), this;
    }
    setGravityScale(A) {
        return this.gravityScale = A, this;
    }
    setAdditionalMass(A) {
        return this.mass = A, this.massOnly = !0, this;
    }
    setLinvel(A, I, g) {
        if ("number" != typeof A || "number" != typeof I || "number" != typeof g) throw TypeError("The linvel components must be numbers.");
        return this.linvel = {
            x: A,
            y: I,
            z: g
        }, this;
    }
    setAngvel(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.copy(this.angvel, A), this;
    }
    setAdditionalMassProperties(A, I, g, C) {
        return this.mass = A, $204508e5b4b18960$export$e2f642242c040d8f.copy(this.centerOfMass, I), $204508e5b4b18960$export$e2f642242c040d8f.copy(this.principalAngularInertia, g), $204508e5b4b18960$export$824960640e91b57.copy(this.angularInertiaLocalFrame, C), this.massOnly = !1, this;
    }
    enabledTranslations(A, I, g) {
        return this.translationsEnabledX = A, this.translationsEnabledY = I, this.translationsEnabledZ = g, this;
    }
    restrictTranslations(A, I, g) {
        return this.enabledTranslations(A, I, g);
    }
    lockTranslations() {
        return this.enabledTranslations(!1, !1, !1);
    }
    enabledRotations(A, I, g) {
        return this.rotationsEnabledX = A, this.rotationsEnabledY = I, this.rotationsEnabledZ = g, this;
    }
    restrictRotations(A, I, g) {
        return this.enabledRotations(A, I, g);
    }
    lockRotations() {
        return this.restrictRotations(!1, !1, !1);
    }
    setLinearDamping(A) {
        return this.linearDamping = A, this;
    }
    setAngularDamping(A) {
        return this.angularDamping = A, this;
    }
    setCanSleep(A) {
        return this.canSleep = A, this;
    }
    setSleeping(A) {
        return this.sleeping = A, this;
    }
    setCcdEnabled(A) {
        return this.ccdEnabled = A, this;
    }
    setSoftCcdPrediction(A) {
        return this.softCcdPrediction = A, this;
    }
    setUserData(A) {
        return this.userData = A, this;
    }
}
class $204508e5b4b18960$var$eA {
    constructor(){
        this.fconv = new Float64Array(1), this.uconv = new Uint32Array(this.fconv.buffer), this.data = new Array, this.size = 0;
    }
    set(A, I) {
        let g = this.index(A);
        for(; this.data.length <= g;)this.data.push(null);
        null == this.data[g] && (this.size += 1), this.data[g] = I;
    }
    len() {
        return this.size;
    }
    delete(A) {
        let I = this.index(A);
        I < this.data.length && (null != this.data[I] && (this.size -= 1), this.data[I] = null);
    }
    clear() {
        this.data = new Array;
    }
    get(A) {
        let I = this.index(A);
        return I < this.data.length ? this.data[I] : null;
    }
    forEach(A) {
        for (const I of this.data)null != I && A(I);
    }
    getAll() {
        return this.data.filter((A)=>null != A);
    }
    index(A) {
        return this.fconv[0] = A, this.uconv[0];
    }
}
class $204508e5b4b18960$export$bd569bf5451ee055 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$IA, this.map = new $204508e5b4b18960$var$eA, A && A.forEachRigidBodyHandle((I)=>{
            this.map.set(I, new $204508e5b4b18960$export$41c0a739a32ac4d(A, null, I));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    finalizeDeserialization(A) {
        this.map.forEach((I)=>I.finalizeDeserialization(A));
    }
    createRigidBody(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.translation), C = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.rotation), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.linvel), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.centerOfMass), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.angvel), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.principalAngularInertia), D = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.angularInertiaLocalFrame), o = this.raw.createRigidBody(I.enabled, g, C, I.gravityScale, I.mass, I.massOnly, Q, B, E, i, D, I.translationsEnabledX, I.translationsEnabledY, I.translationsEnabledZ, I.rotationsEnabledX, I.rotationsEnabledY, I.rotationsEnabledZ, I.linearDamping, I.angularDamping, I.status, I.canSleep, I.sleeping, I.softCcdPrediction, I.ccdEnabled, I.dominanceGroup, I.additionalSolverIterations);
        g.free(), C.free(), B.free(), Q.free(), E.free(), i.free(), D.free();
        const G = new $204508e5b4b18960$export$41c0a739a32ac4d(this.raw, A, o);
        return G.userData = I.userData, this.map.set(o, G), G;
    }
    remove(A, I, g, C, B) {
        for(let I = 0; I < this.raw.rbNumColliders(A); I += 1)g.unmap(this.raw.rbCollider(A, I));
        C.forEachJointHandleAttachedToRigidBody(A, (A)=>C.unmap(A)), B.forEachJointHandleAttachedToRigidBody(A, (A)=>B.unmap(A)), this.raw.remove(A, I.raw, g.raw, C.raw, B.raw), this.map.delete(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    get(A) {
        return this.map.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    forEachActiveRigidBody(A, I) {
        A.forEachActiveRigidBodyHandle((A)=>{
            I(this.get(A));
        });
    }
    getAll() {
        return this.map.getAll();
    }
}
class $204508e5b4b18960$export$c22d4691787a8578 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$j;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    get dt() {
        return this.raw.dt;
    }
    get erp() {
        return this.raw.erp;
    }
    get lengthUnit() {
        return this.raw.lengthUnit;
    }
    get normalizedAllowedLinearError() {
        return this.raw.normalizedAllowedLinearError;
    }
    get normalizedPredictionDistance() {
        return this.raw.normalizedPredictionDistance;
    }
    get numSolverIterations() {
        return this.raw.numSolverIterations;
    }
    get numAdditionalFrictionIterations() {
        return this.raw.numAdditionalFrictionIterations;
    }
    get numInternalPgsIterations() {
        return this.raw.numInternalPgsIterations;
    }
    get minIslandSize() {
        return this.raw.minIslandSize;
    }
    get maxCcdSubsteps() {
        return this.raw.maxCcdSubsteps;
    }
    set dt(A) {
        this.raw.dt = A;
    }
    set erp(A) {
        this.raw.erp = A;
    }
    set lengthUnit(A) {
        this.raw.lengthUnit = A;
    }
    set normalizedAllowedLinearError(A) {
        this.raw.normalizedAllowedLinearError = A;
    }
    set normalizedPredictionDistance(A) {
        this.raw.normalizedPredictionDistance = A;
    }
    set numSolverIterations(A) {
        this.raw.numSolverIterations = A;
    }
    set numAdditionalFrictionIterations(A) {
        this.raw.numAdditionalFrictionIterations = A;
    }
    set numInternalPgsIterations(A) {
        this.raw.numInternalPgsIterations = A;
    }
    set minIslandSize(A) {
        this.raw.minIslandSize = A;
    }
    set maxCcdSubsteps(A) {
        this.raw.maxCcdSubsteps = A;
    }
    switchToStandardPgsSolver() {
        this.raw.switchToStandardPgsSolver();
    }
    switchToSmallStepsPgsSolver() {
        this.raw.switchToSmallStepsPgsSolver();
    }
    switchToSmallStepsPgsSolverWithoutWarmstart() {
        this.raw.switchToSmallStepsPgsSolverWithoutWarmstart();
    }
}
!function(A) {
    A[A.Revolute = 0] = "Revolute", A[A.Fixed = 1] = "Fixed", A[A.Prismatic = 2] = "Prismatic", A[A.Rope = 3] = "Rope", A[A.Spring = 4] = "Spring", A[A.Spherical = 5] = "Spherical", A[A.Generic = 6] = "Generic";
}($204508e5b4b18960$export$d8c34c2371473e33 || ($204508e5b4b18960$export$d8c34c2371473e33 = {})), function(A) {
    A[A.AccelerationBased = 0] = "AccelerationBased", A[A.ForceBased = 1] = "ForceBased";
}($204508e5b4b18960$export$9fe5861f16a3846f || ($204508e5b4b18960$export$9fe5861f16a3846f = {})), function(A) {
    A[A.X = 1] = "X", A[A.Y = 2] = "Y", A[A.Z = 4] = "Z", A[A.AngX = 8] = "AngX", A[A.AngY = 16] = "AngY", A[A.AngZ = 32] = "AngZ";
}($204508e5b4b18960$export$9fb152d4b46f94ce || ($204508e5b4b18960$export$9fb152d4b46f94ce = {}));
class $204508e5b4b18960$export$13616a6dfa0c261e {
    constructor(A, I, g){
        this.rawSet = A, this.bodySet = I, this.handle = g;
    }
    static newTyped(A, I, g) {
        switch(A.jointType(g)){
            case $204508e5b4b18960$var$l.Revolute:
                return new $204508e5b4b18960$export$f21c6aedecbeb53d(A, I, g);
            case $204508e5b4b18960$var$l.Prismatic:
                return new $204508e5b4b18960$export$ca91224fa01cc4c5(A, I, g);
            case $204508e5b4b18960$var$l.Fixed:
                return new $204508e5b4b18960$export$13a2c1429de97fd0(A, I, g);
            case $204508e5b4b18960$var$l.Spring:
                return new $204508e5b4b18960$export$6a104d5406ced20(A, I, g);
            case $204508e5b4b18960$var$l.Rope:
                return new $204508e5b4b18960$export$21cd30e53afbf3c1(A, I, g);
            case $204508e5b4b18960$var$l.Spherical:
                return new $204508e5b4b18960$export$da358565907d92be(A, I, g);
            case $204508e5b4b18960$var$l.Generic:
                return new $204508e5b4b18960$export$9c43d159fbe4a60(A, I, g);
            default:
                return new $204508e5b4b18960$export$13616a6dfa0c261e(A, I, g);
        }
    }
    finalizeDeserialization(A) {
        this.bodySet = A;
    }
    isValid() {
        return this.rawSet.contains(this.handle);
    }
    body1() {
        return this.bodySet.get(this.rawSet.jointBodyHandle1(this.handle));
    }
    body2() {
        return this.bodySet.get(this.rawSet.jointBodyHandle2(this.handle));
    }
    type() {
        return this.rawSet.jointType(this.handle);
    }
    frameX1() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.rawSet.jointFrameX1(this.handle));
    }
    frameX2() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.rawSet.jointFrameX2(this.handle));
    }
    anchor1() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.jointAnchor1(this.handle));
    }
    anchor2() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.rawSet.jointAnchor2(this.handle));
    }
    setAnchor1(A) {
        const I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.jointSetAnchor1(this.handle, I), I.free();
    }
    setAnchor2(A) {
        const I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.rawSet.jointSetAnchor2(this.handle, I), I.free();
    }
    setContactsEnabled(A) {
        this.rawSet.jointSetContactsEnabled(this.handle, A);
    }
    contactsEnabled() {
        return this.rawSet.jointContactsEnabled(this.handle);
    }
}
class $204508e5b4b18960$export$b6c446c752acb453 extends $204508e5b4b18960$export$13616a6dfa0c261e {
    limitsEnabled() {
        return this.rawSet.jointLimitsEnabled(this.handle, this.rawAxis());
    }
    limitsMin() {
        return this.rawSet.jointLimitsMin(this.handle, this.rawAxis());
    }
    limitsMax() {
        return this.rawSet.jointLimitsMax(this.handle, this.rawAxis());
    }
    setLimits(A, I) {
        this.rawSet.jointSetLimits(this.handle, this.rawAxis(), A, I);
    }
    configureMotorModel(A) {
        this.rawSet.jointConfigureMotorModel(this.handle, this.rawAxis(), A);
    }
    configureMotorVelocity(A, I) {
        this.rawSet.jointConfigureMotorVelocity(this.handle, this.rawAxis(), A, I);
    }
    configureMotorPosition(A, I, g) {
        this.rawSet.jointConfigureMotorPosition(this.handle, this.rawAxis(), A, I, g);
    }
    configureMotor(A, I, g, C) {
        this.rawSet.jointConfigureMotor(this.handle, this.rawAxis(), A, I, g, C);
    }
}
class $204508e5b4b18960$export$13a2c1429de97fd0 extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$21cd30e53afbf3c1 extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$6a104d5406ced20 extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$ca91224fa01cc4c5 extends $204508e5b4b18960$export$b6c446c752acb453 {
    rawAxis() {
        return $204508e5b4b18960$var$Y.X;
    }
}
class $204508e5b4b18960$export$f21c6aedecbeb53d extends $204508e5b4b18960$export$b6c446c752acb453 {
    rawAxis() {
        return $204508e5b4b18960$var$Y.AngX;
    }
}
class $204508e5b4b18960$export$9c43d159fbe4a60 extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$da358565907d92be extends $204508e5b4b18960$export$13616a6dfa0c261e {
}
class $204508e5b4b18960$export$9ad4996060073eaa {
    constructor(){}
    static fixed(A, I, g, C) {
        let B = new $204508e5b4b18960$export$9ad4996060073eaa;
        return B.anchor1 = A, B.anchor2 = g, B.frame1 = I, B.frame2 = C, B.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Fixed, B;
    }
    static spring(A, I, g, C, B) {
        let Q = new $204508e5b4b18960$export$9ad4996060073eaa;
        return Q.anchor1 = C, Q.anchor2 = B, Q.length = A, Q.stiffness = I, Q.damping = g, Q.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Spring, Q;
    }
    static rope(A, I, g) {
        let C = new $204508e5b4b18960$export$9ad4996060073eaa;
        return C.anchor1 = I, C.anchor2 = g, C.length = A, C.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Rope, C;
    }
    static generic(A, I, g, C) {
        let B = new $204508e5b4b18960$export$9ad4996060073eaa;
        return B.anchor1 = A, B.anchor2 = I, B.axis = g, B.axesMask = C, B.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Generic, B;
    }
    static spherical(A, I) {
        let g = new $204508e5b4b18960$export$9ad4996060073eaa;
        return g.anchor1 = A, g.anchor2 = I, g.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Spherical, g;
    }
    static prismatic(A, I, g) {
        let C = new $204508e5b4b18960$export$9ad4996060073eaa;
        return C.anchor1 = A, C.anchor2 = I, C.axis = g, C.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Prismatic, C;
    }
    static revolute(A, I, g) {
        let C = new $204508e5b4b18960$export$9ad4996060073eaa;
        return C.anchor1 = A, C.anchor2 = I, C.axis = g, C.jointType = $204508e5b4b18960$export$d8c34c2371473e33.Revolute, C;
    }
    intoRaw() {
        let A, I, g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.anchor1), C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.anchor2), B = !1, Q = 0, E = 0;
        switch(this.jointType){
            case $204508e5b4b18960$export$d8c34c2371473e33.Fixed:
                let i = $204508e5b4b18960$export$824960640e91b57.intoRaw(this.frame1), D = $204508e5b4b18960$export$824960640e91b57.intoRaw(this.frame2);
                I = $204508e5b4b18960$var$x.fixed(g, i, C, D), i.free(), D.free();
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Spring:
                I = $204508e5b4b18960$var$x.spring(this.length, this.stiffness, this.damping, g, C);
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Rope:
                I = $204508e5b4b18960$var$x.rope(this.length, g, C);
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Prismatic:
                A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.axis), this.limitsEnabled && (B = !0, Q = this.limits[0], E = this.limits[1]), I = $204508e5b4b18960$var$x.prismatic(g, C, A, B, Q, E), A.free();
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Generic:
                A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.axis);
                let o = this.axesMask;
                I = $204508e5b4b18960$var$x.generic(g, C, A, o);
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Spherical:
                I = $204508e5b4b18960$var$x.spherical(g, C);
                break;
            case $204508e5b4b18960$export$d8c34c2371473e33.Revolute:
                A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.axis), I = $204508e5b4b18960$var$x.revolute(g, C, A), A.free();
        }
        return g.free(), C.free(), I;
    }
}
class $204508e5b4b18960$export$7b6f816cee9f25f2 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$W, this.map = new $204508e5b4b18960$var$eA, A && A.forEachJointHandle((I)=>{
            this.map.set(I, $204508e5b4b18960$export$13616a6dfa0c261e.newTyped(A, null, I));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    finalizeDeserialization(A) {
        this.map.forEach((I)=>I.finalizeDeserialization(A));
    }
    createJoint(A, I, g, C, B) {
        const Q = I.intoRaw(), E = this.raw.createJoint(Q, g, C, B);
        Q.free();
        let i = $204508e5b4b18960$export$13616a6dfa0c261e.newTyped(this.raw, A, E);
        return this.map.set(E, i), i;
    }
    remove(A, I) {
        this.raw.remove(A, I), this.unmap(A);
    }
    forEachJointHandleAttachedToRigidBody(A, I) {
        this.raw.forEachJointAttachedToRigidBody(A, I);
    }
    unmap(A) {
        this.map.delete(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    get(A) {
        return this.map.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    getAll() {
        return this.map.getAll();
    }
}
class $204508e5b4b18960$export$9f6b52d8d09f7b72 {
    constructor(A, I){
        this.rawSet = A, this.handle = I;
    }
    static newTyped(A, I) {
        switch(A.jointType(I)){
            case $204508e5b4b18960$var$l.Revolute:
                return new $204508e5b4b18960$export$e2bca3ac97ae239e(A, I);
            case $204508e5b4b18960$var$l.Prismatic:
                return new $204508e5b4b18960$export$1ac8e4ec1713e3da(A, I);
            case $204508e5b4b18960$var$l.Fixed:
                return new $204508e5b4b18960$export$6984fd596a92ce33(A, I);
            case $204508e5b4b18960$var$l.Spherical:
                return new $204508e5b4b18960$export$b9ffb05588678855(A, I);
            default:
                return new $204508e5b4b18960$export$9f6b52d8d09f7b72(A, I);
        }
    }
    isValid() {
        return this.rawSet.contains(this.handle);
    }
    setContactsEnabled(A) {
        this.rawSet.jointSetContactsEnabled(this.handle, A);
    }
    contactsEnabled() {
        return this.rawSet.jointContactsEnabled(this.handle);
    }
}
class $204508e5b4b18960$export$b677e6fe6c6cb994 extends $204508e5b4b18960$export$9f6b52d8d09f7b72 {
}
class $204508e5b4b18960$export$6984fd596a92ce33 extends $204508e5b4b18960$export$9f6b52d8d09f7b72 {
}
class $204508e5b4b18960$export$1ac8e4ec1713e3da extends $204508e5b4b18960$export$b677e6fe6c6cb994 {
    rawAxis() {
        return $204508e5b4b18960$var$Y.X;
    }
}
class $204508e5b4b18960$export$e2bca3ac97ae239e extends $204508e5b4b18960$export$b677e6fe6c6cb994 {
    rawAxis() {
        return $204508e5b4b18960$var$Y.AngX;
    }
}
class $204508e5b4b18960$export$b9ffb05588678855 extends $204508e5b4b18960$export$9f6b52d8d09f7b72 {
}
class $204508e5b4b18960$export$b6a38ee363602c2a {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$V, this.map = new $204508e5b4b18960$var$eA, A && A.forEachJointHandle((A)=>{
            this.map.set(A, $204508e5b4b18960$export$9f6b52d8d09f7b72.newTyped(this.raw, A));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    createJoint(A, I, g, C) {
        const B = A.intoRaw(), Q = this.raw.createJoint(B, I, g, C);
        B.free();
        let E = $204508e5b4b18960$export$9f6b52d8d09f7b72.newTyped(this.raw, Q);
        return this.map.set(Q, E), E;
    }
    remove(A, I) {
        this.raw.remove(A, I), this.map.delete(A);
    }
    unmap(A) {
        this.map.delete(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    get(A) {
        return this.map.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    forEachJointHandleAttachedToRigidBody(A, I) {
        this.raw.forEachJointAttachedToRigidBody(A, I);
    }
    getAll() {
        return this.map.getAll();
    }
}
!function(A) {
    A[A.Average = 0] = "Average", A[A.Min = 1] = "Min", A[A.Multiply = 2] = "Multiply", A[A.Max = 3] = "Max";
}($204508e5b4b18960$export$5d7f3962eb4528af || ($204508e5b4b18960$export$5d7f3962eb4528af = {}));
class $204508e5b4b18960$export$ffc4c782649f077 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$L;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
}
class $204508e5b4b18960$export$129e66920a069ba5 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$m;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    forEachActiveRigidBodyHandle(A) {
        this.raw.forEachActiveRigidBodyHandle(A);
    }
}
class $204508e5b4b18960$export$d80423229f8b133 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$H;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
}
class $204508e5b4b18960$export$f7b463e625571e2b {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$X, this.tempManifold = new $204508e5b4b18960$export$7ac890e03fe91616(null);
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    contactPairsWith(A, I) {
        this.raw.contact_pairs_with(A, I);
    }
    intersectionPairsWith(A, I) {
        this.raw.intersection_pairs_with(A, I);
    }
    contactPair(A, I, g) {
        const C = this.raw.contact_pair(A, I);
        if (C) {
            const I = C.collider1() != A;
            let B;
            for(B = 0; B < C.numContactManifolds(); ++B)this.tempManifold.raw = C.contactManifold(B), this.tempManifold.raw && g(this.tempManifold, I), this.tempManifold.free();
            C.free();
        }
    }
    intersectionPair(A, I) {
        return this.raw.intersection_pair(A, I);
    }
}
class $204508e5b4b18960$export$7ac890e03fe91616 {
    constructor(A){
        this.raw = A;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    normal() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.normal());
    }
    localNormal1() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.local_n1());
    }
    localNormal2() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.local_n2());
    }
    subshape1() {
        return this.raw.subshape1();
    }
    subshape2() {
        return this.raw.subshape2();
    }
    numContacts() {
        return this.raw.num_contacts();
    }
    localContactPoint1(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.contact_local_p1(A));
    }
    localContactPoint2(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.contact_local_p2(A));
    }
    contactDist(A) {
        return this.raw.contact_dist(A);
    }
    contactFid1(A) {
        return this.raw.contact_fid1(A);
    }
    contactFid2(A) {
        return this.raw.contact_fid2(A);
    }
    contactImpulse(A) {
        return this.raw.contact_impulse(A);
    }
    contactTangentImpulseX(A) {
        return this.raw.contact_tangent_impulse_x(A);
    }
    contactTangentImpulseY(A) {
        return this.raw.contact_tangent_impulse_y(A);
    }
    numSolverContacts() {
        return this.raw.num_solver_contacts();
    }
    solverContactPoint(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.solver_contact_point(A));
    }
    solverContactDist(A) {
        return this.raw.solver_contact_dist(A);
    }
    solverContactFriction(A) {
        return this.raw.solver_contact_friction(A);
    }
    solverContactRestitution(A) {
        return this.raw.solver_contact_restitution(A);
    }
    solverContactTangentVelocity(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.solver_contact_tangent_velocity(A));
    }
}
class $204508e5b4b18960$export$1d7ee127e07c91bb {
    constructor(A, I, g, C, B){
        this.distance = A, this.point1 = I, this.point2 = g, this.normal1 = C, this.normal2 = B;
    }
    static fromRaw(A) {
        if (!A) return null;
        const I = new $204508e5b4b18960$export$1d7ee127e07c91bb(A.distance(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.point1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.point2()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.normal1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.normal2()));
        return A.free(), I;
    }
}
!function(A) {
    A[A.Vertex = 0] = "Vertex", A[A.Edge = 1] = "Edge", A[A.Face = 2] = "Face", A[A.Unknown = 3] = "Unknown";
}($204508e5b4b18960$export$c40deacab7e2491c || ($204508e5b4b18960$export$c40deacab7e2491c = {}));
class $204508e5b4b18960$export$5e813b027a709134 {
    constructor(A, I){
        this.point = A, this.isInside = I;
    }
    static fromRaw(A) {
        if (!A) return null;
        const I = new $204508e5b4b18960$export$5e813b027a709134($204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.point()), A.isInside());
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$fc779dece190555 {
    constructor(A, I, g, C, B){
        this.featureType = $204508e5b4b18960$export$c40deacab7e2491c.Unknown, this.featureId = void 0, this.collider = A, this.point = I, this.isInside = g, void 0 !== B && (this.featureId = B), void 0 !== C && (this.featureType = C);
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$fc779dece190555(A.get(I.colliderHandle()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.point()), I.isInside(), I.featureType(), I.featureId());
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$a186db52eed6d40e {
    constructor(A, I){
        this.origin = A, this.dir = I;
    }
    pointAt(A) {
        return {
            x: this.origin.x + this.dir.x * A,
            y: this.origin.y + this.dir.y * A,
            z: this.origin.z + this.dir.z * A
        };
    }
}
class $204508e5b4b18960$export$292489680db6ed3f {
    constructor(A, I, g, C){
        this.featureType = $204508e5b4b18960$export$c40deacab7e2491c.Unknown, this.featureId = void 0, this.timeOfImpact = A, this.normal = I, void 0 !== C && (this.featureId = C), void 0 !== g && (this.featureType = g);
    }
    static fromRaw(A) {
        if (!A) return null;
        const I = new $204508e5b4b18960$export$292489680db6ed3f(A.time_of_impact(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.normal()), A.featureType(), A.featureId());
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$bc228139800bb3c {
    constructor(A, I, g, C, B){
        this.featureType = $204508e5b4b18960$export$c40deacab7e2491c.Unknown, this.featureId = void 0, this.collider = A, this.timeOfImpact = I, this.normal = g, void 0 !== B && (this.featureId = B), void 0 !== C && (this.featureType = C);
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$bc228139800bb3c(A.get(I.colliderHandle()), I.time_of_impact(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal()), I.featureType(), I.featureId());
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$f559542b3fef6583 {
    constructor(A, I){
        this.collider = A, this.timeOfImpact = I;
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$f559542b3fef6583(A.get(I.colliderHandle()), I.timeOfImpact());
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$2f19b12a78c879bd {
    constructor(A, I, g, C, B){
        this.time_of_impact = A, this.witness1 = I, this.witness2 = g, this.normal1 = C, this.normal2 = B;
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$2f19b12a78c879bd(I.time_of_impact(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness2()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal2()));
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$e46fe1533b6b9d13 extends $204508e5b4b18960$export$2f19b12a78c879bd {
    constructor(A, I, g, C, B, Q){
        super(I, g, C, B, Q), this.collider = A;
    }
    static fromRaw(A, I) {
        if (!I) return null;
        const g = new $204508e5b4b18960$export$e46fe1533b6b9d13(A.get(I.colliderHandle()), I.time_of_impact(), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.witness2()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal1()), $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(I.normal2()));
        return I.free(), g;
    }
}
class $204508e5b4b18960$export$6428a7f2611ef1fa {
    static fromRaw(A, I) {
        const g = A.coShapeType(I);
        let C, B, Q, E, i, D, o;
        switch(g){
            case $204508e5b4b18960$var$c.Ball:
                return new $204508e5b4b18960$export$a83d7c3fa53790c9(A.coRadius(I));
            case $204508e5b4b18960$var$c.Cuboid:
                return C = A.coHalfExtents(I), new $204508e5b4b18960$export$c8821cc685709b7b(C.x, C.y, C.z);
            case $204508e5b4b18960$var$c.RoundCuboid:
                return C = A.coHalfExtents(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$c87d2c121efe06ab(C.x, C.y, C.z, B);
            case $204508e5b4b18960$var$c.Capsule:
                return i = A.coHalfHeight(I), D = A.coRadius(I), new $204508e5b4b18960$export$28bdb8fc07bf3804(i, D);
            case $204508e5b4b18960$var$c.Segment:
                return Q = A.coVertices(I), new $204508e5b4b18960$export$d53aa5c5ab432700($204508e5b4b18960$export$e2f642242c040d8f.new(Q[0], Q[1], Q[2]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[3], Q[4], Q[5]));
            case $204508e5b4b18960$var$c.Polyline:
                return Q = A.coVertices(I), E = A.coIndices(I), new $204508e5b4b18960$export$79f3ee03e63e7073(Q, E);
            case $204508e5b4b18960$var$c.Triangle:
                return Q = A.coVertices(I), new $204508e5b4b18960$export$5a465592bfe74b48($204508e5b4b18960$export$e2f642242c040d8f.new(Q[0], Q[1], Q[2]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[3], Q[4], Q[5]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[6], Q[7], Q[8]));
            case $204508e5b4b18960$var$c.RoundTriangle:
                return Q = A.coVertices(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$5d38c33920824fab($204508e5b4b18960$export$e2f642242c040d8f.new(Q[0], Q[1], Q[2]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[3], Q[4], Q[5]), $204508e5b4b18960$export$e2f642242c040d8f.new(Q[6], Q[7], Q[8]), B);
            case $204508e5b4b18960$var$c.HalfSpace:
                return o = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.coHalfspaceNormal(I)), new $204508e5b4b18960$export$b774d5dd1a533096(o);
            case $204508e5b4b18960$var$c.TriMesh:
                Q = A.coVertices(I), E = A.coIndices(I);
                const G = A.coTriMeshFlags(I);
                return new $204508e5b4b18960$export$16df86f06e459b09(Q, E, G);
            case $204508e5b4b18960$var$c.HeightField:
                const w = A.coHeightfieldScale(I), S = A.coHeightfieldHeights(I), k = A.coHeightfieldNRows(I), U = A.coHeightfieldNCols(I), a = A.coHeightFieldFlags(I);
                return new $204508e5b4b18960$export$fa360b5b58f475b7(k, U, S, w, a);
            case $204508e5b4b18960$var$c.ConvexPolyhedron:
                return Q = A.coVertices(I), E = A.coIndices(I), new $204508e5b4b18960$export$7c637a75bc263948(Q, E);
            case $204508e5b4b18960$var$c.RoundConvexPolyhedron:
                return Q = A.coVertices(I), E = A.coIndices(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$f9ecc9020d30774f(Q, E, B);
            case $204508e5b4b18960$var$c.Cylinder:
                return i = A.coHalfHeight(I), D = A.coRadius(I), new $204508e5b4b18960$export$665c37f020fe48f9(i, D);
            case $204508e5b4b18960$var$c.RoundCylinder:
                return i = A.coHalfHeight(I), D = A.coRadius(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$6fe70449556bd1bd(i, D, B);
            case $204508e5b4b18960$var$c.Cone:
                return i = A.coHalfHeight(I), D = A.coRadius(I), new $204508e5b4b18960$export$22209bc4af3d3757(i, D);
            case $204508e5b4b18960$var$c.RoundCone:
                return i = A.coHalfHeight(I), D = A.coRadius(I), B = A.coRoundRadius(I), new $204508e5b4b18960$export$fec6094316a593bd(i, D, B);
            default:
                throw new Error("unknown shape type: " + g);
        }
    }
    castShape(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), w = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), S = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), k = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(B), U = $204508e5b4b18960$export$824960640e91b57.intoRaw(Q), a = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(E), K = this.intoRaw(), h = C.intoRaw(), J = $204508e5b4b18960$export$2f19b12a78c879bd.fromRaw(null, K.castShape(G, w, S, h, k, U, a, i, D, o));
        return G.free(), w.free(), S.free(), k.free(), U.free(), a.free(), K.free(), h.free(), J;
    }
    intersectsShape(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(C), D = $204508e5b4b18960$export$824960640e91b57.intoRaw(B), o = this.intoRaw(), G = g.intoRaw(), w = o.intersectsShape(Q, E, G, i, D);
        return Q.free(), E.free(), i.free(), D.free(), o.free(), G.free(), w;
    }
    contactShape(A, I, g, C, B, Q) {
        let E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), i = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(C), o = $204508e5b4b18960$export$824960640e91b57.intoRaw(B), G = this.intoRaw(), w = g.intoRaw(), S = $204508e5b4b18960$export$1d7ee127e07c91bb.fromRaw(G.contactShape(E, i, w, D, o, Q));
        return E.free(), i.free(), D.free(), o.free(), G.free(), w.free(), S;
    }
    containsPoint(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), E = this.intoRaw(), i = E.containsPoint(C, B, Q);
        return C.free(), B.free(), Q.free(), E.free(), i;
    }
    projectPoint(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), Q = $204508e5b4b18960$export$824960640e91b57.intoRaw(I), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), i = this.intoRaw(), D = $204508e5b4b18960$export$5e813b027a709134.fromRaw(i.projectPoint(B, Q, E, C));
        return B.free(), Q.free(), E.free(), i.free(), D;
    }
    intersectsRay(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), Q = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), D = this.intoRaw(), o = D.intersectsRay(B, Q, E, i, C);
        return B.free(), Q.free(), E.free(), i.free(), D.free(), o;
    }
    castRay(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), o = this.intoRaw(), G = o.castRay(Q, E, i, D, C, B);
        return Q.free(), E.free(), i.free(), D.free(), o.free(), G;
    }
    castRayAndGetNormal(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), o = this.intoRaw(), G = $204508e5b4b18960$export$292489680db6ed3f.fromRaw(o.castRayAndGetNormal(Q, E, i, D, C, B));
        return Q.free(), E.free(), i.free(), D.free(), o.free(), G;
    }
}
!function(A) {
    A[A.Ball = 0] = "Ball", A[A.Cuboid = 1] = "Cuboid", A[A.Capsule = 2] = "Capsule", A[A.Segment = 3] = "Segment", A[A.Polyline = 4] = "Polyline", A[A.Triangle = 5] = "Triangle", A[A.TriMesh = 6] = "TriMesh", A[A.HeightField = 7] = "HeightField", A[A.ConvexPolyhedron = 9] = "ConvexPolyhedron", A[A.Cylinder = 10] = "Cylinder", A[A.Cone = 11] = "Cone", A[A.RoundCuboid = 12] = "RoundCuboid", A[A.RoundTriangle = 13] = "RoundTriangle", A[A.RoundCylinder = 14] = "RoundCylinder", A[A.RoundCone = 15] = "RoundCone", A[A.RoundConvexPolyhedron = 16] = "RoundConvexPolyhedron", A[A.HalfSpace = 17] = "HalfSpace";
}($204508e5b4b18960$export$fc850f719b5599d5 || ($204508e5b4b18960$export$fc850f719b5599d5 = {})), function(A) {
    A[A.FIX_INTERNAL_EDGES = 1] = "FIX_INTERNAL_EDGES";
}($204508e5b4b18960$export$1a49384a8815c6a9 || ($204508e5b4b18960$export$1a49384a8815c6a9 = {})), function(A) {
    A[A.DELETE_BAD_TOPOLOGY_TRIANGLES = 4] = "DELETE_BAD_TOPOLOGY_TRIANGLES", A[A.ORIENTED = 8] = "ORIENTED", A[A.MERGE_DUPLICATE_VERTICES = 16] = "MERGE_DUPLICATE_VERTICES", A[A.DELETE_DEGENERATE_TRIANGLES = 32] = "DELETE_DEGENERATE_TRIANGLES", A[A.DELETE_DUPLICATE_TRIANGLES = 64] = "DELETE_DUPLICATE_TRIANGLES", A[A.FIX_INTERNAL_EDGES = 152] = "FIX_INTERNAL_EDGES";
}($204508e5b4b18960$export$5dbdc437333f52f1 || ($204508e5b4b18960$export$5dbdc437333f52f1 = {}));
class $204508e5b4b18960$export$a83d7c3fa53790c9 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Ball, this.radius = A;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.ball(this.radius);
    }
}
class $204508e5b4b18960$export$b774d5dd1a533096 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.HalfSpace, this.normal = A;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.normal), I = $204508e5b4b18960$var$QA.halfspace(A);
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$c8821cc685709b7b extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Cuboid, this.halfExtents = $204508e5b4b18960$export$e2f642242c040d8f.new(A, I, g);
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.cuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z);
    }
}
class $204508e5b4b18960$export$c87d2c121efe06ab extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g, C){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundCuboid, this.halfExtents = $204508e5b4b18960$export$e2f642242c040d8f.new(A, I, g), this.borderRadius = C;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.roundCuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z, this.borderRadius);
    }
}
class $204508e5b4b18960$export$28bdb8fc07bf3804 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Capsule, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.capsule(this.halfHeight, this.radius);
    }
}
class $204508e5b4b18960$export$d53aa5c5ab432700 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Segment, this.a = A, this.b = I;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.a), I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.b), g = $204508e5b4b18960$var$QA.segment(A, I);
        return A.free(), I.free(), g;
    }
}
class $204508e5b4b18960$export$5a465592bfe74b48 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Triangle, this.a = A, this.b = I, this.c = g;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.a), I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.b), g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.c), C = $204508e5b4b18960$var$QA.triangle(A, I, g);
        return A.free(), I.free(), g.free(), C;
    }
}
class $204508e5b4b18960$export$5d38c33920824fab extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g, C){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundTriangle, this.a = A, this.b = I, this.c = g, this.borderRadius = C;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.a), I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.b), g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.c), C = $204508e5b4b18960$var$QA.roundTriangle(A, I, g, this.borderRadius);
        return A.free(), I.free(), g.free(), C;
    }
}
class $204508e5b4b18960$export$79f3ee03e63e7073 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Polyline, this.vertices = A, this.indices = null != I ? I : new Uint32Array(0);
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.polyline(this.vertices, this.indices);
    }
}
class $204508e5b4b18960$export$16df86f06e459b09 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.TriMesh, this.vertices = A, this.indices = I, this.flags = g;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.trimesh(this.vertices, this.indices, this.flags);
    }
}
class $204508e5b4b18960$export$7c637a75bc263948 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.ConvexPolyhedron, this.vertices = A, this.indices = I;
    }
    intoRaw() {
        return this.indices ? $204508e5b4b18960$var$QA.convexMesh(this.vertices, this.indices) : $204508e5b4b18960$var$QA.convexHull(this.vertices);
    }
}
class $204508e5b4b18960$export$f9ecc9020d30774f extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundConvexPolyhedron, this.vertices = A, this.indices = I, this.borderRadius = g;
    }
    intoRaw() {
        return this.indices ? $204508e5b4b18960$var$QA.roundConvexMesh(this.vertices, this.indices, this.borderRadius) : $204508e5b4b18960$var$QA.roundConvexHull(this.vertices, this.borderRadius);
    }
}
class $204508e5b4b18960$export$fa360b5b58f475b7 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g, C, B){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.HeightField, this.nrows = A, this.ncols = I, this.heights = g, this.scale = C, this.flags = B;
    }
    intoRaw() {
        let A = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(this.scale), I = $204508e5b4b18960$var$QA.heightfield(this.nrows, this.ncols, this.heights, A, this.flags);
        return A.free(), I;
    }
}
class $204508e5b4b18960$export$665c37f020fe48f9 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Cylinder, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.cylinder(this.halfHeight, this.radius);
    }
}
class $204508e5b4b18960$export$6fe70449556bd1bd extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundCylinder, this.borderRadius = g, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.roundCylinder(this.halfHeight, this.radius, this.borderRadius);
    }
}
class $204508e5b4b18960$export$22209bc4af3d3757 extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.Cone, this.halfHeight = A, this.radius = I;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.cone(this.halfHeight, this.radius);
    }
}
class $204508e5b4b18960$export$fec6094316a593bd extends $204508e5b4b18960$export$6428a7f2611ef1fa {
    constructor(A, I, g){
        super(), this.type = $204508e5b4b18960$export$fc850f719b5599d5.RoundCone, this.halfHeight = A, this.radius = I, this.borderRadius = g;
    }
    intoRaw() {
        return $204508e5b4b18960$var$QA.roundCone(this.halfHeight, this.radius, this.borderRadius);
    }
}
class $204508e5b4b18960$export$f3c42ca1c254a387 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$P;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    step(A, I, g, C, B, Q, E, i, D, o, G, w) {
        let S = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        G ? this.raw.stepWithEvents(S, I.raw, g.raw, C.raw, B.raw, Q.raw, E.raw, i.raw, D.raw, o.raw, G.raw, w, w ? w.filterContactPair : null, w ? w.filterIntersectionPair : null) : this.raw.step(S, I.raw, g.raw, C.raw, B.raw, Q.raw, E.raw, i.raw, D.raw, o.raw), S.free();
    }
}
!function(A) {
    A[A.EXCLUDE_FIXED = 1] = "EXCLUDE_FIXED", A[A.EXCLUDE_KINEMATIC = 2] = "EXCLUDE_KINEMATIC", A[A.EXCLUDE_DYNAMIC = 4] = "EXCLUDE_DYNAMIC", A[A.EXCLUDE_SENSORS = 8] = "EXCLUDE_SENSORS", A[A.EXCLUDE_SOLIDS = 16] = "EXCLUDE_SOLIDS", A[A.ONLY_DYNAMIC = 3] = "ONLY_DYNAMIC", A[A.ONLY_KINEMATIC = 5] = "ONLY_KINEMATIC", A[A.ONLY_FIXED = 6] = "ONLY_FIXED";
}($204508e5b4b18960$export$39a39008025d4cb || ($204508e5b4b18960$export$39a39008025d4cb = {}));
class $204508e5b4b18960$export$636a60a98ff98f0b {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$v;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    update(A, I) {
        this.raw.update(A.raw, I.raw);
    }
    castRay(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.origin), w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.dir), S = $204508e5b4b18960$export$f559542b3fef6583.fromRaw(I, this.raw.castRay(A.raw, I.raw, G, w, C, B, Q, E, i, D, o));
        return G.free(), w.free(), S;
    }
    castRayAndGetNormal(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.origin), w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.dir), S = $204508e5b4b18960$export$bc228139800bb3c.fromRaw(I, this.raw.castRayAndGetNormal(A.raw, I.raw, G, w, C, B, Q, E, i, D, o));
        return G.free(), w.free(), S;
    }
    intersectionsWithRay(A, I, g, C, B, Q, E, i, D, o, G) {
        let w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.origin), S = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g.dir);
        this.raw.intersectionsWithRay(A.raw, I.raw, w, S, C, B, (A)=>Q($204508e5b4b18960$export$bc228139800bb3c.fromRaw(I, A)), E, i, D, o, G), w.free(), S.free();
    }
    intersectionWithShape(A, I, g, C, B, Q, E, i, D, o) {
        let G = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), w = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), S = B.intoRaw(), k = this.raw.intersectionWithShape(A.raw, I.raw, G, w, S, Q, E, i, D, o);
        return G.free(), w.free(), S.free(), k;
    }
    projectPoint(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), G = $204508e5b4b18960$export$fc779dece190555.fromRaw(I, this.raw.projectPoint(A.raw, I.raw, o, C, B, Q, E, i, D));
        return o.free(), G;
    }
    projectPointAndGetFeature(A, I, g, C, B, Q, E, i) {
        let D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), o = $204508e5b4b18960$export$fc779dece190555.fromRaw(I, this.raw.projectPointAndGetFeature(A.raw, I.raw, D, C, B, Q, E, i));
        return D.free(), o;
    }
    intersectionsWithPoint(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g);
        this.raw.intersectionsWithPoint(A.raw, I.raw, o, C, B, Q, E, i, D), o.free();
    }
    castShape(A, I, g, C, B, Q, E, i, D, o, G, w, S, k) {
        let U = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), a = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), K = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(B), h = Q.intoRaw(), J = $204508e5b4b18960$export$e46fe1533b6b9d13.fromRaw(I, this.raw.castShape(A.raw, I.raw, U, a, K, h, E, i, D, o, G, w, S, k));
        return U.free(), a.free(), K.free(), h.free(), J;
    }
    intersectionsWithShape(A, I, g, C, B, Q, E, i, D, o, G) {
        let w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), S = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), k = B.intoRaw();
        this.raw.intersectionsWithShape(A.raw, I.raw, w, S, k, Q, E, i, D, o, G), w.free(), S.free(), k.free();
    }
    collidersWithAabbIntersectingAabb(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.collidersWithAabbIntersectingAabb(C, B, g), C.free(), B.free();
    }
}
class $204508e5b4b18960$export$b54bf36dd1f18c08 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$BA;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    serializeAll(A, I, g, C, B, Q, E, i, D) {
        let o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        const G = this.raw.serializeAll(o, I.raw, g.raw, C.raw, B.raw, Q.raw, E.raw, i.raw, D.raw);
        return o.free(), G;
    }
    deserializeAll(A) {
        return $204508e5b4b18960$export$812cd9544993280d.fromRaw(this.raw.deserializeAll(A));
    }
}
class $204508e5b4b18960$export$354e114f10103d2d {
    constructor(A, I){
        this.vertices = A, this.colors = I;
    }
}
class $204508e5b4b18960$export$acdffcc934f6bc95 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$O;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.vertices = void 0, this.colors = void 0;
    }
    render(A, I, g, C, B) {
        this.raw.render(A.raw, I.raw, g.raw, C.raw, B.raw), this.vertices = this.raw.vertices(), this.colors = this.raw.colors();
    }
}
class $204508e5b4b18960$export$d8a6c60ecc79c6a6 {
}
class $204508e5b4b18960$export$ed5de7d26b924ce3 {
    constructor(A, I, g, C, B){
        this.params = I, this.bodies = g, this.colliders = C, this.queries = B, this.raw = new $204508e5b4b18960$var$f(A), this.rawCharacterCollision = new $204508e5b4b18960$var$t, this._applyImpulsesToDynamicBodies = !1, this._characterMass = null;
    }
    free() {
        this.raw && (this.raw.free(), this.rawCharacterCollision.free()), this.raw = void 0, this.rawCharacterCollision = void 0;
    }
    up() {
        return this.raw.up();
    }
    setUp(A) {
        let I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        return this.raw.setUp(I);
    }
    applyImpulsesToDynamicBodies() {
        return this._applyImpulsesToDynamicBodies;
    }
    setApplyImpulsesToDynamicBodies(A) {
        this._applyImpulsesToDynamicBodies = A;
    }
    characterMass() {
        return this._characterMass;
    }
    setCharacterMass(A) {
        this._characterMass = A;
    }
    offset() {
        return this.raw.offset();
    }
    setOffset(A) {
        this.raw.setOffset(A);
    }
    normalNudgeFactor() {
        return this.raw.normalNudgeFactor();
    }
    setNormalNudgeFactor(A) {
        this.raw.setNormalNudgeFactor(A);
    }
    slideEnabled() {
        return this.raw.slideEnabled();
    }
    setSlideEnabled(A) {
        this.raw.setSlideEnabled(A);
    }
    autostepMaxHeight() {
        return this.raw.autostepMaxHeight();
    }
    autostepMinWidth() {
        return this.raw.autostepMinWidth();
    }
    autostepIncludesDynamicBodies() {
        return this.raw.autostepIncludesDynamicBodies();
    }
    autostepEnabled() {
        return this.raw.autostepEnabled();
    }
    enableAutostep(A, I, g) {
        this.raw.enableAutostep(A, I, g);
    }
    disableAutostep() {
        return this.raw.disableAutostep();
    }
    maxSlopeClimbAngle() {
        return this.raw.maxSlopeClimbAngle();
    }
    setMaxSlopeClimbAngle(A) {
        this.raw.setMaxSlopeClimbAngle(A);
    }
    minSlopeSlideAngle() {
        return this.raw.minSlopeSlideAngle();
    }
    setMinSlopeSlideAngle(A) {
        this.raw.setMinSlopeSlideAngle(A);
    }
    snapToGroundDistance() {
        return this.raw.snapToGroundDistance();
    }
    enableSnapToGround(A) {
        this.raw.enableSnapToGround(A);
    }
    disableSnapToGround() {
        this.raw.disableSnapToGround();
    }
    snapToGroundEnabled() {
        return this.raw.snapToGroundEnabled();
    }
    computeColliderMovement(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.computeColliderMovement(this.params.dt, this.bodies.raw, this.colliders.raw, this.queries.raw, A.handle, Q, this._applyImpulsesToDynamicBodies, this._characterMass, g, C, this.colliders.castClosure(B)), Q.free();
    }
    computedMovement() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.computedMovement());
    }
    computedGrounded() {
        return this.raw.computedGrounded();
    }
    numComputedCollisions() {
        return this.raw.numComputedCollisions();
    }
    computedCollision(A, I) {
        if (this.raw.computedCollision(A, this.rawCharacterCollision)) {
            let A = this.rawCharacterCollision;
            return (I = null != I ? I : new $204508e5b4b18960$export$d8a6c60ecc79c6a6).translationDeltaApplied = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.translationDeltaApplied()), I.translationDeltaRemaining = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.translationDeltaRemaining()), I.toi = A.toi(), I.witness1 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldWitness1()), I.witness2 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldWitness2()), I.normal1 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldNormal1()), I.normal2 = $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.worldNormal2()), I.collider = this.colliders.get(A.handle()), I;
        }
        return null;
    }
}
class $204508e5b4b18960$export$563c60dbc0927729 {
    constructor(A, I, g, C){
        this.raw = new $204508e5b4b18960$var$Z(A.handle), this.bodies = I, this.colliders = g, this.queries = C, this._chassis = A;
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    updateVehicle(A, I, g, C) {
        this.raw.update_vehicle(A, this.bodies.raw, this.colliders.raw, this.queries.raw, I, g, this.colliders.castClosure(C));
    }
    currentVehicleSpeed() {
        return this.raw.current_vehicle_speed();
    }
    chassis() {
        return this._chassis;
    }
    get indexUpAxis() {
        return this.raw.index_up_axis();
    }
    set indexUpAxis(A) {
        this.raw.set_index_up_axis(A);
    }
    get indexForwardAxis() {
        return this.raw.index_forward_axis();
    }
    set setIndexForwardAxis(A) {
        this.raw.set_index_forward_axis(A);
    }
    addWheel(A, I, g, C, B) {
        let Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g);
        this.raw.add_wheel(Q, E, i, C, B), Q.free(), E.free(), i.free();
    }
    numWheels() {
        return this.raw.num_wheels();
    }
    wheelChassisConnectionPointCs(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.wheel_chassis_connection_point_cs(A));
    }
    setWheelChassisConnectionPointCs(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.set_wheel_chassis_connection_point_cs(A, g), g.free();
    }
    wheelSuspensionRestLength(A) {
        return this.raw.wheel_suspension_rest_length(A);
    }
    setWheelSuspensionRestLength(A, I) {
        this.raw.set_wheel_suspension_rest_length(A, I);
    }
    wheelMaxSuspensionTravel(A) {
        return this.raw.wheel_max_suspension_travel(A);
    }
    setWheelMaxSuspensionTravel(A, I) {
        this.raw.set_wheel_max_suspension_travel(A, I);
    }
    wheelRadius(A) {
        return this.raw.wheel_radius(A);
    }
    setWheelRadius(A, I) {
        this.raw.set_wheel_radius(A, I);
    }
    wheelSuspensionStiffness(A) {
        return this.raw.wheel_suspension_stiffness(A);
    }
    setWheelSuspensionStiffness(A, I) {
        this.raw.set_wheel_suspension_stiffness(A, I);
    }
    wheelSuspensionCompression(A) {
        return this.raw.wheel_suspension_compression(A);
    }
    setWheelSuspensionCompression(A, I) {
        this.raw.set_wheel_suspension_compression(A, I);
    }
    wheelSuspensionRelaxation(A) {
        return this.raw.wheel_suspension_relaxation(A);
    }
    setWheelSuspensionRelaxation(A, I) {
        this.raw.set_wheel_suspension_relaxation(A, I);
    }
    wheelMaxSuspensionForce(A) {
        return this.raw.wheel_max_suspension_force(A);
    }
    setWheelMaxSuspensionForce(A, I) {
        this.raw.set_wheel_max_suspension_force(A, I);
    }
    wheelBrake(A) {
        return this.raw.wheel_brake(A);
    }
    setWheelBrake(A, I) {
        this.raw.set_wheel_brake(A, I);
    }
    wheelSteering(A) {
        return this.raw.wheel_steering(A);
    }
    setWheelSteering(A, I) {
        this.raw.set_wheel_steering(A, I);
    }
    wheelEngineForce(A) {
        return this.raw.wheel_engine_force(A);
    }
    setWheelEngineForce(A, I) {
        this.raw.set_wheel_engine_force(A, I);
    }
    wheelDirectionCs(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.wheel_direction_cs(A));
    }
    setWheelDirectionCs(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.set_wheel_direction_cs(A, g), g.free();
    }
    wheelAxleCs(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.wheel_axle_cs(A));
    }
    setWheelAxleCs(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I);
        this.raw.set_wheel_axle_cs(A, g), g.free();
    }
    wheelFrictionSlip(A) {
        return this.raw.wheel_friction_slip(A);
    }
    setWheelFrictionSlip(A, I) {
        this.raw.set_wheel_friction_slip(A, I);
    }
    wheelSideFrictionStiffness(A) {
        return this.raw.wheel_side_friction_stiffness(A);
    }
    setWheelSideFrictionStiffness(A, I) {
        this.raw.set_wheel_side_friction_stiffness(A, I);
    }
    wheelRotation(A) {
        return this.raw.wheel_rotation(A);
    }
    wheelForwardImpulse(A) {
        return this.raw.wheel_forward_impulse(A);
    }
    wheelSideImpulse(A) {
        return this.raw.wheel_side_impulse(A);
    }
    wheelSuspensionForce(A) {
        return this.raw.wheel_suspension_force(A);
    }
    wheelContactNormal(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.wheel_contact_normal_ws(A));
    }
    wheelContactPoint(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.wheel_contact_point_ws(A));
    }
    wheelSuspensionLength(A) {
        return this.raw.wheel_suspension_length(A);
    }
    wheelHardPoint(A) {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.wheel_hard_point_ws(A));
    }
    wheelIsInContact(A) {
        return this.raw.wheel_is_in_contact(A);
    }
    wheelGroundObject(A) {
        return this.colliders.get(this.raw.wheel_ground_object(A));
    }
}
class $204508e5b4b18960$export$812cd9544993280d {
    constructor(A, I, g, C, B, Q, E, i, D, o, G, w, S, k){
        this.gravity = A, this.integrationParameters = new $204508e5b4b18960$export$c22d4691787a8578(I), this.islands = new $204508e5b4b18960$export$129e66920a069ba5(g), this.broadPhase = new $204508e5b4b18960$export$d80423229f8b133(C), this.narrowPhase = new $204508e5b4b18960$export$f7b463e625571e2b(B), this.bodies = new $204508e5b4b18960$export$bd569bf5451ee055(Q), this.colliders = new $204508e5b4b18960$export$8ec69bf37b303313(E), this.impulseJoints = new $204508e5b4b18960$export$7b6f816cee9f25f2(i), this.multibodyJoints = new $204508e5b4b18960$export$b6a38ee363602c2a(D), this.ccdSolver = new $204508e5b4b18960$export$ffc4c782649f077(o), this.queryPipeline = new $204508e5b4b18960$export$636a60a98ff98f0b(G), this.physicsPipeline = new $204508e5b4b18960$export$f3c42ca1c254a387(w), this.serializationPipeline = new $204508e5b4b18960$export$b54bf36dd1f18c08(S), this.debugRenderPipeline = new $204508e5b4b18960$export$acdffcc934f6bc95(k), this.characterControllers = new Set, this.vehicleControllers = new Set, this.impulseJoints.finalizeDeserialization(this.bodies), this.bodies.finalizeDeserialization(this.colliders), this.colliders.finalizeDeserialization(this.bodies);
    }
    free() {
        this.integrationParameters.free(), this.islands.free(), this.broadPhase.free(), this.narrowPhase.free(), this.bodies.free(), this.colliders.free(), this.impulseJoints.free(), this.multibodyJoints.free(), this.ccdSolver.free(), this.queryPipeline.free(), this.physicsPipeline.free(), this.serializationPipeline.free(), this.debugRenderPipeline.free(), this.characterControllers.forEach((A)=>A.free()), this.vehicleControllers.forEach((A)=>A.free()), this.integrationParameters = void 0, this.islands = void 0, this.broadPhase = void 0, this.narrowPhase = void 0, this.bodies = void 0, this.colliders = void 0, this.ccdSolver = void 0, this.impulseJoints = void 0, this.multibodyJoints = void 0, this.queryPipeline = void 0, this.physicsPipeline = void 0, this.serializationPipeline = void 0, this.debugRenderPipeline = void 0, this.characterControllers = void 0, this.vehicleControllers = void 0;
    }
    static fromRaw(A) {
        return A ? new $204508e5b4b18960$export$812cd9544993280d($204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A.takeGravity()), A.takeIntegrationParameters(), A.takeIslandManager(), A.takeBroadPhase(), A.takeNarrowPhase(), A.takeBodies(), A.takeColliders(), A.takeImpulseJoints(), A.takeMultibodyJoints()) : null;
    }
    takeSnapshot() {
        return this.serializationPipeline.serializeAll(this.gravity, this.integrationParameters, this.islands, this.broadPhase, this.narrowPhase, this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints);
    }
    static restoreSnapshot(A) {
        return (new $204508e5b4b18960$export$b54bf36dd1f18c08).deserializeAll(A);
    }
    debugRender() {
        return this.debugRenderPipeline.render(this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints, this.narrowPhase), new $204508e5b4b18960$export$354e114f10103d2d(this.debugRenderPipeline.vertices, this.debugRenderPipeline.colors);
    }
    step(A, I) {
        this.physicsPipeline.step(this.gravity, this.integrationParameters, this.islands, this.broadPhase, this.narrowPhase, this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints, this.ccdSolver, A, I), this.queryPipeline.update(this.bodies, this.colliders);
    }
    propagateModifiedBodyPositionsToColliders() {
        this.bodies.raw.propagateModifiedBodyPositionsToColliders(this.colliders.raw);
    }
    updateSceneQueries() {
        this.propagateModifiedBodyPositionsToColliders(), this.queryPipeline.update(this.bodies, this.colliders);
    }
    get timestep() {
        return this.integrationParameters.dt;
    }
    set timestep(A) {
        this.integrationParameters.dt = A;
    }
    get lengthUnit() {
        return this.integrationParameters.lengthUnit;
    }
    set lengthUnit(A) {
        this.integrationParameters.lengthUnit = A;
    }
    get numSolverIterations() {
        return this.integrationParameters.numSolverIterations;
    }
    set numSolverIterations(A) {
        this.integrationParameters.numSolverIterations = A;
    }
    get numAdditionalFrictionIterations() {
        return this.integrationParameters.numAdditionalFrictionIterations;
    }
    set numAdditionalFrictionIterations(A) {
        this.integrationParameters.numAdditionalFrictionIterations = A;
    }
    get numInternalPgsIterations() {
        return this.integrationParameters.numInternalPgsIterations;
    }
    set numInternalPgsIterations(A) {
        this.integrationParameters.numInternalPgsIterations = A;
    }
    switchToStandardPgsSolver() {
        this.integrationParameters.switchToStandardPgsSolver();
    }
    switchToSmallStepsPgsSolver() {
        this.integrationParameters.switchToSmallStepsPgsSolver();
    }
    switchToSmallStepsPgsSolverWithoutWarmstart() {
        this.integrationParameters.switchToSmallStepsPgsSolverWithoutWarmstart();
    }
    createRigidBody(A) {
        return this.bodies.createRigidBody(this.colliders, A);
    }
    createCharacterController(A) {
        let I = new $204508e5b4b18960$export$ed5de7d26b924ce3(A, this.integrationParameters, this.bodies, this.colliders, this.queryPipeline);
        return this.characterControllers.add(I), I;
    }
    removeCharacterController(A) {
        this.characterControllers.delete(A), A.free();
    }
    createVehicleController(A) {
        let I = new $204508e5b4b18960$export$563c60dbc0927729(A, this.bodies, this.colliders, this.queryPipeline);
        return this.vehicleControllers.add(I), I;
    }
    removeVehicleController(A) {
        this.vehicleControllers.delete(A), A.free();
    }
    createCollider(A, I) {
        let g = I ? I.handle : void 0;
        return this.colliders.createCollider(this.bodies, A, g);
    }
    createImpulseJoint(A, I, g, C) {
        return this.impulseJoints.createJoint(this.bodies, A, I.handle, g.handle, C);
    }
    createMultibodyJoint(A, I, g, C) {
        return this.multibodyJoints.createJoint(A, I.handle, g.handle, C);
    }
    getRigidBody(A) {
        return this.bodies.get(A);
    }
    getCollider(A) {
        return this.colliders.get(A);
    }
    getImpulseJoint(A) {
        return this.impulseJoints.get(A);
    }
    getMultibodyJoint(A) {
        return this.multibodyJoints.get(A);
    }
    removeRigidBody(A) {
        this.bodies && this.bodies.remove(A.handle, this.islands, this.colliders, this.impulseJoints, this.multibodyJoints);
    }
    removeCollider(A, I) {
        this.colliders && this.colliders.remove(A.handle, this.islands, this.bodies, I);
    }
    removeImpulseJoint(A, I) {
        this.impulseJoints && this.impulseJoints.remove(A.handle, I);
    }
    removeMultibodyJoint(A, I) {
        this.impulseJoints && this.multibodyJoints.remove(A.handle, I);
    }
    forEachCollider(A) {
        this.colliders.forEach(A);
    }
    forEachRigidBody(A) {
        this.bodies.forEach(A);
    }
    forEachActiveRigidBody(A) {
        this.bodies.forEachActiveRigidBody(this.islands, A);
    }
    castRay(A, I, g, C, B, Q, E, i) {
        return this.queryPipeline.castRay(this.bodies, this.colliders, A, I, g, C, B, Q ? Q.handle : null, E ? E.handle : null, this.colliders.castClosure(i));
    }
    castRayAndGetNormal(A, I, g, C, B, Q, E, i) {
        return this.queryPipeline.castRayAndGetNormal(this.bodies, this.colliders, A, I, g, C, B, Q ? Q.handle : null, E ? E.handle : null, this.colliders.castClosure(i));
    }
    intersectionsWithRay(A, I, g, C, B, Q, E, i, D) {
        this.queryPipeline.intersectionsWithRay(this.bodies, this.colliders, A, I, g, C, B, Q, E ? E.handle : null, i ? i.handle : null, this.colliders.castClosure(D));
    }
    intersectionWithShape(A, I, g, C, B, Q, E, i) {
        let D = this.queryPipeline.intersectionWithShape(this.bodies, this.colliders, A, I, g, C, B, Q ? Q.handle : null, E ? E.handle : null, this.colliders.castClosure(i));
        return null != D ? this.colliders.get(D) : null;
    }
    projectPoint(A, I, g, C, B, Q, E) {
        return this.queryPipeline.projectPoint(this.bodies, this.colliders, A, I, g, C, B ? B.handle : null, Q ? Q.handle : null, this.colliders.castClosure(E));
    }
    projectPointAndGetFeature(A, I, g, C, B, Q) {
        return this.queryPipeline.projectPointAndGetFeature(this.bodies, this.colliders, A, I, g, C ? C.handle : null, B ? B.handle : null, this.colliders.castClosure(Q));
    }
    intersectionsWithPoint(A, I, g, C, B, Q, E) {
        this.queryPipeline.intersectionsWithPoint(this.bodies, this.colliders, A, this.colliders.castClosure(I), g, C, B ? B.handle : null, Q ? Q.handle : null, this.colliders.castClosure(E));
    }
    castShape(A, I, g, C, B, Q, E, i, D, o, G, w) {
        return this.queryPipeline.castShape(this.bodies, this.colliders, A, I, g, C, B, Q, E, i, D, o ? o.handle : null, G ? G.handle : null, this.colliders.castClosure(w));
    }
    intersectionsWithShape(A, I, g, C, B, Q, E, i, D) {
        this.queryPipeline.intersectionsWithShape(this.bodies, this.colliders, A, I, g, this.colliders.castClosure(C), B, Q, E ? E.handle : null, i ? i.handle : null, this.colliders.castClosure(D));
    }
    collidersWithAabbIntersectingAabb(A, I, g) {
        this.queryPipeline.collidersWithAabbIntersectingAabb(A, I, this.colliders.castClosure(g));
    }
    contactPairsWith(A, I) {
        this.narrowPhase.contactPairsWith(A.handle, this.colliders.castClosure(I));
    }
    intersectionPairsWith(A, I) {
        this.narrowPhase.intersectionPairsWith(A.handle, this.colliders.castClosure(I));
    }
    contactPair(A, I, g) {
        this.narrowPhase.contactPair(A.handle, I.handle, g);
    }
    intersectionPair(A, I) {
        return this.narrowPhase.intersectionPair(A.handle, I.handle);
    }
}
!function(A) {
    A[A.NONE = 0] = "NONE", A[A.COLLISION_EVENTS = 1] = "COLLISION_EVENTS", A[A.CONTACT_FORCE_EVENTS = 2] = "CONTACT_FORCE_EVENTS";
}($204508e5b4b18960$export$f28998d26d157fd3 || ($204508e5b4b18960$export$f28998d26d157fd3 = {}));
class $204508e5b4b18960$export$cba99c196a0dcc61 {
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    collider1() {
        return this.raw.collider1();
    }
    collider2() {
        return this.raw.collider2();
    }
    totalForce() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.total_force());
    }
    totalForceMagnitude() {
        return this.raw.total_force_magnitude();
    }
    maxForceDirection() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.raw.max_force_direction());
    }
    maxForceMagnitude() {
        return this.raw.max_force_magnitude();
    }
}
class $204508e5b4b18960$export$2fc6338444a158e6 {
    constructor(A, I){
        this.raw = I || new $204508e5b4b18960$var$b(A);
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0;
    }
    drainCollisionEvents(A) {
        this.raw.drainCollisionEvents(A);
    }
    drainContactForceEvents(A) {
        let I = new $204508e5b4b18960$export$cba99c196a0dcc61;
        this.raw.drainContactForceEvents((g)=>{
            I.raw = g, A(I), I.free();
        });
    }
    clear() {
        this.raw.clear();
    }
}
!function(A) {
    A[A.NONE = 0] = "NONE", A[A.FILTER_CONTACT_PAIRS = 1] = "FILTER_CONTACT_PAIRS", A[A.FILTER_INTERSECTION_PAIRS = 2] = "FILTER_INTERSECTION_PAIRS";
}($204508e5b4b18960$export$194d8ad9e2dc63e8 || ($204508e5b4b18960$export$194d8ad9e2dc63e8 = {})), function(A) {
    A[A.EMPTY = 0] = "EMPTY", A[A.COMPUTE_IMPULSE = 1] = "COMPUTE_IMPULSE";
}($204508e5b4b18960$export$d50a7c063745a562 || ($204508e5b4b18960$export$d50a7c063745a562 = {})), function(A) {
    A[A.DYNAMIC_DYNAMIC = 1] = "DYNAMIC_DYNAMIC", A[A.DYNAMIC_KINEMATIC = 12] = "DYNAMIC_KINEMATIC", A[A.DYNAMIC_FIXED = 2] = "DYNAMIC_FIXED", A[A.KINEMATIC_KINEMATIC = 52224] = "KINEMATIC_KINEMATIC", A[A.KINEMATIC_FIXED = 8704] = "KINEMATIC_FIXED", A[A.FIXED_FIXED = 32] = "FIXED_FIXED", A[A.DEFAULT = 15] = "DEFAULT", A[A.ALL = 60943] = "ALL";
}($204508e5b4b18960$export$822f84f0c1c58b2a || ($204508e5b4b18960$export$822f84f0c1c58b2a = {}));
class $204508e5b4b18960$export$b7c6eef0ebb06133 {
    constructor(A, I, g, C){
        this.colliderSet = A, this.handle = I, this._parent = g, this._shape = C;
    }
    finalizeDeserialization(A) {
        null != this.handle && (this._parent = A.get(this.colliderSet.raw.coParent(this.handle)));
    }
    ensureShapeIsCached() {
        this._shape || (this._shape = $204508e5b4b18960$export$6428a7f2611ef1fa.fromRaw(this.colliderSet.raw, this.handle));
    }
    get shape() {
        return this.ensureShapeIsCached(), this._shape;
    }
    isValid() {
        return this.colliderSet.raw.contains(this.handle);
    }
    translation() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.colliderSet.raw.coTranslation(this.handle));
    }
    rotation() {
        return $204508e5b4b18960$export$824960640e91b57.fromRaw(this.colliderSet.raw.coRotation(this.handle));
    }
    isSensor() {
        return this.colliderSet.raw.coIsSensor(this.handle);
    }
    setSensor(A) {
        this.colliderSet.raw.coSetSensor(this.handle, A);
    }
    setShape(A) {
        let I = A.intoRaw();
        this.colliderSet.raw.coSetShape(this.handle, I), I.free(), this._shape = A;
    }
    setEnabled(A) {
        this.colliderSet.raw.coSetEnabled(this.handle, A);
    }
    isEnabled() {
        return this.colliderSet.raw.coIsEnabled(this.handle);
    }
    setRestitution(A) {
        this.colliderSet.raw.coSetRestitution(this.handle, A);
    }
    setFriction(A) {
        this.colliderSet.raw.coSetFriction(this.handle, A);
    }
    frictionCombineRule() {
        return this.colliderSet.raw.coFrictionCombineRule(this.handle);
    }
    setFrictionCombineRule(A) {
        this.colliderSet.raw.coSetFrictionCombineRule(this.handle, A);
    }
    restitutionCombineRule() {
        return this.colliderSet.raw.coRestitutionCombineRule(this.handle);
    }
    setRestitutionCombineRule(A) {
        this.colliderSet.raw.coSetRestitutionCombineRule(this.handle, A);
    }
    setCollisionGroups(A) {
        this.colliderSet.raw.coSetCollisionGroups(this.handle, A);
    }
    setSolverGroups(A) {
        this.colliderSet.raw.coSetSolverGroups(this.handle, A);
    }
    contactSkin() {
        return this.colliderSet.raw.coContactSkin(this.handle);
    }
    setContactSkin(A) {
        return this.colliderSet.raw.coSetContactSkin(this.handle, A);
    }
    activeHooks() {
        return this.colliderSet.raw.coActiveHooks(this.handle);
    }
    setActiveHooks(A) {
        this.colliderSet.raw.coSetActiveHooks(this.handle, A);
    }
    activeEvents() {
        return this.colliderSet.raw.coActiveEvents(this.handle);
    }
    setActiveEvents(A) {
        this.colliderSet.raw.coSetActiveEvents(this.handle, A);
    }
    activeCollisionTypes() {
        return this.colliderSet.raw.coActiveCollisionTypes(this.handle);
    }
    setContactForceEventThreshold(A) {
        return this.colliderSet.raw.coSetContactForceEventThreshold(this.handle, A);
    }
    contactForceEventThreshold() {
        return this.colliderSet.raw.coContactForceEventThreshold(this.handle);
    }
    setActiveCollisionTypes(A) {
        this.colliderSet.raw.coSetActiveCollisionTypes(this.handle, A);
    }
    setDensity(A) {
        this.colliderSet.raw.coSetDensity(this.handle, A);
    }
    setMass(A) {
        this.colliderSet.raw.coSetMass(this.handle, A);
    }
    setMassProperties(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(C);
        this.colliderSet.raw.coSetMassProperties(this.handle, A, B, Q, E), B.free(), Q.free(), E.free();
    }
    setTranslation(A) {
        this.colliderSet.raw.coSetTranslation(this.handle, A.x, A.y, A.z);
    }
    setTranslationWrtParent(A) {
        this.colliderSet.raw.coSetTranslationWrtParent(this.handle, A.x, A.y, A.z);
    }
    setRotation(A) {
        this.colliderSet.raw.coSetRotation(this.handle, A.x, A.y, A.z, A.w);
    }
    setRotationWrtParent(A) {
        this.colliderSet.raw.coSetRotationWrtParent(this.handle, A.x, A.y, A.z, A.w);
    }
    shapeType() {
        return this.colliderSet.raw.coShapeType(this.handle);
    }
    halfExtents() {
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(this.colliderSet.raw.coHalfExtents(this.handle));
    }
    setHalfExtents(A) {
        const I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A);
        this.colliderSet.raw.coSetHalfExtents(this.handle, I);
    }
    radius() {
        return this.colliderSet.raw.coRadius(this.handle);
    }
    setRadius(A) {
        this.colliderSet.raw.coSetRadius(this.handle, A);
    }
    roundRadius() {
        return this.colliderSet.raw.coRoundRadius(this.handle);
    }
    setRoundRadius(A) {
        this.colliderSet.raw.coSetRoundRadius(this.handle, A);
    }
    halfHeight() {
        return this.colliderSet.raw.coHalfHeight(this.handle);
    }
    setHalfHeight(A) {
        this.colliderSet.raw.coSetHalfHeight(this.handle, A);
    }
    vertices() {
        return this.colliderSet.raw.coVertices(this.handle);
    }
    indices() {
        return this.colliderSet.raw.coIndices(this.handle);
    }
    heightfieldHeights() {
        return this.colliderSet.raw.coHeightfieldHeights(this.handle);
    }
    heightfieldScale() {
        let A = this.colliderSet.raw.coHeightfieldScale(this.handle);
        return $204508e5b4b18960$export$e2f642242c040d8f.fromRaw(A);
    }
    heightfieldNRows() {
        return this.colliderSet.raw.coHeightfieldNRows(this.handle);
    }
    heightfieldNCols() {
        return this.colliderSet.raw.coHeightfieldNCols(this.handle);
    }
    parent() {
        return this._parent;
    }
    friction() {
        return this.colliderSet.raw.coFriction(this.handle);
    }
    restitution() {
        return this.colliderSet.raw.coRestitution(this.handle);
    }
    density() {
        return this.colliderSet.raw.coDensity(this.handle);
    }
    mass() {
        return this.colliderSet.raw.coMass(this.handle);
    }
    volume() {
        return this.colliderSet.raw.coVolume(this.handle);
    }
    collisionGroups() {
        return this.colliderSet.raw.coCollisionGroups(this.handle);
    }
    solverGroups() {
        return this.colliderSet.raw.coSolverGroups(this.handle);
    }
    containsPoint(A) {
        let I = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), g = this.colliderSet.raw.coContainsPoint(this.handle, I);
        return I.free(), g;
    }
    projectPoint(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), C = $204508e5b4b18960$export$5e813b027a709134.fromRaw(this.colliderSet.raw.coProjectPoint(this.handle, g, I));
        return g.free(), C;
    }
    intersectsRay(A, I) {
        let g = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), B = this.colliderSet.raw.coIntersectsRay(this.handle, g, C, I);
        return g.free(), C.free(), B;
    }
    castShape(A, I, g, C, B, Q, E, i) {
        let D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), o = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), G = $204508e5b4b18960$export$824960640e91b57.intoRaw(C), w = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(B), S = I.intoRaw(), k = $204508e5b4b18960$export$2f19b12a78c879bd.fromRaw(this.colliderSet, this.colliderSet.raw.coCastShape(this.handle, D, S, o, G, w, Q, E, i));
        return D.free(), o.free(), G.free(), w.free(), S.free(), k;
    }
    castCollider(A, I, g, C, B, Q) {
        let E = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(g), D = $204508e5b4b18960$export$e46fe1533b6b9d13.fromRaw(this.colliderSet, this.colliderSet.raw.coCastCollider(this.handle, E, I.handle, i, C, B, Q));
        return E.free(), i.free(), D;
    }
    intersectsShape(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), B = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), Q = A.intoRaw(), E = this.colliderSet.raw.coIntersectsShape(this.handle, Q, C, B);
        return C.free(), B.free(), Q.free(), E;
    }
    contactShape(A, I, g, C) {
        let B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I), Q = $204508e5b4b18960$export$824960640e91b57.intoRaw(g), E = A.intoRaw(), i = $204508e5b4b18960$export$1d7ee127e07c91bb.fromRaw(this.colliderSet.raw.coContactShape(this.handle, E, B, Q, C));
        return B.free(), Q.free(), E.free(), i;
    }
    contactCollider(A, I) {
        return $204508e5b4b18960$export$1d7ee127e07c91bb.fromRaw(this.colliderSet.raw.coContactCollider(this.handle, A.handle, I));
    }
    castRay(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), Q = this.colliderSet.raw.coCastRay(this.handle, C, B, I, g);
        return C.free(), B.free(), Q;
    }
    castRayAndGetNormal(A, I, g) {
        let C = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.origin), B = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(A.dir), Q = $204508e5b4b18960$export$292489680db6ed3f.fromRaw(this.colliderSet.raw.coCastRayAndGetNormal(this.handle, C, B, I, g));
        return C.free(), B.free(), Q;
    }
}
!function(A) {
    A[A.Density = 0] = "Density", A[A.Mass = 1] = "Mass", A[A.MassProps = 2] = "MassProps";
}($204508e5b4b18960$export$9d99ce4bda7104cf || ($204508e5b4b18960$export$9d99ce4bda7104cf = {}));
class $204508e5b4b18960$export$7d4cec221ee36947 {
    constructor(A){
        this.enabled = !0, this.shape = A, this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.Density, this.density = 1, this.friction = .5, this.restitution = 0, this.rotation = $204508e5b4b18960$export$824960640e91b57.identity(), this.translation = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.isSensor = !1, this.collisionGroups = 4294967295, this.solverGroups = 4294967295, this.frictionCombineRule = $204508e5b4b18960$export$5d7f3962eb4528af.Average, this.restitutionCombineRule = $204508e5b4b18960$export$5d7f3962eb4528af.Average, this.activeCollisionTypes = $204508e5b4b18960$export$822f84f0c1c58b2a.DEFAULT, this.activeEvents = $204508e5b4b18960$export$f28998d26d157fd3.NONE, this.activeHooks = $204508e5b4b18960$export$194d8ad9e2dc63e8.NONE, this.mass = 0, this.centerOfMass = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.contactForceEventThreshold = 0, this.contactSkin = 0, this.principalAngularInertia = $204508e5b4b18960$export$e2f642242c040d8f.zeros(), this.angularInertiaLocalFrame = $204508e5b4b18960$export$824960640e91b57.identity();
    }
    static ball(A) {
        const I = new $204508e5b4b18960$export$a83d7c3fa53790c9(A);
        return new $204508e5b4b18960$export$7d4cec221ee36947(I);
    }
    static capsule(A, I) {
        const g = new $204508e5b4b18960$export$28bdb8fc07bf3804(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static segment(A, I) {
        const g = new $204508e5b4b18960$export$d53aa5c5ab432700(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static triangle(A, I, g) {
        const C = new $204508e5b4b18960$export$5a465592bfe74b48(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static roundTriangle(A, I, g, C) {
        const B = new $204508e5b4b18960$export$5d38c33920824fab(A, I, g, C);
        return new $204508e5b4b18960$export$7d4cec221ee36947(B);
    }
    static polyline(A, I) {
        const g = new $204508e5b4b18960$export$79f3ee03e63e7073(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static trimesh(A, I, g) {
        const C = new $204508e5b4b18960$export$16df86f06e459b09(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static cuboid(A, I, g) {
        const C = new $204508e5b4b18960$export$c8821cc685709b7b(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static roundCuboid(A, I, g, C) {
        const B = new $204508e5b4b18960$export$c87d2c121efe06ab(A, I, g, C);
        return new $204508e5b4b18960$export$7d4cec221ee36947(B);
    }
    static heightfield(A, I, g, C, B) {
        const Q = new $204508e5b4b18960$export$fa360b5b58f475b7(A, I, g, C, B);
        return new $204508e5b4b18960$export$7d4cec221ee36947(Q);
    }
    static cylinder(A, I) {
        const g = new $204508e5b4b18960$export$665c37f020fe48f9(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundCylinder(A, I, g) {
        const C = new $204508e5b4b18960$export$6fe70449556bd1bd(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static cone(A, I) {
        const g = new $204508e5b4b18960$export$22209bc4af3d3757(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundCone(A, I, g) {
        const C = new $204508e5b4b18960$export$fec6094316a593bd(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    static convexHull(A) {
        const I = new $204508e5b4b18960$export$7c637a75bc263948(A, null);
        return new $204508e5b4b18960$export$7d4cec221ee36947(I);
    }
    static convexMesh(A, I) {
        const g = new $204508e5b4b18960$export$7c637a75bc263948(A, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundConvexHull(A, I) {
        const g = new $204508e5b4b18960$export$f9ecc9020d30774f(A, null, I);
        return new $204508e5b4b18960$export$7d4cec221ee36947(g);
    }
    static roundConvexMesh(A, I, g) {
        const C = new $204508e5b4b18960$export$f9ecc9020d30774f(A, I, g);
        return new $204508e5b4b18960$export$7d4cec221ee36947(C);
    }
    setTranslation(A, I, g) {
        if ("number" != typeof A || "number" != typeof I || "number" != typeof g) throw TypeError("The translation components must be numbers.");
        return this.translation = {
            x: A,
            y: I,
            z: g
        }, this;
    }
    setRotation(A) {
        return $204508e5b4b18960$export$824960640e91b57.copy(this.rotation, A), this;
    }
    setSensor(A) {
        return this.isSensor = A, this;
    }
    setEnabled(A) {
        return this.enabled = A, this;
    }
    setContactSkin(A) {
        return this.contactSkin = A, this;
    }
    setDensity(A) {
        return this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.Density, this.density = A, this;
    }
    setMass(A) {
        return this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.Mass, this.mass = A, this;
    }
    setMassProperties(A, I, g, C) {
        return this.massPropsMode = $204508e5b4b18960$export$9d99ce4bda7104cf.MassProps, this.mass = A, $204508e5b4b18960$export$e2f642242c040d8f.copy(this.centerOfMass, I), $204508e5b4b18960$export$e2f642242c040d8f.copy(this.principalAngularInertia, g), $204508e5b4b18960$export$824960640e91b57.copy(this.angularInertiaLocalFrame, C), this;
    }
    setRestitution(A) {
        return this.restitution = A, this;
    }
    setFriction(A) {
        return this.friction = A, this;
    }
    setFrictionCombineRule(A) {
        return this.frictionCombineRule = A, this;
    }
    setRestitutionCombineRule(A) {
        return this.restitutionCombineRule = A, this;
    }
    setCollisionGroups(A) {
        return this.collisionGroups = A, this;
    }
    setSolverGroups(A) {
        return this.solverGroups = A, this;
    }
    setActiveHooks(A) {
        return this.activeHooks = A, this;
    }
    setActiveEvents(A) {
        return this.activeEvents = A, this;
    }
    setActiveCollisionTypes(A) {
        return this.activeCollisionTypes = A, this;
    }
    setContactForceEventThreshold(A) {
        return this.contactForceEventThreshold = A, this;
    }
}
class $204508e5b4b18960$export$8ec69bf37b303313 {
    constructor(A){
        this.raw = A || new $204508e5b4b18960$var$p, this.map = new $204508e5b4b18960$var$eA, A && A.forEachColliderHandle((A)=>{
            this.map.set(A, new $204508e5b4b18960$export$b7c6eef0ebb06133(this, A, null));
        });
    }
    free() {
        this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
    }
    castClosure(A) {
        return (I)=>A ? A(this.get(I)) : void 0;
    }
    finalizeDeserialization(A) {
        this.map.forEach((I)=>I.finalizeDeserialization(A));
    }
    createCollider(A, I, g) {
        let C = null != g && null != g;
        if (C && isNaN(g)) throw Error("Cannot create a collider with a parent rigid-body handle that is not a number.");
        let B = I.shape.intoRaw(), Q = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.translation), E = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.rotation), i = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.centerOfMass), D = $204508e5b4b18960$export$e2f642242c040d8f.intoRaw(I.principalAngularInertia), o = $204508e5b4b18960$export$824960640e91b57.intoRaw(I.angularInertiaLocalFrame), G = this.raw.createCollider(I.enabled, B, Q, E, I.massPropsMode, I.mass, i, D, o, I.density, I.friction, I.restitution, I.frictionCombineRule, I.restitutionCombineRule, I.isSensor, I.collisionGroups, I.solverGroups, I.activeCollisionTypes, I.activeHooks, I.activeEvents, I.contactForceEventThreshold, I.contactSkin, C, C ? g : 0, A.raw);
        B.free(), Q.free(), E.free(), i.free(), D.free(), o.free();
        let w = C ? A.get(g) : null, S = new $204508e5b4b18960$export$b7c6eef0ebb06133(this, G, w, I.shape);
        return this.map.set(G, S), S;
    }
    remove(A, I, g, C) {
        this.raw.remove(A, I.raw, g.raw, C), this.unmap(A);
    }
    unmap(A) {
        this.map.delete(A);
    }
    get(A) {
        return this.map.get(A);
    }
    len() {
        return this.map.len();
    }
    contains(A) {
        return null != this.get(A);
    }
    forEach(A) {
        this.map.forEach(A);
    }
    getAll() {
        return this.map.getAll();
    }
}
function $204508e5b4b18960$var$VI(A, I, g, C) {
    return new (g || (g = Promise))(function(B, Q) {
        function E(A) {
            try {
                D(C.next(A));
            } catch (A) {
                Q(A);
            }
        }
        function i(A) {
            try {
                D(C.throw(A));
            } catch (A) {
                Q(A);
            }
        }
        function D(A) {
            var I;
            A.done ? B(A.value) : (I = A.value, I instanceof g ? I : new g(function(A) {
                A(I);
            })).then(E, i);
        }
        D((C = C.apply(A, I || [])).next());
    });
}
for(var $204508e5b4b18960$var$XI = {
    byteLength: function(A) {
        var I = $204508e5b4b18960$var$Ag(A), g = I[0], C = I[1];
        return 3 * (g + C) / 4 - C;
    },
    toByteArray: function(A) {
        var I, g, C = $204508e5b4b18960$var$Ag(A), B = C[0], Q = C[1], E = new $204508e5b4b18960$var$zI(function(A, I, g) {
            return 3 * (I + g) / 4 - g;
        }(0, B, Q)), i = 0, D = Q > 0 ? B - 4 : B;
        for(g = 0; g < D; g += 4)I = $204508e5b4b18960$var$uI[A.charCodeAt(g)] << 18 | $204508e5b4b18960$var$uI[A.charCodeAt(g + 1)] << 12 | $204508e5b4b18960$var$uI[A.charCodeAt(g + 2)] << 6 | $204508e5b4b18960$var$uI[A.charCodeAt(g + 3)], E[i++] = I >> 16 & 255, E[i++] = I >> 8 & 255, E[i++] = 255 & I;
        2 === Q && (I = $204508e5b4b18960$var$uI[A.charCodeAt(g)] << 2 | $204508e5b4b18960$var$uI[A.charCodeAt(g + 1)] >> 4, E[i++] = 255 & I);
        1 === Q && (I = $204508e5b4b18960$var$uI[A.charCodeAt(g)] << 10 | $204508e5b4b18960$var$uI[A.charCodeAt(g + 1)] << 4 | $204508e5b4b18960$var$uI[A.charCodeAt(g + 2)] >> 2, E[i++] = I >> 8 & 255, E[i++] = 255 & I);
        return E;
    },
    fromByteArray: function(A) {
        for(var I, g = A.length, C = g % 3, B = [], Q = 16383, E = 0, i = g - C; E < i; E += Q)B.push($204508e5b4b18960$var$Ig(A, E, E + Q > i ? i : E + Q));
        1 === C ? (I = A[g - 1], B.push($204508e5b4b18960$var$PI[I >> 2] + $204508e5b4b18960$var$PI[I << 4 & 63] + "==")) : 2 === C && (I = (A[g - 2] << 8) + A[g - 1], B.push($204508e5b4b18960$var$PI[I >> 10] + $204508e5b4b18960$var$PI[I >> 4 & 63] + $204508e5b4b18960$var$PI[I << 2 & 63] + "="));
        return B.join("");
    }
}, $204508e5b4b18960$var$PI = [], $204508e5b4b18960$var$uI = [], $204508e5b4b18960$var$zI = "undefined" != typeof Uint8Array ? Uint8Array : Array, $204508e5b4b18960$var$vI = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $204508e5b4b18960$var$_I = 0, $204508e5b4b18960$var$$I = $204508e5b4b18960$var$vI.length; $204508e5b4b18960$var$_I < $204508e5b4b18960$var$$I; ++$204508e5b4b18960$var$_I)$204508e5b4b18960$var$PI[$204508e5b4b18960$var$_I] = $204508e5b4b18960$var$vI[$204508e5b4b18960$var$_I], $204508e5b4b18960$var$uI[$204508e5b4b18960$var$vI.charCodeAt($204508e5b4b18960$var$_I)] = $204508e5b4b18960$var$_I;
function $204508e5b4b18960$var$Ag(A) {
    var I = A.length;
    if (I % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var g = A.indexOf("=");
    return -1 === g && (g = I), [
        g,
        g === I ? 0 : 4 - g % 4
    ];
}
function $204508e5b4b18960$var$Ig(A, I, g) {
    for(var C, B, Q = [], E = I; E < g; E += 3)C = (A[E] << 16 & 16711680) + (A[E + 1] << 8 & 65280) + (255 & A[E + 2]), Q.push($204508e5b4b18960$var$PI[(B = C) >> 18 & 63] + $204508e5b4b18960$var$PI[B >> 12 & 63] + $204508e5b4b18960$var$PI[B >> 6 & 63] + $204508e5b4b18960$var$PI[63 & B]);
    return Q.join("");
}
function $204508e5b4b18960$export$2cd8252107eb640b() {
    return $204508e5b4b18960$var$VI(this, void 0, void 0, function*() {
        yield $204508e5b4b18960$var$oA($204508e5b4b18960$var$XI.toByteArray("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").buffer);
    });
}
function $204508e5b4b18960$export$83d89fbfd8236492() {
    return function() {
        let I, g;
        try {
            const Q = $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(-16);
            $204508e5b4b18960$var$A.version(Q);
            var C = $204508e5b4b18960$var$G()[Q / 4 + 0], B = $204508e5b4b18960$var$G()[Q / 4 + 1];
            return I = C, g = B, $204508e5b4b18960$var$k(C, B);
        } finally{
            $204508e5b4b18960$var$A.__wbindgen_add_to_stack_pointer(16), $204508e5b4b18960$var$A.__wbindgen_free(I, g, 1);
        }
    }();
}
$204508e5b4b18960$var$uI["-".charCodeAt(0)] = 62, $204508e5b4b18960$var$uI["_".charCodeAt(0)] = 63;
var $204508e5b4b18960$export$2e2bcd8739ae039 = Object.freeze({
    __proto__: null,
    version: $204508e5b4b18960$export$83d89fbfd8236492,
    Vector3: $204508e5b4b18960$export$64b5c384219d3699,
    VectorOps: $204508e5b4b18960$export$e2f642242c040d8f,
    Quaternion: $204508e5b4b18960$export$23d6a54f0bbc85a3,
    RotationOps: $204508e5b4b18960$export$824960640e91b57,
    SdpMatrix3: $204508e5b4b18960$export$a634d4178dd6cfce,
    SdpMatrix3Ops: $204508e5b4b18960$export$afeef1d10fc8a4f3,
    get RigidBodyType () {
        return $204508e5b4b18960$export$9df1fa60cce90854;
    },
    RigidBody: $204508e5b4b18960$export$41c0a739a32ac4d,
    RigidBodyDesc: $204508e5b4b18960$export$105dcb996a5d3c42,
    RigidBodySet: $204508e5b4b18960$export$bd569bf5451ee055,
    IntegrationParameters: $204508e5b4b18960$export$c22d4691787a8578,
    get JointType () {
        return $204508e5b4b18960$export$d8c34c2371473e33;
    },
    get MotorModel () {
        return $204508e5b4b18960$export$9fe5861f16a3846f;
    },
    get JointAxesMask () {
        return $204508e5b4b18960$export$9fb152d4b46f94ce;
    },
    ImpulseJoint: $204508e5b4b18960$export$13616a6dfa0c261e,
    UnitImpulseJoint: $204508e5b4b18960$export$b6c446c752acb453,
    FixedImpulseJoint: $204508e5b4b18960$export$13a2c1429de97fd0,
    RopeImpulseJoint: $204508e5b4b18960$export$21cd30e53afbf3c1,
    SpringImpulseJoint: $204508e5b4b18960$export$6a104d5406ced20,
    PrismaticImpulseJoint: $204508e5b4b18960$export$ca91224fa01cc4c5,
    RevoluteImpulseJoint: $204508e5b4b18960$export$f21c6aedecbeb53d,
    GenericImpulseJoint: $204508e5b4b18960$export$9c43d159fbe4a60,
    SphericalImpulseJoint: $204508e5b4b18960$export$da358565907d92be,
    JointData: $204508e5b4b18960$export$9ad4996060073eaa,
    ImpulseJointSet: $204508e5b4b18960$export$7b6f816cee9f25f2,
    MultibodyJoint: $204508e5b4b18960$export$9f6b52d8d09f7b72,
    UnitMultibodyJoint: $204508e5b4b18960$export$b677e6fe6c6cb994,
    FixedMultibodyJoint: $204508e5b4b18960$export$6984fd596a92ce33,
    PrismaticMultibodyJoint: $204508e5b4b18960$export$1ac8e4ec1713e3da,
    RevoluteMultibodyJoint: $204508e5b4b18960$export$e2bca3ac97ae239e,
    SphericalMultibodyJoint: $204508e5b4b18960$export$b9ffb05588678855,
    MultibodyJointSet: $204508e5b4b18960$export$b6a38ee363602c2a,
    get CoefficientCombineRule () {
        return $204508e5b4b18960$export$5d7f3962eb4528af;
    },
    CCDSolver: $204508e5b4b18960$export$ffc4c782649f077,
    IslandManager: $204508e5b4b18960$export$129e66920a069ba5,
    BroadPhase: $204508e5b4b18960$export$d80423229f8b133,
    NarrowPhase: $204508e5b4b18960$export$f7b463e625571e2b,
    TempContactManifold: $204508e5b4b18960$export$7ac890e03fe91616,
    Shape: $204508e5b4b18960$export$6428a7f2611ef1fa,
    get ShapeType () {
        return $204508e5b4b18960$export$fc850f719b5599d5;
    },
    get HeightFieldFlags () {
        return $204508e5b4b18960$export$1a49384a8815c6a9;
    },
    get TriMeshFlags () {
        return $204508e5b4b18960$export$5dbdc437333f52f1;
    },
    Ball: $204508e5b4b18960$export$a83d7c3fa53790c9,
    HalfSpace: $204508e5b4b18960$export$b774d5dd1a533096,
    Cuboid: $204508e5b4b18960$export$c8821cc685709b7b,
    RoundCuboid: $204508e5b4b18960$export$c87d2c121efe06ab,
    Capsule: $204508e5b4b18960$export$28bdb8fc07bf3804,
    Segment: $204508e5b4b18960$export$d53aa5c5ab432700,
    Triangle: $204508e5b4b18960$export$5a465592bfe74b48,
    RoundTriangle: $204508e5b4b18960$export$5d38c33920824fab,
    Polyline: $204508e5b4b18960$export$79f3ee03e63e7073,
    TriMesh: $204508e5b4b18960$export$16df86f06e459b09,
    ConvexPolyhedron: $204508e5b4b18960$export$7c637a75bc263948,
    RoundConvexPolyhedron: $204508e5b4b18960$export$f9ecc9020d30774f,
    Heightfield: $204508e5b4b18960$export$fa360b5b58f475b7,
    Cylinder: $204508e5b4b18960$export$665c37f020fe48f9,
    RoundCylinder: $204508e5b4b18960$export$6fe70449556bd1bd,
    Cone: $204508e5b4b18960$export$22209bc4af3d3757,
    RoundCone: $204508e5b4b18960$export$fec6094316a593bd,
    get ActiveCollisionTypes () {
        return $204508e5b4b18960$export$822f84f0c1c58b2a;
    },
    Collider: $204508e5b4b18960$export$b7c6eef0ebb06133,
    get MassPropsMode () {
        return $204508e5b4b18960$export$9d99ce4bda7104cf;
    },
    ColliderDesc: $204508e5b4b18960$export$7d4cec221ee36947,
    ColliderSet: $204508e5b4b18960$export$8ec69bf37b303313,
    get FeatureType () {
        return $204508e5b4b18960$export$c40deacab7e2491c;
    },
    Ray: $204508e5b4b18960$export$a186db52eed6d40e,
    RayIntersection: $204508e5b4b18960$export$292489680db6ed3f,
    RayColliderIntersection: $204508e5b4b18960$export$bc228139800bb3c,
    RayColliderHit: $204508e5b4b18960$export$f559542b3fef6583,
    PointProjection: $204508e5b4b18960$export$5e813b027a709134,
    PointColliderProjection: $204508e5b4b18960$export$fc779dece190555,
    ShapeCastHit: $204508e5b4b18960$export$2f19b12a78c879bd,
    ColliderShapeCastHit: $204508e5b4b18960$export$e46fe1533b6b9d13,
    ShapeContact: $204508e5b4b18960$export$1d7ee127e07c91bb,
    World: $204508e5b4b18960$export$812cd9544993280d,
    PhysicsPipeline: $204508e5b4b18960$export$f3c42ca1c254a387,
    SerializationPipeline: $204508e5b4b18960$export$b54bf36dd1f18c08,
    get ActiveEvents () {
        return $204508e5b4b18960$export$f28998d26d157fd3;
    },
    TempContactForceEvent: $204508e5b4b18960$export$cba99c196a0dcc61,
    EventQueue: $204508e5b4b18960$export$2fc6338444a158e6,
    get ActiveHooks () {
        return $204508e5b4b18960$export$194d8ad9e2dc63e8;
    },
    get SolverFlags () {
        return $204508e5b4b18960$export$d50a7c063745a562;
    },
    DebugRenderBuffers: $204508e5b4b18960$export$354e114f10103d2d,
    DebugRenderPipeline: $204508e5b4b18960$export$acdffcc934f6bc95,
    get QueryFilterFlags () {
        return $204508e5b4b18960$export$39a39008025d4cb;
    },
    QueryPipeline: $204508e5b4b18960$export$636a60a98ff98f0b,
    init: $204508e5b4b18960$export$2cd8252107eb640b,
    CharacterCollision: $204508e5b4b18960$export$d8a6c60ecc79c6a6,
    KinematicCharacterController: $204508e5b4b18960$export$ed5de7d26b924ce3,
    DynamicRayCastVehicleController: $204508e5b4b18960$export$563c60dbc0927729
});

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $d5b33d7c30034067$exports = {};

$parcel$export($d5b33d7c30034067$exports, "REVISION", () => $d5b33d7c30034067$export$3545e07a80636437);
$parcel$export($d5b33d7c30034067$exports, "MOUSE", () => $d5b33d7c30034067$export$7177b3e430c2d7ca);
$parcel$export($d5b33d7c30034067$exports, "TOUCH", () => $d5b33d7c30034067$export$d46bd3ead7cc759b);
$parcel$export($d5b33d7c30034067$exports, "CullFaceNone", () => $d5b33d7c30034067$export$3237e1f2c1ea1f44);
$parcel$export($d5b33d7c30034067$exports, "CullFaceBack", () => $d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
$parcel$export($d5b33d7c30034067$exports, "CullFaceFront", () => $d5b33d7c30034067$export$b8058bcc7037d3f3);
$parcel$export($d5b33d7c30034067$exports, "CullFaceFrontBack", () => $d5b33d7c30034067$export$f24be24dcddeac0d);
$parcel$export($d5b33d7c30034067$exports, "BasicShadowMap", () => $d5b33d7c30034067$export$346307dbae2b7447);
$parcel$export($d5b33d7c30034067$exports, "PCFShadowMap", () => $d5b33d7c30034067$export$5813f879eee7cd88);
$parcel$export($d5b33d7c30034067$exports, "PCFSoftShadowMap", () => $d5b33d7c30034067$export$a47c4b43a1be34f0);
$parcel$export($d5b33d7c30034067$exports, "VSMShadowMap", () => $d5b33d7c30034067$export$896ae1ade6c829c4);
$parcel$export($d5b33d7c30034067$exports, "FrontSide", () => $d5b33d7c30034067$export$2ede184fc2998901);
$parcel$export($d5b33d7c30034067$exports, "BackSide", () => $d5b33d7c30034067$export$d9f0486e75b5ace);
$parcel$export($d5b33d7c30034067$exports, "DoubleSide", () => $d5b33d7c30034067$export$3b296b6f144d5b03);
$parcel$export($d5b33d7c30034067$exports, "TwoPassDoubleSide", () => $d5b33d7c30034067$export$211211c00f97204d);
$parcel$export($d5b33d7c30034067$exports, "NoBlending", () => $d5b33d7c30034067$export$63b8d6b580fc65ba);
$parcel$export($d5b33d7c30034067$exports, "NormalBlending", () => $d5b33d7c30034067$export$5b29a26d96ee6af0);
$parcel$export($d5b33d7c30034067$exports, "AdditiveBlending", () => $d5b33d7c30034067$export$777d8f9551c2216b);
$parcel$export($d5b33d7c30034067$exports, "SubtractiveBlending", () => $d5b33d7c30034067$export$cdfa06f868e2e467);
$parcel$export($d5b33d7c30034067$exports, "MultiplyBlending", () => $d5b33d7c30034067$export$4138e1c684b46a20);
$parcel$export($d5b33d7c30034067$exports, "CustomBlending", () => $d5b33d7c30034067$export$eda4864c68df1fa2);
$parcel$export($d5b33d7c30034067$exports, "AddEquation", () => $d5b33d7c30034067$export$20183a0484ce21a0);
$parcel$export($d5b33d7c30034067$exports, "SubtractEquation", () => $d5b33d7c30034067$export$73e0df5177988548);
$parcel$export($d5b33d7c30034067$exports, "ReverseSubtractEquation", () => $d5b33d7c30034067$export$28e582859cbec660);
$parcel$export($d5b33d7c30034067$exports, "MinEquation", () => $d5b33d7c30034067$export$c8c1508da8d0600c);
$parcel$export($d5b33d7c30034067$exports, "MaxEquation", () => $d5b33d7c30034067$export$99948c02fb51055f);
$parcel$export($d5b33d7c30034067$exports, "ZeroFactor", () => $d5b33d7c30034067$export$2110f05edf778d3d);
$parcel$export($d5b33d7c30034067$exports, "OneFactor", () => $d5b33d7c30034067$export$8805bad65e24940e);
$parcel$export($d5b33d7c30034067$exports, "SrcColorFactor", () => $d5b33d7c30034067$export$7fbe15b28d28cf52);
$parcel$export($d5b33d7c30034067$exports, "OneMinusSrcColorFactor", () => $d5b33d7c30034067$export$947829af9f2c17f6);
$parcel$export($d5b33d7c30034067$exports, "SrcAlphaFactor", () => $d5b33d7c30034067$export$d5773124e86cf28c);
$parcel$export($d5b33d7c30034067$exports, "OneMinusSrcAlphaFactor", () => $d5b33d7c30034067$export$11d468cc7f19e971);
$parcel$export($d5b33d7c30034067$exports, "DstAlphaFactor", () => $d5b33d7c30034067$export$a78aed1ca2a87192);
$parcel$export($d5b33d7c30034067$exports, "OneMinusDstAlphaFactor", () => $d5b33d7c30034067$export$5d0fe17fd8773bac);
$parcel$export($d5b33d7c30034067$exports, "DstColorFactor", () => $d5b33d7c30034067$export$ef5f2dd8ffac5574);
$parcel$export($d5b33d7c30034067$exports, "OneMinusDstColorFactor", () => $d5b33d7c30034067$export$56b85b2686ab16);
$parcel$export($d5b33d7c30034067$exports, "SrcAlphaSaturateFactor", () => $d5b33d7c30034067$export$c05e2a1fc8609506);
$parcel$export($d5b33d7c30034067$exports, "ConstantColorFactor", () => $d5b33d7c30034067$export$7dd8f434fd59075);
$parcel$export($d5b33d7c30034067$exports, "OneMinusConstantColorFactor", () => $d5b33d7c30034067$export$99c8d898a9afbcee);
$parcel$export($d5b33d7c30034067$exports, "ConstantAlphaFactor", () => $d5b33d7c30034067$export$310cd2be38d13b56);
$parcel$export($d5b33d7c30034067$exports, "OneMinusConstantAlphaFactor", () => $d5b33d7c30034067$export$db77b8fbcf45dbf4);
$parcel$export($d5b33d7c30034067$exports, "NeverDepth", () => $d5b33d7c30034067$export$69025ce147cee220);
$parcel$export($d5b33d7c30034067$exports, "AlwaysDepth", () => $d5b33d7c30034067$export$7182eb52ea3b3f04);
$parcel$export($d5b33d7c30034067$exports, "LessDepth", () => $d5b33d7c30034067$export$eedccec66ab7ebe);
$parcel$export($d5b33d7c30034067$exports, "LessEqualDepth", () => $d5b33d7c30034067$export$296f78a0b892f81a);
$parcel$export($d5b33d7c30034067$exports, "EqualDepth", () => $d5b33d7c30034067$export$a60d398fc7b7590e);
$parcel$export($d5b33d7c30034067$exports, "GreaterEqualDepth", () => $d5b33d7c30034067$export$7d7234c1240a1fc4);
$parcel$export($d5b33d7c30034067$exports, "GreaterDepth", () => $d5b33d7c30034067$export$c5e2c52991f30937);
$parcel$export($d5b33d7c30034067$exports, "NotEqualDepth", () => $d5b33d7c30034067$export$2f843afa843d8916);
$parcel$export($d5b33d7c30034067$exports, "MultiplyOperation", () => $d5b33d7c30034067$export$e50ac29801f1774d);
$parcel$export($d5b33d7c30034067$exports, "MixOperation", () => $d5b33d7c30034067$export$9f9d94f963c85479);
$parcel$export($d5b33d7c30034067$exports, "AddOperation", () => $d5b33d7c30034067$export$e641dc52bc3494aa);
$parcel$export($d5b33d7c30034067$exports, "NoToneMapping", () => $d5b33d7c30034067$export$9fcb6b4294603b2);
$parcel$export($d5b33d7c30034067$exports, "LinearToneMapping", () => $d5b33d7c30034067$export$98f52c2a46c598ca);
$parcel$export($d5b33d7c30034067$exports, "ReinhardToneMapping", () => $d5b33d7c30034067$export$74b25e54b3bcd548);
$parcel$export($d5b33d7c30034067$exports, "CineonToneMapping", () => $d5b33d7c30034067$export$932b3dd283d4a366);
$parcel$export($d5b33d7c30034067$exports, "ACESFilmicToneMapping", () => $d5b33d7c30034067$export$a0d98fe6d7e4af64);
$parcel$export($d5b33d7c30034067$exports, "CustomToneMapping", () => $d5b33d7c30034067$export$2c7b09c1e9abfb5e);
$parcel$export($d5b33d7c30034067$exports, "AttachedBindMode", () => $d5b33d7c30034067$export$2595a3798997538);
$parcel$export($d5b33d7c30034067$exports, "DetachedBindMode", () => $d5b33d7c30034067$export$d7e7dc2e114517a0);
$parcel$export($d5b33d7c30034067$exports, "UVMapping", () => $d5b33d7c30034067$export$1beec6768cbb3d2d);
$parcel$export($d5b33d7c30034067$exports, "CubeReflectionMapping", () => $d5b33d7c30034067$export$8759762a6477f2c4);
$parcel$export($d5b33d7c30034067$exports, "CubeRefractionMapping", () => $d5b33d7c30034067$export$dc59f8aed047f61d);
$parcel$export($d5b33d7c30034067$exports, "EquirectangularReflectionMapping", () => $d5b33d7c30034067$export$d64030b316d3b087);
$parcel$export($d5b33d7c30034067$exports, "EquirectangularRefractionMapping", () => $d5b33d7c30034067$export$ee99d97d46898098);
$parcel$export($d5b33d7c30034067$exports, "CubeUVReflectionMapping", () => $d5b33d7c30034067$export$dbf3e70ff37af79);
$parcel$export($d5b33d7c30034067$exports, "RepeatWrapping", () => $d5b33d7c30034067$export$533346c8e8dac0f5);
$parcel$export($d5b33d7c30034067$exports, "ClampToEdgeWrapping", () => $d5b33d7c30034067$export$9d9334239a5a5e06);
$parcel$export($d5b33d7c30034067$exports, "MirroredRepeatWrapping", () => $d5b33d7c30034067$export$c7e7c00b14f51a4f);
$parcel$export($d5b33d7c30034067$exports, "NearestFilter", () => $d5b33d7c30034067$export$727aa5ec3fe39bf0);
$parcel$export($d5b33d7c30034067$exports, "NearestMipmapNearestFilter", () => $d5b33d7c30034067$export$d129e38cf6feaa8c);
$parcel$export($d5b33d7c30034067$exports, "NearestMipMapNearestFilter", () => $d5b33d7c30034067$export$14a4936464a36496);
$parcel$export($d5b33d7c30034067$exports, "NearestMipmapLinearFilter", () => $d5b33d7c30034067$export$d2327c1afe5bfdf2);
$parcel$export($d5b33d7c30034067$exports, "NearestMipMapLinearFilter", () => $d5b33d7c30034067$export$cbc5b7f5647595d8);
$parcel$export($d5b33d7c30034067$exports, "LinearFilter", () => $d5b33d7c30034067$export$8a72f490b25c56c8);
$parcel$export($d5b33d7c30034067$exports, "LinearMipmapNearestFilter", () => $d5b33d7c30034067$export$19a719f377145a13);
$parcel$export($d5b33d7c30034067$exports, "LinearMipMapNearestFilter", () => $d5b33d7c30034067$export$dbe96bee3fe9dbf0);
$parcel$export($d5b33d7c30034067$exports, "LinearMipmapLinearFilter", () => $d5b33d7c30034067$export$5d8599b6a933fb1b);
$parcel$export($d5b33d7c30034067$exports, "LinearMipMapLinearFilter", () => $d5b33d7c30034067$export$90d80f1e3506775f);
$parcel$export($d5b33d7c30034067$exports, "UnsignedByteType", () => $d5b33d7c30034067$export$2e8ce08d3f6f5e10);
$parcel$export($d5b33d7c30034067$exports, "ByteType", () => $d5b33d7c30034067$export$545fce0311a9796a);
$parcel$export($d5b33d7c30034067$exports, "ShortType", () => $d5b33d7c30034067$export$88572337f312435f);
$parcel$export($d5b33d7c30034067$exports, "UnsignedShortType", () => $d5b33d7c30034067$export$c63dc51868b06a9d);
$parcel$export($d5b33d7c30034067$exports, "IntType", () => $d5b33d7c30034067$export$5c612977753abe2);
$parcel$export($d5b33d7c30034067$exports, "UnsignedIntType", () => $d5b33d7c30034067$export$c3c7fc4518ebba96);
$parcel$export($d5b33d7c30034067$exports, "FloatType", () => $d5b33d7c30034067$export$f6d331659b644596);
$parcel$export($d5b33d7c30034067$exports, "HalfFloatType", () => $d5b33d7c30034067$export$2697304443f382bc);
$parcel$export($d5b33d7c30034067$exports, "UnsignedShort4444Type", () => $d5b33d7c30034067$export$b3969b01faf587f2);
$parcel$export($d5b33d7c30034067$exports, "UnsignedShort5551Type", () => $d5b33d7c30034067$export$18886f8ae33e90de);
$parcel$export($d5b33d7c30034067$exports, "UnsignedInt248Type", () => $d5b33d7c30034067$export$6c8ea339bfab1301);
$parcel$export($d5b33d7c30034067$exports, "AlphaFormat", () => $d5b33d7c30034067$export$988473390501ed4b);
$parcel$export($d5b33d7c30034067$exports, "RGBAFormat", () => $d5b33d7c30034067$export$3f8bb04b555a363c);
$parcel$export($d5b33d7c30034067$exports, "LuminanceFormat", () => $d5b33d7c30034067$export$cc09ccbf6d1ed449);
$parcel$export($d5b33d7c30034067$exports, "LuminanceAlphaFormat", () => $d5b33d7c30034067$export$9053a81c4a69c289);
$parcel$export($d5b33d7c30034067$exports, "DepthFormat", () => $d5b33d7c30034067$export$c1b6b5136be58045);
$parcel$export($d5b33d7c30034067$exports, "DepthStencilFormat", () => $d5b33d7c30034067$export$1e113ac2d0905829);
$parcel$export($d5b33d7c30034067$exports, "RedFormat", () => $d5b33d7c30034067$export$4e041a7967d15c4b);
$parcel$export($d5b33d7c30034067$exports, "RedIntegerFormat", () => $d5b33d7c30034067$export$aa92e870a709d190);
$parcel$export($d5b33d7c30034067$exports, "RGFormat", () => $d5b33d7c30034067$export$6cdf0b461c7ce8a0);
$parcel$export($d5b33d7c30034067$exports, "RGIntegerFormat", () => $d5b33d7c30034067$export$1ba1c45f9f77d4d7);
$parcel$export($d5b33d7c30034067$exports, "RGBAIntegerFormat", () => $d5b33d7c30034067$export$c200e7d26f592f21);
$parcel$export($d5b33d7c30034067$exports, "RGB_S3TC_DXT1_Format", () => $d5b33d7c30034067$export$21d1799c6d552fc0);
$parcel$export($d5b33d7c30034067$exports, "RGBA_S3TC_DXT1_Format", () => $d5b33d7c30034067$export$afa304c3e981b668);
$parcel$export($d5b33d7c30034067$exports, "RGBA_S3TC_DXT3_Format", () => $d5b33d7c30034067$export$d2a1a68024a3e56c);
$parcel$export($d5b33d7c30034067$exports, "RGBA_S3TC_DXT5_Format", () => $d5b33d7c30034067$export$9a79c424327dacf9);
$parcel$export($d5b33d7c30034067$exports, "RGB_PVRTC_4BPPV1_Format", () => $d5b33d7c30034067$export$19ada9bbb1af3573);
$parcel$export($d5b33d7c30034067$exports, "RGB_PVRTC_2BPPV1_Format", () => $d5b33d7c30034067$export$d0f0355bb3d948e4);
$parcel$export($d5b33d7c30034067$exports, "RGBA_PVRTC_4BPPV1_Format", () => $d5b33d7c30034067$export$b82296714358084c);
$parcel$export($d5b33d7c30034067$exports, "RGBA_PVRTC_2BPPV1_Format", () => $d5b33d7c30034067$export$b71692456c47b6c3);
$parcel$export($d5b33d7c30034067$exports, "RGB_ETC1_Format", () => $d5b33d7c30034067$export$6ab91af2d757aee7);
$parcel$export($d5b33d7c30034067$exports, "RGB_ETC2_Format", () => $d5b33d7c30034067$export$7800993ef8106a6a);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ETC2_EAC_Format", () => $d5b33d7c30034067$export$23ed8300a860e7d8);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_4x4_Format", () => $d5b33d7c30034067$export$dc5570b4a2b92d48);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_5x4_Format", () => $d5b33d7c30034067$export$68880cd325f8b2fb);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_5x5_Format", () => $d5b33d7c30034067$export$7d2c0be323373d95);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_6x5_Format", () => $d5b33d7c30034067$export$22b52da301fc3a3e);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_6x6_Format", () => $d5b33d7c30034067$export$c009e2cb4a66485e);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_8x5_Format", () => $d5b33d7c30034067$export$118fff5afa255b63);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_8x6_Format", () => $d5b33d7c30034067$export$120713c829ae0667);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_8x8_Format", () => $d5b33d7c30034067$export$c79eeabbf53313e9);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x5_Format", () => $d5b33d7c30034067$export$443cf6567cdd6424);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x6_Format", () => $d5b33d7c30034067$export$6573984fc9840780);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x8_Format", () => $d5b33d7c30034067$export$e7aee563f30091de);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_10x10_Format", () => $d5b33d7c30034067$export$2eb8634622ddeab7);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_12x10_Format", () => $d5b33d7c30034067$export$202b1ce7b5d25742);
$parcel$export($d5b33d7c30034067$exports, "RGBA_ASTC_12x12_Format", () => $d5b33d7c30034067$export$18ab77abd087e467);
$parcel$export($d5b33d7c30034067$exports, "RGBA_BPTC_Format", () => $d5b33d7c30034067$export$ce40b115e188bc81);
$parcel$export($d5b33d7c30034067$exports, "RGB_BPTC_SIGNED_Format", () => $d5b33d7c30034067$export$d279c5c4bac5121e);
$parcel$export($d5b33d7c30034067$exports, "RGB_BPTC_UNSIGNED_Format", () => $d5b33d7c30034067$export$cde52d17225fdbd3);
$parcel$export($d5b33d7c30034067$exports, "RED_RGTC1_Format", () => $d5b33d7c30034067$export$b1688df4c4c21670);
$parcel$export($d5b33d7c30034067$exports, "SIGNED_RED_RGTC1_Format", () => $d5b33d7c30034067$export$fc15e5d8261eed58);
$parcel$export($d5b33d7c30034067$exports, "RED_GREEN_RGTC2_Format", () => $d5b33d7c30034067$export$d220f6ade8463a0f);
$parcel$export($d5b33d7c30034067$exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $d5b33d7c30034067$export$768646d09dc1b6ef);
$parcel$export($d5b33d7c30034067$exports, "LoopOnce", () => $d5b33d7c30034067$export$d62fdc9d1b1cccad);
$parcel$export($d5b33d7c30034067$exports, "LoopRepeat", () => $d5b33d7c30034067$export$dfaf4422ce096e29);
$parcel$export($d5b33d7c30034067$exports, "LoopPingPong", () => $d5b33d7c30034067$export$f8f6f2041b78e210);
$parcel$export($d5b33d7c30034067$exports, "InterpolateDiscrete", () => $d5b33d7c30034067$export$995b32462a65e855);
$parcel$export($d5b33d7c30034067$exports, "InterpolateLinear", () => $d5b33d7c30034067$export$30fac1aace31cf4d);
$parcel$export($d5b33d7c30034067$exports, "InterpolateSmooth", () => $d5b33d7c30034067$export$198b11ff4c72bb30);
$parcel$export($d5b33d7c30034067$exports, "ZeroCurvatureEnding", () => $d5b33d7c30034067$export$7f795934b84ab523);
$parcel$export($d5b33d7c30034067$exports, "ZeroSlopeEnding", () => $d5b33d7c30034067$export$24a4ccb5099273b5);
$parcel$export($d5b33d7c30034067$exports, "WrapAroundEnding", () => $d5b33d7c30034067$export$8e8c3ecdcd8e1fee);
$parcel$export($d5b33d7c30034067$exports, "NormalAnimationBlendMode", () => $d5b33d7c30034067$export$bcfbbdcf8de7f8cd);
$parcel$export($d5b33d7c30034067$exports, "AdditiveAnimationBlendMode", () => $d5b33d7c30034067$export$d875e029ef558d3);
$parcel$export($d5b33d7c30034067$exports, "TrianglesDrawMode", () => $d5b33d7c30034067$export$4c28c87c2dc84758);
$parcel$export($d5b33d7c30034067$exports, "TriangleStripDrawMode", () => $d5b33d7c30034067$export$b23a071aa286eb29);
$parcel$export($d5b33d7c30034067$exports, "TriangleFanDrawMode", () => $d5b33d7c30034067$export$f0d8293634f88842);
$parcel$export($d5b33d7c30034067$exports, "LinearEncoding", () => $d5b33d7c30034067$export$7207336e4151a112);
$parcel$export($d5b33d7c30034067$exports, "sRGBEncoding", () => $d5b33d7c30034067$export$f32388edbb32674);
$parcel$export($d5b33d7c30034067$exports, "BasicDepthPacking", () => $d5b33d7c30034067$export$deeb383078690b50);
$parcel$export($d5b33d7c30034067$exports, "RGBADepthPacking", () => $d5b33d7c30034067$export$8f910f4c4f73df11);
$parcel$export($d5b33d7c30034067$exports, "TangentSpaceNormalMap", () => $d5b33d7c30034067$export$2852a58ebdac27b8);
$parcel$export($d5b33d7c30034067$exports, "ObjectSpaceNormalMap", () => $d5b33d7c30034067$export$9990ad26f9db5b2c);
$parcel$export($d5b33d7c30034067$exports, "NoColorSpace", () => $d5b33d7c30034067$export$bfcb490c2dd3db51);
$parcel$export($d5b33d7c30034067$exports, "SRGBColorSpace", () => $d5b33d7c30034067$export$561f394b24edfcaa);
$parcel$export($d5b33d7c30034067$exports, "LinearSRGBColorSpace", () => $d5b33d7c30034067$export$42429b3acfb233a4);
$parcel$export($d5b33d7c30034067$exports, "DisplayP3ColorSpace", () => $d5b33d7c30034067$export$626af19ae879bdf6);
$parcel$export($d5b33d7c30034067$exports, "LinearDisplayP3ColorSpace", () => $d5b33d7c30034067$export$c0dc1bc7e964761);
$parcel$export($d5b33d7c30034067$exports, "LinearTransfer", () => $d5b33d7c30034067$export$f197347d588c1b4a);
$parcel$export($d5b33d7c30034067$exports, "SRGBTransfer", () => $d5b33d7c30034067$export$8d0a61916cc26abb);
$parcel$export($d5b33d7c30034067$exports, "Rec709Primaries", () => $d5b33d7c30034067$export$ce9118f9eaae3bb2);
$parcel$export($d5b33d7c30034067$exports, "P3Primaries", () => $d5b33d7c30034067$export$ef371755dbe7f98a);
$parcel$export($d5b33d7c30034067$exports, "ZeroStencilOp", () => $d5b33d7c30034067$export$69433f11f42d5527);
$parcel$export($d5b33d7c30034067$exports, "KeepStencilOp", () => $d5b33d7c30034067$export$9f542ae4b5baca34);
$parcel$export($d5b33d7c30034067$exports, "ReplaceStencilOp", () => $d5b33d7c30034067$export$8a4f28336ef203d3);
$parcel$export($d5b33d7c30034067$exports, "IncrementStencilOp", () => $d5b33d7c30034067$export$2928c0231297c036);
$parcel$export($d5b33d7c30034067$exports, "DecrementStencilOp", () => $d5b33d7c30034067$export$c0e9611c8a15f9a8);
$parcel$export($d5b33d7c30034067$exports, "IncrementWrapStencilOp", () => $d5b33d7c30034067$export$9c2c08927385dcc4);
$parcel$export($d5b33d7c30034067$exports, "DecrementWrapStencilOp", () => $d5b33d7c30034067$export$7c74ea00fa1315e6);
$parcel$export($d5b33d7c30034067$exports, "InvertStencilOp", () => $d5b33d7c30034067$export$22e2e5726612443);
$parcel$export($d5b33d7c30034067$exports, "NeverStencilFunc", () => $d5b33d7c30034067$export$1343870698229224);
$parcel$export($d5b33d7c30034067$exports, "LessStencilFunc", () => $d5b33d7c30034067$export$8e1d8ed281997fa6);
$parcel$export($d5b33d7c30034067$exports, "EqualStencilFunc", () => $d5b33d7c30034067$export$55648a1cde8329a7);
$parcel$export($d5b33d7c30034067$exports, "LessEqualStencilFunc", () => $d5b33d7c30034067$export$2dff107857e6aca2);
$parcel$export($d5b33d7c30034067$exports, "GreaterStencilFunc", () => $d5b33d7c30034067$export$6f93765ab2f451a2);
$parcel$export($d5b33d7c30034067$exports, "NotEqualStencilFunc", () => $d5b33d7c30034067$export$6f3fb2d2440f2b76);
$parcel$export($d5b33d7c30034067$exports, "GreaterEqualStencilFunc", () => $d5b33d7c30034067$export$4119cf7b4c98fd5a);
$parcel$export($d5b33d7c30034067$exports, "AlwaysStencilFunc", () => $d5b33d7c30034067$export$14cf96713ddd97a8);
$parcel$export($d5b33d7c30034067$exports, "NeverCompare", () => $d5b33d7c30034067$export$d9e2d19a747baaab);
$parcel$export($d5b33d7c30034067$exports, "LessCompare", () => $d5b33d7c30034067$export$36bcf49c713b3eb7);
$parcel$export($d5b33d7c30034067$exports, "EqualCompare", () => $d5b33d7c30034067$export$66f28d946fc6a0d5);
$parcel$export($d5b33d7c30034067$exports, "LessEqualCompare", () => $d5b33d7c30034067$export$64eea11eb407ddf1);
$parcel$export($d5b33d7c30034067$exports, "GreaterCompare", () => $d5b33d7c30034067$export$155af022118f3a38);
$parcel$export($d5b33d7c30034067$exports, "NotEqualCompare", () => $d5b33d7c30034067$export$67ab95dde6bed156);
$parcel$export($d5b33d7c30034067$exports, "GreaterEqualCompare", () => $d5b33d7c30034067$export$1cdcb70d53d65f61);
$parcel$export($d5b33d7c30034067$exports, "AlwaysCompare", () => $d5b33d7c30034067$export$187b73a3e352c145);
$parcel$export($d5b33d7c30034067$exports, "StaticDrawUsage", () => $d5b33d7c30034067$export$763e8360f4d7f77d);
$parcel$export($d5b33d7c30034067$exports, "DynamicDrawUsage", () => $d5b33d7c30034067$export$8505d14ac8546ca);
$parcel$export($d5b33d7c30034067$exports, "StreamDrawUsage", () => $d5b33d7c30034067$export$721e63549e51d81e);
$parcel$export($d5b33d7c30034067$exports, "StaticReadUsage", () => $d5b33d7c30034067$export$415731dc4f48e299);
$parcel$export($d5b33d7c30034067$exports, "DynamicReadUsage", () => $d5b33d7c30034067$export$9e809946455f13bc);
$parcel$export($d5b33d7c30034067$exports, "StreamReadUsage", () => $d5b33d7c30034067$export$2ed9499a35b5f832);
$parcel$export($d5b33d7c30034067$exports, "StaticCopyUsage", () => $d5b33d7c30034067$export$32ab2503ea19469a);
$parcel$export($d5b33d7c30034067$exports, "DynamicCopyUsage", () => $d5b33d7c30034067$export$ab4022c2c3f86315);
$parcel$export($d5b33d7c30034067$exports, "StreamCopyUsage", () => $d5b33d7c30034067$export$ba7f1db36a76a970);
$parcel$export($d5b33d7c30034067$exports, "GLSL1", () => $d5b33d7c30034067$export$43600cc67fabd9f);
$parcel$export($d5b33d7c30034067$exports, "GLSL3", () => $d5b33d7c30034067$export$f63012db5506e7dd);
$parcel$export($d5b33d7c30034067$exports, "_SRGBAFormat", () => $d5b33d7c30034067$export$ca1dce8b5e1de74d);
$parcel$export($d5b33d7c30034067$exports, "WebGLCoordinateSystem", () => $d5b33d7c30034067$export$5a0e9190d10875d3);
$parcel$export($d5b33d7c30034067$exports, "WebGPUCoordinateSystem", () => $d5b33d7c30034067$export$cc83beedcb9be9ac);
$parcel$export($d5b33d7c30034067$exports, "EventDispatcher", () => $d5b33d7c30034067$export$ec8b666c5fe2c75a);
$parcel$export($d5b33d7c30034067$exports, "MathUtils", () => $d5b33d7c30034067$export$6a7ef315a0d1ef07);
$parcel$export($d5b33d7c30034067$exports, "Vector2", () => $d5b33d7c30034067$export$c977b3e384af9ae1);
$parcel$export($d5b33d7c30034067$exports, "Matrix3", () => $d5b33d7c30034067$export$8ff26dafa08918);
$parcel$export($d5b33d7c30034067$exports, "createCanvasElement", () => $d5b33d7c30034067$export$1033a2df66368859);
$parcel$export($d5b33d7c30034067$exports, "ColorManagement", () => $d5b33d7c30034067$export$5e6fd513f44698c);
$parcel$export($d5b33d7c30034067$exports, "ImageUtils", () => $d5b33d7c30034067$export$698882cf06df44aa);
$parcel$export($d5b33d7c30034067$exports, "Source", () => $d5b33d7c30034067$export$1d2df86270c81ecb);
$parcel$export($d5b33d7c30034067$exports, "Texture", () => $d5b33d7c30034067$export$5431306cf43de24a);
$parcel$export($d5b33d7c30034067$exports, "Vector4", () => $d5b33d7c30034067$export$fa7daccca11cdbe3);
$parcel$export($d5b33d7c30034067$exports, "RenderTarget", () => $d5b33d7c30034067$export$efcb1f8bf367cbfb);
$parcel$export($d5b33d7c30034067$exports, "WebGLRenderTarget", () => $d5b33d7c30034067$export$3c052beb2e51e23f);
$parcel$export($d5b33d7c30034067$exports, "DataArrayTexture", () => $d5b33d7c30034067$export$dfac6c8e811406a3);
$parcel$export($d5b33d7c30034067$exports, "WebGLArrayRenderTarget", () => $d5b33d7c30034067$export$c77a02c11ed180c7);
$parcel$export($d5b33d7c30034067$exports, "Data3DTexture", () => $d5b33d7c30034067$export$d7a3086320f856db);
$parcel$export($d5b33d7c30034067$exports, "WebGL3DRenderTarget", () => $d5b33d7c30034067$export$7ee06591009639df);
$parcel$export($d5b33d7c30034067$exports, "WebGLMultipleRenderTargets", () => $d5b33d7c30034067$export$bd934554fb721730);
$parcel$export($d5b33d7c30034067$exports, "Quaternion", () => $d5b33d7c30034067$export$23d6a54f0bbc85a3);
$parcel$export($d5b33d7c30034067$exports, "Vector3", () => $d5b33d7c30034067$export$64b5c384219d3699);
$parcel$export($d5b33d7c30034067$exports, "Box3", () => $d5b33d7c30034067$export$6f7d5a9418ab2aa3);
$parcel$export($d5b33d7c30034067$exports, "Sphere", () => $d5b33d7c30034067$export$805e8b72413ccaba);
$parcel$export($d5b33d7c30034067$exports, "Ray", () => $d5b33d7c30034067$export$a186db52eed6d40e);
$parcel$export($d5b33d7c30034067$exports, "Matrix4", () => $d5b33d7c30034067$export$2ae72fc923e5eb5);
$parcel$export($d5b33d7c30034067$exports, "Euler", () => $d5b33d7c30034067$export$d93cc409a0768c5f);
$parcel$export($d5b33d7c30034067$exports, "Layers", () => $d5b33d7c30034067$export$89312ce47c0ca777);
$parcel$export($d5b33d7c30034067$exports, "Object3D", () => $d5b33d7c30034067$export$e4dd07dff30cc924);
$parcel$export($d5b33d7c30034067$exports, "Triangle", () => $d5b33d7c30034067$export$5a465592bfe74b48);
$parcel$export($d5b33d7c30034067$exports, "Color", () => $d5b33d7c30034067$export$892596cec99bc70e);
$parcel$export($d5b33d7c30034067$exports, "Material", () => $d5b33d7c30034067$export$a2d8b23205c25948);
$parcel$export($d5b33d7c30034067$exports, "MeshBasicMaterial", () => $d5b33d7c30034067$export$55cbcc9b622fe1f5);
$parcel$export($d5b33d7c30034067$exports, "DataUtils", () => $d5b33d7c30034067$export$11ce8b759162cc80);
$parcel$export($d5b33d7c30034067$exports, "BufferAttribute", () => $d5b33d7c30034067$export$8dea267bd6bde117);
$parcel$export($d5b33d7c30034067$exports, "Int8BufferAttribute", () => $d5b33d7c30034067$export$f9ff2d6a20248cbf);
$parcel$export($d5b33d7c30034067$exports, "Uint8BufferAttribute", () => $d5b33d7c30034067$export$cacc90cf35d11cdd);
$parcel$export($d5b33d7c30034067$exports, "Uint8ClampedBufferAttribute", () => $d5b33d7c30034067$export$baaa85a1a812c157);
$parcel$export($d5b33d7c30034067$exports, "Int16BufferAttribute", () => $d5b33d7c30034067$export$2b755a102ccdcefe);
$parcel$export($d5b33d7c30034067$exports, "Uint16BufferAttribute", () => $d5b33d7c30034067$export$640a853f68025f2e);
$parcel$export($d5b33d7c30034067$exports, "Int32BufferAttribute", () => $d5b33d7c30034067$export$46b369aed2968a0a);
$parcel$export($d5b33d7c30034067$exports, "Uint32BufferAttribute", () => $d5b33d7c30034067$export$7eb8c9fa25cd5bd6);
$parcel$export($d5b33d7c30034067$exports, "Float16BufferAttribute", () => $d5b33d7c30034067$export$dbd3698c64958d69);
$parcel$export($d5b33d7c30034067$exports, "Float32BufferAttribute", () => $d5b33d7c30034067$export$cbe7a62641830ebd);
$parcel$export($d5b33d7c30034067$exports, "Float64BufferAttribute", () => $d5b33d7c30034067$export$9e0ade74842adbb8);
$parcel$export($d5b33d7c30034067$exports, "BufferGeometry", () => $d5b33d7c30034067$export$b7be63a67df8959);
$parcel$export($d5b33d7c30034067$exports, "Mesh", () => $d5b33d7c30034067$export$e176487c05830cc5);
$parcel$export($d5b33d7c30034067$exports, "BoxGeometry", () => $d5b33d7c30034067$export$33e43285f7406bd5);
$parcel$export($d5b33d7c30034067$exports, "UniformsUtils", () => $d5b33d7c30034067$export$d8ecdf8615bfea69);
$parcel$export($d5b33d7c30034067$exports, "ShaderMaterial", () => $d5b33d7c30034067$export$83c7d75d550a8b0d);
$parcel$export($d5b33d7c30034067$exports, "Camera", () => $d5b33d7c30034067$export$79f141de891a5fed);
$parcel$export($d5b33d7c30034067$exports, "PerspectiveCamera", () => $d5b33d7c30034067$export$74e4ae24825f68d7);
$parcel$export($d5b33d7c30034067$exports, "CubeCamera", () => $d5b33d7c30034067$export$d0cdd0bd804995de);
$parcel$export($d5b33d7c30034067$exports, "CubeTexture", () => $d5b33d7c30034067$export$ee2e5a18258a4049);
$parcel$export($d5b33d7c30034067$exports, "WebGLCubeRenderTarget", () => $d5b33d7c30034067$export$ac386671d651941e);
$parcel$export($d5b33d7c30034067$exports, "Plane", () => $d5b33d7c30034067$export$7ff5ac152ef991b0);
$parcel$export($d5b33d7c30034067$exports, "Frustum", () => $d5b33d7c30034067$export$35efe6f4c85463d2);
$parcel$export($d5b33d7c30034067$exports, "PlaneGeometry", () => $d5b33d7c30034067$export$967d831af31f69ce);
$parcel$export($d5b33d7c30034067$exports, "ShaderChunk", () => $d5b33d7c30034067$export$955f9f2e84c43c8b);
$parcel$export($d5b33d7c30034067$exports, "UniformsLib", () => $d5b33d7c30034067$export$6643083551874bf5);
$parcel$export($d5b33d7c30034067$exports, "ShaderLib", () => $d5b33d7c30034067$export$bee4a7d47f8f5014);
$parcel$export($d5b33d7c30034067$exports, "OrthographicCamera", () => $d5b33d7c30034067$export$9ebf355ee4ed261b);
$parcel$export($d5b33d7c30034067$exports, "PMREMGenerator", () => $d5b33d7c30034067$export$6add42717753e221);
$parcel$export($d5b33d7c30034067$exports, "MeshDepthMaterial", () => $d5b33d7c30034067$export$2698c22ec13825db);
$parcel$export($d5b33d7c30034067$exports, "MeshDistanceMaterial", () => $d5b33d7c30034067$export$33e187ed002f2a19);
$parcel$export($d5b33d7c30034067$exports, "WebGLUtils", () => $d5b33d7c30034067$export$ddaebcad857649a8);
$parcel$export($d5b33d7c30034067$exports, "ArrayCamera", () => $d5b33d7c30034067$export$56b937d9e5581166);
$parcel$export($d5b33d7c30034067$exports, "Group", () => $d5b33d7c30034067$export$eb2fcfdbd7ba97d4);
$parcel$export($d5b33d7c30034067$exports, "DepthTexture", () => $d5b33d7c30034067$export$fc830aa069cc8c2f);
$parcel$export($d5b33d7c30034067$exports, "WebGLRenderer", () => $d5b33d7c30034067$export$f6cc00ef28d7cf97);
$parcel$export($d5b33d7c30034067$exports, "WebGL1Renderer", () => $d5b33d7c30034067$export$a2f65229194348f9);
$parcel$export($d5b33d7c30034067$exports, "FogExp2", () => $d5b33d7c30034067$export$6f1519f023b8d0f6);
$parcel$export($d5b33d7c30034067$exports, "Fog", () => $d5b33d7c30034067$export$3c890837b09508d4);
$parcel$export($d5b33d7c30034067$exports, "Scene", () => $d5b33d7c30034067$export$38af1803e3442a7f);
$parcel$export($d5b33d7c30034067$exports, "InterleavedBuffer", () => $d5b33d7c30034067$export$3d5cd879f108f53f);
$parcel$export($d5b33d7c30034067$exports, "InterleavedBufferAttribute", () => $d5b33d7c30034067$export$920b6d07334599c7);
$parcel$export($d5b33d7c30034067$exports, "SpriteMaterial", () => $d5b33d7c30034067$export$5ec7dd1c6994bf8e);
$parcel$export($d5b33d7c30034067$exports, "Sprite", () => $d5b33d7c30034067$export$3075603db8e6204c);
$parcel$export($d5b33d7c30034067$exports, "LOD", () => $d5b33d7c30034067$export$112e7237be0c5f30);
$parcel$export($d5b33d7c30034067$exports, "SkinnedMesh", () => $d5b33d7c30034067$export$b303577035157ecf);
$parcel$export($d5b33d7c30034067$exports, "Bone", () => $d5b33d7c30034067$export$b127726e56765aa4);
$parcel$export($d5b33d7c30034067$exports, "DataTexture", () => $d5b33d7c30034067$export$b691f601014eabe1);
$parcel$export($d5b33d7c30034067$exports, "Skeleton", () => $d5b33d7c30034067$export$8f31e4c4a37b8e9c);
$parcel$export($d5b33d7c30034067$exports, "InstancedBufferAttribute", () => $d5b33d7c30034067$export$32ea87a8b54d744a);
$parcel$export($d5b33d7c30034067$exports, "InstancedMesh", () => $d5b33d7c30034067$export$f3c979c331175ad7);
$parcel$export($d5b33d7c30034067$exports, "LineBasicMaterial", () => $d5b33d7c30034067$export$fbaaa33907730a0c);
$parcel$export($d5b33d7c30034067$exports, "Line", () => $d5b33d7c30034067$export$17d680238e50603e);
$parcel$export($d5b33d7c30034067$exports, "LineSegments", () => $d5b33d7c30034067$export$ff1ed10fedfdd604);
$parcel$export($d5b33d7c30034067$exports, "LineLoop", () => $d5b33d7c30034067$export$f85a24d745e4f17d);
$parcel$export($d5b33d7c30034067$exports, "PointsMaterial", () => $d5b33d7c30034067$export$a178c45366ce5d6b);
$parcel$export($d5b33d7c30034067$exports, "Points", () => $d5b33d7c30034067$export$1c787534cb11aa3e);
$parcel$export($d5b33d7c30034067$exports, "VideoTexture", () => $d5b33d7c30034067$export$6e09d1edf8d5a25c);
$parcel$export($d5b33d7c30034067$exports, "FramebufferTexture", () => $d5b33d7c30034067$export$9270d786f73ce6fe);
$parcel$export($d5b33d7c30034067$exports, "CompressedTexture", () => $d5b33d7c30034067$export$3466bac9141a5cc4);
$parcel$export($d5b33d7c30034067$exports, "CompressedArrayTexture", () => $d5b33d7c30034067$export$5fe6b8e34b274fcb);
$parcel$export($d5b33d7c30034067$exports, "CompressedCubeTexture", () => $d5b33d7c30034067$export$d80173634de65bff);
$parcel$export($d5b33d7c30034067$exports, "CanvasTexture", () => $d5b33d7c30034067$export$f7189e49152d1c13);
$parcel$export($d5b33d7c30034067$exports, "Curve", () => $d5b33d7c30034067$export$b0e83c3ef8d2db1);
$parcel$export($d5b33d7c30034067$exports, "EllipseCurve", () => $d5b33d7c30034067$export$3f87a931616cde04);
$parcel$export($d5b33d7c30034067$exports, "ArcCurve", () => $d5b33d7c30034067$export$b1eedc9aab6300e8);
$parcel$export($d5b33d7c30034067$exports, "CatmullRomCurve3", () => $d5b33d7c30034067$export$b9146b27c24b744c);
$parcel$export($d5b33d7c30034067$exports, "CubicBezierCurve", () => $d5b33d7c30034067$export$e36650d36468bb39);
$parcel$export($d5b33d7c30034067$exports, "CubicBezierCurve3", () => $d5b33d7c30034067$export$13d5f1c9525f246c);
$parcel$export($d5b33d7c30034067$exports, "LineCurve", () => $d5b33d7c30034067$export$ab2e07e76531a47e);
$parcel$export($d5b33d7c30034067$exports, "LineCurve3", () => $d5b33d7c30034067$export$1fdfd9d9cf487600);
$parcel$export($d5b33d7c30034067$exports, "QuadraticBezierCurve", () => $d5b33d7c30034067$export$5938c4ee491a43ad);
$parcel$export($d5b33d7c30034067$exports, "QuadraticBezierCurve3", () => $d5b33d7c30034067$export$bf3f4c7e459f90fc);
$parcel$export($d5b33d7c30034067$exports, "SplineCurve", () => $d5b33d7c30034067$export$d3bdd77da77afc1b);
$parcel$export($d5b33d7c30034067$exports, "CurvePath", () => $d5b33d7c30034067$export$4aaf9b66af1bbf2c);
$parcel$export($d5b33d7c30034067$exports, "Path", () => $d5b33d7c30034067$export$4b2950bdac9b6ee9);
$parcel$export($d5b33d7c30034067$exports, "LatheGeometry", () => $d5b33d7c30034067$export$6d839803fcd1882c);
$parcel$export($d5b33d7c30034067$exports, "CapsuleGeometry", () => $d5b33d7c30034067$export$41680e8551036033);
$parcel$export($d5b33d7c30034067$exports, "CircleGeometry", () => $d5b33d7c30034067$export$d5c0e8d607467193);
$parcel$export($d5b33d7c30034067$exports, "CylinderGeometry", () => $d5b33d7c30034067$export$68f745719dbe5198);
$parcel$export($d5b33d7c30034067$exports, "ConeGeometry", () => $d5b33d7c30034067$export$a7a48974f285c9b3);
$parcel$export($d5b33d7c30034067$exports, "PolyhedronGeometry", () => $d5b33d7c30034067$export$60e57a7d3f20ff65);
$parcel$export($d5b33d7c30034067$exports, "DodecahedronGeometry", () => $d5b33d7c30034067$export$c0babfeb8708fc9c);
$parcel$export($d5b33d7c30034067$exports, "EdgesGeometry", () => $d5b33d7c30034067$export$4730b1542707547f);
$parcel$export($d5b33d7c30034067$exports, "Shape", () => $d5b33d7c30034067$export$6428a7f2611ef1fa);
$parcel$export($d5b33d7c30034067$exports, "ShapeUtils", () => $d5b33d7c30034067$export$96bdf6d9c66d7ba8);
$parcel$export($d5b33d7c30034067$exports, "ExtrudeGeometry", () => $d5b33d7c30034067$export$598697a1efa63ca7);
$parcel$export($d5b33d7c30034067$exports, "IcosahedronGeometry", () => $d5b33d7c30034067$export$9567cc828c9535da);
$parcel$export($d5b33d7c30034067$exports, "OctahedronGeometry", () => $d5b33d7c30034067$export$1954e2b809fe361e);
$parcel$export($d5b33d7c30034067$exports, "RingGeometry", () => $d5b33d7c30034067$export$68cb731f50f614af);
$parcel$export($d5b33d7c30034067$exports, "ShapeGeometry", () => $d5b33d7c30034067$export$57a29a1c803e9065);
$parcel$export($d5b33d7c30034067$exports, "SphereGeometry", () => $d5b33d7c30034067$export$1b417fc3b307a251);
$parcel$export($d5b33d7c30034067$exports, "TetrahedronGeometry", () => $d5b33d7c30034067$export$fb3f7adc68bd6e02);
$parcel$export($d5b33d7c30034067$exports, "TorusGeometry", () => $d5b33d7c30034067$export$a2312a2a1fa56495);
$parcel$export($d5b33d7c30034067$exports, "TorusKnotGeometry", () => $d5b33d7c30034067$export$77e9bfadfb9ab8c8);
$parcel$export($d5b33d7c30034067$exports, "TubeGeometry", () => $d5b33d7c30034067$export$7897d9d48904490c);
$parcel$export($d5b33d7c30034067$exports, "WireframeGeometry", () => $d5b33d7c30034067$export$4b739da06d24892b);
$parcel$export($d5b33d7c30034067$exports, "ShadowMaterial", () => $d5b33d7c30034067$export$e8564da406055a3);
$parcel$export($d5b33d7c30034067$exports, "RawShaderMaterial", () => $d5b33d7c30034067$export$21c421a2e1df9d22);
$parcel$export($d5b33d7c30034067$exports, "MeshStandardMaterial", () => $d5b33d7c30034067$export$f2980790215acccd);
$parcel$export($d5b33d7c30034067$exports, "MeshPhysicalMaterial", () => $d5b33d7c30034067$export$28d04986c4269c9f);
$parcel$export($d5b33d7c30034067$exports, "MeshPhongMaterial", () => $d5b33d7c30034067$export$24c72f71cbaf0678);
$parcel$export($d5b33d7c30034067$exports, "MeshToonMaterial", () => $d5b33d7c30034067$export$df893cf97e765622);
$parcel$export($d5b33d7c30034067$exports, "MeshNormalMaterial", () => $d5b33d7c30034067$export$bfe8c0a091f41ae7);
$parcel$export($d5b33d7c30034067$exports, "MeshLambertMaterial", () => $d5b33d7c30034067$export$5023a9a8114806b8);
$parcel$export($d5b33d7c30034067$exports, "MeshMatcapMaterial", () => $d5b33d7c30034067$export$6f5fef6235ec12ee);
$parcel$export($d5b33d7c30034067$exports, "LineDashedMaterial", () => $d5b33d7c30034067$export$327886a3efaeaebe);
$parcel$export($d5b33d7c30034067$exports, "AnimationUtils", () => $d5b33d7c30034067$export$7ee8caa573e71ad1);
$parcel$export($d5b33d7c30034067$exports, "Interpolant", () => $d5b33d7c30034067$export$b558baee9c0f72d3);
$parcel$export($d5b33d7c30034067$exports, "CubicInterpolant", () => $d5b33d7c30034067$export$3646682e7a3959);
$parcel$export($d5b33d7c30034067$exports, "LinearInterpolant", () => $d5b33d7c30034067$export$a8e6009059f51e1a);
$parcel$export($d5b33d7c30034067$exports, "DiscreteInterpolant", () => $d5b33d7c30034067$export$fb9758ef7ef8d5cc);
$parcel$export($d5b33d7c30034067$exports, "KeyframeTrack", () => $d5b33d7c30034067$export$b0e479f45b7006d6);
$parcel$export($d5b33d7c30034067$exports, "BooleanKeyframeTrack", () => $d5b33d7c30034067$export$d3a344b98cf0b775);
$parcel$export($d5b33d7c30034067$exports, "ColorKeyframeTrack", () => $d5b33d7c30034067$export$83444c5d885347d8);
$parcel$export($d5b33d7c30034067$exports, "NumberKeyframeTrack", () => $d5b33d7c30034067$export$d45f0d1a4d9a9314);
$parcel$export($d5b33d7c30034067$exports, "QuaternionLinearInterpolant", () => $d5b33d7c30034067$export$2db1cfb7923d931e);
$parcel$export($d5b33d7c30034067$exports, "QuaternionKeyframeTrack", () => $d5b33d7c30034067$export$b8043f12b5aafbd7);
$parcel$export($d5b33d7c30034067$exports, "StringKeyframeTrack", () => $d5b33d7c30034067$export$6ce41d4f3a8df9cd);
$parcel$export($d5b33d7c30034067$exports, "VectorKeyframeTrack", () => $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
$parcel$export($d5b33d7c30034067$exports, "AnimationClip", () => $d5b33d7c30034067$export$d942c706bf23829c);
$parcel$export($d5b33d7c30034067$exports, "Cache", () => $d5b33d7c30034067$export$94affb487e701bf2);
$parcel$export($d5b33d7c30034067$exports, "LoadingManager", () => $d5b33d7c30034067$export$99cc795e99919eed);
$parcel$export($d5b33d7c30034067$exports, "DefaultLoadingManager", () => $d5b33d7c30034067$export$b033c3f9a95c6a16);
$parcel$export($d5b33d7c30034067$exports, "Loader", () => $d5b33d7c30034067$export$3b0d6d7590275603);
$parcel$export($d5b33d7c30034067$exports, "FileLoader", () => $d5b33d7c30034067$export$98435a25b5cf7b2b);
$parcel$export($d5b33d7c30034067$exports, "AnimationLoader", () => $d5b33d7c30034067$export$29711c7e14f61db);
$parcel$export($d5b33d7c30034067$exports, "CompressedTextureLoader", () => $d5b33d7c30034067$export$bd73ce947a280350);
$parcel$export($d5b33d7c30034067$exports, "ImageLoader", () => $d5b33d7c30034067$export$8905ce1c7a2464a1);
$parcel$export($d5b33d7c30034067$exports, "CubeTextureLoader", () => $d5b33d7c30034067$export$2ec114afc2cf6308);
$parcel$export($d5b33d7c30034067$exports, "DataTextureLoader", () => $d5b33d7c30034067$export$792d8a18f2c55855);
$parcel$export($d5b33d7c30034067$exports, "TextureLoader", () => $d5b33d7c30034067$export$fd1bfc71f64c538c);
$parcel$export($d5b33d7c30034067$exports, "Light", () => $d5b33d7c30034067$export$6ecadb6ed240d696);
$parcel$export($d5b33d7c30034067$exports, "HemisphereLight", () => $d5b33d7c30034067$export$8d474f55edbb9624);
$parcel$export($d5b33d7c30034067$exports, "SpotLight", () => $d5b33d7c30034067$export$81495cbb73897362);
$parcel$export($d5b33d7c30034067$exports, "PointLight", () => $d5b33d7c30034067$export$4c9c1cb3f0b6f455);
$parcel$export($d5b33d7c30034067$exports, "DirectionalLight", () => $d5b33d7c30034067$export$3fea33cc9972c868);
$parcel$export($d5b33d7c30034067$exports, "AmbientLight", () => $d5b33d7c30034067$export$af279bfef9ec2c96);
$parcel$export($d5b33d7c30034067$exports, "RectAreaLight", () => $d5b33d7c30034067$export$61db2d908bbd2429);
$parcel$export($d5b33d7c30034067$exports, "SphericalHarmonics3", () => $d5b33d7c30034067$export$ba61ce607e1f405a);
$parcel$export($d5b33d7c30034067$exports, "LightProbe", () => $d5b33d7c30034067$export$e7ef036e309b38d2);
$parcel$export($d5b33d7c30034067$exports, "MaterialLoader", () => $d5b33d7c30034067$export$3bd6d323353dcf96);
$parcel$export($d5b33d7c30034067$exports, "LoaderUtils", () => $d5b33d7c30034067$export$b5d2dc08d867e41a);
$parcel$export($d5b33d7c30034067$exports, "InstancedBufferGeometry", () => $d5b33d7c30034067$export$231f009cbe414146);
$parcel$export($d5b33d7c30034067$exports, "BufferGeometryLoader", () => $d5b33d7c30034067$export$dc275bb96327833a);
$parcel$export($d5b33d7c30034067$exports, "ObjectLoader", () => $d5b33d7c30034067$export$40110c8505c5ad19);
$parcel$export($d5b33d7c30034067$exports, "ImageBitmapLoader", () => $d5b33d7c30034067$export$52286b55c4a9b51f);
$parcel$export($d5b33d7c30034067$exports, "AudioContext", () => $d5b33d7c30034067$export$fcbc63750ec2a81f);
$parcel$export($d5b33d7c30034067$exports, "AudioLoader", () => $d5b33d7c30034067$export$d8d5fccfbf47714e);
$parcel$export($d5b33d7c30034067$exports, "StereoCamera", () => $d5b33d7c30034067$export$bc7f73a1065bee0c);
$parcel$export($d5b33d7c30034067$exports, "Clock", () => $d5b33d7c30034067$export$9735c82c4bae3302);
$parcel$export($d5b33d7c30034067$exports, "AudioListener", () => $d5b33d7c30034067$export$8a1b810c6fde8951);
$parcel$export($d5b33d7c30034067$exports, "Audio", () => $d5b33d7c30034067$export$153755f98d9861de);
$parcel$export($d5b33d7c30034067$exports, "PositionalAudio", () => $d5b33d7c30034067$export$4b3e397ef1832507);
$parcel$export($d5b33d7c30034067$exports, "AudioAnalyser", () => $d5b33d7c30034067$export$d47da1ef3d382827);
$parcel$export($d5b33d7c30034067$exports, "PropertyMixer", () => $d5b33d7c30034067$export$dfe0af1ca1acb78a);
$parcel$export($d5b33d7c30034067$exports, "PropertyBinding", () => $d5b33d7c30034067$export$7bf70fcf9f891893);
$parcel$export($d5b33d7c30034067$exports, "AnimationObjectGroup", () => $d5b33d7c30034067$export$30619c2afd3f34db);
$parcel$export($d5b33d7c30034067$exports, "AnimationAction", () => $d5b33d7c30034067$export$6946940a69e799e);
$parcel$export($d5b33d7c30034067$exports, "AnimationMixer", () => $d5b33d7c30034067$export$fbd77e5aefaa0102);
$parcel$export($d5b33d7c30034067$exports, "Uniform", () => $d5b33d7c30034067$export$2947cebfe91c02f8);
$parcel$export($d5b33d7c30034067$exports, "UniformsGroup", () => $d5b33d7c30034067$export$c412d5ffe1f79209);
$parcel$export($d5b33d7c30034067$exports, "InstancedInterleavedBuffer", () => $d5b33d7c30034067$export$25ec0e1af1389358);
$parcel$export($d5b33d7c30034067$exports, "GLBufferAttribute", () => $d5b33d7c30034067$export$6b7339ae8dbddf73);
$parcel$export($d5b33d7c30034067$exports, "Raycaster", () => $d5b33d7c30034067$export$8b7aaceff00bd2f);
$parcel$export($d5b33d7c30034067$exports, "Spherical", () => $d5b33d7c30034067$export$d712cd887b4a00f7);
$parcel$export($d5b33d7c30034067$exports, "Cylindrical", () => $d5b33d7c30034067$export$287165bb2177f4fd);
$parcel$export($d5b33d7c30034067$exports, "Box2", () => $d5b33d7c30034067$export$60f553fa130f08b0);
$parcel$export($d5b33d7c30034067$exports, "Line3", () => $d5b33d7c30034067$export$e0ba6359f1954fd3);
$parcel$export($d5b33d7c30034067$exports, "SpotLightHelper", () => $d5b33d7c30034067$export$4b14638ffdd81e68);
$parcel$export($d5b33d7c30034067$exports, "SkeletonHelper", () => $d5b33d7c30034067$export$5277df3c9e732259);
$parcel$export($d5b33d7c30034067$exports, "PointLightHelper", () => $d5b33d7c30034067$export$9a9291685b9e4023);
$parcel$export($d5b33d7c30034067$exports, "HemisphereLightHelper", () => $d5b33d7c30034067$export$8dca15f13f4f8172);
$parcel$export($d5b33d7c30034067$exports, "GridHelper", () => $d5b33d7c30034067$export$3875d39926561055);
$parcel$export($d5b33d7c30034067$exports, "PolarGridHelper", () => $d5b33d7c30034067$export$361430a10f533cd3);
$parcel$export($d5b33d7c30034067$exports, "DirectionalLightHelper", () => $d5b33d7c30034067$export$f8e434dc14203e7d);
$parcel$export($d5b33d7c30034067$exports, "CameraHelper", () => $d5b33d7c30034067$export$ed8e93f853cd795);
$parcel$export($d5b33d7c30034067$exports, "BoxHelper", () => $d5b33d7c30034067$export$38a664cc862a6a9d);
$parcel$export($d5b33d7c30034067$exports, "Box3Helper", () => $d5b33d7c30034067$export$ce39f4bb96c9a290);
$parcel$export($d5b33d7c30034067$exports, "PlaneHelper", () => $d5b33d7c30034067$export$a34fe8156c66e5d7);
$parcel$export($d5b33d7c30034067$exports, "ArrowHelper", () => $d5b33d7c30034067$export$a3008e7bd8d2cbe7);
$parcel$export($d5b33d7c30034067$exports, "AxesHelper", () => $d5b33d7c30034067$export$6c8303f35b8578fd);
$parcel$export($d5b33d7c30034067$exports, "ShapePath", () => $d5b33d7c30034067$export$148534a3c727230b);
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d5b33d7c30034067$export$3545e07a80636437 = '158';
const $d5b33d7c30034067$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $d5b33d7c30034067$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $d5b33d7c30034067$export$3237e1f2c1ea1f44 = 0;
const $d5b33d7c30034067$export$b9a7b4fc5cb15f9b = 1;
const $d5b33d7c30034067$export$b8058bcc7037d3f3 = 2;
const $d5b33d7c30034067$export$f24be24dcddeac0d = 3;
const $d5b33d7c30034067$export$346307dbae2b7447 = 0;
const $d5b33d7c30034067$export$5813f879eee7cd88 = 1;
const $d5b33d7c30034067$export$a47c4b43a1be34f0 = 2;
const $d5b33d7c30034067$export$896ae1ade6c829c4 = 3;
const $d5b33d7c30034067$export$2ede184fc2998901 = 0;
const $d5b33d7c30034067$export$d9f0486e75b5ace = 1;
const $d5b33d7c30034067$export$3b296b6f144d5b03 = 2;
const $d5b33d7c30034067$export$211211c00f97204d = 2; // r149
const $d5b33d7c30034067$export$63b8d6b580fc65ba = 0;
const $d5b33d7c30034067$export$5b29a26d96ee6af0 = 1;
const $d5b33d7c30034067$export$777d8f9551c2216b = 2;
const $d5b33d7c30034067$export$cdfa06f868e2e467 = 3;
const $d5b33d7c30034067$export$4138e1c684b46a20 = 4;
const $d5b33d7c30034067$export$eda4864c68df1fa2 = 5;
const $d5b33d7c30034067$export$20183a0484ce21a0 = 100;
const $d5b33d7c30034067$export$73e0df5177988548 = 101;
const $d5b33d7c30034067$export$28e582859cbec660 = 102;
const $d5b33d7c30034067$export$c8c1508da8d0600c = 103;
const $d5b33d7c30034067$export$99948c02fb51055f = 104;
const $d5b33d7c30034067$export$2110f05edf778d3d = 200;
const $d5b33d7c30034067$export$8805bad65e24940e = 201;
const $d5b33d7c30034067$export$7fbe15b28d28cf52 = 202;
const $d5b33d7c30034067$export$947829af9f2c17f6 = 203;
const $d5b33d7c30034067$export$d5773124e86cf28c = 204;
const $d5b33d7c30034067$export$11d468cc7f19e971 = 205;
const $d5b33d7c30034067$export$a78aed1ca2a87192 = 206;
const $d5b33d7c30034067$export$5d0fe17fd8773bac = 207;
const $d5b33d7c30034067$export$ef5f2dd8ffac5574 = 208;
const $d5b33d7c30034067$export$56b85b2686ab16 = 209;
const $d5b33d7c30034067$export$c05e2a1fc8609506 = 210;
const $d5b33d7c30034067$export$7dd8f434fd59075 = 211;
const $d5b33d7c30034067$export$99c8d898a9afbcee = 212;
const $d5b33d7c30034067$export$310cd2be38d13b56 = 213;
const $d5b33d7c30034067$export$db77b8fbcf45dbf4 = 214;
const $d5b33d7c30034067$export$69025ce147cee220 = 0;
const $d5b33d7c30034067$export$7182eb52ea3b3f04 = 1;
const $d5b33d7c30034067$export$eedccec66ab7ebe = 2;
const $d5b33d7c30034067$export$296f78a0b892f81a = 3;
const $d5b33d7c30034067$export$a60d398fc7b7590e = 4;
const $d5b33d7c30034067$export$7d7234c1240a1fc4 = 5;
const $d5b33d7c30034067$export$c5e2c52991f30937 = 6;
const $d5b33d7c30034067$export$2f843afa843d8916 = 7;
const $d5b33d7c30034067$export$e50ac29801f1774d = 0;
const $d5b33d7c30034067$export$9f9d94f963c85479 = 1;
const $d5b33d7c30034067$export$e641dc52bc3494aa = 2;
const $d5b33d7c30034067$export$9fcb6b4294603b2 = 0;
const $d5b33d7c30034067$export$98f52c2a46c598ca = 1;
const $d5b33d7c30034067$export$74b25e54b3bcd548 = 2;
const $d5b33d7c30034067$export$932b3dd283d4a366 = 3;
const $d5b33d7c30034067$export$a0d98fe6d7e4af64 = 4;
const $d5b33d7c30034067$export$2c7b09c1e9abfb5e = 5;
const $d5b33d7c30034067$export$2595a3798997538 = 'attached';
const $d5b33d7c30034067$export$d7e7dc2e114517a0 = 'detached';
const $d5b33d7c30034067$export$1beec6768cbb3d2d = 300;
const $d5b33d7c30034067$export$8759762a6477f2c4 = 301;
const $d5b33d7c30034067$export$dc59f8aed047f61d = 302;
const $d5b33d7c30034067$export$d64030b316d3b087 = 303;
const $d5b33d7c30034067$export$ee99d97d46898098 = 304;
const $d5b33d7c30034067$export$dbf3e70ff37af79 = 306;
const $d5b33d7c30034067$export$533346c8e8dac0f5 = 1000;
const $d5b33d7c30034067$export$9d9334239a5a5e06 = 1001;
const $d5b33d7c30034067$export$c7e7c00b14f51a4f = 1002;
const $d5b33d7c30034067$export$727aa5ec3fe39bf0 = 1003;
const $d5b33d7c30034067$export$d129e38cf6feaa8c = 1004;
const $d5b33d7c30034067$export$14a4936464a36496 = 1004;
const $d5b33d7c30034067$export$d2327c1afe5bfdf2 = 1005;
const $d5b33d7c30034067$export$cbc5b7f5647595d8 = 1005;
const $d5b33d7c30034067$export$8a72f490b25c56c8 = 1006;
const $d5b33d7c30034067$export$19a719f377145a13 = 1007;
const $d5b33d7c30034067$export$dbe96bee3fe9dbf0 = 1007;
const $d5b33d7c30034067$export$5d8599b6a933fb1b = 1008;
const $d5b33d7c30034067$export$90d80f1e3506775f = 1008;
const $d5b33d7c30034067$export$2e8ce08d3f6f5e10 = 1009;
const $d5b33d7c30034067$export$545fce0311a9796a = 1010;
const $d5b33d7c30034067$export$88572337f312435f = 1011;
const $d5b33d7c30034067$export$c63dc51868b06a9d = 1012;
const $d5b33d7c30034067$export$5c612977753abe2 = 1013;
const $d5b33d7c30034067$export$c3c7fc4518ebba96 = 1014;
const $d5b33d7c30034067$export$f6d331659b644596 = 1015;
const $d5b33d7c30034067$export$2697304443f382bc = 1016;
const $d5b33d7c30034067$export$b3969b01faf587f2 = 1017;
const $d5b33d7c30034067$export$18886f8ae33e90de = 1018;
const $d5b33d7c30034067$export$6c8ea339bfab1301 = 1020;
const $d5b33d7c30034067$export$988473390501ed4b = 1021;
const $d5b33d7c30034067$export$3f8bb04b555a363c = 1023;
const $d5b33d7c30034067$export$cc09ccbf6d1ed449 = 1024;
const $d5b33d7c30034067$export$9053a81c4a69c289 = 1025;
const $d5b33d7c30034067$export$c1b6b5136be58045 = 1026;
const $d5b33d7c30034067$export$1e113ac2d0905829 = 1027;
const $d5b33d7c30034067$export$4e041a7967d15c4b = 1028;
const $d5b33d7c30034067$export$aa92e870a709d190 = 1029;
const $d5b33d7c30034067$export$6cdf0b461c7ce8a0 = 1030;
const $d5b33d7c30034067$export$1ba1c45f9f77d4d7 = 1031;
const $d5b33d7c30034067$export$c200e7d26f592f21 = 1033;
const $d5b33d7c30034067$export$21d1799c6d552fc0 = 33776;
const $d5b33d7c30034067$export$afa304c3e981b668 = 33777;
const $d5b33d7c30034067$export$d2a1a68024a3e56c = 33778;
const $d5b33d7c30034067$export$9a79c424327dacf9 = 33779;
const $d5b33d7c30034067$export$19ada9bbb1af3573 = 35840;
const $d5b33d7c30034067$export$d0f0355bb3d948e4 = 35841;
const $d5b33d7c30034067$export$b82296714358084c = 35842;
const $d5b33d7c30034067$export$b71692456c47b6c3 = 35843;
const $d5b33d7c30034067$export$6ab91af2d757aee7 = 36196;
const $d5b33d7c30034067$export$7800993ef8106a6a = 37492;
const $d5b33d7c30034067$export$23ed8300a860e7d8 = 37496;
const $d5b33d7c30034067$export$dc5570b4a2b92d48 = 37808;
const $d5b33d7c30034067$export$68880cd325f8b2fb = 37809;
const $d5b33d7c30034067$export$7d2c0be323373d95 = 37810;
const $d5b33d7c30034067$export$22b52da301fc3a3e = 37811;
const $d5b33d7c30034067$export$c009e2cb4a66485e = 37812;
const $d5b33d7c30034067$export$118fff5afa255b63 = 37813;
const $d5b33d7c30034067$export$120713c829ae0667 = 37814;
const $d5b33d7c30034067$export$c79eeabbf53313e9 = 37815;
const $d5b33d7c30034067$export$443cf6567cdd6424 = 37816;
const $d5b33d7c30034067$export$6573984fc9840780 = 37817;
const $d5b33d7c30034067$export$e7aee563f30091de = 37818;
const $d5b33d7c30034067$export$2eb8634622ddeab7 = 37819;
const $d5b33d7c30034067$export$202b1ce7b5d25742 = 37820;
const $d5b33d7c30034067$export$18ab77abd087e467 = 37821;
const $d5b33d7c30034067$export$ce40b115e188bc81 = 36492;
const $d5b33d7c30034067$export$d279c5c4bac5121e = 36494;
const $d5b33d7c30034067$export$cde52d17225fdbd3 = 36495;
const $d5b33d7c30034067$export$b1688df4c4c21670 = 36283;
const $d5b33d7c30034067$export$fc15e5d8261eed58 = 36284;
const $d5b33d7c30034067$export$d220f6ade8463a0f = 36285;
const $d5b33d7c30034067$export$768646d09dc1b6ef = 36286;
const $d5b33d7c30034067$export$d62fdc9d1b1cccad = 2200;
const $d5b33d7c30034067$export$dfaf4422ce096e29 = 2201;
const $d5b33d7c30034067$export$f8f6f2041b78e210 = 2202;
const $d5b33d7c30034067$export$995b32462a65e855 = 2300;
const $d5b33d7c30034067$export$30fac1aace31cf4d = 2301;
const $d5b33d7c30034067$export$198b11ff4c72bb30 = 2302;
const $d5b33d7c30034067$export$7f795934b84ab523 = 2400;
const $d5b33d7c30034067$export$24a4ccb5099273b5 = 2401;
const $d5b33d7c30034067$export$8e8c3ecdcd8e1fee = 2402;
const $d5b33d7c30034067$export$bcfbbdcf8de7f8cd = 2500;
const $d5b33d7c30034067$export$d875e029ef558d3 = 2501;
const $d5b33d7c30034067$export$4c28c87c2dc84758 = 0;
const $d5b33d7c30034067$export$b23a071aa286eb29 = 1;
const $d5b33d7c30034067$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $d5b33d7c30034067$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $d5b33d7c30034067$export$f32388edbb32674 = 3001;
const $d5b33d7c30034067$export$deeb383078690b50 = 3200;
const $d5b33d7c30034067$export$8f910f4c4f73df11 = 3201;
const $d5b33d7c30034067$export$2852a58ebdac27b8 = 0;
const $d5b33d7c30034067$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $d5b33d7c30034067$export$bfcb490c2dd3db51 = '';
const $d5b33d7c30034067$export$561f394b24edfcaa = 'srgb';
const $d5b33d7c30034067$export$42429b3acfb233a4 = 'srgb-linear';
const $d5b33d7c30034067$export$626af19ae879bdf6 = 'display-p3';
const $d5b33d7c30034067$export$c0dc1bc7e964761 = 'display-p3-linear';
const $d5b33d7c30034067$export$f197347d588c1b4a = 'linear';
const $d5b33d7c30034067$export$8d0a61916cc26abb = 'srgb';
const $d5b33d7c30034067$export$ce9118f9eaae3bb2 = 'rec709';
const $d5b33d7c30034067$export$ef371755dbe7f98a = 'p3';
const $d5b33d7c30034067$export$69433f11f42d5527 = 0;
const $d5b33d7c30034067$export$9f542ae4b5baca34 = 7680;
const $d5b33d7c30034067$export$8a4f28336ef203d3 = 7681;
const $d5b33d7c30034067$export$2928c0231297c036 = 7682;
const $d5b33d7c30034067$export$c0e9611c8a15f9a8 = 7683;
const $d5b33d7c30034067$export$9c2c08927385dcc4 = 34055;
const $d5b33d7c30034067$export$7c74ea00fa1315e6 = 34056;
const $d5b33d7c30034067$export$22e2e5726612443 = 5386;
const $d5b33d7c30034067$export$1343870698229224 = 512;
const $d5b33d7c30034067$export$8e1d8ed281997fa6 = 513;
const $d5b33d7c30034067$export$55648a1cde8329a7 = 514;
const $d5b33d7c30034067$export$2dff107857e6aca2 = 515;
const $d5b33d7c30034067$export$6f93765ab2f451a2 = 516;
const $d5b33d7c30034067$export$6f3fb2d2440f2b76 = 517;
const $d5b33d7c30034067$export$4119cf7b4c98fd5a = 518;
const $d5b33d7c30034067$export$14cf96713ddd97a8 = 519;
const $d5b33d7c30034067$export$d9e2d19a747baaab = 512;
const $d5b33d7c30034067$export$36bcf49c713b3eb7 = 513;
const $d5b33d7c30034067$export$66f28d946fc6a0d5 = 514;
const $d5b33d7c30034067$export$64eea11eb407ddf1 = 515;
const $d5b33d7c30034067$export$155af022118f3a38 = 516;
const $d5b33d7c30034067$export$67ab95dde6bed156 = 517;
const $d5b33d7c30034067$export$1cdcb70d53d65f61 = 518;
const $d5b33d7c30034067$export$187b73a3e352c145 = 519;
const $d5b33d7c30034067$export$763e8360f4d7f77d = 35044;
const $d5b33d7c30034067$export$8505d14ac8546ca = 35048;
const $d5b33d7c30034067$export$721e63549e51d81e = 35040;
const $d5b33d7c30034067$export$415731dc4f48e299 = 35045;
const $d5b33d7c30034067$export$9e809946455f13bc = 35049;
const $d5b33d7c30034067$export$2ed9499a35b5f832 = 35041;
const $d5b33d7c30034067$export$32ab2503ea19469a = 35046;
const $d5b33d7c30034067$export$ab4022c2c3f86315 = 35050;
const $d5b33d7c30034067$export$ba7f1db36a76a970 = 35042;
const $d5b33d7c30034067$export$43600cc67fabd9f = '100';
const $d5b33d7c30034067$export$f63012db5506e7dd = '300 es';
const $d5b33d7c30034067$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $d5b33d7c30034067$export$5a0e9190d10875d3 = 2000;
const $d5b33d7c30034067$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $d5b33d7c30034067$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $d5b33d7c30034067$var$_seed = 1234567;
const $d5b33d7c30034067$var$DEG2RAD = Math.PI / 180;
const $d5b33d7c30034067$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d5b33d7c30034067$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d5b33d7c30034067$var$_lut[d0 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 & 0xff] + $d5b33d7c30034067$var$_lut[d1 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d5b33d7c30034067$var$_lut[d1 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 & 0x3f | 0x80] + $d5b33d7c30034067$var$_lut[d2 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d2 >> 24 & 0xff] + $d5b33d7c30034067$var$_lut[d3 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d5b33d7c30034067$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d5b33d7c30034067$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d5b33d7c30034067$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d5b33d7c30034067$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d5b33d7c30034067$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d5b33d7c30034067$var$damp(x, y, lambda, dt) {
    return $d5b33d7c30034067$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d5b33d7c30034067$var$pingpong(x, length = 1) {
    return length - Math.abs($d5b33d7c30034067$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d5b33d7c30034067$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d5b33d7c30034067$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d5b33d7c30034067$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d5b33d7c30034067$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d5b33d7c30034067$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d5b33d7c30034067$var$seededRandom(s) {
    if (s !== undefined) $d5b33d7c30034067$var$_seed = s;
    // Mulberry32 generator
    let t = $d5b33d7c30034067$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d5b33d7c30034067$var$degToRad(degrees) {
    return degrees * $d5b33d7c30034067$var$DEG2RAD;
}
function $d5b33d7c30034067$var$radToDeg(radians) {
    return radians * $d5b33d7c30034067$var$RAD2DEG;
}
function $d5b33d7c30034067$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d5b33d7c30034067$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $d5b33d7c30034067$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $d5b33d7c30034067$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $d5b33d7c30034067$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $d5b33d7c30034067$var$DEG2RAD,
    RAD2DEG: $d5b33d7c30034067$var$RAD2DEG,
    generateUUID: $d5b33d7c30034067$var$generateUUID,
    clamp: $d5b33d7c30034067$var$clamp,
    euclideanModulo: $d5b33d7c30034067$var$euclideanModulo,
    mapLinear: $d5b33d7c30034067$var$mapLinear,
    inverseLerp: $d5b33d7c30034067$var$inverseLerp,
    lerp: $d5b33d7c30034067$var$lerp,
    damp: $d5b33d7c30034067$var$damp,
    pingpong: $d5b33d7c30034067$var$pingpong,
    smoothstep: $d5b33d7c30034067$var$smoothstep,
    smootherstep: $d5b33d7c30034067$var$smootherstep,
    randInt: $d5b33d7c30034067$var$randInt,
    randFloat: $d5b33d7c30034067$var$randFloat,
    randFloatSpread: $d5b33d7c30034067$var$randFloatSpread,
    seededRandom: $d5b33d7c30034067$var$seededRandom,
    degToRad: $d5b33d7c30034067$var$degToRad,
    radToDeg: $d5b33d7c30034067$var$radToDeg,
    isPowerOfTwo: $d5b33d7c30034067$var$isPowerOfTwo,
    ceilPowerOfTwo: $d5b33d7c30034067$var$ceilPowerOfTwo,
    floorPowerOfTwo: $d5b33d7c30034067$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $d5b33d7c30034067$var$setQuaternionFromProperEuler,
    normalize: $d5b33d7c30034067$var$normalize,
    denormalize: $d5b33d7c30034067$var$denormalize
};
class $d5b33d7c30034067$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $d5b33d7c30034067$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $d5b33d7c30034067$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $d5b33d7c30034067$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $d5b33d7c30034067$var$_m3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
function $d5b33d7c30034067$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $d5b33d7c30034067$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d5b33d7c30034067$var$getTypedArray(type, buffer) {
    return new $d5b33d7c30034067$var$TYPED_ARRAYS[type](buffer);
}
function $d5b33d7c30034067$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $d5b33d7c30034067$export$1033a2df66368859() {
    const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $d5b33d7c30034067$var$_cache = {};
function $d5b33d7c30034067$var$warnOnce(message) {
    if (message in $d5b33d7c30034067$var$_cache) return;
    $d5b33d7c30034067$var$_cache[message] = true;
    console.warn(message);
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().set(0.8224621, 0.177538, 0.0, 0.0331941, 0.9668058, 0.0, 0.0170827, 0.0723974, 0.9105199);
const $d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().set(1.2249401, -0.2249404, 0.0, -0.0420569, 1.0420571, 0.0, -0.0196376, -0.0786361, 1.0982735);
/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */ const $d5b33d7c30034067$var$COLOR_SPACES = {
    [$d5b33d7c30034067$export$42429b3acfb233a4]: {
        transfer: $d5b33d7c30034067$export$f197347d588c1b4a,
        primaries: $d5b33d7c30034067$export$ce9118f9eaae3bb2,
        toReference: (color)=>color,
        fromReference: (color)=>color
    },
    [$d5b33d7c30034067$export$561f394b24edfcaa]: {
        transfer: $d5b33d7c30034067$export$8d0a61916cc26abb,
        primaries: $d5b33d7c30034067$export$ce9118f9eaae3bb2,
        toReference: (color)=>color.convertSRGBToLinear(),
        fromReference: (color)=>color.convertLinearToSRGB()
    },
    [$d5b33d7c30034067$export$c0dc1bc7e964761]: {
        transfer: $d5b33d7c30034067$export$f197347d588c1b4a,
        primaries: $d5b33d7c30034067$export$ef371755dbe7f98a,
        toReference: (color)=>color.applyMatrix3($d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3)
    },
    [$d5b33d7c30034067$export$626af19ae879bdf6]: {
        transfer: $d5b33d7c30034067$export$8d0a61916cc26abb,
        primaries: $d5b33d7c30034067$export$ef371755dbe7f98a,
        toReference: (color)=>color.convertSRGBToLinear().applyMatrix3($d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB()
    }
};
const $d5b33d7c30034067$var$SUPPORTED_WORKING_COLOR_SPACES = new Set([
    $d5b33d7c30034067$export$42429b3acfb233a4,
    $d5b33d7c30034067$export$c0dc1bc7e964761
]);
const $d5b33d7c30034067$export$5e6fd513f44698c = {
    enabled: true,
    _workingColorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
    get legacyMode () {
        console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return this._workingColorSpace;
    },
    set workingColorSpace (colorSpace){
        if (!$d5b33d7c30034067$var$SUPPORTED_WORKING_COLOR_SPACES.has(colorSpace)) throw new Error(`Unsupported working color space, "${colorSpace}".`);
        this._workingColorSpace = colorSpace;
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToReference = $d5b33d7c30034067$var$COLOR_SPACES[sourceColorSpace].toReference;
        const targetFromReference = $d5b33d7c30034067$var$COLOR_SPACES[targetColorSpace].fromReference;
        return targetFromReference(sourceToReference(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this._workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this._workingColorSpace);
    },
    getPrimaries: function(colorSpace1) {
        return $d5b33d7c30034067$var$COLOR_SPACES[colorSpace1].primaries;
    },
    getTransfer: function(colorSpace1) {
        if (colorSpace1 === $d5b33d7c30034067$export$bfcb490c2dd3db51) return $d5b33d7c30034067$export$f197347d588c1b4a;
        return $d5b33d7c30034067$var$COLOR_SPACES[colorSpace1].transfer;
    }
};
function $d5b33d7c30034067$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $d5b33d7c30034067$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $d5b33d7c30034067$var$_canvas;
class $d5b33d7c30034067$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($d5b33d7c30034067$var$_canvas === undefined) $d5b33d7c30034067$var$_canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            $d5b33d7c30034067$var$_canvas.width = image.width;
            $d5b33d7c30034067$var$_canvas.height = image.height;
            const context = $d5b33d7c30034067$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $d5b33d7c30034067$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $d5b33d7c30034067$var$_sourceId = 0;
class $d5b33d7c30034067$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_sourceId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($d5b33d7c30034067$var$serializeImage(data[i].image));
                else url.push($d5b33d7c30034067$var$serializeImage(data[i]));
            } else // texture
            url = $d5b33d7c30034067$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $d5b33d7c30034067$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $d5b33d7c30034067$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $d5b33d7c30034067$var$_textureId = 0;
class $d5b33d7c30034067$export$5431306cf43de24a extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(image = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $d5b33d7c30034067$export$9d9334239a5a5e06, wrapT = $d5b33d7c30034067$export$9d9334239a5a5e06, magFilter = $d5b33d7c30034067$export$8a72f490b25c56c8, minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b, format = $d5b33d7c30034067$export$3f8bb04b555a363c, type = $d5b33d7c30034067$export$2e8ce08d3f6f5e10, anisotropy = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_textureId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $d5b33d7c30034067$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === 'string') this.colorSpace = colorSpace1;
        else {
            $d5b33d7c30034067$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
            this.colorSpace = colorSpace1 === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $d5b33d7c30034067$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $d5b33d7c30034067$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
        return this.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? $d5b33d7c30034067$export$f32388edbb32674 : $d5b33d7c30034067$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $d5b33d7c30034067$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
        this.colorSpace = encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
    }
}
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING = $d5b33d7c30034067$export$1beec6768cbb3d2d;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $d5b33d7c30034067$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $d5b33d7c30034067$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $d5b33d7c30034067$export$efcb1f8bf367cbfb extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $d5b33d7c30034067$var$warnOnce('THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.');
            options.colorSpace = options.encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            depthTexture: null,
            samples: 0
        }, options);
        this.texture = new $d5b33d7c30034067$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps;
        this.texture.internalFormat = options.internalFormat;
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$3c052beb2e51e23f extends $d5b33d7c30034067$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $d5b33d7c30034067$export$dfac6c8e811406a3 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$c77a02c11ed180c7 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$d7a3086320f856db extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$7ee06591009639df extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$bd934554fb721730 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $d5b33d7c30034067$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($d5b33d7c30034067$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $d5b33d7c30034067$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d5b33d7c30034067$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d5b33d7c30034067$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($d5b33d7c30034067$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d5b33d7c30034067$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d5b33d7c30034067$var$_vector$b = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$6f7d5a9418ab2aa3 {
    constructor(min = new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($d5b33d7c30034067$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($d5b33d7c30034067$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $d5b33d7c30034067$var$_vector$a);
                else $d5b33d7c30034067$var$_vector$a.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_vector$a.applyMatrix4(object.matrixWorld);
                this.expandByPoint($d5b33d7c30034067$var$_vector$a);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$3.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$3.copy(geometry.boundingBox);
                }
                $d5b33d7c30034067$var$_box$3.applyMatrix4(object.matrixWorld);
                this.union($d5b33d7c30034067$var$_box$3);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $d5b33d7c30034067$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $d5b33d7c30034067$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_extents.subVectors(this.max, $d5b33d7c30034067$var$_center);
        // translate triangle to aabb origin
        $d5b33d7c30034067$var$_v0$2.subVectors(triangle.a, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v1$7.subVectors(triangle.b, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v2$4.subVectors(triangle.c, $d5b33d7c30034067$var$_center);
        // compute edge vectors for triangle
        $d5b33d7c30034067$var$_f0.subVectors($d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v0$2);
        $d5b33d7c30034067$var$_f1.subVectors($d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_v1$7);
        $d5b33d7c30034067$var$_f2.subVectors($d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$d5b33d7c30034067$var$_f0.z,
            $d5b33d7c30034067$var$_f0.y,
            0,
            -$d5b33d7c30034067$var$_f1.z,
            $d5b33d7c30034067$var$_f1.y,
            0,
            -$d5b33d7c30034067$var$_f2.z,
            $d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f0.z,
            0,
            -$d5b33d7c30034067$var$_f0.x,
            $d5b33d7c30034067$var$_f1.z,
            0,
            -$d5b33d7c30034067$var$_f1.x,
            $d5b33d7c30034067$var$_f2.z,
            0,
            -$d5b33d7c30034067$var$_f2.x,
            -$d5b33d7c30034067$var$_f0.y,
            $d5b33d7c30034067$var$_f0.x,
            0,
            -$d5b33d7c30034067$var$_f1.y,
            $d5b33d7c30034067$var$_f1.x,
            0,
            -$d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f2.x,
            0
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $d5b33d7c30034067$var$_triangleNormal.crossVectors($d5b33d7c30034067$var$_f0, $d5b33d7c30034067$var$_f1);
        axes = [
            $d5b33d7c30034067$var$_triangleNormal.x,
            $d5b33d7c30034067$var$_triangleNormal.y,
            $d5b33d7c30034067$var$_triangleNormal.z
        ];
        return $d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($d5b33d7c30034067$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $d5b33d7c30034067$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $d5b33d7c30034067$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $d5b33d7c30034067$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $d5b33d7c30034067$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $d5b33d7c30034067$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $d5b33d7c30034067$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $d5b33d7c30034067$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $d5b33d7c30034067$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($d5b33d7c30034067$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_points = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
];
const $d5b33d7c30034067$var$_vector$a = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $d5b33d7c30034067$var$_v0$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
// triangle edge vectors
const $d5b33d7c30034067$var$_f0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_center = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_extents = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangleNormal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_testAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $d5b33d7c30034067$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($d5b33d7c30034067$var$_testAxis.x) + extents.y * Math.abs($d5b33d7c30034067$var$_testAxis.y) + extents.z * Math.abs($d5b33d7c30034067$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($d5b33d7c30034067$var$_testAxis);
        const p1 = v1.dot($d5b33d7c30034067$var$_testAxis);
        const p2 = v2.dot($d5b33d7c30034067$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $d5b33d7c30034067$var$_box$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_v1$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$805e8b72413ccaba {
    constructor(center = new $d5b33d7c30034067$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $d5b33d7c30034067$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $d5b33d7c30034067$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $d5b33d7c30034067$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($d5b33d7c30034067$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $d5b33d7c30034067$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).add($d5b33d7c30034067$var$_v2$3));
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).sub($d5b33d7c30034067$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$9 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segCenter = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segDir = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_diff = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$a186db52eed6d40e {
    constructor(origin = new $d5b33d7c30034067$export$64b5c384219d3699(), direction = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $d5b33d7c30034067$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $d5b33d7c30034067$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $d5b33d7c30034067$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $d5b33d7c30034067$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $d5b33d7c30034067$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $d5b33d7c30034067$var$_segDir.copy(v1).sub(v0).normalize();
        $d5b33d7c30034067$var$_diff.copy(this.origin).sub($d5b33d7c30034067$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($d5b33d7c30034067$var$_segDir);
        const b0 = $d5b33d7c30034067$var$_diff.dot(this.direction);
        const b1 = -$d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_segDir);
        const c = $d5b33d7c30034067$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($d5b33d7c30034067$var$_segCenter).addScaledVector($d5b33d7c30034067$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $d5b33d7c30034067$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $d5b33d7c30034067$var$_vector$9.dot(this.direction);
        const d2 = $d5b33d7c30034067$var$_vector$9.dot($d5b33d7c30034067$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $d5b33d7c30034067$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $d5b33d7c30034067$var$_edge1.subVectors(b, a);
        $d5b33d7c30034067$var$_edge2.subVectors(c, a);
        $d5b33d7c30034067$var$_normal$1.crossVectors($d5b33d7c30034067$var$_edge1, $d5b33d7c30034067$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($d5b33d7c30034067$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $d5b33d7c30034067$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($d5b33d7c30034067$var$_edge2.crossVectors($d5b33d7c30034067$var$_diff, $d5b33d7c30034067$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($d5b33d7c30034067$var$_edge1.cross($d5b33d7c30034067$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $d5b33d7c30034067$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($d5b33d7c30034067$var$_zero, q, $d5b33d7c30034067$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $d5b33d7c30034067$var$_z.subVectors(eye, target);
        if ($d5b33d7c30034067$var$_z.lengthSq() === 0) // eye and target are in the same position
        $d5b33d7c30034067$var$_z.z = 1;
        $d5b33d7c30034067$var$_z.normalize();
        $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        if ($d5b33d7c30034067$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $d5b33d7c30034067$var$_z.x += 0.0001;
            else $d5b33d7c30034067$var$_z.z += 0.0001;
            $d5b33d7c30034067$var$_z.normalize();
            $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        }
        $d5b33d7c30034067$var$_x.normalize();
        $d5b33d7c30034067$var$_y.crossVectors($d5b33d7c30034067$var$_z, $d5b33d7c30034067$var$_x);
        te[0] = $d5b33d7c30034067$var$_x.x;
        te[4] = $d5b33d7c30034067$var$_y.x;
        te[8] = $d5b33d7c30034067$var$_z.x;
        te[1] = $d5b33d7c30034067$var$_x.y;
        te[5] = $d5b33d7c30034067$var$_y.y;
        te[9] = $d5b33d7c30034067$var$_z.y;
        te[2] = $d5b33d7c30034067$var$_x.z;
        te[6] = $d5b33d7c30034067$var$_y.z;
        te[10] = $d5b33d7c30034067$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $d5b33d7c30034067$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $d5b33d7c30034067$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $d5b33d7c30034067$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $d5b33d7c30034067$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $d5b33d7c30034067$var$_m1$2.elements[0] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[1] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[2] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[4] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[5] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[6] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[8] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[9] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $d5b33d7c30034067$var$_v1$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_m1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_zero = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0);
const $d5b33d7c30034067$var$_one = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
const $d5b33d7c30034067$var$_x = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_y = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_z = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_quaternion$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($d5b33d7c30034067$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$d5b33d7c30034067$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($d5b33d7c30034067$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$d5b33d7c30034067$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($d5b33d7c30034067$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$d5b33d7c30034067$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $d5b33d7c30034067$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($d5b33d7c30034067$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $d5b33d7c30034067$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($d5b33d7c30034067$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $d5b33d7c30034067$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $d5b33d7c30034067$var$_object3DId = 0;
const $d5b33d7c30034067$var$_v1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_q1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_target = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_position$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_scale$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_xAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0);
const $d5b33d7c30034067$var$_yAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
const $d5b33d7c30034067$var$_zAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1);
const $d5b33d7c30034067$var$_addedEvent = {
    type: 'added'
};
const $d5b33d7c30034067$var$_removedEvent = {
    type: 'removed'
};
class $d5b33d7c30034067$export$e4dd07dff30cc924 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_object3DId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const rotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        const quaternion = new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
        const scale = new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $d5b33d7c30034067$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        });
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixWorld = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($d5b33d7c30034067$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $d5b33d7c30034067$var$_target.copy(x);
        else $d5b33d7c30034067$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_target, this.up);
        else $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_target, $d5b33d7c30034067$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
        if (parent) {
            $d5b33d7c30034067$var$_m1$1.extractRotation(parent.matrixWorld);
            $d5b33d7c30034067$var$_q1.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
            this.quaternion.premultiply($d5b33d7c30034067$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $d5b33d7c30034067$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($d5b33d7c30034067$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, target, $d5b33d7c30034067$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $d5b33d7c30034067$var$_v0$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vab = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vac = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbc = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vap = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vcp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$warnedGetUV = false;
class $d5b33d7c30034067$export$5a465592bfe74b48 {
    constructor(a = new $d5b33d7c30034067$export$64b5c384219d3699(), b = new $d5b33d7c30034067$export$64b5c384219d3699(), c = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $d5b33d7c30034067$var$_v0$1.subVectors(a, b);
        target.cross($d5b33d7c30034067$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, a);
        $d5b33d7c30034067$var$_v1$3.subVectors(b, a);
        $d5b33d7c30034067$var$_v2$2.subVectors(point, a);
        const dot00 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v0$1);
        const dot01 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v1$3);
        const dot02 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v2$2);
        const dot11 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v1$3);
        const dot12 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $d5b33d7c30034067$var$_v3$1);
        return $d5b33d7c30034067$var$_v3$1.x >= 0 && $d5b33d7c30034067$var$_v3$1.y >= 0 && $d5b33d7c30034067$var$_v3$1.x + $d5b33d7c30034067$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($d5b33d7c30034067$var$warnedGetUV === false) {
            console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');
            $d5b33d7c30034067$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $d5b33d7c30034067$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $d5b33d7c30034067$var$_v3$1.x);
        target.addScaledVector(v2, $d5b33d7c30034067$var$_v3$1.y);
        target.addScaledVector(v3, $d5b33d7c30034067$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, b);
        $d5b33d7c30034067$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $d5b33d7c30034067$var$_v0$1.subVectors(this.c, this.b);
        $d5b33d7c30034067$var$_v1$3.subVectors(this.a, this.b);
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($d5b33d7c30034067$var$warnedGetUV === false) {
            console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');
            $d5b33d7c30034067$var$warnedGetUV = true;
        }
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $d5b33d7c30034067$var$_vab.subVectors(b, a);
        $d5b33d7c30034067$var$_vac.subVectors(c, a);
        $d5b33d7c30034067$var$_vap.subVectors(p, a);
        const d1 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vap);
        const d2 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $d5b33d7c30034067$var$_vbp.subVectors(p, b);
        const d3 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vbp);
        const d4 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v);
        }
        $d5b33d7c30034067$var$_vcp.subVectors(p, c);
        const d5 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vcp);
        const d6 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $d5b33d7c30034067$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($d5b33d7c30034067$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v).addScaledVector($d5b33d7c30034067$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $d5b33d7c30034067$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $d5b33d7c30034067$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $d5b33d7c30034067$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $d5b33d7c30034067$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $d5b33d7c30034067$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $d5b33d7c30034067$var$euclideanModulo(h, 1);
        s = $d5b33d7c30034067$var$clamp(s, 0, 1);
        l = $d5b33d7c30034067$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $d5b33d7c30034067$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $d5b33d7c30034067$var$hue2rgb(q, p, h);
            this.b = $d5b33d7c30034067$var$hue2rgb(q, p, h - 1 / 3);
        }
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        // color keywords
        const hex = $d5b33d7c30034067$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
        this.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
        this.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
        this.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
        this.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        return Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.r * 255, 0, 255)) * 65536 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.g * 255, 0, 255)) * 256 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        target.r = $d5b33d7c30034067$var$_color.r;
        target.g = $d5b33d7c30034067$var$_color.g;
        target.b = $d5b33d7c30034067$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        if (colorSpace1 !== $d5b33d7c30034067$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        return this.setHSL($d5b33d7c30034067$var$_hslA.h + h, $d5b33d7c30034067$var$_hslA.s + s, $d5b33d7c30034067$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        color.getHSL($d5b33d7c30034067$var$_hslB);
        const h = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslB.h, alpha);
        const s = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslB.s, alpha);
        const l = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.l, $d5b33d7c30034067$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $d5b33d7c30034067$var$_color = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
$d5b33d7c30034067$export$892596cec99bc70e.NAMES = $d5b33d7c30034067$var$_colorKeywords;
let $d5b33d7c30034067$var$_materialId = 0;
class $d5b33d7c30034067$export$a2d8b23205c25948 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_materialId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $d5b33d7c30034067$export$5b29a26d96ee6af0;
        this.side = $d5b33d7c30034067$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $d5b33d7c30034067$export$d5773124e86cf28c;
        this.blendDst = $d5b33d7c30034067$export$11d468cc7f19e971;
        this.blendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = $d5b33d7c30034067$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $d5b33d7c30034067$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZPass = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $d5b33d7c30034067$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $d5b33d7c30034067$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $d5b33d7c30034067$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $d5b33d7c30034067$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $d5b33d7c30034067$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $d5b33d7c30034067$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
class $d5b33d7c30034067$export$55cbcc9b622fe1f5 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $d5b33d7c30034067$var$_tables = /*@__PURE__*/ $d5b33d7c30034067$var$_generateTables();
function $d5b33d7c30034067$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $d5b33d7c30034067$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $d5b33d7c30034067$var$clamp(val, -65504, 65504);
    $d5b33d7c30034067$var$_tables.floatView[0] = val;
    const f = $d5b33d7c30034067$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $d5b33d7c30034067$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $d5b33d7c30034067$var$_tables.shiftTable[e]);
}
// float16 to float32
function $d5b33d7c30034067$var$fromHalfFloat(val) {
    const m = val >> 10;
    $d5b33d7c30034067$var$_tables.uint32View[0] = $d5b33d7c30034067$var$_tables.mantissaTable[$d5b33d7c30034067$var$_tables.offsetTable[m] + (val & 0x3ff)] + $d5b33d7c30034067$var$_tables.exponentTable[m];
    return $d5b33d7c30034067$var$_tables.floatView[0];
}
const $d5b33d7c30034067$export$11ce8b759162cc80 = {
    toHalfFloat: $d5b33d7c30034067$var$toHalfFloat,
    fromHalfFloat: $d5b33d7c30034067$var$fromHalfFloat
};
const $d5b33d7c30034067$var$_vector$8 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $d5b33d7c30034067$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector2$1.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $d5b33d7c30034067$var$_vector2$1.x, $d5b33d7c30034067$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $d5b33d7c30034067$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $d5b33d7c30034067$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $d5b33d7c30034067$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
//
class $d5b33d7c30034067$export$f9ff2d6a20248cbf extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$cacc90cf35d11cdd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$baaa85a1a812c157 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$2b755a102ccdcefe extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$640a853f68025f2e extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$46b369aed2968a0a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$dbd3698c64958d69 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $d5b33d7c30034067$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        this.array[index + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
}
class $d5b33d7c30034067$export$cbe7a62641830ebd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$9e0ade74842adbb8 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $d5b33d7c30034067$var$_id$2 = 0;
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_obj = /*@__PURE__*/ new $d5b33d7c30034067$export$e4dd07dff30cc924();
const $d5b33d7c30034067$var$_offset = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_boxMorphTargets = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_vector$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$b7be63a67df8959 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id$2++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($d5b33d7c30034067$var$arrayNeedsUint32(index) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $d5b33d7c30034067$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $d5b33d7c30034067$var$_m1.makeRotationX(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $d5b33d7c30034067$var$_m1.makeRotationY(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $d5b33d7c30034067$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $d5b33d7c30034067$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $d5b33d7c30034067$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    lookAt(vector) {
        $d5b33d7c30034067$var$_obj.lookAt(vector);
        $d5b33d7c30034067$var$_obj.updateMatrix();
        this.applyMatrix4($d5b33d7c30034067$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($d5b33d7c30034067$var$_offset).negate();
        this.translate($d5b33d7c30034067$var$_offset.x, $d5b33d7c30034067$var$_offset.y, $d5b33d7c30034067$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$7.addVectors(this.boundingBox.min, $d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$7);
                    $d5b33d7c30034067$var$_vector$7.addVectors(this.boundingBox.max, $d5b33d7c30034067$var$_box$1.max);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $d5b33d7c30034067$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$7.addVectors($d5b33d7c30034067$var$_box$1.min, $d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$7);
                    $d5b33d7c30034067$var$_vector$7.addVectors($d5b33d7c30034067$var$_box$1.max, $d5b33d7c30034067$var$_boxMorphTargets.max);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$7);
                } else {
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.max);
                }
            }
            $d5b33d7c30034067$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $d5b33d7c30034067$var$_offset.fromBufferAttribute(position, j);
                        $d5b33d7c30034067$var$_vector$7.add($d5b33d7c30034067$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute('tangent').array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
            tan2[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        const vA = new $d5b33d7c30034067$export$64b5c384219d3699(), vB = new $d5b33d7c30034067$export$64b5c384219d3699(), vC = new $d5b33d7c30034067$export$64b5c384219d3699(), uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1(), sdir = new $d5b33d7c30034067$export$64b5c384219d3699(), tdir = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $d5b33d7c30034067$export$64b5c384219d3699(), tmp2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const n = new $d5b33d7c30034067$export$64b5c384219d3699(), n2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $d5b33d7c30034067$export$64b5c384219d3699(), pB = new $d5b33d7c30034067$export$64b5c384219d3699(), pC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const nA = new $d5b33d7c30034067$export$64b5c384219d3699(), nB = new $d5b33d7c30034067$export$64b5c384219d3699(), nC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const cb = new $d5b33d7c30034067$export$64b5c384219d3699(), ab = new $d5b33d7c30034067$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(normals, i);
            $d5b33d7c30034067$var$_vector$7.normalize();
            normals.setXYZ(i, $d5b33d7c30034067$var$_vector$7.x, $d5b33d7c30034067$var$_vector$7.y, $d5b33d7c30034067$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $d5b33d7c30034067$var$_inverseMatrix$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_sphereHitAt = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_normalA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPointWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e176487c05830cc5 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $d5b33d7c30034067$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $d5b33d7c30034067$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA, influence);
                else $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA.sub(target), influence);
            }
            target.add($d5b33d7c30034067$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$5.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($d5b33d7c30034067$var$_sphere$5.containsPoint($d5b33d7c30034067$var$_ray$3.origin) === false) {
            if ($d5b33d7c30034067$var$_ray$3.intersectSphere($d5b33d7c30034067$var$_sphere$5, $d5b33d7c30034067$var$_sphereHitAt) === null) return;
            if ($d5b33d7c30034067$var$_ray$3.origin.distanceToSquared($d5b33d7c30034067$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $d5b33d7c30034067$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $d5b33d7c30034067$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $d5b33d7c30034067$var$_intersectionPointWorld.copy(point);
    $d5b33d7c30034067$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $d5b33d7c30034067$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $d5b33d7c30034067$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $d5b33d7c30034067$var$_vA$1);
    object.getVertexPosition(b, $d5b33d7c30034067$var$_vB$1);
    object.getVertexPosition(c, $d5b33d7c30034067$var$_vC$1);
    const intersection = $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv1, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv1, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $d5b33d7c30034067$var$_normalA.fromBufferAttribute(normal, a);
            $d5b33d7c30034067$var$_normalB.fromBufferAttribute(normal, b);
            $d5b33d7c30034067$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_normalA, $d5b33d7c30034067$var$_normalB, $d5b33d7c30034067$var$_normalC, new $d5b33d7c30034067$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $d5b33d7c30034067$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $d5b33d7c30034067$export$5a465592bfe74b48.getNormal($d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $d5b33d7c30034067$export$33e43285f7406bd5 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $d5b33d7c30034067$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $d5b33d7c30034067$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $d5b33d7c30034067$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $d5b33d7c30034067$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $d5b33d7c30034067$export$d8ecdf8615bfea69 = {
    clone: $d5b33d7c30034067$var$cloneUniforms,
    merge: $d5b33d7c30034067$var$mergeUniforms
};
var $d5b33d7c30034067$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $d5b33d7c30034067$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $d5b33d7c30034067$export$83c7d75d550a8b0d extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $d5b33d7c30034067$var$default_vertex;
        this.fragmentShader = $d5b33d7c30034067$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $d5b33d7c30034067$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $d5b33d7c30034067$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $d5b33d7c30034067$export$79f141de891a5fed extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$74e4ae24825f68d7 extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $d5b33d7c30034067$var$fov = -90; // negative fov is not an error
const $d5b33d7c30034067$var$aspect = 1;
class $d5b33d7c30034067$export$d0cdd0bd804995de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $d5b33d7c30034067$export$ee2e5a18258a4049 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $d5b33d7c30034067$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $d5b33d7c30034067$export$ac386671d651941e extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $d5b33d7c30034067$var$warnOnce('THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.');
            options.colorSpace = options.encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.texture = new $d5b33d7c30034067$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $d5b33d7c30034067$export$33e43285f7406bd5(5, 5, 5);
        const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $d5b33d7c30034067$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            blending: $d5b33d7c30034067$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
        const camera = new $d5b33d7c30034067$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $d5b33d7c30034067$var$_vector1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
class $d5b33d7c30034067$export$7ff5ac152ef991b0 {
    constructor(normal = new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $d5b33d7c30034067$var$_vector1.subVectors(c, b).cross($d5b33d7c30034067$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($d5b33d7c30034067$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $d5b33d7c30034067$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($d5b33d7c30034067$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_sphere$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$35efe6f4c85463d2 {
    constructor(p0 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p1 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p2 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p3 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p4 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p5 = new $d5b33d7c30034067$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $d5b33d7c30034067$var$_sphere$4.center.set(0, 0, 0);
        $d5b33d7c30034067$var$_sphere$4.radius = 0.7071067811865476;
        $d5b33d7c30034067$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $d5b33d7c30034067$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $d5b33d7c30034067$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $d5b33d7c30034067$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($d5b33d7c30034067$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $d5b33d7c30034067$export$967d831af31f69ce extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $d5b33d7c30034067$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5b33d7c30034067$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn sRGBTransferOETF( value );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $d5b33d7c30034067$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tanisotropyV /= material.anisotropy;\n\tmaterial.anisotropy = saturate( material.anisotropy );\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5b33d7c30034067$var$alphahash_fragment,
    alphahash_pars_fragment: $d5b33d7c30034067$var$alphahash_pars_fragment,
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5b33d7c30034067$var$colorspace_fragment,
    colorspace_pars_fragment: $d5b33d7c30034067$var$colorspace_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_fragment: $d5b33d7c30034067$var$lightmap_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    opaque_fragment: $d5b33d7c30034067$var$opaque_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(1, 1, 1), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $d5b33d7c30034067$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $d5b33d7c30034067$export$8d0a61916cc26abb;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(2, 2), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $d5b33d7c30034067$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $d5b33d7c30034067$export$8d0a61916cc26abb;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $d5b33d7c30034067$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl.constructor.name === 'WebGL2RenderingContext';
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), viewNormalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $d5b33d7c30034067$export$d64030b316d3b087) texture.mapping = $d5b33d7c30034067$export$8759762a6477f2c4;
        else if (mapping === $d5b33d7c30034067$export$ee99d97d46898098) texture.mapping = $d5b33d7c30034067$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$9ebf355ee4ed261b extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new $d5b33d7c30034067$export$9ebf355ee4ed261b();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
let $d5b33d7c30034067$var$_oldTarget = null;
let $d5b33d7c30034067$var$_oldActiveCubeFace = 0;
let $d5b33d7c30034067$var$_oldActiveMipmapLevel = 0;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget, $d5b33d7c30034067$var$_oldActiveCubeFace, $d5b33d7c30034067$var$_oldActiveMipmapLevel);
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $d5b33d7c30034067$export$2697304443f382bc,
            format: $d5b33d7c30034067$export$3f8bb04b555a363c,
            colorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $d5b33d7c30034067$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $d5b33d7c30034067$export$b7be63a67df8959();
        planes.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $d5b33d7c30034067$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $d5b33d7c30034067$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $d5b33d7c30034067$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5b33d7c30034067$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098;
            const isCubeMap = mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($d5b33d7c30034067$var$arrayNeedsUint32(indices) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $d5b33d7c30034067$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $d5b33d7c30034067$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $d5b33d7c30034067$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener('dispose', disposeTexture);
                }
                geometry.addEventListener('dispose', disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
            program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
            program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($d5b33d7c30034067$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($d5b33d7c30034067$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                    if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$5431306cf43de24a();
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$dfac6c8e811406a3();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$d7a3086320f856db();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $d5b33d7c30034067$var$emptyTexture, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $d5b33d7c30034067$var$COMPLETION_STATUS_KHR = 0x91B1;
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace1) {
    const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
    const encodingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(colorSpace1);
    let gamutMapping;
    if (workingPrimaries === encodingPrimaries) gamutMapping = '';
    else if (workingPrimaries === $d5b33d7c30034067$export$ef371755dbe7f98a && encodingPrimaries === $d5b33d7c30034067$export$ce9118f9eaae3bb2) gamutMapping = 'LinearDisplayP3ToLinearSRGB';
    else if (workingPrimaries === $d5b33d7c30034067$export$ce9118f9eaae3bb2 && encodingPrimaries === $d5b33d7c30034067$export$ef371755dbe7f98a) gamutMapping = 'LinearSRGBToLinearDisplayP3';
    switch(colorSpace1){
        case $d5b33d7c30034067$export$42429b3acfb233a4:
        case $d5b33d7c30034067$export$c0dc1bc7e964761:
            return [
                gamutMapping,
                'LinearTransferOETF'
            ];
        case $d5b33d7c30034067$export$561f394b24edfcaa:
        case $d5b33d7c30034067$export$626af19ae879bdf6:
            return [
                gamutMapping,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space:', colorSpace1);
            return [
                gamutMapping,
                'LinearTransferOETF'
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace1);
    return `vec4 ${functionName}( vec4 value ) { return ${components[0]}( ${components[1]}( value ) ); }`;
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $d5b33d7c30034067$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $d5b33d7c30034067$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $d5b33d7c30034067$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $d5b33d7c30034067$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $d5b33d7c30034067$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $d5b33d7c30034067$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
const $d5b33d7c30034067$var$shaderChunkMap = new Map([
    [
        'encodings_fragment',
        'colorspace_fragment'
    ],
    [
        'encodings_pars_fragment',
        'colorspace_pars_fragment'
    ],
    [
        'output_fragment',
        'opaque_fragment'
    ]
]);
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    let string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5b33d7c30034067$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5b33d7c30034067$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $d5b33d7c30034067$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$8759762a6477f2c4:
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $d5b33d7c30034067$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $d5b33d7c30034067$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $d5b33d7c30034067$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $d5b33d7c30034067$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? '' : $d5b33d7c30034067$var$generateExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5b33d7c30034067$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $d5b33d7c30034067$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            'precision mediump sampler2DArray;',
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            'precision mediump sampler2DArray;',
            '#define varying in',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $d5b33d7c30034067$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id$1 = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $d5b33d7c30034067$export$89312ce47c0ca777();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            useLegacyLights: renderer._useLegacyLights,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(material.map.colorSpace) === $d5b33d7c30034067$export$8d0a61916cc26abb,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $d5b33d7c30034067$export$3b296b6f144d5b03,
            flipSided: material.side === $d5b33d7c30034067$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has('EXT_shader_texture_lod'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = $d5b33d7c30034067$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        skyColor: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        groundColor: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfWidth: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfHeight: new $d5b33d7c30034067$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions, capabilities) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    const vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const matrix4 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const matrix42 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$2698c22ec13825db extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $d5b33d7c30034067$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $d5b33d7c30034067$export$33e187ed002f2a19 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $d5b33d7c30034067$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    const _shadowMapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewportSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(), _depthMaterial = new $d5b33d7c30034067$export$2698c22ec13825db({
        depthPacking: $d5b33d7c30034067$export$8f910f4c4f73df11
    }), _distanceMaterial = new $d5b33d7c30034067$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$d5b33d7c30034067$export$2ede184fc2998901]: $d5b33d7c30034067$export$d9f0486e75b5ace,
        [$d5b33d7c30034067$export$d9f0486e75b5ace]: $d5b33d7c30034067$export$2ede184fc2998901,
        [$d5b33d7c30034067$export$3b296b6f144d5b03]: $d5b33d7c30034067$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $d5b33d7c30034067$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $d5b33d7c30034067$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $d5b33d7c30034067$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4 ? {
                    minFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
                    magFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $d5b33d7c30034067$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $d5b33d7c30034067$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $d5b33d7c30034067$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $d5b33d7c30034067$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $d5b33d7c30034067$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $d5b33d7c30034067$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $d5b33d7c30034067$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $d5b33d7c30034067$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $d5b33d7c30034067$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $d5b33d7c30034067$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $d5b33d7c30034067$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($d5b33d7c30034067$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$d5b33d7c30034067$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$d5b33d7c30034067$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$d5b33d7c30034067$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$d5b33d7c30034067$export$2110f05edf778d3d]: gl.ZERO,
        [$d5b33d7c30034067$export$8805bad65e24940e]: gl.ONE,
        [$d5b33d7c30034067$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$d5b33d7c30034067$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$d5b33d7c30034067$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$d5b33d7c30034067$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$d5b33d7c30034067$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$d5b33d7c30034067$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$d5b33d7c30034067$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$d5b33d7c30034067$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$d5b33d7c30034067$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA,
        [$d5b33d7c30034067$export$7dd8f434fd59075]: gl.CONSTANT_COLOR,
        [$d5b33d7c30034067$export$99c8d898a9afbcee]: gl.ONE_MINUS_CONSTANT_COLOR,
        [$d5b33d7c30034067$export$310cd2be38d13b56]: gl.CONSTANT_ALPHA,
        [$d5b33d7c30034067$export$db77b8fbcf45dbf4]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === $d5b33d7c30034067$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $d5b33d7c30034067$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $d5b33d7c30034067$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $d5b33d7c30034067$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $d5b33d7c30034067$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $d5b33d7c30034067$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $d5b33d7c30034067$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $d5b33d7c30034067$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $d5b33d7c30034067$var$createElementNS('canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $d5b33d7c30034067$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $d5b33d7c30034067$var$isPowerOfTwo(image.width) && $d5b33d7c30034067$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? $d5b33d7c30034067$export$f197347d588c1b4a : $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace1);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $d5b33d7c30034067$export$727aa5ec3fe39bf0 || f === $d5b33d7c30034067$export$d129e38cf6feaa8c || f === $d5b33d7c30034067$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$d5b33d7c30034067$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$d5b33d7c30034067$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$d5b33d7c30034067$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$d5b33d7c30034067$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$d5b33d7c30034067$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$d5b33d7c30034067$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$d5b33d7c30034067$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$d5b33d7c30034067$export$d9e2d19a747baaab]: _gl.NEVER,
        [$d5b33d7c30034067$export$187b73a3e352c145]: _gl.ALWAYS,
        [$d5b33d7c30034067$export$36bcf49c713b3eb7]: _gl.LESS,
        [$d5b33d7c30034067$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$d5b33d7c30034067$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$d5b33d7c30034067$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$d5b33d7c30034067$export$155af022118f3a38]: _gl.GREATER,
        [$d5b33d7c30034067$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.magFilter === $d5b33d7c30034067$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $d5b33d7c30034067$export$d2327c1afe5bfdf2 && texture.minFilter !== $d5b33d7c30034067$export$5d8599b6a933fb1b) return;
            if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $d5b33d7c30034067$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 ? null : $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
                // validation checks for WebGL 1
                if (texture.format === $d5b33d7c30034067$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $d5b33d7c30034067$export$c63dc51868b06a9d && texture.type !== $d5b33d7c30034067$export$c3c7fc4518ebba96) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                        texture.type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $d5b33d7c30034067$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $d5b33d7c30034067$export$6c8ea339bfab1301) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                        texture.type = $d5b33d7c30034067$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 ? null : $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = isWebGL2 === true ? _gl.DEPTH_COMPONENT24 : _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++){
                if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $d5b33d7c30034067$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $d5b33d7c30034067$export$42429b3acfb233a4 && colorSpace1 !== $d5b33d7c30034067$export$bfcb490c2dd3db51) {
            // sRGB
            if ($d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace1) === $d5b33d7c30034067$export$8d0a61916cc26abb) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has('EXT_sRGB') === true && format === $d5b33d7c30034067$export$3f8bb04b555a363c) {
                        texture.format = $d5b33d7c30034067$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $d5b33d7c30034067$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $d5b33d7c30034067$export$3f8bb04b555a363c || type !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51) {
        let extension;
        const transfer = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace1);
        if (p === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $d5b33d7c30034067$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $d5b33d7c30034067$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $d5b33d7c30034067$export$545fce0311a9796a) return gl.BYTE;
        if (p === $d5b33d7c30034067$export$88572337f312435f) return gl.SHORT;
        if (p === $d5b33d7c30034067$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $d5b33d7c30034067$export$5c612977753abe2) return gl.INT;
        if (p === $d5b33d7c30034067$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $d5b33d7c30034067$export$f6d331659b644596) return gl.FLOAT;
        if (p === $d5b33d7c30034067$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $d5b33d7c30034067$export$988473390501ed4b) return gl.ALPHA;
        if (p === $d5b33d7c30034067$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $d5b33d7c30034067$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $d5b33d7c30034067$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $d5b33d7c30034067$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $d5b33d7c30034067$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $d5b33d7c30034067$export$ca1dce8b5e1de74d) {
            extension = extensions.get('EXT_sRGB');
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $d5b33d7c30034067$export$4e041a7967d15c4b) return gl.RED;
        if (p === $d5b33d7c30034067$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $d5b33d7c30034067$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $d5b33d7c30034067$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $d5b33d7c30034067$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $d5b33d7c30034067$export$21d1799c6d552fc0 || p === $d5b33d7c30034067$export$afa304c3e981b668 || p === $d5b33d7c30034067$export$d2a1a68024a3e56c || p === $d5b33d7c30034067$export$9a79c424327dacf9) {
            if (transfer === $d5b33d7c30034067$export$8d0a61916cc26abb) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $d5b33d7c30034067$export$19ada9bbb1af3573 || p === $d5b33d7c30034067$export$d0f0355bb3d948e4 || p === $d5b33d7c30034067$export$b82296714358084c || p === $d5b33d7c30034067$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $d5b33d7c30034067$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $d5b33d7c30034067$export$7800993ef8106a6a || p === $d5b33d7c30034067$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$7800993ef8106a6a) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $d5b33d7c30034067$export$23ed8300a860e7d8) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48 || p === $d5b33d7c30034067$export$68880cd325f8b2fb || p === $d5b33d7c30034067$export$7d2c0be323373d95 || p === $d5b33d7c30034067$export$22b52da301fc3a3e || p === $d5b33d7c30034067$export$c009e2cb4a66485e || p === $d5b33d7c30034067$export$118fff5afa255b63 || p === $d5b33d7c30034067$export$120713c829ae0667 || p === $d5b33d7c30034067$export$c79eeabbf53313e9 || p === $d5b33d7c30034067$export$443cf6567cdd6424 || p === $d5b33d7c30034067$export$6573984fc9840780 || p === $d5b33d7c30034067$export$e7aee563f30091de || p === $d5b33d7c30034067$export$2eb8634622ddeab7 || p === $d5b33d7c30034067$export$202b1ce7b5d25742 || p === $d5b33d7c30034067$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $d5b33d7c30034067$export$68880cd325f8b2fb) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $d5b33d7c30034067$export$7d2c0be323373d95) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $d5b33d7c30034067$export$22b52da301fc3a3e) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $d5b33d7c30034067$export$c009e2cb4a66485e) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $d5b33d7c30034067$export$118fff5afa255b63) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $d5b33d7c30034067$export$120713c829ae0667) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $d5b33d7c30034067$export$c79eeabbf53313e9) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $d5b33d7c30034067$export$443cf6567cdd6424) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $d5b33d7c30034067$export$6573984fc9840780) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $d5b33d7c30034067$export$e7aee563f30091de) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $d5b33d7c30034067$export$2eb8634622ddeab7) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $d5b33d7c30034067$export$202b1ce7b5d25742) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $d5b33d7c30034067$export$18ab77abd087e467) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $d5b33d7c30034067$export$ce40b115e188bc81 || p === $d5b33d7c30034067$export$d279c5c4bac5121e || p === $d5b33d7c30034067$export$cde52d17225fdbd3) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $d5b33d7c30034067$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $d5b33d7c30034067$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $d5b33d7c30034067$export$b1688df4c4c21670 || p === $d5b33d7c30034067$export$fc15e5d8261eed58 || p === $d5b33d7c30034067$export$d220f6ade8463a0f || p === $d5b33d7c30034067$export$768646d09dc1b6ef) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $d5b33d7c30034067$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $d5b33d7c30034067$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $d5b33d7c30034067$export$56b937d9e5581166 extends $d5b33d7c30034067$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $d5b33d7c30034067$export$eb2fcfdbd7ba97d4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $d5b33d7c30034067$var$_moveEvent = {
    type: 'move'
};
class $d5b33d7c30034067$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($d5b33d7c30034067$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $d5b33d7c30034067$export$fc830aa069cc8c2f extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $d5b33d7c30034067$export$c1b6b5136be58045;
        if (format !== $d5b33d7c30034067$export$c1b6b5136be58045 && format !== $d5b33d7c30034067$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $d5b33d7c30034067$export$c1b6b5136be58045) type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
        if (type === undefined && format === $d5b33d7c30034067$export$1e113ac2d0905829) type = $d5b33d7c30034067$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
class $d5b33d7c30034067$var$WebXRManager extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $d5b33d7c30034067$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $d5b33d7c30034067$export$1e113ac2d0905829 : $d5b33d7c30034067$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $d5b33d7c30034067$export$6c8ea339bfab1301 : $d5b33d7c30034067$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        depthTexture: new $d5b33d7c30034067$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        const cameraRPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $d5b33d7c30034067$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer._useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === 'number') {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number') cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === 'number') {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number') {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $d5b33d7c30034067$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        // physical lights
        this._useLegacyLights = false;
        // tone mapping
        this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        const _vector2 = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const _vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${$d5b33d7c30034067$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    'webgl2',
                    'webgl',
                    'experimental-webgl'
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
            if (typeof WebGLRenderingContext !== 'undefined' && _gl instanceof WebGLRenderingContext) console.warn('THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.');
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    'rangeMin': 1,
                    'rangeMax': 1,
                    'precision': 1
                };
            };
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions, capabilities);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $d5b33d7c30034067$export$c200e7d26f592f21 || targetFormat === $d5b33d7c30034067$export$1ba1c45f9f77d4d7 || targetFormat === $d5b33d7c30034067$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $d5b33d7c30034067$export$2e8ce08d3f6f5e10 || targetType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || targetType === $d5b33d7c30034067$export$c63dc51868b06a9d || targetType === $d5b33d7c30034067$export$6c8ea339bfab1301 || targetType === $d5b33d7c30034067$export$b3969b01faf587f2 || targetType === $d5b33d7c30034067$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this._useLegacyLights);
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this._useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') ? $d5b33d7c30034067$export$2697304443f382bc : $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                minFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b,
                samples: isWebGL2 ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($d5b33d7c30034067$var$floorPowerOfTwo(_vector2.x), $d5b33d7c30034067$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                    } else console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                        console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $d5b33d7c30034067$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $d5b33d7c30034067$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                    if (textureType !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $d5b33d7c30034067$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace1) {
        this._outputColorSpace = colorSpace1;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = colorSpace1 === $d5b33d7c30034067$export$626af19ae879bdf6 ? 'display-p3' : 'srgb';
        gl.unpackColorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace === $d5b33d7c30034067$export$c0dc1bc7e964761 ? 'display-p3' : 'srgb';
    }
    get physicallyCorrectLights() {
        console.warn('THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn('THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn('THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.');
        return this.outputColorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? $d5b33d7c30034067$export$f32388edbb32674 : $d5b33d7c30034067$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn('THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.');
        this.outputColorSpace = encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$42429b3acfb233a4;
    }
    get useLegacyLights() {
        console.warn('THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.');
        return this._useLegacyLights;
    }
    set useLegacyLights(value) {
        console.warn('THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.');
        this._useLegacyLights = value;
    }
}
class $d5b33d7c30034067$export$a2f65229194348f9 extends $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
}
$d5b33d7c30034067$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $d5b33d7c30034067$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $d5b33d7c30034067$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $d5b33d7c30034067$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $d5b33d7c30034067$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $d5b33d7c30034067$export$38af1803e3442a7f extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
}
class $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d5b33d7c30034067$var$_vector$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $d5b33d7c30034067$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $d5b33d7c30034067$export$5ec7dd1c6994bf8e extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $d5b33d7c30034067$var$_geometry;
const $d5b33d7c30034067$var$_intersectPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_worldScale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_mvPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_alignedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_rotatedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_viewWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$3075603db8e6204c extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(material = new $d5b33d7c30034067$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($d5b33d7c30034067$var$_geometry === undefined) {
            $d5b33d7c30034067$var$_geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $d5b33d7c30034067$export$3d5cd879f108f53f(float32Array, 5);
            $d5b33d7c30034067$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $d5b33d7c30034067$var$_geometry.setAttribute('position', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $d5b33d7c30034067$var$_geometry.setAttribute('uv', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $d5b33d7c30034067$var$_geometry;
        this.material = material;
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $d5b33d7c30034067$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $d5b33d7c30034067$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $d5b33d7c30034067$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $d5b33d7c30034067$var$_worldScale.multiplyScalar(-$d5b33d7c30034067$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vA.set(-0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vC.set(0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$_uvA.set(0, 0);
        $d5b33d7c30034067$var$_uvB.set(1, 0);
        $d5b33d7c30034067$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, false, $d5b33d7c30034067$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(-0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
            $d5b33d7c30034067$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_vB, false, $d5b33d7c30034067$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $d5b33d7c30034067$var$_intersectPoint.clone(),
            uv: $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectPoint, $d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_uvA, $d5b33d7c30034067$var$_uvB, $d5b33d7c30034067$var$_uvC, new $d5b33d7c30034067$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $d5b33d7c30034067$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $d5b33d7c30034067$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $d5b33d7c30034067$var$_rotatedPosition.x = cos * $d5b33d7c30034067$var$_alignedPosition.x - sin * $d5b33d7c30034067$var$_alignedPosition.y;
        $d5b33d7c30034067$var$_rotatedPosition.y = sin * $d5b33d7c30034067$var$_alignedPosition.x + cos * $d5b33d7c30034067$var$_alignedPosition.y;
    } else $d5b33d7c30034067$var$_rotatedPosition.copy($d5b33d7c30034067$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $d5b33d7c30034067$var$_rotatedPosition.x;
    vertexPosition.y += $d5b33d7c30034067$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($d5b33d7c30034067$var$_viewWorldMatrix);
}
const $d5b33d7c30034067$var$_v1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$112e7237be0c5f30 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $d5b33d7c30034067$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $d5b33d7c30034067$var$_v1$2.distanceTo($d5b33d7c30034067$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $d5b33d7c30034067$var$_basePosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_skinIndex = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_skinWeight = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_vector3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vertex = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_sphere$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_inverseMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
class $d5b33d7c30034067$export$b303577035157ecf extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = $d5b33d7c30034067$export$2595a3798997538;
        this.bindMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $d5b33d7c30034067$var$_vertex);
            this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $d5b33d7c30034067$var$_vertex);
            this.boundingSphere.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$3.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $d5b33d7c30034067$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$2.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $d5b33d7c30034067$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $d5b33d7c30034067$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $d5b33d7c30034067$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $d5b33d7c30034067$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $d5b33d7c30034067$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $d5b33d7c30034067$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $d5b33d7c30034067$var$_skinIndex.getComponent(i);
                $d5b33d7c30034067$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($d5b33d7c30034067$var$_vector3.copy($d5b33d7c30034067$var$_basePosition).applyMatrix4($d5b33d7c30034067$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn('THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.');
        return this.applyBoneTransform(index, vector);
    }
}
class $d5b33d7c30034067$export$b127726e56765aa4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $d5b33d7c30034067$export$b691f601014eabe1 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $d5b33d7c30034067$var$_offsetMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $d5b33d7c30034067$var$_identityMatrix;
            $d5b33d7c30034067$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $d5b33d7c30034067$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $d5b33d7c30034067$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $d5b33d7c30034067$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $d5b33d7c30034067$export$b691f601014eabe1(boneMatrices, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $d5b33d7c30034067$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $d5b33d7c30034067$export$32ea87a8b54d744a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $d5b33d7c30034067$var$_instanceLocalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceIntersects = [];
const $d5b33d7c30034067$var$_box3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_identity = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_mesh = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_sphere$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$f3c979c331175ad7 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $d5b33d7c30034067$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_box3.copy(geometry.boundingBox).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingBox.union($d5b33d7c30034067$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingSphere.union($d5b33d7c30034067$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $d5b33d7c30034067$var$_mesh.geometry = this.geometry;
        $d5b33d7c30034067$var$_mesh.material = this.material;
        if ($d5b33d7c30034067$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$2.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $d5b33d7c30034067$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $d5b33d7c30034067$var$_mesh.matrixWorld = $d5b33d7c30034067$var$_instanceWorldMatrix;
            $d5b33d7c30034067$var$_mesh.raycast(raycaster, $d5b33d7c30034067$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $d5b33d7c30034067$var$_instanceIntersects.length; i < l; i++){
                const intersect = $d5b33d7c30034067$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$fbaaa33907730a0c extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_start$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_inverseMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$17d680238e50603e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $d5b33d7c30034067$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $d5b33d7c30034067$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $d5b33d7c30034067$var$_start$1.distanceTo($d5b33d7c30034067$var$_end$1);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$1.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$1.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$1) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$1.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vEnd = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interSegment = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interRay = new $d5b33d7c30034067$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $d5b33d7c30034067$var$_start = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$ff1ed10fedfdd604 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $d5b33d7c30034067$var$_start.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $d5b33d7c30034067$var$_start.distanceTo($d5b33d7c30034067$var$_end);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $d5b33d7c30034067$export$f85a24d745e4f17d extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $d5b33d7c30034067$export$a178c45366ce5d6b extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_inverseMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_position$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$1c787534cb11aa3e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $d5b33d7c30034067$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $d5b33d7c30034067$export$6e09d1edf8d5a25c extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$9270d786f73ce6fe extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$3466bac9141a5cc4 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$export$5fe6b8e34b274fcb extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
    }
}
class $d5b33d7c30034067$export$d80173634de65bff extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $d5b33d7c30034067$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $d5b33d7c30034067$export$f7189e49152d1c13 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $d5b33d7c30034067$export$c977b3e384af9ae1() : new $d5b33d7c30034067$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $d5b33d7c30034067$export$64b5c384219d3699();
        const mat = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $d5b33d7c30034067$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        binormals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($d5b33d7c30034067$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($d5b33d7c30034067$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $d5b33d7c30034067$export$3f87a931616cde04 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $d5b33d7c30034067$export$b1eedc9aab6300e8 extends $d5b33d7c30034067$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $d5b33d7c30034067$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $d5b33d7c30034067$var$tmp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$px = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$py = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$pz = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
class $d5b33d7c30034067$export$b9146b27c24b744c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $d5b33d7c30034067$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $d5b33d7c30034067$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $d5b33d7c30034067$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $d5b33d7c30034067$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $d5b33d7c30034067$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $d5b33d7c30034067$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $d5b33d7c30034067$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $d5b33d7c30034067$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $d5b33d7c30034067$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $d5b33d7c30034067$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($d5b33d7c30034067$var$px.calc(weight), $d5b33d7c30034067$var$py.calc(weight), $d5b33d7c30034067$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $d5b33d7c30034067$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $d5b33d7c30034067$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezier(t, p0, p1, p2) {
    return $d5b33d7c30034067$var$QuadraticBezierP0(t, p0) + $d5b33d7c30034067$var$QuadraticBezierP1(t, p1) + $d5b33d7c30034067$var$QuadraticBezierP2(t, p2);
}
//
function $d5b33d7c30034067$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $d5b33d7c30034067$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezier(t, p0, p1, p2, p3) {
    return $d5b33d7c30034067$var$CubicBezierP0(t, p0) + $d5b33d7c30034067$var$CubicBezierP1(t, p1) + $d5b33d7c30034067$var$CubicBezierP2(t, p2) + $d5b33d7c30034067$var$CubicBezierP3(t, p3);
}
class $d5b33d7c30034067$export$e36650d36468bb39 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v3 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$13d5f1c9525f246c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699(), v3 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $d5b33d7c30034067$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$ab2e07e76531a47e extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$1fdfd9d9cf487600 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$5938c4ee491a43ad extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$bf3f4c7e459f90fc extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $d5b33d7c30034067$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$d3bdd77da77afc1b extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($d5b33d7c30034067$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $d5b33d7c30034067$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $d5b33d7c30034067$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $d5b33d7c30034067$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $d5b33d7c30034067$export$b9146b27c24b744c,
    CubicBezierCurve: $d5b33d7c30034067$export$e36650d36468bb39,
    CubicBezierCurve3: $d5b33d7c30034067$export$13d5f1c9525f246c,
    EllipseCurve: $d5b33d7c30034067$export$3f87a931616cde04,
    LineCurve: $d5b33d7c30034067$export$ab2e07e76531a47e,
    LineCurve3: $d5b33d7c30034067$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $d5b33d7c30034067$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $d5b33d7c30034067$export$bf3f4c7e459f90fc,
    SplineCurve: $d5b33d7c30034067$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $d5b33d7c30034067$export$4aaf9b66af1bbf2c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $d5b33d7c30034067$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $d5b33d7c30034067$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $d5b33d7c30034067$export$4b2950bdac9b6ee9 extends $d5b33d7c30034067$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $d5b33d7c30034067$export$ab2e07e76531a47e(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $d5b33d7c30034067$export$5938c4ee491a43ad(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCPx, aCPy), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $d5b33d7c30034067$export$e36650d36468bb39(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP1x, aCP1y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP2x, aCP2y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $d5b33d7c30034067$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $d5b33d7c30034067$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $d5b33d7c30034067$export$6d839803fcd1882c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(points = [
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $d5b33d7c30034067$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const curNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const prevNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $d5b33d7c30034067$export$41680e8551036033 extends $d5b33d7c30034067$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $d5b33d7c30034067$export$d5c0e8d607467193 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$68f745719dbe5198 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$a7a48974f285c9b3 extends $d5b33d7c30034067$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$60e57a7d3f20ff65 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            const centroid = new $d5b33d7c30034067$export$64b5c384219d3699();
            const uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $d5b33d7c30034067$export$c0babfeb8708fc9c extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangle = /*@__PURE__*/ new $d5b33d7c30034067$export$5a465592bfe74b48();
class $d5b33d7c30034067$export$4730b1542707547f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($d5b33d7c30034067$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $d5b33d7c30034067$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $d5b33d7c30034067$var$_triangle.getNormal($d5b33d7c30034067$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $d5b33d7c30034067$var$_triangle[vertKeys[j]];
                    const v1 = $d5b33d7c30034067$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($d5b33d7c30034067$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $d5b33d7c30034067$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $d5b33d7c30034067$var$_v0.fromBufferAttribute(positionAttr, index0);
                $d5b33d7c30034067$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($d5b33d7c30034067$var$_v0.x, $d5b33d7c30034067$var$_v0.y, $d5b33d7c30034067$var$_v0.z);
                vertices.push($d5b33d7c30034067$var$_v1$1.x, $d5b33d7c30034067$var$_v1$1.y, $d5b33d7c30034067$var$_v1$1.z);
            }
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $d5b33d7c30034067$export$6428a7f2611ef1fa extends $d5b33d7c30034067$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $d5b33d7c30034067$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $d5b33d7c30034067$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $d5b33d7c30034067$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $d5b33d7c30034067$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $d5b33d7c30034067$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $d5b33d7c30034067$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d5b33d7c30034067$var$equals(last, last.next)) {
        $d5b33d7c30034067$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $d5b33d7c30034067$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d5b33d7c30034067$var$equals(p, p.next) || $d5b33d7c30034067$var$area(p.prev, p, p.next) === 0)) {
            $d5b33d7c30034067$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $d5b33d7c30034067$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) : $d5b33d7c30034067$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $d5b33d7c30034067$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d5b33d7c30034067$var$earcutLinked($d5b33d7c30034067$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $d5b33d7c30034067$var$cureLocalIntersections($d5b33d7c30034067$var$filterPoints(ear), triangles, dim);
                $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d5b33d7c30034067$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $d5b33d7c30034067$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $d5b33d7c30034067$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $d5b33d7c30034067$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $d5b33d7c30034067$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$intersects(a, p, p.next, b) && $d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $d5b33d7c30034067$var$removeNode(p);
            $d5b33d7c30034067$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $d5b33d7c30034067$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $d5b33d7c30034067$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d5b33d7c30034067$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $d5b33d7c30034067$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $d5b33d7c30034067$var$filterPoints(a, a.next);
                c = $d5b33d7c30034067$var$filterPoints(c, c.next);
                // run earcut on each half
                $d5b33d7c30034067$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $d5b33d7c30034067$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d5b33d7c30034067$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d5b33d7c30034067$var$getLeftmost(list));
    }
    queue.sort($d5b33d7c30034067$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $d5b33d7c30034067$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $d5b33d7c30034067$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $d5b33d7c30034067$var$eliminateHole(hole, outerNode) {
    const bridge = $d5b33d7c30034067$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $d5b33d7c30034067$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $d5b33d7c30034067$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $d5b33d7c30034067$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d5b33d7c30034067$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d5b33d7c30034067$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($d5b33d7c30034067$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $d5b33d7c30034067$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $d5b33d7c30034067$var$sectorContainsSector(m, p) {
    return $d5b33d7c30034067$var$area(m.prev, m, p.prev) < 0 && $d5b33d7c30034067$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $d5b33d7c30034067$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $d5b33d7c30034067$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d5b33d7c30034067$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d5b33d7c30034067$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $d5b33d7c30034067$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $d5b33d7c30034067$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d5b33d7c30034067$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d5b33d7c30034067$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a) && $d5b33d7c30034067$var$middleInside(a, b) && // locally visible
    ($d5b33d7c30034067$var$area(a.prev, a, b.prev) || $d5b33d7c30034067$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$area(a.prev, a, a.next) > 0 && $d5b33d7c30034067$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $d5b33d7c30034067$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $d5b33d7c30034067$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $d5b33d7c30034067$var$intersects(p1, q1, p2, q2) {
    const o1 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, p2));
    const o2 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, q2));
    const o3 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, p1));
    const o4 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $d5b33d7c30034067$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $d5b33d7c30034067$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $d5b33d7c30034067$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $d5b33d7c30034067$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $d5b33d7c30034067$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $d5b33d7c30034067$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $d5b33d7c30034067$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d5b33d7c30034067$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $d5b33d7c30034067$var$locallyInside(a, b) {
    return $d5b33d7c30034067$var$area(a.prev, a, a.next) < 0 ? $d5b33d7c30034067$var$area(a, b, a.next) >= 0 && $d5b33d7c30034067$var$area(a, a.prev, b) >= 0 : $d5b33d7c30034067$var$area(a, b, a.prev) < 0 || $d5b33d7c30034067$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $d5b33d7c30034067$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d5b33d7c30034067$var$splitPolygon(a, b) {
    const a2 = new $d5b33d7c30034067$var$Node(a.i, a.x, a.y), b2 = new $d5b33d7c30034067$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $d5b33d7c30034067$var$insertNode(i, x, y, last) {
    const p = new $d5b33d7c30034067$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d5b33d7c30034067$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d5b33d7c30034067$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $d5b33d7c30034067$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $d5b33d7c30034067$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $d5b33d7c30034067$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $d5b33d7c30034067$var$removeDupEndPts(contour);
        $d5b33d7c30034067$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($d5b33d7c30034067$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $d5b33d7c30034067$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $d5b33d7c30034067$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $d5b33d7c30034067$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $d5b33d7c30034067$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $d5b33d7c30034067$export$598697a1efa63ca7 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $d5b33d7c30034067$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $d5b33d7c30034067$export$64b5c384219d3699();
                normal = new $d5b33d7c30034067$export$64b5c384219d3699();
                position2 = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $d5b33d7c30034067$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $d5b33d7c30034067$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $d5b33d7c30034067$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $d5b33d7c30034067$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, a_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, b_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $d5b33d7c30034067$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $d5b33d7c30034067$export$9567cc828c9535da extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$1954e2b809fe361e extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$68cb731f50f614af extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$57a29a1c803e9065 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $d5b33d7c30034067$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $d5b33d7c30034067$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $d5b33d7c30034067$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $d5b33d7c30034067$export$1b417fc3b307a251 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$fb3f7adc68bd6e02 extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$a2312a2a1fa56495 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $d5b33d7c30034067$export$77e9bfadfb9ab8c8 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P1 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const B = new $d5b33d7c30034067$export$64b5c384219d3699();
        const T = new $d5b33d7c30034067$export$64b5c384219d3699();
        const N = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $d5b33d7c30034067$export$7897d9d48904490c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(path = new $d5b33d7c30034067$export$bf3f4c7e459f90fc(new $d5b33d7c30034067$export$64b5c384219d3699(-1, -1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let P = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $d5b33d7c30034067$export$7897d9d48904490c(new $d5b33d7c30034067$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $d5b33d7c30034067$export$4b739da06d24892b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $d5b33d7c30034067$export$64b5c384219d3699();
            const end = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $d5b33d7c30034067$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $d5b33d7c30034067$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $d5b33d7c30034067$export$33e43285f7406bd5,
    CapsuleGeometry: $d5b33d7c30034067$export$41680e8551036033,
    CircleGeometry: $d5b33d7c30034067$export$d5c0e8d607467193,
    ConeGeometry: $d5b33d7c30034067$export$a7a48974f285c9b3,
    CylinderGeometry: $d5b33d7c30034067$export$68f745719dbe5198,
    DodecahedronGeometry: $d5b33d7c30034067$export$c0babfeb8708fc9c,
    EdgesGeometry: $d5b33d7c30034067$export$4730b1542707547f,
    ExtrudeGeometry: $d5b33d7c30034067$export$598697a1efa63ca7,
    IcosahedronGeometry: $d5b33d7c30034067$export$9567cc828c9535da,
    LatheGeometry: $d5b33d7c30034067$export$6d839803fcd1882c,
    OctahedronGeometry: $d5b33d7c30034067$export$1954e2b809fe361e,
    PlaneGeometry: $d5b33d7c30034067$export$967d831af31f69ce,
    PolyhedronGeometry: $d5b33d7c30034067$export$60e57a7d3f20ff65,
    RingGeometry: $d5b33d7c30034067$export$68cb731f50f614af,
    ShapeGeometry: $d5b33d7c30034067$export$57a29a1c803e9065,
    SphereGeometry: $d5b33d7c30034067$export$1b417fc3b307a251,
    TetrahedronGeometry: $d5b33d7c30034067$export$fb3f7adc68bd6e02,
    TorusGeometry: $d5b33d7c30034067$export$a2312a2a1fa56495,
    TorusKnotGeometry: $d5b33d7c30034067$export$77e9bfadfb9ab8c8,
    TubeGeometry: $d5b33d7c30034067$export$7897d9d48904490c,
    WireframeGeometry: $d5b33d7c30034067$export$4b739da06d24892b
});
class $d5b33d7c30034067$export$e8564da406055a3 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$21c421a2e1df9d22 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $d5b33d7c30034067$export$f2980790215acccd extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$28d04986c4269c9f extends $d5b33d7c30034067$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $d5b33d7c30034067$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $d5b33d7c30034067$export$24c72f71cbaf0678 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $d5b33d7c30034067$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$df893cf97e765622 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$bfe8c0a091f41ae7 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $d5b33d7c30034067$export$5023a9a8114806b8 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$6f5fef6235ec12ee extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$327886a3efaeaebe extends $d5b33d7c30034067$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $d5b33d7c30034067$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $d5b33d7c30034067$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $d5b33d7c30034067$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $d5b33d7c30034067$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $d5b33d7c30034067$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $d5b33d7c30034067$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $d5b33d7c30034067$var$convertArray(times, track.times.constructor);
        track.values = $d5b33d7c30034067$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $d5b33d7c30034067$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $d5b33d7c30034067$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $d5b33d7c30034067$export$d875e029ef558d3;
    return targetClip;
}
const $d5b33d7c30034067$export$7ee8caa573e71ad1 = {
    convertArray: $d5b33d7c30034067$var$convertArray,
    isTypedArray: $d5b33d7c30034067$var$isTypedArray,
    getKeyframeOrder: $d5b33d7c30034067$var$getKeyframeOrder,
    sortedArray: $d5b33d7c30034067$var$sortedArray,
    flattenJSON: $d5b33d7c30034067$var$flattenJSON,
    subclip: $d5b33d7c30034067$var$subclip,
    makeClipAdditive: $d5b33d7c30034067$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $d5b33d7c30034067$export$3646682e7a3959 extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $d5b33d7c30034067$export$a8e6009059f51e1a extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $d5b33d7c30034067$export$fb9758ef7ef8d5cc extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $d5b33d7c30034067$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $d5b33d7c30034067$var$convertArray(times, this.TimeBufferType);
        this.values = $d5b33d7c30034067$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $d5b33d7c30034067$var$convertArray(track.times, Array),
                'values': $d5b33d7c30034067$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $d5b33d7c30034067$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $d5b33d7c30034067$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $d5b33d7c30034067$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $d5b33d7c30034067$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $d5b33d7c30034067$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $d5b33d7c30034067$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $d5b33d7c30034067$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $d5b33d7c30034067$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($d5b33d7c30034067$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $d5b33d7c30034067$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $d5b33d7c30034067$export$d3a344b98cf0b775 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $d5b33d7c30034067$export$83444c5d885347d8 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $d5b33d7c30034067$export$d45f0d1a4d9a9314 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $d5b33d7c30034067$export$2db1cfb7923d931e extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $d5b33d7c30034067$export$b8043f12b5aafbd7 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $d5b33d7c30034067$export$6ce41d4f3a8df9cd extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $d5b33d7c30034067$export$5ce2dcb4cc9f2bff extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $d5b33d7c30034067$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $d5b33d7c30034067$var$getKeyframeOrder(times);
            times = $d5b33d7c30034067$var$sortedArray(times, 1, order);
            values = $d5b33d7c30034067$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $d5b33d7c30034067$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $d5b33d7c30034067$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $d5b33d7c30034067$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $d5b33d7c30034067$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $d5b33d7c30034067$export$83444c5d885347d8;
        case 'quaternion':
            return $d5b33d7c30034067$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $d5b33d7c30034067$export$d3a344b98cf0b775;
        case 'string':
            return $d5b33d7c30034067$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $d5b33d7c30034067$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $d5b33d7c30034067$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $d5b33d7c30034067$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $d5b33d7c30034067$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $d5b33d7c30034067$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $d5b33d7c30034067$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $d5b33d7c30034067$export$99cc795e99919eed();
class $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $d5b33d7c30034067$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$d5b33d7c30034067$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $d5b33d7c30034067$var$loading = {};
class $d5b33d7c30034067$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $d5b33d7c30034067$export$98435a25b5cf7b2b extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($d5b33d7c30034067$var$loading[url] !== undefined) {
            $d5b33d7c30034067$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $d5b33d7c30034067$var$loading[url] = [];
        $d5b33d7c30034067$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $d5b33d7c30034067$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('Content-Length') || response.headers.get('X-File-Size');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $d5b33d7c30034067$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, data);
            const callbacks = $d5b33d7c30034067$var$loading[url];
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $d5b33d7c30034067$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $d5b33d7c30034067$export$29711c7e14f61db extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$bd73ce947a280350 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $d5b33d7c30034067$export$3466bac9141a5cc4();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$8905ce1c7a2464a1 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $d5b33d7c30034067$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $d5b33d7c30034067$export$2ec114afc2cf6308 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
        texture.colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$792d8a18f2c55855 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $d5b33d7c30034067$export$b691f601014eabe1();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$fd1bfc71f64c538c extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$6ecadb6ed240d696 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $d5b33d7c30034067$export$8d474f55edbb9624 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $d5b33d7c30034067$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $d5b33d7c30034067$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($d5b33d7c30034067$var$_lightPositionWorld$1);
        $d5b33d7c30034067$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($d5b33d7c30034067$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $d5b33d7c30034067$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($d5b33d7c30034067$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $d5b33d7c30034067$var$SpotLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $d5b33d7c30034067$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $d5b33d7c30034067$export$81495cbb73897362 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $d5b33d7c30034067$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$PointLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
        $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
        $d5b33d7c30034067$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($d5b33d7c30034067$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
        $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix);
    }
}
class $d5b33d7c30034067$export$4c9c1cb3f0b6f455 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $d5b33d7c30034067$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$var$DirectionalLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $d5b33d7c30034067$export$3fea33cc9972c868 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.shadow = new $d5b33d7c30034067$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$export$af279bfef9ec2c96 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $d5b33d7c30034067$export$61db2d908bbd2429 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $d5b33d7c30034067$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $d5b33d7c30034067$export$e7ef036e309b38d2 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(sh = new $d5b33d7c30034067$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3bd6d323353dcf96 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = $d5b33d7c30034067$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $d5b33d7c30034067$export$e8564da406055a3,
            SpriteMaterial: $d5b33d7c30034067$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $d5b33d7c30034067$export$21c421a2e1df9d22,
            ShaderMaterial: $d5b33d7c30034067$export$83c7d75d550a8b0d,
            PointsMaterial: $d5b33d7c30034067$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $d5b33d7c30034067$export$28d04986c4269c9f,
            MeshStandardMaterial: $d5b33d7c30034067$export$f2980790215acccd,
            MeshPhongMaterial: $d5b33d7c30034067$export$24c72f71cbaf0678,
            MeshToonMaterial: $d5b33d7c30034067$export$df893cf97e765622,
            MeshNormalMaterial: $d5b33d7c30034067$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $d5b33d7c30034067$export$5023a9a8114806b8,
            MeshDepthMaterial: $d5b33d7c30034067$export$2698c22ec13825db,
            MeshDistanceMaterial: $d5b33d7c30034067$export$33e187ed002f2a19,
            MeshBasicMaterial: $d5b33d7c30034067$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $d5b33d7c30034067$export$6f5fef6235ec12ee,
            LineDashedMaterial: $d5b33d7c30034067$export$327886a3efaeaebe,
            LineBasicMaterial: $d5b33d7c30034067$export$fbaaa33907730a0c,
            Material: $d5b33d7c30034067$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $d5b33d7c30034067$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $d5b33d7c30034067$export$231f009cbe414146 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $d5b33d7c30034067$export$dc275bb96327833a extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $d5b33d7c30034067$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $d5b33d7c30034067$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $d5b33d7c30034067$export$231f009cbe414146() : new $d5b33d7c30034067$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $d5b33d7c30034067$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $d5b33d7c30034067$export$32ea87a8b54d744a : $d5b33d7c30034067$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $d5b33d7c30034067$export$40110c8505c5ad19 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $d5b33d7c30034067$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $d5b33d7c30034067$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $d5b33d7c30034067$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $d5b33d7c30034067$var$Geometries) geometry = $d5b33d7c30034067$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $d5b33d7c30034067$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $d5b33d7c30034067$export$99cc795e99919eed(onLoad);
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $d5b33d7c30034067$export$b691f601014eabe1();
                else texture = new $d5b33d7c30034067$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $d5b33d7c30034067$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $d5b33d7c30034067$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $d5b33d7c30034067$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $d5b33d7c30034067$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $d5b33d7c30034067$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case 'PerspectiveCamera':
                object = new $d5b33d7c30034067$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $d5b33d7c30034067$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $d5b33d7c30034067$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $d5b33d7c30034067$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new $d5b33d7c30034067$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $d5b33d7c30034067$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $d5b33d7c30034067$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new $d5b33d7c30034067$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $d5b33d7c30034067$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $d5b33d7c30034067$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'LOD':
                object = new $d5b33d7c30034067$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $d5b33d7c30034067$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $d5b33d7c30034067$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $d5b33d7c30034067$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $d5b33d7c30034067$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $d5b33d7c30034067$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $d5b33d7c30034067$export$b127726e56765aa4();
                break;
            default:
                object = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $d5b33d7c30034067$var$TEXTURE_MAPPING = {
    UVMapping: $d5b33d7c30034067$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $d5b33d7c30034067$export$8759762a6477f2c4,
    CubeRefractionMapping: $d5b33d7c30034067$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $d5b33d7c30034067$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $d5b33d7c30034067$export$ee99d97d46898098,
    CubeUVReflectionMapping: $d5b33d7c30034067$export$dbf3e70ff37af79
};
const $d5b33d7c30034067$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $d5b33d7c30034067$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $d5b33d7c30034067$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $d5b33d7c30034067$export$c7e7c00b14f51a4f
};
const $d5b33d7c30034067$var$TEXTURE_FILTER = {
    NearestFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $d5b33d7c30034067$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $d5b33d7c30034067$export$d2327c1afe5bfdf2,
    LinearFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $d5b33d7c30034067$export$19a719f377145a13,
    LinearMipmapLinearFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b
};
class $d5b33d7c30034067$export$52286b55c4a9b51f extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $d5b33d7c30034067$var$_context;
class $d5b33d7c30034067$export$fcbc63750ec2a81f {
    static getContext() {
        if ($d5b33d7c30034067$var$_context === undefined) $d5b33d7c30034067$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $d5b33d7c30034067$var$_context;
    }
    static setContext(value) {
        $d5b33d7c30034067$var$_context = value;
    }
}
class $d5b33d7c30034067$export$d8d5fccfbf47714e extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $d5b33d7c30034067$var$_eyeRight = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_eyeLeft = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_projectionMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $d5b33d7c30034067$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($d5b33d7c30034067$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $d5b33d7c30034067$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $d5b33d7c30034067$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeRight);
    }
}
class $d5b33d7c30034067$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $d5b33d7c30034067$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $d5b33d7c30034067$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $d5b33d7c30034067$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $d5b33d7c30034067$var$_position$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$8a1b810c6fde8951 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$1, $d5b33d7c30034067$var$_quaternion$1, $d5b33d7c30034067$var$_scale$1);
        $d5b33d7c30034067$var$_orientation$1.set(0, 0, -1).applyQuaternion($d5b33d7c30034067$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($d5b33d7c30034067$var$_position$1.x, $d5b33d7c30034067$var$_position$1.y, $d5b33d7c30034067$var$_position$1.z);
            listener.setOrientation($d5b33d7c30034067$var$_orientation$1.x, $d5b33d7c30034067$var$_orientation$1.y, $d5b33d7c30034067$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $d5b33d7c30034067$export$153755f98d9861de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $d5b33d7c30034067$var$_position = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b3e397ef1832507 extends $d5b33d7c30034067$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position, $d5b33d7c30034067$var$_quaternion, $d5b33d7c30034067$var$_scale);
        $d5b33d7c30034067$var$_orientation.set(0, 0, 1).applyQuaternion($d5b33d7c30034067$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.z, endTime);
        } else {
            panner.setPosition($d5b33d7c30034067$var$_position.x, $d5b33d7c30034067$var$_position.y, $d5b33d7c30034067$var$_position.z);
            panner.setOrientation($d5b33d7c30034067$var$_orientation.x, $d5b33d7c30034067$var$_orientation.y, $d5b33d7c30034067$var$_orientation.z);
        }
    }
}
class $d5b33d7c30034067$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $d5b33d7c30034067$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $d5b33d7c30034067$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $d5b33d7c30034067$var$_reservedRe = new RegExp('[' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $d5b33d7c30034067$var$_wordChar = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']';
const $d5b33d7c30034067$var$_wordCharOrDot = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $d5b33d7c30034067$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $d5b33d7c30034067$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $d5b33d7c30034067$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $d5b33d7c30034067$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $d5b33d7c30034067$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
const $d5b33d7c30034067$var$_trackRe = new RegExp("^" + $d5b33d7c30034067$var$_directoryRe + $d5b33d7c30034067$var$_nodeRe + $d5b33d7c30034067$var$_objectRe + $d5b33d7c30034067$var$_propertyRe + '$');
const $d5b33d7c30034067$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $d5b33d7c30034067$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $d5b33d7c30034067$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $d5b33d7c30034067$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $d5b33d7c30034067$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($d5b33d7c30034067$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $d5b33d7c30034067$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($d5b33d7c30034067$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$d5b33d7c30034067$export$7bf70fcf9f891893.Composite = $d5b33d7c30034067$var$Composite;
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_direct,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_array,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $d5b33d7c30034067$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $d5b33d7c30034067$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $d5b33d7c30034067$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $d5b33d7c30034067$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $d5b33d7c30034067$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $d5b33d7c30034067$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $d5b33d7c30034067$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $d5b33d7c30034067$export$24a4ccb5099273b5;
            settings.endingEnd = $d5b33d7c30034067$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingStart = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingEnd = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $d5b33d7c30034067$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $d5b33d7c30034067$export$fbd77e5aefaa0102 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $d5b33d7c30034067$export$dfe0af1ca1acb78a($d5b33d7c30034067$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $d5b33d7c30034067$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $d5b33d7c30034067$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $d5b33d7c30034067$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $d5b33d7c30034067$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $d5b33d7c30034067$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$export$c412d5ffe1f79209 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id++
        });
        this.name = '';
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$25ec0e1af1389358 extends $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $d5b33d7c30034067$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $d5b33d7c30034067$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $d5b33d7c30034067$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $d5b33d7c30034067$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
}
function $d5b33d7c30034067$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $d5b33d7c30034067$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $d5b33d7c30034067$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($d5b33d7c30034067$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $d5b33d7c30034067$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$60f553fa130f08b0 {
    constructor(min = new $d5b33d7c30034067$export$c977b3e384af9ae1(Infinity, Infinity), max = new $d5b33d7c30034067$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_startP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_startEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e0ba6359f1954fd3 {
    constructor(start = new $d5b33d7c30034067$export$64b5c384219d3699(), end = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $d5b33d7c30034067$var$_startP.subVectors(point, this.start);
        $d5b33d7c30034067$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startEnd);
        const startEnd_startP = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $d5b33d7c30034067$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b14638ffdd81e68 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $d5b33d7c30034067$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $d5b33d7c30034067$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($d5b33d7c30034067$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $d5b33d7c30034067$var$_vector$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_boneMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_matrixWorldInv = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$5277df3c9e732259 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $d5b33d7c30034067$var$getBoneList(object);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $d5b33d7c30034067$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.parent.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j + 1, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $d5b33d7c30034067$var$getBoneList(object.children[i]));
    return boneList;
}
class $d5b33d7c30034067$export$9a9291685b9e4023 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $d5b33d7c30034067$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $d5b33d7c30034067$var$_vector$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_color1 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
const $d5b33d7c30034067$var$_color2 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
class $d5b33d7c30034067$export$8dca15f13f4f8172 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $d5b33d7c30034067$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $d5b33d7c30034067$export$8dea267bd6bde117(colors, 3));
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $d5b33d7c30034067$var$_color1.copy(this.light.color);
            $d5b33d7c30034067$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $d5b33d7c30034067$var$_color1 : $d5b33d7c30034067$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($d5b33d7c30034067$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $d5b33d7c30034067$export$3875d39926561055 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$361430a10f533cd3 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $d5b33d7c30034067$var$_v1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$f8e434dc14203e7d extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $d5b33d7c30034067$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $d5b33d7c30034067$var$_v3.subVectors($d5b33d7c30034067$var$_v2, $d5b33d7c30034067$var$_v1);
        this.lightPlane.lookAt($d5b33d7c30034067$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($d5b33d7c30034067$var$_v2);
        this.targetLine.scale.z = $d5b33d7c30034067$var$_v3.length();
    }
}
const $d5b33d7c30034067$var$_vector = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_camera = /*@__PURE__*/ new $d5b33d7c30034067$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $d5b33d7c30034067$export$ed8e93f853cd795 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $d5b33d7c30034067$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $d5b33d7c30034067$export$892596cec99bc70e(0xff0000);
        const colorUp = new $d5b33d7c30034067$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        const colorCross = new $d5b33d7c30034067$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $d5b33d7c30034067$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $d5b33d7c30034067$var$setPoint('c', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, -1);
        $d5b33d7c30034067$var$setPoint('t', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, 1);
        // near
        $d5b33d7c30034067$var$setPoint('n1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, -1);
        $d5b33d7c30034067$var$setPoint('n4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, -1);
        // far
        $d5b33d7c30034067$var$setPoint('f1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, 1);
        $d5b33d7c30034067$var$setPoint('f4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, 1);
        // up
        $d5b33d7c30034067$var$setPoint('u1', pointMap, geometry, $d5b33d7c30034067$var$_camera, w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u2', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h * 2, -1);
        // cross
        $d5b33d7c30034067$var$setPoint('cf1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, 1);
        $d5b33d7c30034067$var$setPoint('cf4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, 1);
        $d5b33d7c30034067$var$setPoint('cn1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, -1);
        $d5b33d7c30034067$var$setPoint('cn4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $d5b33d7c30034067$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $d5b33d7c30034067$var$_vector.x, $d5b33d7c30034067$var$_vector.y, $d5b33d7c30034067$var$_vector.z);
    }
}
const $d5b33d7c30034067$var$_box = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
class $d5b33d7c30034067$export$38a664cc862a6a9d extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $d5b33d7c30034067$var$_box.setFromObject(this.object);
        if ($d5b33d7c30034067$var$_box.isEmpty()) return;
        const min = $d5b33d7c30034067$var$_box.min;
        const max = $d5b33d7c30034067$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$ce39f4bb96c9a290 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$a34fe8156c66e5d7 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry2, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $d5b33d7c30034067$var$_axis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$_lineGeometry, $d5b33d7c30034067$var$_coneGeometry;
class $d5b33d7c30034067$export$a3008e7bd8d2cbe7 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1), origin = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($d5b33d7c30034067$var$_lineGeometry === undefined) {
            $d5b33d7c30034067$var$_lineGeometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            $d5b33d7c30034067$var$_lineGeometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $d5b33d7c30034067$var$_coneGeometry = new $d5b33d7c30034067$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $d5b33d7c30034067$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $d5b33d7c30034067$export$17d680238e50603e($d5b33d7c30034067$var$_lineGeometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $d5b33d7c30034067$export$e176487c05830cc5($d5b33d7c30034067$var$_coneGeometry, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $d5b33d7c30034067$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($d5b33d7c30034067$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $d5b33d7c30034067$export$6c8303f35b8578fd extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $d5b33d7c30034067$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $d5b33d7c30034067$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $d5b33d7c30034067$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $d5b33d7c30034067$export$3545e07a80636437;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $c393f2421b1ab54b$exports = {};
'use strict';

$c393f2421b1ab54b$exports = (parcelRequire("02ePV"));


var $af9e91ea6e32034a$exports = {};
'use strict';
Object.defineProperty($af9e91ea6e32034a$exports, '__esModule', {
    value: true
});

var $acw62 = parcelRequire("acw62");
function $af9e91ea6e32034a$var$createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn('[DEPRECATED] Please use `subscribeWithSelector` middleware');
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var $af9e91ea6e32034a$var$isSSR = typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var $af9e91ea6e32034a$var$useIsomorphicLayoutEffect = $af9e91ea6e32034a$var$isSSR ? $acw62.useEffect : $acw62.useLayoutEffect;
function $af9e91ea6e32034a$var$create(createState) {
    var api = typeof createState === 'function' ? $af9e91ea6e32034a$var$createStore(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = $acw62.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = $acw62.useRef(state);
        var selectorRef = $acw62.useRef(selector);
        var equalityFnRef = $acw62.useRef(equalityFn);
        var erroredRef = $acw62.useRef(false);
        var currentSliceRef = $acw62.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $af9e91ea6e32034a$var$useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = $acw62.useRef(state);
        $af9e91ea6e32034a$var$useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        var sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        $acw62.useDebugValue(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn('[useStore, api] = create() is deprecated and will be removed in v4');
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
$af9e91ea6e32034a$exports["default"] = $af9e91ea6e32034a$var$create;


var $5785509ae5140e70$exports = {};
'use strict';

$5785509ae5140e70$exports = (parcelRequire("8RuUj"));


var $cc7d8ebd00fdedf2$exports = {};
'use strict';

$cc7d8ebd00fdedf2$exports = (parcelRequire("lJYlP"));


const $f681624d9766226e$var$isPromise = (promise)=>typeof promise === 'object' && typeof promise.then === 'function';
const $f681624d9766226e$var$globalCache = [];
function $f681624d9766226e$var$shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
function $f681624d9766226e$var$query(fn, keys = null, preload = false, config = {}) {
    // If no keys were given, the function is the key
    if (keys === null) keys = [
        fn
    ];
    for (const entry of $f681624d9766226e$var$globalCache)// Find a match
    if ($f681624d9766226e$var$shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, 'error')) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, 'response')) {
            if (config.lifespan && config.lifespan > 0) {
                if (entry.timeout) clearTimeout(entry.timeout);
                entry.timeout = setTimeout(entry.remove, config.lifespan);
            }
            return entry.response;
        } // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys: keys,
        equal: config.equal,
        remove: ()=>{
            const index = $f681624d9766226e$var$globalCache.indexOf(entry);
            if (index !== -1) $f681624d9766226e$var$globalCache.splice(index, 1);
        },
        promise: ($f681624d9766226e$var$isPromise(fn) ? fn : fn(...keys) // When it resolves, store its value
        ).then((response)=>{
            entry.response = response; // Remove the entry in time if a lifespan was given
            if (config.lifespan && config.lifespan > 0) entry.timeout = setTimeout(entry.remove, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    $f681624d9766226e$var$globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const $f681624d9766226e$export$a1428c8f7ba796e8 = (fn, keys, config)=>$f681624d9766226e$var$query(fn, keys, false, config);
const $f681624d9766226e$export$513ccb98c53b8039 = (fn, keys, config)=>void $f681624d9766226e$var$query(fn, keys, true, config);
const $f681624d9766226e$export$4d3fb11e950abb9e = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = $f681624d9766226e$var$globalCache.find((entry)=>$f681624d9766226e$var$shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const $f681624d9766226e$export$42ffd38884aecdac = (keys)=>{
    if (keys === undefined || keys.length === 0) $f681624d9766226e$var$globalCache.splice(0, $f681624d9766226e$var$globalCache.length);
    else {
        const entry = $f681624d9766226e$var$globalCache.find((entry)=>$f681624d9766226e$var$shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) entry.remove();
    }
};


var $2ec6beadbaf9c031$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
const $2ec6beadbaf9c031$var$catalogue = {};
const $2ec6beadbaf9c031$export$f1e1789686576879 = (objects)=>void Object.assign($2ec6beadbaf9c031$var$catalogue, objects);
function $2ec6beadbaf9c031$var$createRenderer(_roots, _getEventPriority) {
    function createInstance(type, { args: args = [], attach: attach, ...props }, root) {
        let name = `${type[0].toUpperCase()}${type.slice(1)}`;
        let instance;
        if (type === 'primitive') {
            if (props.object === undefined) throw new Error("R3F: Primitives without 'object' are invalid!");
            const object = props.object;
            instance = $2ec6beadbaf9c031$var$prepare(object, {
                type: type,
                root: root,
                attach: attach,
                primitive: true
            });
        } else {
            const target = $2ec6beadbaf9c031$var$catalogue[name];
            if (!target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
            // Throw if an object or literal was passed for args
            if (!Array.isArray(args)) throw new Error('R3F: The args prop must be an array!');
            // Instanciate new object, link it to the root
            // Append memoized props with args so it's not forgotten
            instance = $2ec6beadbaf9c031$var$prepare(new target(...args), {
                type: type,
                root: root,
                attach: attach,
                // Save args in case we need to reconstruct later for HMR
                memoizedProps: {
                    args: args
                }
            });
        }
        // Auto-attach geometries and materials
        if (instance.__r3f.attach === undefined) {
            if (instance instanceof $d5b33d7c30034067$export$b7be63a67df8959) instance.__r3f.attach = 'geometry';
            else if (instance instanceof $d5b33d7c30034067$export$a2d8b23205c25948) instance.__r3f.attach = 'material';
        }
        // It should NOT call onUpdate on object instanciation, because it hasn't been added to the
        // view yet. If the callback relies on references for instance, they won't be ready yet, this is
        // why it passes "true" here
        // There is no reason to apply props to injects
        if (name !== 'inject') $2ec6beadbaf9c031$var$applyProps$1(instance, props);
        return instance;
    }
    function appendChild(parentInstance, child) {
        let added = false;
        if (child) {
            var _child$__r3f, _parentInstance$__r3f;
            // The attach attribute implies that the object attaches itself on the parent
            if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) $2ec6beadbaf9c031$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                // add in the usual parent-child way
                parentInstance.add(child);
                added = true;
            }
            // This is for anything that used attach, and for non-Object3Ds that don't get attached to props;
            // that is, anything that's a child in React but not a child in the scenegraph.
            if (!added) (_parentInstance$__r3f = parentInstance.__r3f) == null || _parentInstance$__r3f.objects.push(child);
            if (!child.__r3f) $2ec6beadbaf9c031$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $2ec6beadbaf9c031$var$updateInstance(child);
            $2ec6beadbaf9c031$var$invalidateInstance(child);
        }
    }
    function insertBefore(parentInstance, child, beforeChild) {
        let added = false;
        if (child) {
            var _child$__r3f2, _parentInstance$__r3f2;
            if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) $2ec6beadbaf9c031$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                child.parent = parentInstance;
                child.dispatchEvent({
                    type: 'added'
                });
                const restSiblings = parentInstance.children.filter((sibling)=>sibling !== child);
                const index = restSiblings.indexOf(beforeChild);
                parentInstance.children = [
                    ...restSiblings.slice(0, index),
                    child,
                    ...restSiblings.slice(index)
                ];
                added = true;
            }
            if (!added) (_parentInstance$__r3f2 = parentInstance.__r3f) == null || _parentInstance$__r3f2.objects.push(child);
            if (!child.__r3f) $2ec6beadbaf9c031$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $2ec6beadbaf9c031$var$updateInstance(child);
            $2ec6beadbaf9c031$var$invalidateInstance(child);
        }
    }
    function removeRecursive(array, parent, dispose = false) {
        if (array) [
            ...array
        ].forEach((child)=>removeChild(parent, child, dispose));
    }
    function removeChild(parentInstance, child, dispose) {
        if (child) {
            var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
            // Clear the parent reference
            if (child.__r3f) child.__r3f.parent = null;
            // Remove child from the parents objects
            if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects) parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x)=>x !== child);
            // Remove attachment
            if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) $2ec6beadbaf9c031$var$detach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                var _child$__r3f4;
                parentInstance.remove(child);
                // @ts-ignore
                // Remove interactivity on the initial root
                if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) $2ec6beadbaf9c031$var$removeInteractivity($2ec6beadbaf9c031$var$findInitialRoot(child), child);
            }
            // Allow objects to bail out of recursive dispose altogether by passing dispose={null}
            // Never dispose of primitives because their state may be kept outside of React!
            // In order for an object to be able to dispose it has to have
            //   - a dispose method,
            //   - it cannot be a <primitive object={...} />
            //   - it cannot be a THREE.Scene, because three has broken it's own api
            //
            // Since disposal is recursive, we can check the optional dispose arg, which will be undefined
            // when the reconciler calls it, but then carry our own check recursively
            const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
            const shouldDispose = !isPrimitive && (dispose === undefined ? child.dispose !== null : dispose);
            // Remove nested child objects. Primitives should not have objects and children that are
            // attached to them declaratively ...
            if (!isPrimitive) {
                var _child$__r3f6;
                removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
                removeRecursive(child.children, child, shouldDispose);
            }
            // Remove references
            delete child.__r3f;
            // Dispose item whenever the reconciler feels like it
            if (shouldDispose && child.dispose && child.type !== 'Scene') {
                const callback = ()=>{
                    try {
                        child.dispose();
                    } catch (e) {
                    /* ... */ }
                };
                // Schedule async at runtime, flush sync in testing
                if (typeof IS_REACT_ACT_ENVIRONMENT === 'undefined') (0, $cc7d8ebd00fdedf2$exports.unstable_scheduleCallback)((0, $cc7d8ebd00fdedf2$exports.unstable_IdlePriority), callback);
                else callback();
            }
            $2ec6beadbaf9c031$var$invalidateInstance(parentInstance);
        }
    }
    function switchInstance(instance, type, newProps, fiber) {
        var _instance$__r3f;
        const parent = (_instance$__r3f = instance.__r3f) == null ? void 0 : _instance$__r3f.parent;
        if (!parent) return;
        const newInstance = createInstance(type, newProps, instance.__r3f.root);
        // https://github.com/pmndrs/react-three-fiber/issues/1348
        // When args change the instance has to be re-constructed, which then
        // forces r3f to re-parent the children and non-scene objects
        if (instance.children) {
            for (const child of instance.children)if (child.__r3f) appendChild(newInstance, child);
            instance.children = instance.children.filter((child)=>!child.__r3f);
        }
        instance.__r3f.objects.forEach((child)=>appendChild(newInstance, child));
        instance.__r3f.objects = [];
        if (!instance.__r3f.autoRemovedBeforeAppend) removeChild(parent, instance);
        if (newInstance.parent) newInstance.__r3f.autoRemovedBeforeAppend = true;
        appendChild(parent, newInstance);
        // Re-bind event handlers on the initial root
        if (newInstance.raycast && newInstance.__r3f.eventCount) {
            const rootState = $2ec6beadbaf9c031$var$findInitialRoot(newInstance).getState();
            rootState.internal.interaction.push(newInstance);
        }
        [
            fiber,
            fiber.alternate
        ].forEach((fiber)=>{
            if (fiber !== null) {
                fiber.stateNode = newInstance;
                if (fiber.ref) {
                    if (typeof fiber.ref === 'function') fiber.ref(newInstance);
                    else fiber.ref.current = newInstance;
                }
            }
        });
    }
    // Don't handle text instances, warn on undefined behavior
    const handleTextInstance = ()=>console.warn('Text is not allowed in the R3F tree! This could be stray whitespace or characters.');
    const reconciler = (0, (/*@__PURE__*/$parcel$interopDefault($5785509ae5140e70$exports)))({
        createInstance: createInstance,
        removeChild: removeChild,
        appendChild: appendChild,
        appendInitialChild: appendChild,
        insertBefore: insertBefore,
        supportsMutation: true,
        isPrimaryRenderer: false,
        supportsPersistence: false,
        supportsHydration: false,
        noTimeout: -1,
        appendChildToContainer: (container, child)=>{
            if (!child) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            // Link current root to the default scene
            scene.__r3f.root = container;
            appendChild(scene, child);
        },
        removeChildFromContainer: (container, child)=>{
            if (!child) return;
            removeChild(container.getState().scene, child);
        },
        insertInContainerBefore: (container, child, beforeChild)=>{
            if (!child || !beforeChild) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            insertBefore(scene, child, beforeChild);
        },
        getRootHostContext: ()=>null,
        getChildHostContext: (parentHostContext)=>parentHostContext,
        finalizeInitialChildren (instance) {
            var _instance$__r3f2;
            const localState = (_instance$__r3f2 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f2 : {};
            // https://github.com/facebook/react/issues/20271
            // Returning true will trigger commitMount
            return Boolean(localState.handlers);
        },
        prepareUpdate (instance, _type, oldProps, newProps) {
            var _instance$__r3f3;
            const localState = (_instance$__r3f3 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f3 : {};
            // Create diff-sets
            if (localState.primitive && newProps.object && newProps.object !== instance) return [
                true
            ];
            else {
                // This is a data object, let's extract critical information about it
                const { args: argsNew = [], children: cN, ...restNew } = newProps;
                const { args: argsOld = [], children: cO, ...restOld } = oldProps;
                // Throw if an object or literal was passed for args
                if (!Array.isArray(argsNew)) throw new Error('R3F: the args prop must be an array!');
                // If it has new props or arguments, then it needs to be re-instantiated
                if (argsNew.some((value, index)=>value !== argsOld[index])) return [
                    true
                ];
                // Create a diff-set, flag if there are any changes
                const diff = $2ec6beadbaf9c031$var$diffProps(instance, restNew, restOld, true);
                if (diff.changes.length) return [
                    false,
                    diff
                ];
                // Otherwise do not touch the instance
                return null;
            }
        },
        commitUpdate (instance, [reconstruct, diff], type, _oldProps, newProps, fiber) {
            // Reconstruct when args or <primitive object={...} have changes
            if (reconstruct) switchInstance(instance, type, newProps, fiber);
            else $2ec6beadbaf9c031$var$applyProps$1(instance, diff);
        },
        commitMount (instance, _type, _props, _int) {
            var _instance$__r3f4;
            // https://github.com/facebook/react/issues/20271
            // This will make sure events are only added once to the central container on the initial root
            const localState = (_instance$__r3f4 = instance.__r3f) != null ? _instance$__r3f4 : {};
            if (instance.raycast && localState.handlers && localState.eventCount) $2ec6beadbaf9c031$var$findInitialRoot(instance).getState().internal.interaction.push(instance);
        },
        getPublicInstance: (instance)=>instance,
        prepareForCommit: ()=>null,
        preparePortalMount: (container)=>$2ec6beadbaf9c031$var$prepare(container.getState().scene),
        resetAfterCommit: ()=>{},
        shouldSetTextContent: ()=>false,
        clearContainer: ()=>false,
        hideInstance (instance) {
            var _instance$__r3f5;
            // Detach while the instance is hidden
            const { attach: type, parent: parent } = (_instance$__r3f5 = instance.__r3f) != null ? _instance$__r3f5 : {};
            if (type && parent) $2ec6beadbaf9c031$var$detach(parent, instance, type);
            if (instance.isObject3D) instance.visible = false;
            $2ec6beadbaf9c031$var$invalidateInstance(instance);
        },
        unhideInstance (instance, props) {
            var _instance$__r3f6;
            // Re-attach when the instance is unhidden
            const { attach: type, parent: parent } = (_instance$__r3f6 = instance.__r3f) != null ? _instance$__r3f6 : {};
            if (type && parent) $2ec6beadbaf9c031$var$attach(parent, instance, type);
            if (instance.isObject3D && props.visible == null || props.visible) instance.visible = true;
            $2ec6beadbaf9c031$var$invalidateInstance(instance);
        },
        createTextInstance: handleTextInstance,
        hideTextInstance: handleTextInstance,
        unhideTextInstance: handleTextInstance,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
        // @ts-ignore
        getCurrentEventPriority: ()=>_getEventPriority ? _getEventPriority() : (0, $c393f2421b1ab54b$exports.DefaultEventPriority),
        beforeActiveInstanceBlur: ()=>{},
        afterActiveInstanceBlur: ()=>{},
        detachDeletedInstance: ()=>{},
        now: typeof performance !== 'undefined' && $2ec6beadbaf9c031$var$is.fun(performance.now) ? performance.now : $2ec6beadbaf9c031$var$is.fun(Date.now) ? Date.now : ()=>0,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
        scheduleTimeout: $2ec6beadbaf9c031$var$is.fun(setTimeout) ? setTimeout : undefined,
        cancelTimeout: $2ec6beadbaf9c031$var$is.fun(clearTimeout) ? clearTimeout : undefined
    });
    return {
        reconciler: reconciler,
        applyProps: $2ec6beadbaf9c031$var$applyProps$1
    };
}
var $2ec6beadbaf9c031$var$_window$document, $2ec6beadbaf9c031$var$_window$navigator;
/**
 * Returns `true` with correct TS type inference if an object has a configurable color space (since r152).
 */ const $2ec6beadbaf9c031$var$hasColorSpace = (object)=>'colorSpace' in object || 'outputColorSpace' in object;
/**
 * The current THREE.ColorManagement instance, if present.
 */ const $2ec6beadbaf9c031$var$getColorManagement = ()=>{
    var _ColorManagement;
    return (_ColorManagement = $2ec6beadbaf9c031$var$catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const $2ec6beadbaf9c031$var$isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const $2ec6beadbaf9c031$export$23f2a1d2818174ef = (obj)=>obj && obj.hasOwnProperty('current');
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $2ec6beadbaf9c031$export$407448d2b89b1813 = typeof window !== 'undefined' && (($2ec6beadbaf9c031$var$_window$document = window.document) != null && $2ec6beadbaf9c031$var$_window$document.createElement || (($2ec6beadbaf9c031$var$_window$navigator = window.navigator) == null ? void 0 : $2ec6beadbaf9c031$var$_window$navigator.product) === 'ReactNative') ? $acw62.useLayoutEffect : $acw62.useEffect;
function $2ec6beadbaf9c031$export$3b14a55fb2447963(fn) {
    const ref = $acw62.useRef(fn);
    $2ec6beadbaf9c031$export$407448d2b89b1813(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
function $2ec6beadbaf9c031$export$ef35774e6d314e91({ set: set }) {
    $2ec6beadbaf9c031$export$407448d2b89b1813(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
class $2ec6beadbaf9c031$export$a9c23c6ac3fc3eca extends $acw62.Component {
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
    }
    componentDidCatch(err) {
        this.props.set(err);
    }
    render() {
        return this.state.error ? null : this.props.children;
    }
}
$2ec6beadbaf9c031$export$a9c23c6ac3fc3eca.getDerivedStateFromError = ()=>({
        error: true
    });
const $2ec6beadbaf9c031$var$DEFAULT = '__default';
const $2ec6beadbaf9c031$var$DEFAULTS = new Map();
const $2ec6beadbaf9c031$var$isDiffSet = (def)=>def && !!def.memoized && !!def.changes;
function $2ec6beadbaf9c031$var$calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== 'undefined' ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ const $2ec6beadbaf9c031$export$2408f22a0fab9ae5 = (obj)=>{
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
/**
 * Returns the instances initial (outmost) root
 */ function $2ec6beadbaf9c031$var$findInitialRoot(child) {
    let root = child.__r3f.root;
    while(root.getState().previousRoot)root = root.getState().previousRoot;
    return root;
}
// A collection of compare functions
const $2ec6beadbaf9c031$var$is = {
    obj: (a)=>a === Object(a) && !$2ec6beadbaf9c031$var$is.arr(a) && typeof a !== 'function',
    fun: (a)=>typeof a === 'function',
    str: (a)=>typeof a === 'string',
    num: (a)=>typeof a === 'number',
    boo: (a)=>typeof a === 'boolean',
    und: (a)=>a === void 0,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays: arrays = 'shallow', objects: objects = 'reference', strict: strict = true } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if ($2ec6beadbaf9c031$var$is.str(a) || $2ec6beadbaf9c031$var$is.num(a)) return a === b;
        const isObj = $2ec6beadbaf9c031$var$is.obj(a);
        if (isObj && objects === 'reference') return a === b;
        const isArr = $2ec6beadbaf9c031$var$is.arr(a);
        if (isArr && arrays === 'reference') return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === 'shallow' && objects === 'shallow') {
            for(i in strict ? b : a)if (!$2ec6beadbaf9c031$var$is.equ(a[i], b[i], {
                strict: strict,
                objects: 'reference'
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if ($2ec6beadbaf9c031$var$is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
/**
 * Collects nodes and materials from a THREE.Object3D.
 */ function $2ec6beadbaf9c031$export$efccba1c4a2ef57b(object) {
    const data = {
        nodes: {},
        materials: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
    });
    return data;
}
// Disposes an object and all its properties
function $2ec6beadbaf9c031$export$342063e11d6c3cad(obj) {
    if (obj.dispose && obj.type !== 'Scene') obj.dispose();
    for(const p in obj){
        p.dispose == null || p.dispose();
        delete obj[p];
    }
}
// Each object in the scene carries a small LocalState descriptor
function $2ec6beadbaf9c031$var$prepare(object, state) {
    const instance = object;
    instance.__r3f = {
        type: '',
        root: null,
        previousAttach: null,
        memoizedProps: {},
        eventCount: 0,
        handlers: {},
        objects: [],
        parent: null,
        ...state
    };
    return object;
}
function $2ec6beadbaf9c031$var$resolve(instance, key) {
    let target = instance;
    if (key.includes('-')) {
        const entries = key.split('-');
        const last = entries.pop();
        target = entries.reduce((acc, key)=>acc[key], instance);
        return {
            target: target,
            key: last
        };
    } else return {
        target: target,
        key: key
    };
}
// Checks if a dash-cased string ends with an integer
const $2ec6beadbaf9c031$var$INDEX_REGEX = /-\d+$/;
function $2ec6beadbaf9c031$var$attach(parent, child, type) {
    if ($2ec6beadbaf9c031$var$is.str(type)) {
        // If attaching into an array (foo-0), create one
        if ($2ec6beadbaf9c031$var$INDEX_REGEX.test(type)) {
            const root = type.replace($2ec6beadbaf9c031$var$INDEX_REGEX, '');
            const { target: target, key: key } = $2ec6beadbaf9c031$var$resolve(parent, root);
            if (!Array.isArray(target[key])) target[key] = [];
        }
        const { target: target, key: key } = $2ec6beadbaf9c031$var$resolve(parent, type);
        child.__r3f.previousAttach = target[key];
        target[key] = child;
    } else child.__r3f.previousAttach = type(parent, child);
}
function $2ec6beadbaf9c031$var$detach(parent, child, type) {
    var _child$__r3f, _child$__r3f2;
    if ($2ec6beadbaf9c031$var$is.str(type)) {
        const { target: target, key: key } = $2ec6beadbaf9c031$var$resolve(parent, type);
        const previous = child.__r3f.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete target[key];
        else target[key] = previous;
    } else (_child$__r3f = child.__r3f) == null || _child$__r3f.previousAttach == null || _child$__r3f.previousAttach(parent, child);
    (_child$__r3f2 = child.__r3f) == null || delete _child$__r3f2.previousAttach;
}
// This function prepares a set of changes to be applied to the instance
function $2ec6beadbaf9c031$var$diffProps(instance, { children: cN, key: kN, ref: rN, ...props }, { children: cP, key: kP, ref: rP, ...previous } = {}, remove = false) {
    var _instance$__r3f;
    const localState = (_instance$__r3f = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f : {};
    const entries = Object.entries(props);
    const changes = [];
    // Catch removed props, prepend them so they can be reset or removed
    if (remove) {
        const previousKeys = Object.keys(previous);
        for(let i = 0; i < previousKeys.length; i++)if (!props.hasOwnProperty(previousKeys[i])) entries.unshift([
            previousKeys[i],
            $2ec6beadbaf9c031$var$DEFAULT + 'remove'
        ]);
    }
    entries.forEach(([key, value])=>{
        var _instance$__r3f2;
        // Bail out on primitive object
        if ((_instance$__r3f2 = instance.__r3f) != null && _instance$__r3f2.primitive && key === 'object') return;
        // When props match bail out
        if ($2ec6beadbaf9c031$var$is.equ(value, previous[key])) return;
        // Collect handlers and bail out
        if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key)) return changes.push([
            key,
            value,
            true,
            []
        ]);
        // Split dashed props
        let entries = [];
        if (key.includes('-')) entries = key.split('-');
        changes.push([
            key,
            value,
            false,
            entries
        ]);
        // Reset pierced props
        for(const prop in props){
            const value = props[prop];
            if (prop.startsWith(`${key}-`)) changes.push([
                prop,
                value,
                false,
                prop.split('-')
            ]);
        }
    });
    const memoized = {
        ...props
    };
    if (localState.memoizedProps && localState.memoizedProps.args) memoized.args = localState.memoizedProps.args;
    if (localState.memoizedProps && localState.memoizedProps.attach) memoized.attach = localState.memoizedProps.attach;
    return {
        memoized: memoized,
        changes: changes
    };
}
const $2ec6beadbaf9c031$var$__DEV__ = false;
// This function applies a set of changes to the instance
function $2ec6beadbaf9c031$var$applyProps$1(instance, data) {
    var _instance$__r3f3, _root$getState, _instance$__r3f4;
    // Filter equals, events and reserved props
    const localState = (_instance$__r3f3 = instance.__r3f) != null ? _instance$__r3f3 : {};
    const root = localState.root;
    const rootState = (_root$getState = root == null ? void 0 : root.getState == null ? void 0 : root.getState()) != null ? _root$getState : {};
    const { memoized: memoized, changes: changes } = $2ec6beadbaf9c031$var$isDiffSet(data) ? data : $2ec6beadbaf9c031$var$diffProps(instance, data);
    const prevHandlers = localState.eventCount;
    // Prepare memoized props
    if (instance.__r3f) instance.__r3f.memoizedProps = memoized;
    for(let i = 0; i < changes.length; i++){
        let [key, value, isEvent, keys] = changes[i];
        // Alias (output)encoding => (output)colorSpace (since r152)
        // https://github.com/pmndrs/react-three-fiber/pull/2829
        if ($2ec6beadbaf9c031$var$hasColorSpace(instance)) {
            const sRGBEncoding = 3001;
            const SRGBColorSpace = 'srgb';
            const LinearSRGBColorSpace = 'srgb-linear';
            if (key === 'encoding') {
                key = 'colorSpace';
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            } else if (key === 'outputEncoding') {
                key = 'outputColorSpace';
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            }
        }
        let currentInstance = instance;
        let targetProp = currentInstance[key];
        // Revolve dashed props
        if (keys.length) {
            targetProp = keys.reduce((acc, key)=>acc[key], instance);
            // If the target is atomic, it forces us to switch the root
            if (!(targetProp && targetProp.set)) {
                const [name, ...reverseEntries] = keys.reverse();
                currentInstance = reverseEntries.reverse().reduce((acc, key)=>acc[key], instance);
                key = name;
            }
        }
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (value === $2ec6beadbaf9c031$var$DEFAULT + 'remove') {
            if (currentInstance.constructor) {
                // create a blank slate of the instance and copy the particular parameter.
                let ctor = $2ec6beadbaf9c031$var$DEFAULTS.get(currentInstance.constructor);
                if (!ctor) {
                    // @ts-ignore
                    ctor = new currentInstance.constructor();
                    $2ec6beadbaf9c031$var$DEFAULTS.set(currentInstance.constructor, ctor);
                }
                value = ctor[key];
            } else // instance does not have constructor, just set it to 0
            value = 0;
        }
        // Deal with pointer events ...
        if (isEvent) {
            if (value) localState.handlers[key] = value;
            else delete localState.handlers[key];
            localState.eventCount = Object.keys(localState.handlers).length;
        } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof $d5b33d7c30034067$export$89312ce47c0ca777)) {
            // If value is an array
            if (Array.isArray(value)) {
                if (targetProp.fromArray) targetProp.fromArray(value);
                else targetProp.set(...value);
            } else if (targetProp.copy && value && value.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
            // Loosen to unminified names, ignoring descendents.
            // https://github.com/pmndrs/react-three-fiber/issues/2856
            // TODO: fix upstream and remove in v9
            ($2ec6beadbaf9c031$var$__DEV__ ? targetProp.constructor.name === value.constructor.name : targetProp.constructor === value.constructor)) targetProp.copy(value);
            else if (value !== undefined) {
                const isColor = targetProp instanceof $d5b33d7c30034067$export$892596cec99bc70e;
                // Allow setting array scalars
                if (!isColor && targetProp.setScalar) targetProp.setScalar(value);
                else if (targetProp instanceof $d5b33d7c30034067$export$89312ce47c0ca777 && value instanceof $d5b33d7c30034067$export$89312ce47c0ca777) targetProp.mask = value.mask;
                else targetProp.set(value);
                // For versions of three which don't support THREE.ColorManagement,
                // Auto-convert sRGB colors
                // https://github.com/pmndrs/react-three-fiber/issues/344
                if (!$2ec6beadbaf9c031$var$getColorManagement() && !rootState.linear && isColor) targetProp.convertSRGBToLinear();
            }
        // Else, just overwrite the value
        } else {
            currentInstance[key] = value;
            // Auto-convert sRGB textures, for now ...
            // https://github.com/pmndrs/react-three-fiber/issues/344
            if (currentInstance[key] instanceof $d5b33d7c30034067$export$5431306cf43de24a && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            currentInstance[key].format === $d5b33d7c30034067$export$3f8bb04b555a363c && currentInstance[key].type === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) {
                const texture = currentInstance[key];
                if ($2ec6beadbaf9c031$var$hasColorSpace(texture) && $2ec6beadbaf9c031$var$hasColorSpace(rootState.gl)) texture.colorSpace = rootState.gl.outputColorSpace;
                else texture.encoding = rootState.gl.outputEncoding;
            }
        }
        $2ec6beadbaf9c031$var$invalidateInstance(instance);
    }
    if (localState.parent && instance.raycast && prevHandlers !== localState.eventCount) {
        // Get the initial root state's internals
        const internal = $2ec6beadbaf9c031$var$findInitialRoot(instance).getState().internal;
        // Pre-emptively remove the instance from the interaction manager
        const index = internal.interaction.indexOf(instance);
        if (index > -1) internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (localState.eventCount) internal.interaction.push(instance);
    }
    // Call the update lifecycle when it is being updated, but only when it is part of the scene.
    // Skip updates to the `onUpdate` prop itself
    const isCircular = changes.length === 1 && changes[0][0] === 'onUpdate';
    if (!isCircular && changes.length && (_instance$__r3f4 = instance.__r3f) != null && _instance$__r3f4.parent) $2ec6beadbaf9c031$var$updateInstance(instance);
    return instance;
}
function $2ec6beadbaf9c031$var$invalidateInstance(instance) {
    var _instance$__r3f5, _instance$__r3f5$root;
    const state = (_instance$__r3f5 = instance.__r3f) == null ? void 0 : (_instance$__r3f5$root = _instance$__r3f5.root) == null ? void 0 : _instance$__r3f5$root.getState == null ? void 0 : _instance$__r3f5$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function $2ec6beadbaf9c031$var$updateInstance(instance) {
    instance.onUpdate == null || instance.onUpdate(instance);
}
function $2ec6beadbaf9c031$var$updateCamera(camera, size) {
    // https://github.com/pmndrs/react-three-fiber/issues/92
    // Do not mess with the camera if it belongs to the user
    if (!camera.manual) {
        if ($2ec6beadbaf9c031$var$isOrthographicCamera(camera)) {
            camera.left = size.width / -2;
            camera.right = size.width / 2;
            camera.top = size.height / 2;
            camera.bottom = size.height / -2;
        } else camera.aspect = size.width / size.height;
        camera.updateProjectionMatrix();
        // https://github.com/pmndrs/react-three-fiber/issues/178
        // Update matrix world since the renderer is a frame late
        camera.updateMatrixWorld();
    }
}
function $2ec6beadbaf9c031$var$makeId(event) {
    return (event.eventObject || event.object).uuid + '/' + event.index + event.instanceId;
}
// https://github.com/facebook/react/tree/main/packages/react-reconciler#getcurrenteventpriority
// Gives React a clue as to how import the current interaction is
function $2ec6beadbaf9c031$var$getEventPriority() {
    var _globalScope$event;
    // Get a handle to the current global scope in window and worker contexts if able
    // https://github.com/pmndrs/react-three-fiber/pull/2493
    const globalScope = typeof self !== 'undefined' && self || typeof window !== 'undefined' && window;
    if (!globalScope) return 0, $c393f2421b1ab54b$exports.DefaultEventPriority;
    const name = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
    switch(name){
        case 'click':
        case 'contextmenu':
        case 'dblclick':
        case 'pointercancel':
        case 'pointerdown':
        case 'pointerup':
            return 0, $c393f2421b1ab54b$exports.DiscreteEventPriority;
        case 'pointermove':
        case 'pointerout':
        case 'pointerover':
        case 'pointerenter':
        case 'pointerleave':
        case 'wheel':
            return 0, $c393f2421b1ab54b$exports.ContinuousEventPriority;
        default:
            return 0, $c393f2421b1ab54b$exports.DefaultEventPriority;
    }
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function $2ec6beadbaf9c031$var$releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function $2ec6beadbaf9c031$var$removeInteractivity(store, object) {
    const { internal: internal } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        $2ec6beadbaf9c031$var$releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function $2ec6beadbaf9c031$export$db3b6bfb95261072(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal: internal } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                'Move',
                'Over',
                'Enter',
                'Out',
                'Leave'
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers['onPointer' + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = $2ec6beadbaf9c031$export$2408f22a0fab9ae5(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = $2ec6beadbaf9c031$export$2408f22a0fab9ae5(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = $2ec6beadbaf9c031$export$2408f22a0fab9ae5(a.object);
            const bState = $2ec6beadbaf9c031$export$2408f22a0fab9ae5(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = $2ec6beadbaf9c031$var$makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject: eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ('pointerId' in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has($2ec6beadbaf9c031$var$makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        const rootState = store.getState();
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                const state = $2ec6beadbaf9c031$export$2408f22a0fab9ae5(hit.object) || rootState;
                const { raycaster: raycaster, pointer: pointer, camera: camera, internal: internal } = state;
                const unprojectedPoint = new $d5b33d7c30034067$export$64b5c384219d3699(pointer.x, pointer.y, 0).unproject(camera);
                const hasPointerCapture = (id)=>{
                    var _internal$capturedMap, _internal$capturedMap2;
                    return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                };
                const setPointerCapture = (id)=>{
                    const captureData = {
                        intersection: hit,
                        target: event.target
                    };
                    if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                    // event capturedMap.
                    internal.capturedMap.get(id).set(hit.eventObject, captureData);
                    else // if the pointerId was not previously captured, we create a map
                    // containing the hitObject, and the hit. hitObject is used for
                    // faster access.
                    internal.capturedMap.set(id, new Map([
                        [
                            hit.eventObject,
                            captureData
                        ]
                    ]));
                    event.target.setPointerCapture(id);
                };
                const releasePointerCapture = (id)=>{
                    const captures = internal.capturedMap.get(id);
                    if (captures) $2ec6beadbaf9c031$var$releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                };
                // Add native event props
                let extractEventProps = {};
                // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                for(let prop in event){
                    let property = event[prop];
                    // Only copy over atomics, leave functions alone as these should be
                    // called as event.nativeEvent.fn()
                    if (typeof property !== 'function') extractEventProps[prop] = property;
                }
                let raycastEvent = {
                    ...hit,
                    ...extractEventProps,
                    pointer: pointer,
                    intersections: intersections,
                    stopped: localState.stopped,
                    delta: delta,
                    unprojectedPoint: unprojectedPoint,
                    ray: raycaster.ray,
                    camera: camera,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation () {
                        // https://github.com/pmndrs/react-three-fiber/issues/596
                        // Events are not allowed to stop propagation if the pointer has been captured
                        const capturesForPointer = 'pointerId' in event && internal.capturedMap.get(event.pointerId);
                        // We only authorize stopPropagation...
                        if (// ...if this pointer hasn't been captured
                        !capturesForPointer || // ... or if the hit object is capturing the pointer
                        capturesForPointer.has(hit.eventObject)) {
                            raycastEvent.stopped = localState.stopped = true;
                            // Propagation is stopped, remove all other hover records
                            // An event handler is only allowed to flush other handlers if it is hovered itself
                            if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                // Objects cannot flush out higher up objects that have already caught the event
                                const higher = intersections.slice(0, intersections.indexOf(hit));
                                cancelPointer([
                                    ...higher,
                                    hit
                                ]);
                            }
                        }
                    },
                    // there should be a distinction between target and currentTarget
                    target: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    currentTarget: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    nativeEvent: event
                };
                // Call subscribers
                callback(raycastEvent);
                // Event bubbling may be interrupted by stopPropagation
                if (localState.stopped === true) break;
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal: internal } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            const handlers = instance == null ? void 0 : instance.handlers;
            internal.hovered.delete($2ec6beadbaf9c031$var$makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections: intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case 'onPointerLeave':
            case 'onPointerCancel':
                return ()=>cancelPointer([]);
            case 'onLostPointerCapture':
                return (event)=>{
                    const { internal: internal } = store.getState();
                    if ('pointerId' in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed: onPointerMissed, internal: internal } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === 'onPointerMove';
            const isClickEvent = name === 'onClick' || name === 'onContextMenu' || name === 'onDoubleClick';
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === 'onPointerDown') {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                const handlers = instance == null ? void 0 : instance.handlers;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = $2ec6beadbaf9c031$var$makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer: handlePointer
    };
}
// Keys that shouldn't be copied between R3F stores
const $2ec6beadbaf9c031$var$privateKeys = [
    'set',
    'get',
    'setSize',
    'setFrameloop',
    'setDpr',
    'events',
    'invalidate',
    'advance',
    'size',
    'viewport'
];
const $2ec6beadbaf9c031$var$isRenderer = (def)=>!!(def != null && def.render);
const $2ec6beadbaf9c031$export$2d1720544b23b823 = /*#__PURE__*/ $acw62.createContext(null);
const $2ec6beadbaf9c031$var$createStore = (invalidate, advance)=>{
    const rootState = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((set, get)=>{
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const defaultTarget = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tempTarget = new $d5b33d7c30034067$export$64b5c384219d3699();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width: width, height: height, top: top, left: left } = size;
            const aspect = width / height;
            if (target instanceof $d5b33d7c30034067$export$64b5c384219d3699) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if ($2ec6beadbaf9c031$var$isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top: top,
                left: left,
                factor: 1,
                distance: distance,
                aspect: aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top: top,
                    left: left,
                    factor: width / w,
                    distance: distance,
                    aspect: aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current: current
                    }
                }));
        const pointer = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const rootState = {
            set: set,
            get: get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            xr: null,
            scene: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new $d5b33d7c30034067$export$9735c82c4bae3302(),
            pointer: pointer,
            mouse: pointer,
            frameloop: 'always',
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                updateStyle: false
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, updateStyle, top, left)=>{
                const camera = get().camera;
                const size = {
                    width: width,
                    height: height,
                    top: top || 0,
                    left: left || 0,
                    updateStyle: updateStyle
                };
                set((state)=>({
                        size: size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = $2ec6beadbaf9c031$var$calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = 'always')=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== 'never') {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop: frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                active: false,
                priority: 0,
                frames: 0,
                lastEvent: /*#__PURE__*/ $acw62.createRef(),
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref: ref,
                        priority: priority,
                        store: store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootState.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootState.subscribe(()=>{
        const { camera: camera, size: size, viewport: viewport, gl: gl, set: set } = rootState.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size.width !== oldSize.width || size.height !== oldSize.height || viewport.dpr !== oldDpr) {
            var _size$updateStyle;
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            $2ec6beadbaf9c031$var$updateCamera(camera, size);
            gl.setPixelRatio(viewport.dpr);
            const updateStyle = (_size$updateStyle = size.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== 'undefined' && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootState.subscribe((state)=>invalidate(state));
    // Return root state
    return rootState;
};
function $2ec6beadbaf9c031$var$createSubs(callback, subs) {
    const sub = {
        callback: callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
let $2ec6beadbaf9c031$var$i;
let $2ec6beadbaf9c031$var$globalEffects = new Set();
let $2ec6beadbaf9c031$var$globalAfterEffects = new Set();
let $2ec6beadbaf9c031$var$globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const $2ec6beadbaf9c031$export$7ccc53e8f1e7dfc5 = (callback)=>$2ec6beadbaf9c031$var$createSubs(callback, $2ec6beadbaf9c031$var$globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const $2ec6beadbaf9c031$export$ae1af26003f05816 = (callback)=>$2ec6beadbaf9c031$var$createSubs(callback, $2ec6beadbaf9c031$var$globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const $2ec6beadbaf9c031$export$ffb5f4729a158638 = (callback)=>$2ec6beadbaf9c031$var$createSubs(callback, $2ec6beadbaf9c031$var$globalTailEffects);
function $2ec6beadbaf9c031$var$run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback: callback } of effects.values())callback(timestamp);
}
function $2ec6beadbaf9c031$export$9e5f44173e64f162(type, timestamp) {
    switch(type){
        case 'before':
            return $2ec6beadbaf9c031$var$run($2ec6beadbaf9c031$var$globalEffects, timestamp);
        case 'after':
            return $2ec6beadbaf9c031$var$run($2ec6beadbaf9c031$var$globalAfterEffects, timestamp);
        case 'tail':
            return $2ec6beadbaf9c031$var$run($2ec6beadbaf9c031$var$globalTailEffects, timestamp);
    }
}
let $2ec6beadbaf9c031$var$subscribers;
let $2ec6beadbaf9c031$var$subscription;
function $2ec6beadbaf9c031$var$render$1(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === 'never' && typeof timestamp === 'number') {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    $2ec6beadbaf9c031$var$subscribers = state.internal.subscribers;
    for($2ec6beadbaf9c031$var$i = 0; $2ec6beadbaf9c031$var$i < $2ec6beadbaf9c031$var$subscribers.length; $2ec6beadbaf9c031$var$i++){
        $2ec6beadbaf9c031$var$subscription = $2ec6beadbaf9c031$var$subscribers[$2ec6beadbaf9c031$var$i];
        $2ec6beadbaf9c031$var$subscription.ref.current($2ec6beadbaf9c031$var$subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === 'always' ? 1 : state.internal.frames;
}
function $2ec6beadbaf9c031$var$createLoop(roots) {
    let running = false;
    let repeat;
    let frame;
    let state;
    function loop(timestamp) {
        frame = requestAnimationFrame(loop);
        running = true;
        repeat = 0;
        // Run effects
        $2ec6beadbaf9c031$export$9e5f44173e64f162('before', timestamp);
        // Render all roots
        for (const root of roots.values()){
            var _state$gl$xr;
            state = root.store.getState();
            // If the frameloop is invalidated, do not run another frame
            if (state.internal.active && (state.frameloop === 'always' || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) repeat += $2ec6beadbaf9c031$var$render$1(timestamp, state);
        }
        // Run after-effects
        $2ec6beadbaf9c031$export$9e5f44173e64f162('after', timestamp);
        // Stop the loop if nothing invalidates it
        if (repeat === 0) {
            // Tail call effects, they are called when rendering stops
            $2ec6beadbaf9c031$export$9e5f44173e64f162('tail', timestamp);
            // Flag end of operation
            running = false;
            return cancelAnimationFrame(frame);
        }
    }
    function invalidate(state, frames = 1) {
        var _state$gl$xr2;
        if (!state) return roots.forEach((root)=>invalidate(root.store.getState()), frames);
        if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === 'never') return;
        // Increase frames, do not go higher than 60
        state.internal.frames = Math.min(60, state.internal.frames + frames);
        // If the render-loop isn't active, start it
        if (!running) {
            running = true;
            requestAnimationFrame(loop);
        }
    }
    function advance(timestamp, runGlobalEffects = true, state, frame) {
        if (runGlobalEffects) $2ec6beadbaf9c031$export$9e5f44173e64f162('before', timestamp);
        if (!state) for (const root of roots.values())$2ec6beadbaf9c031$var$render$1(timestamp, root.store.getState());
        else $2ec6beadbaf9c031$var$render$1(timestamp, state, frame);
        if (runGlobalEffects) $2ec6beadbaf9c031$export$9e5f44173e64f162('after', timestamp);
    }
    return {
        loop: loop,
        invalidate: /**
     * Invalidates the view, requesting a frame to be rendered. Will globally invalidate unless passed a root's state.
     * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#invalidate
     */ invalidate,
        advance: /**
     * Advances the frameloop and runs render effects, useful for when manually rendering via `frameloop="never"`.
     * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#advance
     */ advance
    };
}
/**
 * Exposes an object's {@link LocalState}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function $2ec6beadbaf9c031$export$4a5767248b18ef41(ref) {
    const instance = $acw62.useRef(null);
    $2ec6beadbaf9c031$export$407448d2b89b1813(()=>void (instance.current = ref.current.__r3f), [
        ref
    ]);
    return instance;
}
function $2ec6beadbaf9c031$export$df995fae86a55f06() {
    const store = $acw62.useContext($2ec6beadbaf9c031$export$2d1720544b23b823);
    if (!store) throw new Error('R3F: Hooks can only be used within the Canvas component!');
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function $2ec6beadbaf9c031$export$ebd11618f299a286(selector = (state)=>state, equalityFn) {
    return $2ec6beadbaf9c031$export$df995fae86a55f06()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function $2ec6beadbaf9c031$export$e7094788287c5e9b(callback, renderPriority = 0) {
    const store = $2ec6beadbaf9c031$export$df995fae86a55f06();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = $2ec6beadbaf9c031$export$3b14a55fb2447963(callback);
    // Subscribe on mount, unsubscribe on unmount
    $2ec6beadbaf9c031$export$407448d2b89b1813(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function $2ec6beadbaf9c031$export$96f57966bedc81b4(object) {
    return $acw62.useMemo(()=>$2ec6beadbaf9c031$export$efccba1c4a2ef57b(object), [
        object
    ]);
}
const $2ec6beadbaf9c031$var$memoizedLoaders = new WeakMap();
function $2ec6beadbaf9c031$var$loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        // Construct new loader and run extensions
        let loader = $2ec6beadbaf9c031$var$memoizedLoaders.get(Proto);
        if (!loader) {
            loader = new Proto();
            $2ec6beadbaf9c031$var$memoizedLoaders.set(Proto, loader);
        }
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if (data.scene) Object.assign(data, $2ec6beadbaf9c031$export$efccba1c4a2ef57b(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error == null ? void 0 : error.message}`)))))).finally(()=>loader.dispose == null ? void 0 : loader.dispose());
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function $2ec6beadbaf9c031$export$d66501df72047452(Proto, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, $f681624d9766226e$export$a1428c8f7ba796e8)($2ec6beadbaf9c031$var$loadingFn(extensions, onProgress), [
        Proto,
        ...keys
    ], {
        equal: $2ec6beadbaf9c031$var$is.equ
    });
    // Return the object/s
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ $2ec6beadbaf9c031$export$d66501df72047452.preload = function(Proto, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $f681624d9766226e$export$513ccb98c53b8039)($2ec6beadbaf9c031$var$loadingFn(extensions), [
        Proto,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ $2ec6beadbaf9c031$export$d66501df72047452.clear = function(Proto, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $f681624d9766226e$export$42ffd38884aecdac)([
        Proto,
        ...keys
    ]);
};
const $2ec6beadbaf9c031$export$d141bba7fdc215a3 = new Map();
const { invalidate: $2ec6beadbaf9c031$export$882b5998b3b9117c, advance: $2ec6beadbaf9c031$export$953cecd6e717a553 } = $2ec6beadbaf9c031$var$createLoop($2ec6beadbaf9c031$export$d141bba7fdc215a3);
const { reconciler: $2ec6beadbaf9c031$export$dda1d9f60106f0e9, applyProps: $2ec6beadbaf9c031$export$35e795649ee09318 } = $2ec6beadbaf9c031$var$createRenderer($2ec6beadbaf9c031$export$d141bba7fdc215a3, $2ec6beadbaf9c031$var$getEventPriority);
const $2ec6beadbaf9c031$var$shallowLoose = {
    objects: 'shallow',
    strict: false
};
const $2ec6beadbaf9c031$var$createRendererInstance = (gl, canvas)=>{
    const customRenderer = typeof gl === 'function' ? gl(canvas) : gl;
    if ($2ec6beadbaf9c031$var$isRenderer(customRenderer)) return customRenderer;
    else return new $d5b33d7c30034067$export$f6cc00ef28d7cf97({
        powerPreference: 'high-performance',
        canvas: canvas,
        antialias: true,
        alpha: true,
        ...gl
    });
};
function $2ec6beadbaf9c031$var$computeInitialSize(canvas, defaultSize) {
    const defaultStyle = typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement;
    if (defaultSize) {
        const { width: width, height: height, top: top, left: left, updateStyle: updateStyle = defaultStyle } = defaultSize;
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            updateStyle: updateStyle
        };
    } else if (typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width: width, height: height, top: top, left: left } = canvas.parentElement.getBoundingClientRect();
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            updateStyle: defaultStyle
        };
    } else if (typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0,
        updateStyle: defaultStyle
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    };
}
function $2ec6beadbaf9c031$export$8b22cf2602fb60ce(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = $2ec6beadbaf9c031$export$d141bba7fdc215a3.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn('R3F.createRoot should only be called once!');
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === 'function' ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || $2ec6beadbaf9c031$var$createStore($2ec6beadbaf9c031$export$882b5998b3b9117c, $2ec6beadbaf9c031$export$953cecd6e717a553);
    // Create renderer
    const fiber = prevFiber || $2ec6beadbaf9c031$export$dda1d9f60106f0e9.createContainer(store, (0, $c393f2421b1ab54b$exports.ConcurrentRoot), null, false, null, '', logRecoverableError, null);
    // Map it
    if (!prevRoot) $2ec6beadbaf9c031$export$d141bba7fdc215a3.set(canvas, {
        fiber: fiber,
        store: store
    });
    // Locals
    let onCreated;
    let configured = false;
    let lastCamera;
    return {
        configure (props = {}) {
            let { gl: glConfig, size: propsSize, scene: sceneOptions, events: events, onCreated: onCreatedCallback, shadows: shadows = false, linear: linear = false, flat: flat = false, legacy: legacy = false, orthographic: orthographic = false, frameloop: frameloop = 'always', dpr: dpr = [
                1,
                2
            ], performance: performance1, raycaster: raycastOptions, camera: cameraOptions, onPointerMissed: onPointerMissed } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) state.set({
                gl: gl = $2ec6beadbaf9c031$var$createRendererInstance(glConfig, canvas)
            });
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new $d5b33d7c30034067$export$8b7aaceff00bd2f()
            });
            // Set raycaster options
            const { params: params, ...options } = raycastOptions || {};
            if (!$2ec6beadbaf9c031$var$is.equ(options, raycaster, $2ec6beadbaf9c031$var$shallowLoose)) $2ec6beadbaf9c031$export$35e795649ee09318(raycaster, {
                ...options
            });
            if (!$2ec6beadbaf9c031$var$is.equ(params, raycaster.params, $2ec6beadbaf9c031$var$shallowLoose)) $2ec6beadbaf9c031$export$35e795649ee09318(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !$2ec6beadbaf9c031$var$is.equ(lastCamera, cameraOptions, $2ec6beadbaf9c031$var$shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions instanceof $d5b33d7c30034067$export$79f141de891a5fed;
                const camera = isCamera ? cameraOptions : orthographic ? new $d5b33d7c30034067$export$9ebf355ee4ed261b(0, 0, 0, 0, 0.1, 1000) : new $d5b33d7c30034067$export$74e4ae24825f68d7(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) $2ec6beadbaf9c031$export$35e795649ee09318(camera, cameraOptions);
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera: camera
                });
                // Configure raycaster
                // https://github.com/pmndrs/react-xr/issues/300
                raycaster.camera = camera;
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions instanceof $d5b33d7c30034067$export$38af1803e3442a7f) scene = sceneOptions;
                else {
                    scene = new $d5b33d7c30034067$export$38af1803e3442a7f();
                    if (sceneOptions) $2ec6beadbaf9c031$export$35e795649ee09318(scene, sceneOptions);
                }
                state.set({
                    scene: $2ec6beadbaf9c031$var$prepare(scene)
                });
            }
            // Set up XR (one time only!)
            if (!state.xr) {
                var _gl$xr;
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === 'never') return;
                    $2ec6beadbaf9c031$export$953cecd6e717a553(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) $2ec6beadbaf9c031$export$882b5998b3b9117c(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener('sessionstart', handleSessionChange);
                        gl.xr.addEventListener('sessionend', handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener('sessionstart', handleSessionChange);
                        gl.xr.removeEventListener('sessionend', handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === 'function') xr.connect();
                state.set({
                    xr: xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if ($2ec6beadbaf9c031$var$is.boo(shadows)) gl.shadowMap.type = $d5b33d7c30034067$export$a47c4b43a1be34f0;
                else if ($2ec6beadbaf9c031$var$is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: $d5b33d7c30034067$export$346307dbae2b7447,
                        percentage: $d5b33d7c30034067$export$5813f879eee7cd88,
                        soft: $d5b33d7c30034067$export$a47c4b43a1be34f0,
                        variance: $d5b33d7c30034067$export$896ae1ade6c829c4
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : $d5b33d7c30034067$export$a47c4b43a1be34f0;
                } else if ($2ec6beadbaf9c031$var$is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            // Safely set color management if available.
            // Avoid accessing THREE.ColorManagement to play nice with older versions
            const ColorManagement = $2ec6beadbaf9c031$var$getColorManagement();
            if (ColorManagement) {
                if ('enabled' in ColorManagement) ColorManagement.enabled = !legacy;
                else if ('legacyMode' in ColorManagement) ColorManagement.legacyMode = legacy;
            }
            // Set color space and tonemapping preferences
            const LinearEncoding = 3000;
            const sRGBEncoding = 3001;
            $2ec6beadbaf9c031$export$35e795649ee09318(gl, {
                outputEncoding: linear ? LinearEncoding : sRGBEncoding,
                toneMapping: flat ? $d5b33d7c30034067$export$9fcb6b4294603b2 : $d5b33d7c30034067$export$a0d98fe6d7e4af64
            });
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy: legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear: linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat: flat
                }));
            // Set gl props
            if (glConfig && !$2ec6beadbaf9c031$var$is.fun(glConfig) && !$2ec6beadbaf9c031$var$isRenderer(glConfig) && !$2ec6beadbaf9c031$var$is.equ(glConfig, gl, $2ec6beadbaf9c031$var$shallowLoose)) $2ec6beadbaf9c031$export$35e795649ee09318(gl, glConfig);
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = $2ec6beadbaf9c031$var$computeInitialSize(canvas, propsSize);
            if (!$2ec6beadbaf9c031$var$is.equ(size, state.size, $2ec6beadbaf9c031$var$shallowLoose)) state.setSize(size.width, size.height, size.updateStyle, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== $2ec6beadbaf9c031$var$calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed: onPointerMissed
            });
            // Check performance
            if (performance1 && !$2ec6beadbaf9c031$var$is.equ(performance1, state.performance, $2ec6beadbaf9c031$var$shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance1
                    }
                }));
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured) this.configure();
            $2ec6beadbaf9c031$export$dda1d9f60106f0e9.updateContainer(/*#__PURE__*/ $acw62.createElement($2ec6beadbaf9c031$var$Provider, {
                store: store,
                children: children,
                onCreated: onCreated,
                rootElement: canvas
            }), fiber, null, ()=>undefined);
            return store;
        },
        unmount () {
            $2ec6beadbaf9c031$export$4368d992c4eafac0(canvas);
        }
    };
}
function $2ec6beadbaf9c031$export$43caf9889c228507(children, canvas, config) {
    console.warn('R3F.render is no longer supported in React 18. Use createRoot instead!');
    const root = $2ec6beadbaf9c031$export$8b22cf2602fb60ce(canvas);
    root.configure(config);
    return root.render(children);
}
function $2ec6beadbaf9c031$var$Provider({ store: store, children: children, onCreated: onCreated, rootElement: rootElement }) {
    $2ec6beadbaf9c031$export$407448d2b89b1813(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notifiy that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $acw62.createElement($2ec6beadbaf9c031$export$2d1720544b23b823.Provider, {
        value: store
    }, children);
}
function $2ec6beadbaf9c031$export$4368d992c4eafac0(canvas, callback) {
    const root = $2ec6beadbaf9c031$export$d141bba7fdc215a3.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        $2ec6beadbaf9c031$export$dda1d9f60106f0e9.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    $2ec6beadbaf9c031$export$342063e11d6c3cad(state);
                    $2ec6beadbaf9c031$export$d141bba7fdc215a3.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function $2ec6beadbaf9c031$export$39b482c5e57630a8(children, container, state) {
    return /*#__PURE__*/ $acw62.createElement($2ec6beadbaf9c031$var$Portal, {
        key: container.uuid,
        children: children,
        container: container,
        state: state
    });
}
function $2ec6beadbaf9c031$var$Portal({ state: state = {}, children: children, container: container }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events: events, size: size, ...rest } = state;
    const previousRoot = $2ec6beadbaf9c031$export$df995fae86a55f06();
    const [raycaster] = $acw62.useState(()=>new $d5b33d7c30034067$export$8b7aaceff00bd2f());
    const [pointer] = $acw62.useState(()=>new $d5b33d7c30034067$export$c977b3e384af9ae1());
    const inject = $acw62.useCallback((rootState, injectState)=>{
        const intersect = {
            ...rootState
        }; // all prev state props
        // Only the fields of "rootState" that do not differ from injectState
        // Some props should be off-limits
        // Otherwise filter out the props that are different and let the inject layer take precedence
        Object.keys(rootState).forEach((key)=>{
            if (// Some props should be off-limits
            $2ec6beadbaf9c031$var$privateKeys.includes(key) || // Otherwise filter out the props that are different and let the inject layer take precedence
            // Unless the inject layer props is undefined, then we keep the root layer
            rootState[key] !== injectState[key] && injectState[key]) delete intersect[key];
        });
        let viewport = undefined;
        if (injectState && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new $d5b33d7c30034067$export$64b5c384219d3699(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) $2ec6beadbaf9c031$var$updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...intersect,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster: raycaster,
            pointer: pointer,
            mouse: pointer,
            previousRoot: // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState == null ? void 0 : injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            ...rest
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        state
    ]);
    const [usePortalStore] = $acw62.useState(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const previousState = previousRoot.getState();
        const store = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((set, get)=>({
                ...previousState,
                scene: container,
                raycaster: raycaster,
                pointer: pointer,
                mouse: pointer,
                previousRoot: previousRoot,
                events: {
                    ...previousState.events,
                    ...events
                },
                size: {
                    ...previousState.size,
                    ...size
                },
                ...rest,
                set: // Set and get refer to this root-state
                set,
                get: get,
                // Layers are allowed to override events
                setEvents: (events)=>set((state)=>({
                            ...state,
                            events: {
                                ...state.events,
                                ...events
                            }
                        }))
            }));
        return store;
    });
    $acw62.useEffect(()=>{
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const unsub = previousRoot.subscribe((prev)=>usePortalStore.setState((state)=>inject(prev, state)));
        return ()=>{
            unsub();
            usePortalStore.destroy();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        usePortalStore.setState((injectState)=>inject(previousRoot.getState(), injectState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inject
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, $2ec6beadbaf9c031$export$dda1d9f60106f0e9.createPortal(/*#__PURE__*/ $acw62.createElement($2ec6beadbaf9c031$export$2d1720544b23b823.Provider, {
        value: usePortalStore
    }, children), usePortalStore, null));
}
$2ec6beadbaf9c031$export$dda1d9f60106f0e9.injectIntoDevTools({
    bundleType: 0,
    rendererPackageName: '@react-three/fiber',
    version: $acw62.version
});
const $2ec6beadbaf9c031$export$90a7f3efeed30595 = $acw62.unstable_act;


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $186cacd6c17eb54c$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $186cacd6c17eb54c$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $acw62.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $acw62.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $acw62.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$186cacd6c17eb54c$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $186cacd6c17eb54c$var$g(r, f) : r,
            d ? $186cacd6c17eb54c$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $186cacd6c17eb54c$var$E(r), b());
    };
    return $186cacd6c17eb54c$var$X(s, !!t), $186cacd6c17eb54c$var$W(m), (0, $acw62.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $acw62.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $186cacd6c17eb54c$var$W(n) {
    (0, $acw62.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $186cacd6c17eb54c$var$X(n, t) {
    (0, $acw62.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $186cacd6c17eb54c$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$186cacd6c17eb54c$var$E(n.parentElement)
    ];
}
const $186cacd6c17eb54c$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $186cacd6c17eb54c$var$D = (n, t)=>$186cacd6c17eb54c$var$k.every((o)=>n[o] === t[o]);



var $acw62 = parcelRequire("acw62");
var $766f6a56a9206ba0$var$__defProp = Object.defineProperty;
var $766f6a56a9206ba0$var$__defProps = Object.defineProperties;
var $766f6a56a9206ba0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $766f6a56a9206ba0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $766f6a56a9206ba0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $766f6a56a9206ba0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $766f6a56a9206ba0$var$__defNormalProp = (obj, key, value)=>key in obj ? $766f6a56a9206ba0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $766f6a56a9206ba0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($766f6a56a9206ba0$var$__hasOwnProp.call(b, prop)) $766f6a56a9206ba0$var$__defNormalProp(a, prop, b[prop]);
    if ($766f6a56a9206ba0$var$__getOwnPropSymbols) {
        for (var prop of $766f6a56a9206ba0$var$__getOwnPropSymbols(b))if ($766f6a56a9206ba0$var$__propIsEnum.call(b, prop)) $766f6a56a9206ba0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $766f6a56a9206ba0$var$__spreadProps = (a, b)=>$766f6a56a9206ba0$var$__defProps(a, $766f6a56a9206ba0$var$__getOwnPropDescs(b));
var $766f6a56a9206ba0$var$_a, $766f6a56a9206ba0$var$_b;
const $766f6a56a9206ba0$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && ((($766f6a56a9206ba0$var$_a = window.document) == null ? void 0 : $766f6a56a9206ba0$var$_a.createElement) || (($766f6a56a9206ba0$var$_b = window.navigator) == null ? void 0 : $766f6a56a9206ba0$var$_b.product) === "ReactNative") ? $acw62.useLayoutEffect : $acw62.useEffect;
function $766f6a56a9206ba0$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $766f6a56a9206ba0$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $766f6a56a9206ba0$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $766f6a56a9206ba0$var$error = console.error;
console.error = function() {
    const message = [
        ...arguments
    ].join("");
    if ((message == null ? void 0 : message.startsWith("Warning:")) && message.includes("useContext")) {
        console.error = $766f6a56a9206ba0$var$error;
        return;
    }
    return $766f6a56a9206ba0$var$error.apply(this, arguments);
};
const $766f6a56a9206ba0$var$FiberContext = $766f6a56a9206ba0$var$wrapContext($acw62.createContext(null));
class $766f6a56a9206ba0$export$5a20fcbfd44d38b7 extends $acw62.Component {
    render() {
        return /* @__PURE__ */ $acw62.createElement($766f6a56a9206ba0$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $766f6a56a9206ba0$export$69c8591d5df5c7d6() {
    const root = $acw62.useContext($766f6a56a9206ba0$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $acw62.useId();
    const fiber = $acw62.useMemo(()=>{
        for (const maybeFiber of [
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $766f6a56a9206ba0$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $766f6a56a9206ba0$export$b537cf6ebaf7ff54() {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const root = $acw62.useMemo(()=>$766f6a56a9206ba0$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a2;
            return ((_a2 = node.stateNode) == null ? void 0 : _a2.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $766f6a56a9206ba0$export$aec415ac1d7388b6(type) {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const childRef = $acw62.useRef();
    $766f6a56a9206ba0$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        childRef.current = (_a2 = $766f6a56a9206ba0$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $766f6a56a9206ba0$export$b57c9fdd1434988b(type) {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const parentRef = $acw62.useRef();
    $766f6a56a9206ba0$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        parentRef.current = (_a2 = $766f6a56a9206ba0$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $766f6a56a9206ba0$export$8859381a76e56404() {
    const fiber = $766f6a56a9206ba0$export$69c8591d5df5c7d6();
    const [contextMap] = $acw62.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        if (node.type && typeof node.type === "object") {
            const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
            const context = enableRenderableContext ? node.type : node.type._context;
            if (context && context !== $766f6a56a9206ba0$var$FiberContext && !contextMap.has(context)) contextMap.set(context, $acw62.useContext($766f6a56a9206ba0$var$wrapContext(context)));
        }
        node = node.return;
    }
    return contextMap;
}
function $766f6a56a9206ba0$export$39579d26c695d393() {
    const contextMap = $766f6a56a9206ba0$export$8859381a76e56404();
    return $acw62.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $acw62.createElement(Prev, null, /* @__PURE__ */ $acw62.createElement(context.Provider, $766f6a56a9206ba0$var$__spreadProps($766f6a56a9206ba0$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $acw62.createElement($766f6a56a9206ba0$export$5a20fcbfd44d38b7, $766f6a56a9206ba0$var$__spreadValues({}, props))), [
        contextMap
    ]);
}







const $f24fded2ba3df096$var$DOM_EVENTS = {
    onClick: [
        'click',
        false
    ],
    onContextMenu: [
        'contextmenu',
        false
    ],
    onDoubleClick: [
        'dblclick',
        false
    ],
    onWheel: [
        'wheel',
        true
    ],
    onPointerDown: [
        'pointerdown',
        true
    ],
    onPointerUp: [
        'pointerup',
        true
    ],
    onPointerLeave: [
        'pointerleave',
        true
    ],
    onPointerMove: [
        'pointermove',
        true
    ],
    onPointerCancel: [
        'pointercancel',
        true
    ],
    onLostPointerCapture: [
        'lostpointercapture',
        true
    ]
};
/** Default R3F event manager for web */ function $f24fded2ba3df096$export$4bf9923669ad6c63(store) {
    const { handlePointer: handlePointer } = (0, $2ec6beadbaf9c031$export$db3b6bfb95261072)(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys($f24fded2ba3df096$var$DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events: events, internal: internal } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            var _events$handlers;
            const { set: set, events: events } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            Object.entries((_events$handlers = events.handlers) != null ? _events$handlers : []).forEach(([name, event])=>{
                const [eventName, passive] = $f24fded2ba3df096$var$DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive: passive
                });
            });
        },
        disconnect: ()=>{
            const { set: set, events: events } = store.getState();
            if (events.connected) {
                var _events$handlers2;
                Object.entries((_events$handlers2 = events.handlers) != null ? _events$handlers2 : []).forEach(([name, event])=>{
                    if (events && events.connected instanceof HTMLElement) {
                        const [eventName] = $f24fded2ba3df096$var$DOM_EVENTS[name];
                        events.connected.removeEventListener(eventName, event);
                    }
                });
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}
const $f24fded2ba3df096$var$CanvasImpl = /*#__PURE__*/ $acw62.forwardRef(function Canvas({ children: children, fallback: fallback, resize: resize, style: style, gl: gl, events: events = $f24fded2ba3df096$export$4bf9923669ad6c63, eventSource: eventSource, eventPrefix: eventPrefix, shadows: shadows, linear: linear, flat: flat, legacy: legacy, orthographic: orthographic, frameloop: frameloop, dpr: dpr, performance: performance, raycaster: raycaster, camera: camera, scene: scene, onPointerMissed: onPointerMissed, onCreated: onCreated, ...props }, forwardedRef) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    $acw62.useMemo(()=>(0, $2ec6beadbaf9c031$export$f1e1789686576879)($d5b33d7c30034067$exports), []);
    const Bridge = (0, $766f6a56a9206ba0$export$39579d26c695d393)();
    const [containerRef, containerRect] = (0, $186cacd6c17eb54c$export$2e2bcd8739ae039)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = $acw62.useRef(null);
    const divRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(forwardedRef, ()=>canvasRef.current);
    const handlePointerMissed = (0, $2ec6beadbaf9c031$export$3b14a55fb2447963)(onPointerMissed);
    const [block, setBlock] = $acw62.useState(false);
    const [error, setError] = $acw62.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = $acw62.useRef(null);
    (0, $2ec6beadbaf9c031$export$407448d2b89b1813)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, $2ec6beadbaf9c031$export$8b22cf2602fb60ce)(canvas);
            root.current.configure({
                gl: gl,
                events: events,
                shadows: shadows,
                linear: linear,
                flat: flat,
                legacy: legacy,
                orthographic: orthographic,
                frameloop: frameloop,
                dpr: dpr,
                performance: performance,
                raycaster: raycaster,
                camera: camera,
                scene: scene,
                size: containerRect,
                // Pass mutable reference to onPointerMissed so it's free to update
                onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                onCreated: (state)=>{
                    // Connect to event source
                    state.events.connect == null || state.events.connect(eventSource ? (0, $2ec6beadbaf9c031$export$23f2a1d2818174ef)(eventSource) ? eventSource.current : eventSource : divRef.current);
                    // Set up compute function
                    if (eventPrefix) state.setEvents({
                        compute: (event, state)=>{
                            const x = event[eventPrefix + 'X'];
                            const y = event[eventPrefix + 'Y'];
                            state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                            state.raycaster.setFromCamera(state.pointer, state.camera);
                        }
                    });
                    // Call onCreated callback
                    onCreated == null || onCreated(state);
                }
            });
            root.current.render(/*#__PURE__*/ $acw62.createElement(Bridge, null, /*#__PURE__*/ $acw62.createElement((0, $2ec6beadbaf9c031$export$a9c23c6ac3fc3eca), {
                set: setError
            }, /*#__PURE__*/ $acw62.createElement($acw62.Suspense, {
                fallback: /*#__PURE__*/ $acw62.createElement((0, $2ec6beadbaf9c031$export$ef35774e6d314e91), {
                    set: setBlock
                })
            }, children))));
        }
    });
    $acw62.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, $2ec6beadbaf9c031$export$4368d992c4eafac0)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? 'none' : 'auto';
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: divRef,
        style: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: pointerEvents,
            ...style
        }
    }, props), /*#__PURE__*/ $acw62.createElement("div", {
        ref: containerRef,
        style: {
            width: '100%',
            height: '100%'
        }
    }, /*#__PURE__*/ $acw62.createElement("canvas", {
        ref: canvasRef,
        style: {
            display: 'block'
        }
    }, fallback)));
});
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ const $f24fded2ba3df096$export$8d01c972ee8b14a9 = /*#__PURE__*/ $acw62.forwardRef(function CanvasWrapper(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $766f6a56a9206ba0$export$5a20fcbfd44d38b7), null, /*#__PURE__*/ $acw62.createElement($f24fded2ba3df096$var$CanvasImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    })));
});




var $acw62 = parcelRequire("acw62");




const $11ba8c3812c85a5e$export$83d89fbfd8236492 = /* @__PURE__ */ (()=>parseInt((0, $d5b33d7c30034067$export$3545e07a80636437).replace(/\D+/g, "")))();


const $9a6ff25e6616da7a$var$isCubeTexture = (def)=>def && def.isCubeTexture;
class $9a6ff25e6616da7a$export$a8dfc348093aebdf extends (0, $d5b33d7c30034067$export$e176487c05830cc5) {
    constructor(texture, options){
        var _a, _b;
        const isCubeMap = $9a6ff25e6616da7a$var$isCubeTexture(texture);
        const w = (_b = isCubeMap ? (_a = texture.image[0]) == null ? void 0 : _a.width : texture.image.width) != null ? _b : 1024;
        const cubeSize = w / 4;
        const _lodMax = Math.floor(Math.log2(cubeSize));
        const _cubeSize = Math.pow(2, _lodMax);
        const width = 3 * Math.max(_cubeSize, 112);
        const height = 4 * _cubeSize;
        const defines = [
            isCubeMap ? "#define ENVMAP_TYPE_CUBE" : "",
            `#define CUBEUV_TEXEL_WIDTH ${1 / width}`,
            `#define CUBEUV_TEXEL_HEIGHT ${1 / height}`,
            `#define CUBEUV_MAX_MIP ${_lodMax}.0`
        ];
        const vertexShader = /* glsl */ `
        varying vec3 vWorldPosition;
        void main() 
        {
            vec4 worldPosition = ( modelMatrix * vec4( position, 1.0 ) );
            vWorldPosition = worldPosition.xyz;
            
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
        `;
        const fragmentShader = defines.join("\n") + /* glsl */ `
        #define ENVMAP_TYPE_CUBE_UV
        varying vec3 vWorldPosition;
        uniform float radius;
        uniform float height;
        uniform float angle;
        #ifdef ENVMAP_TYPE_CUBE
            uniform samplerCube map;
        #else
            uniform sampler2D map;
        #endif
        // From: https://www.shadertoy.com/view/4tsBD7
        float diskIntersectWithBackFaceCulling( vec3 ro, vec3 rd, vec3 c, vec3 n, float r ) 
        {
            float d = dot ( rd, n );
            
            if( d > 0.0 ) { return 1e6; }
            
            vec3  o = ro - c;
            float t = - dot( n, o ) / d;
            vec3  q = o + rd * t;
            
            return ( dot( q, q ) < r * r ) ? t : 1e6;
        }
        // From: https://www.iquilezles.org/www/articles/intersectors/intersectors.htm
        float sphereIntersect( vec3 ro, vec3 rd, vec3 ce, float ra ) 
        {
            vec3 oc = ro - ce;
            float b = dot( oc, rd );
            float c = dot( oc, oc ) - ra * ra;
            float h = b * b - c;
            
            if( h < 0.0 ) { return -1.0; }
            
            h = sqrt( h );
            
            return - b + h;
        }
        vec3 project() 
        {
            vec3 p = normalize( vWorldPosition );
            vec3 camPos = cameraPosition;
            camPos.y -= height;
            float intersection = sphereIntersect( camPos, p, vec3( 0.0 ), radius );
            if( intersection > 0.0 ) {
                
                vec3 h = vec3( 0.0, - height, 0.0 );
                float intersection2 = diskIntersectWithBackFaceCulling( camPos, p, h, vec3( 0.0, 1.0, 0.0 ), radius );
                p = ( camPos + min( intersection, intersection2 ) * p ) / radius;
            } else {
                p = vec3( 0.0, 1.0, 0.0 );
            }
            return p;
        }
        #include <common>
        #include <cube_uv_reflection_fragment>
        void main() 
        {
            vec3 projectedWorldPosition = project();
            
            #ifdef ENVMAP_TYPE_CUBE
                vec3 outcolor = textureCube( map, projectedWorldPosition ).rgb;
            #else
                vec3 direction = normalize( projectedWorldPosition );
                vec2 uv = equirectUv( direction );
                vec3 outcolor = texture2D( map, uv ).rgb;
            #endif
            gl_FragColor = vec4( outcolor, 1.0 );
            #include <tonemapping_fragment>
            #include <${(0, $11ba8c3812c85a5e$export$83d89fbfd8236492) >= 154 ? "colorspace_fragment" : "encodings_fragment"}>
        }
        `;
        const uniforms = {
            map: {
                value: texture
            },
            height: {
                value: (options == null ? void 0 : options.height) || 15
            },
            radius: {
                value: (options == null ? void 0 : options.radius) || 100
            }
        };
        const geometry = new (0, $d5b33d7c30034067$export$9567cc828c9535da)(1, 16);
        const material = new (0, $d5b33d7c30034067$export$83c7d75d550a8b0d)({
            uniforms: uniforms,
            fragmentShader: fragmentShader,
            vertexShader: vertexShader,
            side: (0, $d5b33d7c30034067$export$3b296b6f144d5b03)
        });
        super(geometry, material);
    }
    set radius(radius) {
        this.material.uniforms.radius.value = radius;
    }
    get radius() {
        return this.material.uniforms.radius.value;
    }
    set height(height) {
        this.material.uniforms.height.value = height;
    }
    get height() {
        return this.material.uniforms.height.value;
    }
}





// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $2859987fb8f88888$var$ch2 = {};
var $2859987fb8f88888$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($2859987fb8f88888$var$ch2[id] || ($2859987fb8f88888$var$ch2[id] = URL.createObjectURL(new Blob([
        c
    ], {
        type: 'text/javascript'
    }))));
    w.onerror = function(e) {
        return cb(e.error, null);
    };
    w.onmessage = function(e) {
        return cb(null, e.data);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $2859987fb8f88888$var$u8 = Uint8Array, $2859987fb8f88888$var$u16 = Uint16Array, $2859987fb8f88888$var$u32 = Uint32Array;
// fixed length extra bits
var $2859987fb8f88888$var$fleb = new $2859987fb8f88888$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $2859987fb8f88888$var$fdeb = new $2859987fb8f88888$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $2859987fb8f88888$var$clim = new $2859987fb8f88888$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $2859987fb8f88888$var$freb = function(eb, start) {
    var b = new $2859987fb8f88888$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $2859987fb8f88888$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $2859987fb8f88888$var$_a = $2859987fb8f88888$var$freb($2859987fb8f88888$var$fleb, 2), $2859987fb8f88888$var$fl = $2859987fb8f88888$var$_a[0], $2859987fb8f88888$var$revfl = $2859987fb8f88888$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$2859987fb8f88888$var$fl[28] = 258, $2859987fb8f88888$var$revfl[258] = 28;
var $2859987fb8f88888$var$_b = $2859987fb8f88888$var$freb($2859987fb8f88888$var$fdeb, 0), $2859987fb8f88888$var$fd = $2859987fb8f88888$var$_b[0], $2859987fb8f88888$var$revfd = $2859987fb8f88888$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $2859987fb8f88888$var$rev = new $2859987fb8f88888$var$u16(32768);
for(var $2859987fb8f88888$var$i = 0; $2859987fb8f88888$var$i < 32768; ++$2859987fb8f88888$var$i){
    // reverse table algorithm from SO
    var $2859987fb8f88888$var$x = ($2859987fb8f88888$var$i & 0xAAAA) >>> 1 | ($2859987fb8f88888$var$i & 0x5555) << 1;
    $2859987fb8f88888$var$x = ($2859987fb8f88888$var$x & 0xCCCC) >>> 2 | ($2859987fb8f88888$var$x & 0x3333) << 2;
    $2859987fb8f88888$var$x = ($2859987fb8f88888$var$x & 0xF0F0) >>> 4 | ($2859987fb8f88888$var$x & 0x0F0F) << 4;
    $2859987fb8f88888$var$rev[$2859987fb8f88888$var$i] = (($2859987fb8f88888$var$x & 0xFF00) >>> 8 | ($2859987fb8f88888$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $2859987fb8f88888$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $2859987fb8f88888$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $2859987fb8f88888$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $2859987fb8f88888$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$2859987fb8f88888$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $2859987fb8f88888$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $2859987fb8f88888$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $2859987fb8f88888$var$flt = new $2859987fb8f88888$var$u8(288);
for(var $2859987fb8f88888$var$i = 0; $2859987fb8f88888$var$i < 144; ++$2859987fb8f88888$var$i)$2859987fb8f88888$var$flt[$2859987fb8f88888$var$i] = 8;
for(var $2859987fb8f88888$var$i = 144; $2859987fb8f88888$var$i < 256; ++$2859987fb8f88888$var$i)$2859987fb8f88888$var$flt[$2859987fb8f88888$var$i] = 9;
for(var $2859987fb8f88888$var$i = 256; $2859987fb8f88888$var$i < 280; ++$2859987fb8f88888$var$i)$2859987fb8f88888$var$flt[$2859987fb8f88888$var$i] = 7;
for(var $2859987fb8f88888$var$i = 280; $2859987fb8f88888$var$i < 288; ++$2859987fb8f88888$var$i)$2859987fb8f88888$var$flt[$2859987fb8f88888$var$i] = 8;
// fixed distance tree
var $2859987fb8f88888$var$fdt = new $2859987fb8f88888$var$u8(32);
for(var $2859987fb8f88888$var$i = 0; $2859987fb8f88888$var$i < 32; ++$2859987fb8f88888$var$i)$2859987fb8f88888$var$fdt[$2859987fb8f88888$var$i] = 5;
// fixed length map
var $2859987fb8f88888$var$flm = /*#__PURE__*/ $2859987fb8f88888$var$hMap($2859987fb8f88888$var$flt, 9, 0), $2859987fb8f88888$var$flrm = /*#__PURE__*/ $2859987fb8f88888$var$hMap($2859987fb8f88888$var$flt, 9, 1);
// fixed distance map
var $2859987fb8f88888$var$fdm = /*#__PURE__*/ $2859987fb8f88888$var$hMap($2859987fb8f88888$var$fdt, 5, 0), $2859987fb8f88888$var$fdrm = /*#__PURE__*/ $2859987fb8f88888$var$hMap($2859987fb8f88888$var$fdt, 5, 1);
// find max of array
var $2859987fb8f88888$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $2859987fb8f88888$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $2859987fb8f88888$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $2859987fb8f88888$var$shft = function(p) {
    return (p / 8 | 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $2859987fb8f88888$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof $2859987fb8f88888$var$u16 ? $2859987fb8f88888$var$u16 : v instanceof $2859987fb8f88888$var$u32 ? $2859987fb8f88888$var$u32 : $2859987fb8f88888$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var $2859987fb8f88888$var$inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && !st.l && sl < 5) return buf || new $2859987fb8f88888$var$u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $2859987fb8f88888$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $2859987fb8f88888$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $2859987fb8f88888$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $2859987fb8f88888$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $2859987fb8f88888$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = $2859987fb8f88888$var$flrm, dm = $2859987fb8f88888$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $2859987fb8f88888$var$bits(dat, pos, 31) + 257, hcLen = $2859987fb8f88888$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $2859987fb8f88888$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $2859987fb8f88888$var$u8(tl);
                // code length tree
                var clt = new $2859987fb8f88888$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$2859987fb8f88888$var$clim[i]] = $2859987fb8f88888$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $2859987fb8f88888$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $2859987fb8f88888$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$2859987fb8f88888$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $2859987fb8f88888$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $2859987fb8f88888$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $2859987fb8f88888$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $2859987fb8f88888$var$max(lt);
                // max dist bits
                dbt = $2859987fb8f88888$var$max(dt);
                lm = $2859987fb8f88888$var$hMap(lt, lbt, 1);
                dm = $2859987fb8f88888$var$hMap(dt, dbt, 1);
            } else throw 'invalid block type';
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$2859987fb8f88888$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
            if (!c) throw 'invalid length/literal';
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $2859987fb8f88888$var$fleb[i];
                    add = $2859987fb8f88888$var$bits(dat, pos, (1 << b) - 1) + $2859987fb8f88888$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$2859987fb8f88888$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw 'invalid distance';
                pos += d & 15;
                var dt = $2859987fb8f88888$var$fd[dsym];
                if (dsym > 3) {
                    var b = $2859987fb8f88888$var$fdeb[dsym];
                    dt += $2859987fb8f88888$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $2859987fb8f88888$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $2859987fb8f88888$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $2859987fb8f88888$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $2859987fb8f88888$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        $2859987fb8f88888$var$et,
        0
    ];
    if (s == 1) {
        var v = new $2859987fb8f88888$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $2859987fb8f88888$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $2859987fb8f88888$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $2859987fb8f88888$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $2859987fb8f88888$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($2859987fb8f88888$var$ln(n.l, l, d + 1), $2859987fb8f88888$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $2859987fb8f88888$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $2859987fb8f88888$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $2859987fb8f88888$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $2859987fb8f88888$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $2859987fb8f88888$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $2859987fb8f88888$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $2859987fb8f88888$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $2859987fb8f88888$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $2859987fb8f88888$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $2859987fb8f88888$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $2859987fb8f88888$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $2859987fb8f88888$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $2859987fb8f88888$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$2859987fb8f88888$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $2859987fb8f88888$var$clen(lf, $2859987fb8f88888$var$flt) + $2859987fb8f88888$var$clen(df, $2859987fb8f88888$var$fdt) + eb;
    var dtlen = $2859987fb8f88888$var$clen(lf, dlt) + $2859987fb8f88888$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $2859987fb8f88888$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $2859987fb8f88888$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $2859987fb8f88888$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $2859987fb8f88888$var$hMap(dlt, mlb, 0), ll = dlt, dm = $2859987fb8f88888$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $2859987fb8f88888$var$hMap(lct, mlcb, 0);
        $2859987fb8f88888$var$wbits(out, p, nlc - 257);
        $2859987fb8f88888$var$wbits(out, p + 5, ndc - 1);
        $2859987fb8f88888$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$2859987fb8f88888$var$wbits(out, p + 3 * i, lct[$2859987fb8f88888$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $2859987fb8f88888$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $2859987fb8f88888$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $2859987fb8f88888$var$flm, ll = $2859987fb8f88888$var$flt, dm = $2859987fb8f88888$var$fdm, dl = $2859987fb8f88888$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $2859987fb8f88888$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $2859987fb8f88888$var$wbits(out, p, syms[i] >>> 23 & 31), p += $2859987fb8f88888$var$fleb[len];
        var dst = syms[i] & 31;
        $2859987fb8f88888$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $2859987fb8f88888$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $2859987fb8f88888$var$fdeb[dst];
    } else $2859987fb8f88888$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $2859987fb8f88888$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $2859987fb8f88888$var$deo = /*#__PURE__*/ new $2859987fb8f88888$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $2859987fb8f88888$var$et = /*#__PURE__*/ new $2859987fb8f88888$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $2859987fb8f88888$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $2859987fb8f88888$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e < s) // write full block
        pos = $2859987fb8f88888$var$wfblk(w, pos, dat.subarray(i, e));
        else {
            // write final block
            w[i] = lst;
            pos = $2859987fb8f88888$var$wfblk(w, pos, dat.subarray(i, s));
        }
    }
    else {
        var opt = $2859987fb8f88888$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $2859987fb8f88888$var$u16(32768), head = new $2859987fb8f88888$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $2859987fb8f88888$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $2859987fb8f88888$var$u16(288), df = new $2859987fb8f88888$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $2859987fb8f88888$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $2859987fb8f88888$var$revfl[l] << 18 | $2859987fb8f88888$var$revfd[d];
                    var lin = $2859987fb8f88888$var$revfl[l] & 31, din = $2859987fb8f88888$var$revfd[d] & 31;
                    eb += $2859987fb8f88888$var$fleb[lin] + $2859987fb8f88888$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $2859987fb8f88888$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = $2859987fb8f88888$var$wfblk(w, pos + 1, $2859987fb8f88888$var$et);
    }
    return $2859987fb8f88888$var$slc(o, 0, pre + $2859987fb8f88888$var$shft(pos) + post);
};
// CRC32 table
var $2859987fb8f88888$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $2859987fb8f88888$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $2859987fb8f88888$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var $2859987fb8f88888$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var $2859987fb8f88888$var$dopt = function(dat, opt, pre, post, st) {
    return $2859987fb8f88888$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $2859987fb8f88888$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $2859987fb8f88888$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $2859987fb8f88888$var$ch = [];
// clone bufs
var $2859987fb8f88888$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k] instanceof $2859987fb8f88888$var$u8 || v[k] instanceof $2859987fb8f88888$var$u16 || v[k] instanceof $2859987fb8f88888$var$u32) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $2859987fb8f88888$var$wrkr = function(fns, init, id, cb) {
    var _a;
    if (!$2859987fb8f88888$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $2859987fb8f88888$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $2859987fb8f88888$var$ch[id] = $2859987fb8f88888$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $2859987fb8f88888$var$mrg({}, $2859987fb8f88888$var$ch[id][1]);
    return $2859987fb8f88888$var$wk($2859987fb8f88888$var$ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $2859987fb8f88888$var$cbfs(td), cb);
};
// base async inflate fn
var $2859987fb8f88888$var$bInflt = function() {
    return [
        $2859987fb8f88888$var$u8,
        $2859987fb8f88888$var$u16,
        $2859987fb8f88888$var$u32,
        $2859987fb8f88888$var$fleb,
        $2859987fb8f88888$var$fdeb,
        $2859987fb8f88888$var$clim,
        $2859987fb8f88888$var$fl,
        $2859987fb8f88888$var$fd,
        $2859987fb8f88888$var$flrm,
        $2859987fb8f88888$var$fdrm,
        $2859987fb8f88888$var$rev,
        $2859987fb8f88888$var$hMap,
        $2859987fb8f88888$var$max,
        $2859987fb8f88888$var$bits,
        $2859987fb8f88888$var$bits16,
        $2859987fb8f88888$var$shft,
        $2859987fb8f88888$var$slc,
        $2859987fb8f88888$var$inflt,
        $2859987fb8f88888$export$90366d8b308ba94a,
        $2859987fb8f88888$var$pbf,
        $2859987fb8f88888$var$gu8
    ];
};
var $2859987fb8f88888$var$bDflt = function() {
    return [
        $2859987fb8f88888$var$u8,
        $2859987fb8f88888$var$u16,
        $2859987fb8f88888$var$u32,
        $2859987fb8f88888$var$fleb,
        $2859987fb8f88888$var$fdeb,
        $2859987fb8f88888$var$clim,
        $2859987fb8f88888$var$revfl,
        $2859987fb8f88888$var$revfd,
        $2859987fb8f88888$var$flm,
        $2859987fb8f88888$var$flt,
        $2859987fb8f88888$var$fdm,
        $2859987fb8f88888$var$fdt,
        $2859987fb8f88888$var$rev,
        $2859987fb8f88888$var$deo,
        $2859987fb8f88888$var$et,
        $2859987fb8f88888$var$hMap,
        $2859987fb8f88888$var$wbits,
        $2859987fb8f88888$var$wbits16,
        $2859987fb8f88888$var$hTree,
        $2859987fb8f88888$var$ln,
        $2859987fb8f88888$var$lc,
        $2859987fb8f88888$var$clen,
        $2859987fb8f88888$var$wfblk,
        $2859987fb8f88888$var$wblk,
        $2859987fb8f88888$var$shft,
        $2859987fb8f88888$var$slc,
        $2859987fb8f88888$var$dflt,
        $2859987fb8f88888$var$dopt,
        $2859987fb8f88888$export$21533ff51b8a0b4a,
        $2859987fb8f88888$var$pbf
    ];
};
// gzip extra
var $2859987fb8f88888$var$gze = function() {
    return [
        $2859987fb8f88888$var$gzh,
        $2859987fb8f88888$var$gzhl,
        $2859987fb8f88888$var$wbytes,
        $2859987fb8f88888$var$crc,
        $2859987fb8f88888$var$crct
    ];
};
// gunzip extra
var $2859987fb8f88888$var$guze = function() {
    return [
        $2859987fb8f88888$var$gzs,
        $2859987fb8f88888$var$gzl
    ];
};
// zlib extra
var $2859987fb8f88888$var$zle = function() {
    return [
        $2859987fb8f88888$var$zlh,
        $2859987fb8f88888$var$wbytes,
        $2859987fb8f88888$var$adler
    ];
};
// unzlib extra
var $2859987fb8f88888$var$zule = function() {
    return [
        $2859987fb8f88888$var$zlv
    ];
};
// post buf
var $2859987fb8f88888$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $2859987fb8f88888$var$gu8 = function(o) {
    return o && o.size && new $2859987fb8f88888$var$u8(o.size);
};
// async helper
var $2859987fb8f88888$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $2859987fb8f88888$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $2859987fb8f88888$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $2859987fb8f88888$var$astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = $2859987fb8f88888$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (t) throw 'stream finished';
        if (!strm.ondata) throw 'no stream handler';
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $2859987fb8f88888$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $2859987fb8f88888$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $2859987fb8f88888$var$b8 = function(d, b) {
    return $2859987fb8f88888$var$b4(d, b) + $2859987fb8f88888$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $2859987fb8f88888$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $2859987fb8f88888$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $2859987fb8f88888$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $2859987fb8f88888$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $2859987fb8f88888$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $2859987fb8f88888$var$gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $2859987fb8f88888$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $2859987fb8f88888$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw 'invalid zlib data';
    if (d[1] & 32) throw 'invalid zlib data: preset dictionaries not supported';
};
function $2859987fb8f88888$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $2859987fb8f88888$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($2859987fb8f88888$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $2859987fb8f88888$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $2859987fb8f88888$var$astrmify([
            $2859987fb8f88888$var$bDflt,
            function() {
                return [
                    $2859987fb8f88888$var$astrm,
                    $2859987fb8f88888$export$ae157b6234afe138
                ];
            }
        ], this, $2859987fb8f88888$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $2859987fb8f88888$export$ae157b6234afe138(ev.data);
            onmessage = $2859987fb8f88888$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $2859987fb8f88888$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $2859987fb8f88888$var$cbify(data, opts, [
        $2859987fb8f88888$var$bDflt
    ], function(ev) {
        return $2859987fb8f88888$var$pbf($2859987fb8f88888$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $2859987fb8f88888$export$21533ff51b8a0b4a(data, opts) {
    return $2859987fb8f88888$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $2859987fb8f88888$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $2859987fb8f88888$var$u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        var l = this.p.length;
        var n = new $2859987fb8f88888$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $2859987fb8f88888$var$inflt(this.p, this.o, this.s);
        this.ondata($2859987fb8f88888$var$slc(dt, bts, this.s.b), this.d);
        this.o = $2859987fb8f88888$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $2859987fb8f88888$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $2859987fb8f88888$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $2859987fb8f88888$var$astrmify([
            $2859987fb8f88888$var$bInflt,
            function() {
                return [
                    $2859987fb8f88888$var$astrm,
                    $2859987fb8f88888$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $2859987fb8f88888$export$d1de70a877d6e43c();
            onmessage = $2859987fb8f88888$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $2859987fb8f88888$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $2859987fb8f88888$var$cbify(data, opts, [
        $2859987fb8f88888$var$bInflt
    ], function(ev) {
        return $2859987fb8f88888$var$pbf($2859987fb8f88888$export$90366d8b308ba94a(ev.data[0], $2859987fb8f88888$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $2859987fb8f88888$export$90366d8b308ba94a(data, out) {
    return $2859987fb8f88888$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $2859987fb8f88888$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $2859987fb8f88888$var$crc();
        this.l = 0;
        this.v = 1;
        $2859987fb8f88888$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $2859987fb8f88888$var$dopt(c, this.o, this.v && $2859987fb8f88888$var$gzhl(this.o), f && 8, !f);
        if (this.v) $2859987fb8f88888$var$gzh(raw, this.o), this.v = 0;
        if (f) $2859987fb8f88888$var$wbytes(raw, raw.length - 8, this.c.d()), $2859987fb8f88888$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $2859987fb8f88888$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $2859987fb8f88888$var$astrmify([
            $2859987fb8f88888$var$bDflt,
            $2859987fb8f88888$var$gze,
            function() {
                return [
                    $2859987fb8f88888$var$astrm,
                    $2859987fb8f88888$export$ae157b6234afe138,
                    $2859987fb8f88888$export$8e4b66d280bf8342
                ];
            }
        ], this, $2859987fb8f88888$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $2859987fb8f88888$export$8e4b66d280bf8342(ev.data);
            onmessage = $2859987fb8f88888$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $2859987fb8f88888$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $2859987fb8f88888$var$cbify(data, opts, [
        $2859987fb8f88888$var$bDflt,
        $2859987fb8f88888$var$gze,
        function() {
            return [
                $2859987fb8f88888$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $2859987fb8f88888$var$pbf($2859987fb8f88888$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $2859987fb8f88888$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $2859987fb8f88888$var$crc(), l = data.length;
    c.p(data);
    var d = $2859987fb8f88888$var$dopt(data, opts, $2859987fb8f88888$var$gzhl(opts), 8), s = d.length;
    return $2859987fb8f88888$var$gzh(d, opts), $2859987fb8f88888$var$wbytes(d, s - 8, c.d()), $2859987fb8f88888$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $2859987fb8f88888$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $2859987fb8f88888$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? $2859987fb8f88888$var$gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $2859987fb8f88888$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $2859987fb8f88888$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $2859987fb8f88888$var$astrmify([
            $2859987fb8f88888$var$bInflt,
            $2859987fb8f88888$var$guze,
            function() {
                return [
                    $2859987fb8f88888$var$astrm,
                    $2859987fb8f88888$export$d1de70a877d6e43c,
                    $2859987fb8f88888$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $2859987fb8f88888$export$4cb607de6db70415();
            onmessage = $2859987fb8f88888$var$astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function $2859987fb8f88888$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $2859987fb8f88888$var$cbify(data, opts, [
        $2859987fb8f88888$var$bInflt,
        $2859987fb8f88888$var$guze,
        function() {
            return [
                $2859987fb8f88888$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $2859987fb8f88888$var$pbf($2859987fb8f88888$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $2859987fb8f88888$export$c80456f7aaba691c(data, out) {
    return $2859987fb8f88888$var$inflt(data.subarray($2859987fb8f88888$var$gzs(data), -8), out || new $2859987fb8f88888$var$u8($2859987fb8f88888$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $2859987fb8f88888$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $2859987fb8f88888$var$adler();
        this.v = 1;
        $2859987fb8f88888$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $2859987fb8f88888$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $2859987fb8f88888$var$zlh(raw, this.o), this.v = 0;
        if (f) $2859987fb8f88888$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $2859987fb8f88888$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $2859987fb8f88888$var$astrmify([
            $2859987fb8f88888$var$bDflt,
            $2859987fb8f88888$var$zle,
            function() {
                return [
                    $2859987fb8f88888$var$astrm,
                    $2859987fb8f88888$export$ae157b6234afe138,
                    $2859987fb8f88888$export$4187ccf2467013b9
                ];
            }
        ], this, $2859987fb8f88888$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $2859987fb8f88888$export$4187ccf2467013b9(ev.data);
            onmessage = $2859987fb8f88888$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $2859987fb8f88888$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $2859987fb8f88888$var$cbify(data, opts, [
        $2859987fb8f88888$var$bDflt,
        $2859987fb8f88888$var$zle,
        function() {
            return [
                $2859987fb8f88888$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $2859987fb8f88888$var$pbf($2859987fb8f88888$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $2859987fb8f88888$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $2859987fb8f88888$var$adler();
    a.p(data);
    var d = $2859987fb8f88888$var$dopt(data, opts, 2, 4);
    return $2859987fb8f88888$var$zlh(d, opts), $2859987fb8f88888$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $2859987fb8f88888$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $2859987fb8f88888$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $2859987fb8f88888$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $2859987fb8f88888$export$cf6668790220dcad = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $2859987fb8f88888$var$astrmify([
            $2859987fb8f88888$var$bInflt,
            $2859987fb8f88888$var$zule,
            function() {
                return [
                    $2859987fb8f88888$var$astrm,
                    $2859987fb8f88888$export$d1de70a877d6e43c,
                    $2859987fb8f88888$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $2859987fb8f88888$export$af2424f875ff1b17();
            onmessage = $2859987fb8f88888$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $2859987fb8f88888$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $2859987fb8f88888$var$cbify(data, opts, [
        $2859987fb8f88888$var$bInflt,
        $2859987fb8f88888$var$zule,
        function() {
            return [
                $2859987fb8f88888$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $2859987fb8f88888$var$pbf($2859987fb8f88888$export$9ec8134f0f1b9fc6(ev.data[0], $2859987fb8f88888$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $2859987fb8f88888$export$9ec8134f0f1b9fc6(data, out) {
    return $2859987fb8f88888$var$inflt(($2859987fb8f88888$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $2859987fb8f88888$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $2859987fb8f88888$export$4cb607de6db70415;
        this.I = $2859987fb8f88888$export$d1de70a877d6e43c;
        this.Z = $2859987fb8f88888$export$af2424f875ff1b17;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $2859987fb8f88888$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $2859987fb8f88888$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $2859987fb8f88888$export$d5adcdd968132151;
        this.I = $2859987fb8f88888$export$fff8358d6dbaa9cc;
        this.Z = $2859987fb8f88888$export$cf6668790220dcad;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $2859987fb8f88888$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $2859987fb8f88888$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $2859987fb8f88888$export$cae1ce83fe4a1782(data, opts, cb) : $2859987fb8f88888$export$ca7cbb494e731274(data, opts, cb);
}
function $2859987fb8f88888$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $2859987fb8f88888$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $2859987fb8f88888$export$90366d8b308ba94a(data, out) : $2859987fb8f88888$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $2859987fb8f88888$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k;
        if (val instanceof $2859987fb8f88888$var$u8) t[n] = [
            val,
            o
        ];
        else if (Array.isArray(val)) t[n] = [
            val[0],
            $2859987fb8f88888$var$mrg(o, val[1])
        ];
        else $2859987fb8f88888$var$fltn(val, n + '/', t, o);
    }
};
// text encoder
var $2859987fb8f88888$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $2859987fb8f88888$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $2859987fb8f88888$var$tds = 0;
try {
    $2859987fb8f88888$var$td.decode($2859987fb8f88888$var$et, {
        stream: true
    });
    $2859987fb8f88888$var$tds = 1;
} catch (e) {}
// decode UTF8
var $2859987fb8f88888$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            $2859987fb8f88888$var$slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $2859987fb8f88888$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($2859987fb8f88888$var$tds) this.t = new TextDecoder();
        else this.p = $2859987fb8f88888$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback';
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) throw 'invalid utf-8 data';
                this.t = null;
            }
            return;
        }
        if (!this.p) throw 'stream finished';
        var dat = new $2859987fb8f88888$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $2859987fb8f88888$var$dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) throw 'invalid utf-8 data';
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $2859987fb8f88888$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback';
        if (this.d) throw 'stream finished';
        this.ondata($2859987fb8f88888$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $2859987fb8f88888$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $2859987fb8f88888$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($2859987fb8f88888$var$te) return $2859987fb8f88888$var$te.encode(str);
    var l = str.length;
    var ar = new $2859987fb8f88888$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $2859987fb8f88888$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $2859987fb8f88888$var$slc(ar, 0, ai);
}
function $2859987fb8f88888$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($2859987fb8f88888$var$td) return $2859987fb8f88888$var$td.decode(dat);
    else {
        var _a = $2859987fb8f88888$var$dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) throw 'invalid utf-8 data';
        return out;
    }
}
// deflate bit flag
var $2859987fb8f88888$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $2859987fb8f88888$var$slzh = function(d, b) {
    return b + 30 + $2859987fb8f88888$var$b2(d, b + 26) + $2859987fb8f88888$var$b2(d, b + 28);
};
// read zip header
var $2859987fb8f88888$var$zh = function(d, b, z) {
    var fnl = $2859987fb8f88888$var$b2(d, b + 28), fn = $2859987fb8f88888$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($2859987fb8f88888$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $2859987fb8f88888$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $2859987fb8f88888$var$z64e(d, es) : [
        bs,
        $2859987fb8f88888$var$b4(d, b + 24),
        $2859987fb8f88888$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $2859987fb8f88888$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $2859987fb8f88888$var$b2(d, b + 30) + $2859987fb8f88888$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $2859987fb8f88888$var$z64e = function(d, b) {
    for(; $2859987fb8f88888$var$b2(d, b) != 1; b += 4 + $2859987fb8f88888$var$b2(d, b + 2));
    return [
        $2859987fb8f88888$var$b8(d, b + 12),
        $2859987fb8f88888$var$b8(d, b + 4),
        $2859987fb8f88888$var$b8(d, b + 20)
    ];
};
// extra field length
var $2859987fb8f88888$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) throw 'extra field too long';
        le += l + 4;
    }
    return le;
};
// write zip header
var $2859987fb8f88888$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $2859987fb8f88888$var$exfl(ex);
    $2859987fb8f88888$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) throw 'date not in range 1980-2099';
    $2859987fb8f88888$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        $2859987fb8f88888$var$wbytes(d, b, f.crc);
        $2859987fb8f88888$var$wbytes(d, b + 4, c);
        $2859987fb8f88888$var$wbytes(d, b + 8, f.size);
    }
    $2859987fb8f88888$var$wbytes(d, b + 12, fl);
    $2859987fb8f88888$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $2859987fb8f88888$var$wbytes(d, b, col);
        $2859987fb8f88888$var$wbytes(d, b + 6, f.attrs);
        $2859987fb8f88888$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $2859987fb8f88888$var$wbytes(d, b, +k);
        $2859987fb8f88888$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $2859987fb8f88888$var$wzf = function(o, b, c, d, e) {
    $2859987fb8f88888$var$wbytes(o, b, 0x6054B50); // skip disk
    $2859987fb8f88888$var$wbytes(o, b + 8, c);
    $2859987fb8f88888$var$wbytes(o, b + 10, c);
    $2859987fb8f88888$var$wbytes(o, b + 12, d);
    $2859987fb8f88888$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $2859987fb8f88888$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $2859987fb8f88888$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback - add to ZIP archive before pushing';
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $2859987fb8f88888$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $2859987fb8f88888$export$2b25194e1767ea06.call(this, filename);
        this.d = new $2859987fb8f88888$export$ae157b6234afe138(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $2859987fb8f88888$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $2859987fb8f88888$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $2859987fb8f88888$export$2b25194e1767ea06.call(this, filename);
        this.d = new $2859987fb8f88888$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $2859987fb8f88888$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $2859987fb8f88888$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $2859987fb8f88888$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (this.d & 2) throw 'stream finished';
        var f = $2859987fb8f88888$export$366b39a6daa8ed7a(file.filename), fl = f.length;
        var com = file.comment, o = com && $2859987fb8f88888$export$366b39a6daa8ed7a(com);
        var u = fl != file.filename.length || o && com.length != o.length;
        var hl = fl + $2859987fb8f88888$var$exfl(file.extra) + 30;
        if (fl > 65535) throw 'filename too long';
        var header = new $2859987fb8f88888$var$u8(hl);
        $2859987fb8f88888$var$wzh(header, 0, file, f, u);
        var chks = [
            header
        ];
        var pAll = function() {
            for(var _i = 0, chks_1 = chks; _i < chks_1.length; _i++){
                var chk = chks_1[_i];
                _this_1.ondata(null, chk, false);
            }
            chks = [];
        };
        var tr = this.d;
        this.d = 0;
        var ind = this.u.length;
        var uf = $2859987fb8f88888$var$mrg(file, {
            f: f,
            u: u,
            o: o,
            t: function() {
                if (file.terminate) file.terminate();
            },
            r: function() {
                pAll();
                if (tr) {
                    var nxt = _this_1.u[ind + 1];
                    if (nxt) nxt.r();
                    else _this_1.d = 1;
                }
                tr = 1;
            }
        });
        var cl = 0;
        file.ondata = function(err, dat, final) {
            if (err) {
                _this_1.ondata(err, dat, final);
                _this_1.terminate();
            } else {
                cl += dat.length;
                chks.push(dat);
                if (final) {
                    var dd = new $2859987fb8f88888$var$u8(16);
                    $2859987fb8f88888$var$wbytes(dd, 0, 0x8074B50);
                    $2859987fb8f88888$var$wbytes(dd, 4, file.crc);
                    $2859987fb8f88888$var$wbytes(dd, 8, cl);
                    $2859987fb8f88888$var$wbytes(dd, 12, file.size);
                    chks.push(dd);
                    uf.c = cl, uf.b = hl + cl + 16, uf.crc = file.crc, uf.size = file.size;
                    if (tr) uf.r();
                    tr = 1;
                } else if (tr) pAll();
            }
        };
        this.u.push(uf);
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            if (this.d & 1) throw 'stream finishing';
            throw 'stream finished';
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $2859987fb8f88888$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $2859987fb8f88888$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $2859987fb8f88888$var$wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + $2859987fb8f88888$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $2859987fb8f88888$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $2859987fb8f88888$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    var r = {};
    $2859987fb8f88888$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbf = function() {
        var out = new $2859987fb8f88888$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $2859987fb8f88888$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $2859987fb8f88888$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $2859987fb8f88888$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cb(e, null);
            }
        }
        $2859987fb8f88888$var$wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $2859987fb8f88888$var$crc(), size = file.length;
        c.p(file);
        var f = $2859987fb8f88888$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $2859987fb8f88888$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $2859987fb8f88888$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                var l = d.length;
                files[i] = $2859987fb8f88888$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl('filename too long', null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $2859987fb8f88888$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($2859987fb8f88888$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $2859987fb8f88888$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $2859987fb8f88888$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $2859987fb8f88888$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $2859987fb8f88888$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $2859987fb8f88888$var$exfl(p.extra);
        if (s > 65535) throw 'filename too long';
        var d = compression ? $2859987fb8f88888$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $2859987fb8f88888$var$crc();
        c.p(file);
        files.push($2859987fb8f88888$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $2859987fb8f88888$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $2859987fb8f88888$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $2859987fb8f88888$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $2859987fb8f88888$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $2859987fb8f88888$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $2859987fb8f88888$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $2859987fb8f88888$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new $2859987fb8f88888$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, data, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $2859987fb8f88888$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new $2859987fb8f88888$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new $2859987fb8f88888$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $2859987fb8f88888$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $2859987fb8f88888$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $2859987fb8f88888$export$93f81d5bbbb7c6bf
        };
        this.p = $2859987fb8f88888$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) throw 'no callback';
        if (!this.p) throw 'stream finished';
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $2859987fb8f88888$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $2859987fb8f88888$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $2859987fb8f88888$var$b2(buf, i + 6), cmp_1 = $2859987fb8f88888$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $2859987fb8f88888$var$b2(buf, i + 26), es = $2859987fb8f88888$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_2 = [];
                        this_1.k.unshift(chks_2);
                        f = 2;
                        var sc_1 = $2859987fb8f88888$var$b4(buf, i + 18), su_1 = $2859987fb8f88888$var$b4(buf, i + 22);
                        var fn_1 = $2859987fb8f88888$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $2859987fb8f88888$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) throw 'no callback';
                                if (!sc_1) file_1.ondata(null, $2859987fb8f88888$var$et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) throw 'unknown compression type ' + cmp_1;
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_3 = chks_2; _i < chks_3.length; _i++){
                                        var dat = chks_3[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_2 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push($2859987fb8f88888$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $2859987fb8f88888$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($2859987fb8f88888$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) throw 'invalid zip file';
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
function $2859987fb8f88888$export$23c8d3f8757cab88(data, cb) {
    if (typeof cb != 'function') throw 'no callback';
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for(; $2859987fb8f88888$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cb('invalid zip file', null);
        return;
    }
    var lft = $2859987fb8f88888$var$b2(data, e + 8);
    if (!lft) cb(null, {});
    var c = lft;
    var o = $2859987fb8f88888$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $2859987fb8f88888$var$b4(data, e - 12);
        if ($2859987fb8f88888$var$b4(data, e) != 0x6064B50) {
            cb('invalid zip file', null);
            return;
        }
        c = lft = $2859987fb8f88888$var$b4(data, e + 32);
        o = $2859987fb8f88888$var$b4(data, e + 48);
    }
    var _loop_3 = function(i) {
        var _a = $2859987fb8f88888$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $2859987fb8f88888$var$slzh(data, off);
        o = no;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                files[fn] = d;
                if (!--lft) cb(null, files);
            }
        };
        if (!c_1) cbl(null, $2859987fb8f88888$var$slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) try {
                cbl(null, $2859987fb8f88888$export$90366d8b308ba94a(infl, new $2859987fb8f88888$var$u8(su)));
            } catch (e) {
                cbl(e, null);
            }
            else term.push($2859987fb8f88888$export$cae1ce83fe4a1782(infl, {
                size: su
            }, cbl));
        } else cbl('unknown compression type ' + c_1, null);
    };
    for(var i = 0; i < c; ++i)_loop_3(i);
    return tAll;
}
function $2859987fb8f88888$export$c757709326bb5901(data) {
    var files = {};
    var e = data.length - 22;
    for(; $2859987fb8f88888$var$b4(data, e) != 0x6054B50; --e){
        if (!e || data.length - e > 65558) throw 'invalid zip file';
    }
    var c = $2859987fb8f88888$var$b2(data, e + 8);
    if (!c) return {};
    var o = $2859987fb8f88888$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $2859987fb8f88888$var$b4(data, e - 12);
        if ($2859987fb8f88888$var$b4(data, e) != 0x6064B50) throw 'invalid zip file';
        c = $2859987fb8f88888$var$b4(data, e + 32);
        o = $2859987fb8f88888$var$b4(data, e + 48);
    }
    for(var i = 0; i < c; ++i){
        var _a = $2859987fb8f88888$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $2859987fb8f88888$var$slzh(data, off);
        o = no;
        if (!c_2) files[fn] = $2859987fb8f88888$var$slc(data, b, b + sc);
        else if (c_2 == 8) files[fn] = $2859987fb8f88888$export$90366d8b308ba94a(data.subarray(b, b + sc), new $2859987fb8f88888$var$u8(su));
        else throw 'unknown compression type ' + c_2;
    }
    return files;
}



const $f6d7c4e62ce766b3$var$hasColorSpace = (0, $11ba8c3812c85a5e$export$83d89fbfd8236492) >= 152;
class $f6d7c4e62ce766b3$export$ccf20607163eaf96 extends (0, $d5b33d7c30034067$export$792d8a18f2c55855) {
    constructor(manager){
        super(manager);
        this.type = (0, $d5b33d7c30034067$export$2697304443f382bc);
    }
    parse(buffer) {
        const USHORT_RANGE = 65536;
        const BITMAP_SIZE = USHORT_RANGE >> 3;
        const HUF_ENCBITS = 16;
        const HUF_DECBITS = 14;
        const HUF_ENCSIZE = (1 << HUF_ENCBITS) + 1;
        const HUF_DECSIZE = 1 << HUF_DECBITS;
        const HUF_DECMASK = HUF_DECSIZE - 1;
        const NBITS = 16;
        const A_OFFSET = 1 << NBITS - 1;
        const MOD_MASK = (1 << NBITS) - 1;
        const SHORT_ZEROCODE_RUN = 59;
        const LONG_ZEROCODE_RUN = 63;
        const SHORTEST_LONG_RUN = 2 + LONG_ZEROCODE_RUN - SHORT_ZEROCODE_RUN;
        const ULONG_SIZE = 8;
        const FLOAT32_SIZE = 4;
        const INT32_SIZE = 4;
        const INT16_SIZE = 2;
        const INT8_SIZE = 1;
        const STATIC_HUFFMAN = 0;
        const DEFLATE = 1;
        const UNKNOWN = 0;
        const LOSSY_DCT = 1;
        const RLE = 2;
        const logBase = Math.pow(2.7182818, 2.2);
        function reverseLutFromBitmap(bitmap, lut) {
            var k = 0;
            for(var i = 0; i < USHORT_RANGE; ++i)if (i == 0 || bitmap[i >> 3] & 1 << (i & 7)) lut[k++] = i;
            var n = k - 1;
            while(k < USHORT_RANGE)lut[k++] = 0;
            return n;
        }
        function hufClearDecTable(hdec) {
            for(var i = 0; i < HUF_DECSIZE; i++){
                hdec[i] = {};
                hdec[i].len = 0;
                hdec[i].lit = 0;
                hdec[i].p = null;
            }
        }
        const getBitsReturn = {
            l: 0,
            c: 0,
            lc: 0
        };
        function getBits(nBits, c, lc, uInt8Array2, inOffset) {
            while(lc < nBits){
                c = c << 8 | parseUint8Array(uInt8Array2, inOffset);
                lc += 8;
            }
            lc -= nBits;
            getBitsReturn.l = c >> lc & (1 << nBits) - 1;
            getBitsReturn.c = c;
            getBitsReturn.lc = lc;
        }
        const hufTableBuffer = new Array(59);
        function hufCanonicalCodeTable(hcode) {
            for(var i = 0; i <= 58; ++i)hufTableBuffer[i] = 0;
            for(var i = 0; i < HUF_ENCSIZE; ++i)hufTableBuffer[hcode[i]] += 1;
            var c = 0;
            for(var i = 58; i > 0; --i){
                var nc = c + hufTableBuffer[i] >> 1;
                hufTableBuffer[i] = c;
                c = nc;
            }
            for(var i = 0; i < HUF_ENCSIZE; ++i){
                var l = hcode[i];
                if (l > 0) hcode[i] = l | hufTableBuffer[l]++ << 6;
            }
        }
        function hufUnpackEncTable(uInt8Array2, inDataView, inOffset, ni, im, iM, hcode) {
            var p = inOffset;
            var c = 0;
            var lc = 0;
            for(; im <= iM; im++){
                if (p.value - inOffset.value > ni) return false;
                getBits(6, c, lc, uInt8Array2, p);
                var l = getBitsReturn.l;
                c = getBitsReturn.c;
                lc = getBitsReturn.lc;
                hcode[im] = l;
                if (l == LONG_ZEROCODE_RUN) {
                    if (p.value - inOffset.value > ni) throw "Something wrong with hufUnpackEncTable";
                    getBits(8, c, lc, uInt8Array2, p);
                    var zerun = getBitsReturn.l + SHORTEST_LONG_RUN;
                    c = getBitsReturn.c;
                    lc = getBitsReturn.lc;
                    if (im + zerun > iM + 1) throw "Something wrong with hufUnpackEncTable";
                    while(zerun--)hcode[im++] = 0;
                    im--;
                } else if (l >= SHORT_ZEROCODE_RUN) {
                    var zerun = l - SHORT_ZEROCODE_RUN + 2;
                    if (im + zerun > iM + 1) throw "Something wrong with hufUnpackEncTable";
                    while(zerun--)hcode[im++] = 0;
                    im--;
                }
            }
            hufCanonicalCodeTable(hcode);
        }
        function hufLength(code) {
            return code & 63;
        }
        function hufCode(code) {
            return code >> 6;
        }
        function hufBuildDecTable(hcode, im, iM, hdecod) {
            for(; im <= iM; im++){
                var c = hufCode(hcode[im]);
                var l = hufLength(hcode[im]);
                if (c >> l) throw "Invalid table entry";
                if (l > HUF_DECBITS) {
                    var pl = hdecod[c >> l - HUF_DECBITS];
                    if (pl.len) throw "Invalid table entry";
                    pl.lit++;
                    if (pl.p) {
                        var p = pl.p;
                        pl.p = new Array(pl.lit);
                        for(var i = 0; i < pl.lit - 1; ++i)pl.p[i] = p[i];
                    } else pl.p = new Array(1);
                    pl.p[pl.lit - 1] = im;
                } else if (l) {
                    var plOffset = 0;
                    for(var i = 1 << HUF_DECBITS - l; i > 0; i--){
                        var pl = hdecod[(c << HUF_DECBITS - l) + plOffset];
                        if (pl.len || pl.p) throw "Invalid table entry";
                        pl.len = l;
                        pl.lit = im;
                        plOffset++;
                    }
                }
            }
            return true;
        }
        const getCharReturn = {
            c: 0,
            lc: 0
        };
        function getChar(c, lc, uInt8Array2, inOffset) {
            c = c << 8 | parseUint8Array(uInt8Array2, inOffset);
            lc += 8;
            getCharReturn.c = c;
            getCharReturn.lc = lc;
        }
        const getCodeReturn = {
            c: 0,
            lc: 0
        };
        function getCode(po, rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outBufferOffset, outBufferEndOffset) {
            if (po == rlc) {
                if (lc < 8) {
                    getChar(c, lc, uInt8Array2, inOffset);
                    c = getCharReturn.c;
                    lc = getCharReturn.lc;
                }
                lc -= 8;
                var cs = c >> lc;
                var cs = new Uint8Array([
                    cs
                ])[0];
                if (outBufferOffset.value + cs > outBufferEndOffset) return false;
                var s = outBuffer[outBufferOffset.value - 1];
                while(cs-- > 0)outBuffer[outBufferOffset.value++] = s;
            } else if (outBufferOffset.value < outBufferEndOffset) outBuffer[outBufferOffset.value++] = po;
            else return false;
            getCodeReturn.c = c;
            getCodeReturn.lc = lc;
        }
        function UInt16(value) {
            return value & 65535;
        }
        function Int16(value) {
            var ref = UInt16(value);
            return ref > 32767 ? ref - 65536 : ref;
        }
        const wdec14Return = {
            a: 0,
            b: 0
        };
        function wdec14(l, h) {
            var ls = Int16(l);
            var hs = Int16(h);
            var hi = hs;
            var ai = ls + (hi & 1) + (hi >> 1);
            var as = ai;
            var bs = ai - hi;
            wdec14Return.a = as;
            wdec14Return.b = bs;
        }
        function wdec16(l, h) {
            var m = UInt16(l);
            var d = UInt16(h);
            var bb = m - (d >> 1) & MOD_MASK;
            var aa = d + bb - A_OFFSET & MOD_MASK;
            wdec14Return.a = aa;
            wdec14Return.b = bb;
        }
        function wav2Decode(buffer2, j, nx, ox, ny, oy, mx) {
            var w14 = mx < 16384;
            var n = nx > ny ? ny : nx;
            var p = 1;
            var p2;
            while(p <= n)p <<= 1;
            p >>= 1;
            p2 = p;
            p >>= 1;
            while(p >= 1){
                var py = 0;
                var ey = py + oy * (ny - p2);
                var oy1 = oy * p;
                var oy2 = oy * p2;
                var ox1 = ox * p;
                var ox2 = ox * p2;
                var i00, i01, i10, i11;
                for(; py <= ey; py += oy2){
                    var px = py;
                    var ex = py + ox * (nx - p2);
                    for(; px <= ex; px += ox2){
                        var p01 = px + ox1;
                        var p10 = px + oy1;
                        var p11 = p10 + ox1;
                        if (w14) {
                            wdec14(buffer2[px + j], buffer2[p10 + j]);
                            i00 = wdec14Return.a;
                            i10 = wdec14Return.b;
                            wdec14(buffer2[p01 + j], buffer2[p11 + j]);
                            i01 = wdec14Return.a;
                            i11 = wdec14Return.b;
                            wdec14(i00, i01);
                            buffer2[px + j] = wdec14Return.a;
                            buffer2[p01 + j] = wdec14Return.b;
                            wdec14(i10, i11);
                            buffer2[p10 + j] = wdec14Return.a;
                            buffer2[p11 + j] = wdec14Return.b;
                        } else {
                            wdec16(buffer2[px + j], buffer2[p10 + j]);
                            i00 = wdec14Return.a;
                            i10 = wdec14Return.b;
                            wdec16(buffer2[p01 + j], buffer2[p11 + j]);
                            i01 = wdec14Return.a;
                            i11 = wdec14Return.b;
                            wdec16(i00, i01);
                            buffer2[px + j] = wdec14Return.a;
                            buffer2[p01 + j] = wdec14Return.b;
                            wdec16(i10, i11);
                            buffer2[p10 + j] = wdec14Return.a;
                            buffer2[p11 + j] = wdec14Return.b;
                        }
                    }
                    if (nx & p) {
                        var p10 = px + oy1;
                        if (w14) wdec14(buffer2[px + j], buffer2[p10 + j]);
                        else wdec16(buffer2[px + j], buffer2[p10 + j]);
                        i00 = wdec14Return.a;
                        buffer2[p10 + j] = wdec14Return.b;
                        buffer2[px + j] = i00;
                    }
                }
                if (ny & p) {
                    var px = py;
                    var ex = py + ox * (nx - p2);
                    for(; px <= ex; px += ox2){
                        var p01 = px + ox1;
                        if (w14) wdec14(buffer2[px + j], buffer2[p01 + j]);
                        else wdec16(buffer2[px + j], buffer2[p01 + j]);
                        i00 = wdec14Return.a;
                        buffer2[p01 + j] = wdec14Return.b;
                        buffer2[px + j] = i00;
                    }
                }
                p2 = p;
                p >>= 1;
            }
            return py;
        }
        function hufDecode(encodingTable, decodingTable, uInt8Array2, inDataView, inOffset, ni, rlc, no, outBuffer, outOffset) {
            var c = 0;
            var lc = 0;
            var outBufferEndOffset = no;
            var inOffsetEnd = Math.trunc(inOffset.value + (ni + 7) / 8);
            while(inOffset.value < inOffsetEnd){
                getChar(c, lc, uInt8Array2, inOffset);
                c = getCharReturn.c;
                lc = getCharReturn.lc;
                while(lc >= HUF_DECBITS){
                    var index = c >> lc - HUF_DECBITS & HUF_DECMASK;
                    var pl = decodingTable[index];
                    if (pl.len) {
                        lc -= pl.len;
                        getCode(pl.lit, rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
                        c = getCodeReturn.c;
                        lc = getCodeReturn.lc;
                    } else {
                        if (!pl.p) throw "hufDecode issues";
                        var j;
                        for(j = 0; j < pl.lit; j++){
                            var l = hufLength(encodingTable[pl.p[j]]);
                            while(lc < l && inOffset.value < inOffsetEnd){
                                getChar(c, lc, uInt8Array2, inOffset);
                                c = getCharReturn.c;
                                lc = getCharReturn.lc;
                            }
                            if (lc >= l) {
                                if (hufCode(encodingTable[pl.p[j]]) == (c >> lc - l & (1 << l) - 1)) {
                                    lc -= l;
                                    getCode(pl.p[j], rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
                                    c = getCodeReturn.c;
                                    lc = getCodeReturn.lc;
                                    break;
                                }
                            }
                        }
                        if (j == pl.lit) throw "hufDecode issues";
                    }
                }
            }
            var i = 8 - ni & 7;
            c >>= i;
            lc -= i;
            while(lc > 0){
                var pl = decodingTable[c << HUF_DECBITS - lc & HUF_DECMASK];
                if (pl.len) {
                    lc -= pl.len;
                    getCode(pl.lit, rlc, c, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
                    c = getCodeReturn.c;
                    lc = getCodeReturn.lc;
                } else throw "hufDecode issues";
            }
            return true;
        }
        function hufUncompress(uInt8Array2, inDataView, inOffset, nCompressed, outBuffer, nRaw) {
            var outOffset = {
                value: 0
            };
            var initialInOffset = inOffset.value;
            var im = parseUint32(inDataView, inOffset);
            var iM = parseUint32(inDataView, inOffset);
            inOffset.value += 4;
            var nBits = parseUint32(inDataView, inOffset);
            inOffset.value += 4;
            if (im < 0 || im >= HUF_ENCSIZE || iM < 0 || iM >= HUF_ENCSIZE) throw "Something wrong with HUF_ENCSIZE";
            var freq = new Array(HUF_ENCSIZE);
            var hdec = new Array(HUF_DECSIZE);
            hufClearDecTable(hdec);
            var ni = nCompressed - (inOffset.value - initialInOffset);
            hufUnpackEncTable(uInt8Array2, inDataView, inOffset, ni, im, iM, freq);
            if (nBits > 8 * (nCompressed - (inOffset.value - initialInOffset))) throw "Something wrong with hufUncompress";
            hufBuildDecTable(freq, im, iM, hdec);
            hufDecode(freq, hdec, uInt8Array2, inDataView, inOffset, nBits, iM, nRaw, outBuffer, outOffset);
        }
        function applyLut(lut, data, nData) {
            for(var i = 0; i < nData; ++i)data[i] = lut[data[i]];
        }
        function predictor(source) {
            for(var t = 1; t < source.length; t++){
                var d = source[t - 1] + source[t] - 128;
                source[t] = d;
            }
        }
        function interleaveScalar(source, out) {
            var t1 = 0;
            var t2 = Math.floor((source.length + 1) / 2);
            var s = 0;
            var stop = source.length - 1;
            while(true){
                if (s > stop) break;
                out[s++] = source[t1++];
                if (s > stop) break;
                out[s++] = source[t2++];
            }
        }
        function decodeRunLength(source) {
            var size = source.byteLength;
            var out = new Array();
            var p = 0;
            var reader = new DataView(source);
            while(size > 0){
                var l = reader.getInt8(p++);
                if (l < 0) {
                    var count = -l;
                    size -= count + 1;
                    for(var i = 0; i < count; i++)out.push(reader.getUint8(p++));
                } else {
                    var count = l;
                    size -= 2;
                    var value = reader.getUint8(p++);
                    for(var i = 0; i < count + 1; i++)out.push(value);
                }
            }
            return out;
        }
        function lossyDctDecode(cscSet, rowPtrs, channelData, acBuffer, dcBuffer, outBuffer) {
            var dataView = new DataView(outBuffer.buffer);
            var width = channelData[cscSet.idx[0]].width;
            var height = channelData[cscSet.idx[0]].height;
            var numComp = 3;
            var numFullBlocksX = Math.floor(width / 8);
            var numBlocksX = Math.ceil(width / 8);
            var numBlocksY = Math.ceil(height / 8);
            var leftoverX = width - (numBlocksX - 1) * 8;
            var leftoverY = height - (numBlocksY - 1) * 8;
            var currAcComp = {
                value: 0
            };
            var currDcComp = new Array(numComp);
            var dctData = new Array(numComp);
            var halfZigBlock = new Array(numComp);
            var rowBlock = new Array(numComp);
            var rowOffsets = new Array(numComp);
            for(let comp2 = 0; comp2 < numComp; ++comp2){
                rowOffsets[comp2] = rowPtrs[cscSet.idx[comp2]];
                currDcComp[comp2] = comp2 < 1 ? 0 : currDcComp[comp2 - 1] + numBlocksX * numBlocksY;
                dctData[comp2] = new Float32Array(64);
                halfZigBlock[comp2] = new Uint16Array(64);
                rowBlock[comp2] = new Uint16Array(numBlocksX * 64);
            }
            for(let blocky = 0; blocky < numBlocksY; ++blocky){
                var maxY = 8;
                if (blocky == numBlocksY - 1) maxY = leftoverY;
                var maxX = 8;
                for(let blockx = 0; blockx < numBlocksX; ++blockx){
                    if (blockx == numBlocksX - 1) maxX = leftoverX;
                    for(let comp2 = 0; comp2 < numComp; ++comp2){
                        halfZigBlock[comp2].fill(0);
                        halfZigBlock[comp2][0] = dcBuffer[currDcComp[comp2]++];
                        unRleAC(currAcComp, acBuffer, halfZigBlock[comp2]);
                        unZigZag(halfZigBlock[comp2], dctData[comp2]);
                        dctInverse(dctData[comp2]);
                    }
                    csc709Inverse(dctData);
                    for(let comp2 = 0; comp2 < numComp; ++comp2)convertToHalf(dctData[comp2], rowBlock[comp2], blockx * 64);
                }
                let offset2 = 0;
                for(let comp2 = 0; comp2 < numComp; ++comp2){
                    const type2 = channelData[cscSet.idx[comp2]].type;
                    for(let y2 = 8 * blocky; y2 < 8 * blocky + maxY; ++y2){
                        offset2 = rowOffsets[comp2][y2];
                        for(let blockx = 0; blockx < numFullBlocksX; ++blockx){
                            const src = blockx * 64 + (y2 & 7) * 8;
                            dataView.setUint16(offset2 + 0 * INT16_SIZE * type2, rowBlock[comp2][src + 0], true);
                            dataView.setUint16(offset2 + 1 * INT16_SIZE * type2, rowBlock[comp2][src + 1], true);
                            dataView.setUint16(offset2 + 2 * INT16_SIZE * type2, rowBlock[comp2][src + 2], true);
                            dataView.setUint16(offset2 + 3 * INT16_SIZE * type2, rowBlock[comp2][src + 3], true);
                            dataView.setUint16(offset2 + 4 * INT16_SIZE * type2, rowBlock[comp2][src + 4], true);
                            dataView.setUint16(offset2 + 5 * INT16_SIZE * type2, rowBlock[comp2][src + 5], true);
                            dataView.setUint16(offset2 + 6 * INT16_SIZE * type2, rowBlock[comp2][src + 6], true);
                            dataView.setUint16(offset2 + 7 * INT16_SIZE * type2, rowBlock[comp2][src + 7], true);
                            offset2 += 8 * INT16_SIZE * type2;
                        }
                    }
                    if (numFullBlocksX != numBlocksX) for(let y2 = 8 * blocky; y2 < 8 * blocky + maxY; ++y2){
                        const offset3 = rowOffsets[comp2][y2] + 8 * numFullBlocksX * INT16_SIZE * type2;
                        const src = numFullBlocksX * 64 + (y2 & 7) * 8;
                        for(let x2 = 0; x2 < maxX; ++x2)dataView.setUint16(offset3 + x2 * INT16_SIZE * type2, rowBlock[comp2][src + x2], true);
                    }
                }
            }
            var halfRow = new Uint16Array(width);
            var dataView = new DataView(outBuffer.buffer);
            for(var comp = 0; comp < numComp; ++comp){
                channelData[cscSet.idx[comp]].decoded = true;
                var type = channelData[cscSet.idx[comp]].type;
                if (channelData[comp].type != 2) continue;
                for(var y = 0; y < height; ++y){
                    const offset2 = rowOffsets[comp][y];
                    for(var x = 0; x < width; ++x)halfRow[x] = dataView.getUint16(offset2 + x * INT16_SIZE * type, true);
                    for(var x = 0; x < width; ++x)dataView.setFloat32(offset2 + x * INT16_SIZE * type, decodeFloat16(halfRow[x]), true);
                }
            }
        }
        function unRleAC(currAcComp, acBuffer, halfZigBlock) {
            var acValue;
            var dctComp = 1;
            while(dctComp < 64){
                acValue = acBuffer[currAcComp.value];
                if (acValue == 65280) dctComp = 64;
                else if (acValue >> 8 == 255) dctComp += acValue & 255;
                else {
                    halfZigBlock[dctComp] = acValue;
                    dctComp++;
                }
                currAcComp.value++;
            }
        }
        function unZigZag(src, dst) {
            dst[0] = decodeFloat16(src[0]);
            dst[1] = decodeFloat16(src[1]);
            dst[2] = decodeFloat16(src[5]);
            dst[3] = decodeFloat16(src[6]);
            dst[4] = decodeFloat16(src[14]);
            dst[5] = decodeFloat16(src[15]);
            dst[6] = decodeFloat16(src[27]);
            dst[7] = decodeFloat16(src[28]);
            dst[8] = decodeFloat16(src[2]);
            dst[9] = decodeFloat16(src[4]);
            dst[10] = decodeFloat16(src[7]);
            dst[11] = decodeFloat16(src[13]);
            dst[12] = decodeFloat16(src[16]);
            dst[13] = decodeFloat16(src[26]);
            dst[14] = decodeFloat16(src[29]);
            dst[15] = decodeFloat16(src[42]);
            dst[16] = decodeFloat16(src[3]);
            dst[17] = decodeFloat16(src[8]);
            dst[18] = decodeFloat16(src[12]);
            dst[19] = decodeFloat16(src[17]);
            dst[20] = decodeFloat16(src[25]);
            dst[21] = decodeFloat16(src[30]);
            dst[22] = decodeFloat16(src[41]);
            dst[23] = decodeFloat16(src[43]);
            dst[24] = decodeFloat16(src[9]);
            dst[25] = decodeFloat16(src[11]);
            dst[26] = decodeFloat16(src[18]);
            dst[27] = decodeFloat16(src[24]);
            dst[28] = decodeFloat16(src[31]);
            dst[29] = decodeFloat16(src[40]);
            dst[30] = decodeFloat16(src[44]);
            dst[31] = decodeFloat16(src[53]);
            dst[32] = decodeFloat16(src[10]);
            dst[33] = decodeFloat16(src[19]);
            dst[34] = decodeFloat16(src[23]);
            dst[35] = decodeFloat16(src[32]);
            dst[36] = decodeFloat16(src[39]);
            dst[37] = decodeFloat16(src[45]);
            dst[38] = decodeFloat16(src[52]);
            dst[39] = decodeFloat16(src[54]);
            dst[40] = decodeFloat16(src[20]);
            dst[41] = decodeFloat16(src[22]);
            dst[42] = decodeFloat16(src[33]);
            dst[43] = decodeFloat16(src[38]);
            dst[44] = decodeFloat16(src[46]);
            dst[45] = decodeFloat16(src[51]);
            dst[46] = decodeFloat16(src[55]);
            dst[47] = decodeFloat16(src[60]);
            dst[48] = decodeFloat16(src[21]);
            dst[49] = decodeFloat16(src[34]);
            dst[50] = decodeFloat16(src[37]);
            dst[51] = decodeFloat16(src[47]);
            dst[52] = decodeFloat16(src[50]);
            dst[53] = decodeFloat16(src[56]);
            dst[54] = decodeFloat16(src[59]);
            dst[55] = decodeFloat16(src[61]);
            dst[56] = decodeFloat16(src[35]);
            dst[57] = decodeFloat16(src[36]);
            dst[58] = decodeFloat16(src[48]);
            dst[59] = decodeFloat16(src[49]);
            dst[60] = decodeFloat16(src[57]);
            dst[61] = decodeFloat16(src[58]);
            dst[62] = decodeFloat16(src[62]);
            dst[63] = decodeFloat16(src[63]);
        }
        function dctInverse(data) {
            const a = 0.5 * Math.cos(0.7853975);
            const b = 0.5 * Math.cos(3.14159 / 16);
            const c = 0.5 * Math.cos(3.14159 / 8);
            const d = 0.5 * Math.cos(3 * 3.14159 / 16);
            const e = 0.5 * Math.cos(0.981746875);
            const f = 0.5 * Math.cos(3 * 3.14159 / 8);
            const g = 0.5 * Math.cos(1.374445625);
            var alpha = new Array(4);
            var beta = new Array(4);
            var theta = new Array(4);
            var gamma = new Array(4);
            for(var row = 0; row < 8; ++row){
                var rowPtr = row * 8;
                alpha[0] = c * data[rowPtr + 2];
                alpha[1] = f * data[rowPtr + 2];
                alpha[2] = c * data[rowPtr + 6];
                alpha[3] = f * data[rowPtr + 6];
                beta[0] = b * data[rowPtr + 1] + d * data[rowPtr + 3] + e * data[rowPtr + 5] + g * data[rowPtr + 7];
                beta[1] = d * data[rowPtr + 1] - g * data[rowPtr + 3] - b * data[rowPtr + 5] - e * data[rowPtr + 7];
                beta[2] = e * data[rowPtr + 1] - b * data[rowPtr + 3] + g * data[rowPtr + 5] + d * data[rowPtr + 7];
                beta[3] = g * data[rowPtr + 1] - e * data[rowPtr + 3] + d * data[rowPtr + 5] - b * data[rowPtr + 7];
                theta[0] = a * (data[rowPtr + 0] + data[rowPtr + 4]);
                theta[3] = a * (data[rowPtr + 0] - data[rowPtr + 4]);
                theta[1] = alpha[0] + alpha[3];
                theta[2] = alpha[1] - alpha[2];
                gamma[0] = theta[0] + theta[1];
                gamma[1] = theta[3] + theta[2];
                gamma[2] = theta[3] - theta[2];
                gamma[3] = theta[0] - theta[1];
                data[rowPtr + 0] = gamma[0] + beta[0];
                data[rowPtr + 1] = gamma[1] + beta[1];
                data[rowPtr + 2] = gamma[2] + beta[2];
                data[rowPtr + 3] = gamma[3] + beta[3];
                data[rowPtr + 4] = gamma[3] - beta[3];
                data[rowPtr + 5] = gamma[2] - beta[2];
                data[rowPtr + 6] = gamma[1] - beta[1];
                data[rowPtr + 7] = gamma[0] - beta[0];
            }
            for(var column = 0; column < 8; ++column){
                alpha[0] = c * data[16 + column];
                alpha[1] = f * data[16 + column];
                alpha[2] = c * data[48 + column];
                alpha[3] = f * data[48 + column];
                beta[0] = b * data[8 + column] + d * data[24 + column] + e * data[40 + column] + g * data[56 + column];
                beta[1] = d * data[8 + column] - g * data[24 + column] - b * data[40 + column] - e * data[56 + column];
                beta[2] = e * data[8 + column] - b * data[24 + column] + g * data[40 + column] + d * data[56 + column];
                beta[3] = g * data[8 + column] - e * data[24 + column] + d * data[40 + column] - b * data[56 + column];
                theta[0] = a * (data[column] + data[32 + column]);
                theta[3] = a * (data[column] - data[32 + column]);
                theta[1] = alpha[0] + alpha[3];
                theta[2] = alpha[1] - alpha[2];
                gamma[0] = theta[0] + theta[1];
                gamma[1] = theta[3] + theta[2];
                gamma[2] = theta[3] - theta[2];
                gamma[3] = theta[0] - theta[1];
                data[0 + column] = gamma[0] + beta[0];
                data[8 + column] = gamma[1] + beta[1];
                data[16 + column] = gamma[2] + beta[2];
                data[24 + column] = gamma[3] + beta[3];
                data[32 + column] = gamma[3] - beta[3];
                data[40 + column] = gamma[2] - beta[2];
                data[48 + column] = gamma[1] - beta[1];
                data[56 + column] = gamma[0] - beta[0];
            }
        }
        function csc709Inverse(data) {
            for(var i = 0; i < 64; ++i){
                var y = data[0][i];
                var cb = data[1][i];
                var cr = data[2][i];
                data[0][i] = y + 1.5747 * cr;
                data[1][i] = y - 0.1873 * cb - 0.4682 * cr;
                data[2][i] = y + 1.8556 * cb;
            }
        }
        function convertToHalf(src, dst, idx) {
            for(var i = 0; i < 64; ++i)dst[idx + i] = (0, $d5b33d7c30034067$export$11ce8b759162cc80).toHalfFloat(toLinear(src[i]));
        }
        function toLinear(float) {
            if (float <= 1) return Math.sign(float) * Math.pow(Math.abs(float), 2.2);
            else return Math.sign(float) * Math.pow(logBase, Math.abs(float) - 1);
        }
        function uncompressRAW(info) {
            return new DataView(info.array.buffer, info.offset.value, info.size);
        }
        function uncompressRLE(info) {
            var compressed = info.viewer.buffer.slice(info.offset.value, info.offset.value + info.size);
            var rawBuffer = new Uint8Array(decodeRunLength(compressed));
            var tmpBuffer = new Uint8Array(rawBuffer.length);
            predictor(rawBuffer);
            interleaveScalar(rawBuffer, tmpBuffer);
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressZIP(info) {
            var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
            var rawBuffer = (0, $2859987fb8f88888$export$9ec8134f0f1b9fc6)(compressed);
            var tmpBuffer = new Uint8Array(rawBuffer.length);
            predictor(rawBuffer);
            interleaveScalar(rawBuffer, tmpBuffer);
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressPIZ(info) {
            var inDataView = info.viewer;
            var inOffset = {
                value: info.offset.value
            };
            var outBuffer = new Uint16Array(info.width * info.scanlineBlockSize * (info.channels * info.type));
            var bitmap = new Uint8Array(BITMAP_SIZE);
            var outBufferEnd = 0;
            var pizChannelData = new Array(info.channels);
            for(var i = 0; i < info.channels; i++){
                pizChannelData[i] = {};
                pizChannelData[i]["start"] = outBufferEnd;
                pizChannelData[i]["end"] = pizChannelData[i]["start"];
                pizChannelData[i]["nx"] = info.width;
                pizChannelData[i]["ny"] = info.lines;
                pizChannelData[i]["size"] = info.type;
                outBufferEnd += pizChannelData[i].nx * pizChannelData[i].ny * pizChannelData[i].size;
            }
            var minNonZero = parseUint16(inDataView, inOffset);
            var maxNonZero = parseUint16(inDataView, inOffset);
            if (maxNonZero >= BITMAP_SIZE) throw "Something is wrong with PIZ_COMPRESSION BITMAP_SIZE";
            if (minNonZero <= maxNonZero) for(var i = 0; i < maxNonZero - minNonZero + 1; i++)bitmap[i + minNonZero] = parseUint8(inDataView, inOffset);
            var lut = new Uint16Array(USHORT_RANGE);
            var maxValue = reverseLutFromBitmap(bitmap, lut);
            var length = parseUint32(inDataView, inOffset);
            hufUncompress(info.array, inDataView, inOffset, length, outBuffer, outBufferEnd);
            for(var i = 0; i < info.channels; ++i){
                var cd = pizChannelData[i];
                for(var j = 0; j < pizChannelData[i].size; ++j)wav2Decode(outBuffer, cd.start + j, cd.nx, cd.size, cd.ny, cd.nx * cd.size, maxValue);
            }
            applyLut(lut, outBuffer, outBufferEnd);
            var tmpOffset2 = 0;
            var tmpBuffer = new Uint8Array(outBuffer.buffer.byteLength);
            for(var y = 0; y < info.lines; y++)for(var c = 0; c < info.channels; c++){
                var cd = pizChannelData[c];
                var n = cd.nx * cd.size;
                var cp = new Uint8Array(outBuffer.buffer, cd.end * INT16_SIZE, n * INT16_SIZE);
                tmpBuffer.set(cp, tmpOffset2);
                tmpOffset2 += n * INT16_SIZE;
                cd.end += n;
            }
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressPXR(info) {
            var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
            var rawBuffer = (0, $2859987fb8f88888$export$9ec8134f0f1b9fc6)(compressed);
            const sz = info.lines * info.channels * info.width;
            const tmpBuffer = info.type == 1 ? new Uint16Array(sz) : new Uint32Array(sz);
            let tmpBufferEnd = 0;
            let writePtr = 0;
            const ptr = new Array(4);
            for(let y = 0; y < info.lines; y++)for(let c = 0; c < info.channels; c++){
                let pixel = 0;
                switch(info.type){
                    case 1:
                        ptr[0] = tmpBufferEnd;
                        ptr[1] = ptr[0] + info.width;
                        tmpBufferEnd = ptr[1] + info.width;
                        for(let j = 0; j < info.width; ++j){
                            const diff = rawBuffer[ptr[0]++] << 8 | rawBuffer[ptr[1]++];
                            pixel += diff;
                            tmpBuffer[writePtr] = pixel;
                            writePtr++;
                        }
                        break;
                    case 2:
                        ptr[0] = tmpBufferEnd;
                        ptr[1] = ptr[0] + info.width;
                        ptr[2] = ptr[1] + info.width;
                        tmpBufferEnd = ptr[2] + info.width;
                        for(let j = 0; j < info.width; ++j){
                            const diff = rawBuffer[ptr[0]++] << 24 | rawBuffer[ptr[1]++] << 16 | rawBuffer[ptr[2]++] << 8;
                            pixel += diff;
                            tmpBuffer[writePtr] = pixel;
                            writePtr++;
                        }
                        break;
                }
            }
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressDWA(info) {
            var inDataView = info.viewer;
            var inOffset = {
                value: info.offset.value
            };
            var outBuffer = new Uint8Array(info.width * info.lines * (info.channels * info.type * INT16_SIZE));
            var dwaHeader = {
                version: parseInt64(inDataView, inOffset),
                unknownUncompressedSize: parseInt64(inDataView, inOffset),
                unknownCompressedSize: parseInt64(inDataView, inOffset),
                acCompressedSize: parseInt64(inDataView, inOffset),
                dcCompressedSize: parseInt64(inDataView, inOffset),
                rleCompressedSize: parseInt64(inDataView, inOffset),
                rleUncompressedSize: parseInt64(inDataView, inOffset),
                rleRawSize: parseInt64(inDataView, inOffset),
                totalAcUncompressedCount: parseInt64(inDataView, inOffset),
                totalDcUncompressedCount: parseInt64(inDataView, inOffset),
                acCompression: parseInt64(inDataView, inOffset)
            };
            if (dwaHeader.version < 2) throw "EXRLoader.parse: " + EXRHeader.compression + " version " + dwaHeader.version + " is unsupported";
            var channelRules = new Array();
            var ruleSize = parseUint16(inDataView, inOffset) - INT16_SIZE;
            while(ruleSize > 0){
                var name = parseNullTerminatedString(inDataView.buffer, inOffset);
                var value = parseUint8(inDataView, inOffset);
                var compression = value >> 2 & 3;
                var csc = (value >> 4) - 1;
                var index = new Int8Array([
                    csc
                ])[0];
                var type = parseUint8(inDataView, inOffset);
                channelRules.push({
                    name: name,
                    index: index,
                    type: type,
                    compression: compression
                });
                ruleSize -= name.length + 3;
            }
            var channels = EXRHeader.channels;
            var channelData = new Array(info.channels);
            for(var i = 0; i < info.channels; ++i){
                var cd = channelData[i] = {};
                var channel = channels[i];
                cd.name = channel.name;
                cd.compression = UNKNOWN;
                cd.decoded = false;
                cd.type = channel.pixelType;
                cd.pLinear = channel.pLinear;
                cd.width = info.width;
                cd.height = info.lines;
            }
            var cscSet = {
                idx: new Array(3)
            };
            for(var offset2 = 0; offset2 < info.channels; ++offset2){
                var cd = channelData[offset2];
                for(var i = 0; i < channelRules.length; ++i){
                    var rule = channelRules[i];
                    if (cd.name == rule.name) {
                        cd.compression = rule.compression;
                        if (rule.index >= 0) cscSet.idx[rule.index] = offset2;
                        cd.offset = offset2;
                    }
                }
            }
            if (dwaHeader.acCompressedSize > 0) switch(dwaHeader.acCompression){
                case STATIC_HUFFMAN:
                    var acBuffer = new Uint16Array(dwaHeader.totalAcUncompressedCount);
                    hufUncompress(info.array, inDataView, inOffset, dwaHeader.acCompressedSize, acBuffer, dwaHeader.totalAcUncompressedCount);
                    break;
                case DEFLATE:
                    var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.totalAcUncompressedCount);
                    var data = (0, $2859987fb8f88888$export$9ec8134f0f1b9fc6)(compressed);
                    var acBuffer = new Uint16Array(data.buffer);
                    inOffset.value += dwaHeader.totalAcUncompressedCount;
                    break;
            }
            if (dwaHeader.dcCompressedSize > 0) {
                var zlibInfo = {
                    array: info.array,
                    offset: inOffset,
                    size: dwaHeader.dcCompressedSize
                };
                var dcBuffer = new Uint16Array(uncompressZIP(zlibInfo).buffer);
                inOffset.value += dwaHeader.dcCompressedSize;
            }
            if (dwaHeader.rleRawSize > 0) {
                var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.rleCompressedSize);
                var data = (0, $2859987fb8f88888$export$9ec8134f0f1b9fc6)(compressed);
                var rleBuffer = decodeRunLength(data.buffer);
                inOffset.value += dwaHeader.rleCompressedSize;
            }
            var outBufferEnd = 0;
            var rowOffsets = new Array(channelData.length);
            for(var i = 0; i < rowOffsets.length; ++i)rowOffsets[i] = new Array();
            for(var y = 0; y < info.lines; ++y)for(var chan = 0; chan < channelData.length; ++chan){
                rowOffsets[chan].push(outBufferEnd);
                outBufferEnd += channelData[chan].width * info.type * INT16_SIZE;
            }
            lossyDctDecode(cscSet, rowOffsets, channelData, acBuffer, dcBuffer, outBuffer);
            for(var i = 0; i < channelData.length; ++i){
                var cd = channelData[i];
                if (cd.decoded) continue;
                switch(cd.compression){
                    case RLE:
                        var row = 0;
                        var rleOffset = 0;
                        for(var y = 0; y < info.lines; ++y){
                            var rowOffsetBytes = rowOffsets[i][row];
                            for(var x = 0; x < cd.width; ++x){
                                for(var byte = 0; byte < INT16_SIZE * cd.type; ++byte)outBuffer[rowOffsetBytes++] = rleBuffer[rleOffset + byte * cd.width * cd.height];
                                rleOffset++;
                            }
                            row++;
                        }
                        break;
                    case LOSSY_DCT:
                    default:
                        throw "EXRLoader.parse: unsupported channel compression";
                }
            }
            return new DataView(outBuffer.buffer);
        }
        function parseNullTerminatedString(buffer2, offset2) {
            var uintBuffer = new Uint8Array(buffer2);
            var endOffset = 0;
            while(uintBuffer[offset2.value + endOffset] != 0)endOffset += 1;
            var stringValue = new TextDecoder().decode(uintBuffer.slice(offset2.value, offset2.value + endOffset));
            offset2.value = offset2.value + endOffset + 1;
            return stringValue;
        }
        function parseFixedLengthString(buffer2, offset2, size) {
            var stringValue = new TextDecoder().decode(new Uint8Array(buffer2).slice(offset2.value, offset2.value + size));
            offset2.value = offset2.value + size;
            return stringValue;
        }
        function parseRational(dataView, offset2) {
            var x = parseInt32(dataView, offset2);
            var y = parseUint32(dataView, offset2);
            return [
                x,
                y
            ];
        }
        function parseTimecode(dataView, offset2) {
            var x = parseUint32(dataView, offset2);
            var y = parseUint32(dataView, offset2);
            return [
                x,
                y
            ];
        }
        function parseInt32(dataView, offset2) {
            var Int32 = dataView.getInt32(offset2.value, true);
            offset2.value = offset2.value + INT32_SIZE;
            return Int32;
        }
        function parseUint32(dataView, offset2) {
            var Uint32 = dataView.getUint32(offset2.value, true);
            offset2.value = offset2.value + INT32_SIZE;
            return Uint32;
        }
        function parseUint8Array(uInt8Array2, offset2) {
            var Uint8 = uInt8Array2[offset2.value];
            offset2.value = offset2.value + INT8_SIZE;
            return Uint8;
        }
        function parseUint8(dataView, offset2) {
            var Uint8 = dataView.getUint8(offset2.value);
            offset2.value = offset2.value + INT8_SIZE;
            return Uint8;
        }
        const parseInt64 = function(dataView, offset2) {
            let int;
            if ("getBigInt64" in DataView.prototype) int = Number(dataView.getBigInt64(offset2.value, true));
            else int = dataView.getUint32(offset2.value + 4, true) + Number(dataView.getUint32(offset2.value, true) << 32);
            offset2.value += ULONG_SIZE;
            return int;
        };
        function parseFloat32(dataView, offset2) {
            var float = dataView.getFloat32(offset2.value, true);
            offset2.value += FLOAT32_SIZE;
            return float;
        }
        function decodeFloat32(dataView, offset2) {
            return (0, $d5b33d7c30034067$export$11ce8b759162cc80).toHalfFloat(parseFloat32(dataView, offset2));
        }
        function decodeFloat16(binary) {
            var exponent = (binary & 31744) >> 10, fraction = binary & 1023;
            return (binary >> 15 ? -1 : 1) * (exponent ? exponent === 31 ? fraction ? NaN : Infinity : Math.pow(2, exponent - 15) * (1 + fraction / 1024) : 6103515625e-14 * (fraction / 1024));
        }
        function parseUint16(dataView, offset2) {
            var Uint16 = dataView.getUint16(offset2.value, true);
            offset2.value += INT16_SIZE;
            return Uint16;
        }
        function parseFloat16(buffer2, offset2) {
            return decodeFloat16(parseUint16(buffer2, offset2));
        }
        function parseChlist(dataView, buffer2, offset2, size) {
            var startOffset = offset2.value;
            var channels = [];
            while(offset2.value < startOffset + size - 1){
                var name = parseNullTerminatedString(buffer2, offset2);
                var pixelType = parseInt32(dataView, offset2);
                var pLinear = parseUint8(dataView, offset2);
                offset2.value += 3;
                var xSampling = parseInt32(dataView, offset2);
                var ySampling = parseInt32(dataView, offset2);
                channels.push({
                    name: name,
                    pixelType: pixelType,
                    pLinear: pLinear,
                    xSampling: xSampling,
                    ySampling: ySampling
                });
            }
            offset2.value += 1;
            return channels;
        }
        function parseChromaticities(dataView, offset2) {
            var redX = parseFloat32(dataView, offset2);
            var redY = parseFloat32(dataView, offset2);
            var greenX = parseFloat32(dataView, offset2);
            var greenY = parseFloat32(dataView, offset2);
            var blueX = parseFloat32(dataView, offset2);
            var blueY = parseFloat32(dataView, offset2);
            var whiteX = parseFloat32(dataView, offset2);
            var whiteY = parseFloat32(dataView, offset2);
            return {
                redX: redX,
                redY: redY,
                greenX: greenX,
                greenY: greenY,
                blueX: blueX,
                blueY: blueY,
                whiteX: whiteX,
                whiteY: whiteY
            };
        }
        function parseCompression(dataView, offset2) {
            var compressionCodes = [
                "NO_COMPRESSION",
                "RLE_COMPRESSION",
                "ZIPS_COMPRESSION",
                "ZIP_COMPRESSION",
                "PIZ_COMPRESSION",
                "PXR24_COMPRESSION",
                "B44_COMPRESSION",
                "B44A_COMPRESSION",
                "DWAA_COMPRESSION",
                "DWAB_COMPRESSION"
            ];
            var compression = parseUint8(dataView, offset2);
            return compressionCodes[compression];
        }
        function parseBox2i(dataView, offset2) {
            var xMin = parseUint32(dataView, offset2);
            var yMin = parseUint32(dataView, offset2);
            var xMax = parseUint32(dataView, offset2);
            var yMax = parseUint32(dataView, offset2);
            return {
                xMin: xMin,
                yMin: yMin,
                xMax: xMax,
                yMax: yMax
            };
        }
        function parseLineOrder(dataView, offset2) {
            var lineOrders = [
                "INCREASING_Y"
            ];
            var lineOrder = parseUint8(dataView, offset2);
            return lineOrders[lineOrder];
        }
        function parseV2f(dataView, offset2) {
            var x = parseFloat32(dataView, offset2);
            var y = parseFloat32(dataView, offset2);
            return [
                x,
                y
            ];
        }
        function parseV3f(dataView, offset2) {
            var x = parseFloat32(dataView, offset2);
            var y = parseFloat32(dataView, offset2);
            var z = parseFloat32(dataView, offset2);
            return [
                x,
                y,
                z
            ];
        }
        function parseValue(dataView, buffer2, offset2, type, size) {
            if (type === "string" || type === "stringvector" || type === "iccProfile") return parseFixedLengthString(buffer2, offset2, size);
            else if (type === "chlist") return parseChlist(dataView, buffer2, offset2, size);
            else if (type === "chromaticities") return parseChromaticities(dataView, offset2);
            else if (type === "compression") return parseCompression(dataView, offset2);
            else if (type === "box2i") return parseBox2i(dataView, offset2);
            else if (type === "lineOrder") return parseLineOrder(dataView, offset2);
            else if (type === "float") return parseFloat32(dataView, offset2);
            else if (type === "v2f") return parseV2f(dataView, offset2);
            else if (type === "v3f") return parseV3f(dataView, offset2);
            else if (type === "int") return parseInt32(dataView, offset2);
            else if (type === "rational") return parseRational(dataView, offset2);
            else if (type === "timecode") return parseTimecode(dataView, offset2);
            else if (type === "preview") {
                offset2.value += size;
                return "skipped";
            } else {
                offset2.value += size;
                return void 0;
            }
        }
        function parseHeader(dataView, buffer2, offset2) {
            const EXRHeader2 = {};
            if (dataView.getUint32(0, true) != 20000630) throw "THREE.EXRLoader: provided file doesn't appear to be in OpenEXR format.";
            EXRHeader2.version = dataView.getUint8(4);
            const spec = dataView.getUint8(5);
            EXRHeader2.spec = {
                singleTile: !!(spec & 2),
                longName: !!(spec & 4),
                deepFormat: !!(spec & 8),
                multiPart: !!(spec & 16)
            };
            offset2.value = 8;
            var keepReading = true;
            while(keepReading){
                var attributeName = parseNullTerminatedString(buffer2, offset2);
                if (attributeName == 0) keepReading = false;
                else {
                    var attributeType = parseNullTerminatedString(buffer2, offset2);
                    var attributeSize = parseUint32(dataView, offset2);
                    var attributeValue = parseValue(dataView, buffer2, offset2, attributeType, attributeSize);
                    if (attributeValue === void 0) console.warn(`EXRLoader.parse: skipped unknown header attribute type '${attributeType}'.`);
                    else EXRHeader2[attributeName] = attributeValue;
                }
            }
            if ((spec & -5) != 0) {
                console.error("EXRHeader:", EXRHeader2);
                throw "THREE.EXRLoader: provided file is currently unsupported.";
            }
            return EXRHeader2;
        }
        function setupDecoder(EXRHeader2, dataView, uInt8Array2, offset2, outputType) {
            const EXRDecoder2 = {
                size: 0,
                viewer: dataView,
                array: uInt8Array2,
                offset: offset2,
                width: EXRHeader2.dataWindow.xMax - EXRHeader2.dataWindow.xMin + 1,
                height: EXRHeader2.dataWindow.yMax - EXRHeader2.dataWindow.yMin + 1,
                channels: EXRHeader2.channels.length,
                bytesPerLine: null,
                lines: null,
                inputSize: null,
                type: EXRHeader2.channels[0].pixelType,
                uncompress: null,
                getter: null,
                format: null,
                [$f6d7c4e62ce766b3$var$hasColorSpace ? "colorSpace" : "encoding"]: null
            };
            switch(EXRHeader2.compression){
                case "NO_COMPRESSION":
                    EXRDecoder2.lines = 1;
                    EXRDecoder2.uncompress = uncompressRAW;
                    break;
                case "RLE_COMPRESSION":
                    EXRDecoder2.lines = 1;
                    EXRDecoder2.uncompress = uncompressRLE;
                    break;
                case "ZIPS_COMPRESSION":
                    EXRDecoder2.lines = 1;
                    EXRDecoder2.uncompress = uncompressZIP;
                    break;
                case "ZIP_COMPRESSION":
                    EXRDecoder2.lines = 16;
                    EXRDecoder2.uncompress = uncompressZIP;
                    break;
                case "PIZ_COMPRESSION":
                    EXRDecoder2.lines = 32;
                    EXRDecoder2.uncompress = uncompressPIZ;
                    break;
                case "PXR24_COMPRESSION":
                    EXRDecoder2.lines = 16;
                    EXRDecoder2.uncompress = uncompressPXR;
                    break;
                case "DWAA_COMPRESSION":
                    EXRDecoder2.lines = 32;
                    EXRDecoder2.uncompress = uncompressDWA;
                    break;
                case "DWAB_COMPRESSION":
                    EXRDecoder2.lines = 256;
                    EXRDecoder2.uncompress = uncompressDWA;
                    break;
                default:
                    throw "EXRLoader.parse: " + EXRHeader2.compression + " is unsupported";
            }
            EXRDecoder2.scanlineBlockSize = EXRDecoder2.lines;
            if (EXRDecoder2.type == 1) switch(outputType){
                case 0, $d5b33d7c30034067$export$f6d331659b644596:
                    EXRDecoder2.getter = parseFloat16;
                    EXRDecoder2.inputSize = INT16_SIZE;
                    break;
                case 0, $d5b33d7c30034067$export$2697304443f382bc:
                    EXRDecoder2.getter = parseUint16;
                    EXRDecoder2.inputSize = INT16_SIZE;
                    break;
            }
            else if (EXRDecoder2.type == 2) switch(outputType){
                case 0, $d5b33d7c30034067$export$f6d331659b644596:
                    EXRDecoder2.getter = parseFloat32;
                    EXRDecoder2.inputSize = FLOAT32_SIZE;
                    break;
                case 0, $d5b33d7c30034067$export$2697304443f382bc:
                    EXRDecoder2.getter = decodeFloat32;
                    EXRDecoder2.inputSize = FLOAT32_SIZE;
            }
            else throw "EXRLoader.parse: unsupported pixelType " + EXRDecoder2.type + " for " + EXRHeader2.compression + ".";
            EXRDecoder2.blockCount = (EXRHeader2.dataWindow.yMax + 1) / EXRDecoder2.scanlineBlockSize;
            for(var i = 0; i < EXRDecoder2.blockCount; i++)parseInt64(dataView, offset2);
            EXRDecoder2.outputChannels = EXRDecoder2.channels == 3 ? 4 : EXRDecoder2.channels;
            const size = EXRDecoder2.width * EXRDecoder2.height * EXRDecoder2.outputChannels;
            switch(outputType){
                case 0, $d5b33d7c30034067$export$f6d331659b644596:
                    EXRDecoder2.byteArray = new Float32Array(size);
                    if (EXRDecoder2.channels < EXRDecoder2.outputChannels) EXRDecoder2.byteArray.fill(1, 0, size);
                    break;
                case 0, $d5b33d7c30034067$export$2697304443f382bc:
                    EXRDecoder2.byteArray = new Uint16Array(size);
                    if (EXRDecoder2.channels < EXRDecoder2.outputChannels) EXRDecoder2.byteArray.fill(15360, 0, size);
                    break;
                default:
                    console.error("THREE.EXRLoader: unsupported type: ", outputType);
                    break;
            }
            EXRDecoder2.bytesPerLine = EXRDecoder2.width * EXRDecoder2.inputSize * EXRDecoder2.channels;
            if (EXRDecoder2.outputChannels == 4) EXRDecoder2.format = (0, $d5b33d7c30034067$export$3f8bb04b555a363c);
            else EXRDecoder2.format = (0, $d5b33d7c30034067$export$4e041a7967d15c4b);
            if ($f6d7c4e62ce766b3$var$hasColorSpace) EXRDecoder2.colorSpace = "srgb-linear";
            else EXRDecoder2.encoding = 3e3;
            return EXRDecoder2;
        }
        const bufferDataView = new DataView(buffer);
        const uInt8Array = new Uint8Array(buffer);
        const offset = {
            value: 0
        };
        const EXRHeader = parseHeader(bufferDataView, buffer, offset);
        const EXRDecoder = setupDecoder(EXRHeader, bufferDataView, uInt8Array, offset, this.type);
        const tmpOffset = {
            value: 0
        };
        const channelOffsets = {
            R: 0,
            G: 1,
            B: 2,
            A: 3,
            Y: 0
        };
        for(let scanlineBlockIdx = 0; scanlineBlockIdx < EXRDecoder.height / EXRDecoder.scanlineBlockSize; scanlineBlockIdx++){
            const line = parseUint32(bufferDataView, offset);
            EXRDecoder.size = parseUint32(bufferDataView, offset);
            EXRDecoder.lines = line + EXRDecoder.scanlineBlockSize > EXRDecoder.height ? EXRDecoder.height - line : EXRDecoder.scanlineBlockSize;
            const isCompressed = EXRDecoder.size < EXRDecoder.lines * EXRDecoder.bytesPerLine;
            const viewer = isCompressed ? EXRDecoder.uncompress(EXRDecoder) : uncompressRAW(EXRDecoder);
            offset.value += EXRDecoder.size;
            for(let line_y = 0; line_y < EXRDecoder.scanlineBlockSize; line_y++){
                const true_y = line_y + scanlineBlockIdx * EXRDecoder.scanlineBlockSize;
                if (true_y >= EXRDecoder.height) break;
                for(let channelID = 0; channelID < EXRDecoder.channels; channelID++){
                    const cOff = channelOffsets[EXRHeader.channels[channelID].name];
                    for(let x = 0; x < EXRDecoder.width; x++){
                        tmpOffset.value = (line_y * (EXRDecoder.channels * EXRDecoder.width) + channelID * EXRDecoder.width + x) * EXRDecoder.inputSize;
                        const outIndex = (EXRDecoder.height - 1 - true_y) * (EXRDecoder.width * EXRDecoder.outputChannels) + x * EXRDecoder.outputChannels + cOff;
                        EXRDecoder.byteArray[outIndex] = EXRDecoder.getter(viewer, tmpOffset);
                    }
                }
            }
        }
        return {
            header: EXRHeader,
            width: EXRDecoder.width,
            height: EXRDecoder.height,
            data: EXRDecoder.byteArray,
            format: EXRDecoder.format,
            [$f6d7c4e62ce766b3$var$hasColorSpace ? "colorSpace" : "encoding"]: EXRDecoder[$f6d7c4e62ce766b3$var$hasColorSpace ? "colorSpace" : "encoding"],
            type: this.type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            if ($f6d7c4e62ce766b3$var$hasColorSpace) texture.colorSpace = texData.colorSpace;
            else texture.encoding = texData.encoding;
            texture.minFilter = (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
            texture.magFilter = (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
            texture.generateMipmaps = false;
            texture.flipY = false;
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}


class $1741da12ffb0eb8a$export$d076a711b55c758a extends (0, $d5b33d7c30034067$export$792d8a18f2c55855) {
    constructor(manager){
        super(manager);
        this.type = (0, $d5b33d7c30034067$export$2697304443f382bc);
    }
    // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
    parse(buffer) {
        const rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function(rgbe_error_code, msg) {
            switch(rgbe_error_code){
                case rgbe_read_error:
                    throw new Error("THREE.RGBELoader: Read Error: " + (msg || ""));
                case rgbe_write_error:
                    throw new Error("THREE.RGBELoader: Write Error: " + (msg || ""));
                case rgbe_format_error:
                    throw new Error("THREE.RGBELoader: Bad File Format: " + (msg || ""));
                default:
                case rgbe_memory_error:
                    throw new Error("THREE.RGBELoader: Memory Error: " + (msg || ""));
            }
        }, RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = "\n", fgets = function(buffer2, lineLimit, consume) {
            const chunkSize = 128;
            lineLimit = !lineLimit ? 1024 : lineLimit;
            let p = buffer2.pos, i = -1, len = 0, s = "", chunk = String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p, p + chunkSize)));
            while(0 > (i = chunk.indexOf(NEWLINE)) && len < lineLimit && p < buffer2.byteLength){
                s += chunk;
                len += chunk.length;
                p += chunkSize;
                chunk += String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p, p + chunkSize)));
            }
            if (-1 < i) {
                if (false !== consume) buffer2.pos += len + i + 1;
                return s + chunk.slice(0, i);
            }
            return false;
        }, RGBE_ReadHeader = function(buffer2) {
            const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, header = {
                valid: 0,
                string: "",
                comments: "",
                programtype: "RGBE",
                format: "",
                gamma: 1,
                exposure: 1,
                width: 0,
                height: 0
            };
            let line, match;
            if (buffer2.pos >= buffer2.byteLength || !(line = fgets(buffer2))) rgbe_error(rgbe_read_error, "no header found");
            if (!(match = line.match(magic_token_re))) rgbe_error(rgbe_format_error, "bad initial token");
            header.valid |= RGBE_VALID_PROGRAMTYPE;
            header.programtype = match[1];
            header.string += line + "\n";
            while(true){
                line = fgets(buffer2);
                if (false === line) break;
                header.string += line + "\n";
                if ("#" === line.charAt(0)) {
                    header.comments += line + "\n";
                    continue;
                }
                if (match = line.match(gamma_re)) header.gamma = parseFloat(match[1]);
                if (match = line.match(exposure_re)) header.exposure = parseFloat(match[1]);
                if (match = line.match(format_re)) {
                    header.valid |= RGBE_VALID_FORMAT;
                    header.format = match[1];
                }
                if (match = line.match(dimensions_re)) {
                    header.valid |= RGBE_VALID_DIMENSIONS;
                    header.height = parseInt(match[1], 10);
                    header.width = parseInt(match[2], 10);
                }
                if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS) break;
            }
            if (!(header.valid & RGBE_VALID_FORMAT)) rgbe_error(rgbe_format_error, "missing format specifier");
            if (!(header.valid & RGBE_VALID_DIMENSIONS)) rgbe_error(rgbe_format_error, "missing image size specifier");
            return header;
        }, RGBE_ReadPixels_RLE = function(buffer2, w2, h2) {
            const scanline_width = w2;
            if (// run length encoding is not allowed so read flat
            scanline_width < 8 || scanline_width > 32767 || // this file is not run length encoded
            2 !== buffer2[0] || 2 !== buffer2[1] || buffer2[2] & 128) return new Uint8Array(buffer2);
            if (scanline_width !== (buffer2[2] << 8 | buffer2[3])) rgbe_error(rgbe_format_error, "wrong scanline width");
            const data_rgba = new Uint8Array(4 * w2 * h2);
            if (!data_rgba.length) rgbe_error(rgbe_memory_error, "unable to allocate buffer space");
            let offset = 0, pos = 0;
            const ptr_end = 4 * scanline_width;
            const rgbeStart = new Uint8Array(4);
            const scanline_buffer = new Uint8Array(ptr_end);
            let num_scanlines = h2;
            while(num_scanlines > 0 && pos < buffer2.byteLength){
                if (pos + 4 > buffer2.byteLength) rgbe_error(rgbe_read_error);
                rgbeStart[0] = buffer2[pos++];
                rgbeStart[1] = buffer2[pos++];
                rgbeStart[2] = buffer2[pos++];
                rgbeStart[3] = buffer2[pos++];
                if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) rgbe_error(rgbe_format_error, "bad rgbe scanline format");
                let ptr = 0, count;
                while(ptr < ptr_end && pos < buffer2.byteLength){
                    count = buffer2[pos++];
                    const isEncodedRun = count > 128;
                    if (isEncodedRun) count -= 128;
                    if (0 === count || ptr + count > ptr_end) rgbe_error(rgbe_format_error, "bad scanline data");
                    if (isEncodedRun) {
                        const byteValue = buffer2[pos++];
                        for(let i = 0; i < count; i++)scanline_buffer[ptr++] = byteValue;
                    } else {
                        scanline_buffer.set(buffer2.subarray(pos, pos + count), ptr);
                        ptr += count;
                        pos += count;
                    }
                }
                const l = scanline_width;
                for(let i = 0; i < l; i++){
                    let off = 0;
                    data_rgba[offset] = scanline_buffer[i + off];
                    off += scanline_width;
                    data_rgba[offset + 1] = scanline_buffer[i + off];
                    off += scanline_width;
                    data_rgba[offset + 2] = scanline_buffer[i + off];
                    off += scanline_width;
                    data_rgba[offset + 3] = scanline_buffer[i + off];
                    offset += 4;
                }
                num_scanlines--;
            }
            return data_rgba;
        };
        const RGBEByteToRGBFloat = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2, e - 128) / 255;
            destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
            destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
            destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
            destArray[destOffset + 3] = 1;
        };
        const RGBEByteToRGBHalf = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2, e - 128) / 255;
            destArray[destOffset + 0] = (0, $d5b33d7c30034067$export$11ce8b759162cc80).toHalfFloat(Math.min(sourceArray[sourceOffset + 0] * scale, 65504));
            destArray[destOffset + 1] = (0, $d5b33d7c30034067$export$11ce8b759162cc80).toHalfFloat(Math.min(sourceArray[sourceOffset + 1] * scale, 65504));
            destArray[destOffset + 2] = (0, $d5b33d7c30034067$export$11ce8b759162cc80).toHalfFloat(Math.min(sourceArray[sourceOffset + 2] * scale, 65504));
            destArray[destOffset + 3] = (0, $d5b33d7c30034067$export$11ce8b759162cc80).toHalfFloat(1);
        };
        const byteArray = new Uint8Array(buffer);
        byteArray.pos = 0;
        const rgbe_header_info = RGBE_ReadHeader(byteArray);
        const w = rgbe_header_info.width, h = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w, h);
        let data, type;
        let numElements;
        switch(this.type){
            case 0, $d5b33d7c30034067$export$f6d331659b644596:
                numElements = image_rgba_data.length / 4;
                const floatArray = new Float32Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBFloat(image_rgba_data, j * 4, floatArray, j * 4);
                data = floatArray;
                type = (0, $d5b33d7c30034067$export$f6d331659b644596);
                break;
            case 0, $d5b33d7c30034067$export$2697304443f382bc:
                numElements = image_rgba_data.length / 4;
                const halfArray = new Uint16Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBHalf(image_rgba_data, j * 4, halfArray, j * 4);
                data = halfArray;
                type = (0, $d5b33d7c30034067$export$2697304443f382bc);
                break;
            default:
                throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
        }
        return {
            width: w,
            height: h,
            data: data,
            header: rgbe_header_info.string,
            gamma: rgbe_header_info.gamma,
            exposure: rgbe_header_info.exposure,
            type: type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            switch(texture.type){
                case 0, $d5b33d7c30034067$export$f6d331659b644596:
                case 0, $d5b33d7c30034067$export$2697304443f382bc:
                    if ("colorSpace" in texture) texture.colorSpace = "srgb-linear";
                    else texture.encoding = 3e3;
                    texture.minFilter = (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
                    texture.magFilter = (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
                    texture.generateMipmaps = false;
                    texture.flipY = true;
                    break;
            }
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}


/**
 * @monogrid/gainmap-js v3.1.0
 * With ❤️, by MONOGRID <rnd@monogrid.com>
 */ /**
 * @monogrid/gainmap-js v3.1.0
 * With ❤️, by MONOGRID <rnd@monogrid.com>
 */ 
const $3f27dfcfb244068b$var$getBufferForType = (type, width, height)=>{
    let out;
    switch(type){
        case 0, $d5b33d7c30034067$export$2e8ce08d3f6f5e10:
            out = new Uint8ClampedArray(width * height * 4);
            break;
        case 0, $d5b33d7c30034067$export$2697304443f382bc:
            out = new Uint16Array(width * height * 4);
            break;
        case 0, $d5b33d7c30034067$export$c3c7fc4518ebba96:
            out = new Uint32Array(width * height * 4);
            break;
        case 0, $d5b33d7c30034067$export$545fce0311a9796a:
            out = new Int8Array(width * height * 4);
            break;
        case 0, $d5b33d7c30034067$export$88572337f312435f:
            out = new Int16Array(width * height * 4);
            break;
        case 0, $d5b33d7c30034067$export$5c612977753abe2:
            out = new Int32Array(width * height * 4);
            break;
        case 0, $d5b33d7c30034067$export$f6d331659b644596:
            out = new Float32Array(width * height * 4);
            break;
        default:
            throw new Error('Unsupported data type');
    }
    return out;
};
let $3f27dfcfb244068b$var$_canReadPixelsResult;
/**
 * Test if this browser implementation can correctly read pixels from the specified
 * Render target type.
 *
 * Runs only once
 *
 * @param type
 * @param renderer
 * @param camera
 * @param renderTargetOptions
 * @returns
 */ const $3f27dfcfb244068b$var$canReadPixels = (type, renderer, camera, renderTargetOptions)=>{
    if ($3f27dfcfb244068b$var$_canReadPixelsResult !== undefined) return $3f27dfcfb244068b$var$_canReadPixelsResult;
    const testRT = new (0, $d5b33d7c30034067$export$3c052beb2e51e23f)(1, 1, renderTargetOptions);
    renderer.setRenderTarget(testRT);
    const mesh = new (0, $d5b33d7c30034067$export$e176487c05830cc5)(new (0, $d5b33d7c30034067$export$967d831af31f69ce)(), new (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)({
        color: 0xffffff
    }));
    renderer.render(mesh, camera);
    renderer.setRenderTarget(null);
    const out = $3f27dfcfb244068b$var$getBufferForType(type, testRT.width, testRT.height);
    renderer.readRenderTargetPixels(testRT, 0, 0, testRT.width, testRT.height, out);
    testRT.dispose();
    mesh.geometry.dispose();
    mesh.material.dispose();
    $3f27dfcfb244068b$var$_canReadPixelsResult = out[0] !== 0;
    return $3f27dfcfb244068b$var$_canReadPixelsResult;
};
/**
 * Utility class used for rendering a texture with a material
 *
 * @category Core
 * @group Core
 */ class $3f27dfcfb244068b$export$3722cfe417b6ed86 {
    /**
     * Constructs a new QuadRenderer
     *
     * @param options Parameters for this QuadRenderer
     */ constructor(options){
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        this._rendererIsDisposable = false;
        this._supportsReadPixels = true;
        /**
         * Renders the input texture using the specified material
         */ this.render = ()=>{
            this._renderer.setRenderTarget(this._renderTarget);
            try {
                this._renderer.render(this._scene, this._camera);
            } catch (e) {
                this._renderer.setRenderTarget(null);
                throw e;
            }
            this._renderer.setRenderTarget(null);
        };
        this._width = options.width;
        this._height = options.height;
        this._type = options.type;
        this._colorSpace = options.colorSpace;
        const rtOptions = {
            // fixed options
            format: (0, $d5b33d7c30034067$export$3f8bb04b555a363c),
            depthBuffer: false,
            stencilBuffer: false,
            // user options
            type: this._type,
            colorSpace: this._colorSpace,
            anisotropy: ((_a = options.renderTargetOptions) === null || _a === void 0 ? void 0 : _a.anisotropy) !== undefined ? (_b = options.renderTargetOptions) === null || _b === void 0 ? void 0 : _b.anisotropy : 1,
            generateMipmaps: ((_c = options.renderTargetOptions) === null || _c === void 0 ? void 0 : _c.generateMipmaps) !== undefined ? (_d = options.renderTargetOptions) === null || _d === void 0 ? void 0 : _d.generateMipmaps : false,
            magFilter: ((_e = options.renderTargetOptions) === null || _e === void 0 ? void 0 : _e.magFilter) !== undefined ? (_f = options.renderTargetOptions) === null || _f === void 0 ? void 0 : _f.magFilter : (0, $d5b33d7c30034067$export$8a72f490b25c56c8),
            minFilter: ((_g = options.renderTargetOptions) === null || _g === void 0 ? void 0 : _g.minFilter) !== undefined ? (_h = options.renderTargetOptions) === null || _h === void 0 ? void 0 : _h.minFilter : (0, $d5b33d7c30034067$export$8a72f490b25c56c8),
            samples: ((_j = options.renderTargetOptions) === null || _j === void 0 ? void 0 : _j.samples) !== undefined ? (_k = options.renderTargetOptions) === null || _k === void 0 ? void 0 : _k.samples : undefined,
            wrapS: ((_l = options.renderTargetOptions) === null || _l === void 0 ? void 0 : _l.wrapS) !== undefined ? (_m = options.renderTargetOptions) === null || _m === void 0 ? void 0 : _m.wrapS : (0, $d5b33d7c30034067$export$9d9334239a5a5e06),
            wrapT: ((_o = options.renderTargetOptions) === null || _o === void 0 ? void 0 : _o.wrapT) !== undefined ? (_p = options.renderTargetOptions) === null || _p === void 0 ? void 0 : _p.wrapT : (0, $d5b33d7c30034067$export$9d9334239a5a5e06)
        };
        this._material = options.material;
        if (options.renderer) this._renderer = options.renderer;
        else {
            this._renderer = $3f27dfcfb244068b$export$3722cfe417b6ed86.instantiateRenderer();
            this._rendererIsDisposable = true;
        }
        this._scene = new (0, $d5b33d7c30034067$export$38af1803e3442a7f)();
        this._camera = new (0, $d5b33d7c30034067$export$9ebf355ee4ed261b)();
        this._camera.position.set(0, 0, 10);
        this._camera.left = -0.5;
        this._camera.right = 0.5;
        this._camera.top = 0.5;
        this._camera.bottom = -0.5;
        this._camera.updateProjectionMatrix();
        if (!$3f27dfcfb244068b$var$canReadPixels(this._type, this._renderer, this._camera, rtOptions)) {
            let alternativeType;
            switch(this._type){
                case 0, $d5b33d7c30034067$export$2697304443f382bc:
                    alternativeType = this._renderer.extensions.has('EXT_color_buffer_float') ? (0, $d5b33d7c30034067$export$f6d331659b644596) : undefined;
                    break;
            }
            if (alternativeType !== undefined) {
                console.warn(`This browser does not support reading pixels from ${this._type} RenderTargets, switching to ${(0, $d5b33d7c30034067$export$f6d331659b644596)}`);
                this._type = alternativeType;
            } else {
                this._supportsReadPixels = false;
                console.warn('This browser dos not support toArray or toDataTexture, calls to those methods will result in an error thrown');
            }
        }
        this._quad = new (0, $d5b33d7c30034067$export$e176487c05830cc5)(new (0, $d5b33d7c30034067$export$967d831af31f69ce)(), this._material);
        this._quad.geometry.computeBoundingBox();
        this._scene.add(this._quad);
        this._renderTarget = new (0, $d5b33d7c30034067$export$3c052beb2e51e23f)(this.width, this.height, rtOptions);
        this._renderTarget.texture.mapping = ((_q = options.renderTargetOptions) === null || _q === void 0 ? void 0 : _q.mapping) !== undefined ? (_r = options.renderTargetOptions) === null || _r === void 0 ? void 0 : _r.mapping : (0, $d5b33d7c30034067$export$1beec6768cbb3d2d);
    }
    /**
     * Instantiates a temporary renderer
     *
     * @returns
     */ static instantiateRenderer() {
        const renderer = new (0, $d5b33d7c30034067$export$f6cc00ef28d7cf97)();
        renderer.setSize(128, 128);
        // renderer.outputColorSpace = SRGBColorSpace
        // renderer.toneMapping = LinearToneMapping
        // renderer.debug.checkShaderErrors = false
        // this._rendererIsDisposable = true
        return renderer;
    }
    /**
     * Obtains a Buffer containing the rendered texture.
     *
     * @throws Error if the browser cannot read pixels from this RenderTarget type.
     * @returns a TypedArray containing RGBA values from this renderer
     */ toArray() {
        if (!this._supportsReadPixels) throw new Error('Can\'t read pixels in this browser');
        const out = $3f27dfcfb244068b$var$getBufferForType(this._type, this._width, this._height);
        this._renderer.readRenderTargetPixels(this._renderTarget, 0, 0, this._width, this._height, out);
        return out;
    }
    /**
     * Performs a readPixel operation in the renderTarget
     * and returns a DataTexture containing the read data
     *
     * @param options options
     * @returns
     */ toDataTexture(options) {
        const returnValue = new (0, $d5b33d7c30034067$export$b691f601014eabe1)(// fixed values
        this.toArray(), this.width, this.height, (0, $d5b33d7c30034067$export$3f8bb04b555a363c), this._type, // user values
        (options === null || options === void 0 ? void 0 : options.mapping) || (0, $d5b33d7c30034067$export$1beec6768cbb3d2d), (options === null || options === void 0 ? void 0 : options.wrapS) || (0, $d5b33d7c30034067$export$9d9334239a5a5e06), (options === null || options === void 0 ? void 0 : options.wrapT) || (0, $d5b33d7c30034067$export$9d9334239a5a5e06), (options === null || options === void 0 ? void 0 : options.magFilter) || (0, $d5b33d7c30034067$export$8a72f490b25c56c8), (options === null || options === void 0 ? void 0 : options.minFilter) || (0, $d5b33d7c30034067$export$8a72f490b25c56c8), (options === null || options === void 0 ? void 0 : options.anisotropy) || 1, // fixed value
        (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        // set this afterwards, we can't set it in constructor
        returnValue.generateMipmaps = (options === null || options === void 0 ? void 0 : options.generateMipmaps) !== undefined ? options === null || options === void 0 ? void 0 : options.generateMipmaps : false;
        return returnValue;
    }
    /**
     * If using a disposable renderer, it will dispose it.
     */ disposeOnDemandRenderer() {
        this._renderer.setRenderTarget(null);
        if (this._rendererIsDisposable) {
            this._renderer.dispose();
            this._renderer.forceContextLoss();
        }
    }
    /**
     * Will dispose of **all** assets used by this renderer.
     *
     *
     * @param disposeRenderTarget will dispose of the renderTarget which will not be usable later
     * set this to true if you passed the `renderTarget.texture` to a `PMREMGenerator`
     * or are otherwise done with it.
     *
     * @example
     * ```js
     * const loader = new HDRJPGLoader(renderer)
     * const result = await loader.loadAsync('gainmap.jpeg')
     * const mesh = new Mesh(geometry, new MeshBasicMaterial({ map: result.renderTarget.texture }) )
     * // DO NOT dispose the renderTarget here,
     * // it is used directly in the material
     * result.dispose()
     * ```
     *
     * @example
     * ```js
     * const loader = new HDRJPGLoader(renderer)
     * const pmremGenerator = new PMREMGenerator( renderer );
     * const result = await loader.loadAsync('gainmap.jpeg')
     * const envMap = pmremGenerator.fromEquirectangular(result.renderTarget.texture)
     * const mesh = new Mesh(geometry, new MeshStandardMaterial({ envMap }) )
     * // renderTarget can be disposed here
     * // because it was used to generate a PMREM texture
     * result.dispose(true)
     * ```
     */ dispose(disposeRenderTarget) {
        this.disposeOnDemandRenderer();
        if (disposeRenderTarget) this.renderTarget.dispose();
        // dispose shader material texture uniforms
        if (this.material instanceof (0, $d5b33d7c30034067$export$83c7d75d550a8b0d)) Object.values(this.material.uniforms).forEach((v)=>{
            if (v.value instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) v.value.dispose();
        });
        // dispose other material properties
        Object.values(this.material).forEach((value)=>{
            if (value instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) value.dispose();
        });
        this.material.dispose();
        this._quad.geometry.dispose();
    }
    /**
     * Width of the texture
     */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        this._renderTarget.setSize(this._width, this._height);
    }
    /**
     * Height of the texture
     */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        this._renderTarget.setSize(this._width, this._height);
    }
    /**
     * The renderer used
     */ get renderer() {
        return this._renderer;
    }
    /**
     * The `WebGLRenderTarget` used.
     */ get renderTarget() {
        return this._renderTarget;
    }
    set renderTarget(value) {
        this._renderTarget = value;
        this._width = value.width;
        this._height = value.height;
    // this._type = value.texture.type
    }
    /**
     * The `Material` used.
     */ get material() {
        return this._material;
    }
    /**
     *
     */ get type() {
        return this._type;
    }
    get colorSpace() {
        return this._colorSpace;
    }
}



const $43eb07ae7cdea2cd$var$vertexShader = /* glsl */ `
varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;
const $43eb07ae7cdea2cd$var$fragmentShader = /* glsl */ `
// min half float value
#define HALF_FLOAT_MIN vec3( -65504, -65504, -65504 )
// max half float value
#define HALF_FLOAT_MAX vec3( 65504, 65504, 65504 )

uniform sampler2D sdr;
uniform sampler2D gainMap;
uniform vec3 gamma;
uniform vec3 offsetHdr;
uniform vec3 offsetSdr;
uniform vec3 gainMapMin;
uniform vec3 gainMapMax;
uniform float weightFactor;

varying vec2 vUv;

void main() {
  vec3 rgb = texture2D( sdr, vUv ).rgb;
  vec3 recovery = texture2D( gainMap, vUv ).rgb;
  vec3 logRecovery = pow( recovery, gamma );
  vec3 logBoost = gainMapMin * ( 1.0 - logRecovery ) + gainMapMax * logRecovery;
  vec3 hdrColor = (rgb + offsetSdr) * exp2( logBoost * weightFactor ) - offsetHdr;
  vec3 clampedHdrColor = max( HALF_FLOAT_MIN, min( HALF_FLOAT_MAX, hdrColor ));
  gl_FragColor = vec4( clampedHdrColor , 1.0 );
}
`;
/**
 * A Material which is able to decode the Gainmap into a full HDR Representation
 *
 * @category Materials
 * @group Materials
 */ class $43eb07ae7cdea2cd$export$e02cd6fd4585498a extends (0, $d5b33d7c30034067$export$83c7d75d550a8b0d) {
    /**
     *
     * @param params
     */ constructor({ gamma: gamma, offsetHdr: offsetHdr, offsetSdr: offsetSdr, gainMapMin: gainMapMin, gainMapMax: gainMapMax, maxDisplayBoost: maxDisplayBoost, hdrCapacityMin: hdrCapacityMin, hdrCapacityMax: hdrCapacityMax, sdr: sdr, gainMap: gainMap }){
        super({
            name: 'GainMapDecoderMaterial',
            vertexShader: $43eb07ae7cdea2cd$var$vertexShader,
            fragmentShader: $43eb07ae7cdea2cd$var$fragmentShader,
            uniforms: {
                sdr: {
                    value: sdr
                },
                gainMap: {
                    value: gainMap
                },
                gamma: {
                    value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)(1.0 / gamma[0], 1.0 / gamma[1], 1.0 / gamma[2])
                },
                offsetHdr: {
                    value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)().fromArray(offsetHdr)
                },
                offsetSdr: {
                    value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)().fromArray(offsetSdr)
                },
                gainMapMin: {
                    value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)().fromArray(gainMapMin)
                },
                gainMapMax: {
                    value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)().fromArray(gainMapMax)
                },
                weightFactor: {
                    value: (Math.log2(maxDisplayBoost) - hdrCapacityMin) / (hdrCapacityMax - hdrCapacityMin)
                }
            },
            blending: (0, $d5b33d7c30034067$export$63b8d6b580fc65ba),
            depthTest: false,
            depthWrite: false
        });
        this._maxDisplayBoost = maxDisplayBoost;
        this._hdrCapacityMin = hdrCapacityMin;
        this._hdrCapacityMax = hdrCapacityMax;
        this.needsUpdate = true;
        this.uniformsNeedUpdate = true;
    }
    get sdr() {
        return this.uniforms.sdr.value;
    }
    set sdr(value) {
        this.uniforms.sdr.value = value;
    }
    get gainMap() {
        return this.uniforms.gainMap.value;
    }
    set gainMap(value) {
        this.uniforms.gainMap.value = value;
    }
    /**
     * @see {@link GainMapMetadata.offsetHdr}
     */ get offsetHdr() {
        return this.uniforms.offsetHdr.value.toArray();
    }
    set offsetHdr(value) {
        this.uniforms.offsetHdr.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.offsetSdr}
     */ get offsetSdr() {
        return this.uniforms.offsetSdr.value.toArray();
    }
    set offsetSdr(value) {
        this.uniforms.offsetSdr.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.gainMapMin}
     */ get gainMapMin() {
        return this.uniforms.gainMapMin.value.toArray();
    }
    set gainMapMin(value) {
        this.uniforms.gainMapMin.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.gainMapMax}
     */ get gainMapMax() {
        return this.uniforms.gainMapMax.value.toArray();
    }
    set gainMapMax(value) {
        this.uniforms.gainMapMax.value.fromArray(value);
    }
    /**
     * @see {@link GainMapMetadata.gamma}
     */ get gamma() {
        const g = this.uniforms.gamma.value;
        return [
            1 / g.x,
            1 / g.y,
            1 / g.z
        ];
    }
    set gamma(value) {
        const g = this.uniforms.gamma.value;
        g.x = 1.0 / value[0];
        g.y = 1.0 / value[1];
        g.z = 1.0 / value[2];
    }
    /**
     * @see {@link GainMapMetadata.hdrCapacityMin}
     * @remarks Logarithmic space
     */ get hdrCapacityMin() {
        return this._hdrCapacityMin;
    }
    set hdrCapacityMin(value) {
        this._hdrCapacityMin = value;
        this.calculateWeight();
    }
    /**
     * @see {@link GainMapMetadata.hdrCapacityMin}
     * @remarks Logarithmic space
     */ get hdrCapacityMax() {
        return this._hdrCapacityMax;
    }
    set hdrCapacityMax(value) {
        this._hdrCapacityMax = value;
        this.calculateWeight();
    }
    /**
     * @see {@link GainmapDecodingParameters.maxDisplayBoost}
     * @remarks Non Logarithmic space
     */ get maxDisplayBoost() {
        return this._maxDisplayBoost;
    }
    set maxDisplayBoost(value) {
        this._maxDisplayBoost = Math.max(1, Math.min(65504, value));
        this.calculateWeight();
    }
    calculateWeight() {
        const val = (Math.log2(this._maxDisplayBoost) - this._hdrCapacityMin) / (this._hdrCapacityMax - this._hdrCapacityMin);
        this.uniforms.weightFactor.value = Math.max(0, Math.min(1, val));
    }
}
/**
 * Decodes a gain map using a WebGLRenderTarget
 *
 * @category Decoding Functions
 * @group Decoding Functions
 * @example
 * import { decode } from '@monogrid/gainmap-js'
 * import {
 *   Mesh,
 *   MeshBasicMaterial,
 *   PerspectiveCamera,
 *   PlaneGeometry,
 *   Scene,
 *   TextureLoader,
 *   WebGLRenderer
 * } from 'three'
 *
 * const renderer = new WebGLRenderer()
 *
 * const textureLoader = new TextureLoader()
 *
 * // load SDR Representation
 * const sdr = await textureLoader.loadAsync('sdr.jpg')
 * // load Gain map recovery image
 * const gainMap = await textureLoader.loadAsync('gainmap.jpg')
 * // load metadata
 * const metadata = await (await fetch('metadata.json')).json()
 *
 * const result = await decode({
 *   sdr,
 *   gainMap,
 *   // this allows to use `result.renderTarget.texture` directly
 *   renderer,
 *   // this will restore the full HDR range
 *   maxDisplayBoost: Math.pow(2, metadata.hdrCapacityMax),
 *   ...metadata
 * })
 *
 * const scene = new Scene()
 * // `result` can be used to populate a Texture
 * const mesh = new Mesh(
 *   new PlaneGeometry(),
 *   new MeshBasicMaterial({ map: result.renderTarget.texture })
 * )
 * scene.add(mesh)
 * renderer.render(scene, new PerspectiveCamera())
 *
 * // result must be manually disposed
 * // when you are done using it
 * result.dispose()
 *
 * @param params
 * @returns
 * @throws {Error} if the WebGLRenderer fails to render the gain map
 */ const $43eb07ae7cdea2cd$export$2f872c0f2117be69 = (params)=>{
    const { sdr: sdr, gainMap: gainMap, renderer: renderer } = params;
    if (sdr.colorSpace !== (0, $d5b33d7c30034067$export$561f394b24edfcaa)) {
        console.warn('SDR Colorspace needs to be *SRGBColorSpace*, setting it automatically');
        sdr.colorSpace = (0, $d5b33d7c30034067$export$561f394b24edfcaa);
    }
    sdr.needsUpdate = true;
    if (gainMap.colorSpace !== (0, $d5b33d7c30034067$export$42429b3acfb233a4)) {
        console.warn('Gainmap Colorspace needs to be *LinearSRGBColorSpace*, setting it automatically');
        gainMap.colorSpace = (0, $d5b33d7c30034067$export$42429b3acfb233a4);
    }
    gainMap.needsUpdate = true;
    const material = new $43eb07ae7cdea2cd$export$e02cd6fd4585498a({
        ...params,
        sdr: sdr,
        gainMap: gainMap
    });
    const quadRenderer = new (0, $3f27dfcfb244068b$export$3722cfe417b6ed86)({
        // TODO: three types are generic, eslint complains here, see how we can solve
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        width: sdr.image.width,
        // TODO: three types are generic, eslint complains here, see how we can solve
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        height: sdr.image.height,
        type: (0, $d5b33d7c30034067$export$2697304443f382bc),
        colorSpace: (0, $d5b33d7c30034067$export$42429b3acfb233a4),
        material: material,
        renderer: renderer,
        renderTargetOptions: params.renderTargetOptions
    });
    try {
        quadRenderer.render();
    } catch (e) {
        quadRenderer.disposeOnDemandRenderer();
        throw e;
    }
    return quadRenderer;
};
class $43eb07ae7cdea2cd$var$GainMapNotFoundError extends Error {
}
class $43eb07ae7cdea2cd$var$XMPMetadataNotFoundError extends Error {
}
const $43eb07ae7cdea2cd$var$getXMLValue = (xml, tag, defaultValue)=>{
    // Check for attribute format first: tag="value"
    const attributeMatch = new RegExp(`${tag}="([^"]*)"`, 'i').exec(xml);
    if (attributeMatch) return attributeMatch[1];
    // Check for tag format: <tag>value</tag> or <tag><rdf:li>value</rdf:li>...</tag>
    const tagMatch = new RegExp(`<${tag}[^>]*>([\\s\\S]*?)</${tag}>`, 'i').exec(xml);
    if (tagMatch) {
        // Check if it contains rdf:li elements
        const liValues = tagMatch[1].match(/<rdf:li>([^<]*)<\/rdf:li>/g);
        if (liValues && liValues.length === 3) return liValues.map((v)=>v.replace(/<\/?rdf:li>/g, ''));
        return tagMatch[1].trim();
    }
    if (defaultValue !== undefined) return defaultValue;
    throw new Error(`Can't find ${tag} in gainmap metadata`);
};
const $43eb07ae7cdea2cd$export$e8e129c92c64cfcd = (input)=>{
    let str;
    // support node test environment
    if (typeof TextDecoder !== 'undefined') str = new TextDecoder().decode(input);
    else str = input.toString();
    let start = str.indexOf('<x:xmpmeta');
    while(start !== -1){
        const end = str.indexOf('x:xmpmeta>', start);
        const xmpBlock = str.slice(start, end + 10);
        try {
            const gainMapMin = $43eb07ae7cdea2cd$var$getXMLValue(xmpBlock, 'hdrgm:GainMapMin', '0');
            const gainMapMax = $43eb07ae7cdea2cd$var$getXMLValue(xmpBlock, 'hdrgm:GainMapMax');
            const gamma = $43eb07ae7cdea2cd$var$getXMLValue(xmpBlock, 'hdrgm:Gamma', '1');
            const offsetSDR = $43eb07ae7cdea2cd$var$getXMLValue(xmpBlock, 'hdrgm:OffsetSDR', '0.015625');
            const offsetHDR = $43eb07ae7cdea2cd$var$getXMLValue(xmpBlock, 'hdrgm:OffsetHDR', '0.015625');
            // These are always attributes, so we can use a simpler regex
            const hdrCapacityMinMatch = /hdrgm:HDRCapacityMin="([^"]*)"/.exec(xmpBlock);
            const hdrCapacityMin = hdrCapacityMinMatch ? hdrCapacityMinMatch[1] : '0';
            const hdrCapacityMaxMatch = /hdrgm:HDRCapacityMax="([^"]*)"/.exec(xmpBlock);
            if (!hdrCapacityMaxMatch) throw new Error('Incomplete gainmap metadata');
            const hdrCapacityMax = hdrCapacityMaxMatch[1];
            return {
                gainMapMin: Array.isArray(gainMapMin) ? gainMapMin.map((v)=>parseFloat(v)) : [
                    parseFloat(gainMapMin),
                    parseFloat(gainMapMin),
                    parseFloat(gainMapMin)
                ],
                gainMapMax: Array.isArray(gainMapMax) ? gainMapMax.map((v)=>parseFloat(v)) : [
                    parseFloat(gainMapMax),
                    parseFloat(gainMapMax),
                    parseFloat(gainMapMax)
                ],
                gamma: Array.isArray(gamma) ? gamma.map((v)=>parseFloat(v)) : [
                    parseFloat(gamma),
                    parseFloat(gamma),
                    parseFloat(gamma)
                ],
                offsetSdr: Array.isArray(offsetSDR) ? offsetSDR.map((v)=>parseFloat(v)) : [
                    parseFloat(offsetSDR),
                    parseFloat(offsetSDR),
                    parseFloat(offsetSDR)
                ],
                offsetHdr: Array.isArray(offsetHDR) ? offsetHDR.map((v)=>parseFloat(v)) : [
                    parseFloat(offsetHDR),
                    parseFloat(offsetHDR),
                    parseFloat(offsetHDR)
                ],
                hdrCapacityMin: parseFloat(hdrCapacityMin),
                hdrCapacityMax: parseFloat(hdrCapacityMax)
            };
        } catch (e) {
        // Continue searching for another xmpmeta block if this one fails
        }
        start = str.indexOf('<x:xmpmeta', end);
    }
};
/**
 * MPF Extractor (Multi Picture Format Extractor)
 * By Henrik S Nilsson 2019
 *
 * Extracts images stored in images based on the MPF format (found here: https://www.cipa.jp/e/std/std-sec.html
 * under "CIPA DC-007-Translation-2021 Multi-Picture Format"
 *
 * Overly commented, and without intention of being complete or production ready.
 * Created to extract depth maps from iPhone images, and to learn about image metadata.
 * Kudos to: Phil Harvey (exiftool), Jaume Sanchez (android-lens-blur-depth-extractor)
 */ class $43eb07ae7cdea2cd$export$271cf0688b8d2d24 {
    constructor(options){
        this.options = {
            debug: options && options.debug !== undefined ? options.debug : false,
            extractFII: options && options.extractFII !== undefined ? options.extractFII : true,
            extractNonFII: options && options.extractNonFII !== undefined ? options.extractNonFII : true
        };
    }
    extract(imageArrayBuffer) {
        return new Promise((resolve, reject)=>{
            const debug = this.options.debug;
            const dataView = new DataView(imageArrayBuffer.buffer);
            // If you're executing this line on a big endian machine, it'll be reversed.
            // bigEnd further down though, refers to the endianness of the image itself.
            if (dataView.getUint16(0) !== 0xffd8) {
                reject(new Error('Not a valid jpeg'));
                return;
            }
            const length = dataView.byteLength;
            let offset = 2;
            let loops = 0;
            let marker; // APP# marker
            while(offset < length){
                if (++loops > 250) {
                    reject(new Error(`Found no marker after ${loops} loops \u{1F635}`));
                    return;
                }
                if (dataView.getUint8(offset) !== 0xff) {
                    reject(new Error(`Not a valid marker at offset 0x${offset.toString(16)}, found: 0x${dataView.getUint8(offset).toString(16)}`));
                    return;
                }
                marker = dataView.getUint8(offset + 1);
                if (debug) console.log(`Marker: ${marker.toString(16)}`);
                if (marker === 0xe2) {
                    if (debug) console.log('Found APP2 marker (0xffe2)');
                    // Works for iPhone 8 Plus, X, and XSMax. Or any photos of MPF format.
                    // Great way to visualize image information in html is using Exiftool. E.g.:
                    // ./exiftool.exe -htmldump -wantTrailer photo.jpg > photo.html
                    const formatPt = offset + 4;
                    /*
                     *  Structure of the MP Format Identifier
                     *
                     *  Offset Addr.  | Code (Hex)  | Description
                     *  +00             ff            Marker Prefix      <-- offset
                     *  +01             e2            APP2
                     *  +02             #n            APP2 Field Length
                     *  +03             #n            APP2 Field Length
                     *  +04             4d            'M'                <-- formatPt
                     *  +05             50            'P'
                     *  +06             46            'F'
                     *  +07             00            NULL
                     *                                                   <-- tiffOffset
                     */ if (dataView.getUint32(formatPt) === 0x4d504600) {
                        // Found MPF tag, so we start dig out sub images
                        const tiffOffset = formatPt + 4;
                        let bigEnd; // Endianness from TIFF header
                        // Test for TIFF validity and endianness
                        // 0x4949 and 0x4D4D ('II' and 'MM') marks Little Endian and Big Endian
                        if (dataView.getUint16(tiffOffset) === 0x4949) bigEnd = false;
                        else if (dataView.getUint16(tiffOffset) === 0x4d4d) bigEnd = true;
                        else {
                            reject(new Error('No valid endianness marker found in TIFF header'));
                            return;
                        }
                        if (dataView.getUint16(tiffOffset + 2, !bigEnd) !== 0x002a) {
                            reject(new Error('Not valid TIFF data! (no 0x002A marker)'));
                            return;
                        }
                        // 32 bit number stating the offset from the start of the 8 Byte MP Header
                        // to MP Index IFD Least possible value is thus 8 (means 0 offset)
                        const firstIFDOffset = dataView.getUint32(tiffOffset + 4, !bigEnd);
                        if (firstIFDOffset < 0x00000008) {
                            reject(new Error('Not valid TIFF data! (First offset less than 8)'));
                            return;
                        }
                        // Move ahead to MP Index IFD
                        // Assume we're at the first IFD, so firstIFDOffset points to
                        // MP Index IFD and not MP Attributes IFD. (If we try extract from a sub image,
                        // we fail silently here due to this assumption)
                        // Count (2 Byte) | MP Index Fields a.k.a. MP Entries (count * 12 Byte) | Offset of Next IFD (4 Byte)
                        const dirStart = tiffOffset + firstIFDOffset; // Start of IFD (Image File Directory)
                        const count = dataView.getUint16(dirStart, !bigEnd); // Count of MPEntries (2 Byte)
                        // Extract info from MPEntries (starting after Count)
                        const entriesStart = dirStart + 2;
                        let numberOfImages = 0;
                        for(let i = entriesStart; i < entriesStart + 12 * count; i += 12)// Each entry is 12 Bytes long
                        // Check MP Index IFD tags, here we only take tag 0xb001 = Number of images
                        if (dataView.getUint16(i, !bigEnd) === 0xb001) // stored in Last 4 bytes of its 12 Byte entry.
                        numberOfImages = dataView.getUint32(i + 8, !bigEnd);
                        const nextIFDOffsetLen = 4; // 4 Byte offset field that appears after MP Index IFD tags
                        const MPImageListValPt = dirStart + 2 + count * 12 + nextIFDOffsetLen;
                        const images = [];
                        for(let i = MPImageListValPt; i < MPImageListValPt + numberOfImages * 16; i += 16){
                            const image = {
                                MPType: dataView.getUint32(i, !bigEnd),
                                size: dataView.getUint32(i + 4, !bigEnd),
                                // This offset is specified relative to the address of the MP Endian
                                // field in the MP Header, unless the image is a First Individual Image,
                                // in which case the value of the offset shall be NULL (0x00000000).
                                dataOffset: dataView.getUint32(i + 8, !bigEnd),
                                dependantImages: dataView.getUint32(i + 12, !bigEnd),
                                start: -1,
                                end: -1,
                                isFII: false
                            };
                            if (!image.dataOffset) {
                                // dataOffset is 0x00000000 for First Individual Image
                                image.start = 0;
                                image.isFII = true;
                            } else {
                                image.start = tiffOffset + image.dataOffset;
                                image.isFII = false;
                            }
                            image.end = image.start + image.size;
                            images.push(image);
                        }
                        if (this.options.extractNonFII && images.length) {
                            const bufferBlob = new Blob([
                                dataView
                            ]);
                            const imgs = [];
                            for (const image of images){
                                if (image.isFII && !this.options.extractFII) continue; // Skip FII
                                const imageBlob = bufferBlob.slice(image.start, image.end + 1, 'image/jpeg');
                                // we don't need this
                                // const imageUrl = URL.createObjectURL(imageBlob)
                                // image.img = document.createElement('img')
                                // image.img.src = imageUrl
                                imgs.push(imageBlob);
                            }
                            resolve(imgs);
                        }
                    }
                }
                offset += 2 + dataView.getUint16(offset + 2);
            }
        });
    }
}
/**
 * Extracts XMP Metadata and the gain map recovery image
 * from a single JPEG file.
 *
 * @category Decoding Functions
 * @group Decoding Functions
 * @param jpegFile an `Uint8Array` containing and encoded JPEG file
 * @returns an sdr `Uint8Array` compressed in JPEG, a gainMap `Uint8Array` compressed in JPEG and the XMP parsed XMP metadata
 * @throws Error if XMP Metadata is not found
 * @throws Error if Gain map image is not found
 * @example
 * import { FileLoader } from 'three'
 * import { extractGainmapFromJPEG } from '@monogrid/gainmap-js'
 *
 * const jpegFile = await new FileLoader()
 *  .setResponseType('arraybuffer')
 *  .loadAsync('image.jpg')
 *
 * const { sdr, gainMap, metadata } = extractGainmapFromJPEG(jpegFile)
 */ const $43eb07ae7cdea2cd$export$3d5c60ab5d2aebc9 = async (jpegFile)=>{
    const metadata = $43eb07ae7cdea2cd$export$e8e129c92c64cfcd(jpegFile);
    if (!metadata) throw new $43eb07ae7cdea2cd$var$XMPMetadataNotFoundError('Gain map XMP metadata not found');
    const mpfExtractor = new $43eb07ae7cdea2cd$export$271cf0688b8d2d24({
        extractFII: true,
        extractNonFII: true
    });
    const images = await mpfExtractor.extract(jpegFile);
    if (images.length !== 2) throw new $43eb07ae7cdea2cd$var$GainMapNotFoundError('Gain map recovery image not found');
    return {
        sdr: new Uint8Array(await images[0].arrayBuffer()),
        gainMap: new Uint8Array(await images[1].arrayBuffer()),
        metadata: metadata
    };
};
/**
 * private function, async get image from blob
 *
 * @param blob
 * @returns
 */ const $43eb07ae7cdea2cd$var$getHTMLImageFromBlob = (blob)=>{
    return new Promise((resolve, reject)=>{
        const img = document.createElement('img');
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = (e)=>{
            reject(e);
        };
        img.src = URL.createObjectURL(blob);
    });
};
class $43eb07ae7cdea2cd$var$LoaderBase extends (0, $d5b33d7c30034067$export$3b0d6d7590275603) {
    /**
     *
     * @param renderer
     * @param manager
     */ constructor(renderer, manager){
        super(manager);
        if (renderer) this._renderer = renderer;
        this._internalLoadingManager = new (0, $d5b33d7c30034067$export$99cc795e99919eed)();
    }
    /**
     * Specify the renderer to use when rendering the gain map
     *
     * @param renderer
     * @returns
     */ setRenderer(renderer) {
        this._renderer = renderer;
        return this;
    }
    /**
     * Specify the renderTarget options to use when rendering the gain map
     *
     * @param options
     * @returns
     */ setRenderTargetOptions(options) {
        this._renderTargetOptions = options;
        return this;
    }
    /**
     * @private
     * @returns
     */ prepareQuadRenderer() {
        if (!this._renderer) console.warn('WARNING: An existing WebGL Renderer was not passed to this Loader constructor or in setRenderer, the result of this Loader will need to be converted to a Data Texture with toDataTexture() before you can use it in your renderer.');
        // temporary values
        const material = new $43eb07ae7cdea2cd$export$e02cd6fd4585498a({
            gainMapMax: [
                1,
                1,
                1
            ],
            gainMapMin: [
                0,
                0,
                0
            ],
            gamma: [
                1,
                1,
                1
            ],
            offsetHdr: [
                1,
                1,
                1
            ],
            offsetSdr: [
                1,
                1,
                1
            ],
            hdrCapacityMax: 1,
            hdrCapacityMin: 0,
            maxDisplayBoost: 1,
            gainMap: new (0, $d5b33d7c30034067$export$5431306cf43de24a)(),
            sdr: new (0, $d5b33d7c30034067$export$5431306cf43de24a)()
        });
        return new (0, $3f27dfcfb244068b$export$3722cfe417b6ed86)({
            width: 16,
            height: 16,
            type: (0, $d5b33d7c30034067$export$2697304443f382bc),
            colorSpace: (0, $d5b33d7c30034067$export$42429b3acfb233a4),
            material: material,
            renderer: this._renderer,
            renderTargetOptions: this._renderTargetOptions
        });
    }
    /**
   * @private
   * @param quadRenderer
   * @param metadata
   * @param sdrBuffer
   * @param gainMapBuffer
   */ async render(quadRenderer, metadata, sdrBuffer, gainMapBuffer) {
        // this is optional, will render a black gain-map if not present
        const gainMapBlob = gainMapBuffer ? new Blob([
            gainMapBuffer
        ], {
            type: 'image/jpeg'
        }) : undefined;
        const sdrBlob = new Blob([
            sdrBuffer
        ], {
            type: 'image/jpeg'
        });
        let sdrImage;
        let gainMapImage;
        let needsFlip = false;
        if (typeof createImageBitmap === 'undefined') {
            const res = await Promise.all([
                gainMapBlob ? $43eb07ae7cdea2cd$var$getHTMLImageFromBlob(gainMapBlob) : Promise.resolve(undefined),
                $43eb07ae7cdea2cd$var$getHTMLImageFromBlob(sdrBlob)
            ]);
            gainMapImage = res[0];
            sdrImage = res[1];
            needsFlip = true;
        } else {
            const res = await Promise.all([
                gainMapBlob ? createImageBitmap(gainMapBlob, {
                    imageOrientation: 'flipY'
                }) : Promise.resolve(undefined),
                createImageBitmap(sdrBlob, {
                    imageOrientation: 'flipY'
                })
            ]);
            gainMapImage = res[0];
            sdrImage = res[1];
        }
        const gainMap = new (0, $d5b33d7c30034067$export$5431306cf43de24a)(gainMapImage || new ImageData(2, 2), (0, $d5b33d7c30034067$export$1beec6768cbb3d2d), (0, $d5b33d7c30034067$export$9d9334239a5a5e06), (0, $d5b33d7c30034067$export$9d9334239a5a5e06), (0, $d5b33d7c30034067$export$8a72f490b25c56c8), (0, $d5b33d7c30034067$export$90d80f1e3506775f), (0, $d5b33d7c30034067$export$3f8bb04b555a363c), (0, $d5b33d7c30034067$export$2e8ce08d3f6f5e10), 1, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        gainMap.flipY = needsFlip;
        gainMap.needsUpdate = true;
        const sdr = new (0, $d5b33d7c30034067$export$5431306cf43de24a)(sdrImage, (0, $d5b33d7c30034067$export$1beec6768cbb3d2d), (0, $d5b33d7c30034067$export$9d9334239a5a5e06), (0, $d5b33d7c30034067$export$9d9334239a5a5e06), (0, $d5b33d7c30034067$export$8a72f490b25c56c8), (0, $d5b33d7c30034067$export$90d80f1e3506775f), (0, $d5b33d7c30034067$export$3f8bb04b555a363c), (0, $d5b33d7c30034067$export$2e8ce08d3f6f5e10), 1, (0, $d5b33d7c30034067$export$561f394b24edfcaa));
        sdr.flipY = needsFlip;
        sdr.needsUpdate = true;
        quadRenderer.width = sdrImage.width;
        quadRenderer.height = sdrImage.height;
        quadRenderer.material.gainMap = gainMap;
        quadRenderer.material.sdr = sdr;
        quadRenderer.material.gainMapMin = metadata.gainMapMin;
        quadRenderer.material.gainMapMax = metadata.gainMapMax;
        quadRenderer.material.offsetHdr = metadata.offsetHdr;
        quadRenderer.material.offsetSdr = metadata.offsetSdr;
        quadRenderer.material.gamma = metadata.gamma;
        quadRenderer.material.hdrCapacityMin = metadata.hdrCapacityMin;
        quadRenderer.material.hdrCapacityMax = metadata.hdrCapacityMax;
        quadRenderer.material.maxDisplayBoost = Math.pow(2, metadata.hdrCapacityMax);
        quadRenderer.material.needsUpdate = true;
        quadRenderer.render();
    }
}
/**
 * A Three.js Loader for the gain map format.
 *
 * @category Loaders
 * @group Loaders
 *
 * @example
 * import { GainMapLoader } from '@monogrid/gainmap-js'
 * import {
 *   EquirectangularReflectionMapping,
 *   LinearFilter,
 *   Mesh,
 *   MeshBasicMaterial,
 *   PerspectiveCamera,
 *   PlaneGeometry,
 *   Scene,
 *   WebGLRenderer
 * } from 'three'
 *
 * const renderer = new WebGLRenderer()
 *
 * const loader = new GainMapLoader(renderer)
 *
 * const result = await loader.loadAsync(['sdr.jpeg', 'gainmap.jpeg', 'metadata.json'])
 * // `result` can be used to populate a Texture
 *
 * const scene = new Scene()
 * const mesh = new Mesh(
 *   new PlaneGeometry(),
 *   new MeshBasicMaterial({ map: result.renderTarget.texture })
 * )
 * scene.add(mesh)
 * renderer.render(scene, new PerspectiveCamera())
 *
 * // Starting from three.js r159
 * // `result.renderTarget.texture` can
 * // also be used as Equirectangular scene background
 * //
 * // it was previously needed to convert it
 * // to a DataTexture with `result.toDataTexture()`
 * scene.background = result.renderTarget.texture
 * scene.background.mapping = EquirectangularReflectionMapping
 *
 * // result must be manually disposed
 * // when you are done using it
 * result.dispose()
 *
 */ class $43eb07ae7cdea2cd$export$79004d1af8c8c9b7 extends $43eb07ae7cdea2cd$var$LoaderBase {
    /**
     * Loads a gainmap using separate data
     * * sdr image
     * * gain map image
     * * metadata json
     *
     * useful for webp gain maps
     *
     * @param urls An array in the form of [sdr.jpg, gainmap.jpg, metadata.json]
     * @param onLoad Load complete callback, will receive the result
     * @param onProgress Progress callback, will receive a {@link ProgressEvent}
     * @param onError Error callback
     * @returns
     */ load([sdrUrl, gainMapUrl, metadataUrl], onLoad, onProgress, onError) {
        const quadRenderer = this.prepareQuadRenderer();
        let sdr;
        let gainMap;
        let metadata;
        const loadCheck = async ()=>{
            if (sdr && gainMap && metadata) {
                // solves #16
                try {
                    await this.render(quadRenderer, metadata, sdr, gainMap);
                } catch (error) {
                    this.manager.itemError(sdrUrl);
                    this.manager.itemError(gainMapUrl);
                    this.manager.itemError(metadataUrl);
                    if (typeof onError === 'function') onError(error);
                    quadRenderer.disposeOnDemandRenderer();
                    return;
                }
                if (typeof onLoad === 'function') onLoad(quadRenderer);
                this.manager.itemEnd(sdrUrl);
                this.manager.itemEnd(gainMapUrl);
                this.manager.itemEnd(metadataUrl);
                quadRenderer.disposeOnDemandRenderer();
            }
        };
        let sdrLengthComputable = true;
        let sdrTotal = 0;
        let sdrLoaded = 0;
        let gainMapLengthComputable = true;
        let gainMapTotal = 0;
        let gainMapLoaded = 0;
        let metadataLengthComputable = true;
        let metadataTotal = 0;
        let metadataLoaded = 0;
        const progressHandler = ()=>{
            if (typeof onProgress === 'function') {
                const total = sdrTotal + gainMapTotal + metadataTotal;
                const loaded = sdrLoaded + gainMapLoaded + metadataLoaded;
                const lengthComputable = sdrLengthComputable && gainMapLengthComputable && metadataLengthComputable;
                onProgress(new ProgressEvent('progress', {
                    lengthComputable: lengthComputable,
                    loaded: loaded,
                    total: total
                }));
            }
        };
        this.manager.itemStart(sdrUrl);
        this.manager.itemStart(gainMapUrl);
        this.manager.itemStart(metadataUrl);
        const sdrLoader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this._internalLoadingManager);
        sdrLoader.setResponseType('arraybuffer');
        sdrLoader.setRequestHeader(this.requestHeader);
        sdrLoader.setPath(this.path);
        sdrLoader.setWithCredentials(this.withCredentials);
        sdrLoader.load(sdrUrl, async (buffer)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof buffer === 'string') throw new Error('Invalid sdr buffer');
            sdr = buffer;
            await loadCheck();
        }, (e)=>{
            sdrLengthComputable = e.lengthComputable;
            sdrLoaded = e.loaded;
            sdrTotal = e.total;
            progressHandler();
        }, (error)=>{
            this.manager.itemError(sdrUrl);
            if (typeof onError === 'function') onError(error);
        });
        const gainMapLoader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this._internalLoadingManager);
        gainMapLoader.setResponseType('arraybuffer');
        gainMapLoader.setRequestHeader(this.requestHeader);
        gainMapLoader.setPath(this.path);
        gainMapLoader.setWithCredentials(this.withCredentials);
        gainMapLoader.load(gainMapUrl, async (buffer)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof buffer === 'string') throw new Error('Invalid gainmap buffer');
            gainMap = buffer;
            await loadCheck();
        }, (e)=>{
            gainMapLengthComputable = e.lengthComputable;
            gainMapLoaded = e.loaded;
            gainMapTotal = e.total;
            progressHandler();
        }, (error)=>{
            this.manager.itemError(gainMapUrl);
            if (typeof onError === 'function') onError(error);
        });
        const metadataLoader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this._internalLoadingManager);
        // metadataLoader.setResponseType('json')
        metadataLoader.setRequestHeader(this.requestHeader);
        metadataLoader.setPath(this.path);
        metadataLoader.setWithCredentials(this.withCredentials);
        metadataLoader.load(metadataUrl, async (json)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof json !== 'string') throw new Error('Invalid metadata string');
            // TODO: implement check on JSON file and remove this eslint disable
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            metadata = JSON.parse(json);
            await loadCheck();
        }, (e)=>{
            metadataLengthComputable = e.lengthComputable;
            metadataLoaded = e.loaded;
            metadataTotal = e.total;
            progressHandler();
        }, (error)=>{
            this.manager.itemError(metadataUrl);
            if (typeof onError === 'function') onError(error);
        });
        return quadRenderer;
    }
}
/**
 * A Three.js Loader for a JPEG with embedded gainmap metadata.
 *
 * @category Loaders
 * @group Loaders
 *
 * @example
 * import { HDRJPGLoader } from '@monogrid/gainmap-js'
 * import {
 *   EquirectangularReflectionMapping,
 *   LinearFilter,
 *   Mesh,
 *   MeshBasicMaterial,
 *   PerspectiveCamera,
 *   PlaneGeometry,
 *   Scene,
 *   WebGLRenderer
 * } from 'three'
 *
 * const renderer = new WebGLRenderer()
 *
 * const loader = new HDRJPGLoader(renderer)
 *
 * const result = await loader.loadAsync('gainmap.jpeg')
 * // `result` can be used to populate a Texture
 *
 * const scene = new Scene()
 * const mesh = new Mesh(
 *   new PlaneGeometry(),
 *   new MeshBasicMaterial({ map: result.renderTarget.texture })
 * )
 * scene.add(mesh)
 * renderer.render(scene, new PerspectiveCamera())
 *
 * // Starting from three.js r159
 * // `result.renderTarget.texture` can
 * // also be used as Equirectangular scene background
 * //
 * // it was previously needed to convert it
 * // to a DataTexture with `result.toDataTexture()`
 * scene.background = result.renderTarget.texture
 * scene.background.mapping = EquirectangularReflectionMapping
 *
 * // result must be manually disposed
 * // when you are done using it
 * result.dispose()
 *
 */ class $43eb07ae7cdea2cd$export$1204838c7449706d extends $43eb07ae7cdea2cd$var$LoaderBase {
    /**
     * Loads a JPEG containing gain map metadata
     * Renders a normal SDR image if gainmap data is not found
     *
     * @param url An array in the form of [sdr.jpg, gainmap.jpg, metadata.json]
     * @param onLoad Load complete callback, will receive the result
     * @param onProgress Progress callback, will receive a {@link ProgressEvent}
     * @param onError Error callback
     * @returns
     */ load(url, onLoad, onProgress, onError) {
        const quadRenderer = this.prepareQuadRenderer();
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this._internalLoadingManager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(this.withCredentials);
        this.manager.itemStart(url);
        loader.load(url, async (jpeg)=>{
            /* istanbul ignore if
             this condition exists only because of three.js types + strict mode
            */ if (typeof jpeg === 'string') throw new Error('Invalid buffer, received [string], was expecting [ArrayBuffer]');
            const jpegBuffer = new Uint8Array(jpeg);
            let sdrJPEG;
            let gainMapJPEG;
            let metadata;
            try {
                const extractionResult = await $43eb07ae7cdea2cd$export$3d5c60ab5d2aebc9(jpegBuffer);
                // gain map is successfully reconstructed
                sdrJPEG = extractionResult.sdr;
                gainMapJPEG = extractionResult.gainMap;
                metadata = extractionResult.metadata;
            } catch (e) {
                // render the SDR version if this is not a gainmap
                if (e instanceof $43eb07ae7cdea2cd$var$XMPMetadataNotFoundError || e instanceof $43eb07ae7cdea2cd$var$GainMapNotFoundError) {
                    console.warn(`Failure to reconstruct an HDR image from ${url}: Gain map metadata not found in the file, HDRJPGLoader will render the SDR jpeg`);
                    metadata = {
                        gainMapMin: [
                            0,
                            0,
                            0
                        ],
                        gainMapMax: [
                            1,
                            1,
                            1
                        ],
                        gamma: [
                            1,
                            1,
                            1
                        ],
                        hdrCapacityMin: 0,
                        hdrCapacityMax: 1,
                        offsetHdr: [
                            0,
                            0,
                            0
                        ],
                        offsetSdr: [
                            0,
                            0,
                            0
                        ]
                    };
                    sdrJPEG = jpegBuffer;
                } else throw e;
            }
            // solves #16
            try {
                await this.render(quadRenderer, metadata, sdrJPEG, gainMapJPEG);
            } catch (error) {
                this.manager.itemError(url);
                if (typeof onError === 'function') onError(error);
                quadRenderer.disposeOnDemandRenderer();
                return;
            }
            if (typeof onLoad === 'function') onLoad(quadRenderer);
            this.manager.itemEnd(url);
            quadRenderer.disposeOnDemandRenderer();
        }, onProgress, (error)=>{
            this.manager.itemError(url);
            if (typeof onError === 'function') onError(error);
        });
        return quadRenderer;
    }
}


const $69f1147424cb1214$export$b32137689bbc87ef = {
    apartment: 'lebombo_1k.hdr',
    city: 'potsdamer_platz_1k.hdr',
    dawn: 'kiara_1_dawn_1k.hdr',
    forest: 'forest_slope_1k.hdr',
    lobby: 'st_fagans_interior_1k.hdr',
    night: 'dikhololo_night_1k.hdr',
    park: 'rooitou_park_1k.hdr',
    studio: 'studio_small_03_1k.hdr',
    sunset: 'venice_sunset_1k.hdr',
    warehouse: 'empty_warehouse_01_1k.hdr'
};


/**
 * Sets `BufferAttribute.updateRange` since r159.
 */ const $1e5fdfdb12605aed$export$7493a2e33011a8ee = (attribute, updateRange)=>{
    if ('updateRanges' in attribute) // r159
    // @ts-ignore
    attribute.updateRanges[0] = updateRange;
    else attribute.updateRange = updateRange;
};
const $1e5fdfdb12605aed$export$7207336e4151a112 = 3000;
const $1e5fdfdb12605aed$export$f32388edbb32674 = 3001;



var $acw62 = parcelRequire("acw62");
const $1dbca181e8ca05fa$var$CUBEMAP_ROOT = 'https://raw.githack.com/pmndrs/drei-assets/456060a26bbeb8fdf79326f224b6d99b8bcce736/hdri/';
const $1dbca181e8ca05fa$var$isArray = (arr)=>Array.isArray(arr);
function $1dbca181e8ca05fa$export$ea7ed2425832167d({ files: files = [
    '/px.png',
    '/nx.png',
    '/py.png',
    '/ny.png',
    '/pz.png',
    '/nz.png'
], path: path = '', preset: preset, encoding: encoding, extensions: extensions } = {}) {
    var _firstEntry$split$pop;
    let loader = null;
    let multiFile = false;
    if (preset) {
        if (!(preset in (0, $69f1147424cb1214$export$b32137689bbc87ef))) throw new Error('Preset must be one of: ' + Object.keys((0, $69f1147424cb1214$export$b32137689bbc87ef)).join(', '));
        files = (0, $69f1147424cb1214$export$b32137689bbc87ef)[preset];
        path = $1dbca181e8ca05fa$var$CUBEMAP_ROOT;
    }
    const isCubemap = $1dbca181e8ca05fa$var$isArray(files) && files.length === 6;
    const isGainmap = $1dbca181e8ca05fa$var$isArray(files) && files.length === 3 && files.some((file)=>file.endsWith('json'));
    const firstEntry = $1dbca181e8ca05fa$var$isArray(files) ? files[0] : files;
    // Everything else
    multiFile = $1dbca181e8ca05fa$var$isArray(files);
    const extension = isCubemap ? 'cube' : isGainmap ? 'webp' : firstEntry.startsWith('data:application/exr') ? 'exr' : firstEntry.startsWith('data:application/hdr') ? 'hdr' : firstEntry.startsWith('data:image/jpeg') ? 'jpg' : (_firstEntry$split$pop = firstEntry.split('.').pop()) == null || (_firstEntry$split$pop = _firstEntry$split$pop.split('?')) == null || (_firstEntry$split$pop = _firstEntry$split$pop.shift()) == null ? void 0 : _firstEntry$split$pop.toLowerCase();
    loader = extension === 'cube' ? (0, $d5b33d7c30034067$export$2ec114afc2cf6308) : extension === 'hdr' ? (0, $1741da12ffb0eb8a$export$d076a711b55c758a) : extension === 'exr' ? (0, $f6d7c4e62ce766b3$export$ccf20607163eaf96) : extension === 'jpg' || extension === 'jpeg' ? (0, $43eb07ae7cdea2cd$export$1204838c7449706d) : extension === 'webp' ? (0, $43eb07ae7cdea2cd$export$79004d1af8c8c9b7) : null;
    if (!loader) throw new Error('useEnvironment: Unrecognized file extension: ' + files);
    const gl = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.gl);
    (0, $acw62.useLayoutEffect)(()=>{
        // Only required for gainmap
        if (extension !== 'webp' && extension !== 'jpg' && extension !== 'jpeg') return;
        function clearGainmapTexture() {
            // @ts-expect-error
            (0, $2ec6beadbaf9c031$export$d66501df72047452).clear(loader, multiFile ? [
                files
            ] : files);
        }
        gl.domElement.addEventListener('webglcontextlost', clearGainmapTexture, {
            once: true
        });
    }, [
        files,
        gl.domElement
    ]);
    const loaderResult = (0, $2ec6beadbaf9c031$export$d66501df72047452)(// @ts-expect-error
    loader, multiFile ? [
        files
    ] : files, (loader)=>{
        // Gainmap requires a renderer
        if (extension === 'webp' || extension === 'jpg' || extension === 'jpeg') loader.setRenderer(gl);
        loader.setPath == null || loader.setPath(path);
        if (extensions) extensions(loader);
    });
    let texture = multiFile ? // @ts-ignore
    loaderResult[0] : loaderResult;
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'webp') {
        var _renderTarget;
        texture = (_renderTarget = texture.renderTarget) == null ? void 0 : _renderTarget.texture;
    }
    texture.mapping = isCubemap ? (0, $d5b33d7c30034067$export$8759762a6477f2c4) : (0, $d5b33d7c30034067$export$d64030b316d3b087);
    if ('colorSpace' in texture) texture.colorSpace = (encoding !== null && encoding !== void 0 ? encoding : isCubemap) ? 'srgb' : 'srgb-linear';
    else texture.encoding = (encoding !== null && encoding !== void 0 ? encoding : isCubemap) ? (0, $1e5fdfdb12605aed$export$f32388edbb32674) : (0, $1e5fdfdb12605aed$export$7207336e4151a112);
    return texture;
}


const $78b36dbdd2fd5ec5$var$isRef = (obj)=>obj.current && obj.current.isScene;
const $78b36dbdd2fd5ec5$var$resolveScene = (scene)=>$78b36dbdd2fd5ec5$var$isRef(scene) ? scene.current : scene;
function $78b36dbdd2fd5ec5$var$setEnvProps(background, scene, defaultScene, texture, sceneProps = {}) {
    var _sceneProps$blur, _target$backgroundRot, _target$backgroundRot2, _target$environmentRo, _target$environmentRo2;
    // defaults
    sceneProps = {
        backgroundBlurriness: (_sceneProps$blur = sceneProps.blur) !== null && _sceneProps$blur !== void 0 ? _sceneProps$blur : 0,
        backgroundIntensity: 1,
        backgroundRotation: [
            0,
            0,
            0
        ],
        environmentIntensity: 1,
        environmentRotation: [
            0,
            0,
            0
        ],
        ...sceneProps
    };
    const target = $78b36dbdd2fd5ec5$var$resolveScene(scene || defaultScene);
    const oldbg = target.background;
    const oldenv = target.environment;
    const oldSceneProps = {
        // @ts-ignore
        backgroundBlurriness: target.backgroundBlurriness,
        // @ts-ignore
        backgroundIntensity: target.backgroundIntensity,
        // @ts-ignore
        backgroundRotation: (_target$backgroundRot = (_target$backgroundRot2 = target.backgroundRotation) == null || _target$backgroundRot2.clone == null ? void 0 : _target$backgroundRot2.clone()) !== null && _target$backgroundRot !== void 0 ? _target$backgroundRot : [
            0,
            0,
            0
        ],
        // @ts-ignore
        environmentIntensity: target.environmentIntensity,
        // @ts-ignore
        environmentRotation: (_target$environmentRo = (_target$environmentRo2 = target.environmentRotation) == null || _target$environmentRo2.clone == null ? void 0 : _target$environmentRo2.clone()) !== null && _target$environmentRo !== void 0 ? _target$environmentRo : [
            0,
            0,
            0
        ]
    };
    if (background !== 'only') target.environment = texture;
    if (background) target.background = texture;
    (0, $2ec6beadbaf9c031$export$35e795649ee09318)(target, sceneProps);
    return ()=>{
        if (background !== 'only') target.environment = oldenv;
        if (background) target.background = oldbg;
        (0, $2ec6beadbaf9c031$export$35e795649ee09318)(target, oldSceneProps);
    };
}
function $78b36dbdd2fd5ec5$export$5d2a45dffef53508({ scene: scene, background: background = false, map: map, ...config }) {
    const defaultScene = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.scene);
    $acw62.useLayoutEffect(()=>{
        if (map) return $78b36dbdd2fd5ec5$var$setEnvProps(background, scene, defaultScene, map, config);
    });
    return null;
}
function $78b36dbdd2fd5ec5$export$1480799530c0b477({ background: background = false, scene: scene, blur: blur, backgroundBlurriness: backgroundBlurriness, backgroundIntensity: backgroundIntensity, backgroundRotation: backgroundRotation, environmentIntensity: environmentIntensity, environmentRotation: environmentRotation, ...rest }) {
    const texture = (0, $1dbca181e8ca05fa$export$ea7ed2425832167d)(rest);
    const defaultScene = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.scene);
    $acw62.useLayoutEffect(()=>{
        return $78b36dbdd2fd5ec5$var$setEnvProps(background, scene, defaultScene, texture, {
            blur: blur,
            backgroundBlurriness: backgroundBlurriness,
            backgroundIntensity: backgroundIntensity,
            backgroundRotation: backgroundRotation,
            environmentIntensity: environmentIntensity,
            environmentRotation: environmentRotation
        });
    });
    return null;
}
function $78b36dbdd2fd5ec5$export$fad6a10e29ccfe2a({ children: children, near: near = 1, far: far = 1000, resolution: resolution = 256, frames: frames = 1, map: map, background: background = false, blur: blur, backgroundBlurriness: backgroundBlurriness, backgroundIntensity: backgroundIntensity, backgroundRotation: backgroundRotation, environmentIntensity: environmentIntensity, environmentRotation: environmentRotation, scene: scene, files: files, path: path, preset: preset, extensions: extensions }) {
    const gl = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.gl);
    const defaultScene = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.scene);
    const camera = $acw62.useRef(null);
    const [virtualScene] = $acw62.useState(()=>new (0, $d5b33d7c30034067$export$38af1803e3442a7f)());
    const fbo = $acw62.useMemo(()=>{
        const fbo = new (0, $d5b33d7c30034067$export$ac386671d651941e)(resolution);
        fbo.texture.type = (0, $d5b33d7c30034067$export$2697304443f382bc);
        return fbo;
    }, [
        resolution
    ]);
    $acw62.useLayoutEffect(()=>{
        if (frames === 1) camera.current.update(gl, virtualScene);
        return $78b36dbdd2fd5ec5$var$setEnvProps(background, scene, defaultScene, fbo.texture, {
            blur: blur,
            backgroundBlurriness: backgroundBlurriness,
            backgroundIntensity: backgroundIntensity,
            backgroundRotation: backgroundRotation,
            environmentIntensity: environmentIntensity,
            environmentRotation: environmentRotation
        });
    }, [
        children,
        virtualScene,
        fbo.texture,
        scene,
        defaultScene,
        background,
        frames,
        gl
    ]);
    let count = 1;
    (0, $2ec6beadbaf9c031$export$e7094788287c5e9b)(()=>{
        if (frames === Infinity || count < frames) {
            camera.current.update(gl, virtualScene);
            count++;
        }
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (0, $2ec6beadbaf9c031$export$39b482c5e57630a8)(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, children, /*#__PURE__*/ $acw62.createElement("cubeCamera", {
        ref: camera,
        args: [
            near,
            far,
            fbo
        ]
    }), files || preset ? /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$export$1480799530c0b477, {
        background: true,
        files: files,
        preset: preset,
        path: path,
        extensions: extensions
    }) : map ? /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$export$5d2a45dffef53508, {
        background: true,
        map: map,
        extensions: extensions
    }) : null), virtualScene));
}
function $78b36dbdd2fd5ec5$var$EnvironmentGround(props) {
    var _props$ground, _props$ground2, _scale, _props$ground3;
    const textureDefault = (0, $1dbca181e8ca05fa$export$ea7ed2425832167d)(props);
    const texture = props.map || textureDefault;
    $acw62.useMemo(()=>(0, $2ec6beadbaf9c031$export$f1e1789686576879)({
            GroundProjectedEnvImpl: (0, $9a6ff25e6616da7a$export$a8dfc348093aebdf)
        }), []);
    const args = $acw62.useMemo(()=>[
            texture
        ], [
        texture
    ]);
    const height = (_props$ground = props.ground) == null ? void 0 : _props$ground.height;
    const radius = (_props$ground2 = props.ground) == null ? void 0 : _props$ground2.radius;
    const scale = (_scale = (_props$ground3 = props.ground) == null ? void 0 : _props$ground3.scale) !== null && _scale !== void 0 ? _scale : 1000;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$export$5d2a45dffef53508, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        map: texture
    })), /*#__PURE__*/ $acw62.createElement("groundProjectedEnvImpl", {
        args: args,
        scale: scale,
        height: height,
        radius: radius
    }));
}
function $78b36dbdd2fd5ec5$export$7dc6752a22ab011a(props) {
    return props.ground ? /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$var$EnvironmentGround, props) : props.map ? /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$export$5d2a45dffef53508, props) : props.children ? /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$export$fad6a10e29ccfe2a, props) : /*#__PURE__*/ $acw62.createElement($78b36dbdd2fd5ec5$export$1480799530c0b477, props);
}




var $acw62 = parcelRequire("acw62");

const $b3bae46eafcab220$export$9ae1655cef674212 = /* @__PURE__ */ $acw62.forwardRef(({ args: args, map: map, toneMapped: toneMapped = false, color: color = 'white', form: Form = 'rect', intensity: intensity = 1, scale: scale = 1, target: target, children: children, ...props }, forwardRef)=>{
    // Apply emissive power
    const ref = $acw62.useRef(null);
    $acw62.useImperativeHandle(forwardRef, ()=>ref.current, []);
    $acw62.useLayoutEffect(()=>{
        if (!children && !props.material) {
            (0, $2ec6beadbaf9c031$export$35e795649ee09318)(ref.current.material, {
                color: color
            });
            ref.current.material.color.multiplyScalar(intensity);
        }
    }, [
        color,
        intensity,
        children,
        props.material
    ]);
    // Target light
    $acw62.useLayoutEffect(()=>{
        if (target) ref.current.lookAt(Array.isArray(target) ? new $d5b33d7c30034067$export$64b5c384219d3699(...target) : target);
    }, [
        target
    ]);
    // Fix 2-dimensional scale
    scale = Array.isArray(scale) && scale.length === 2 ? [
        scale[0],
        scale[1],
        1
    ] : scale;
    return /*#__PURE__*/ $acw62.createElement("mesh", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        scale: scale
    }, props), Form === 'circle' ? /*#__PURE__*/ $acw62.createElement("ringGeometry", {
        args: [
            0,
            1,
            64
        ]
    }) : Form === 'ring' ? /*#__PURE__*/ $acw62.createElement("ringGeometry", {
        args: [
            0.5,
            1,
            64
        ]
    }) : Form === 'rect' ? /*#__PURE__*/ $acw62.createElement("planeGeometry", null) : /*#__PURE__*/ $acw62.createElement(Form, {
        args: args
    }), children ? children : !props.material ? /*#__PURE__*/ $acw62.createElement("meshBasicMaterial", {
        toneMapped: toneMapped,
        map: map,
        side: $d5b33d7c30034067$export$3b296b6f144d5b03
    }) : null);
});



var $acw62 = parcelRequire("acw62");

/**
 * Main content for the worker that handles the loading and execution of
 * modules within it.
 */ function $62dc134116dcb5c9$var$workerBootstrap() {
    var modules = Object.create(null);
    // Handle messages for registering a module
    function registerModule(ref, callback) {
        var id = ref.id;
        var name = ref.name;
        var dependencies = ref.dependencies;
        if (dependencies === void 0) dependencies = [];
        var init = ref.init;
        if (init === void 0) init = function() {};
        var getTransferables = ref.getTransferables;
        if (getTransferables === void 0) getTransferables = null;
        // Only register once
        if (modules[id]) return;
        try {
            // If any dependencies are modules, ensure they're registered and grab their value
            dependencies = dependencies.map(function(dep) {
                if (dep && dep.isWorkerModule) {
                    registerModule(dep, function(depResult) {
                        if (depResult instanceof Error) throw depResult;
                    });
                    dep = modules[dep.id].value;
                }
                return dep;
            });
            // Rehydrate functions
            init = rehydrate("<" + name + ">.init", init);
            if (getTransferables) getTransferables = rehydrate("<" + name + ">.getTransferables", getTransferables);
            // Initialize the module and store its value
            var value = null;
            if (typeof init === 'function') value = init.apply(void 0, dependencies);
            else console.error('worker module init function failed to rehydrate');
            modules[id] = {
                id: id,
                value: value,
                getTransferables: getTransferables
            };
            callback(value);
        } catch (err) {
            if (!(err && err.noLog)) console.error(err);
            callback(err);
        }
    }
    // Handle messages for calling a registered module's result function
    function callModule(ref, callback) {
        var ref$1;
        var id = ref.id;
        var args = ref.args;
        if (!modules[id] || typeof modules[id].value !== 'function') callback(new Error("Worker module " + id + ": not found or its 'init' did not return a function"));
        try {
            var result = (ref$1 = modules[id]).value.apply(ref$1, args);
            if (result && typeof result.then === 'function') result.then(handleResult, function(rej) {
                return callback(rej instanceof Error ? rej : new Error('' + rej));
            });
            else handleResult(result);
        } catch (err) {
            callback(err);
        }
        function handleResult(result) {
            try {
                var tx = modules[id].getTransferables && modules[id].getTransferables(result);
                if (!tx || !Array.isArray(tx) || !tx.length) tx = undefined; //postMessage is very picky about not passing null or empty transferables
                callback(result, tx);
            } catch (err) {
                console.error(err);
                callback(err);
            }
        }
    }
    function rehydrate(name, str) {
        var result = void 0;
        self.troikaDefine = function(r) {
            return result = r;
        };
        var url = URL.createObjectURL(new Blob([
            "/** " + name.replace(/\*/g, '') + " **/\n\ntroikaDefine(\n" + str + "\n)"
        ], {
            type: 'application/javascript'
        }));
        try {
            importScripts(url);
        } catch (err) {
            console.error(err);
        }
        URL.revokeObjectURL(url);
        delete self.troikaDefine;
        return result;
    }
    // Handler for all messages within the worker
    self.addEventListener('message', function(e) {
        var ref = e.data;
        var messageId = ref.messageId;
        var action = ref.action;
        var data = ref.data;
        try {
            // Module registration
            if (action === 'registerModule') registerModule(data, function(result) {
                if (result instanceof Error) postMessage({
                    messageId: messageId,
                    success: false,
                    error: result.message
                });
                else postMessage({
                    messageId: messageId,
                    success: true,
                    result: {
                        isCallable: typeof result === 'function'
                    }
                });
            });
            // Invocation
            if (action === 'callModule') callModule(data, function(result, transferables) {
                if (result instanceof Error) postMessage({
                    messageId: messageId,
                    success: false,
                    error: result.message
                });
                else postMessage({
                    messageId: messageId,
                    success: true,
                    result: result
                }, transferables || undefined);
            });
        } catch (err) {
            postMessage({
                messageId: messageId,
                success: false,
                error: err.stack
            });
        }
    });
}
/**
 * Fallback for `defineWorkerModule` that behaves identically but runs in the main
 * thread, for when the execution environment doesn't support web workers or they
 * are disallowed due to e.g. CSP security restrictions.
 */ function $62dc134116dcb5c9$var$defineMainThreadModule(options) {
    var moduleFunc = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return moduleFunc._getInitResult().then(function(initResult) {
            if (typeof initResult === 'function') return initResult.apply(void 0, args);
            else throw new Error('Worker module function was called but `init` did not return a callable function');
        });
    };
    moduleFunc._getInitResult = function() {
        // We can ignore getTransferables in main thread. TODO workerId?
        var dependencies = options.dependencies;
        var init = options.init;
        // Resolve dependencies
        dependencies = Array.isArray(dependencies) ? dependencies.map(function(dep) {
            return dep && dep._getInitResult ? dep._getInitResult() : dep;
        }) : [];
        // Invoke init with the resolved dependencies
        var initPromise = Promise.all(dependencies).then(function(deps) {
            return init.apply(null, deps);
        });
        // Cache the resolved promise for subsequent calls
        moduleFunc._getInitResult = function() {
            return initPromise;
        };
        return initPromise;
    };
    return moduleFunc;
}
var $62dc134116dcb5c9$var$supportsWorkers = function() {
    var supported = false;
    // Only attempt worker initialization in browsers; elsewhere it would just be
    // noise e.g. loading into a Node environment for SSR.
    if (typeof window !== 'undefined' && typeof window.document !== 'undefined') try {
        // TODO additional checks for things like importScripts within the worker?
        //  Would need to be an async check.
        var worker = new Worker(URL.createObjectURL(new Blob([
            ''
        ], {
            type: 'application/javascript'
        })));
        worker.terminate();
        supported = true;
    } catch (err) {
        console.log("Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" + err.message + "]");
    }
    // Cached result
    $62dc134116dcb5c9$var$supportsWorkers = function() {
        return supported;
    };
    return supported;
};
var $62dc134116dcb5c9$var$_workerModuleId = 0;
var $62dc134116dcb5c9$var$_messageId = 0;
var $62dc134116dcb5c9$var$_allowInitAsString = false;
var $62dc134116dcb5c9$var$workers = Object.create(null);
var $62dc134116dcb5c9$var$registeredModules = Object.create(null); //workerId -> Set<unregisterFn>
var $62dc134116dcb5c9$var$openRequests = Object.create(null);
/**
 * Define a module of code that will be executed with a web worker. This provides a simple
 * interface for moving chunks of logic off the main thread, and managing their dependencies
 * among one another.
 *
 * @param {object} options
 * @param {function} options.init
 * @param {array} [options.dependencies]
 * @param {function} [options.getTransferables]
 * @param {string} [options.name]
 * @param {string} [options.workerId]
 * @return {function(...[*]): {then}}
 */ function $62dc134116dcb5c9$export$e2063b0a5e3f6023(options) {
    if ((!options || typeof options.init !== 'function') && !$62dc134116dcb5c9$var$_allowInitAsString) throw new Error('requires `options.init` function');
    var dependencies = options.dependencies;
    var init = options.init;
    var getTransferables = options.getTransferables;
    var workerId = options.workerId;
    if (!$62dc134116dcb5c9$var$supportsWorkers()) return $62dc134116dcb5c9$var$defineMainThreadModule(options);
    if (workerId == null) workerId = '#default';
    var id = "workerModule" + ++$62dc134116dcb5c9$var$_workerModuleId;
    var name = options.name || id;
    var registrationPromise = null;
    dependencies = dependencies && dependencies.map(function(dep) {
        // Wrap raw functions as worker modules with no dependencies
        if (typeof dep === 'function' && !dep.workerModuleData) {
            $62dc134116dcb5c9$var$_allowInitAsString = true;
            dep = $62dc134116dcb5c9$export$e2063b0a5e3f6023({
                workerId: workerId,
                name: "<" + name + "> function dependency: " + dep.name,
                init: "function(){return (\n" + $62dc134116dcb5c9$export$d62b0b738687b4b2(dep) + "\n)}"
            });
            $62dc134116dcb5c9$var$_allowInitAsString = false;
        }
        // Grab postable data for worker modules
        if (dep && dep.workerModuleData) dep = dep.workerModuleData;
        return dep;
    });
    function moduleFunc() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // Register this module if needed
        if (!registrationPromise) {
            registrationPromise = $62dc134116dcb5c9$var$callWorker(workerId, 'registerModule', moduleFunc.workerModuleData);
            var unregister = function() {
                registrationPromise = null;
                $62dc134116dcb5c9$var$registeredModules[workerId].delete(unregister);
            };
            ($62dc134116dcb5c9$var$registeredModules[workerId] || ($62dc134116dcb5c9$var$registeredModules[workerId] = new Set())).add(unregister);
        }
        // Invoke the module, returning a promise
        return registrationPromise.then(function(ref) {
            var isCallable = ref.isCallable;
            if (isCallable) return $62dc134116dcb5c9$var$callWorker(workerId, 'callModule', {
                id: id,
                args: args
            });
            else throw new Error('Worker module function was called but `init` did not return a callable function');
        });
    }
    moduleFunc.workerModuleData = {
        isWorkerModule: true,
        id: id,
        name: name,
        dependencies: dependencies,
        init: $62dc134116dcb5c9$export$d62b0b738687b4b2(init),
        getTransferables: getTransferables && $62dc134116dcb5c9$export$d62b0b738687b4b2(getTransferables)
    };
    return moduleFunc;
}
/**
 * Terminate an active Worker by a workerId that was passed to defineWorkerModule.
 * This only terminates the Worker itself; the worker module will remain available
 * and if you call it again its Worker will be respawned.
 * @param {string} workerId
 */ function $62dc134116dcb5c9$export$a61a973ac243a75e(workerId) {
    // Unregister all modules that were registered in that worker
    if ($62dc134116dcb5c9$var$registeredModules[workerId]) $62dc134116dcb5c9$var$registeredModules[workerId].forEach(function(unregister) {
        unregister();
    });
    // Terminate the Worker object
    if ($62dc134116dcb5c9$var$workers[workerId]) {
        $62dc134116dcb5c9$var$workers[workerId].terminate();
        delete $62dc134116dcb5c9$var$workers[workerId];
    }
}
/**
 * Stringifies a function into a form that can be deserialized in the worker
 * @param fn
 */ function $62dc134116dcb5c9$export$d62b0b738687b4b2(fn) {
    var str = fn.toString();
    // If it was defined in object method/property format, it needs to be modified
    if (!/^function/.test(str) && /^\w+\s*\(/.test(str)) str = 'function ' + str;
    return str;
}
function $62dc134116dcb5c9$var$getWorker(workerId) {
    var worker = $62dc134116dcb5c9$var$workers[workerId];
    if (!worker) {
        // Bootstrap the worker's content
        var bootstrap = $62dc134116dcb5c9$export$d62b0b738687b4b2($62dc134116dcb5c9$var$workerBootstrap);
        // Create the worker from the bootstrap function content
        worker = $62dc134116dcb5c9$var$workers[workerId] = new Worker(URL.createObjectURL(new Blob([
            "/** Worker Module Bootstrap: " + workerId.replace(/\*/g, '') + " **/\n\n;(" + bootstrap + ")()"
        ], {
            type: 'application/javascript'
        })));
        // Single handler for response messages from the worker
        worker.onmessage = function(e) {
            var response = e.data;
            var msgId = response.messageId;
            var callback = $62dc134116dcb5c9$var$openRequests[msgId];
            if (!callback) throw new Error('WorkerModule response with empty or unknown messageId');
            delete $62dc134116dcb5c9$var$openRequests[msgId];
            callback(response);
        };
    }
    return worker;
}
// Issue a call to the worker with a callback to handle the response
function $62dc134116dcb5c9$var$callWorker(workerId, action, data) {
    return new Promise(function(resolve, reject) {
        var messageId = ++$62dc134116dcb5c9$var$_messageId;
        $62dc134116dcb5c9$var$openRequests[messageId] = function(response) {
            if (response.success) resolve(response.result);
            else reject(new Error("Error in worker " + action + " call: " + response.error));
        };
        $62dc134116dcb5c9$var$getWorker(workerId).postMessage({
            messageId: messageId,
            action: action,
            data: data
        });
    });
}


function $a7b056c205977ae3$export$2e2bcd8739ae039() {
    var exports = function(exports) {
        /**
   * Find the point on a quadratic bezier curve at t where t is in the range [0, 1]
   */ function pointOnQuadraticBezier(x0, y0, x1, y1, x2, y2, t, pointOut) {
            var t2 = 1 - t;
            pointOut.x = t2 * t2 * x0 + 2 * t2 * t * x1 + t * t * x2;
            pointOut.y = t2 * t2 * y0 + 2 * t2 * t * y1 + t * t * y2;
        }
        /**
   * Find the point on a cubic bezier curve at t where t is in the range [0, 1]
   */ function pointOnCubicBezier(x0, y0, x1, y1, x2, y2, x3, y3, t, pointOut) {
            var t2 = 1 - t;
            pointOut.x = t2 * t2 * t2 * x0 + 3 * t2 * t2 * t * x1 + 3 * t2 * t * t * x2 + t * t * t * x3;
            pointOut.y = t2 * t2 * t2 * y0 + 3 * t2 * t2 * t * y1 + 3 * t2 * t * t * y2 + t * t * t * y3;
        }
        /**
   * Parse a path string into its constituent line/curve commands, invoking a callback for each.
   * @param {string} pathString - An SVG-like path string to parse; should only contain commands: M/L/Q/C/Z
   * @param {function(
   *   command: 'L'|'Q'|'C',
   *   startX: number,
   *   startY: number,
   *   endX: number,
   *   endY: number,
   *   ctrl1X?: number,
   *   ctrl1Y?: number,
   *   ctrl2X?: number,
   *   ctrl2Y?: number
   * )} commandCallback - A callback function that will be called once for each parsed path command, passing the
   *                      command identifier (only L/Q/C commands) and its numeric arguments.
   */ function forEachPathCommand(pathString, commandCallback) {
            var segmentRE = /([MLQCZ])([^MLQCZ]*)/g;
            var match, firstX, firstY, prevX, prevY;
            while(match = segmentRE.exec(pathString)){
                var args = match[2].replace(/^\s*|\s*$/g, '').split(/[,\s]+/).map(function(v) {
                    return parseFloat(v);
                });
                switch(match[1]){
                    case 'M':
                        prevX = firstX = args[0];
                        prevY = firstY = args[1];
                        break;
                    case 'L':
                        if (args[0] !== prevX || args[1] !== prevY) commandCallback('L', prevX, prevY, prevX = args[0], prevY = args[1]);
                        break;
                    case 'Q':
                        commandCallback('Q', prevX, prevY, prevX = args[2], prevY = args[3], args[0], args[1]);
                        break;
                    case 'C':
                        commandCallback('C', prevX, prevY, prevX = args[4], prevY = args[5], args[0], args[1], args[2], args[3]);
                        break;
                    case 'Z':
                        if (prevX !== firstX || prevY !== firstY) commandCallback('L', prevX, prevY, firstX, firstY);
                        break;
                }
            }
        }
        /**
   * Convert a path string to a series of straight line segments
   * @param {string} pathString - An SVG-like path string to parse; should only contain commands: M/L/Q/C/Z
   * @param {function(x1:number, y1:number, x2:number, y2:number)} segmentCallback - A callback
   *        function that will be called once for every line segment
   * @param {number} [curvePoints] - How many straight line segments to use when approximating a
   *        bezier curve in the path. Defaults to 16.
   */ function pathToLineSegments(pathString, segmentCallback, curvePoints) {
            if (curvePoints === void 0) curvePoints = 16;
            var tempPoint = {
                x: 0,
                y: 0
            };
            forEachPathCommand(pathString, function(command, startX, startY, endX, endY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y) {
                switch(command){
                    case 'L':
                        segmentCallback(startX, startY, endX, endY);
                        break;
                    case 'Q':
                        var prevCurveX = startX;
                        var prevCurveY = startY;
                        for(var i = 1; i < curvePoints; i++){
                            pointOnQuadraticBezier(startX, startY, ctrl1X, ctrl1Y, endX, endY, i / (curvePoints - 1), tempPoint);
                            segmentCallback(prevCurveX, prevCurveY, tempPoint.x, tempPoint.y);
                            prevCurveX = tempPoint.x;
                            prevCurveY = tempPoint.y;
                        }
                        break;
                    case 'C':
                        var prevCurveX$1 = startX;
                        var prevCurveY$1 = startY;
                        for(var i$1 = 1; i$1 < curvePoints; i$1++){
                            pointOnCubicBezier(startX, startY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y, endX, endY, i$1 / (curvePoints - 1), tempPoint);
                            segmentCallback(prevCurveX$1, prevCurveY$1, tempPoint.x, tempPoint.y);
                            prevCurveX$1 = tempPoint.x;
                            prevCurveY$1 = tempPoint.y;
                        }
                        break;
                }
            });
        }
        var viewportQuadVertex = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
        var copyTexFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}";
        var cache = new WeakMap();
        var glContextParams = {
            premultipliedAlpha: false,
            preserveDrawingBuffer: true,
            antialias: false,
            depth: false
        };
        /**
   * This is a little helper library for WebGL. It assists with state management for a GL context.
   * It's pretty tightly wrapped to the needs of this package, not very general-purpose.
   *
   * @param { WebGLRenderingContext | HTMLCanvasElement | OffscreenCanvas } glOrCanvas - the GL context to wrap
   * @param { ({gl, getExtension, withProgram, withTexture, withTextureFramebuffer, handleContextLoss}) => void } callback
   */ function withWebGLContext(glOrCanvas, callback) {
            var gl = glOrCanvas.getContext ? glOrCanvas.getContext('webgl', glContextParams) : glOrCanvas;
            var wrapper = cache.get(gl);
            if (!wrapper) {
                var isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext;
                var extensions = {};
                var programs = {};
                var textures = {};
                var textureUnit = -1;
                var framebufferStack = [];
                gl.canvas.addEventListener('webglcontextlost', function(e) {
                    handleContextLoss();
                    e.preventDefault();
                }, false);
                function getExtension(name) {
                    var ext = extensions[name];
                    if (!ext) {
                        ext = extensions[name] = gl.getExtension(name);
                        if (!ext) throw new Error(name + " not supported");
                    }
                    return ext;
                }
                function compileShader(src, type) {
                    var shader = gl.createShader(type);
                    gl.shaderSource(shader, src);
                    gl.compileShader(shader);
                    // const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS)
                    // if (!status && !gl.isContextLost()) {
                    //   throw new Error(gl.getShaderInfoLog(shader).trim())
                    // }
                    return shader;
                }
                function withProgram(name, vert, frag, func) {
                    if (!programs[name]) {
                        var attributes = {};
                        var uniforms = {};
                        var program = gl.createProgram();
                        gl.attachShader(program, compileShader(vert, gl.VERTEX_SHADER));
                        gl.attachShader(program, compileShader(frag, gl.FRAGMENT_SHADER));
                        gl.linkProgram(program);
                        programs[name] = {
                            program: program,
                            transaction: function transaction(func) {
                                gl.useProgram(program);
                                func({
                                    setUniform: function setUniform(type, name) {
                                        var values = [], len = arguments.length - 2;
                                        while(len-- > 0)values[len] = arguments[len + 2];
                                        var uniformLoc = uniforms[name] || (uniforms[name] = gl.getUniformLocation(program, name));
                                        gl["uniform" + type].apply(gl, [
                                            uniformLoc
                                        ].concat(values));
                                    },
                                    setAttribute: function setAttribute(name, size, usage, instancingDivisor, data) {
                                        var attr = attributes[name];
                                        if (!attr) attr = attributes[name] = {
                                            buf: gl.createBuffer(),
                                            loc: gl.getAttribLocation(program, name),
                                            data: null
                                        };
                                        gl.bindBuffer(gl.ARRAY_BUFFER, attr.buf);
                                        gl.vertexAttribPointer(attr.loc, size, gl.FLOAT, false, 0, 0);
                                        gl.enableVertexAttribArray(attr.loc);
                                        if (isWebGL2) gl.vertexAttribDivisor(attr.loc, instancingDivisor);
                                        else getExtension('ANGLE_instanced_arrays').vertexAttribDivisorANGLE(attr.loc, instancingDivisor);
                                        if (data !== attr.data) {
                                            gl.bufferData(gl.ARRAY_BUFFER, data, usage);
                                            attr.data = data;
                                        }
                                    }
                                });
                            }
                        };
                    }
                    programs[name].transaction(func);
                }
                function withTexture(name, func) {
                    textureUnit++;
                    try {
                        gl.activeTexture(gl.TEXTURE0 + textureUnit);
                        var texture = textures[name];
                        if (!texture) {
                            texture = textures[name] = gl.createTexture();
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
                            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
                        }
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        func(texture, textureUnit);
                    } finally{
                        textureUnit--;
                    }
                }
                function withTextureFramebuffer(texture, textureUnit, func) {
                    var framebuffer = gl.createFramebuffer();
                    framebufferStack.push(framebuffer);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                    gl.activeTexture(gl.TEXTURE0 + textureUnit);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
                    try {
                        func(framebuffer);
                    } finally{
                        gl.deleteFramebuffer(framebuffer);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebufferStack[--framebufferStack.length - 1] || null);
                    }
                }
                function handleContextLoss() {
                    extensions = {};
                    programs = {};
                    textures = {};
                    textureUnit = -1;
                    framebufferStack.length = 0;
                }
                cache.set(gl, wrapper = {
                    gl: gl,
                    isWebGL2: isWebGL2,
                    getExtension: getExtension,
                    withProgram: withProgram,
                    withTexture: withTexture,
                    withTextureFramebuffer: withTextureFramebuffer,
                    handleContextLoss: handleContextLoss
                });
            }
            callback(wrapper);
        }
        function renderImageData(glOrCanvas, imageData, x, y, width, height, channels, framebuffer) {
            if (channels === void 0) channels = 15;
            if (framebuffer === void 0) framebuffer = null;
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var withProgram = ref.withProgram;
                var withTexture = ref.withTexture;
                withTexture('copy', function(tex, texUnit) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, imageData);
                    withProgram('copy', viewportQuadVertex, copyTexFragment, function(ref) {
                        var setUniform = ref.setUniform;
                        var setAttribute = ref.setAttribute;
                        setAttribute('aUV', 2, gl.STATIC_DRAW, 0, new Float32Array([
                            0,
                            0,
                            2,
                            0,
                            0,
                            2
                        ]));
                        setUniform('1i', 'image', texUnit);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer || null);
                        gl.disable(gl.BLEND);
                        gl.colorMask(channels & 8, channels & 4, channels & 2, channels & 1);
                        gl.viewport(x, y, width, height);
                        gl.scissor(x, y, width, height);
                        gl.drawArrays(gl.TRIANGLES, 0, 3);
                    });
                });
            });
        }
        /**
   * Resizing a canvas clears its contents; this utility copies the previous contents over.
   * @param canvas
   * @param newWidth
   * @param newHeight
   */ function resizeWebGLCanvasWithoutClearing(canvas, newWidth, newHeight) {
            var width = canvas.width;
            var height = canvas.height;
            withWebGLContext(canvas, function(ref) {
                var gl = ref.gl;
                var data = new Uint8Array(width * height * 4);
                gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, data);
                canvas.width = newWidth;
                canvas.height = newHeight;
                renderImageData(gl, data, 0, 0, width, height);
            });
        }
        var webglUtils = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            withWebGLContext: withWebGLContext,
            renderImageData: renderImageData,
            resizeWebGLCanvasWithoutClearing: resizeWebGLCanvasWithoutClearing
        });
        function generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
            if (sdfExponent === void 0) sdfExponent = 1;
            var textureData = new Uint8Array(sdfWidth * sdfHeight);
            var viewBoxWidth = viewBox[2] - viewBox[0];
            var viewBoxHeight = viewBox[3] - viewBox[1];
            // Decompose all paths into straight line segments and add them to an index
            var segments = [];
            pathToLineSegments(path, function(x1, y1, x2, y2) {
                segments.push({
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    minX: Math.min(x1, x2),
                    minY: Math.min(y1, y2),
                    maxX: Math.max(x1, x2),
                    maxY: Math.max(y1, y2)
                });
            });
            // Sort segments by maxX, this will let us short-circuit some loops below
            segments.sort(function(a, b) {
                return a.maxX - b.maxX;
            });
            // For each target SDF texel, find the distance from its center to its nearest line segment,
            // map that distance to an alpha value, and write that alpha to the texel
            for(var sdfX = 0; sdfX < sdfWidth; sdfX++)for(var sdfY = 0; sdfY < sdfHeight; sdfY++){
                var signedDist = findNearestSignedDistance(viewBox[0] + viewBoxWidth * (sdfX + 0.5) / sdfWidth, viewBox[1] + viewBoxHeight * (sdfY + 0.5) / sdfHeight);
                // Use an exponential scale to ensure the texels very near the glyph path have adequate
                // precision, while allowing the distance field to cover the entire texture, given that
                // there are only 8 bits available. Formula visualized: https://www.desmos.com/calculator/uiaq5aqiam
                var alpha = Math.pow(1 - Math.abs(signedDist) / maxDistance, sdfExponent) / 2;
                if (signedDist < 0) alpha = 1 - alpha;
                alpha = Math.max(0, Math.min(255, Math.round(alpha * 255))); //clamp
                textureData[sdfY * sdfWidth + sdfX] = alpha;
            }
            return textureData;
            /**
     * For a given x/y, search the index for the closest line segment and return
     * its signed distance. Negative = inside, positive = outside, zero = on edge
     * @param x
     * @param y
     * @returns {number}
     */ function findNearestSignedDistance(x, y) {
                var closestDistSq = Infinity;
                var closestDist = Infinity;
                for(var i = segments.length; i--;){
                    var seg = segments[i];
                    if (seg.maxX + closestDist <= x) break;
                     //sorting by maxX means no more can be closer, so we can short-circuit
                    if (x + closestDist > seg.minX && y - closestDist < seg.maxY && y + closestDist > seg.minY) {
                        var distSq = absSquareDistanceToLineSegment(x, y, seg.x1, seg.y1, seg.x2, seg.y2);
                        if (distSq < closestDistSq) {
                            closestDistSq = distSq;
                            closestDist = Math.sqrt(closestDistSq);
                        }
                    }
                }
                // Flip to negative distance if inside the poly
                if (isPointInPoly(x, y)) closestDist = -closestDist;
                return closestDist;
            }
            /**
     * Determine whether the given point lies inside or outside the glyph. Uses a simple
     * winding-number ray casting algorithm using a ray pointing east from the point.
     */ function isPointInPoly(x, y) {
                var winding = 0;
                for(var i = segments.length; i--;){
                    var seg = segments[i];
                    if (seg.maxX <= x) break;
                     //sorting by maxX means no more can cross, so we can short-circuit
                    var intersects = seg.y1 > y !== seg.y2 > y && x < (seg.x2 - seg.x1) * (y - seg.y1) / (seg.y2 - seg.y1) + seg.x1;
                    if (intersects) winding += seg.y1 < seg.y2 ? 1 : -1;
                }
                return winding !== 0;
            }
        }
        function generateIntoCanvas$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x, y, channel);
        }
        function generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            var data = generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent);
            // Expand single-channel data to rbga
            var rgbaData = new Uint8Array(data.length * 4);
            for(var i = 0; i < data.length; i++)rgbaData[i * 4 + channel] = data[i];
            renderImageData(glOrCanvas, rgbaData, x, y, sdfWidth, sdfHeight, 1 << 3 - channel, framebuffer);
        }
        /**
   * Find the absolute distance from a point to a line segment at closest approach
   */ function absSquareDistanceToLineSegment(x, y, lineX0, lineY0, lineX1, lineY1) {
            var ldx = lineX1 - lineX0;
            var ldy = lineY1 - lineY0;
            var lengthSq = ldx * ldx + ldy * ldy;
            var t = lengthSq ? Math.max(0, Math.min(1, ((x - lineX0) * ldx + (y - lineY0) * ldy) / lengthSq)) : 0;
            var dx = x - (lineX0 + t * ldx);
            var dy = y - (lineY0 + t * ldy);
            return dx * dx + dy * dy;
        }
        var javascript = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            generate: generate$2,
            generateIntoCanvas: generateIntoCanvas$2,
            generateIntoFramebuffer: generateIntoFramebuffer$1
        });
        var mainVertex = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
        var mainFragment = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}";
        var postFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}";
        // Single triangle covering viewport
        var viewportUVs = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        var implicitContext = null;
        var isTestingSupport = false;
        var NULL_OBJECT = {};
        var supportByCanvas = new WeakMap(); // canvas -> bool
        function validateSupport(glOrCanvas) {
            if (!isTestingSupport && !isSupported(glOrCanvas)) throw new Error('WebGL generation not supported');
        }
        function generate$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (glOrCanvas === void 0) glOrCanvas = null;
            if (!glOrCanvas) {
                glOrCanvas = implicitContext;
                if (!glOrCanvas) {
                    var canvas = typeof OffscreenCanvas === 'function' ? new OffscreenCanvas(1, 1) : typeof document !== 'undefined' ? document.createElement('canvas') : null;
                    if (!canvas) throw new Error('OffscreenCanvas or DOM canvas not supported');
                    glOrCanvas = implicitContext = canvas.getContext('webgl', {
                        depth: false
                    });
                }
            }
            validateSupport(glOrCanvas);
            var rgbaData = new Uint8Array(sdfWidth * sdfHeight * 4); //not Uint8ClampedArray, cuz Safari
            // Render into a background texture framebuffer
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var withTexture = ref.withTexture;
                var withTextureFramebuffer = ref.withTextureFramebuffer;
                withTexture('readable', function(texture, textureUnit) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, sdfWidth, sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    withTextureFramebuffer(texture, textureUnit, function(framebuffer) {
                        generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, gl, framebuffer, 0, 0, 0 // red channel
                        );
                        gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, rgbaData);
                    });
                });
            });
            // Throw away all but the red channel
            var data = new Uint8Array(sdfWidth * sdfHeight);
            for(var i = 0, j = 0; i < rgbaData.length; i += 4)data[j++] = rgbaData[i];
            return data;
        }
        function generateIntoCanvas$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x, y, channel);
        }
        function generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            // Verify support
            validateSupport(glOrCanvas);
            // Compute path segments
            var lineSegmentCoords = [];
            pathToLineSegments(path, function(x1, y1, x2, y2) {
                lineSegmentCoords.push(x1, y1, x2, y2);
            });
            lineSegmentCoords = new Float32Array(lineSegmentCoords);
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var isWebGL2 = ref.isWebGL2;
                var getExtension = ref.getExtension;
                var withProgram = ref.withProgram;
                var withTexture = ref.withTexture;
                var withTextureFramebuffer = ref.withTextureFramebuffer;
                var handleContextLoss = ref.handleContextLoss;
                withTexture('rawDistances', function(intermediateTexture, intermediateTextureUnit) {
                    if (sdfWidth !== intermediateTexture._lastWidth || sdfHeight !== intermediateTexture._lastHeight) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, intermediateTexture._lastWidth = sdfWidth, intermediateTexture._lastHeight = sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    // Unsigned distance pass
                    withProgram('main', mainVertex, mainFragment, function(ref) {
                        var setAttribute = ref.setAttribute;
                        var setUniform = ref.setUniform;
                        // Init extensions
                        var instancingExtension = !isWebGL2 && getExtension('ANGLE_instanced_arrays');
                        var blendMinMaxExtension = !isWebGL2 && getExtension('EXT_blend_minmax');
                        // Init/update attributes
                        setAttribute('aUV', 2, gl.STATIC_DRAW, 0, viewportUVs);
                        setAttribute('aLineSegment', 4, gl.DYNAMIC_DRAW, 1, lineSegmentCoords);
                        // Init/update uniforms
                        setUniform.apply(void 0, [
                            '4f',
                            'uGlyphBounds'
                        ].concat(viewBox));
                        setUniform('1f', 'uMaxDistance', maxDistance);
                        setUniform('1f', 'uExponent', sdfExponent);
                        // Render initial unsigned distance / winding number info to a texture
                        withTextureFramebuffer(intermediateTexture, intermediateTextureUnit, function(framebuffer) {
                            gl.enable(gl.BLEND);
                            gl.colorMask(true, true, true, true);
                            gl.viewport(0, 0, sdfWidth, sdfHeight);
                            gl.scissor(0, 0, sdfWidth, sdfHeight);
                            gl.blendFunc(gl.ONE, gl.ONE);
                            // Red+Green channels are incremented (FUNC_ADD) for segment-ray crossings to give a "winding number".
                            // Alpha holds the closest (MAX) unsigned distance.
                            gl.blendEquationSeparate(gl.FUNC_ADD, isWebGL2 ? gl.MAX : blendMinMaxExtension.MAX_EXT);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                            if (isWebGL2) gl.drawArraysInstanced(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
                            else instancingExtension.drawArraysInstancedANGLE(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
                        // Debug
                        // const debug = new Uint8Array(sdfWidth * sdfHeight * 4)
                        // gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, debug)
                        // console.log('intermediate texture data: ', debug)
                        });
                    });
                    // Use the data stored in the texture to apply inside/outside and write to the output framebuffer rect+channel.
                    withProgram('post', viewportQuadVertex, postFragment, function(program) {
                        program.setAttribute('aUV', 2, gl.STATIC_DRAW, 0, viewportUVs);
                        program.setUniform('1i', 'tex', intermediateTextureUnit);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                        gl.disable(gl.BLEND);
                        gl.colorMask(channel === 0, channel === 1, channel === 2, channel === 3);
                        gl.viewport(x, y, sdfWidth, sdfHeight);
                        gl.scissor(x, y, sdfWidth, sdfHeight);
                        gl.drawArrays(gl.TRIANGLES, 0, 3);
                    });
                });
                // Handle context loss occurring during any of the above calls
                if (gl.isContextLost()) {
                    handleContextLoss();
                    throw new Error('webgl context lost');
                }
            });
        }
        function isSupported(glOrCanvas) {
            var key = !glOrCanvas || glOrCanvas === implicitContext ? NULL_OBJECT : glOrCanvas.canvas || glOrCanvas;
            var supported = supportByCanvas.get(key);
            if (supported === undefined) {
                isTestingSupport = true;
                var failReason = null;
                try {
                    // Since we can't detect all failure modes up front, let's just do a trial run of a
                    // simple path and compare what we get back to the correct expected result. This will
                    // also serve to prime the shader compilation.
                    var expectedResult = [
                        97,
                        106,
                        97,
                        61,
                        99,
                        137,
                        118,
                        80,
                        80,
                        118,
                        137,
                        99,
                        61,
                        97,
                        106,
                        97
                    ];
                    var testResult = generate$1(4, 4, 'M8,8L16,8L24,24L16,24Z', [
                        0,
                        0,
                        32,
                        32
                    ], 24, 1, glOrCanvas);
                    supported = testResult && expectedResult.length === testResult.length && testResult.every(function(val, i) {
                        return val === expectedResult[i];
                    });
                    if (!supported) {
                        failReason = 'bad trial run results';
                        console.info(expectedResult, testResult);
                    }
                } catch (err) {
                    // TODO if it threw due to webgl context loss, should we maybe leave isSupported as null and try again later?
                    supported = false;
                    failReason = err.message;
                }
                if (failReason) console.warn('WebGL SDF generation not supported:', failReason);
                isTestingSupport = false;
                supportByCanvas.set(key, supported);
            }
            return supported;
        }
        var webgl = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            generate: generate$1,
            generateIntoCanvas: generateIntoCanvas$1,
            generateIntoFramebuffer: generateIntoFramebuffer,
            isSupported: isSupported
        });
        /**
   * Generate an SDF texture image for a 2D path.
   *
   * @param {number} sdfWidth - width of the SDF output image in pixels.
   * @param {number} sdfHeight - height of the SDF output image in pixels.
   * @param {string} path - an SVG-like path string describing the glyph; should only contain commands: M/L/Q/C/Z.
   * @param {number[]} viewBox - [minX, minY, maxX, maxY] in font units aligning with the texture's edges.
   * @param {number} maxDistance - the maximum distance from the glyph path in font units that will be encoded; defaults
   *        to half the maximum viewBox dimension.
   * @param {number} [sdfExponent] - specifies an exponent for encoding the SDF's distance values; higher exponents
   *        will give greater precision nearer the glyph's path.
   * @return {Uint8Array}
   */ function generate(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
            if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
            if (sdfExponent === void 0) sdfExponent = 1;
            try {
                return generate$1.apply(webgl, arguments);
            } catch (e) {
                console.info('WebGL SDF generation failed, falling back to JS', e);
                return generate$2.apply(javascript, arguments);
            }
        }
        /**
   * Generate an SDF texture image for a 2D path, inserting the result into a WebGL `canvas` at a given x/y position
   * and color channel. This is generally much faster than calling `generate` because it does not require reading pixels
   * back from the GPU->CPU -- the `canvas` can be used directly as a WebGL texture image, so it all stays on the GPU.
   *
   * @param {number} sdfWidth - width of the SDF output image in pixels.
   * @param {number} sdfHeight - height of the SDF output image in pixels.
   * @param {string} path - an SVG-like path string describing the glyph; should only contain commands: M/L/Q/C/Z.
   * @param {number[]} viewBox - [minX, minY, maxX, maxY] in font units aligning with the texture's edges.
   * @param {number} maxDistance - the maximum distance from the glyph path in font units that will be encoded; defaults
   *        to half the maximum viewBox dimension.
   * @param {number} [sdfExponent] - specifies an exponent for encoding the SDF's distance values; higher exponents
   *        will give greater precision nearer the glyph's path.
   * @param {HTMLCanvasElement|OffscreenCanvas} canvas - a WebGL-enabled canvas into which the SDF will be rendered.
   *        Only the relevant rect/channel will be modified, the rest will be preserved. To avoid unpredictable results
   *        due to shared GL context state, this canvas should be dedicated to use by this library alone.
   * @param {number} x - the x position at which to render the SDF.
   * @param {number} y - the y position at which to render the SDF.
   * @param {number} channel - the color channel index (0-4) into which the SDF will be rendered.
   * @return {Uint8Array}
   */ function generateIntoCanvas(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            try {
                return generateIntoCanvas$1.apply(webgl, arguments);
            } catch (e) {
                console.info('WebGL SDF generation failed, falling back to JS', e);
                return generateIntoCanvas$2.apply(javascript, arguments);
            }
        }
        exports.forEachPathCommand = forEachPathCommand;
        exports.generate = generate;
        exports.generateIntoCanvas = generateIntoCanvas;
        exports.javascript = javascript;
        exports.pathToLineSegments = pathToLineSegments;
        exports.webgl = webgl;
        exports.webglUtils = webglUtils;
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        return exports;
    }({});
    return exports;
}


function $39f838faf692eed9$var$bidiFactory() {
    var bidi = function(exports) {
        // Bidi character types data, auto generated
        var DATA = {
            "R": "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
            "EN": "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
            "ES": "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
            "ET": "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
            "AN": "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
            "CS": "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
            "B": "a,3,f+2,2v,690",
            "S": "9,2,k",
            "WS": "c,k,4f4,1vk+a,u,1j,335",
            "ON": "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
            "BN": "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
            "NSM": "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
            "AL": "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
            "LRO": "6ct",
            "RLO": "6cu",
            "LRE": "6cq",
            "RLE": "6cr",
            "PDF": "6cs",
            "LRI": "6ee",
            "RLI": "6ef",
            "FSI": "6eg",
            "PDI": "6eh"
        };
        var TYPES = {};
        var TYPES_TO_NAMES = {};
        TYPES.L = 1; //L is the default
        TYPES_TO_NAMES[1] = 'L';
        Object.keys(DATA).forEach(function(type, i) {
            TYPES[type] = 1 << i + 1;
            TYPES_TO_NAMES[TYPES[type]] = type;
        });
        Object.freeze(TYPES);
        var ISOLATE_INIT_TYPES = TYPES.LRI | TYPES.RLI | TYPES.FSI;
        var STRONG_TYPES = TYPES.L | TYPES.R | TYPES.AL;
        var NEUTRAL_ISOLATE_TYPES = TYPES.B | TYPES.S | TYPES.WS | TYPES.ON | TYPES.FSI | TYPES.LRI | TYPES.RLI | TYPES.PDI;
        var BN_LIKE_TYPES = TYPES.BN | TYPES.RLE | TYPES.LRE | TYPES.RLO | TYPES.LRO | TYPES.PDF;
        var TRAILING_TYPES = TYPES.S | TYPES.WS | TYPES.B | ISOLATE_INIT_TYPES | TYPES.PDI | BN_LIKE_TYPES;
        var map = null;
        function parseData() {
            if (!map) {
                //const start = performance.now()
                map = new Map();
                var loop = function(type) {
                    if (DATA.hasOwnProperty(type)) {
                        var lastCode = 0;
                        DATA[type].split(',').forEach(function(range) {
                            var ref = range.split('+');
                            var skip = ref[0];
                            var step = ref[1];
                            skip = parseInt(skip, 36);
                            step = step ? parseInt(step, 36) : 0;
                            map.set(lastCode += skip, TYPES[type]);
                            for(var i = 0; i < step; i++)map.set(++lastCode, TYPES[type]);
                        });
                    }
                };
                for(var type in DATA)loop(type);
            //console.log(`char types parsed in ${performance.now() - start}ms`)
            }
        }
        /**
   * @param {string} char
   * @return {number}
   */ function getBidiCharType(char) {
            parseData();
            return map.get(char.codePointAt(0)) || TYPES.L;
        }
        function getBidiCharTypeName(char) {
            return TYPES_TO_NAMES[getBidiCharType(char)];
        }
        // Bidi bracket pairs data, auto generated
        var data$1 = {
            "pairs": "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
            "canonical": "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
        };
        /**
   * Parses an string that holds encoded codepoint mappings, e.g. for bracket pairs or
   * mirroring characters, as encoded by scripts/generateBidiData.js. Returns an object
   * holding the `map`, and optionally a `reverseMap` if `includeReverse:true`.
   * @param {string} encodedString
   * @param {boolean} includeReverse - true if you want reverseMap in the output
   * @return {{map: Map<number, number>, reverseMap?: Map<number, number>}}
   */ function parseCharacterMap(encodedString, includeReverse) {
            var radix = 36;
            var lastCode = 0;
            var map = new Map();
            var reverseMap = includeReverse && new Map();
            var prevPair;
            encodedString.split(',').forEach(function visit(entry) {
                if (entry.indexOf('+') !== -1) for(var i = +entry; i--;)visit(prevPair);
                else {
                    prevPair = entry;
                    var ref = entry.split('>');
                    var a = ref[0];
                    var b = ref[1];
                    a = String.fromCodePoint(lastCode += parseInt(a, radix));
                    b = String.fromCodePoint(lastCode += parseInt(b, radix));
                    map.set(a, b);
                    includeReverse && reverseMap.set(b, a);
                }
            });
            return {
                map: map,
                reverseMap: reverseMap
            };
        }
        var openToClose, closeToOpen, canonical;
        function parse$1() {
            if (!openToClose) {
                //const start = performance.now()
                var ref = parseCharacterMap(data$1.pairs, true);
                var map = ref.map;
                var reverseMap = ref.reverseMap;
                openToClose = map;
                closeToOpen = reverseMap;
                canonical = parseCharacterMap(data$1.canonical, false).map;
            //console.log(`brackets parsed in ${performance.now() - start}ms`)
            }
        }
        function openingToClosingBracket(char) {
            parse$1();
            return openToClose.get(char) || null;
        }
        function closingToOpeningBracket(char) {
            parse$1();
            return closeToOpen.get(char) || null;
        }
        function getCanonicalBracket(char) {
            parse$1();
            return canonical.get(char) || null;
        }
        // Local type aliases
        var TYPE_L = TYPES.L;
        var TYPE_R = TYPES.R;
        var TYPE_EN = TYPES.EN;
        var TYPE_ES = TYPES.ES;
        var TYPE_ET = TYPES.ET;
        var TYPE_AN = TYPES.AN;
        var TYPE_CS = TYPES.CS;
        var TYPE_B = TYPES.B;
        var TYPE_S = TYPES.S;
        var TYPE_ON = TYPES.ON;
        var TYPE_BN = TYPES.BN;
        var TYPE_NSM = TYPES.NSM;
        var TYPE_AL = TYPES.AL;
        var TYPE_LRO = TYPES.LRO;
        var TYPE_RLO = TYPES.RLO;
        var TYPE_LRE = TYPES.LRE;
        var TYPE_RLE = TYPES.RLE;
        var TYPE_PDF = TYPES.PDF;
        var TYPE_LRI = TYPES.LRI;
        var TYPE_RLI = TYPES.RLI;
        var TYPE_FSI = TYPES.FSI;
        var TYPE_PDI = TYPES.PDI;
        /**
   * @typedef {object} GetEmbeddingLevelsResult
   * @property {{start, end, level}[]} paragraphs
   * @property {Uint8Array} levels
   */ /**
   * This function applies the Bidirectional Algorithm to a string, returning the resolved embedding levels
   * in a single Uint8Array plus a list of objects holding each paragraph's start and end indices and resolved
   * base embedding level.
   *
   * @param {string} string - The input string
   * @param {"ltr"|"rtl"|"auto"} [baseDirection] - Use "ltr" or "rtl" to force a base paragraph direction,
   *        otherwise a direction will be chosen automatically from each paragraph's contents.
   * @return {GetEmbeddingLevelsResult}
   */ function getEmbeddingLevels(string, baseDirection) {
            var MAX_DEPTH = 125;
            // Start by mapping all characters to their unicode type, as a bitmask integer
            var charTypes = new Uint32Array(string.length);
            for(var i = 0; i < string.length; i++)charTypes[i] = getBidiCharType(string[i]);
            var charTypeCounts = new Map(); //will be cleared at start of each paragraph
            function changeCharType(i, type) {
                var oldType = charTypes[i];
                charTypes[i] = type;
                charTypeCounts.set(oldType, charTypeCounts.get(oldType) - 1);
                if (oldType & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) - 1);
                charTypeCounts.set(type, (charTypeCounts.get(type) || 0) + 1);
                if (type & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
            }
            var embedLevels = new Uint8Array(string.length);
            var isolationPairs = new Map(); //init->pdi and pdi->init
            // === 3.3.1 The Paragraph Level ===
            // 3.3.1 P1: Split the text into paragraphs
            var paragraphs = []; // [{start, end, level}, ...]
            var paragraph = null;
            for(var i$1 = 0; i$1 < string.length; i$1++){
                if (!paragraph) paragraphs.push(paragraph = {
                    start: i$1,
                    end: string.length - 1,
                    // 3.3.1 P2-P3: Determine the paragraph level
                    level: baseDirection === 'rtl' ? 1 : baseDirection === 'ltr' ? 0 : determineAutoEmbedLevel(i$1, false)
                });
                if (charTypes[i$1] & TYPE_B) {
                    paragraph.end = i$1;
                    paragraph = null;
                }
            }
            var FORMATTING_TYPES = TYPE_RLE | TYPE_LRE | TYPE_RLO | TYPE_LRO | ISOLATE_INIT_TYPES | TYPE_PDI | TYPE_PDF | TYPE_B;
            var nextEven = function(n) {
                return n + (n & 1 ? 1 : 2);
            };
            var nextOdd = function(n) {
                return n + (n & 1 ? 2 : 1);
            };
            // Everything from here on will operate per paragraph.
            for(var paraIdx = 0; paraIdx < paragraphs.length; paraIdx++){
                paragraph = paragraphs[paraIdx];
                var statusStack = [
                    {
                        _level: paragraph.level,
                        _override: 0,
                        _isolate: 0 //bool
                    }
                ];
                var stackTop = void 0;
                var overflowIsolateCount = 0;
                var overflowEmbeddingCount = 0;
                var validIsolateCount = 0;
                charTypeCounts.clear();
                // === 3.3.2 Explicit Levels and Directions ===
                for(var i$2 = paragraph.start; i$2 <= paragraph.end; i$2++){
                    var charType = charTypes[i$2];
                    stackTop = statusStack[statusStack.length - 1];
                    // Set initial counts
                    charTypeCounts.set(charType, (charTypeCounts.get(charType) || 0) + 1);
                    if (charType & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
                    // Explicit Embeddings: 3.3.2 X2 - X3
                    if (charType & FORMATTING_TYPES) {
                        if (charType & (TYPE_RLE | TYPE_LRE)) {
                            embedLevels[i$2] = stackTop._level; // 5.2
                            var level = (charType === TYPE_RLE ? nextOdd : nextEven)(stackTop._level);
                            if (level <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) statusStack.push({
                                _level: level,
                                _override: 0,
                                _isolate: 0
                            });
                            else if (!overflowIsolateCount) overflowEmbeddingCount++;
                        } else if (charType & (TYPE_RLO | TYPE_LRO)) {
                            embedLevels[i$2] = stackTop._level; // 5.2
                            var level$1 = (charType === TYPE_RLO ? nextOdd : nextEven)(stackTop._level);
                            if (level$1 <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) statusStack.push({
                                _level: level$1,
                                _override: charType & TYPE_RLO ? TYPE_R : TYPE_L,
                                _isolate: 0
                            });
                            else if (!overflowIsolateCount) overflowEmbeddingCount++;
                        } else if (charType & ISOLATE_INIT_TYPES) {
                            // X5c - FSI becomes either RLI or LRI
                            if (charType & TYPE_FSI) charType = determineAutoEmbedLevel(i$2 + 1, true) === 1 ? TYPE_RLI : TYPE_LRI;
                            embedLevels[i$2] = stackTop._level;
                            if (stackTop._override) changeCharType(i$2, stackTop._override);
                            var level$2 = (charType === TYPE_RLI ? nextOdd : nextEven)(stackTop._level);
                            if (level$2 <= MAX_DEPTH && overflowIsolateCount === 0 && overflowEmbeddingCount === 0) {
                                validIsolateCount++;
                                statusStack.push({
                                    _level: level$2,
                                    _override: 0,
                                    _isolate: 1,
                                    _isolInitIndex: i$2
                                });
                            } else overflowIsolateCount++;
                        } else if (charType & TYPE_PDI) {
                            if (overflowIsolateCount > 0) overflowIsolateCount--;
                            else if (validIsolateCount > 0) {
                                overflowEmbeddingCount = 0;
                                while(!statusStack[statusStack.length - 1]._isolate)statusStack.pop();
                                // Add to isolation pairs bidirectional mapping:
                                var isolInitIndex = statusStack[statusStack.length - 1]._isolInitIndex;
                                if (isolInitIndex != null) {
                                    isolationPairs.set(isolInitIndex, i$2);
                                    isolationPairs.set(i$2, isolInitIndex);
                                }
                                statusStack.pop();
                                validIsolateCount--;
                            }
                            stackTop = statusStack[statusStack.length - 1];
                            embedLevels[i$2] = stackTop._level;
                            if (stackTop._override) changeCharType(i$2, stackTop._override);
                        } else if (charType & TYPE_PDF) {
                            if (overflowIsolateCount === 0) {
                                if (overflowEmbeddingCount > 0) overflowEmbeddingCount--;
                                else if (!stackTop._isolate && statusStack.length > 1) {
                                    statusStack.pop();
                                    stackTop = statusStack[statusStack.length - 1];
                                }
                            }
                            embedLevels[i$2] = stackTop._level; // 5.2
                        } else if (charType & TYPE_B) embedLevels[i$2] = paragraph.level;
                    } else {
                        embedLevels[i$2] = stackTop._level;
                        // NOTE: This exclusion of BN seems to go against what section 5.2 says, but is required for test passage
                        if (stackTop._override && charType !== TYPE_BN) changeCharType(i$2, stackTop._override);
                    }
                }
                // === 3.3.3 Preparations for Implicit Processing ===
                // Remove all RLE, LRE, RLO, LRO, PDF, and BN characters: 3.3.3 X9
                // Note: Due to section 5.2, we won't remove them, but we'll use the BN_LIKE_TYPES bitset to
                // easily ignore them all from here on out.
                // 3.3.3 X10
                // Compute the set of isolating run sequences as specified by BD13
                var levelRuns = [];
                var currentRun = null;
                for(var i$3 = paragraph.start; i$3 <= paragraph.end; i$3++){
                    var charType$1 = charTypes[i$3];
                    if (!(charType$1 & BN_LIKE_TYPES)) {
                        var lvl = embedLevels[i$3];
                        var isIsolInit = charType$1 & ISOLATE_INIT_TYPES;
                        var isPDI = charType$1 === TYPE_PDI;
                        if (currentRun && lvl === currentRun._level) {
                            currentRun._end = i$3;
                            currentRun._endsWithIsolInit = isIsolInit;
                        } else levelRuns.push(currentRun = {
                            _start: i$3,
                            _end: i$3,
                            _level: lvl,
                            _startsWithPDI: isPDI,
                            _endsWithIsolInit: isIsolInit
                        });
                    }
                }
                var isolatingRunSeqs = []; // [{seqIndices: [], sosType: L|R, eosType: L|R}]
                for(var runIdx = 0; runIdx < levelRuns.length; runIdx++){
                    var run = levelRuns[runIdx];
                    if (!run._startsWithPDI || run._startsWithPDI && !isolationPairs.has(run._start)) {
                        var seqRuns = [
                            currentRun = run
                        ];
                        for(var pdiIndex = void 0; currentRun && currentRun._endsWithIsolInit && (pdiIndex = isolationPairs.get(currentRun._end)) != null;){
                            for(var i$4 = runIdx + 1; i$4 < levelRuns.length; i$4++)if (levelRuns[i$4]._start === pdiIndex) {
                                seqRuns.push(currentRun = levelRuns[i$4]);
                                break;
                            }
                        }
                        // build flat list of indices across all runs:
                        var seqIndices = [];
                        for(var i$5 = 0; i$5 < seqRuns.length; i$5++){
                            var run$1 = seqRuns[i$5];
                            for(var j = run$1._start; j <= run$1._end; j++)seqIndices.push(j);
                        }
                        // determine the sos/eos types:
                        var firstLevel = embedLevels[seqIndices[0]];
                        var prevLevel = paragraph.level;
                        for(var i$6 = seqIndices[0] - 1; i$6 >= 0; i$6--)if (!(charTypes[i$6] & BN_LIKE_TYPES)) {
                            prevLevel = embedLevels[i$6];
                            break;
                        }
                        var lastIndex = seqIndices[seqIndices.length - 1];
                        var lastLevel = embedLevels[lastIndex];
                        var nextLevel = paragraph.level;
                        if (!(charTypes[lastIndex] & ISOLATE_INIT_TYPES)) {
                            for(var i$7 = lastIndex + 1; i$7 <= paragraph.end; i$7++)if (!(charTypes[i$7] & BN_LIKE_TYPES)) {
                                nextLevel = embedLevels[i$7];
                                break;
                            }
                        }
                        isolatingRunSeqs.push({
                            _seqIndices: seqIndices,
                            _sosType: Math.max(prevLevel, firstLevel) % 2 ? TYPE_R : TYPE_L,
                            _eosType: Math.max(nextLevel, lastLevel) % 2 ? TYPE_R : TYPE_L
                        });
                    }
                }
                // The next steps are done per isolating run sequence
                for(var seqIdx = 0; seqIdx < isolatingRunSeqs.length; seqIdx++){
                    var ref = isolatingRunSeqs[seqIdx];
                    var seqIndices$1 = ref._seqIndices;
                    var sosType = ref._sosType;
                    var eosType = ref._eosType;
                    /**
         * All the level runs in an isolating run sequence have the same embedding level.
         * 
         * DO NOT change any `embedLevels[i]` within the current scope.
         */ var embedDirection = embedLevels[seqIndices$1[0]] & 1 ? TYPE_R : TYPE_L;
                    // === 3.3.4 Resolving Weak Types ===
                    // W1 + 5.2. Search backward from each NSM to the first character in the isolating run sequence whose
                    // bidirectional type is not BN, and set the NSM to ON if it is an isolate initiator or PDI, and to its
                    // type otherwise. If the NSM is the first non-BN character, change the NSM to the type of sos.
                    if (charTypeCounts.get(TYPE_NSM)) for(var si = 0; si < seqIndices$1.length; si++){
                        var i$8 = seqIndices$1[si];
                        if (charTypes[i$8] & TYPE_NSM) {
                            var prevType = sosType;
                            for(var sj = si - 1; sj >= 0; sj--)if (!(charTypes[seqIndices$1[sj]] & BN_LIKE_TYPES)) {
                                prevType = charTypes[seqIndices$1[sj]];
                                break;
                            }
                            changeCharType(i$8, prevType & (ISOLATE_INIT_TYPES | TYPE_PDI) ? TYPE_ON : prevType);
                        }
                    }
                    // W2. Search backward from each instance of a European number until the first strong type (R, L, AL, or sos)
                    // is found. If an AL is found, change the type of the European number to Arabic number.
                    if (charTypeCounts.get(TYPE_EN)) for(var si$1 = 0; si$1 < seqIndices$1.length; si$1++){
                        var i$9 = seqIndices$1[si$1];
                        if (charTypes[i$9] & TYPE_EN) for(var sj$1 = si$1 - 1; sj$1 >= -1; sj$1--){
                            var prevCharType = sj$1 === -1 ? sosType : charTypes[seqIndices$1[sj$1]];
                            if (prevCharType & STRONG_TYPES) {
                                if (prevCharType === TYPE_AL) changeCharType(i$9, TYPE_AN);
                                break;
                            }
                        }
                    }
                    // W3. Change all ALs to R
                    if (charTypeCounts.get(TYPE_AL)) for(var si$2 = 0; si$2 < seqIndices$1.length; si$2++){
                        var i$10 = seqIndices$1[si$2];
                        if (charTypes[i$10] & TYPE_AL) changeCharType(i$10, TYPE_R);
                    }
                    // W4. A single European separator between two European numbers changes to a European number. A single common
                    // separator between two numbers of the same type changes to that type.
                    if (charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) for(var si$3 = 1; si$3 < seqIndices$1.length - 1; si$3++){
                        var i$11 = seqIndices$1[si$3];
                        if (charTypes[i$11] & (TYPE_ES | TYPE_CS)) {
                            var prevType$1 = 0, nextType = 0;
                            for(var sj$2 = si$3 - 1; sj$2 >= 0; sj$2--){
                                prevType$1 = charTypes[seqIndices$1[sj$2]];
                                if (!(prevType$1 & BN_LIKE_TYPES)) break;
                            }
                            for(var sj$3 = si$3 + 1; sj$3 < seqIndices$1.length; sj$3++){
                                nextType = charTypes[seqIndices$1[sj$3]];
                                if (!(nextType & BN_LIKE_TYPES)) break;
                            }
                            if (prevType$1 === nextType && (charTypes[i$11] === TYPE_ES ? prevType$1 === TYPE_EN : prevType$1 & (TYPE_EN | TYPE_AN))) changeCharType(i$11, prevType$1);
                        }
                    }
                    // W5. A sequence of European terminators adjacent to European numbers changes to all European numbers.
                    if (charTypeCounts.get(TYPE_EN)) for(var si$4 = 0; si$4 < seqIndices$1.length; si$4++){
                        var i$12 = seqIndices$1[si$4];
                        if (charTypes[i$12] & TYPE_EN) {
                            for(var sj$4 = si$4 - 1; sj$4 >= 0 && charTypes[seqIndices$1[sj$4]] & (TYPE_ET | BN_LIKE_TYPES); sj$4--)changeCharType(seqIndices$1[sj$4], TYPE_EN);
                            for(si$4++; si$4 < seqIndices$1.length && charTypes[seqIndices$1[si$4]] & (TYPE_ET | BN_LIKE_TYPES | TYPE_EN); si$4++)if (charTypes[seqIndices$1[si$4]] !== TYPE_EN) changeCharType(seqIndices$1[si$4], TYPE_EN);
                        }
                    }
                    // W6. Otherwise, separators and terminators change to Other Neutral.
                    if (charTypeCounts.get(TYPE_ET) || charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) for(var si$5 = 0; si$5 < seqIndices$1.length; si$5++){
                        var i$13 = seqIndices$1[si$5];
                        if (charTypes[i$13] & (TYPE_ET | TYPE_ES | TYPE_CS)) {
                            changeCharType(i$13, TYPE_ON);
                            // 5.2 transform adjacent BNs too:
                            for(var sj$5 = si$5 - 1; sj$5 >= 0 && charTypes[seqIndices$1[sj$5]] & BN_LIKE_TYPES; sj$5--)changeCharType(seqIndices$1[sj$5], TYPE_ON);
                            for(var sj$6 = si$5 + 1; sj$6 < seqIndices$1.length && charTypes[seqIndices$1[sj$6]] & BN_LIKE_TYPES; sj$6++)changeCharType(seqIndices$1[sj$6], TYPE_ON);
                        }
                    }
                    // W7. Search backward from each instance of a European number until the first strong type (R, L, or sos)
                    // is found. If an L is found, then change the type of the European number to L.
                    // NOTE: implemented in single forward pass for efficiency
                    if (charTypeCounts.get(TYPE_EN)) for(var si$6 = 0, prevStrongType = sosType; si$6 < seqIndices$1.length; si$6++){
                        var i$14 = seqIndices$1[si$6];
                        var type = charTypes[i$14];
                        if (type & TYPE_EN) {
                            if (prevStrongType === TYPE_L) changeCharType(i$14, TYPE_L);
                        } else if (type & STRONG_TYPES) prevStrongType = type;
                    }
                    // === 3.3.5 Resolving Neutral and Isolate Formatting Types ===
                    if (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES)) {
                        // N0. Process bracket pairs in an isolating run sequence sequentially in the logical order of the text
                        // positions of the opening paired brackets using the logic given below. Within this scope, bidirectional
                        // types EN and AN are treated as R.
                        var R_TYPES_FOR_N_STEPS = TYPE_R | TYPE_EN | TYPE_AN;
                        var STRONG_TYPES_FOR_N_STEPS = R_TYPES_FOR_N_STEPS | TYPE_L;
                        // * Identify the bracket pairs in the current isolating run sequence according to BD16.
                        var bracketPairs = [];
                        var openerStack = [];
                        for(var si$7 = 0; si$7 < seqIndices$1.length; si$7++)// NOTE: for any potential bracket character we also test that it still carries a NI
                        // type, as that may have been changed earlier. This doesn't seem to be explicitly
                        // called out in the spec, but is required for passage of certain tests.
                        if (charTypes[seqIndices$1[si$7]] & NEUTRAL_ISOLATE_TYPES) {
                            var char = string[seqIndices$1[si$7]];
                            var oppositeBracket = void 0;
                            // Opening bracket
                            if (openingToClosingBracket(char) !== null) {
                                if (openerStack.length < 63) openerStack.push({
                                    char: char,
                                    seqIndex: si$7
                                });
                                else break;
                            } else if ((oppositeBracket = closingToOpeningBracket(char)) !== null) for(var stackIdx = openerStack.length - 1; stackIdx >= 0; stackIdx--){
                                var stackChar = openerStack[stackIdx].char;
                                if (stackChar === oppositeBracket || stackChar === closingToOpeningBracket(getCanonicalBracket(char)) || openingToClosingBracket(getCanonicalBracket(stackChar)) === char) {
                                    bracketPairs.push([
                                        openerStack[stackIdx].seqIndex,
                                        si$7
                                    ]);
                                    openerStack.length = stackIdx; //pop the matching bracket and all following
                                    break;
                                }
                            }
                        }
                        bracketPairs.sort(function(a, b) {
                            return a[0] - b[0];
                        });
                        // * For each bracket-pair element in the list of pairs of text positions
                        for(var pairIdx = 0; pairIdx < bracketPairs.length; pairIdx++){
                            var ref$1 = bracketPairs[pairIdx];
                            var openSeqIdx = ref$1[0];
                            var closeSeqIdx = ref$1[1];
                            // a. Inspect the bidirectional types of the characters enclosed within the bracket pair.
                            // b. If any strong type (either L or R) matching the embedding direction is found, set the type for both
                            // brackets in the pair to match the embedding direction.
                            var foundStrongType = false;
                            var useStrongType = 0;
                            for(var si$8 = openSeqIdx + 1; si$8 < closeSeqIdx; si$8++){
                                var i$15 = seqIndices$1[si$8];
                                if (charTypes[i$15] & STRONG_TYPES_FOR_N_STEPS) {
                                    foundStrongType = true;
                                    var lr = charTypes[i$15] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                    if (lr === embedDirection) {
                                        useStrongType = lr;
                                        break;
                                    }
                                }
                            }
                            // c. Otherwise, if there is a strong type it must be opposite the embedding direction. Therefore, test
                            // for an established context with a preceding strong type by checking backwards before the opening paired
                            // bracket until the first strong type (L, R, or sos) is found.
                            //    1. If the preceding strong type is also opposite the embedding direction, context is established, so
                            //    set the type for both brackets in the pair to that direction.
                            //    2. Otherwise set the type for both brackets in the pair to the embedding direction.
                            if (foundStrongType && !useStrongType) {
                                useStrongType = sosType;
                                for(var si$9 = openSeqIdx - 1; si$9 >= 0; si$9--){
                                    var i$16 = seqIndices$1[si$9];
                                    if (charTypes[i$16] & STRONG_TYPES_FOR_N_STEPS) {
                                        var lr$1 = charTypes[i$16] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                        if (lr$1 !== embedDirection) useStrongType = lr$1;
                                        else useStrongType = embedDirection;
                                        break;
                                    }
                                }
                            }
                            if (useStrongType) {
                                charTypes[seqIndices$1[openSeqIdx]] = charTypes[seqIndices$1[closeSeqIdx]] = useStrongType;
                                // * Any number of characters that had original bidirectional character type NSM prior to the application
                                // of W1 that immediately follow a paired bracket which changed to L or R under N0 should change to match
                                // the type of their preceding bracket.
                                if (useStrongType !== embedDirection) {
                                    for(var si$10 = openSeqIdx + 1; si$10 < seqIndices$1.length; si$10++)if (!(charTypes[seqIndices$1[si$10]] & BN_LIKE_TYPES)) {
                                        if (getBidiCharType(string[seqIndices$1[si$10]]) & TYPE_NSM) charTypes[seqIndices$1[si$10]] = useStrongType;
                                        break;
                                    }
                                }
                                if (useStrongType !== embedDirection) {
                                    for(var si$11 = closeSeqIdx + 1; si$11 < seqIndices$1.length; si$11++)if (!(charTypes[seqIndices$1[si$11]] & BN_LIKE_TYPES)) {
                                        if (getBidiCharType(string[seqIndices$1[si$11]]) & TYPE_NSM) charTypes[seqIndices$1[si$11]] = useStrongType;
                                        break;
                                    }
                                }
                            }
                        }
                        // N1. A sequence of NIs takes the direction of the surrounding strong text if the text on both sides has the
                        // same direction.
                        // N2. Any remaining NIs take the embedding direction.
                        for(var si$12 = 0; si$12 < seqIndices$1.length; si$12++)if (charTypes[seqIndices$1[si$12]] & NEUTRAL_ISOLATE_TYPES) {
                            var niRunStart = si$12, niRunEnd = si$12;
                            var prevType$2 = sosType; //si === 0 ? sosType : (charTypes[seqIndices[si - 1]] & R_TYPES_FOR_N_STEPS) ? TYPE_R : TYPE_L
                            for(var si2 = si$12 - 1; si2 >= 0; si2--)if (charTypes[seqIndices$1[si2]] & BN_LIKE_TYPES) niRunStart = si2; //5.2 treat BNs adjacent to NIs as NIs
                            else {
                                prevType$2 = charTypes[seqIndices$1[si2]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                break;
                            }
                            var nextType$1 = eosType;
                            for(var si2$1 = si$12 + 1; si2$1 < seqIndices$1.length; si2$1++)if (charTypes[seqIndices$1[si2$1]] & (NEUTRAL_ISOLATE_TYPES | BN_LIKE_TYPES)) niRunEnd = si2$1;
                            else {
                                nextType$1 = charTypes[seqIndices$1[si2$1]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                break;
                            }
                            for(var sj$7 = niRunStart; sj$7 <= niRunEnd; sj$7++)charTypes[seqIndices$1[sj$7]] = prevType$2 === nextType$1 ? prevType$2 : embedDirection;
                            si$12 = niRunEnd;
                        }
                    }
                }
                // === 3.3.6 Resolving Implicit Levels ===
                for(var i$17 = paragraph.start; i$17 <= paragraph.end; i$17++){
                    var level$3 = embedLevels[i$17];
                    var type$1 = charTypes[i$17];
                    // I2. For all characters with an odd (right-to-left) embedding level, those of type L, EN or AN go up one level.
                    if (level$3 & 1) {
                        if (type$1 & (TYPE_L | TYPE_EN | TYPE_AN)) embedLevels[i$17]++;
                    } else {
                        if (type$1 & TYPE_R) embedLevels[i$17]++;
                        else if (type$1 & (TYPE_AN | TYPE_EN)) embedLevels[i$17] += 2;
                    }
                    // 5.2: Resolve any LRE, RLE, LRO, RLO, PDF, or BN to the level of the preceding character if there is one,
                    // and otherwise to the base level.
                    if (type$1 & BN_LIKE_TYPES) embedLevels[i$17] = i$17 === 0 ? paragraph.level : embedLevels[i$17 - 1];
                    // 3.4 L1.1-4: Reset the embedding level of segment/paragraph separators, and any sequence of whitespace or
                    // isolate formatting characters preceding them or the end of the paragraph, to the paragraph level.
                    // NOTE: this will also need to be applied to each individual line ending after line wrapping occurs.
                    if (i$17 === paragraph.end || getBidiCharType(string[i$17]) & (TYPE_S | TYPE_B)) for(var j$1 = i$17; j$1 >= 0 && getBidiCharType(string[j$1]) & TRAILING_TYPES; j$1--)embedLevels[j$1] = paragraph.level;
                }
            }
            // DONE! The resolved levels can then be used, after line wrapping, to flip runs of characters
            // according to section 3.4 Reordering Resolved Levels
            return {
                levels: embedLevels,
                paragraphs: paragraphs
            };
            function determineAutoEmbedLevel(start, isFSI) {
                // 3.3.1 P2 - P3
                for(var i = start; i < string.length; i++){
                    var charType = charTypes[i];
                    if (charType & (TYPE_R | TYPE_AL)) return 1;
                    if (charType & (TYPE_B | TYPE_L) || isFSI && charType === TYPE_PDI) return 0;
                    if (charType & ISOLATE_INIT_TYPES) {
                        var pdi = indexOfMatchingPDI(i);
                        i = pdi === -1 ? string.length : pdi;
                    }
                }
                return 0;
            }
            function indexOfMatchingPDI(isolateStart) {
                // 3.1.2 BD9
                var isolationLevel = 1;
                for(var i = isolateStart + 1; i < string.length; i++){
                    var charType = charTypes[i];
                    if (charType & TYPE_B) break;
                    if (charType & TYPE_PDI) {
                        if (--isolationLevel === 0) return i;
                    } else if (charType & ISOLATE_INIT_TYPES) isolationLevel++;
                }
                return -1;
            }
        }
        // Bidi mirrored chars data, auto generated
        var data = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1";
        var mirrorMap;
        function parse() {
            if (!mirrorMap) {
                //const start = performance.now()
                var ref = parseCharacterMap(data, true);
                var map = ref.map;
                var reverseMap = ref.reverseMap;
                // Combine both maps into one
                reverseMap.forEach(function(value, key) {
                    map.set(key, value);
                });
                mirrorMap = map;
            //console.log(`mirrored chars parsed in ${performance.now() - start}ms`)
            }
        }
        function getMirroredCharacter(char) {
            parse();
            return mirrorMap.get(char) || null;
        }
        /**
   * Given a string and its resolved embedding levels, build a map of indices to replacement chars
   * for any characters in right-to-left segments that have defined mirrored characters.
   * @param string
   * @param embeddingLevels
   * @param [start]
   * @param [end]
   * @return {Map<number, string>}
   */ function getMirroredCharactersMap(string, embeddingLevels, start, end) {
            var strLen = string.length;
            start = Math.max(0, start == null ? 0 : +start);
            end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
            var map = new Map();
            for(var i = start; i <= end; i++)if (embeddingLevels[i] & 1) {
                var mirror = getMirroredCharacter(string[i]);
                if (mirror !== null) map.set(i, mirror);
            }
            return map;
        }
        /**
   * Given a start and end denoting a single line within a string, and a set of precalculated
   * bidi embedding levels, produce a list of segments whose ordering should be flipped, in sequence.
   * @param {string} string - the full input string
   * @param {GetEmbeddingLevelsResult} embeddingLevelsResult - the result object from getEmbeddingLevels
   * @param {number} [start] - first character in a subset of the full string
   * @param {number} [end] - last character in a subset of the full string
   * @return {number[][]} - the list of start/end segments that should be flipped, in order.
   */ function getReorderSegments(string, embeddingLevelsResult, start, end) {
            var strLen = string.length;
            start = Math.max(0, start == null ? 0 : +start);
            end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
            var segments = [];
            embeddingLevelsResult.paragraphs.forEach(function(paragraph) {
                var lineStart = Math.max(start, paragraph.start);
                var lineEnd = Math.min(end, paragraph.end);
                if (lineStart < lineEnd) {
                    // Local slice for mutation
                    var lineLevels = embeddingLevelsResult.levels.slice(lineStart, lineEnd + 1);
                    // 3.4 L1.4: Reset any sequence of whitespace characters and/or isolate formatting characters at the
                    // end of the line to the paragraph level.
                    for(var i = lineEnd; i >= lineStart && getBidiCharType(string[i]) & TRAILING_TYPES; i--)lineLevels[i] = paragraph.level;
                    // L2. From the highest level found in the text to the lowest odd level on each line, including intermediate levels
                    // not actually present in the text, reverse any contiguous sequence of characters that are at that level or higher.
                    var maxLevel = paragraph.level;
                    var minOddLevel = Infinity;
                    for(var i$1 = 0; i$1 < lineLevels.length; i$1++){
                        var level = lineLevels[i$1];
                        if (level > maxLevel) maxLevel = level;
                        if (level < minOddLevel) minOddLevel = level | 1;
                    }
                    for(var lvl = maxLevel; lvl >= minOddLevel; lvl--){
                        for(var i$2 = 0; i$2 < lineLevels.length; i$2++)if (lineLevels[i$2] >= lvl) {
                            var segStart = i$2;
                            while(i$2 + 1 < lineLevels.length && lineLevels[i$2 + 1] >= lvl)i$2++;
                            if (i$2 > segStart) segments.push([
                                segStart + lineStart,
                                i$2 + lineStart
                            ]);
                        }
                    }
                }
            });
            return segments;
        }
        /**
   * @param {string} string
   * @param {GetEmbeddingLevelsResult} embedLevelsResult
   * @param {number} [start]
   * @param {number} [end]
   * @return {string} the new string with bidi segments reordered
   */ function getReorderedString(string, embedLevelsResult, start, end) {
            var indices = getReorderedIndices(string, embedLevelsResult, start, end);
            var chars = [].concat(string);
            indices.forEach(function(charIndex, i) {
                chars[i] = (embedLevelsResult.levels[charIndex] & 1 ? getMirroredCharacter(string[charIndex]) : null) || string[charIndex];
            });
            return chars.join('');
        }
        /**
   * @param {string} string
   * @param {GetEmbeddingLevelsResult} embedLevelsResult
   * @param {number} [start]
   * @param {number} [end]
   * @return {number[]} an array with character indices in their new bidi order
   */ function getReorderedIndices(string, embedLevelsResult, start, end) {
            var segments = getReorderSegments(string, embedLevelsResult, start, end);
            // Fill an array with indices
            var indices = [];
            for(var i = 0; i < string.length; i++)indices[i] = i;
            // Reverse each segment in order
            segments.forEach(function(ref) {
                var start = ref[0];
                var end = ref[1];
                var slice = indices.slice(start, end + 1);
                for(var i = slice.length; i--;)indices[end - i] = slice[i];
            });
            return indices;
        }
        exports.closingToOpeningBracket = closingToOpeningBracket;
        exports.getBidiCharType = getBidiCharType;
        exports.getBidiCharTypeName = getBidiCharTypeName;
        exports.getCanonicalBracket = getCanonicalBracket;
        exports.getEmbeddingLevels = getEmbeddingLevels;
        exports.getMirroredCharacter = getMirroredCharacter;
        exports.getMirroredCharactersMap = getMirroredCharactersMap;
        exports.getReorderSegments = getReorderSegments;
        exports.getReorderedIndices = getReorderedIndices;
        exports.getReorderedString = getReorderedString;
        exports.openingToClosingBracket = openingToClosingBracket;
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        return exports;
    }({});
    return bidi;
}
var $39f838faf692eed9$export$2e2bcd8739ae039 = $39f838faf692eed9$var$bidiFactory;



/**
 * Regular expression for matching the `void main() {` opener line in GLSL.
 * @type {RegExp}
 */ const $3280116647888dc9$export$f402b5c74ecf5e1e = /\bvoid\s+main\s*\(\s*\)\s*{/g;
/**
 * Recursively expands all `#include <xyz>` statements within string of shader code.
 * Copied from three's WebGLProgram#parseIncludes for external use.
 *
 * @param {string} source - The GLSL source code to evaluate
 * @return {string} The GLSL code with all includes expanded
 */ function $3280116647888dc9$export$bec7143e67d6a2ef(source) {
    const pattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
    function replace(match, include) {
        let chunk = (0, $d5b33d7c30034067$export$955f9f2e84c43c8b)[include];
        return chunk ? $3280116647888dc9$export$bec7143e67d6a2ef(chunk) : match;
    }
    return source.replace(pattern, replace);
}
/*
 * This is a direct copy of MathUtils.generateUUID from Three.js, to preserve compatibility with three
 * versions before 0.113.0 as it was changed from Math to MathUtils in that version.
 * https://github.com/mrdoob/three.js/blob/dd8b5aa3b270c17096b90945cd2d6d1b13aaec53/src/math/MathUtils.js#L16
 */ const $3280116647888dc9$var$_lut = [];
for(let i = 0; i < 256; i++)$3280116647888dc9$var$_lut[i] = (i < 16 ? '0' : '') + i.toString(16);
function $3280116647888dc9$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $3280116647888dc9$var$_lut[d0 & 0xff] + $3280116647888dc9$var$_lut[d0 >> 8 & 0xff] + $3280116647888dc9$var$_lut[d0 >> 16 & 0xff] + $3280116647888dc9$var$_lut[d0 >> 24 & 0xff] + '-' + $3280116647888dc9$var$_lut[d1 & 0xff] + $3280116647888dc9$var$_lut[d1 >> 8 & 0xff] + '-' + $3280116647888dc9$var$_lut[d1 >> 16 & 0x0f | 0x40] + $3280116647888dc9$var$_lut[d1 >> 24 & 0xff] + '-' + $3280116647888dc9$var$_lut[d2 & 0x3f | 0x80] + $3280116647888dc9$var$_lut[d2 >> 8 & 0xff] + '-' + $3280116647888dc9$var$_lut[d2 >> 16 & 0xff] + $3280116647888dc9$var$_lut[d2 >> 24 & 0xff] + $3280116647888dc9$var$_lut[d3 & 0xff] + $3280116647888dc9$var$_lut[d3 >> 8 & 0xff] + $3280116647888dc9$var$_lut[d3 >> 16 & 0xff] + $3280116647888dc9$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
// Local assign polyfill to avoid importing troika-core
const $3280116647888dc9$var$assign = Object.assign || function() {
    let target = arguments[0];
    for(let i = 1, len = arguments.length; i < len; i++){
        let source = arguments[i];
        if (source) {
            for(let prop in source)if (Object.prototype.hasOwnProperty.call(source, prop)) target[prop] = source[prop];
        }
    }
    return target;
};
const $3280116647888dc9$var$epoch = Date.now();
const $3280116647888dc9$var$CONSTRUCTOR_CACHE = new WeakMap();
const $3280116647888dc9$var$SHADER_UPGRADE_CACHE = new Map();
// Material ids must be integers, but we can't access the increment from Three's `Material` module,
// so let's choose a sufficiently large starting value that should theoretically never collide.
let $3280116647888dc9$var$materialInstanceId = 1e10;
/**
 * A utility for creating a custom shader material derived from another material's
 * shaders. This allows you to inject custom shader logic and transforms into the
 * builtin ThreeJS materials without having to recreate them from scratch.
 *
 * @param {THREE.Material} baseMaterial - the original material to derive from
 *
 * @param {Object} options - How the base material should be modified.
 * @param {Object} options.defines - Custom `defines` for the material
 * @param {Object} options.extensions - Custom `extensions` for the material, e.g. `{derivatives: true}`
 * @param {Object} options.uniforms - Custom `uniforms` for use in the modified shader. These can
 *        be accessed and manipulated via the resulting material's `uniforms` property, just like
 *        in a ShaderMaterial. You do not need to repeat the base material's own uniforms here.
 * @param {String} options.timeUniform - If specified, a uniform of this name will be injected into
 *        both shaders, and it will automatically be updated on each render frame with a number of
 *        elapsed milliseconds. The "zero" epoch time is not significant so don't rely on this as a
 *        true calendar time.
 * @param {String} options.vertexDefs - Custom GLSL code to inject into the vertex shader's top-level
 *        definitions, above the `void main()` function.
 * @param {String} options.vertexMainIntro - Custom GLSL code to inject at the top of the vertex
 *        shader's `void main` function.
 * @param {String} options.vertexMainOutro - Custom GLSL code to inject at the end of the vertex
 *        shader's `void main` function.
 * @param {String} options.vertexTransform - Custom GLSL code to manipulate the `position`, `normal`,
 *        and/or `uv` vertex attributes. This code will be wrapped within a standalone function with
 *        those attributes exposed by their normal names as read/write values.
 * @param {String} options.fragmentDefs - Custom GLSL code to inject into the fragment shader's top-level
 *        definitions, above the `void main()` function.
 * @param {String} options.fragmentMainIntro - Custom GLSL code to inject at the top of the fragment
 *        shader's `void main` function.
 * @param {String} options.fragmentMainOutro - Custom GLSL code to inject at the end of the fragment
 *        shader's `void main` function. You can manipulate `gl_FragColor` here but keep in mind it goes
 *        after any of ThreeJS's color postprocessing shader chunks (tonemapping, fog, etc.), so if you
 *        want those to apply to your changes use `fragmentColorTransform` instead.
 * @param {String} options.fragmentColorTransform - Custom GLSL code to manipulate the `gl_FragColor`
 *        output value. Will be injected near the end of the `void main` function, but before any
 *        of ThreeJS's color postprocessing shader chunks (tonemapping, fog, etc.), and before the
 *        `fragmentMainOutro`.
 * @param {function<{vertexShader,fragmentShader}>:{vertexShader,fragmentShader}} options.customRewriter - A function
 *        for performing custom rewrites of the full shader code. Useful if you need to do something
 *        special that's not covered by the other builtin options. This function will be executed before
 *        any other transforms are applied.
 * @param {boolean} options.chained - Set to `true` to prototype-chain the derived material to the base
 *        material, rather than the default behavior of copying it. This allows the derived material to
 *        automatically pick up changes made to the base material and its properties. This can be useful
 *        where the derived material is hidden from the user as an implementation detail, allowing them
 *        to work with the original material like normal. But it can result in unexpected behavior if not
 *        handled carefully.
 *
 * @return {THREE.Material}
 *
 * The returned material will also have two new methods, `getDepthMaterial()` and `getDistanceMaterial()`,
 * which can be called to get a variant of the derived material for use in shadow casting. If the
 * target mesh is expected to cast shadows, then you can assign these to the mesh's `customDepthMaterial`
 * (for directional and spot lights) and/or `customDistanceMaterial` (for point lights) properties to
 * allow the cast shadow to honor your derived shader's vertex transforms and discarded fragments. These
 * will also set a custom `#define IS_DEPTH_MATERIAL` or `#define IS_DISTANCE_MATERIAL` that you can look
 * for in your derived shaders with `#ifdef` to customize their behavior for the depth or distance
 * scenarios, e.g. skipping antialiasing or expensive shader logic.
 */ function $3280116647888dc9$export$9251ec91c7de57b5(baseMaterial, options) {
    // Generate a key that is unique to the content of these `options`. We'll use this
    // throughout for caching and for generating the upgraded shader code. This increases
    // the likelihood that the resulting shaders will line up across multiple calls so
    // their GL programs can be shared and cached.
    const optionsKey = $3280116647888dc9$var$getKeyForOptions(options);
    // First check to see if we've already derived from this baseMaterial using this
    // unique set of options, and if so reuse the constructor to avoid some allocations.
    let ctorsByDerivation = $3280116647888dc9$var$CONSTRUCTOR_CACHE.get(baseMaterial);
    if (!ctorsByDerivation) $3280116647888dc9$var$CONSTRUCTOR_CACHE.set(baseMaterial, ctorsByDerivation = Object.create(null));
    if (ctorsByDerivation[optionsKey]) return new ctorsByDerivation[optionsKey]();
    const privateBeforeCompileProp = `_onBeforeCompile${optionsKey}`;
    // Private onBeforeCompile handler that injects the modified shaders and uniforms when
    // the renderer switches to this material's program
    const onBeforeCompile = function(shaderInfo, renderer) {
        baseMaterial.onBeforeCompile.call(this, shaderInfo, renderer);
        // Upgrade the shaders, caching the result by incoming source code
        const cacheKey = this.customProgramCacheKey() + '|' + shaderInfo.vertexShader + '|' + shaderInfo.fragmentShader;
        let upgradedShaders = $3280116647888dc9$var$SHADER_UPGRADE_CACHE[cacheKey];
        if (!upgradedShaders) {
            const upgraded = $3280116647888dc9$var$upgradeShaders(this, shaderInfo, options, optionsKey);
            upgradedShaders = $3280116647888dc9$var$SHADER_UPGRADE_CACHE[cacheKey] = upgraded;
        }
        // Inject upgraded shaders and uniforms into the program
        shaderInfo.vertexShader = upgradedShaders.vertexShader;
        shaderInfo.fragmentShader = upgradedShaders.fragmentShader;
        $3280116647888dc9$var$assign(shaderInfo.uniforms, this.uniforms);
        // Inject auto-updating time uniform if requested
        if (options.timeUniform) shaderInfo.uniforms[options.timeUniform] = {
            get value () {
                return Date.now() - $3280116647888dc9$var$epoch;
            }
        };
        // Users can still add their own handlers on top of ours
        if (this[privateBeforeCompileProp]) this[privateBeforeCompileProp](shaderInfo);
    };
    const DerivedMaterial = function DerivedMaterial() {
        return derive(options.chained ? baseMaterial : baseMaterial.clone());
    };
    const derive = function(base) {
        // Prototype chain to the base material
        const derived = Object.create(base, descriptor);
        // Store the baseMaterial for reference; this is always the original even when cloning
        Object.defineProperty(derived, 'baseMaterial', {
            value: baseMaterial
        });
        // Needs its own ids
        Object.defineProperty(derived, 'id', {
            value: $3280116647888dc9$var$materialInstanceId++
        });
        derived.uuid = $3280116647888dc9$var$generateUUID();
        // Merge uniforms, defines, and extensions
        derived.uniforms = $3280116647888dc9$var$assign({}, base.uniforms, options.uniforms);
        derived.defines = $3280116647888dc9$var$assign({}, base.defines, options.defines);
        derived.defines[`TROIKA_DERIVED_MATERIAL_${optionsKey}`] = ''; //force a program change from the base material
        derived.extensions = $3280116647888dc9$var$assign({}, base.extensions, options.extensions);
        // Don't inherit EventDispatcher listeners
        derived._listeners = undefined;
        return derived;
    };
    const descriptor = {
        constructor: {
            value: DerivedMaterial
        },
        isDerivedMaterial: {
            value: true
        },
        customProgramCacheKey: {
            writable: true,
            configurable: true,
            value: function() {
                return baseMaterial.customProgramCacheKey() + '|' + optionsKey;
            }
        },
        onBeforeCompile: {
            get () {
                return onBeforeCompile;
            },
            set (fn) {
                this[privateBeforeCompileProp] = fn;
            }
        },
        copy: {
            writable: true,
            configurable: true,
            value: function(source) {
                baseMaterial.copy.call(this, source);
                if (!baseMaterial.isShaderMaterial && !baseMaterial.isDerivedMaterial) {
                    $3280116647888dc9$var$assign(this.extensions, source.extensions);
                    $3280116647888dc9$var$assign(this.defines, source.defines);
                    $3280116647888dc9$var$assign(this.uniforms, (0, $d5b33d7c30034067$export$d8ecdf8615bfea69).clone(source.uniforms));
                }
                return this;
            }
        },
        clone: {
            writable: true,
            configurable: true,
            value: function() {
                const newBase = new baseMaterial.constructor();
                return derive(newBase).copy(this);
            }
        },
        /**
     * Utility to get a MeshDepthMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */ getDepthMaterial: {
            writable: true,
            configurable: true,
            value: function() {
                let depthMaterial = this._depthMaterial;
                if (!depthMaterial) {
                    depthMaterial = this._depthMaterial = $3280116647888dc9$export$9251ec91c7de57b5(baseMaterial.isDerivedMaterial ? baseMaterial.getDepthMaterial() : new (0, $d5b33d7c30034067$export$2698c22ec13825db)({
                        depthPacking: (0, $d5b33d7c30034067$export$8f910f4c4f73df11)
                    }), options);
                    depthMaterial.defines.IS_DEPTH_MATERIAL = '';
                    depthMaterial.uniforms = this.uniforms; //automatically recieve same uniform values
                }
                return depthMaterial;
            }
        },
        /**
     * Utility to get a MeshDistanceMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */ getDistanceMaterial: {
            writable: true,
            configurable: true,
            value: function() {
                let distanceMaterial = this._distanceMaterial;
                if (!distanceMaterial) {
                    distanceMaterial = this._distanceMaterial = $3280116647888dc9$export$9251ec91c7de57b5(baseMaterial.isDerivedMaterial ? baseMaterial.getDistanceMaterial() : new (0, $d5b33d7c30034067$export$33e187ed002f2a19)(), options);
                    distanceMaterial.defines.IS_DISTANCE_MATERIAL = '';
                    distanceMaterial.uniforms = this.uniforms; //automatically recieve same uniform values
                }
                return distanceMaterial;
            }
        },
        dispose: {
            writable: true,
            configurable: true,
            value () {
                const { _depthMaterial: _depthMaterial, _distanceMaterial: _distanceMaterial } = this;
                if (_depthMaterial) _depthMaterial.dispose();
                if (_distanceMaterial) _distanceMaterial.dispose();
                baseMaterial.dispose.call(this);
            }
        }
    };
    ctorsByDerivation[optionsKey] = DerivedMaterial;
    return new DerivedMaterial();
}
function $3280116647888dc9$var$upgradeShaders(material, { vertexShader: vertexShader, fragmentShader: fragmentShader }, options, key) {
    let { vertexDefs: vertexDefs, vertexMainIntro: vertexMainIntro, vertexMainOutro: vertexMainOutro, vertexTransform: vertexTransform, fragmentDefs: fragmentDefs, fragmentMainIntro: fragmentMainIntro, fragmentMainOutro: fragmentMainOutro, fragmentColorTransform: fragmentColorTransform, customRewriter: customRewriter, timeUniform: timeUniform } = options;
    vertexDefs = vertexDefs || '';
    vertexMainIntro = vertexMainIntro || '';
    vertexMainOutro = vertexMainOutro || '';
    fragmentDefs = fragmentDefs || '';
    fragmentMainIntro = fragmentMainIntro || '';
    fragmentMainOutro = fragmentMainOutro || '';
    // Expand includes if needed
    if (vertexTransform || customRewriter) vertexShader = $3280116647888dc9$export$bec7143e67d6a2ef(vertexShader);
    if (fragmentColorTransform || customRewriter) {
        // We need to be able to find postprocessing chunks after include expansion in order to
        // put them after the fragmentColorTransform, so mark them with comments first. Even if
        // this particular derivation doesn't have a fragmentColorTransform, other derivations may,
        // so we still mark them.
        fragmentShader = fragmentShader.replace(/^[ \t]*#include <((?:tonemapping|encodings|fog|premultiplied_alpha|dithering)_fragment)>/gm, '\n//!BEGIN_POST_CHUNK $1\n$&\n//!END_POST_CHUNK\n');
        fragmentShader = $3280116647888dc9$export$bec7143e67d6a2ef(fragmentShader);
    }
    // Apply custom rewriter function
    if (customRewriter) {
        let res = customRewriter({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader
        });
        vertexShader = res.vertexShader;
        fragmentShader = res.fragmentShader;
    }
    // The fragmentColorTransform needs to go before any postprocessing chunks, so extract
    // those and re-insert them into the outro in the correct place:
    if (fragmentColorTransform) {
        let postChunks = [];
        fragmentShader = fragmentShader.replace(/^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm, (match)=>{
            postChunks.push(match);
            return '';
        });
        fragmentMainOutro = `${fragmentColorTransform}\n${postChunks.join('\n')}\n${fragmentMainOutro}`;
    }
    // Inject auto-updating time uniform if requested
    if (timeUniform) {
        const code = `\nuniform float ${timeUniform};\n`;
        vertexDefs = code + vertexDefs;
        fragmentDefs = code + fragmentDefs;
    }
    // Inject a function for the vertexTransform and rename all usages of position/normal/uv
    if (vertexTransform) {
        // Hoist these defs to the very top so they work in other function defs
        vertexShader = `vec3 troika_position_${key};
vec3 troika_normal_${key};
vec2 troika_uv_${key};
${vertexShader}
`;
        vertexDefs = `${vertexDefs}
void troikaVertexTransform${key}(inout vec3 position, inout vec3 normal, inout vec2 uv) {
  ${vertexTransform}
}
`;
        vertexMainIntro = `
troika_position_${key} = vec3(position);
troika_normal_${key} = vec3(normal);
troika_uv_${key} = vec2(uv);
troikaVertexTransform${key}(troika_position_${key}, troika_normal_${key}, troika_uv_${key});
${vertexMainIntro}
`;
        vertexShader = vertexShader.replace(/\b(position|normal|uv)\b/g, (match, match1, index, fullStr)=>{
            return /\battribute\s+vec[23]\s+$/.test(fullStr.substr(0, index)) ? match1 : `troika_${match1}_${key}`;
        });
        // Three r152 introduced the MAP_UV token, replace it too if it's pointing to the main 'uv'
        // Perhaps the other textures too going forward?
        if (!(material.map && material.map.channel > 0)) vertexShader = vertexShader.replace(/\bMAP_UV\b/g, `troika_uv_${key}`);
    }
    // Inject defs and intro/outro snippets
    vertexShader = $3280116647888dc9$var$injectIntoShaderCode(vertexShader, key, vertexDefs, vertexMainIntro, vertexMainOutro);
    fragmentShader = $3280116647888dc9$var$injectIntoShaderCode(fragmentShader, key, fragmentDefs, fragmentMainIntro, fragmentMainOutro);
    return {
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
    };
}
function $3280116647888dc9$var$injectIntoShaderCode(shaderCode, id, defs, intro, outro) {
    if (intro || outro || defs) {
        shaderCode = shaderCode.replace($3280116647888dc9$export$f402b5c74ecf5e1e, `
${defs}
void troikaOrigMain${id}() {`);
        shaderCode += `
void main() {
  ${intro}
  troikaOrigMain${id}();
  ${outro}
}`;
    }
    return shaderCode;
}
function $3280116647888dc9$var$optionsJsonReplacer(key, value) {
    return key === 'uniforms' ? undefined : typeof value === 'function' ? value.toString() : value;
}
let $3280116647888dc9$var$_idCtr = 0;
const $3280116647888dc9$var$optionsHashesToIds = new Map();
function $3280116647888dc9$var$getKeyForOptions(options) {
    const optionsHash = JSON.stringify(options, $3280116647888dc9$var$optionsJsonReplacer);
    let id = $3280116647888dc9$var$optionsHashesToIds.get(optionsHash);
    if (id == null) $3280116647888dc9$var$optionsHashesToIds.set(optionsHash, id = ++$3280116647888dc9$var$_idCtr);
    return id;
}
// Copied from threejs WebGLPrograms.js so we can resolve builtin materials to their shaders
// TODO how can we keep this from getting stale?
const $3280116647888dc9$var$MATERIAL_TYPES_TO_SHADERS = {
    MeshDepthMaterial: 'depth',
    MeshDistanceMaterial: 'distanceRGBA',
    MeshNormalMaterial: 'normal',
    MeshBasicMaterial: 'basic',
    MeshLambertMaterial: 'lambert',
    MeshPhongMaterial: 'phong',
    MeshToonMaterial: 'toon',
    MeshStandardMaterial: 'physical',
    MeshPhysicalMaterial: 'physical',
    MeshMatcapMaterial: 'matcap',
    LineBasicMaterial: 'basic',
    LineDashedMaterial: 'dashed',
    PointsMaterial: 'points',
    ShadowMaterial: 'shadow',
    SpriteMaterial: 'sprite'
};
/**
 * Given a Three.js `Material` instance, find the shaders/uniforms that will be
 * used to render that material.
 *
 * @param material - the Material instance
 * @return {object} - the material's shader info: `{uniforms:{}, fragmentShader:'', vertexShader:''}`
 */ function $3280116647888dc9$export$45b4115c5d90bd21(material) {
    let builtinType = $3280116647888dc9$var$MATERIAL_TYPES_TO_SHADERS[material.type];
    return builtinType ? (0, $d5b33d7c30034067$export$bee4a7d47f8f5014)[builtinType] : material //TODO fallback for unknown type?
    ;
}
/**
 * Find all uniforms and their types within a shader code string.
 *
 * @param {string} shader - The shader code to parse
 * @return {object} mapping of uniform names to their glsl type
 */ function $3280116647888dc9$export$c7d2dd72fdbc2421(shader) {
    let uniformRE = /\buniform\s+(int|float|vec[234]|mat[34])\s+([A-Za-z_][\w]*)/g;
    let uniforms = Object.create(null);
    let match;
    while((match = uniformRE.exec(shader)) !== null)uniforms[match[2]] = match[1];
    return uniforms;
}
/**
 * Helper for smoothing out the `m.getInverse(x)` --> `m.copy(x).invert()` conversion
 * that happened in ThreeJS r123.
 * @param {Matrix4} srcMatrix
 * @param {Matrix4} [tgtMatrix]
 */ function $3280116647888dc9$export$3425937be2407bfa(srcMatrix, tgtMatrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)()) {
    if (typeof tgtMatrix.invert === 'function') tgtMatrix.copy(srcMatrix).invert();
    else tgtMatrix.getInverse(srcMatrix);
    return tgtMatrix;
}
/*
Input geometry is a cylinder with r=1, height in y dimension from 0 to 1,
divided into a reasonable number of height segments.
*/ const $3280116647888dc9$var$vertexDefs = `
uniform vec3 pointA;
uniform vec3 controlA;
uniform vec3 controlB;
uniform vec3 pointB;
uniform float radius;
varying float bezierT;

vec3 cubicBezier(vec3 p1, vec3 c1, vec3 c2, vec3 p2, float t) {
  float t2 = 1.0 - t;
  float b0 = t2 * t2 * t2;
  float b1 = 3.0 * t * t2 * t2;
  float b2 = 3.0 * t * t * t2;
  float b3 = t * t * t;
  return b0 * p1 + b1 * c1 + b2 * c2 + b3 * p2;
}

vec3 cubicBezierDerivative(vec3 p1, vec3 c1, vec3 c2, vec3 p2, float t) {
  float t2 = 1.0 - t;
  return -3.0 * p1 * t2 * t2 +
    c1 * (3.0 * t2 * t2 - 6.0 * t2 * t) +
    c2 * (6.0 * t2 * t - 3.0 * t * t) +
    3.0 * p2 * t * t;
}
`;
const $3280116647888dc9$var$vertexTransform = `
float t = position.y;
bezierT = t;
vec3 bezierCenterPos = cubicBezier(pointA, controlA, controlB, pointB, t);
vec3 bezierDir = normalize(cubicBezierDerivative(pointA, controlA, controlB, pointB, t));

// Make "sideways" always perpendicular to the camera ray; this ensures that any twists
// in the cylinder occur where you won't see them: 
vec3 viewDirection = normalMatrix * vec3(0.0, 0.0, 1.0);
if (bezierDir == viewDirection) {
  bezierDir = normalize(cubicBezierDerivative(pointA, controlA, controlB, pointB, t == 1.0 ? t - 0.0001 : t + 0.0001));
}
vec3 sideways = normalize(cross(bezierDir, viewDirection));
vec3 upish = normalize(cross(sideways, bezierDir));

// Build a matrix for transforming this disc in the cylinder:
mat4 discTx;
discTx[0].xyz = sideways * radius;
discTx[1].xyz = bezierDir * radius;
discTx[2].xyz = upish * radius;
discTx[3].xyz = bezierCenterPos;
discTx[3][3] = 1.0;

// Apply transform, ignoring original y
position = (discTx * vec4(position.x, 0.0, position.z, 1.0)).xyz;
normal = normalize(mat3(discTx) * normal);
`;
const $3280116647888dc9$var$fragmentDefs = `
uniform vec3 dashing;
varying float bezierT;
`;
const $3280116647888dc9$var$fragmentMainIntro = `
if (dashing.x + dashing.y > 0.0) {
  float dashFrac = mod(bezierT - dashing.z, dashing.x + dashing.y);
  if (dashFrac > dashing.x) {
    discard;
  }
}
`;
// Debugging: separate color for each of the 6 sides:
// const fragmentColorTransform = `
// float sideNum = floor(vUV.x * 6.0);
// vec3 mixColor = sideNum < 1.0 ? vec3(1.0, 0.0, 0.0) :
//   sideNum < 2.0 ? vec3(0.0, 1.0, 1.0) :
//   sideNum < 3.0 ? vec3(1.0, 1.0, 0.0) :
//   sideNum < 4.0 ? vec3(0.0, 0.0, 1.0) :
//   sideNum < 5.0 ? vec3(0.0, 1.0, 0.0) :
//   vec3(1.0, 0.0, 1.0);
// gl_FragColor.xyz = mix(gl_FragColor.xyz, mixColor, 0.5);
// `
function $3280116647888dc9$var$createBezierMeshMaterial(baseMaterial) {
    return $3280116647888dc9$export$9251ec91c7de57b5(baseMaterial, {
        chained: true,
        uniforms: {
            pointA: {
                value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
            },
            controlA: {
                value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
            },
            controlB: {
                value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
            },
            pointB: {
                value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
            },
            radius: {
                value: 0.01
            },
            dashing: {
                value: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
            } //on, off, offset
        },
        vertexDefs: $3280116647888dc9$var$vertexDefs,
        vertexTransform: $3280116647888dc9$var$vertexTransform,
        fragmentDefs: $3280116647888dc9$var$fragmentDefs,
        fragmentMainIntro: $3280116647888dc9$var$fragmentMainIntro
    });
}
let $3280116647888dc9$var$geometry = null;
const $3280116647888dc9$var$defaultBaseMaterial = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$f2980790215acccd)({
    color: 0xffffff,
    side: (0, $d5b33d7c30034067$export$3b296b6f144d5b03)
});
/**
 * A ThreeJS `Mesh` that bends a tube shape along a 3D cubic bezier path. The bending is done
 * by deforming a straight cylindrical geometry in the vertex shader based on a set of four
 * control point uniforms. It patches the necessary GLSL into the mesh's assigned `material`
 * automatically.
 *
 * The cubiz bezier path is determined by its four `Vector3` properties:
 * - `pointA`
 * - `controlA`
 * - `controlB`
 * - `pointB`
 *
 * The tube's radius is controlled by its `radius` property, which defaults to `0.01`.
 *
 * You can also give the tube a dashed appearance with two properties:
 *
 * - `dashArray` - an array of two numbers, defining the length of "on" and "off" parts of
 *   the dash. Each is a 0-1 ratio of the entire path's length. (Actually this is the `t` length
 *   used as input to the cubic bezier function, not its visible length.)
 * - `dashOffset` - offset of where the dash starts. You can animate this to make the dashes move.
 *
 * Note that the dashes will appear like a hollow tube, not solid. This will be more apparent on
 * thicker tubes.
 *
 * TODO: proper geometry bounding sphere and raycasting
 * TODO: allow control of the geometry's segment counts
 */ class $3280116647888dc9$export$5f27619f2db8836e extends (0, $d5b33d7c30034067$export$e176487c05830cc5) {
    static getGeometry() {
        return $3280116647888dc9$var$geometry || ($3280116647888dc9$var$geometry = new (0, $d5b33d7c30034067$export$68f745719dbe5198)(1, 1, 1, 6, 64).translate(0, 0.5, 0));
    }
    constructor(){
        super($3280116647888dc9$export$5f27619f2db8836e.getGeometry(), $3280116647888dc9$var$defaultBaseMaterial);
        this.pointA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this.controlA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this.controlB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this.pointB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this.radius = 0.01;
        this.dashArray = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this.dashOffset = 0;
        // TODO - disabling frustum culling until I figure out how to customize the
        //  geometry's bounding sphere that gets used
        this.frustumCulled = false;
    }
    // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
    // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
    get material() {
        let derivedMaterial = this._derivedMaterial;
        const baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $3280116647888dc9$var$defaultBaseMaterial.clone());
        if (!derivedMaterial || derivedMaterial.baseMaterial !== baseMaterial) {
            derivedMaterial = this._derivedMaterial = $3280116647888dc9$var$createBezierMeshMaterial(baseMaterial);
            // dispose the derived material when its base material is disposed:
            baseMaterial.addEventListener('dispose', function onDispose() {
                baseMaterial.removeEventListener('dispose', onDispose);
                derivedMaterial.dispose();
            });
        }
        return derivedMaterial;
    }
    set material(baseMaterial) {
        this._baseMaterial = baseMaterial;
    }
    // Create and update material for shadows upon request:
    get customDepthMaterial() {
        return this.material.getDepthMaterial();
    }
    get customDistanceMaterial() {
        return this.material.getDistanceMaterial();
    }
    onBeforeRender() {
        const { uniforms: uniforms } = this.material;
        const { pointA: pointA, controlA: controlA, controlB: controlB, pointB: pointB, radius: radius, dashArray: dashArray, dashOffset: dashOffset } = this;
        uniforms.pointA.value.copy(pointA);
        uniforms.controlA.value.copy(controlA);
        uniforms.controlB.value.copy(controlB);
        uniforms.pointB.value.copy(pointB);
        uniforms.radius.value = radius;
        uniforms.dashing.value.set(dashArray.x, dashArray.y, dashOffset || 0);
    }
    raycast() {
    // TODO - just fail for now
    }
}


/*!
Custom build of Typr.ts (https://github.com/fredli74/Typr.ts) for use in Troika text rendering.
Original MIT license applies: https://github.com/fredli74/Typr.ts/blob/master/LICENSE
*/ function $bc7831423112e56a$var$typrFactory() {
    return "undefined" == typeof window && (self.window = self), function(r) {
        var e = {
            parse: function(r) {
                var t = e._bin, a = new Uint8Array(r);
                if ("ttcf" == t.readASCII(a, 0, 4)) {
                    var n = 4;
                    t.readUshort(a, n), n += 2, t.readUshort(a, n), n += 2;
                    var o = t.readUint(a, n);
                    n += 4;
                    for(var s = [], i = 0; i < o; i++){
                        var h = t.readUint(a, n);
                        n += 4, s.push(e._readFont(a, h));
                    }
                    return s;
                }
                return [
                    e._readFont(a, 0)
                ];
            },
            _readFont: function(r, t) {
                var a = e._bin, n = t;
                a.readFixed(r, t), t += 4;
                var o = a.readUshort(r, t);
                t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2;
                for(var s = [
                    "cmap",
                    "head",
                    "hhea",
                    "maxp",
                    "hmtx",
                    "name",
                    "OS/2",
                    "post",
                    "loca",
                    "glyf",
                    "kern",
                    "CFF ",
                    "GDEF",
                    "GPOS",
                    "GSUB",
                    "SVG "
                ], i = {
                    _data: r,
                    _offset: n
                }, h = {}, d = 0; d < o; d++){
                    var f = a.readASCII(r, t, 4);
                    t += 4, a.readUint(r, t), t += 4;
                    var u = a.readUint(r, t);
                    t += 4;
                    var l = a.readUint(r, t);
                    t += 4, h[f] = {
                        offset: u,
                        length: l
                    };
                }
                for(d = 0; d < s.length; d++){
                    var v = s[d];
                    h[v] && (i[v.trim()] = e[v.trim()].parse(r, h[v].offset, h[v].length, i));
                }
                return i;
            },
            _tabOffset: function(r, t, a) {
                for(var n = e._bin, o = n.readUshort(r, a + 4), s = a + 12, i = 0; i < o; i++){
                    var h = n.readASCII(r, s, 4);
                    s += 4, n.readUint(r, s), s += 4;
                    var d = n.readUint(r, s);
                    if (s += 4, n.readUint(r, s), s += 4, h == t) return d;
                }
                return 0;
            }
        };
        e._bin = {
            readFixed: function(r, e) {
                return (r[e] << 8 | r[e + 1]) + (r[e + 2] << 8 | r[e + 3]) / 65540;
            },
            readF2dot14: function(r, t) {
                return e._bin.readShort(r, t) / 16384;
            },
            readInt: function(r, t) {
                return e._bin._view(r).getInt32(t);
            },
            readInt8: function(r, t) {
                return e._bin._view(r).getInt8(t);
            },
            readShort: function(r, t) {
                return e._bin._view(r).getInt16(t);
            },
            readUshort: function(r, t) {
                return e._bin._view(r).getUint16(t);
            },
            readUshorts: function(r, t, a) {
                for(var n = [], o = 0; o < a; o++)n.push(e._bin.readUshort(r, t + 2 * o));
                return n;
            },
            readUint: function(r, t) {
                return e._bin._view(r).getUint32(t);
            },
            readUint64: function(r, t) {
                return 4294967296 * e._bin.readUint(r, t) + e._bin.readUint(r, t + 4);
            },
            readASCII: function(r, e, t) {
                for(var a = "", n = 0; n < t; n++)a += String.fromCharCode(r[e + n]);
                return a;
            },
            readUnicode: function(r, e, t) {
                for(var a = "", n = 0; n < t; n++){
                    var o = r[e++] << 8 | r[e++];
                    a += String.fromCharCode(o);
                }
                return a;
            },
            _tdec: "undefined" != typeof window && window.TextDecoder ? new window.TextDecoder : null,
            readUTF8: function(r, t, a) {
                var n = e._bin._tdec;
                return n && 0 == t && a == r.length ? n.decode(r) : e._bin.readASCII(r, t, a);
            },
            readBytes: function(r, e, t) {
                for(var a = [], n = 0; n < t; n++)a.push(r[e + n]);
                return a;
            },
            readASCIIArray: function(r, e, t) {
                for(var a = [], n = 0; n < t; n++)a.push(String.fromCharCode(r[e + n]));
                return a;
            },
            _view: function(r) {
                return r._dataView || (r._dataView = r.buffer ? new DataView(r.buffer, r.byteOffset, r.byteLength) : new DataView(new Uint8Array(r).buffer));
            }
        }, e._lctf = {}, e._lctf.parse = function(r, t, a, n, o) {
            var s = e._bin, i = {}, h = t;
            s.readFixed(r, t), t += 4;
            var d = s.readUshort(r, t);
            t += 2;
            var f = s.readUshort(r, t);
            t += 2;
            var u = s.readUshort(r, t);
            return t += 2, i.scriptList = e._lctf.readScriptList(r, h + d), i.featureList = e._lctf.readFeatureList(r, h + f), i.lookupList = e._lctf.readLookupList(r, h + u, o), i;
        }, e._lctf.readLookupList = function(r, t, a) {
            var n = e._bin, o = t, s = [], i = n.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                var d = n.readUshort(r, t);
                t += 2;
                var f = e._lctf.readLookupTable(r, o + d, a);
                s.push(f);
            }
            return s;
        }, e._lctf.readLookupTable = function(r, t, a) {
            var n = e._bin, o = t, s = {
                tabs: []
            };
            s.ltype = n.readUshort(r, t), t += 2, s.flag = n.readUshort(r, t), t += 2;
            var i = n.readUshort(r, t);
            t += 2;
            for(var h = s.ltype, d = 0; d < i; d++){
                var f = n.readUshort(r, t);
                t += 2;
                var u = a(r, h, o + f, s);
                s.tabs.push(u);
            }
            return s;
        }, e._lctf.numOfOnes = function(r) {
            for(var e = 0, t = 0; t < 32; t++)0 != (r >>> t & 1) && e++;
            return e;
        }, e._lctf.readClassDef = function(r, t) {
            var a = e._bin, n = [], o = a.readUshort(r, t);
            if (t += 2, 1 == o) {
                var s = a.readUshort(r, t);
                t += 2;
                var i = a.readUshort(r, t);
                t += 2;
                for(var h = 0; h < i; h++)n.push(s + h), n.push(s + h), n.push(a.readUshort(r, t)), t += 2;
            }
            if (2 == o) {
                var d = a.readUshort(r, t);
                t += 2;
                for(h = 0; h < d; h++)n.push(a.readUshort(r, t)), t += 2, n.push(a.readUshort(r, t)), t += 2, n.push(a.readUshort(r, t)), t += 2;
            }
            return n;
        }, e._lctf.getInterval = function(r, e) {
            for(var t = 0; t < r.length; t += 3){
                var a = r[t], n = r[t + 1];
                if (r[t + 2], a <= e && e <= n) return t;
            }
            return -1;
        }, e._lctf.readCoverage = function(r, t) {
            var a = e._bin, n = {};
            n.fmt = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            return t += 2, 1 == n.fmt && (n.tab = a.readUshorts(r, t, o)), 2 == n.fmt && (n.tab = a.readUshorts(r, t, 3 * o)), n;
        }, e._lctf.coverageIndex = function(r, t) {
            var a = r.tab;
            if (1 == r.fmt) return a.indexOf(t);
            if (2 == r.fmt) {
                var n = e._lctf.getInterval(a, t);
                if (-1 != n) return a[n + 2] + (t - a[n]);
            }
            return -1;
        }, e._lctf.readFeatureList = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readASCII(r, t, 4);
                t += 4;
                var d = a.readUshort(r, t);
                t += 2;
                var f = e._lctf.readFeatureTable(r, n + d);
                f.tag = h.trim(), o.push(f);
            }
            return o;
        }, e._lctf.readFeatureTable = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2, s > 0 && (o.featureParams = n + s);
            var i = a.readUshort(r, t);
            t += 2, o.tab = [];
            for(var h = 0; h < i; h++)o.tab.push(a.readUshort(r, t + 2 * h));
            return o;
        }, e._lctf.readScriptList = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readASCII(r, t, 4);
                t += 4;
                var d = a.readUshort(r, t);
                t += 2, o[h.trim()] = e._lctf.readScriptTable(r, n + d);
            }
            return o;
        }, e._lctf.readScriptTable = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2, s > 0 && (o.default = e._lctf.readLangSysTable(r, n + s));
            var i = a.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                var d = a.readASCII(r, t, 4);
                t += 4;
                var f = a.readUshort(r, t);
                t += 2, o[d.trim()] = e._lctf.readLangSysTable(r, n + f);
            }
            return o;
        }, e._lctf.readLangSysTable = function(r, t) {
            var a = e._bin, n = {};
            a.readUshort(r, t), t += 2, n.reqFeature = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            return t += 2, n.features = a.readUshorts(r, t, o), n;
        }, e.CFF = {}, e.CFF.parse = function(r, t, a) {
            var n = e._bin;
            (r = new Uint8Array(r.buffer, t, a))[t = 0], r[++t], r[++t], r[++t], t++;
            var o = [];
            t = e.CFF.readIndex(r, t, o);
            for(var s = [], i = 0; i < o.length - 1; i++)s.push(n.readASCII(r, t + o[i], o[i + 1] - o[i]));
            t += o[o.length - 1];
            var h = [];
            t = e.CFF.readIndex(r, t, h);
            var d = [];
            for(i = 0; i < h.length - 1; i++)d.push(e.CFF.readDict(r, t + h[i], t + h[i + 1]));
            t += h[h.length - 1];
            var f = d[0], u = [];
            t = e.CFF.readIndex(r, t, u);
            var l = [];
            for(i = 0; i < u.length - 1; i++)l.push(n.readASCII(r, t + u[i], u[i + 1] - u[i]));
            if (t += u[u.length - 1], e.CFF.readSubrs(r, t, f), f.CharStrings) {
                t = f.CharStrings;
                u = [];
                t = e.CFF.readIndex(r, t, u);
                var v = [];
                for(i = 0; i < u.length - 1; i++)v.push(n.readBytes(r, t + u[i], u[i + 1] - u[i]));
                f.CharStrings = v;
            }
            if (f.ROS) {
                t = f.FDArray;
                var c = [];
                t = e.CFF.readIndex(r, t, c), f.FDArray = [];
                for(i = 0; i < c.length - 1; i++){
                    var p = e.CFF.readDict(r, t + c[i], t + c[i + 1]);
                    e.CFF._readFDict(r, p, l), f.FDArray.push(p);
                }
                t += c[c.length - 1], t = f.FDSelect, f.FDSelect = [];
                var U = r[t];
                if (t++, 3 != U) throw U;
                var g = n.readUshort(r, t);
                t += 2;
                for(i = 0; i < g + 1; i++)f.FDSelect.push(n.readUshort(r, t), r[t + 2]), t += 3;
            }
            return f.Encoding && (f.Encoding = e.CFF.readEncoding(r, f.Encoding, f.CharStrings.length)), f.charset && (f.charset = e.CFF.readCharset(r, f.charset, f.CharStrings.length)), e.CFF._readFDict(r, f, l), f;
        }, e.CFF._readFDict = function(r, t, a) {
            var n;
            for(var o in t.Private && (n = t.Private[1], t.Private = e.CFF.readDict(r, n, n + t.Private[0]), t.Private.Subrs && e.CFF.readSubrs(r, n + t.Private.Subrs, t.Private)), t)-1 != [
                "FamilyName",
                "FontName",
                "FullName",
                "Notice",
                "version",
                "Copyright"
            ].indexOf(o) && (t[o] = a[t[o] - 426 + 35]);
        }, e.CFF.readSubrs = function(r, t, a) {
            var n = e._bin, o = [];
            t = e.CFF.readIndex(r, t, o);
            var s, i = o.length;
            s = i < 1240 ? 107 : i < 33900 ? 1131 : 32768, a.Bias = s, a.Subrs = [];
            for(var h = 0; h < o.length - 1; h++)a.Subrs.push(n.readBytes(r, t + o[h], o[h + 1] - o[h]));
        }, e.CFF.tableSE = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            0,
            111,
            112,
            113,
            114,
            0,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            0,
            123,
            0,
            124,
            125,
            126,
            127,
            128,
            129,
            130,
            131,
            0,
            132,
            133,
            0,
            134,
            135,
            136,
            137,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            138,
            0,
            139,
            0,
            0,
            0,
            0,
            140,
            141,
            142,
            143,
            0,
            0,
            0,
            0,
            0,
            144,
            0,
            0,
            0,
            145,
            0,
            0,
            146,
            147,
            148,
            149,
            0,
            0,
            0,
            0
        ], e.CFF.glyphByUnicode = function(r, e) {
            for(var t = 0; t < r.charset.length; t++)if (r.charset[t] == e) return t;
            return -1;
        }, e.CFF.glyphBySE = function(r, t) {
            return t < 0 || t > 255 ? -1 : e.CFF.glyphByUnicode(r, e.CFF.tableSE[t]);
        }, e.CFF.readEncoding = function(r, t, a) {
            e._bin;
            var n = [
                ".notdef"
            ], o = r[t];
            if (t++, 0 != o) throw "error: unknown encoding format: " + o;
            var s = r[t];
            t++;
            for(var i = 0; i < s; i++)n.push(r[t + i]);
            return n;
        }, e.CFF.readCharset = function(r, t, a) {
            var n = e._bin, o = [
                ".notdef"
            ], s = r[t];
            if (t++, 0 == s) for(var i = 0; i < a; i++){
                var h = n.readUshort(r, t);
                t += 2, o.push(h);
            }
            else {
                if (1 != s && 2 != s) throw "error: format: " + s;
                for(; o.length < a;){
                    h = n.readUshort(r, t);
                    t += 2;
                    var d = 0;
                    1 == s ? (d = r[t], t++) : (d = n.readUshort(r, t), t += 2);
                    for(i = 0; i <= d; i++)o.push(h), h++;
                }
            }
            return o;
        }, e.CFF.readIndex = function(r, t, a) {
            var n = e._bin, o = n.readUshort(r, t) + 1, s = r[t += 2];
            if (t++, 1 == s) for(var i = 0; i < o; i++)a.push(r[t + i]);
            else if (2 == s) for(i = 0; i < o; i++)a.push(n.readUshort(r, t + 2 * i));
            else if (3 == s) for(i = 0; i < o; i++)a.push(16777215 & n.readUint(r, t + 3 * i - 1));
            else if (1 != o) throw "unsupported offset size: " + s + ", count: " + o;
            return (t += o * s) - 1;
        }, e.CFF.getCharString = function(r, t, a) {
            var n = e._bin, o = r[t], s = r[t + 1];
            r[t + 2], r[t + 3], r[t + 4];
            var i = 1, h = null, d = null;
            o <= 20 && (h = o, i = 1), 12 == o && (h = 100 * o + s, i = 2), 21 <= o && o <= 27 && (h = o, i = 1), 28 == o && (d = n.readShort(r, t + 1), i = 3), 29 <= o && o <= 31 && (h = o, i = 1), 32 <= o && o <= 246 && (d = o - 139, i = 1), 247 <= o && o <= 250 && (d = 256 * (o - 247) + s + 108, i = 2), 251 <= o && o <= 254 && (d = 256 * -(o - 251) - s - 108, i = 2), 255 == o && (d = n.readInt(r, t + 1) / 65535, i = 5), a.val = null != d ? d : "o" + h, a.size = i;
        }, e.CFF.readCharString = function(r, t, a) {
            for(var n = t + a, o = e._bin, s = []; t < n;){
                var i = r[t], h = r[t + 1];
                r[t + 2], r[t + 3], r[t + 4];
                var d = 1, f = null, u = null;
                i <= 20 && (f = i, d = 1), 12 == i && (f = 100 * i + h, d = 2), 19 != i && 20 != i || (f = i, d = 2), 21 <= i && i <= 27 && (f = i, d = 1), 28 == i && (u = o.readShort(r, t + 1), d = 3), 29 <= i && i <= 31 && (f = i, d = 1), 32 <= i && i <= 246 && (u = i - 139, d = 1), 247 <= i && i <= 250 && (u = 256 * (i - 247) + h + 108, d = 2), 251 <= i && i <= 254 && (u = 256 * -(i - 251) - h - 108, d = 2), 255 == i && (u = o.readInt(r, t + 1) / 65535, d = 5), s.push(null != u ? u : "o" + f), t += d;
            }
            return s;
        }, e.CFF.readDict = function(r, t, a) {
            for(var n = e._bin, o = {}, s = []; t < a;){
                var i = r[t], h = r[t + 1];
                r[t + 2], r[t + 3], r[t + 4];
                var d = 1, f = null, u = null;
                if (28 == i && (u = n.readShort(r, t + 1), d = 3), 29 == i && (u = n.readInt(r, t + 1), d = 5), 32 <= i && i <= 246 && (u = i - 139, d = 1), 247 <= i && i <= 250 && (u = 256 * (i - 247) + h + 108, d = 2), 251 <= i && i <= 254 && (u = 256 * -(i - 251) - h - 108, d = 2), 255 == i) throw u = n.readInt(r, t + 1) / 65535, d = 5, "unknown number";
                if (30 == i) {
                    var l = [];
                    for(d = 1;;){
                        var v = r[t + d];
                        d++;
                        var c = v >> 4, p = 15 & v;
                        if (15 != c && l.push(c), 15 != p && l.push(p), 15 == p) break;
                    }
                    for(var U = "", g = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        ".",
                        "e",
                        "e-",
                        "reserved",
                        "-",
                        "endOfNumber"
                    ], S = 0; S < l.length; S++)U += g[l[S]];
                    u = parseFloat(U);
                }
                if (i <= 21) {
                    if (f = [
                        "version",
                        "Notice",
                        "FullName",
                        "FamilyName",
                        "Weight",
                        "FontBBox",
                        "BlueValues",
                        "OtherBlues",
                        "FamilyBlues",
                        "FamilyOtherBlues",
                        "StdHW",
                        "StdVW",
                        "escape",
                        "UniqueID",
                        "XUID",
                        "charset",
                        "Encoding",
                        "CharStrings",
                        "Private",
                        "Subrs",
                        "defaultWidthX",
                        "nominalWidthX"
                    ][i], d = 1, 12 == i) f = [
                        "Copyright",
                        "isFixedPitch",
                        "ItalicAngle",
                        "UnderlinePosition",
                        "UnderlineThickness",
                        "PaintType",
                        "CharstringType",
                        "FontMatrix",
                        "StrokeWidth",
                        "BlueScale",
                        "BlueShift",
                        "BlueFuzz",
                        "StemSnapH",
                        "StemSnapV",
                        "ForceBold",
                        0,
                        0,
                        "LanguageGroup",
                        "ExpansionFactor",
                        "initialRandomSeed",
                        "SyntheticBase",
                        "PostScript",
                        "BaseFontName",
                        "BaseFontBlend",
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        "ROS",
                        "CIDFontVersion",
                        "CIDFontRevision",
                        "CIDFontType",
                        "CIDCount",
                        "UIDBase",
                        "FDArray",
                        "FDSelect",
                        "FontName"
                    ][h], d = 2;
                }
                null != f ? (o[f] = 1 == s.length ? s[0] : s, s = []) : s.push(u), t += d;
            }
            return o;
        }, e.cmap = {}, e.cmap.parse = function(r, t, a) {
            r = new Uint8Array(r.buffer, t, a), t = 0;
            var n = e._bin, o = {};
            n.readUshort(r, t), t += 2;
            var s = n.readUshort(r, t);
            t += 2;
            var i = [];
            o.tables = [];
            for(var h = 0; h < s; h++){
                var d = n.readUshort(r, t);
                t += 2;
                var f = n.readUshort(r, t);
                t += 2;
                var u = n.readUint(r, t);
                t += 4;
                var l = "p" + d + "e" + f, v = i.indexOf(u);
                if (-1 == v) {
                    var c;
                    v = o.tables.length, i.push(u);
                    var p = n.readUshort(r, u);
                    0 == p ? c = e.cmap.parse0(r, u) : 4 == p ? c = e.cmap.parse4(r, u) : 6 == p ? c = e.cmap.parse6(r, u) : 12 == p ? c = e.cmap.parse12(r, u) : console.debug("unknown format: " + p, d, f, u), o.tables.push(c);
                }
                if (null != o[l]) throw "multiple tables for one platform+encoding";
                o[l] = v;
            }
            return o;
        }, e.cmap.parse0 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2, a.readUshort(r, t), t += 2, n.map = [];
            for(var s = 0; s < o - 6; s++)n.map.push(r[t + s]);
            return n;
        }, e.cmap.parse4 = function(r, t) {
            var a = e._bin, n = t, o = {};
            o.format = a.readUshort(r, t), t += 2;
            var s = a.readUshort(r, t);
            t += 2, a.readUshort(r, t), t += 2;
            var i = a.readUshort(r, t);
            t += 2;
            var h = i / 2;
            o.searchRange = a.readUshort(r, t), t += 2, o.entrySelector = a.readUshort(r, t), t += 2, o.rangeShift = a.readUshort(r, t), t += 2, o.endCount = a.readUshorts(r, t, h), t += 2 * h, t += 2, o.startCount = a.readUshorts(r, t, h), t += 2 * h, o.idDelta = [];
            for(var d = 0; d < h; d++)o.idDelta.push(a.readShort(r, t)), t += 2;
            for(o.idRangeOffset = a.readUshorts(r, t, h), t += 2 * h, o.glyphIdArray = []; t < n + s;)o.glyphIdArray.push(a.readUshort(r, t)), t += 2;
            return o;
        }, e.cmap.parse6 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, n.firstCode = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2, n.glyphIdArray = [];
            for(var s = 0; s < o; s++)n.glyphIdArray.push(a.readUshort(r, t)), t += 2;
            return n;
        }, e.cmap.parse12 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2, t += 2, a.readUint(r, t), t += 4, a.readUint(r, t), t += 4;
            var o = a.readUint(r, t);
            t += 4, n.groups = [];
            for(var s = 0; s < o; s++){
                var i = t + 12 * s, h = a.readUint(r, i + 0), d = a.readUint(r, i + 4), f = a.readUint(r, i + 8);
                n.groups.push([
                    h,
                    d,
                    f
                ]);
            }
            return n;
        }, e.glyf = {}, e.glyf.parse = function(r, e, t, a) {
            for(var n = [], o = 0; o < a.maxp.numGlyphs; o++)n.push(null);
            return n;
        }, e.glyf._parseGlyf = function(r, t) {
            var a = e._bin, n = r._data, o = e._tabOffset(n, "glyf", r._offset) + r.loca[t];
            if (r.loca[t] == r.loca[t + 1]) return null;
            var s = {};
            if (s.noc = a.readShort(n, o), o += 2, s.xMin = a.readShort(n, o), o += 2, s.yMin = a.readShort(n, o), o += 2, s.xMax = a.readShort(n, o), o += 2, s.yMax = a.readShort(n, o), o += 2, s.xMin >= s.xMax || s.yMin >= s.yMax) return null;
            if (s.noc > 0) {
                s.endPts = [];
                for(var i = 0; i < s.noc; i++)s.endPts.push(a.readUshort(n, o)), o += 2;
                var h = a.readUshort(n, o);
                if (o += 2, n.length - o < h) return null;
                s.instructions = a.readBytes(n, o, h), o += h;
                var d = s.endPts[s.noc - 1] + 1;
                s.flags = [];
                for(i = 0; i < d; i++){
                    var f = n[o];
                    if (o++, s.flags.push(f), 0 != (8 & f)) {
                        var u = n[o];
                        o++;
                        for(var l = 0; l < u; l++)s.flags.push(f), i++;
                    }
                }
                s.xs = [];
                for(i = 0; i < d; i++){
                    var v = 0 != (2 & s.flags[i]), c = 0 != (16 & s.flags[i]);
                    v ? (s.xs.push(c ? n[o] : -n[o]), o++) : c ? s.xs.push(0) : (s.xs.push(a.readShort(n, o)), o += 2);
                }
                s.ys = [];
                for(i = 0; i < d; i++){
                    v = 0 != (4 & s.flags[i]), c = 0 != (32 & s.flags[i]);
                    v ? (s.ys.push(c ? n[o] : -n[o]), o++) : c ? s.ys.push(0) : (s.ys.push(a.readShort(n, o)), o += 2);
                }
                var p = 0, U = 0;
                for(i = 0; i < d; i++)p += s.xs[i], U += s.ys[i], s.xs[i] = p, s.ys[i] = U;
            } else {
                var g;
                s.parts = [];
                do {
                    g = a.readUshort(n, o), o += 2;
                    var S = {
                        m: {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            tx: 0,
                            ty: 0
                        },
                        p1: -1,
                        p2: -1
                    };
                    if (s.parts.push(S), S.glyphIndex = a.readUshort(n, o), o += 2, 1 & g) {
                        var m = a.readShort(n, o);
                        o += 2;
                        var b = a.readShort(n, o);
                        o += 2;
                    } else {
                        m = a.readInt8(n, o);
                        o++;
                        b = a.readInt8(n, o);
                        o++;
                    }
                    2 & g ? (S.m.tx = m, S.m.ty = b) : (S.p1 = m, S.p2 = b), 8 & g ? (S.m.a = S.m.d = a.readF2dot14(n, o), o += 2) : 64 & g ? (S.m.a = a.readF2dot14(n, o), o += 2, S.m.d = a.readF2dot14(n, o), o += 2) : 128 & g && (S.m.a = a.readF2dot14(n, o), o += 2, S.m.b = a.readF2dot14(n, o), o += 2, S.m.c = a.readF2dot14(n, o), o += 2, S.m.d = a.readF2dot14(n, o), o += 2);
                }while (32 & g);
                if (256 & g) {
                    var y = a.readUshort(n, o);
                    o += 2, s.instr = [];
                    for(i = 0; i < y; i++)s.instr.push(n[o]), o++;
                }
            }
            return s;
        }, e.GDEF = {}, e.GDEF.parse = function(r, t, a, n) {
            var o = t;
            t += 4;
            var s = e._bin.readUshort(r, t);
            return {
                glyphClassDef: 0 === s ? null : e._lctf.readClassDef(r, o + s)
            };
        }, e.GPOS = {}, e.GPOS.parse = function(r, t, a, n) {
            return e._lctf.parse(r, t, a, n, e.GPOS.subt);
        }, e.GPOS.subt = function(r, t, a, n) {
            var o = e._bin, s = a, i = {};
            if (i.fmt = o.readUshort(r, a), a += 2, 1 == t || 2 == t || 3 == t || 7 == t || 8 == t && i.fmt <= 2) {
                var h = o.readUshort(r, a);
                a += 2, i.coverage = e._lctf.readCoverage(r, h + s);
            }
            if (1 == t && 1 == i.fmt) {
                var d = o.readUshort(r, a);
                a += 2, 0 != d && (i.pos = e.GPOS.readValueRecord(r, a, d));
            } else if (2 == t && i.fmt >= 1 && i.fmt <= 2) {
                d = o.readUshort(r, a);
                a += 2;
                var f = o.readUshort(r, a);
                a += 2;
                var u = e._lctf.numOfOnes(d), l = e._lctf.numOfOnes(f);
                if (1 == i.fmt) {
                    i.pairsets = [];
                    var v = o.readUshort(r, a);
                    a += 2;
                    for(var c = 0; c < v; c++){
                        var p = s + o.readUshort(r, a);
                        a += 2;
                        var U = o.readUshort(r, p);
                        p += 2;
                        for(var g = [], S = 0; S < U; S++){
                            var m = o.readUshort(r, p);
                            p += 2, 0 != d && (P = e.GPOS.readValueRecord(r, p, d), p += 2 * u), 0 != f && (x = e.GPOS.readValueRecord(r, p, f), p += 2 * l), g.push({
                                gid2: m,
                                val1: P,
                                val2: x
                            });
                        }
                        i.pairsets.push(g);
                    }
                }
                if (2 == i.fmt) {
                    var b = o.readUshort(r, a);
                    a += 2;
                    var y = o.readUshort(r, a);
                    a += 2;
                    var F = o.readUshort(r, a);
                    a += 2;
                    var C = o.readUshort(r, a);
                    a += 2, i.classDef1 = e._lctf.readClassDef(r, s + b), i.classDef2 = e._lctf.readClassDef(r, s + y), i.matrix = [];
                    for(c = 0; c < F; c++){
                        var _ = [];
                        for(S = 0; S < C; S++){
                            var P = null, x = null;
                            0 != d && (P = e.GPOS.readValueRecord(r, a, d), a += 2 * u), 0 != f && (x = e.GPOS.readValueRecord(r, a, f), a += 2 * l), _.push({
                                val1: P,
                                val2: x
                            });
                        }
                        i.matrix.push(_);
                    }
                }
            } else if (4 == t && 1 == i.fmt) i.markCoverage = e._lctf.readCoverage(r, o.readUshort(r, a) + s), i.baseCoverage = e._lctf.readCoverage(r, o.readUshort(r, a + 2) + s), i.markClassCount = o.readUshort(r, a + 4), i.markArray = e.GPOS.readMarkArray(r, o.readUshort(r, a + 6) + s), i.baseArray = e.GPOS.readBaseArray(r, o.readUshort(r, a + 8) + s, i.markClassCount);
            else if (6 == t && 1 == i.fmt) i.mark1Coverage = e._lctf.readCoverage(r, o.readUshort(r, a) + s), i.mark2Coverage = e._lctf.readCoverage(r, o.readUshort(r, a + 2) + s), i.markClassCount = o.readUshort(r, a + 4), i.mark1Array = e.GPOS.readMarkArray(r, o.readUshort(r, a + 6) + s), i.mark2Array = e.GPOS.readBaseArray(r, o.readUshort(r, a + 8) + s, i.markClassCount);
            else {
                if (9 == t && 1 == i.fmt) {
                    var I = o.readUshort(r, a);
                    a += 2;
                    var w = o.readUint(r, a);
                    if (a += 4, 9 == n.ltype) n.ltype = I;
                    else if (n.ltype != I) throw "invalid extension substitution";
                    return e.GPOS.subt(r, n.ltype, s + w);
                }
                console.debug("unsupported GPOS table LookupType", t, "format", i.fmt);
            }
            return i;
        }, e.GPOS.readValueRecord = function(r, t, a) {
            var n = e._bin, o = [];
            return o.push(1 & a ? n.readShort(r, t) : 0), t += 1 & a ? 2 : 0, o.push(2 & a ? n.readShort(r, t) : 0), t += 2 & a ? 2 : 0, o.push(4 & a ? n.readShort(r, t) : 0), t += 4 & a ? 2 : 0, o.push(8 & a ? n.readShort(r, t) : 0), t += 8 & a ? 2 : 0, o;
        }, e.GPOS.readBaseArray = function(r, t, a) {
            var n = e._bin, o = [], s = t, i = n.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                for(var d = [], f = 0; f < a; f++)d.push(e.GPOS.readAnchorRecord(r, s + n.readUshort(r, t))), t += 2;
                o.push(d);
            }
            return o;
        }, e.GPOS.readMarkArray = function(r, t) {
            var a = e._bin, n = [], o = t, s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = e.GPOS.readAnchorRecord(r, a.readUshort(r, t + 2) + o);
                h.markClass = a.readUshort(r, t), n.push(h), t += 4;
            }
            return n;
        }, e.GPOS.readAnchorRecord = function(r, t) {
            var a = e._bin, n = {};
            return n.fmt = a.readUshort(r, t), n.x = a.readShort(r, t + 2), n.y = a.readShort(r, t + 4), n;
        }, e.GSUB = {}, e.GSUB.parse = function(r, t, a, n) {
            return e._lctf.parse(r, t, a, n, e.GSUB.subt);
        }, e.GSUB.subt = function(r, t, a, n) {
            var o = e._bin, s = a, i = {};
            if (i.fmt = o.readUshort(r, a), a += 2, 1 != t && 2 != t && 4 != t && 5 != t && 6 != t) return null;
            if (1 == t || 2 == t || 4 == t || 5 == t && i.fmt <= 2 || 6 == t && i.fmt <= 2) {
                var h = o.readUshort(r, a);
                a += 2, i.coverage = e._lctf.readCoverage(r, s + h);
            }
            if (1 == t && i.fmt >= 1 && i.fmt <= 2) {
                if (1 == i.fmt) i.delta = o.readShort(r, a), a += 2;
                else if (2 == i.fmt) {
                    var d = o.readUshort(r, a);
                    a += 2, i.newg = o.readUshorts(r, a, d), a += 2 * i.newg.length;
                }
            } else if (2 == t && 1 == i.fmt) {
                d = o.readUshort(r, a);
                a += 2, i.seqs = [];
                for(var f = 0; f < d; f++){
                    var u = o.readUshort(r, a) + s;
                    a += 2;
                    var l = o.readUshort(r, u);
                    i.seqs.push(o.readUshorts(r, u + 2, l));
                }
            } else if (4 == t) {
                i.vals = [];
                d = o.readUshort(r, a);
                a += 2;
                for(f = 0; f < d; f++){
                    var v = o.readUshort(r, a);
                    a += 2, i.vals.push(e.GSUB.readLigatureSet(r, s + v));
                }
            } else if (5 == t && 2 == i.fmt) {
                if (2 == i.fmt) {
                    var c = o.readUshort(r, a);
                    a += 2, i.cDef = e._lctf.readClassDef(r, s + c), i.scset = [];
                    var p = o.readUshort(r, a);
                    a += 2;
                    for(f = 0; f < p; f++){
                        var U = o.readUshort(r, a);
                        a += 2, i.scset.push(0 == U ? null : e.GSUB.readSubClassSet(r, s + U));
                    }
                }
            } else if (6 == t && 3 == i.fmt) {
                if (3 == i.fmt) {
                    for(f = 0; f < 3; f++){
                        d = o.readUshort(r, a);
                        a += 2;
                        for(var g = [], S = 0; S < d; S++)g.push(e._lctf.readCoverage(r, s + o.readUshort(r, a + 2 * S)));
                        a += 2 * d, 0 == f && (i.backCvg = g), 1 == f && (i.inptCvg = g), 2 == f && (i.ahedCvg = g);
                    }
                    d = o.readUshort(r, a);
                    a += 2, i.lookupRec = e.GSUB.readSubstLookupRecords(r, a, d);
                }
            } else {
                if (7 == t && 1 == i.fmt) {
                    var m = o.readUshort(r, a);
                    a += 2;
                    var b = o.readUint(r, a);
                    if (a += 4, 9 == n.ltype) n.ltype = m;
                    else if (n.ltype != m) throw "invalid extension substitution";
                    return e.GSUB.subt(r, n.ltype, s + b);
                }
                console.debug("unsupported GSUB table LookupType", t, "format", i.fmt);
            }
            return i;
        }, e.GSUB.readSubClassSet = function(r, t) {
            var a = e._bin.readUshort, n = t, o = [], s = a(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a(r, t);
                t += 2, o.push(e.GSUB.readSubClassRule(r, n + h));
            }
            return o;
        }, e.GSUB.readSubClassRule = function(r, t) {
            var a = e._bin.readUshort, n = {}, o = a(r, t), s = a(r, t += 2);
            t += 2, n.input = [];
            for(var i = 0; i < o - 1; i++)n.input.push(a(r, t)), t += 2;
            return n.substLookupRecords = e.GSUB.readSubstLookupRecords(r, t, s), n;
        }, e.GSUB.readSubstLookupRecords = function(r, t, a) {
            for(var n = e._bin.readUshort, o = [], s = 0; s < a; s++)o.push(n(r, t), n(r, t + 2)), t += 4;
            return o;
        }, e.GSUB.readChainSubClassSet = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readUshort(r, t);
                t += 2, o.push(e.GSUB.readChainSubClassRule(r, n + h));
            }
            return o;
        }, e.GSUB.readChainSubClassRule = function(r, t) {
            for(var a = e._bin, n = {}, o = [
                "backtrack",
                "input",
                "lookahead"
            ], s = 0; s < o.length; s++){
                var i = a.readUshort(r, t);
                t += 2, 1 == s && i--, n[o[s]] = a.readUshorts(r, t, i), t += 2 * n[o[s]].length;
            }
            i = a.readUshort(r, t);
            return t += 2, n.subst = a.readUshorts(r, t, 2 * i), t += 2 * n.subst.length, n;
        }, e.GSUB.readLigatureSet = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readUshort(r, t);
                t += 2, o.push(e.GSUB.readLigature(r, n + h));
            }
            return o;
        }, e.GSUB.readLigature = function(r, t) {
            var a = e._bin, n = {
                chain: []
            };
            n.nglyph = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2;
            for(var s = 0; s < o - 1; s++)n.chain.push(a.readUshort(r, t)), t += 2;
            return n;
        }, e.head = {}, e.head.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return n.readFixed(r, t), t += 4, o.fontRevision = n.readFixed(r, t), t += 4, n.readUint(r, t), t += 4, n.readUint(r, t), t += 4, o.flags = n.readUshort(r, t), t += 2, o.unitsPerEm = n.readUshort(r, t), t += 2, o.created = n.readUint64(r, t), t += 8, o.modified = n.readUint64(r, t), t += 8, o.xMin = n.readShort(r, t), t += 2, o.yMin = n.readShort(r, t), t += 2, o.xMax = n.readShort(r, t), t += 2, o.yMax = n.readShort(r, t), t += 2, o.macStyle = n.readUshort(r, t), t += 2, o.lowestRecPPEM = n.readUshort(r, t), t += 2, o.fontDirectionHint = n.readShort(r, t), t += 2, o.indexToLocFormat = n.readShort(r, t), t += 2, o.glyphDataFormat = n.readShort(r, t), t += 2, o;
        }, e.hhea = {}, e.hhea.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return n.readFixed(r, t), t += 4, o.ascender = n.readShort(r, t), t += 2, o.descender = n.readShort(r, t), t += 2, o.lineGap = n.readShort(r, t), t += 2, o.advanceWidthMax = n.readUshort(r, t), t += 2, o.minLeftSideBearing = n.readShort(r, t), t += 2, o.minRightSideBearing = n.readShort(r, t), t += 2, o.xMaxExtent = n.readShort(r, t), t += 2, o.caretSlopeRise = n.readShort(r, t), t += 2, o.caretSlopeRun = n.readShort(r, t), t += 2, o.caretOffset = n.readShort(r, t), t += 2, t += 8, o.metricDataFormat = n.readShort(r, t), t += 2, o.numberOfHMetrics = n.readUshort(r, t), t += 2, o;
        }, e.hmtx = {}, e.hmtx.parse = function(r, t, a, n) {
            for(var o = e._bin, s = {
                aWidth: [],
                lsBearing: []
            }, i = 0, h = 0, d = 0; d < n.maxp.numGlyphs; d++)d < n.hhea.numberOfHMetrics && (i = o.readUshort(r, t), t += 2, h = o.readShort(r, t), t += 2), s.aWidth.push(i), s.lsBearing.push(h);
            return s;
        }, e.kern = {}, e.kern.parse = function(r, t, a, n) {
            var o = e._bin, s = o.readUshort(r, t);
            if (t += 2, 1 == s) return e.kern.parseV1(r, t - 2, a, n);
            var i = o.readUshort(r, t);
            t += 2;
            for(var h = {
                glyph1: [],
                rval: []
            }, d = 0; d < i; d++){
                t += 2;
                a = o.readUshort(r, t);
                t += 2;
                var f = o.readUshort(r, t);
                t += 2;
                var u = f >>> 8;
                if (0 != (u &= 15)) throw "unknown kern table format: " + u;
                t = e.kern.readFormat0(r, t, h);
            }
            return h;
        }, e.kern.parseV1 = function(r, t, a, n) {
            var o = e._bin;
            o.readFixed(r, t), t += 4;
            var s = o.readUint(r, t);
            t += 4;
            for(var i = {
                glyph1: [],
                rval: []
            }, h = 0; h < s; h++){
                o.readUint(r, t), t += 4;
                var d = o.readUshort(r, t);
                t += 2, o.readUshort(r, t), t += 2;
                var f = d >>> 8;
                if (0 != (f &= 15)) throw "unknown kern table format: " + f;
                t = e.kern.readFormat0(r, t, i);
            }
            return i;
        }, e.kern.readFormat0 = function(r, t, a) {
            var n = e._bin, o = -1, s = n.readUshort(r, t);
            t += 2, n.readUshort(r, t), t += 2, n.readUshort(r, t), t += 2, n.readUshort(r, t), t += 2;
            for(var i = 0; i < s; i++){
                var h = n.readUshort(r, t);
                t += 2;
                var d = n.readUshort(r, t);
                t += 2;
                var f = n.readShort(r, t);
                t += 2, h != o && (a.glyph1.push(h), a.rval.push({
                    glyph2: [],
                    vals: []
                }));
                var u = a.rval[a.rval.length - 1];
                u.glyph2.push(d), u.vals.push(f), o = h;
            }
            return t;
        }, e.loca = {}, e.loca.parse = function(r, t, a, n) {
            var o = e._bin, s = [], i = n.head.indexToLocFormat, h = n.maxp.numGlyphs + 1;
            if (0 == i) for(var d = 0; d < h; d++)s.push(o.readUshort(r, t + (d << 1)) << 1);
            if (1 == i) for(d = 0; d < h; d++)s.push(o.readUint(r, t + (d << 2)));
            return s;
        }, e.maxp = {}, e.maxp.parse = function(r, t, a) {
            var n = e._bin, o = {}, s = n.readUint(r, t);
            return t += 4, o.numGlyphs = n.readUshort(r, t), t += 2, 65536 == s && (o.maxPoints = n.readUshort(r, t), t += 2, o.maxContours = n.readUshort(r, t), t += 2, o.maxCompositePoints = n.readUshort(r, t), t += 2, o.maxCompositeContours = n.readUshort(r, t), t += 2, o.maxZones = n.readUshort(r, t), t += 2, o.maxTwilightPoints = n.readUshort(r, t), t += 2, o.maxStorage = n.readUshort(r, t), t += 2, o.maxFunctionDefs = n.readUshort(r, t), t += 2, o.maxInstructionDefs = n.readUshort(r, t), t += 2, o.maxStackElements = n.readUshort(r, t), t += 2, o.maxSizeOfInstructions = n.readUshort(r, t), t += 2, o.maxComponentElements = n.readUshort(r, t), t += 2, o.maxComponentDepth = n.readUshort(r, t), t += 2), o;
        }, e.name = {}, e.name.parse = function(r, t, a) {
            var n = e._bin, o = {};
            n.readUshort(r, t), t += 2;
            var s = n.readUshort(r, t);
            t += 2, n.readUshort(r, t);
            for(var i, h = [
                "copyright",
                "fontFamily",
                "fontSubfamily",
                "ID",
                "fullName",
                "version",
                "postScriptName",
                "trademark",
                "manufacturer",
                "designer",
                "description",
                "urlVendor",
                "urlDesigner",
                "licence",
                "licenceURL",
                "---",
                "typoFamilyName",
                "typoSubfamilyName",
                "compatibleFull",
                "sampleText",
                "postScriptCID",
                "wwsFamilyName",
                "wwsSubfamilyName",
                "lightPalette",
                "darkPalette"
            ], d = t += 2, f = 0; f < s; f++){
                var u = n.readUshort(r, t);
                t += 2;
                var l = n.readUshort(r, t);
                t += 2;
                var v = n.readUshort(r, t);
                t += 2;
                var c = n.readUshort(r, t);
                t += 2;
                var p = n.readUshort(r, t);
                t += 2;
                var U = n.readUshort(r, t);
                t += 2;
                var g, S = h[c], m = d + 12 * s + U;
                if (0 == u) g = n.readUnicode(r, m, p / 2);
                else if (3 == u && 0 == l) g = n.readUnicode(r, m, p / 2);
                else if (0 == l) g = n.readASCII(r, m, p);
                else if (1 == l) g = n.readUnicode(r, m, p / 2);
                else if (3 == l) g = n.readUnicode(r, m, p / 2);
                else {
                    if (1 != u) throw "unknown encoding " + l + ", platformID: " + u;
                    g = n.readASCII(r, m, p), console.debug("reading unknown MAC encoding " + l + " as ASCII");
                }
                var b = "p" + u + "," + v.toString(16);
                null == o[b] && (o[b] = {}), o[b][void 0 !== S ? S : c] = g, o[b]._lang = v;
            }
            for(var y in o)if (null != o[y].postScriptName && 1033 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName && 0 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName && 3084 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName) return o[y];
            for(var y in o){
                i = y;
                break;
            }
            return console.debug("returning name table with languageID " + o[i]._lang), o[i];
        }, e["OS/2"] = {}, e["OS/2"].parse = function(r, t, a) {
            var n = e._bin.readUshort(r, t);
            t += 2;
            var o = {};
            if (0 == n) e["OS/2"].version0(r, t, o);
            else if (1 == n) e["OS/2"].version1(r, t, o);
            else if (2 == n || 3 == n || 4 == n) e["OS/2"].version2(r, t, o);
            else {
                if (5 != n) throw "unknown OS/2 table version: " + n;
                e["OS/2"].version5(r, t, o);
            }
            return o;
        }, e["OS/2"].version0 = function(r, t, a) {
            var n = e._bin;
            return a.xAvgCharWidth = n.readShort(r, t), t += 2, a.usWeightClass = n.readUshort(r, t), t += 2, a.usWidthClass = n.readUshort(r, t), t += 2, a.fsType = n.readUshort(r, t), t += 2, a.ySubscriptXSize = n.readShort(r, t), t += 2, a.ySubscriptYSize = n.readShort(r, t), t += 2, a.ySubscriptXOffset = n.readShort(r, t), t += 2, a.ySubscriptYOffset = n.readShort(r, t), t += 2, a.ySuperscriptXSize = n.readShort(r, t), t += 2, a.ySuperscriptYSize = n.readShort(r, t), t += 2, a.ySuperscriptXOffset = n.readShort(r, t), t += 2, a.ySuperscriptYOffset = n.readShort(r, t), t += 2, a.yStrikeoutSize = n.readShort(r, t), t += 2, a.yStrikeoutPosition = n.readShort(r, t), t += 2, a.sFamilyClass = n.readShort(r, t), t += 2, a.panose = n.readBytes(r, t, 10), t += 10, a.ulUnicodeRange1 = n.readUint(r, t), t += 4, a.ulUnicodeRange2 = n.readUint(r, t), t += 4, a.ulUnicodeRange3 = n.readUint(r, t), t += 4, a.ulUnicodeRange4 = n.readUint(r, t), t += 4, a.achVendID = [
                n.readInt8(r, t),
                n.readInt8(r, t + 1),
                n.readInt8(r, t + 2),
                n.readInt8(r, t + 3)
            ], t += 4, a.fsSelection = n.readUshort(r, t), t += 2, a.usFirstCharIndex = n.readUshort(r, t), t += 2, a.usLastCharIndex = n.readUshort(r, t), t += 2, a.sTypoAscender = n.readShort(r, t), t += 2, a.sTypoDescender = n.readShort(r, t), t += 2, a.sTypoLineGap = n.readShort(r, t), t += 2, a.usWinAscent = n.readUshort(r, t), t += 2, a.usWinDescent = n.readUshort(r, t), t += 2;
        }, e["OS/2"].version1 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version0(r, t, a), a.ulCodePageRange1 = n.readUint(r, t), t += 4, a.ulCodePageRange2 = n.readUint(r, t), t += 4;
        }, e["OS/2"].version2 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version1(r, t, a), a.sxHeight = n.readShort(r, t), t += 2, a.sCapHeight = n.readShort(r, t), t += 2, a.usDefault = n.readUshort(r, t), t += 2, a.usBreak = n.readUshort(r, t), t += 2, a.usMaxContext = n.readUshort(r, t), t += 2;
        }, e["OS/2"].version5 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version2(r, t, a), a.usLowerOpticalPointSize = n.readUshort(r, t), t += 2, a.usUpperOpticalPointSize = n.readUshort(r, t), t += 2;
        }, e.post = {}, e.post.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return o.version = n.readFixed(r, t), t += 4, o.italicAngle = n.readFixed(r, t), t += 4, o.underlinePosition = n.readShort(r, t), t += 2, o.underlineThickness = n.readShort(r, t), t += 2, o;
        }, null == e && (e = {}), null == e.U && (e.U = {}), e.U.codeToGlyph = function(r, e) {
            var t = r.cmap, a = -1;
            if (null != t.p0e4 ? a = t.p0e4 : null != t.p3e1 ? a = t.p3e1 : null != t.p1e0 ? a = t.p1e0 : null != t.p0e3 && (a = t.p0e3), -1 == a) throw "no familiar platform and encoding!";
            var n = t.tables[a];
            if (0 == n.format) return e >= n.map.length ? 0 : n.map[e];
            if (4 == n.format) {
                for(var o = -1, s = 0; s < n.endCount.length; s++)if (e <= n.endCount[s]) {
                    o = s;
                    break;
                }
                if (-1 == o) return 0;
                if (n.startCount[o] > e) return 0;
                return 65535 & (0 != n.idRangeOffset[o] ? n.glyphIdArray[e - n.startCount[o] + (n.idRangeOffset[o] >> 1) - (n.idRangeOffset.length - o)] : e + n.idDelta[o]);
            }
            if (12 == n.format) {
                if (e > n.groups[n.groups.length - 1][1]) return 0;
                for(s = 0; s < n.groups.length; s++){
                    var i = n.groups[s];
                    if (i[0] <= e && e <= i[1]) return i[2] + (e - i[0]);
                }
                return 0;
            }
            throw "unknown cmap table format " + n.format;
        }, e.U.glyphToPath = function(r, t) {
            var a = {
                cmds: [],
                crds: []
            };
            if (r.SVG && r.SVG.entries[t]) {
                var n = r.SVG.entries[t];
                return null == n ? a : ("string" == typeof n && (n = e.SVG.toPath(n), r.SVG.entries[t] = n), n);
            }
            if (r.CFF) {
                var o = {
                    x: 0,
                    y: 0,
                    stack: [],
                    nStems: 0,
                    haveWidth: !1,
                    width: r.CFF.Private ? r.CFF.Private.defaultWidthX : 0,
                    open: !1
                }, s = r.CFF, i = r.CFF.Private;
                if (s.ROS) {
                    for(var h = 0; s.FDSelect[h + 2] <= t;)h += 2;
                    i = s.FDArray[s.FDSelect[h + 1]].Private;
                }
                e.U._drawCFF(r.CFF.CharStrings[t], o, s, i, a);
            } else r.glyf && e.U._drawGlyf(t, r, a);
            return a;
        }, e.U._drawGlyf = function(r, t, a) {
            var n = t.glyf[r];
            null == n && (n = t.glyf[r] = e.glyf._parseGlyf(t, r)), null != n && (n.noc > -1 ? e.U._simpleGlyph(n, a) : e.U._compoGlyph(n, t, a));
        }, e.U._simpleGlyph = function(r, t) {
            for(var a = 0; a < r.noc; a++){
                for(var n = 0 == a ? 0 : r.endPts[a - 1] + 1, o = r.endPts[a], s = n; s <= o; s++){
                    var i = s == n ? o : s - 1, h = s == o ? n : s + 1, d = 1 & r.flags[s], f = 1 & r.flags[i], u = 1 & r.flags[h], l = r.xs[s], v = r.ys[s];
                    if (s == n) {
                        if (d) {
                            if (!f) {
                                e.U.P.moveTo(t, l, v);
                                continue;
                            }
                            e.U.P.moveTo(t, r.xs[i], r.ys[i]);
                        } else f ? e.U.P.moveTo(t, r.xs[i], r.ys[i]) : e.U.P.moveTo(t, (r.xs[i] + l) / 2, (r.ys[i] + v) / 2);
                    }
                    d ? f && e.U.P.lineTo(t, l, v) : u ? e.U.P.qcurveTo(t, l, v, r.xs[h], r.ys[h]) : e.U.P.qcurveTo(t, l, v, (l + r.xs[h]) / 2, (v + r.ys[h]) / 2);
                }
                e.U.P.closePath(t);
            }
        }, e.U._compoGlyph = function(r, t, a) {
            for(var n = 0; n < r.parts.length; n++){
                var o = {
                    cmds: [],
                    crds: []
                }, s = r.parts[n];
                e.U._drawGlyf(s.glyphIndex, t, o);
                for(var i = s.m, h = 0; h < o.crds.length; h += 2){
                    var d = o.crds[h], f = o.crds[h + 1];
                    a.crds.push(d * i.a + f * i.b + i.tx), a.crds.push(d * i.c + f * i.d + i.ty);
                }
                for(h = 0; h < o.cmds.length; h++)a.cmds.push(o.cmds[h]);
            }
        }, e.U._getGlyphClass = function(r, t) {
            var a = e._lctf.getInterval(t, r);
            return -1 == a ? 0 : t[a + 2];
        }, e.U._applySubs = function(r, t, a, n) {
            for(var o = r.length - t - 1, s = 0; s < a.tabs.length; s++)if (null != a.tabs[s]) {
                var i, h = a.tabs[s];
                if (!h.coverage || -1 != (i = e._lctf.coverageIndex(h.coverage, r[t]))) {
                    if (1 == a.ltype) r[t], 1 == h.fmt ? r[t] = r[t] + h.delta : r[t] = h.newg[i];
                    else if (4 == a.ltype) for(var d = h.vals[i], f = 0; f < d.length; f++){
                        var u = d[f], l = u.chain.length;
                        if (!(l > o)) {
                            for(var v = !0, c = 0, p = 0; p < l; p++){
                                for(; -1 == r[t + c + (1 + p)];)c++;
                                u.chain[p] != r[t + c + (1 + p)] && (v = !1);
                            }
                            if (v) {
                                r[t] = u.nglyph;
                                for(p = 0; p < l + c; p++)r[t + p + 1] = -1;
                                break;
                            }
                        }
                    }
                    else if (5 == a.ltype && 2 == h.fmt) for(var U = e._lctf.getInterval(h.cDef, r[t]), g = h.cDef[U + 2], S = h.scset[g], m = 0; m < S.length; m++){
                        var b = S[m], y = b.input;
                        if (!(y.length > o)) {
                            for(v = !0, p = 0; p < y.length; p++){
                                var F = e._lctf.getInterval(h.cDef, r[t + 1 + p]);
                                if (-1 == U && h.cDef[F + 2] != y[p]) {
                                    v = !1;
                                    break;
                                }
                            }
                            if (v) {
                                var C = b.substLookupRecords;
                                for(f = 0; f < C.length; f += 2)C[f], C[f + 1];
                            }
                        }
                    }
                    else if (6 == a.ltype && 3 == h.fmt) {
                        if (!e.U._glsCovered(r, h.backCvg, t - h.backCvg.length)) continue;
                        if (!e.U._glsCovered(r, h.inptCvg, t)) continue;
                        if (!e.U._glsCovered(r, h.ahedCvg, t + h.inptCvg.length)) continue;
                        var _ = h.lookupRec;
                        for(m = 0; m < _.length; m += 2){
                            U = _[m];
                            var P = n[_[m + 1]];
                            e.U._applySubs(r, t + U, P, n);
                        }
                    }
                }
            }
        }, e.U._glsCovered = function(r, t, a) {
            for(var n = 0; n < t.length; n++){
                if (-1 == e._lctf.coverageIndex(t[n], r[a + n])) return !1;
            }
            return !0;
        }, e.U.glyphsToPath = function(r, t, a) {
            for(var n = {
                cmds: [],
                crds: []
            }, o = 0, s = 0; s < t.length; s++){
                var i = t[s];
                if (-1 != i) {
                    for(var h = s < t.length - 1 && -1 != t[s + 1] ? t[s + 1] : 0, d = e.U.glyphToPath(r, i), f = 0; f < d.crds.length; f += 2)n.crds.push(d.crds[f] + o), n.crds.push(d.crds[f + 1]);
                    a && n.cmds.push(a);
                    for(f = 0; f < d.cmds.length; f++)n.cmds.push(d.cmds[f]);
                    a && n.cmds.push("X"), o += r.hmtx.aWidth[i], s < t.length - 1 && (o += e.U.getPairAdjustment(r, i, h));
                }
            }
            return n;
        }, e.U.P = {}, e.U.P.moveTo = function(r, e, t) {
            r.cmds.push("M"), r.crds.push(e, t);
        }, e.U.P.lineTo = function(r, e, t) {
            r.cmds.push("L"), r.crds.push(e, t);
        }, e.U.P.curveTo = function(r, e, t, a, n, o, s) {
            r.cmds.push("C"), r.crds.push(e, t, a, n, o, s);
        }, e.U.P.qcurveTo = function(r, e, t, a, n) {
            r.cmds.push("Q"), r.crds.push(e, t, a, n);
        }, e.U.P.closePath = function(r) {
            r.cmds.push("Z");
        }, e.U._drawCFF = function(r, t, a, n, o) {
            for(var s = t.stack, i = t.nStems, h = t.haveWidth, d = t.width, f = t.open, u = 0, l = t.x, v = t.y, c = 0, p = 0, U = 0, g = 0, S = 0, m = 0, b = 0, y = 0, F = 0, C = 0, _ = {
                val: 0,
                size: 0
            }; u < r.length;){
                e.CFF.getCharString(r, u, _);
                var P = _.val;
                if (u += _.size, "o1" == P || "o18" == P) s.length % 2 != 0 && !h && (d = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0;
                else if ("o3" == P || "o23" == P) s.length % 2 != 0 && !h && (d = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0;
                else if ("o4" == P) s.length > 1 && !h && (d = s.shift() + n.nominalWidthX, h = !0), f && e.U.P.closePath(o), v += s.pop(), e.U.P.moveTo(o, l, v), f = !0;
                else if ("o5" == P) for(; s.length > 0;)l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v);
                else if ("o6" == P || "o7" == P) for(var x = s.length, I = "o6" == P, w = 0; w < x; w++){
                    var k = s.shift();
                    I ? l += k : v += k, I = !I, e.U.P.lineTo(o, l, v);
                }
                else if ("o8" == P || "o24" == P) {
                    x = s.length;
                    for(var G = 0; G + 6 <= x;)c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v), G += 6;
                    "o24" == P && (l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v));
                } else {
                    if ("o11" == P) break;
                    if ("o1234" == P || "o1235" == P || "o1236" == P || "o1237" == P) "o1234" == P && (p = v, U = (c = l + s.shift()) + s.shift(), C = g = p + s.shift(), m = g, y = v, l = (b = (S = (F = U + s.shift()) + s.shift()) + s.shift()) + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, C), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1235" == P && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), F = U + s.shift(), C = g + s.shift(), S = F + s.shift(), m = C + s.shift(), b = S + s.shift(), y = m + s.shift(), l = b + s.shift(), v = y + s.shift(), s.shift(), e.U.P.curveTo(o, c, p, U, g, F, C), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1236" == P && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), C = g = p + s.shift(), m = g, b = (S = (F = U + s.shift()) + s.shift()) + s.shift(), y = m + s.shift(), l = b + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, C), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1237" == P && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), F = U + s.shift(), C = g + s.shift(), S = F + s.shift(), m = C + s.shift(), b = S + s.shift(), y = m + s.shift(), Math.abs(b - l) > Math.abs(y - v) ? l = b + s.shift() : v = y + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, C), e.U.P.curveTo(o, S, m, b, y, l, v));
                    else if ("o14" == P) {
                        if (s.length > 0 && !h && (d = s.shift() + a.nominalWidthX, h = !0), 4 == s.length) {
                            var O = s.shift(), T = s.shift(), D = s.shift(), B = s.shift(), A = e.CFF.glyphBySE(a, D), R = e.CFF.glyphBySE(a, B);
                            e.U._drawCFF(a.CharStrings[A], t, a, n, o), t.x = O, t.y = T, e.U._drawCFF(a.CharStrings[R], t, a, n, o);
                        }
                        f && (e.U.P.closePath(o), f = !1);
                    } else if ("o19" == P || "o20" == P) s.length % 2 != 0 && !h && (d = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0, u += i + 7 >> 3;
                    else if ("o21" == P) s.length > 2 && !h && (d = s.shift() + n.nominalWidthX, h = !0), v += s.pop(), l += s.pop(), f && e.U.P.closePath(o), e.U.P.moveTo(o, l, v), f = !0;
                    else if ("o22" == P) s.length > 1 && !h && (d = s.shift() + n.nominalWidthX, h = !0), l += s.pop(), f && e.U.P.closePath(o), e.U.P.moveTo(o, l, v), f = !0;
                    else if ("o25" == P) {
                        for(; s.length > 6;)l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v);
                        c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v);
                    } else if ("o26" == P) for(s.length % 2 && (l += s.shift()); s.length > 0;)c = l, p = v + s.shift(), l = U = c + s.shift(), v = (g = p + s.shift()) + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v);
                    else if ("o27" == P) for(s.length % 2 && (v += s.shift()); s.length > 0;)p = v, U = (c = l + s.shift()) + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g, e.U.P.curveTo(o, c, p, U, g, l, v);
                    else if ("o10" == P || "o29" == P) {
                        var L = "o10" == P ? n : a;
                        if (0 == s.length) console.debug("error: empty stack");
                        else {
                            var W = s.pop(), M = L.Subrs[W + L.Bias];
                            t.x = l, t.y = v, t.nStems = i, t.haveWidth = h, t.width = d, t.open = f, e.U._drawCFF(M, t, a, n, o), l = t.x, v = t.y, i = t.nStems, h = t.haveWidth, d = t.width, f = t.open;
                        }
                    } else if ("o30" == P || "o31" == P) {
                        var V = s.length, E = (G = 0, "o31" == P);
                        for(G += V - (x = -3 & V); G < x;)E ? (p = v, U = (c = l + s.shift()) + s.shift(), v = (g = p + s.shift()) + s.shift(), x - G == 5 ? (l = U + s.shift(), G++) : l = U, E = !1) : (c = l, p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), x - G == 5 ? (v = g + s.shift(), G++) : v = g, E = !0), e.U.P.curveTo(o, c, p, U, g, l, v), G += 4;
                    } else {
                        if ("o" == (P + "").charAt(0)) throw console.debug("Unknown operation: " + P, r), P;
                        s.push(P);
                    }
                }
            }
            t.x = l, t.y = v, t.nStems = i, t.haveWidth = h, t.width = d, t.open = f;
        };
        var t = e, a = {
            Typr: t
        };
        return r.Typr = t, r.default = a, Object.defineProperty(r, "__esModule", {
            value: !0
        }), r;
    }({}).Typr;
}
/*!
Custom bundle of woff2otf (https://github.com/arty-name/woff2otf) with fflate
(https://github.com/101arrowz/fflate) for use in Troika text rendering. 
Original licenses apply: 
- fflate: https://github.com/101arrowz/fflate/blob/master/LICENSE (MIT)
- woff2otf.js: https://github.com/arty-name/woff2otf/blob/master/woff2otf.js (Apache2)
*/ function $bc7831423112e56a$var$woff2otfFactory() {
    return function(r) {
        var e = Uint8Array, n = Uint16Array, t = Uint32Array, a = new e([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), i = new e([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), o = new e([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), f = function(r, e) {
            for(var a = new n(31), i = 0; i < 31; ++i)a[i] = e += 1 << r[i - 1];
            var o = new t(a[30]);
            for(i = 1; i < 30; ++i)for(var f = a[i]; f < a[i + 1]; ++f)o[f] = f - a[i] << 5 | i;
            return [
                a,
                o
            ];
        }, u = f(a, 2), v = u[0], s = u[1];
        v[28] = 258, s[258] = 28;
        for(var l = f(i, 0)[0], c = new n(32768), g = 0; g < 32768; ++g){
            var h = (43690 & g) >>> 1 | (21845 & g) << 1;
            h = (61680 & (h = (52428 & h) >>> 2 | (13107 & h) << 2)) >>> 4 | (3855 & h) << 4, c[g] = ((65280 & h) >>> 8 | (255 & h) << 8) >>> 1;
        }
        var w = function(r, e, t) {
            for(var a = r.length, i = 0, o = new n(e); i < a; ++i)++o[r[i] - 1];
            var f, u = new n(e);
            for(i = 0; i < e; ++i)u[i] = u[i - 1] + o[i - 1] << 1;
            if (t) {
                f = new n(1 << e);
                var v = 15 - e;
                for(i = 0; i < a; ++i)if (r[i]) for(var s = i << 4 | r[i], l = e - r[i], g = u[r[i] - 1]++ << l, h = g | (1 << l) - 1; g <= h; ++g)f[c[g] >>> v] = s;
            } else for(f = new n(a), i = 0; i < a; ++i)r[i] && (f[i] = c[u[r[i] - 1]++] >>> 15 - r[i]);
            return f;
        }, d = new e(288);
        for(g = 0; g < 144; ++g)d[g] = 8;
        for(g = 144; g < 256; ++g)d[g] = 9;
        for(g = 256; g < 280; ++g)d[g] = 7;
        for(g = 280; g < 288; ++g)d[g] = 8;
        var m = new e(32);
        for(g = 0; g < 32; ++g)m[g] = 5;
        var b = w(d, 9, 1), p = w(m, 5, 1), y = function(r) {
            for(var e = r[0], n = 1; n < r.length; ++n)r[n] > e && (e = r[n]);
            return e;
        }, L = function(r, e, n) {
            var t = e / 8 | 0;
            return (r[t] | r[t + 1] << 8) >> (7 & e) & n;
        }, U = function(r, e) {
            var n = e / 8 | 0;
            return (r[n] | r[n + 1] << 8 | r[n + 2] << 16) >> (7 & e);
        }, k = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], T = function(r, e, n) {
            var t = new Error(e || k[r]);
            if (t.code = r, Error.captureStackTrace && Error.captureStackTrace(t, T), !n) throw t;
            return t;
        }, O = function(r, f, u) {
            var s = r.length;
            if (!s || u && !u.l && s < 5) return f || new e(0);
            var c = !f || u, g = !u || u.i;
            u || (u = {}), f || (f = new e(3 * s));
            var h, d = function(r) {
                var n = f.length;
                if (r > n) {
                    var t = new e(Math.max(2 * n, r));
                    t.set(f), f = t;
                }
            }, m = u.f || 0, k = u.p || 0, O = u.b || 0, A = u.l, x = u.d, E = u.m, D = u.n, M = 8 * s;
            do {
                if (!A) {
                    u.f = m = L(r, k, 1);
                    var S = L(r, k + 1, 3);
                    if (k += 3, !S) {
                        var V = r[(I = ((h = k) / 8 | 0) + (7 & h && 1) + 4) - 4] | r[I - 3] << 8, _ = I + V;
                        if (_ > s) {
                            g && T(0);
                            break;
                        }
                        c && d(O + V), f.set(r.subarray(I, _), O), u.b = O += V, u.p = k = 8 * _;
                        continue;
                    }
                    if (1 == S) A = b, x = p, E = 9, D = 5;
                    else if (2 == S) {
                        var j = L(r, k, 31) + 257, z = L(r, k + 10, 15) + 4, C = j + L(r, k + 5, 31) + 1;
                        k += 14;
                        for(var F = new e(C), P = new e(19), q = 0; q < z; ++q)P[o[q]] = L(r, k + 3 * q, 7);
                        k += 3 * z;
                        var B = y(P), G = (1 << B) - 1, H = w(P, B, 1);
                        for(q = 0; q < C;){
                            var I, J = H[L(r, k, G)];
                            if (k += 15 & J, (I = J >>> 4) < 16) F[q++] = I;
                            else {
                                var K = 0, N = 0;
                                for(16 == I ? (N = 3 + L(r, k, 3), k += 2, K = F[q - 1]) : 17 == I ? (N = 3 + L(r, k, 7), k += 3) : 18 == I && (N = 11 + L(r, k, 127), k += 7); N--;)F[q++] = K;
                            }
                        }
                        var Q = F.subarray(0, j), R = F.subarray(j);
                        E = y(Q), D = y(R), A = w(Q, E, 1), x = w(R, D, 1);
                    } else T(1);
                    if (k > M) {
                        g && T(0);
                        break;
                    }
                }
                c && d(O + 131072);
                for(var W = (1 << E) - 1, X = (1 << D) - 1, Y = k;; Y = k){
                    var Z = (K = A[U(r, k) & W]) >>> 4;
                    if ((k += 15 & K) > M) {
                        g && T(0);
                        break;
                    }
                    if (K || T(2), Z < 256) f[O++] = Z;
                    else {
                        if (256 == Z) {
                            Y = k, A = null;
                            break;
                        }
                        var $ = Z - 254;
                        if (Z > 264) {
                            var rr = a[q = Z - 257];
                            $ = L(r, k, (1 << rr) - 1) + v[q], k += rr;
                        }
                        var er = x[U(r, k) & X], nr = er >>> 4;
                        er || T(3), k += 15 & er;
                        R = l[nr];
                        if (nr > 3) {
                            rr = i[nr];
                            R += U(r, k) & (1 << rr) - 1, k += rr;
                        }
                        if (k > M) {
                            g && T(0);
                            break;
                        }
                        c && d(O + 131072);
                        for(var tr = O + $; O < tr; O += 4)f[O] = f[O - R], f[O + 1] = f[O + 1 - R], f[O + 2] = f[O + 2 - R], f[O + 3] = f[O + 3 - R];
                        O = tr;
                    }
                }
                u.l = A, u.p = Y, u.b = O, A && (m = 1, u.m = E, u.d = x, u.n = D);
            }while (!m);
            return O == f.length ? f : function(r, a, i) {
                (null == a || a < 0) && (a = 0), (null == i || i > r.length) && (i = r.length);
                var o = new (r instanceof n ? n : r instanceof t ? t : e)(i - a);
                return o.set(r.subarray(a, i)), o;
            }(f, 0, O);
        }, A = new e(0);
        var x = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            x.decode(A, {
                stream: !0
            });
        } catch (r) {}
        return r.convert_streams = function(r) {
            var e = new DataView(r), n = 0;
            function t() {
                var r = e.getUint16(n);
                return n += 2, r;
            }
            function a() {
                var r = e.getUint32(n);
                return n += 4, r;
            }
            function i(r) {
                m.setUint16(b, r), b += 2;
            }
            function o(r) {
                m.setUint32(b, r), b += 4;
            }
            for(var f = {
                signature: a(),
                flavor: a(),
                length: a(),
                numTables: t(),
                reserved: t(),
                totalSfntSize: a(),
                majorVersion: t(),
                minorVersion: t(),
                metaOffset: a(),
                metaLength: a(),
                metaOrigLength: a(),
                privOffset: a(),
                privLength: a()
            }, u = 0; Math.pow(2, u) <= f.numTables;)u++;
            u--;
            for(var v = 16 * Math.pow(2, u), s = 16 * f.numTables - v, l = 12, c = [], g = 0; g < f.numTables; g++)c.push({
                tag: a(),
                offset: a(),
                compLength: a(),
                origLength: a(),
                origChecksum: a()
            }), l += 16;
            var h, w = new Uint8Array(12 + 16 * c.length + c.reduce(function(r, e) {
                return r + e.origLength + 4;
            }, 0)), d = w.buffer, m = new DataView(d), b = 0;
            return o(f.flavor), i(f.numTables), i(v), i(u), i(s), c.forEach(function(r) {
                o(r.tag), o(r.origChecksum), o(l), o(r.origLength), r.outOffset = l, (l += r.origLength) % 4 != 0 && (l += 4 - l % 4);
            }), c.forEach(function(e) {
                var n, t = r.slice(e.offset, e.offset + e.compLength);
                if (e.compLength != e.origLength) {
                    var a = new Uint8Array(e.origLength);
                    n = new Uint8Array(t, 2), O(n, a);
                } else a = new Uint8Array(t);
                w.set(a, e.outOffset);
                var i = 0;
                (l = e.outOffset + e.origLength) % 4 != 0 && (i = 4 - l % 4), w.set(new Uint8Array(i).buffer, e.outOffset + e.origLength), h = l + i;
            }), d.slice(0, h);
        }, Object.defineProperty(r, "__esModule", {
            value: !0
        }), r;
    }({}).convert_streams;
}
/**
 * A factory wrapper parsing a font file using Typr.
 * Also adds support for WOFF files (not WOFF2).
 */ /**
 * @typedef ParsedFont
 * @property {number} ascender
 * @property {number} descender
 * @property {number} xHeight
 * @property {(number) => boolean} supportsCodePoint
 * @property {(text:string, fontSize:number, letterSpacing:number, callback) => number} forEachGlyph
 * @property {number} lineGap
 * @property {number} capHeight
 * @property {number} unitsPerEm
 */ /**
 * @typedef {(buffer: ArrayBuffer) => ParsedFont} FontParser
 */ /**
 * @returns {FontParser}
 */ function $bc7831423112e56a$var$parserFactory(Typr, woff2otf) {
    const cmdArgLengths = {
        M: 2,
        L: 2,
        Q: 4,
        C: 6,
        Z: 0
    };
    // {joinType: "skip+step,..."}
    const joiningTypeRawData = {
        "C": "18g,ca,368,1kz",
        "D": "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v",
        "R": "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6",
        "L": "x9u,jff,a,fd,jv",
        "T": "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n"
    };
    const JT_LEFT = 1, JT_RIGHT = 2, JT_DUAL = 4, JT_TRANSPARENT = 8, JT_JOIN_CAUSING = 16, JT_NON_JOINING = 32; //indicates that a character does not join with the preceding or with the subsequent character.,
    let joiningTypeMap;
    function getCharJoiningType(ch) {
        if (!joiningTypeMap) {
            const m = {
                R: JT_RIGHT,
                L: JT_LEFT,
                D: JT_DUAL,
                C: JT_JOIN_CAUSING,
                U: JT_NON_JOINING,
                T: JT_TRANSPARENT
            };
            joiningTypeMap = new Map();
            for(let type in joiningTypeRawData){
                let lastCode = 0;
                joiningTypeRawData[type].split(',').forEach((range)=>{
                    let [skip, step] = range.split('+');
                    skip = parseInt(skip, 36);
                    step = step ? parseInt(step, 36) : 0;
                    joiningTypeMap.set(lastCode += skip, m[type]);
                    for(let i = step; i--;)joiningTypeMap.set(++lastCode, m[type]);
                });
            }
        }
        return joiningTypeMap.get(ch) || JT_NON_JOINING;
    }
    const ISOL = 1, INIT = 2, FINA = 3, MEDI = 4;
    const formsToFeatures = [
        null,
        'isol',
        'init',
        'fina',
        'medi'
    ];
    function detectJoiningForms(str) {
        // This implements the algorithm described here:
        // https://github.com/n8willis/opentype-shaping-documents/blob/master/opentype-shaping-arabic-general.md
        const joiningForms = new Uint8Array(str.length);
        let prevJoiningType = JT_NON_JOINING;
        let prevForm = ISOL;
        let prevIndex = -1;
        for(let i = 0; i < str.length; i++){
            const code = str.codePointAt(i);
            let joiningType = getCharJoiningType(code) | 0;
            let form = ISOL;
            if (joiningType & JT_TRANSPARENT) continue;
            if (prevJoiningType & (JT_LEFT | JT_DUAL | JT_JOIN_CAUSING)) {
                if (joiningType & (JT_RIGHT | JT_DUAL | JT_JOIN_CAUSING)) {
                    form = FINA;
                    // isol->init, fina->medi
                    if (prevForm === ISOL || prevForm === FINA) joiningForms[prevIndex]++;
                } else if (joiningType & (JT_LEFT | JT_NON_JOINING)) // medi->fina, init->isol
                {
                    if (prevForm === INIT || prevForm === MEDI) joiningForms[prevIndex]--;
                }
            } else if (prevJoiningType & (JT_RIGHT | JT_NON_JOINING)) // medi->fina, init->isol
            {
                if (prevForm === INIT || prevForm === MEDI) joiningForms[prevIndex]--;
            }
            prevForm = joiningForms[i] = form;
            prevJoiningType = joiningType;
            prevIndex = i;
            if (code > 0xffff) i++;
        }
        // console.log(str.split('').map(ch => ch.codePointAt(0).toString(16)))
        // console.log(str.split('').map(ch => getCharJoiningType(ch.codePointAt(0))))
        // console.log(Array.from(joiningForms).map(f => formsToFeatures[f] || 'none'))
        return joiningForms;
    }
    function stringToGlyphs(font, str) {
        const glyphIds = [];
        for(let i = 0; i < str.length; i++){
            const cc = str.codePointAt(i);
            if (cc > 0xffff) i++;
            glyphIds.push(Typr.U.codeToGlyph(font, cc));
        }
        const gsub = font['GSUB'];
        if (gsub) {
            const { lookupList: lookupList, featureList: featureList } = gsub;
            let joiningForms;
            const supportedFeatures = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws|ccmp)$/;
            const usedLookups = [];
            featureList.forEach((feature)=>{
                if (supportedFeatures.test(feature.tag)) for(let ti = 0; ti < feature.tab.length; ti++){
                    if (usedLookups[feature.tab[ti]]) continue;
                    usedLookups[feature.tab[ti]] = true;
                    const tab = lookupList[feature.tab[ti]];
                    const isJoiningFeature = /^(isol|init|fina|medi)$/.test(feature.tag);
                    if (isJoiningFeature && !joiningForms) joiningForms = detectJoiningForms(str);
                    for(let ci = 0; ci < glyphIds.length; ci++)if (!joiningForms || !isJoiningFeature || formsToFeatures[joiningForms[ci]] === feature.tag) Typr.U._applySubs(glyphIds, ci, tab, lookupList);
                }
            });
        }
        return glyphIds;
    }
    // Calculate advances and x/y offsets for each glyph, e.g. kerning and mark
    // attachments. This is a more complete version of Typr.U.getPairAdjustment
    // and should become an upstream replacement eventually.
    function calcGlyphPositions(font, glyphIds) {
        const positions = new Int16Array(glyphIds.length * 3); // [offsetX, offsetY, advanceX, ...]
        let glyphIndex = 0;
        for(; glyphIndex < glyphIds.length; glyphIndex++){
            const glyphId = glyphIds[glyphIndex];
            if (glyphId === -1) continue;
            positions[glyphIndex * 3 + 2] = font.hmtx.aWidth[glyphId]; // populate advanceX in...advance.
            const gpos = font.GPOS;
            if (gpos) {
                const llist = gpos.lookupList;
                for(let i = 0; i < llist.length; i++){
                    const lookup = llist[i];
                    for(let j = 0; j < lookup.tabs.length; j++){
                        const tab = lookup.tabs[j];
                        // Single char placement
                        if (lookup.ltype === 1) {
                            const ind = Typr._lctf.coverageIndex(tab.coverage, glyphId);
                            if (ind !== -1 && tab.pos) {
                                applyValueRecord(tab.pos, glyphIndex);
                                break;
                            }
                        } else if (lookup.ltype === 2) {
                            let adj = null;
                            let prevGlyphIndex = getPrevGlyphIndex();
                            if (prevGlyphIndex !== -1) {
                                const coverageIndex = Typr._lctf.coverageIndex(tab.coverage, glyphIds[prevGlyphIndex]);
                                if (coverageIndex !== -1) {
                                    if (tab.fmt === 1) {
                                        const right = tab.pairsets[coverageIndex];
                                        for(let k = 0; k < right.length; k++)if (right[k].gid2 === glyphId) adj = right[k];
                                    } else if (tab.fmt === 2) {
                                        const c1 = Typr.U._getGlyphClass(glyphIds[prevGlyphIndex], tab.classDef1);
                                        const c2 = Typr.U._getGlyphClass(glyphId, tab.classDef2);
                                        adj = tab.matrix[c1][c2];
                                    }
                                    if (adj) {
                                        if (adj.val1) applyValueRecord(adj.val1, prevGlyphIndex);
                                        if (adj.val2) applyValueRecord(adj.val2, glyphIndex);
                                        break;
                                    }
                                }
                            }
                        } else if (lookup.ltype === 4) {
                            const markArrIndex = Typr._lctf.coverageIndex(tab.markCoverage, glyphId);
                            if (markArrIndex !== -1) {
                                const baseGlyphIndex = getPrevGlyphIndex(isBaseGlyph);
                                const baseArrIndex = baseGlyphIndex === -1 ? -1 : Typr._lctf.coverageIndex(tab.baseCoverage, glyphIds[baseGlyphIndex]);
                                if (baseArrIndex !== -1) {
                                    const markRecord = tab.markArray[markArrIndex];
                                    const baseAnchor = tab.baseArray[baseArrIndex][markRecord.markClass];
                                    positions[glyphIndex * 3] = baseAnchor.x - markRecord.x + positions[baseGlyphIndex * 3] - positions[baseGlyphIndex * 3 + 2];
                                    positions[glyphIndex * 3 + 1] = baseAnchor.y - markRecord.y + positions[baseGlyphIndex * 3 + 1];
                                    break;
                                }
                            }
                        } else if (lookup.ltype === 6) {
                            const mark1ArrIndex = Typr._lctf.coverageIndex(tab.mark1Coverage, glyphId);
                            if (mark1ArrIndex !== -1) {
                                const prevGlyphIndex = getPrevGlyphIndex();
                                if (prevGlyphIndex !== -1) {
                                    const prevGlyphId = glyphIds[prevGlyphIndex];
                                    if (getGlyphClass(font, prevGlyphId) === 3) {
                                        const mark2ArrIndex = Typr._lctf.coverageIndex(tab.mark2Coverage, prevGlyphId);
                                        if (mark2ArrIndex !== -1) {
                                            const mark1Record = tab.mark1Array[mark1ArrIndex];
                                            const mark2Anchor = tab.mark2Array[mark2ArrIndex][mark1Record.markClass];
                                            positions[glyphIndex * 3] = mark2Anchor.x - mark1Record.x + positions[prevGlyphIndex * 3] - positions[prevGlyphIndex * 3 + 2];
                                            positions[glyphIndex * 3 + 1] = mark2Anchor.y - mark1Record.y + positions[prevGlyphIndex * 3 + 1];
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (font.kern && !font.cff) {
                const prevGlyphIndex = getPrevGlyphIndex();
                if (prevGlyphIndex !== -1) {
                    const ind1 = font.kern.glyph1.indexOf(glyphIds[prevGlyphIndex]);
                    if (ind1 !== -1) {
                        const ind2 = font.kern.rval[ind1].glyph2.indexOf(glyphId);
                        if (ind2 !== -1) positions[prevGlyphIndex * 3 + 2] += font.kern.rval[ind1].vals[ind2];
                    }
                }
            }
        }
        return positions;
        function getPrevGlyphIndex(filter) {
            for(let i = glyphIndex - 1; i >= 0; i--){
                if (glyphIds[i] !== -1 && (!filter || filter(glyphIds[i]))) return i;
            }
            return -1;
        }
        function isBaseGlyph(glyphId) {
            return getGlyphClass(font, glyphId) === 1;
        }
        function applyValueRecord(source, gi) {
            for(let i = 0; i < 3; i++)positions[gi * 3 + i] += source[i] || 0;
        }
    }
    function getGlyphClass(font, glyphId) {
        const classDef = font.GDEF && font.GDEF.glyphClassDef;
        return classDef ? Typr.U._getGlyphClass(glyphId, classDef) : 0;
    }
    function firstNum(...args) {
        for(let i = 0; i < args.length; i++){
            if (typeof args[i] === 'number') return args[i];
        }
    }
    /**
   * @returns ParsedFont
   */ function wrapFontObj(typrFont) {
        const glyphMap = Object.create(null);
        const os2 = typrFont['OS/2'];
        const hhea = typrFont.hhea;
        const unitsPerEm = typrFont.head.unitsPerEm;
        const ascender = firstNum(os2 && os2.sTypoAscender, hhea && hhea.ascender, unitsPerEm);
        /** @type ParsedFont */ const fontObj = {
            unitsPerEm: unitsPerEm,
            ascender: ascender,
            descender: firstNum(os2 && os2.sTypoDescender, hhea && hhea.descender, 0),
            capHeight: firstNum(os2 && os2.sCapHeight, ascender),
            xHeight: firstNum(os2 && os2.sxHeight, ascender),
            lineGap: firstNum(os2 && os2.sTypoLineGap, hhea && hhea.lineGap),
            supportsCodePoint (code) {
                return Typr.U.codeToGlyph(typrFont, code) > 0;
            },
            forEachGlyph (text, fontSize, letterSpacing, callback) {
                let penX = 0;
                const fontScale = 1 / fontObj.unitsPerEm * fontSize;
                const glyphIds = stringToGlyphs(typrFont, text);
                let charIndex = 0;
                const positions = calcGlyphPositions(typrFont, glyphIds);
                glyphIds.forEach((glyphId, i)=>{
                    // Typr returns a glyph index per string codepoint, with -1s in place of those that
                    // were omitted due to ligature substitution. So we can track original index in the
                    // string via simple increment, and skip everything else when seeing a -1.
                    if (glyphId !== -1) {
                        let glyphObj = glyphMap[glyphId];
                        if (!glyphObj) {
                            const { cmds: cmds, crds: crds } = Typr.U.glyphToPath(typrFont, glyphId);
                            // Build path string
                            let path = '';
                            let crdsIdx = 0;
                            for(let i = 0, len = cmds.length; i < len; i++){
                                const numArgs = cmdArgLengths[cmds[i]];
                                path += cmds[i];
                                for(let j = 1; j <= numArgs; j++)path += (j > 1 ? ',' : '') + crds[crdsIdx++];
                            }
                            // Find extents - Glyf gives this in metadata but not CFF, and Typr doesn't
                            // normalize the two, so it's simplest just to iterate ourselves.
                            let xMin, yMin, xMax, yMax;
                            if (crds.length) {
                                xMin = yMin = Infinity;
                                xMax = yMax = -Infinity;
                                for(let i = 0, len = crds.length; i < len; i += 2){
                                    let x = crds[i];
                                    let y = crds[i + 1];
                                    if (x < xMin) xMin = x;
                                    if (y < yMin) yMin = y;
                                    if (x > xMax) xMax = x;
                                    if (y > yMax) yMax = y;
                                }
                            } else xMin = xMax = yMin = yMax = 0;
                            glyphObj = glyphMap[glyphId] = {
                                index: glyphId,
                                advanceWidth: typrFont.hmtx.aWidth[glyphId],
                                xMin: xMin,
                                yMin: yMin,
                                xMax: xMax,
                                yMax: yMax,
                                path: path
                            };
                        }
                        callback.call(null, glyphObj, penX + positions[i * 3] * fontScale, positions[i * 3 + 1] * fontScale, charIndex);
                        penX += positions[i * 3 + 2] * fontScale;
                        if (letterSpacing) penX += letterSpacing * fontSize;
                    }
                    charIndex += text.codePointAt(charIndex) > 0xffff ? 2 : 1;
                });
                return penX;
            }
        };
        return fontObj;
    }
    /**
   * @type FontParser
   */ return function parse(buffer) {
        // Look to see if we have a WOFF file and convert it if so:
        const peek = new Uint8Array(buffer, 0, 4);
        const tag = Typr._bin.readASCII(peek, 0, 4);
        if (tag === 'wOFF') buffer = woff2otf(buffer);
        else if (tag === 'wOF2') throw new Error('woff2 fonts not supported');
        return wrapFontObj(Typr.parse(buffer)[0]);
    };
}
const $bc7831423112e56a$var$workerModule = /*#__PURE__*/ (0, $62dc134116dcb5c9$export$e2063b0a5e3f6023)({
    name: 'Typr Font Parser',
    dependencies: [
        $bc7831423112e56a$var$typrFactory,
        $bc7831423112e56a$var$woff2otfFactory,
        $bc7831423112e56a$var$parserFactory
    ],
    init (typrFactory, woff2otfFactory, parserFactory) {
        const Typr = typrFactory();
        const woff2otf = woff2otfFactory();
        return parserFactory(Typr, woff2otf);
    }
});
/*!
Custom bundle of @unicode-font-resolver/client v1.0.2 (https://github.com/lojjic/unicode-font-resolver)
for use in Troika text rendering. 
Original MIT license applies
*/ function $bc7831423112e56a$var$unicodeFontResolverClientFactory() {
    return function(t) {
        var n = function() {
            this.buckets = new Map;
        };
        n.prototype.add = function(t) {
            var n = t >> 5;
            this.buckets.set(n, (this.buckets.get(n) || 0) | 1 << (31 & t));
        }, n.prototype.has = function(t) {
            var n = this.buckets.get(t >> 5);
            return void 0 !== n && 0 != (n & 1 << (31 & t));
        }, n.prototype.serialize = function() {
            var t = [];
            return this.buckets.forEach(function(n, r) {
                t.push((+r).toString(36) + ":" + n.toString(36));
            }), t.join(",");
        }, n.prototype.deserialize = function(t) {
            var n = this;
            this.buckets.clear(), t.split(",").forEach(function(t) {
                var r = t.split(":");
                n.buckets.set(parseInt(r[0], 36), parseInt(r[1], 36));
            });
        };
        var r = Math.pow(2, 8), e = r - 1, o = ~e;
        function a(t) {
            var n = (function(t) {
                return t & o;
            })(t).toString(16), e = (function(t) {
                return (t & o) + r - 1;
            })(t).toString(16);
            return "codepoint-index/plane" + (t >> 16) + "/" + n + "-" + e + ".json";
        }
        function i(t, n) {
            var r = t & e, o = n.codePointAt(r / 6 | 0);
            return 0 != ((o = (o || 48) - 48) & 1 << r % 6);
        }
        function u(t, n) {
            var r;
            (r = t, r.replace(/U\+/gi, "").replace(/^,+|,+$/g, "").split(/,+/).map(function(t) {
                return t.split("-").map(function(t) {
                    return parseInt(t.trim(), 16);
                });
            })).forEach(function(t) {
                var r = t[0], e = t[1];
                void 0 === e && (e = r), n(r, e);
            });
        }
        function c(t, n) {
            u(t, function(t, r) {
                for(var e = t; e <= r; e++)n(e);
            });
        }
        var s = {}, f = {}, l = new WeakMap, v = "https://cdn.jsdelivr.net/gh/lojjic/unicode-font-resolver@v1.0.1/packages/data";
        function d(t) {
            var r = l.get(t);
            return r || (r = new n, c(t.ranges, function(t) {
                return r.add(t);
            }), l.set(t, r)), r;
        }
        var h, p = new Map;
        function g(t, n, r) {
            return t[n] ? n : t[r] ? r : function(t) {
                for(var n in t)return n;
            }(t);
        }
        function w(t, n) {
            var r = n;
            if (!t.includes(r)) {
                r = 1 / 0;
                for(var e = 0; e < t.length; e++)Math.abs(t[e] - n) < Math.abs(r - n) && (r = t[e]);
            }
            return r;
        }
        function k(t) {
            return h || (h = new Set, c("9-D,20,85,A0,1680,2000-200A,2028-202F,205F,3000", function(t) {
                h.add(t);
            })), h.has(t);
        }
        return t.CodePointSet = n, t.clearCache = function() {
            s = {}, f = {};
        }, t.getFontsForString = function(t, n) {
            void 0 === n && (n = {});
            var r, e = n.lang;
            void 0 === e && (e = /\p{Script=Hangul}/u.test(r = t) ? "ko" : /\p{Script=Hiragana}|\p{Script=Katakana}/u.test(r) ? "ja" : "en");
            var o = n.category;
            void 0 === o && (o = "sans-serif");
            var u = n.style;
            void 0 === u && (u = "normal");
            var c = n.weight;
            void 0 === c && (c = 400);
            var l = (n.dataUrl || v).replace(/\/$/g, ""), h = new Map, y = new Uint8Array(t.length), b = {}, m = {}, A = new Array(t.length), S = new Map, j = !1;
            function M(t) {
                var n = p.get(t);
                return n || (n = fetch(l + "/" + t).then(function(t) {
                    if (!t.ok) throw new Error(t.statusText);
                    return t.json().then(function(t) {
                        if (!Array.isArray(t) || 1 !== t[0]) throw new Error("Incorrect schema version; need 1, got " + t[0]);
                        return t[1];
                    });
                }).catch(function(n) {
                    if (l !== v) return j || (console.error('unicode-font-resolver: Failed loading from dataUrl "' + l + '", trying default CDN. ' + n.message), j = !0), l = v, p.delete(t), M(t);
                    throw n;
                }), p.set(t, n)), n;
            }
            for(var P = function(n) {
                var r = t.codePointAt(n), e = a(r);
                A[n] = e, s[e] || S.has(e) || S.set(e, M(e).then(function(t) {
                    s[e] = t;
                })), r > 65535 && (n++, E = n);
            }, E = 0; E < t.length; E++)P(E);
            return Promise.all(S.values()).then(function() {
                S.clear();
                for(var n = function(n) {
                    var o = t.codePointAt(n), a = null, u = s[A[n]], c = void 0;
                    for(var l in u){
                        var v = m[l];
                        if (void 0 === v && (v = m[l] = new RegExp(l).test(e || "en")), v) {
                            for(var d in c = l, u[l])if (i(o, u[l][d])) {
                                a = d;
                                break;
                            }
                            break;
                        }
                    }
                    if (!a) {
                        t: for(var h in u)if (h !== c) {
                            for(var p in u[h])if (i(o, u[h][p])) {
                                a = p;
                                break t;
                            }
                        }
                    }
                    a || (console.debug("No font coverage for U+" + o.toString(16)), a = "latin"), A[n] = a, f[a] || S.has(a) || S.set(a, M("font-meta/" + a + ".json").then(function(t) {
                        f[a] = t;
                    })), o > 65535 && (n++, r = n);
                }, r = 0; r < t.length; r++)n(r);
                return Promise.all(S.values());
            }).then(function() {
                for(var n, r = null, e = 0; e < t.length; e++){
                    var a = t.codePointAt(e);
                    if (r && (k(a) || d(r).has(a))) y[e] = y[e - 1];
                    else {
                        r = f[A[e]];
                        var i = b[r.id];
                        if (!i) {
                            var s = r.typeforms, v = g(s, o, "sans-serif"), p = g(s[v], u, "normal"), m = w(null === (n = s[v]) || void 0 === n ? void 0 : n[p], c);
                            i = b[r.id] = l + "/font-files/" + r.id + "/" + v + "." + p + "." + m + ".woff";
                        }
                        var S = h.get(i);
                        null == S && (S = h.size, h.set(i, S)), y[e] = S;
                    }
                    a > 65535 && (e++, y[e] = y[e - 1]);
                }
                return {
                    fontUrls: Array.from(h.keys()),
                    chars: y
                };
            });
        }, Object.defineProperty(t, "__esModule", {
            value: !0
        }), t;
    }({});
}
/**
 * @typedef {string | {src:string, label?:string, unicodeRange?:string, lang?:string}} UserFont
 */ /**
 * @typedef {ClientOptions} FontResolverOptions
 * @property {Array<UserFont>|UserFont} [fonts]
 * @property {'normal'|'italic'} [style]
 * @property {'normal'|'bold'|number} [style]
 * @property {string} [unicodeFontsURL]
 */ /**
 * @typedef {Object} FontResolverResult
 * @property {Uint8Array} chars
 * @property {Array<ParsedFont & {src:string}>} fonts
 */ /**
 * @typedef {function} FontResolver
 * @param {string} text
 * @param {(FontResolverResult) => void} callback
 * @param {FontResolverOptions} [options]
 */ /**
 * Factory for the FontResolver function.
 * @param {FontParser} fontParser
 * @param {{getFontsForString: function, CodePointSet: function}} unicodeFontResolverClient
 * @return {FontResolver}
 */ function $bc7831423112e56a$var$createFontResolver(fontParser, unicodeFontResolverClient) {
    /**
   * @type {Record<string, ParsedFont>}
   */ const parsedFonts = Object.create(null);
    /**
   * @type {Record<string, Array<(ParsedFont) => void>>}
   */ const loadingFonts = Object.create(null);
    /**
   * Load a given font url
   */ function doLoadFont(url, callback) {
        const onError = (err)=>{
            console.error(`Failure loading font ${url}`, err);
        };
        try {
            const request = new XMLHttpRequest();
            request.open('get', url, true);
            request.responseType = 'arraybuffer';
            request.onload = function() {
                if (request.status >= 400) onError(new Error(request.statusText));
                else if (request.status > 0) try {
                    const fontObj = fontParser(request.response);
                    fontObj.src = url;
                    callback(fontObj);
                } catch (e) {
                    onError(e);
                }
            };
            request.onerror = onError;
            request.send();
        } catch (err) {
            onError(err);
        }
    }
    /**
   * Load a given font url if needed, invoking a callback when it's loaded. If already
   * loaded, the callback will be called synchronously.
   * @param {string} fontUrl
   * @param {(font: ParsedFont) => void} callback
   */ function loadFont(fontUrl, callback) {
        let font = parsedFonts[fontUrl];
        if (font) callback(font);
        else if (loadingFonts[fontUrl]) loadingFonts[fontUrl].push(callback);
        else {
            loadingFonts[fontUrl] = [
                callback
            ];
            doLoadFont(fontUrl, (fontObj)=>{
                fontObj.src = fontUrl;
                parsedFonts[fontUrl] = fontObj;
                loadingFonts[fontUrl].forEach((cb)=>cb(fontObj));
                delete loadingFonts[fontUrl];
            });
        }
    }
    /**
   * For a given string of text, determine which fonts are required to fully render it and
   * ensure those fonts are loaded.
   */ return function(text, callback, { lang: lang, fonts: userFonts = [], style: style = 'normal', weight: weight = 'normal', unicodeFontsURL: unicodeFontsURL } = {}) {
        const charResolutions = new Uint8Array(text.length);
        const fontResolutions = [];
        if (!text.length) allDone();
        const fontIndices = new Map();
        const fallbackRanges = []; // [[start, end], ...]
        if (style !== 'italic') style = 'normal';
        if (typeof weight !== 'number') weight = weight === 'bold' ? 700 : 400;
        if (userFonts && !Array.isArray(userFonts)) userFonts = [
            userFonts
        ];
        userFonts = userFonts.slice()// filter by language
        .filter((def)=>!def.lang || def.lang.test(lang))// switch order for easier iteration
        .reverse();
        if (userFonts.length) {
            const UNKNOWN = 0;
            const RESOLVED = 1;
            const NEEDS_FALLBACK = 2;
            let prevCharResult = UNKNOWN;
            (function resolveUserFonts(startIndex = 0) {
                for(let i = startIndex, iLen = text.length; i < iLen; i++){
                    const codePoint = text.codePointAt(i);
                    // Carry previous character's result forward if:
                    // - it resolved to a font that also covers this character
                    // - this character is whitespace
                    if (prevCharResult === RESOLVED && fontResolutions[charResolutions[i - 1]].supportsCodePoint(codePoint) || /\s/.test(text[i])) {
                        charResolutions[i] = charResolutions[i - 1];
                        if (prevCharResult === NEEDS_FALLBACK) fallbackRanges[fallbackRanges.length - 1][1] = i;
                    } else {
                        for(let j = charResolutions[i], jLen = userFonts.length; j <= jLen; j++)if (j === jLen) {
                            // none of the user fonts matched; needs fallback
                            const range = prevCharResult === NEEDS_FALLBACK ? fallbackRanges[fallbackRanges.length - 1] : fallbackRanges[fallbackRanges.length] = [
                                i,
                                i
                            ];
                            range[1] = i;
                            prevCharResult = NEEDS_FALLBACK;
                        } else {
                            charResolutions[i] = j;
                            const { src: src, unicodeRange: unicodeRange } = userFonts[j];
                            // filter by optional explicit unicode ranges
                            if (!unicodeRange || isCodeInRanges(codePoint, unicodeRange)) {
                                const fontObj = parsedFonts[src];
                                // font not yet loaded, load it and resume
                                if (!fontObj) {
                                    loadFont(src, ()=>{
                                        resolveUserFonts(i);
                                    });
                                    return;
                                }
                                // if the font actually contains a glyph for this char, lock it in
                                if (fontObj.supportsCodePoint(codePoint)) {
                                    let fontIndex = fontIndices.get(fontObj);
                                    if (typeof fontIndex !== 'number') {
                                        fontIndex = fontResolutions.length;
                                        fontResolutions.push(fontObj);
                                        fontIndices.set(fontObj, fontIndex);
                                    }
                                    charResolutions[i] = fontIndex;
                                    prevCharResult = RESOLVED;
                                    break;
                                }
                            }
                        }
                    }
                    if (codePoint > 0xffff && i + 1 < iLen) {
                        charResolutions[i + 1] = charResolutions[i];
                        i++;
                        if (prevCharResult === NEEDS_FALLBACK) fallbackRanges[fallbackRanges.length - 1][1] = i;
                    }
                }
                resolveFallbacks();
            })();
        } else {
            fallbackRanges.push([
                0,
                text.length - 1
            ]);
            resolveFallbacks();
        }
        function resolveFallbacks() {
            if (fallbackRanges.length) {
                // Combine all fallback substrings into a single string for querying
                const fallbackString = fallbackRanges.map((range)=>text.substring(range[0], range[1] + 1)).join('\n');
                unicodeFontResolverClient.getFontsForString(fallbackString, {
                    lang: lang || undefined,
                    style: style,
                    weight: weight,
                    dataUrl: unicodeFontsURL
                }).then(({ fontUrls: fontUrls, chars: chars })=>{
                    // Extract results and put them back in the main array
                    const fontIndexOffset = fontResolutions.length;
                    let charIdx = 0;
                    fallbackRanges.forEach((range)=>{
                        for(let i = 0, endIdx = range[1] - range[0]; i <= endIdx; i++)charResolutions[range[0] + i] = chars[charIdx++] + fontIndexOffset;
                        charIdx++; //skip segment separator
                    });
                    // Load and parse the fallback fonts - avoiding Promise here to prevent polyfills in the worker
                    let loadedCount = 0;
                    fontUrls.forEach((url, i)=>{
                        loadFont(url, (fontObj)=>{
                            fontResolutions[i + fontIndexOffset] = fontObj;
                            if (++loadedCount === fontUrls.length) allDone();
                        });
                    });
                });
            } else allDone();
        }
        function allDone() {
            callback({
                chars: charResolutions,
                fonts: fontResolutions
            });
        }
        function isCodeInRanges(code, ranges) {
            // todo optimize search - CodePointSet from unicode-font-resolver?
            for(let k = 0; k < ranges.length; k++){
                const [start, end = start] = ranges[k];
                if (start <= code && code <= end) return true;
            }
            return false;
        }
    };
}
const $bc7831423112e56a$export$85a5d697a084610 = /*#__PURE__*/ (0, $62dc134116dcb5c9$export$e2063b0a5e3f6023)({
    name: 'FontResolver',
    dependencies: [
        $bc7831423112e56a$var$createFontResolver,
        $bc7831423112e56a$var$workerModule,
        $bc7831423112e56a$var$unicodeFontResolverClientFactory
    ],
    init (createFontResolver, fontParser, unicodeFontResolverClientFactory) {
        return createFontResolver(fontParser, unicodeFontResolverClientFactory());
    }
});
/**
 * @typedef {number|'left'|'center'|'right'} AnchorXValue
 */ /**
 * @typedef {number|'top'|'top-baseline'|'top-cap'|'top-ex'|'middle'|'bottom-baseline'|'bottom'} AnchorYValue
 */ /**
 * @typedef {object} TypesetParams
 * @property {string} text
 * @property {UserFont|UserFont[]} [font]
 * @property {string} [lang]
 * @property {number} [sdfGlyphSize=64]
 * @property {number} [fontSize=1]
 * @property {number|'normal'|'bold'} [fontWeight='normal']
 * @property {'normal'|'italic'} [fontStyle='normal']
 * @property {number} [letterSpacing=0]
 * @property {'normal'|number} [lineHeight='normal']
 * @property {number} [maxWidth]
 * @property {'ltr'|'rtl'} [direction='ltr']
 * @property {string} [textAlign='left']
 * @property {number} [textIndent=0]
 * @property {'normal'|'nowrap'} [whiteSpace='normal']
 * @property {'normal'|'break-word'} [overflowWrap='normal']
 * @property {AnchorXValue} [anchorX=0]
 * @property {AnchorYValue} [anchorY=0]
 * @property {boolean} [metricsOnly=false]
 * @property {string} [unicodeFontsURL]
 * @property {FontResolverResult} [preResolvedFonts]
 * @property {boolean} [includeCaretPositions=false]
 * @property {number} [chunkedBoundsSize=8192]
 * @property {{[rangeStartIndex]: number}} [colorRanges]
 */ /**
 * @typedef {object} TypesetResult
 * @property {Uint16Array} glyphIds id for each glyph, specific to that glyph's font
 * @property {Uint8Array} glyphFontIndices index into fontData for each glyph
 * @property {Float32Array} glyphPositions x,y of each glyph's origin in layout
 * @property {{[font]: {[glyphId]: {path: string, pathBounds: number[]}}}} glyphData data about each glyph appearing in the text
 * @property {TypesetFontData[]} fontData data about each font used in the text
 * @property {Float32Array} [caretPositions] startX,endX,bottomY caret positions for each char
 * @property {Uint8Array} [glyphColors] color for each glyph, if color ranges supplied
 *         chunkedBounds, //total rects per (n=chunkedBoundsSize) consecutive glyphs
 *         fontSize, //calculated em height
 *         topBaseline: anchorYOffset + lines[0].baseline, //y coordinate of the top line's baseline
 *         blockBounds: [ //bounds for the whole block of text, including vertical padding for lineHeight
 *           anchorXOffset,
 *           anchorYOffset - totalHeight,
 *           anchorXOffset + maxLineWidth,
 *           anchorYOffset
 *         ],
 *         visibleBounds, //total bounds of visible text paths, may be larger or smaller than blockBounds
 *         timings
 */ /**
 * @typedef {object} TypesetFontData
 * @property src
 * @property unitsPerEm
 * @property ascender
 * @property descender
 * @property lineHeight
 * @property capHeight
 * @property xHeight
 */ /**
 * @typedef {function} TypesetterTypesetFunction - compute fonts and layout for some text.
 * @param {TypesetParams} params
 * @param {(TypesetResult) => void} callback - function called when typesetting is complete.
 *    If the params included `preResolvedFonts`, this will be called synchronously.
 */ /**
 * @typedef {function} TypesetterMeasureFunction - compute width/height for some text.
 * @param {TypesetParams} params
 * @param {(width:number, height:number) => void} callback - function called when measurement is complete.
 *    If the params included `preResolvedFonts`, this will be called synchronously.
 */ /**
 * Factory function that creates a self-contained environment for processing text typesetting requests.
 *
 * It is important that this function has no closure dependencies, so that it can be easily injected
 * into the source for a Worker without requiring a build step or complex dependency loading. All its
 * dependencies must be passed in at initialization.
 *
 * @param {FontResolver} resolveFonts - function to resolve a string to parsed fonts
 * @param {object} bidi - the bidi.js implementation object
 * @return {{typeset: TypesetterTypesetFunction, measure: TypesetterMeasureFunction}}
 */ function $bc7831423112e56a$var$createTypesetter(resolveFonts, bidi) {
    const INF = Infinity;
    // Set of Unicode Default_Ignorable_Code_Point characters, these will not produce visible glyphs
    // eslint-disable-next-line no-misleading-character-class
    const DEFAULT_IGNORABLE_CHARS = /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/;
    // This regex (instead of /\s/) allows us to select all whitespace EXCEPT for non-breaking white spaces
    const lineBreakingWhiteSpace = `[^\\S\\u00A0]`;
    // Incomplete set of characters that allow line breaking after them
    // In the future we may consider a full Unicode line breaking algorithm impl: https://www.unicode.org/reports/tr14
    const BREAK_AFTER_CHARS = new RegExp(`${lineBreakingWhiteSpace}|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]`);
    /**
   * Load and parse all the necessary fonts to render a given string of text, then group
   * them into consecutive runs of characters sharing a font.
   */ function calculateFontRuns({ text: text, lang: lang, fonts: fonts, style: style, weight: weight, preResolvedFonts: preResolvedFonts, unicodeFontsURL: unicodeFontsURL }, onDone) {
        const onResolved = ({ chars: chars, fonts: parsedFonts })=>{
            let curRun, prevVal;
            const runs = [];
            for(let i = 0; i < chars.length; i++)if (chars[i] !== prevVal) {
                prevVal = chars[i];
                runs.push(curRun = {
                    start: i,
                    end: i,
                    fontObj: parsedFonts[chars[i]]
                });
            } else curRun.end = i;
            onDone(runs);
        };
        if (preResolvedFonts) onResolved(preResolvedFonts);
        else resolveFonts(text, onResolved, {
            lang: lang,
            fonts: fonts,
            style: style,
            weight: weight,
            unicodeFontsURL: unicodeFontsURL
        });
    }
    /**
   * Main entry point.
   * Process a text string with given font and formatting parameters, and return all info
   * necessary to render all its glyphs.
   * @type TypesetterTypesetFunction
   */ function typeset({ text: text = '', font: font, lang: lang, sdfGlyphSize: sdfGlyphSize = 64, fontSize: fontSize = 400, fontWeight: fontWeight = 1, fontStyle: fontStyle = 'normal', letterSpacing: letterSpacing = 0, lineHeight: lineHeight = 'normal', maxWidth: maxWidth = INF, direction: direction, textAlign: textAlign = 'left', textIndent: textIndent = 0, whiteSpace: whiteSpace = 'normal', overflowWrap: overflowWrap = 'normal', anchorX: anchorX = 0, anchorY: anchorY = 0, metricsOnly: metricsOnly = false, unicodeFontsURL: unicodeFontsURL, preResolvedFonts: preResolvedFonts = null, includeCaretPositions: includeCaretPositions = false, chunkedBoundsSize: chunkedBoundsSize = 8192, colorRanges: colorRanges = null }, callback) {
        const mainStart = now();
        const timings = {
            fontLoad: 0,
            typesetting: 0
        };
        // Ensure newlines are normalized
        if (text.indexOf('\r') > -1) {
            console.info('Typesetter: got text with \\r chars; normalizing to \\n');
            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        }
        // Ensure we've got numbers not strings
        fontSize = +fontSize;
        letterSpacing = +letterSpacing;
        maxWidth = +maxWidth;
        lineHeight = lineHeight || 'normal';
        textIndent = +textIndent;
        calculateFontRuns({
            text: text,
            lang: lang,
            style: fontStyle,
            weight: fontWeight,
            fonts: typeof font === 'string' ? [
                {
                    src: font
                }
            ] : font,
            unicodeFontsURL: unicodeFontsURL,
            preResolvedFonts: preResolvedFonts
        }, (runs)=>{
            timings.fontLoad = now() - mainStart;
            const hasMaxWidth = isFinite(maxWidth);
            let glyphIds = null;
            let glyphFontIndices = null;
            let glyphPositions = null;
            let glyphData = null;
            let glyphColors = null;
            let caretPositions = null;
            let visibleBounds = null;
            let chunkedBounds = null;
            let maxLineWidth = 0;
            let renderableGlyphCount = 0;
            let canWrap = whiteSpace !== 'nowrap';
            const metricsByFont = new Map(); // fontObj -> metrics
            const typesetStart = now();
            // Distribute glyphs into lines based on wrapping
            let lineXOffset = textIndent;
            let prevRunEndX = 0;
            let currentLine = new TextLine();
            const lines = [
                currentLine
            ];
            runs.forEach((run)=>{
                const { fontObj: fontObj } = run;
                const { ascender: ascender, descender: descender, unitsPerEm: unitsPerEm, lineGap: lineGap, capHeight: capHeight, xHeight: xHeight } = fontObj;
                // Calculate metrics for each font used
                let fontData = metricsByFont.get(fontObj);
                if (!fontData) {
                    // Find conversion between native font units and fontSize units
                    const fontSizeMult = fontSize / unitsPerEm;
                    // Determine appropriate value for 'normal' line height based on the font's actual metrics
                    // This does not guarantee individual glyphs won't exceed the line height, e.g. Roboto; should we use yMin/Max instead?
                    const calcLineHeight = lineHeight === 'normal' ? (ascender - descender + lineGap) * fontSizeMult : lineHeight * fontSize;
                    // Determine line height and leading adjustments
                    const halfLeading = (calcLineHeight - (ascender - descender) * fontSizeMult) / 2;
                    const caretHeight = Math.min(calcLineHeight, (ascender - descender) * fontSizeMult);
                    const caretTop = (ascender + descender) / 2 * fontSizeMult + caretHeight / 2;
                    fontData = {
                        index: metricsByFont.size,
                        src: fontObj.src,
                        fontObj: fontObj,
                        fontSizeMult: fontSizeMult,
                        unitsPerEm: unitsPerEm,
                        ascender: ascender * fontSizeMult,
                        descender: descender * fontSizeMult,
                        capHeight: capHeight * fontSizeMult,
                        xHeight: xHeight * fontSizeMult,
                        lineHeight: calcLineHeight,
                        baseline: -halfLeading - ascender * fontSizeMult,
                        caretTop: // cap: -halfLeading - capHeight * fontSizeMult, // cap from top of line height
                        // ex: -halfLeading - xHeight * fontSizeMult, // ex from top of line height
                        caretTop,
                        caretBottom: caretTop - caretHeight
                    };
                    metricsByFont.set(fontObj, fontData);
                }
                const { fontSizeMult: fontSizeMult } = fontData;
                const runText = text.slice(run.start, run.end + 1);
                let prevGlyphX, prevGlyphObj;
                fontObj.forEachGlyph(runText, fontSize, letterSpacing, (glyphObj, glyphX, glyphY, charIndex)=>{
                    glyphX += prevRunEndX;
                    charIndex += run.start;
                    prevGlyphX = glyphX;
                    prevGlyphObj = glyphObj;
                    const char = text.charAt(charIndex);
                    const glyphWidth = glyphObj.advanceWidth * fontSizeMult;
                    const curLineCount = currentLine.count;
                    let nextLine;
                    // Calc isWhitespace and isEmpty once per glyphObj
                    if (!('isEmpty' in glyphObj)) {
                        glyphObj.isWhitespace = !!char && new RegExp(lineBreakingWhiteSpace).test(char);
                        glyphObj.canBreakAfter = !!char && BREAK_AFTER_CHARS.test(char);
                        glyphObj.isEmpty = glyphObj.xMin === glyphObj.xMax || glyphObj.yMin === glyphObj.yMax || DEFAULT_IGNORABLE_CHARS.test(char);
                    }
                    if (!glyphObj.isWhitespace && !glyphObj.isEmpty) renderableGlyphCount++;
                    // If a non-whitespace character overflows the max width, we need to soft-wrap
                    if (canWrap && hasMaxWidth && !glyphObj.isWhitespace && glyphX + glyphWidth + lineXOffset > maxWidth && curLineCount) {
                        // If it's the first char after a whitespace, start a new line
                        if (currentLine.glyphAt(curLineCount - 1).glyphObj.canBreakAfter) {
                            nextLine = new TextLine();
                            lineXOffset = -glyphX;
                        } else // Back up looking for a whitespace character to wrap at
                        for(let i = curLineCount; i--;){
                            // If we got the start of the line there's no soft break point; make hard break if overflowWrap='break-word'
                            if (i === 0 && overflowWrap === 'break-word') {
                                nextLine = new TextLine();
                                lineXOffset = -glyphX;
                                break;
                            } else if (currentLine.glyphAt(i).glyphObj.canBreakAfter) {
                                nextLine = currentLine.splitAt(i + 1);
                                const adjustX = nextLine.glyphAt(0).x;
                                lineXOffset -= adjustX;
                                for(let j = nextLine.count; j--;)nextLine.glyphAt(j).x -= adjustX;
                                break;
                            }
                        }
                        if (nextLine) {
                            currentLine.isSoftWrapped = true;
                            currentLine = nextLine;
                            lines.push(currentLine);
                            maxLineWidth = maxWidth; //after soft wrapping use maxWidth as calculated width
                        }
                    }
                    let fly = currentLine.glyphAt(currentLine.count);
                    fly.glyphObj = glyphObj;
                    fly.x = glyphX + lineXOffset;
                    fly.y = glyphY;
                    fly.width = glyphWidth;
                    fly.charIndex = charIndex;
                    fly.fontData = fontData;
                    // Handle hard line breaks
                    if (char === '\n') {
                        currentLine = new TextLine();
                        lines.push(currentLine);
                        lineXOffset = -(glyphX + glyphWidth + letterSpacing * fontSize) + textIndent;
                    }
                });
                // At the end of a run we must capture the x position as the starting point for the next run
                prevRunEndX = prevGlyphX + prevGlyphObj.advanceWidth * fontSizeMult + letterSpacing * fontSize;
            });
            // Calculate width/height/baseline of each line (excluding trailing whitespace) and maximum block width
            let totalHeight = 0;
            lines.forEach((line)=>{
                let isTrailingWhitespace = true;
                for(let i = line.count; i--;){
                    const glyphInfo = line.glyphAt(i);
                    // omit trailing whitespace from width calculation
                    if (isTrailingWhitespace && !glyphInfo.glyphObj.isWhitespace) {
                        line.width = glyphInfo.x + glyphInfo.width;
                        if (line.width > maxLineWidth) maxLineWidth = line.width;
                        isTrailingWhitespace = false;
                    }
                    // use the tallest line height, lowest baseline, and highest cap/ex
                    let { lineHeight: lineHeight, capHeight: capHeight, xHeight: xHeight, baseline: baseline } = glyphInfo.fontData;
                    if (lineHeight > line.lineHeight) line.lineHeight = lineHeight;
                    const baselineDiff = baseline - line.baseline;
                    if (baselineDiff < 0) {
                        line.baseline += baselineDiff;
                        line.cap += baselineDiff;
                        line.ex += baselineDiff;
                    }
                    // compare cap/ex based on new lowest baseline
                    line.cap = Math.max(line.cap, line.baseline + capHeight);
                    line.ex = Math.max(line.ex, line.baseline + xHeight);
                }
                line.baseline -= totalHeight;
                line.cap -= totalHeight;
                line.ex -= totalHeight;
                totalHeight += line.lineHeight;
            });
            // Find overall position adjustments for anchoring
            let anchorXOffset = 0;
            let anchorYOffset = 0;
            if (anchorX) {
                if (typeof anchorX === 'number') anchorXOffset = -anchorX;
                else if (typeof anchorX === 'string') anchorXOffset = -maxLineWidth * (anchorX === 'left' ? 0 : anchorX === 'center' ? 0.5 : anchorX === 'right' ? 1 : parsePercent(anchorX));
            }
            if (anchorY) {
                if (typeof anchorY === 'number') anchorYOffset = -anchorY;
                else if (typeof anchorY === 'string') anchorYOffset = anchorY === 'top' ? 0 : anchorY === 'top-baseline' ? -lines[0].baseline : anchorY === 'top-cap' ? -lines[0].cap : anchorY === 'top-ex' ? -lines[0].ex : anchorY === 'middle' ? totalHeight / 2 : anchorY === 'bottom' ? totalHeight : anchorY === 'bottom-baseline' ? -lines[lines.length - 1].baseline : parsePercent(anchorY) * totalHeight;
            }
            if (!metricsOnly) {
                // Resolve bidi levels
                const bidiLevelsResult = bidi.getEmbeddingLevels(text, direction);
                // Process each line, applying alignment offsets, adding each glyph to the atlas, and
                // collecting all renderable glyphs into a single collection.
                glyphIds = new Uint16Array(renderableGlyphCount);
                glyphFontIndices = new Uint8Array(renderableGlyphCount);
                glyphPositions = new Float32Array(renderableGlyphCount * 2);
                glyphData = {};
                visibleBounds = [
                    INF,
                    INF,
                    -INF,
                    -INF
                ];
                chunkedBounds = [];
                if (includeCaretPositions) caretPositions = new Float32Array(text.length * 4);
                if (colorRanges) glyphColors = new Uint8Array(renderableGlyphCount * 3);
                let renderableGlyphIndex = 0;
                let prevCharIndex = -1;
                let colorCharIndex = -1;
                let chunk;
                let currentColor;
                lines.forEach((line, lineIndex)=>{
                    let { count: lineGlyphCount, width: lineWidth } = line;
                    // Ignore empty lines
                    if (lineGlyphCount > 0) {
                        // Count trailing whitespaces, we want to ignore these for certain things
                        let trailingWhitespaceCount = 0;
                        for(let i = lineGlyphCount; i-- && line.glyphAt(i).glyphObj.isWhitespace;)trailingWhitespaceCount++;
                        // Apply horizontal alignment adjustments
                        let lineXOffset = 0;
                        let justifyAdjust = 0;
                        if (textAlign === 'center') lineXOffset = (maxLineWidth - lineWidth) / 2;
                        else if (textAlign === 'right') lineXOffset = maxLineWidth - lineWidth;
                        else if (textAlign === 'justify' && line.isSoftWrapped) {
                            // count non-trailing whitespace characters, and we'll adjust the offsets per character in the next loop
                            let whitespaceCount = 0;
                            for(let i = lineGlyphCount - trailingWhitespaceCount; i--;)if (line.glyphAt(i).glyphObj.isWhitespace) whitespaceCount++;
                            justifyAdjust = (maxLineWidth - lineWidth) / whitespaceCount;
                        }
                        if (justifyAdjust || lineXOffset) {
                            let justifyOffset = 0;
                            for(let i = 0; i < lineGlyphCount; i++){
                                let glyphInfo = line.glyphAt(i);
                                const glyphObj = glyphInfo.glyphObj;
                                glyphInfo.x += lineXOffset + justifyOffset;
                                // Expand non-trailing whitespaces for justify alignment
                                if (justifyAdjust !== 0 && glyphObj.isWhitespace && i < lineGlyphCount - trailingWhitespaceCount) {
                                    justifyOffset += justifyAdjust;
                                    glyphInfo.width += justifyAdjust;
                                }
                            }
                        }
                        // Perform bidi range flipping
                        const flips = bidi.getReorderSegments(text, bidiLevelsResult, line.glyphAt(0).charIndex, line.glyphAt(line.count - 1).charIndex);
                        for(let fi = 0; fi < flips.length; fi++){
                            const [start, end] = flips[fi];
                            // Map start/end string indices to indices in the line
                            let left = Infinity, right = -Infinity;
                            for(let i = 0; i < lineGlyphCount; i++)if (line.glyphAt(i).charIndex >= start) {
                                let startInLine = i, endInLine = i;
                                for(; endInLine < lineGlyphCount; endInLine++){
                                    let info = line.glyphAt(endInLine);
                                    if (info.charIndex > end) break;
                                    if (endInLine < lineGlyphCount - trailingWhitespaceCount) {
                                        left = Math.min(left, info.x);
                                        right = Math.max(right, info.x + info.width);
                                    }
                                }
                                for(let j = startInLine; j < endInLine; j++){
                                    const glyphInfo = line.glyphAt(j);
                                    glyphInfo.x = right - (glyphInfo.x + glyphInfo.width - left);
                                }
                                break;
                            }
                        }
                        // Assemble final data arrays
                        let glyphObj;
                        const setGlyphObj = (g)=>glyphObj = g;
                        for(let i = 0; i < lineGlyphCount; i++){
                            const glyphInfo = line.glyphAt(i);
                            glyphObj = glyphInfo.glyphObj;
                            const glyphId = glyphObj.index;
                            // Replace mirrored characters in rtl
                            const rtl = bidiLevelsResult.levels[glyphInfo.charIndex] & 1; //odd level means rtl
                            if (rtl) {
                                const mirrored = bidi.getMirroredCharacter(text[glyphInfo.charIndex]);
                                if (mirrored) glyphInfo.fontData.fontObj.forEachGlyph(mirrored, 0, 0, setGlyphObj);
                            }
                            // Add caret positions
                            if (includeCaretPositions) {
                                const { charIndex: charIndex, fontData: fontData } = glyphInfo;
                                const caretLeft = glyphInfo.x + anchorXOffset;
                                const caretRight = glyphInfo.x + glyphInfo.width + anchorXOffset;
                                caretPositions[charIndex * 4] = rtl ? caretRight : caretLeft; //start edge x
                                caretPositions[charIndex * 4 + 1] = rtl ? caretLeft : caretRight; //end edge x
                                caretPositions[charIndex * 4 + 2] = line.baseline + fontData.caretBottom + anchorYOffset; //common bottom y
                                caretPositions[charIndex * 4 + 3] = line.baseline + fontData.caretTop + anchorYOffset; //common top y
                                // If we skipped any chars from the previous glyph (due to ligature subs), fill in caret
                                // positions for those missing char indices; currently this uses a best-guess by dividing
                                // the ligature's width evenly. In the future we may try to use the font's LigatureCaretList
                                // table to get better interior caret positions.
                                const ligCount = charIndex - prevCharIndex;
                                if (ligCount > 1) fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                                prevCharIndex = charIndex;
                            }
                            // Track current color range
                            if (colorRanges) {
                                const { charIndex: charIndex } = glyphInfo;
                                while(charIndex > colorCharIndex){
                                    colorCharIndex++;
                                    if (colorRanges.hasOwnProperty(colorCharIndex)) currentColor = colorRanges[colorCharIndex];
                                }
                            }
                            // Get atlas data for renderable glyphs
                            if (!glyphObj.isWhitespace && !glyphObj.isEmpty) {
                                const idx = renderableGlyphIndex++;
                                const { fontSizeMult: fontSizeMult, src: fontSrc, index: fontIndex } = glyphInfo.fontData;
                                // Add this glyph's path data
                                const fontGlyphData = glyphData[fontSrc] || (glyphData[fontSrc] = {});
                                if (!fontGlyphData[glyphId]) fontGlyphData[glyphId] = {
                                    path: glyphObj.path,
                                    pathBounds: [
                                        glyphObj.xMin,
                                        glyphObj.yMin,
                                        glyphObj.xMax,
                                        glyphObj.yMax
                                    ]
                                };
                                // Determine final glyph position and add to glyphPositions array
                                const glyphX = glyphInfo.x + anchorXOffset;
                                const glyphY = glyphInfo.y + line.baseline + anchorYOffset;
                                glyphPositions[idx * 2] = glyphX;
                                glyphPositions[idx * 2 + 1] = glyphY;
                                // Track total visible bounds
                                const visX0 = glyphX + glyphObj.xMin * fontSizeMult;
                                const visY0 = glyphY + glyphObj.yMin * fontSizeMult;
                                const visX1 = glyphX + glyphObj.xMax * fontSizeMult;
                                const visY1 = glyphY + glyphObj.yMax * fontSizeMult;
                                if (visX0 < visibleBounds[0]) visibleBounds[0] = visX0;
                                if (visY0 < visibleBounds[1]) visibleBounds[1] = visY0;
                                if (visX1 > visibleBounds[2]) visibleBounds[2] = visX1;
                                if (visY1 > visibleBounds[3]) visibleBounds[3] = visY1;
                                // Track bounding rects for each chunk of N glyphs
                                if (idx % chunkedBoundsSize === 0) {
                                    chunk = {
                                        start: idx,
                                        end: idx,
                                        rect: [
                                            INF,
                                            INF,
                                            -INF,
                                            -INF
                                        ]
                                    };
                                    chunkedBounds.push(chunk);
                                }
                                chunk.end++;
                                const chunkRect = chunk.rect;
                                if (visX0 < chunkRect[0]) chunkRect[0] = visX0;
                                if (visY0 < chunkRect[1]) chunkRect[1] = visY0;
                                if (visX1 > chunkRect[2]) chunkRect[2] = visX1;
                                if (visY1 > chunkRect[3]) chunkRect[3] = visY1;
                                // Add to glyph ids and font indices arrays
                                glyphIds[idx] = glyphId;
                                glyphFontIndices[idx] = fontIndex;
                                // Add colors
                                if (colorRanges) {
                                    const start = idx * 3;
                                    glyphColors[start] = currentColor >> 16 & 255;
                                    glyphColors[start + 1] = currentColor >> 8 & 255;
                                    glyphColors[start + 2] = currentColor & 255;
                                }
                            }
                        }
                    }
                });
                // Fill in remaining caret positions in case the final character was a ligature
                if (caretPositions) {
                    const ligCount = text.length - prevCharIndex;
                    if (ligCount > 1) fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                }
            }
            // Assemble final data about each font used
            const fontData = [];
            metricsByFont.forEach(({ index: index, src: src, unitsPerEm: unitsPerEm, ascender: ascender, descender: descender, lineHeight: lineHeight, capHeight: capHeight, xHeight: xHeight })=>{
                fontData[index] = {
                    src: src,
                    unitsPerEm: unitsPerEm,
                    ascender: ascender,
                    descender: descender,
                    lineHeight: lineHeight,
                    capHeight: capHeight,
                    xHeight: xHeight
                };
            });
            // Timing stats
            timings.typesetting = now() - typesetStart;
            callback({
                glyphIds: glyphIds,
                glyphFontIndices: glyphFontIndices,
                glyphPositions: glyphPositions,
                glyphData: glyphData,
                fontData: fontData,
                caretPositions: caretPositions,
                glyphColors: // caretHeight, //height of cursor from bottom to top - todo per glyph?
                glyphColors,
                chunkedBounds: chunkedBounds,
                fontSize: fontSize,
                topBaseline: anchorYOffset + lines[0].baseline,
                blockBounds: [
                    anchorXOffset,
                    anchorYOffset - totalHeight,
                    anchorXOffset + maxLineWidth,
                    anchorYOffset
                ],
                visibleBounds: visibleBounds,
                timings: timings
            });
        });
    }
    /**
   * For a given text string and font parameters, determine the resulting block dimensions
   * after wrapping for the given maxWidth.
   * @param args
   * @param callback
   */ function measure(args, callback) {
        typeset({
            ...args,
            metricsOnly: true
        }, (result)=>{
            const [x0, y0, x1, y1] = result.blockBounds;
            callback({
                width: x1 - x0,
                height: y1 - y0
            });
        });
    }
    function parsePercent(str) {
        let match = str.match(/^([\d.]+)%$/);
        let pct = match ? parseFloat(match[1]) : NaN;
        return isNaN(pct) ? 0 : pct / 100;
    }
    function fillLigatureCaretPositions(caretPositions, ligStartIndex, ligCount) {
        const ligStartX = caretPositions[ligStartIndex * 4];
        const ligEndX = caretPositions[ligStartIndex * 4 + 1];
        const ligBottom = caretPositions[ligStartIndex * 4 + 2];
        const ligTop = caretPositions[ligStartIndex * 4 + 3];
        const guessedAdvanceX = (ligEndX - ligStartX) / ligCount;
        for(let i = 0; i < ligCount; i++){
            const startIndex = (ligStartIndex + i) * 4;
            caretPositions[startIndex] = ligStartX + guessedAdvanceX * i;
            caretPositions[startIndex + 1] = ligStartX + guessedAdvanceX * (i + 1);
            caretPositions[startIndex + 2] = ligBottom;
            caretPositions[startIndex + 3] = ligTop;
        }
    }
    function now() {
        return (self.performance || Date).now();
    }
    // Array-backed structure for a single line's glyphs data
    function TextLine() {
        this.data = [];
    }
    const textLineProps = [
        'glyphObj',
        'x',
        'y',
        'width',
        'charIndex',
        'fontData'
    ];
    TextLine.prototype = {
        width: 0,
        lineHeight: 0,
        baseline: 0,
        cap: 0,
        ex: 0,
        isSoftWrapped: false,
        get count () {
            return Math.ceil(this.data.length / textLineProps.length);
        },
        glyphAt (i) {
            let fly = TextLine.flyweight;
            fly.data = this.data;
            fly.index = i;
            return fly;
        },
        splitAt (i) {
            let newLine = new TextLine();
            newLine.data = this.data.splice(i * textLineProps.length);
            return newLine;
        }
    };
    TextLine.flyweight = textLineProps.reduce((obj, prop, i, all)=>{
        Object.defineProperty(obj, prop, {
            get () {
                return this.data[this.index * textLineProps.length + i];
            },
            set (val) {
                this.data[this.index * textLineProps.length + i] = val;
            }
        });
        return obj;
    }, {
        data: null,
        index: 0
    });
    return {
        typeset: typeset,
        measure: measure
    };
}
const $bc7831423112e56a$var$now = ()=>(self.performance || Date).now();
const $bc7831423112e56a$var$mainThreadGenerator = /*#__PURE__*/ (0, $a7b056c205977ae3$export$2e2bcd8739ae039)();
let $bc7831423112e56a$var$warned;
/**
 * Generate an SDF texture image for a single glyph path, placing the result into a webgl canvas at a
 * given location and channel. Utilizes the webgl-sdf-generator external package for GPU-accelerated SDF
 * generation when supported.
 */ function $bc7831423112e56a$var$generateSDF(width, height, path, viewBox, distance, exponent, canvas, x, y, channel, useWebGL = true) {
    // Allow opt-out
    if (!useWebGL) return $bc7831423112e56a$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel);
    // Attempt GPU-accelerated generation first
    return $bc7831423112e56a$var$generateSDF_GL(width, height, path, viewBox, distance, exponent, canvas, x, y, channel).then(null, (err)=>{
        // WebGL failed either due to a hard error or unexpected results; fall back to JS in workers
        if (!$bc7831423112e56a$var$warned) {
            console.warn(`WebGL SDF generation failed, falling back to JS`, err);
            $bc7831423112e56a$var$warned = true;
        }
        return $bc7831423112e56a$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel);
    });
}
const $bc7831423112e56a$var$queue = [];
const $bc7831423112e56a$var$chunkTimeBudget = 5; // ms
let $bc7831423112e56a$var$timer = 0;
function $bc7831423112e56a$var$nextChunk() {
    const start = $bc7831423112e56a$var$now();
    while($bc7831423112e56a$var$queue.length && $bc7831423112e56a$var$now() - start < $bc7831423112e56a$var$chunkTimeBudget)$bc7831423112e56a$var$queue.shift()();
    $bc7831423112e56a$var$timer = $bc7831423112e56a$var$queue.length ? setTimeout($bc7831423112e56a$var$nextChunk, 0) : 0;
}
/**
 * WebGL-based implementation executed on the main thread. Requests are executed in time-bounded
 * macrotask chunks to allow render frames to execute in between.
 */ const $bc7831423112e56a$var$generateSDF_GL = (...args)=>{
    return new Promise((resolve, reject)=>{
        $bc7831423112e56a$var$queue.push(()=>{
            const start = $bc7831423112e56a$var$now();
            try {
                $bc7831423112e56a$var$mainThreadGenerator.webgl.generateIntoCanvas(...args);
                resolve({
                    timing: $bc7831423112e56a$var$now() - start
                });
            } catch (err) {
                reject(err);
            }
        });
        if (!$bc7831423112e56a$var$timer) $bc7831423112e56a$var$timer = setTimeout($bc7831423112e56a$var$nextChunk, 0);
    });
};
const $bc7831423112e56a$var$threadCount = 4; // how many workers to spawn
const $bc7831423112e56a$var$idleTimeout = 2000; // workers will be terminated after being idle this many milliseconds
const $bc7831423112e56a$var$threads = {};
let $bc7831423112e56a$var$callNum = 0;
/**
 * Fallback JS-based implementation, fanned out to a number of worker threads for parallelism
 */ function $bc7831423112e56a$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel) {
    const workerId = 'TroikaTextSDFGenerator_JS_' + $bc7831423112e56a$var$callNum++ % $bc7831423112e56a$var$threadCount;
    let thread = $bc7831423112e56a$var$threads[workerId];
    if (!thread) thread = $bc7831423112e56a$var$threads[workerId] = {
        workerModule: (0, $62dc134116dcb5c9$export$e2063b0a5e3f6023)({
            name: workerId,
            workerId: workerId,
            dependencies: [
                (0, $a7b056c205977ae3$export$2e2bcd8739ae039),
                $bc7831423112e56a$var$now
            ],
            init (_createSDFGenerator, now) {
                const generate = _createSDFGenerator().javascript.generate;
                return function(...args) {
                    const start = now();
                    const textureData = generate(...args);
                    return {
                        textureData: textureData,
                        timing: now() - start
                    };
                };
            },
            getTransferables (result) {
                return [
                    result.textureData.buffer
                ];
            }
        }),
        requests: 0,
        idleTimer: null
    };
    thread.requests++;
    clearTimeout(thread.idleTimer);
    return thread.workerModule(width, height, path, viewBox, distance, exponent).then(({ textureData: textureData, timing: timing })=>{
        // copy result data into the canvas
        const start = $bc7831423112e56a$var$now();
        // expand single-channel data into rgba
        const imageData = new Uint8Array(textureData.length * 4);
        for(let i = 0; i < textureData.length; i++)imageData[i * 4 + channel] = textureData[i];
        $bc7831423112e56a$var$mainThreadGenerator.webglUtils.renderImageData(canvas, imageData, x, y, width, height, 1 << 3 - channel);
        timing += $bc7831423112e56a$var$now() - start;
        // clean up workers after a while
        if (--thread.requests === 0) thread.idleTimer = setTimeout(()=>{
            (0, $62dc134116dcb5c9$export$a61a973ac243a75e)(workerId);
        }, $bc7831423112e56a$var$idleTimeout);
        return {
            timing: timing
        };
    });
}
function $bc7831423112e56a$var$warmUpSDFCanvas(canvas) {
    if (!canvas._warm) {
        $bc7831423112e56a$var$mainThreadGenerator.webgl.isSupported(canvas);
        canvas._warm = true;
    }
}
const $bc7831423112e56a$var$resizeWebGLCanvasWithoutClearing = $bc7831423112e56a$var$mainThreadGenerator.webglUtils.resizeWebGLCanvasWithoutClearing;
const $bc7831423112e56a$var$CONFIG = {
    defaultFontURL: null,
    unicodeFontsURL: null,
    sdfGlyphSize: 64,
    sdfMargin: 1 / 16,
    sdfExponent: 9,
    textureWidth: 2048
};
const $bc7831423112e56a$var$tempColor = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$892596cec99bc70e)();
let $bc7831423112e56a$var$hasRequested = false;
function $bc7831423112e56a$var$now$1() {
    return (self.performance || Date).now();
}
/**
 * Customizes the text builder configuration. This must be called prior to the first font processing
 * request, and applies to all fonts.
 *
 * @param {String} config.defaultFontURL - The URL of the default font to use for text processing
 *                 requests, in case none is specified or the specifiede font fails to load or parse.
 *                 Defaults to "Roboto Regular" from Google Fonts.
 * @param {String} config.unicodeFontsURL - A custom location for the fallback unicode-font-resolver
 *                 data and font files, if you don't want to use the default CDN. See
 *                 https://github.com/lojjic/unicode-font-resolver for details. It can also be
 *                 configured per text instance, but this lets you do it once globally.
 * @param {Number} config.sdfGlyphSize - The default size of each glyph's SDF (signed distance field)
 *                 texture used for rendering. Must be a power-of-two number, and applies to all fonts,
 *                 but note that this can also be overridden per call to `getTextRenderInfo()`.
 *                 Larger sizes can improve the quality of glyph rendering by increasing the sharpness
 *                 of corners and preventing loss of very thin lines, at the expense of memory. Defaults
 *                 to 64 which is generally a good balance of size and quality.
 * @param {Number} config.sdfExponent - The exponent used when encoding the SDF values. A higher exponent
 *                 shifts the encoded 8-bit values to achieve higher precision/accuracy at texels nearer
 *                 the glyph's path, with lower precision further away. Defaults to 9.
 * @param {Number} config.sdfMargin - How much space to reserve in the SDF as margin outside the glyph's
 *                 path, as a percentage of the SDF width. A larger margin increases the quality of
 *                 extruded glyph outlines, but decreases the precision available for the glyph itself.
 *                 Defaults to 1/16th of the glyph size.
 * @param {Number} config.textureWidth - The width of the SDF texture; must be a power of 2. Defaults to
 *                 2048 which is a safe maximum texture dimension according to the stats at
 *                 https://webglstats.com/webgl/parameter/MAX_TEXTURE_SIZE and should allow for a
 *                 reasonably large number of glyphs (default glyph size of 64^2 and safe texture size of
 *                 2048^2, times 4 channels, allows for 4096 glyphs.) This can be increased if you need to
 *                 increase the glyph size and/or have an extraordinary number of glyphs.
 */ function $bc7831423112e56a$export$57e337d56090a178(config) {
    if ($bc7831423112e56a$var$hasRequested) console.warn('configureTextBuilder called after first font request; will be ignored.');
    else $bc7831423112e56a$var$assign($bc7831423112e56a$var$CONFIG, config);
}
/**
 * Repository for all font SDF atlas textures and their glyph mappings. There is a separate atlas for
 * each sdfGlyphSize. Each atlas has a single Texture that holds all glyphs for all fonts.
 *
 *   {
 *     [sdfGlyphSize]: {
 *       glyphCount: number,
 *       sdfGlyphSize: number,
 *       sdfTexture: Texture,
 *       sdfCanvas: HTMLCanvasElement,
 *       contextLost: boolean,
 *       glyphsByFont: Map<fontURL, Map<glyphID, {path, atlasIndex, sdfViewBox}>>
 *     }
 *   }
 */ const $bc7831423112e56a$var$atlases = Object.create(null);
/**
 * @typedef {object} TroikaTextRenderInfo - Format of the result from `getTextRenderInfo`.
 * @property {TypesetParams} parameters - The normalized input arguments to the render call.
 * @property {Texture} sdfTexture - The SDF atlas texture.
 * @property {number} sdfGlyphSize - The size of each glyph's SDF; see `configureTextBuilder`.
 * @property {number} sdfExponent - The exponent used in encoding the SDF's values; see `configureTextBuilder`.
 * @property {Float32Array} glyphBounds - List of [minX, minY, maxX, maxY] quad bounds for each glyph.
 * @property {Float32Array} glyphAtlasIndices - List holding each glyph's index in the SDF atlas.
 * @property {Uint8Array} [glyphColors] - List holding each glyph's [r, g, b] color, if `colorRanges` was supplied.
 * @property {Float32Array} [caretPositions] - A list of caret positions for all characters in the string; each is
 *           four elements: the starting X, the ending X, the bottom Y, and the top Y for the caret.
 * @property {number} [caretHeight] - An appropriate height for all selection carets.
 * @property {number} ascender - The font's ascender metric.
 * @property {number} descender - The font's descender metric.
 * @property {number} capHeight - The font's cap height metric, based on the height of Latin capital letters.
 * @property {number} xHeight - The font's x height metric, based on the height of Latin lowercase letters.
 * @property {number} lineHeight - The final computed lineHeight measurement.
 * @property {number} topBaseline - The y position of the top line's baseline.
 * @property {Array<number>} blockBounds - The total [minX, minY, maxX, maxY] rect of the whole text block;
 *           this can include extra vertical space beyond the visible glyphs due to lineHeight, and is
 *           equivalent to the dimensions of a block-level text element in CSS.
 * @property {Array<number>} visibleBounds - The total [minX, minY, maxX, maxY] rect of the whole text block;
 *           unlike `blockBounds` this is tightly wrapped to the visible glyph paths.
 * @property {Array<object>} chunkedBounds - List of bounding rects for each consecutive set of N glyphs,
 *           in the format `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`.
 * @property {object} timings - Timing info for various parts of the rendering logic including SDF
 *           generation, typesetting, etc.
 * @frozen
 */ /**
 * @callback getTextRenderInfo~callback
 * @param {TroikaTextRenderInfo} textRenderInfo
 */ /**
 * Main entry point for requesting the data needed to render a text string with given font parameters.
 * This is an asynchronous call, performing most of the logic in a web worker thread.
 * @param {TypesetParams} args
 * @param {getTextRenderInfo~callback} callback
 */ function $bc7831423112e56a$export$8a83a1532cd0ce42(args, callback) {
    $bc7831423112e56a$var$hasRequested = true;
    args = $bc7831423112e56a$var$assign({}, args);
    const totalStart = $bc7831423112e56a$var$now$1();
    // Convert relative URL to absolute so it can be resolved in the worker, and add fallbacks.
    // In the future we'll allow args.font to be a list with unicode ranges too.
    const { defaultFontURL: defaultFontURL } = $bc7831423112e56a$var$CONFIG;
    const fonts = [];
    if (defaultFontURL) fonts.push({
        label: 'default',
        src: $bc7831423112e56a$var$toAbsoluteURL(defaultFontURL)
    });
    if (args.font) fonts.push({
        label: 'user',
        src: $bc7831423112e56a$var$toAbsoluteURL(args.font)
    });
    args.font = fonts;
    // Normalize text to a string
    args.text = '' + args.text;
    args.sdfGlyphSize = args.sdfGlyphSize || $bc7831423112e56a$var$CONFIG.sdfGlyphSize;
    args.unicodeFontsURL = args.unicodeFontsURL || $bc7831423112e56a$var$CONFIG.unicodeFontsURL;
    // Normalize colors
    if (args.colorRanges != null) {
        let colors = {};
        for(let key in args.colorRanges)if (args.colorRanges.hasOwnProperty(key)) {
            let val = args.colorRanges[key];
            if (typeof val !== 'number') val = $bc7831423112e56a$var$tempColor.set(val).getHex();
            colors[key] = val;
        }
        args.colorRanges = colors;
    }
    Object.freeze(args);
    // Init the atlas if needed
    const { textureWidth: textureWidth, sdfExponent: sdfExponent } = $bc7831423112e56a$var$CONFIG;
    const { sdfGlyphSize: sdfGlyphSize } = args;
    const glyphsPerRow = textureWidth / sdfGlyphSize * 4;
    let atlas = $bc7831423112e56a$var$atlases[sdfGlyphSize];
    if (!atlas) {
        const canvas = document.createElement('canvas');
        canvas.width = textureWidth;
        canvas.height = sdfGlyphSize * 256 / glyphsPerRow; // start tall enough to fit 256 glyphs
        atlas = $bc7831423112e56a$var$atlases[sdfGlyphSize] = {
            glyphCount: 0,
            sdfGlyphSize: sdfGlyphSize,
            sdfCanvas: canvas,
            sdfTexture: new (0, $d5b33d7c30034067$export$5431306cf43de24a)(canvas, undefined, undefined, undefined, (0, $d5b33d7c30034067$export$8a72f490b25c56c8), (0, $d5b33d7c30034067$export$8a72f490b25c56c8)),
            contextLost: false,
            glyphsByFont: new Map()
        };
        atlas.sdfTexture.generateMipmaps = false;
        $bc7831423112e56a$var$initContextLossHandling(atlas);
    }
    const { sdfTexture: sdfTexture, sdfCanvas: sdfCanvas } = atlas;
    // Issue request to the typesetting engine in the worker
    $bc7831423112e56a$var$typesetInWorker(args).then((result)=>{
        const { glyphIds: glyphIds, glyphFontIndices: glyphFontIndices, fontData: fontData, glyphPositions: glyphPositions, fontSize: fontSize, timings: timings } = result;
        const neededSDFs = [];
        const glyphBounds = new Float32Array(glyphIds.length * 4);
        let boundsIdx = 0;
        let positionsIdx = 0;
        const quadsStart = $bc7831423112e56a$var$now$1();
        const fontGlyphMaps = fontData.map((font)=>{
            let map = atlas.glyphsByFont.get(font.src);
            if (!map) atlas.glyphsByFont.set(font.src, map = new Map());
            return map;
        });
        glyphIds.forEach((glyphId, i)=>{
            const fontIndex = glyphFontIndices[i];
            const { src: fontSrc, unitsPerEm: unitsPerEm } = fontData[fontIndex];
            let glyphInfo = fontGlyphMaps[fontIndex].get(glyphId);
            // If this is a glyphId not seen before, add it to the atlas
            if (!glyphInfo) {
                const { path: path, pathBounds: pathBounds } = result.glyphData[fontSrc][glyphId];
                // Margin around path edges in SDF, based on a percentage of the glyph's max dimension.
                // Note we add an extra 0.5 px over the configured value because the outer 0.5 doesn't contain
                // useful interpolated values and will be ignored anyway.
                const fontUnitsMargin = Math.max(pathBounds[2] - pathBounds[0], pathBounds[3] - pathBounds[1]) / sdfGlyphSize * ($bc7831423112e56a$var$CONFIG.sdfMargin * sdfGlyphSize + 0.5);
                const atlasIndex = atlas.glyphCount++;
                const sdfViewBox = [
                    pathBounds[0] - fontUnitsMargin,
                    pathBounds[1] - fontUnitsMargin,
                    pathBounds[2] + fontUnitsMargin,
                    pathBounds[3] + fontUnitsMargin
                ];
                fontGlyphMaps[fontIndex].set(glyphId, glyphInfo = {
                    path: path,
                    atlasIndex: atlasIndex,
                    sdfViewBox: sdfViewBox
                });
                // Collect those that need SDF generation
                neededSDFs.push(glyphInfo);
            }
            // Calculate bounds for renderable quads
            // TODO can we get this back off the main thread?
            const { sdfViewBox: sdfViewBox } = glyphInfo;
            const posX = glyphPositions[positionsIdx++];
            const posY = glyphPositions[positionsIdx++];
            const fontSizeMult = fontSize / unitsPerEm;
            glyphBounds[boundsIdx++] = posX + sdfViewBox[0] * fontSizeMult;
            glyphBounds[boundsIdx++] = posY + sdfViewBox[1] * fontSizeMult;
            glyphBounds[boundsIdx++] = posX + sdfViewBox[2] * fontSizeMult;
            glyphBounds[boundsIdx++] = posY + sdfViewBox[3] * fontSizeMult;
            // Convert glyphId to SDF index for the shader
            glyphIds[i] = glyphInfo.atlasIndex;
        });
        timings.quads = (timings.quads || 0) + ($bc7831423112e56a$var$now$1() - quadsStart);
        const sdfStart = $bc7831423112e56a$var$now$1();
        timings.sdf = {};
        // Grow the texture height by power of 2 if needed
        const currentHeight = sdfCanvas.height;
        const neededRows = Math.ceil(atlas.glyphCount / glyphsPerRow);
        const neededHeight = Math.pow(2, Math.ceil(Math.log2(neededRows * sdfGlyphSize)));
        if (neededHeight > currentHeight) {
            // Since resizing the canvas clears its render buffer, it needs special handling to copy the old contents over
            console.info(`Increasing SDF texture size ${currentHeight}->${neededHeight}`);
            $bc7831423112e56a$var$resizeWebGLCanvasWithoutClearing(sdfCanvas, textureWidth, neededHeight);
            // As of Three r136 textures cannot be resized once they're allocated on the GPU, we must dispose to reallocate it
            sdfTexture.dispose();
        }
        Promise.all(neededSDFs.map((glyphInfo)=>$bc7831423112e56a$var$generateGlyphSDF(glyphInfo, atlas, args.gpuAccelerateSDF).then(({ timing: timing })=>{
                timings.sdf[glyphInfo.atlasIndex] = timing;
            }))).then(()=>{
            if (neededSDFs.length && !atlas.contextLost) {
                $bc7831423112e56a$var$safariPre15Workaround(atlas);
                sdfTexture.needsUpdate = true;
            }
            timings.sdfTotal = $bc7831423112e56a$var$now$1() - sdfStart;
            timings.total = $bc7831423112e56a$var$now$1() - totalStart;
            // console.log(`SDF - ${timings.sdfTotal}, Total - ${timings.total - timings.fontLoad}`)
            // Invoke callback with the text layout arrays and updated texture
            callback(Object.freeze({
                parameters: args,
                sdfTexture: sdfTexture,
                sdfGlyphSize: sdfGlyphSize,
                sdfExponent: sdfExponent,
                glyphBounds: glyphBounds,
                glyphAtlasIndices: glyphIds,
                glyphColors: result.glyphColors,
                caretPositions: result.caretPositions,
                chunkedBounds: result.chunkedBounds,
                ascender: result.ascender,
                descender: result.descender,
                lineHeight: result.lineHeight,
                capHeight: result.capHeight,
                xHeight: result.xHeight,
                topBaseline: result.topBaseline,
                blockBounds: result.blockBounds,
                visibleBounds: result.visibleBounds,
                timings: result.timings
            }));
        });
    });
    // While the typesetting request is being handled, go ahead and make sure the atlas canvas context is
    // "warmed up"; the first request will be the longest due to shader program compilation so this gets
    // a head start on that process before SDFs actually start getting processed.
    Promise.resolve().then(()=>{
        if (!atlas.contextLost) $bc7831423112e56a$var$warmUpSDFCanvas(sdfCanvas);
    });
}
function $bc7831423112e56a$var$generateGlyphSDF({ path: path, atlasIndex: atlasIndex, sdfViewBox: sdfViewBox }, { sdfGlyphSize: sdfGlyphSize, sdfCanvas: sdfCanvas, contextLost: contextLost }, useGPU) {
    if (contextLost) // If the context is lost there's nothing we can do, just quit silently and let it
    // get regenerated when the context is restored
    return Promise.resolve({
        timing: -1
    });
    const { textureWidth: textureWidth, sdfExponent: sdfExponent } = $bc7831423112e56a$var$CONFIG;
    const maxDist = Math.max(sdfViewBox[2] - sdfViewBox[0], sdfViewBox[3] - sdfViewBox[1]);
    const squareIndex = Math.floor(atlasIndex / 4);
    const x = squareIndex % (textureWidth / sdfGlyphSize) * sdfGlyphSize;
    const y = Math.floor(squareIndex / (textureWidth / sdfGlyphSize)) * sdfGlyphSize;
    const channel = atlasIndex % 4;
    return $bc7831423112e56a$var$generateSDF(sdfGlyphSize, sdfGlyphSize, path, sdfViewBox, maxDist, sdfExponent, sdfCanvas, x, y, channel, useGPU);
}
function $bc7831423112e56a$var$initContextLossHandling(atlas) {
    const canvas = atlas.sdfCanvas;
    /*
  // Begin context loss simulation
  if (!window.WebGLDebugUtils) {
    let script = document.getElementById('WebGLDebugUtilsScript')
    if (!script) {
      script = document.createElement('script')
      script.id = 'WebGLDebugUtils'
      document.head.appendChild(script)
      script.src = 'https://cdn.jsdelivr.net/gh/KhronosGroup/WebGLDeveloperTools@b42e702/src/debug/webgl-debug.js'
    }
    script.addEventListener('load', () => {
      initContextLossHandling(atlas)
    })
    return
  }
  window.WebGLDebugUtils.makeLostContextSimulatingCanvas(canvas)
  canvas.loseContextInNCalls(500)
  canvas.addEventListener('webglcontextrestored', (event) => {
    canvas.loseContextInNCalls(5000)
  })
  // End context loss simulation
  */ canvas.addEventListener('webglcontextlost', (event)=>{
        console.log('Context Lost', event);
        event.preventDefault();
        atlas.contextLost = true;
    });
    canvas.addEventListener('webglcontextrestored', (event)=>{
        console.log('Context Restored', event);
        atlas.contextLost = false;
        // Regenerate all glyphs into the restored canvas:
        const promises = [];
        atlas.glyphsByFont.forEach((glyphMap)=>{
            glyphMap.forEach((glyph)=>{
                promises.push($bc7831423112e56a$var$generateGlyphSDF(glyph, atlas, true));
            });
        });
        Promise.all(promises).then(()=>{
            $bc7831423112e56a$var$safariPre15Workaround(atlas);
            atlas.sdfTexture.needsUpdate = true;
        });
    });
}
/**
 * Preload a given font and optionally pre-generate glyph SDFs for one or more character sequences.
 * This can be useful to avoid long pauses when first showing text in a scene, by preloading the
 * needed fonts and glyphs up front along with other assets.
 *
 * @param {object} options
 * @param {string} options.font - URL of the font file to preload. If not given, the default font will
 *        be loaded.
 * @param {string|string[]} options.characters - One or more character sequences for which to pre-
 *        generate glyph SDFs. Note that this will honor ligature substitution, so you may need
 *        to specify ligature sequences in addition to their individual characters to get all
 *        possible glyphs, e.g. `["t", "h", "th"]` to get the "t" and "h" glyphs plus the "th" ligature.
 * @param {number} options.sdfGlyphSize - The size at which to prerender the SDF textures for the
 *        specified `characters`.
 * @param {function} callback - A function that will be called when the preloading is complete.
 */ function $bc7831423112e56a$export$8a6ffa2d67c47c6c({ font: font, characters: characters, sdfGlyphSize: sdfGlyphSize }, callback) {
    let text = Array.isArray(characters) ? characters.join('\n') : '' + characters;
    $bc7831423112e56a$export$8a83a1532cd0ce42({
        font: font,
        sdfGlyphSize: sdfGlyphSize,
        text: text
    }, callback);
}
// Local assign impl so we don't have to import troika-core
function $bc7831423112e56a$var$assign(toObj, fromObj) {
    for(let key in fromObj)if (fromObj.hasOwnProperty(key)) toObj[key] = fromObj[key];
    return toObj;
}
// Utility for making URLs absolute
let $bc7831423112e56a$var$linkEl;
function $bc7831423112e56a$var$toAbsoluteURL(path) {
    if (!$bc7831423112e56a$var$linkEl) $bc7831423112e56a$var$linkEl = typeof document === 'undefined' ? {} : document.createElement('a');
    $bc7831423112e56a$var$linkEl.href = path;
    return $bc7831423112e56a$var$linkEl.href;
}
/**
 * Safari < v15 seems unable to use the SDF webgl canvas as a texture. This applies a workaround
 * where it reads the pixels out of that canvas and uploads them as a data texture instead, at
 * a slight performance cost.
 */ function $bc7831423112e56a$var$safariPre15Workaround(atlas) {
    // Use createImageBitmap support as a proxy for Safari<15, all other mainstream browsers
    // have supported it for a long while so any false positives should be minimal.
    if (typeof createImageBitmap !== 'function') {
        console.info('Safari<15: applying SDF canvas workaround');
        const { sdfCanvas: sdfCanvas, sdfTexture: sdfTexture } = atlas;
        const { width: width, height: height } = sdfCanvas;
        const gl = atlas.sdfCanvas.getContext('webgl');
        let pixels = sdfTexture.image.data;
        if (!pixels || pixels.length !== width * height * 4) {
            pixels = new Uint8Array(width * height * 4);
            sdfTexture.image = {
                width: width,
                height: height,
                data: pixels
            };
            sdfTexture.flipY = false;
            sdfTexture.isDataTexture = true;
        }
        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    }
}
const $bc7831423112e56a$export$adeaafcde0994a07 = /*#__PURE__*/ (0, $62dc134116dcb5c9$export$e2063b0a5e3f6023)({
    name: 'Typesetter',
    dependencies: [
        $bc7831423112e56a$var$createTypesetter,
        $bc7831423112e56a$export$85a5d697a084610,
        (0, $39f838faf692eed9$export$2e2bcd8739ae039)
    ],
    init (createTypesetter, fontResolver, bidiFactory) {
        return createTypesetter(fontResolver, bidiFactory());
    }
});
const $bc7831423112e56a$var$typesetInWorker = /*#__PURE__*/ (0, $62dc134116dcb5c9$export$e2063b0a5e3f6023)({
    name: 'Typesetter',
    dependencies: [
        $bc7831423112e56a$export$adeaafcde0994a07
    ],
    init (typesetter) {
        return function(args) {
            return new Promise((resolve)=>{
                typesetter.typeset(args, resolve);
            });
        };
    },
    getTransferables (result) {
        // Mark array buffers as transferable to avoid cloning during postMessage
        const transferables = [];
        for(let p in result)if (result[p] && result[p].buffer) transferables.push(result[p].buffer);
        return transferables;
    }
});
function $bc7831423112e56a$export$f81271cf861a33c1() {
    Object.keys($bc7831423112e56a$var$atlases).forEach((size)=>{
        const canvas = $bc7831423112e56a$var$atlases[size].sdfCanvas;
        const { width: width, height: height } = canvas;
        console.log("%c.", `
      background: url(${canvas.toDataURL()});
      background-size: ${width}px ${height}px;
      color: transparent;
      font-size: 0;
      line-height: ${height}px;
      padding-left: ${width}px;
    `);
    });
}
const $bc7831423112e56a$var$templateGeometries = {};
function $bc7831423112e56a$var$getTemplateGeometry(detail) {
    let geom = $bc7831423112e56a$var$templateGeometries[detail];
    if (!geom) {
        // Geometry is two planes back-to-back, which will always be rendered FrontSide only but
        // appear as DoubleSide by default. FrontSide/BackSide are emulated using drawRange.
        // We do it this way to avoid the performance hit of two draw calls for DoubleSide materials
        // introduced by Three.js in r130 - see https://github.com/mrdoob/three.js/pull/21967
        const front = new (0, $d5b33d7c30034067$export$967d831af31f69ce)(1, 1, detail, detail);
        const back = front.clone();
        const frontAttrs = front.attributes;
        const backAttrs = back.attributes;
        const combined = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
        const vertCount = frontAttrs.uv.count;
        for(let i = 0; i < vertCount; i++){
            backAttrs.position.array[i * 3] *= -1; // flip position x
            backAttrs.normal.array[i * 3 + 2] *= -1; // flip normal z
        }
        [
            'position',
            'normal',
            'uv'
        ].forEach((name)=>{
            combined.setAttribute(name, new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)([
                ...frontAttrs[name].array,
                ...backAttrs[name].array
            ], frontAttrs[name].itemSize));
        });
        combined.setIndex([
            ...front.index.array,
            ...back.index.array.map((n)=>n + vertCount)
        ]);
        combined.translate(0.5, 0.5, 0);
        geom = $bc7831423112e56a$var$templateGeometries[detail] = combined;
    }
    return geom;
}
const $bc7831423112e56a$var$glyphBoundsAttrName = 'aTroikaGlyphBounds';
const $bc7831423112e56a$var$glyphIndexAttrName = 'aTroikaGlyphIndex';
const $bc7831423112e56a$var$glyphColorAttrName = 'aTroikaGlyphColor';
/**
@class GlyphsGeometry

A specialized Geometry for rendering a set of text glyphs. Uses InstancedBufferGeometry to
render the glyphs using GPU instancing of a single quad, rather than constructing a whole
geometry with vertices, for much smaller attribute arraybuffers according to this math:

  Where N = number of glyphs...

  Instanced:
  - position: 4 * 3
  - index: 2 * 3
  - normal: 4 * 3
  - uv: 4 * 2
  - glyph x/y bounds: N * 4
  - glyph indices: N * 1
  = 5N + 38

  Non-instanced:
  - position: N * 4 * 3
  - index: N * 2 * 3
  - normal: N * 4 * 3
  - uv: N * 4 * 2
  - glyph indices: N * 1
  = 39N

A downside of this is the rare-but-possible lack of the instanced arrays extension,
which we could potentially work around with a fallback non-instanced implementation.

*/ class $bc7831423112e56a$export$16fe3b8f85ab6e35 extends (0, $d5b33d7c30034067$export$231f009cbe414146) {
    constructor(){
        super();
        this.detail = 1;
        this.curveRadius = 0;
        // Define groups for rendering text outline as a separate pass; these will only
        // be used when the `material` getter returns an array, i.e. outlineWidth > 0.
        this.groups = [
            {
                start: 0,
                count: Infinity,
                materialIndex: 0
            },
            {
                start: 0,
                count: Infinity,
                materialIndex: 1
            }
        ];
        // Preallocate empty bounding objects
        this.boundingSphere = new (0, $d5b33d7c30034067$export$805e8b72413ccaba)();
        this.boundingBox = new (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3)();
    }
    computeBoundingSphere() {
    // No-op; we'll sync the boundingSphere proactively when needed.
    }
    computeBoundingBox() {
    // No-op; we'll sync the boundingBox proactively when needed.
    }
    // Since our base geometry contains triangles for both front and back sides, we can emulate
    // the "side" by restricting the draw range.
    setSide(side) {
        const verts = this.getIndex().count;
        this.setDrawRange(side === (0, $d5b33d7c30034067$export$d9f0486e75b5ace) ? verts / 2 : 0, side === (0, $d5b33d7c30034067$export$3b296b6f144d5b03) ? verts : verts / 2);
    }
    set detail(detail) {
        if (detail !== this._detail) {
            this._detail = detail;
            if (typeof detail !== 'number' || detail < 1) detail = 1;
            let tpl = $bc7831423112e56a$var$getTemplateGeometry(detail);
            [
                'position',
                'normal',
                'uv'
            ].forEach((attr)=>{
                this.attributes[attr] = tpl.attributes[attr].clone();
            });
            this.setIndex(tpl.getIndex().clone());
        }
    }
    get detail() {
        return this._detail;
    }
    set curveRadius(r) {
        if (r !== this._curveRadius) {
            this._curveRadius = r;
            this._updateBounds();
        }
    }
    get curveRadius() {
        return this._curveRadius;
    }
    /**
   * Update the geometry for a new set of glyphs.
   * @param {Float32Array} glyphBounds - An array holding the planar bounds for all glyphs
   *        to be rendered, 4 entries for each glyph: x1,x2,y1,y1
   * @param {Float32Array} glyphAtlasIndices - An array holding the index of each glyph within
   *        the SDF atlas texture.
   * @param {Array} blockBounds - An array holding the [minX, minY, maxX, maxY] across all glyphs
   * @param {Array} [chunkedBounds] - An array of objects describing bounds for each chunk of N
   *        consecutive glyphs: `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`. This can be
   *        used with `applyClipRect` to choose an optimized `instanceCount`.
   * @param {Uint8Array} [glyphColors] - An array holding r,g,b values for each glyph.
   */ updateGlyphs(glyphBounds, glyphAtlasIndices, blockBounds, chunkedBounds, glyphColors) {
        // Update the instance attributes
        $bc7831423112e56a$var$updateBufferAttr(this, $bc7831423112e56a$var$glyphBoundsAttrName, glyphBounds, 4);
        $bc7831423112e56a$var$updateBufferAttr(this, $bc7831423112e56a$var$glyphIndexAttrName, glyphAtlasIndices, 1);
        $bc7831423112e56a$var$updateBufferAttr(this, $bc7831423112e56a$var$glyphColorAttrName, glyphColors, 3);
        this._blockBounds = blockBounds;
        this._chunkedBounds = chunkedBounds;
        this.instanceCount = glyphAtlasIndices.length;
        this._updateBounds();
    }
    _updateBounds() {
        const bounds = this._blockBounds;
        if (bounds) {
            const { curveRadius: curveRadius, boundingBox: bbox } = this;
            if (curveRadius) {
                const { PI: PI, floor: floor, min: min, max: max, sin: sin, cos: cos } = Math;
                const halfPi = PI / 2;
                const twoPi = PI * 2;
                const absR = Math.abs(curveRadius);
                const leftAngle = bounds[0] / absR;
                const rightAngle = bounds[2] / absR;
                const minX = floor((leftAngle + halfPi) / twoPi) !== floor((rightAngle + halfPi) / twoPi) ? -absR : min(sin(leftAngle) * absR, sin(rightAngle) * absR);
                const maxX = floor((leftAngle - halfPi) / twoPi) !== floor((rightAngle - halfPi) / twoPi) ? absR : max(sin(leftAngle) * absR, sin(rightAngle) * absR);
                const maxZ = floor((leftAngle + PI) / twoPi) !== floor((rightAngle + PI) / twoPi) ? absR * 2 : max(absR - cos(leftAngle) * absR, absR - cos(rightAngle) * absR);
                bbox.min.set(minX, bounds[1], curveRadius < 0 ? -maxZ : 0);
                bbox.max.set(maxX, bounds[3], curveRadius < 0 ? 0 : maxZ);
            } else {
                bbox.min.set(bounds[0], bounds[1], 0);
                bbox.max.set(bounds[2], bounds[3], 0);
            }
            bbox.getBoundingSphere(this.boundingSphere);
        }
    }
    /**
   * Given a clipping rect, and the chunkedBounds from the last updateGlyphs call, choose the lowest
   * `instanceCount` that will show all glyphs within the clipped view. This is an optimization
   * for long blocks of text that are clipped, to skip vertex shader evaluation for glyphs that would
   * be clipped anyway.
   *
   * Note that since `drawElementsInstanced[ANGLE]` only accepts an instance count and not a starting
   * offset, this optimization becomes less effective as the clipRect moves closer to the end of the
   * text block. We could fix that by switching from instancing to a full geometry with a drawRange,
   * but at the expense of much larger attribute buffers (see classdoc above.)
   *
   * @param {Vector4} clipRect
   */ applyClipRect(clipRect) {
        let count = this.getAttribute($bc7831423112e56a$var$glyphIndexAttrName).count;
        let chunks = this._chunkedBounds;
        if (chunks) for(let i = chunks.length; i--;){
            count = chunks[i].end;
            let rect = chunks[i].rect;
            // note: both rects are l-b-r-t
            if (rect[1] < clipRect.w && rect[3] > clipRect.y && rect[0] < clipRect.z && rect[2] > clipRect.x) break;
        }
        this.instanceCount = count;
    }
}
function $bc7831423112e56a$var$updateBufferAttr(geom, attrName, newArray, itemSize) {
    const attr = geom.getAttribute(attrName);
    if (newArray) {
        // If length isn't changing, just update the attribute's array data
        if (attr && attr.array.length === newArray.length) {
            attr.array.set(newArray);
            attr.needsUpdate = true;
        } else {
            geom.setAttribute(attrName, new (0, $d5b33d7c30034067$export$32ea87a8b54d744a)(newArray, itemSize));
            // If the new attribute has a different size, we also have to (as of r117) manually clear the
            // internal cached max instance count. See https://github.com/mrdoob/three.js/issues/19706
            // It's unclear if this is a threejs bug or a truly unsupported scenario; discussion in
            // that ticket is ambiguous as to whether replacing a BufferAttribute with one of a
            // different size is supported, but https://github.com/mrdoob/three.js/pull/17418 strongly
            // implies it should be supported. It's possible we need to
            delete geom._maxInstanceCount; //for r117+, could be fragile
            geom.dispose(); //for r118+, more robust feeling, but more heavy-handed than I'd like
        }
    } else if (attr) geom.deleteAttribute(attrName);
}
// language=GLSL
const $bc7831423112e56a$var$VERTEX_DEFS = `
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform vec4 uTroikaTotalBounds;
uniform vec4 uTroikaClipRect;
uniform mat3 uTroikaOrient;
uniform bool uTroikaUseGlyphColors;
uniform float uTroikaDistanceOffset;
uniform float uTroikaBlurRadius;
uniform vec2 uTroikaPositionOffset;
uniform float uTroikaCurveRadius;
attribute vec4 aTroikaGlyphBounds;
attribute float aTroikaGlyphIndex;
attribute vec3 aTroikaGlyphColor;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec3 vTroikaGlyphColor;
varying vec2 vTroikaGlyphDimensions;
`;
// language=GLSL prefix="void main() {" suffix="}"
const $bc7831423112e56a$var$VERTEX_TRANSFORM = `
vec4 bounds = aTroikaGlyphBounds;
bounds.xz += uTroikaPositionOffset.x;
bounds.yw -= uTroikaPositionOffset.y;

vec4 outlineBounds = vec4(
  bounds.xy - uTroikaDistanceOffset - uTroikaBlurRadius,
  bounds.zw + uTroikaDistanceOffset + uTroikaBlurRadius
);
vec4 clippedBounds = vec4(
  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),
  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)
);

vec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);

position.xy = mix(bounds.xy, bounds.zw, clippedXY);

uv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);

float rad = uTroikaCurveRadius;
if (rad != 0.0) {
  float angle = position.x / rad;
  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);
  normal.xz = vec2(sin(angle), cos(angle));
}
  
position = uTroikaOrient * position;
normal = uTroikaOrient * normal;

vTroikaGlyphUV = clippedXY.xy;
vTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);

${'' /* NOTE: it seems important to calculate the glyph's bounding texture UVs here in the
  vertex shader, rather than in the fragment shader, as the latter gives strange artifacts
  on some glyphs (those in the leftmost texture column) on some systems. The exact reason
  isn't understood but doing this here, then mix()-ing in the fragment shader, seems to work. */ }
float txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;
vec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;
vec2 txStartUV = txUvPerSquare * vec2(
  mod(floor(aTroikaGlyphIndex / 4.0), txCols),
  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)
);
vTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);
vTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);
`;
// language=GLSL
const $bc7831423112e56a$var$FRAGMENT_DEFS = `
uniform sampler2D uTroikaSDFTexture;
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform float uTroikaSDFExponent;
uniform float uTroikaDistanceOffset;
uniform float uTroikaFillOpacity;
uniform float uTroikaOutlineOpacity;
uniform float uTroikaBlurRadius;
uniform vec3 uTroikaStrokeColor;
uniform float uTroikaStrokeWidth;
uniform float uTroikaStrokeOpacity;
uniform bool uTroikaSDFDebug;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec2 vTroikaGlyphDimensions;

float troikaSdfValueToSignedDistance(float alpha) {
  // Inverse of exponential encoding in webgl-sdf-generator
  ${'' /* TODO - there's some slight inaccuracy here when dealing with interpolated alpha values; those
    are linearly interpolated where the encoding is exponential. Look into improving this by rounding
    to nearest 2 whole texels, decoding those exponential values, and linearly interpolating the result.
  */ }
  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);
  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;
  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);
  return signedDist;
}

float troikaGlyphUvToSdfValue(vec2 glyphUV) {
  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);
  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);
  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1
  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;
}

float troikaGlyphUvToDistance(vec2 uv) {
  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));
}

float troikaGetAADist() {
  ${'' /*
    When the standard derivatives extension is available, we choose an antialiasing alpha threshold based
    on the potential change in the SDF's alpha from this fragment to its neighbor. This strategy maximizes 
    readability and edge crispness at all sizes and screen resolutions.
  */ }
  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300
  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;
  #else
  return vTroikaGlyphDimensions.x / 64.0;
  #endif
}

float troikaGetFragDistValue() {
  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);
  float distance = troikaGlyphUvToDistance(clampedGlyphUV);
 
  // Extrapolate distance when outside bounds:
  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : 
    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);

  ${'' /* 
  // TODO more refined extrapolated distance by adjusting for angle of gradient at edge...
  // This has potential but currently gives very jagged extensions, maybe due to precision issues?
  float uvStep = 1.0 / uTroikaSDFGlyphSize;
  vec2 neighbor1UV = clampedGlyphUV + (
    vTroikaGlyphUV.x != clampedGlyphUV.x ? vec2(0.0, uvStep * sign(0.5 - vTroikaGlyphUV.y)) :
    vTroikaGlyphUV.y != clampedGlyphUV.y ? vec2(uvStep * sign(0.5 - vTroikaGlyphUV.x), 0.0) :
    vec2(0.0)
  );
  vec2 neighbor2UV = clampedGlyphUV + (
    vTroikaGlyphUV.x != clampedGlyphUV.x ? vec2(0.0, uvStep * -sign(0.5 - vTroikaGlyphUV.y)) :
    vTroikaGlyphUV.y != clampedGlyphUV.y ? vec2(uvStep * -sign(0.5 - vTroikaGlyphUV.x), 0.0) :
    vec2(0.0)
  );
  float neighbor1Distance = troikaGlyphUvToDistance(neighbor1UV);
  float neighbor2Distance = troikaGlyphUvToDistance(neighbor2UV);
  float distToUnclamped = length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);
  float distToNeighbor = length((clampedGlyphUV - neighbor1UV) * vTroikaGlyphDimensions);
  float gradientAngle1 = min(asin(abs(neighbor1Distance - distance) / distToNeighbor), PI / 2.0);
  float gradientAngle2 = min(asin(abs(neighbor2Distance - distance) / distToNeighbor), PI / 2.0);
  distance += (cos(gradientAngle1) + cos(gradientAngle2)) / 2.0 * distToUnclamped;
  */ }

  return distance;
}

float troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {
  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)
  float alpha = step(-distanceOffset, -distance);
  #else

  float alpha = smoothstep(
    distanceOffset + aaDist,
    distanceOffset - aaDist,
    distance
  );
  #endif

  return alpha;
}
`;
// language=GLSL prefix="void main() {" suffix="}"
const $bc7831423112e56a$var$FRAGMENT_TRANSFORM = `
float aaDist = troikaGetAADist();
float fragDistance = troikaGetFragDistValue();
float edgeAlpha = uTroikaSDFDebug ?
  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :
  troikaGetEdgeAlpha(fragDistance, uTroikaDistanceOffset, max(aaDist, uTroikaBlurRadius));

#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)
vec4 fillRGBA = gl_FragColor;
fillRGBA.a *= uTroikaFillOpacity;
vec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);
if (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;
gl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(
  -uTroikaStrokeWidth - aaDist,
  -uTroikaStrokeWidth + aaDist,
  fragDistance
));
gl_FragColor.a *= edgeAlpha;
#endif

if (edgeAlpha == 0.0) {
  discard;
}
`;
/**
 * Create a material for rendering text, derived from a baseMaterial
 */ function $bc7831423112e56a$export$ec8c2d2c0fe50886(baseMaterial) {
    const textMaterial = (0, $3280116647888dc9$export$9251ec91c7de57b5)(baseMaterial, {
        chained: true,
        extensions: {
            derivatives: true
        },
        uniforms: {
            uTroikaSDFTexture: {
                value: null
            },
            uTroikaSDFTextureSize: {
                value: new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)()
            },
            uTroikaSDFGlyphSize: {
                value: 0
            },
            uTroikaSDFExponent: {
                value: 0
            },
            uTroikaTotalBounds: {
                value: new (0, $d5b33d7c30034067$export$fa7daccca11cdbe3)(0, 0, 0, 0)
            },
            uTroikaClipRect: {
                value: new (0, $d5b33d7c30034067$export$fa7daccca11cdbe3)(0, 0, 0, 0)
            },
            uTroikaDistanceOffset: {
                value: 0
            },
            uTroikaOutlineOpacity: {
                value: 0
            },
            uTroikaFillOpacity: {
                value: 1
            },
            uTroikaPositionOffset: {
                value: new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)()
            },
            uTroikaCurveRadius: {
                value: 0
            },
            uTroikaBlurRadius: {
                value: 0
            },
            uTroikaStrokeWidth: {
                value: 0
            },
            uTroikaStrokeColor: {
                value: new (0, $d5b33d7c30034067$export$892596cec99bc70e)()
            },
            uTroikaStrokeOpacity: {
                value: 1
            },
            uTroikaOrient: {
                value: new (0, $d5b33d7c30034067$export$8ff26dafa08918)()
            },
            uTroikaUseGlyphColors: {
                value: true
            },
            uTroikaSDFDebug: {
                value: false
            }
        },
        vertexDefs: $bc7831423112e56a$var$VERTEX_DEFS,
        vertexTransform: $bc7831423112e56a$var$VERTEX_TRANSFORM,
        fragmentDefs: $bc7831423112e56a$var$FRAGMENT_DEFS,
        fragmentColorTransform: $bc7831423112e56a$var$FRAGMENT_TRANSFORM,
        customRewriter ({ vertexShader: vertexShader, fragmentShader: fragmentShader }) {
            let uDiffuseRE = /\buniform\s+vec3\s+diffuse\b/;
            if (uDiffuseRE.test(fragmentShader)) {
                // Replace all instances of `diffuse` with our varying
                fragmentShader = fragmentShader.replace(uDiffuseRE, 'varying vec3 vTroikaGlyphColor').replace(/\bdiffuse\b/g, 'vTroikaGlyphColor');
                // Make sure the vertex shader declares the uniform so we can grab it as a fallback
                if (!uDiffuseRE.test(vertexShader)) vertexShader = vertexShader.replace((0, $3280116647888dc9$export$f402b5c74ecf5e1e), 'uniform vec3 diffuse;\n$&\nvTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;\n');
            }
            return {
                vertexShader: vertexShader,
                fragmentShader: fragmentShader
            };
        }
    });
    // Force transparency - TODO is this reasonable?
    textMaterial.transparent = true;
    Object.defineProperties(textMaterial, {
        isTroikaTextMaterial: {
            value: true
        },
        // WebGLShadowMap reverses the side of the shadow material by default, which fails
        // for planes, so here we force the `shadowSide` to always match the main side.
        shadowSide: {
            get () {
                return this.side;
            },
            set () {
            //no-op
            }
        }
    });
    return textMaterial;
}
const $bc7831423112e56a$var$defaultMaterial = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)({
    color: 0xffffff,
    side: (0, $d5b33d7c30034067$export$3b296b6f144d5b03),
    transparent: true
});
const $bc7831423112e56a$var$defaultStrokeColor = 0x808080;
const $bc7831423112e56a$var$tempMat4 = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
const $bc7831423112e56a$var$tempVec3a = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $bc7831423112e56a$var$tempVec3b = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $bc7831423112e56a$var$tempArray = [];
const $bc7831423112e56a$var$origin = /*#__PURE__*/ new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $bc7831423112e56a$var$defaultOrient = '+x+y';
function $bc7831423112e56a$var$first(o) {
    return Array.isArray(o) ? o[0] : o;
}
let $bc7831423112e56a$var$getFlatRaycastMesh = ()=>{
    const mesh = new (0, $d5b33d7c30034067$export$e176487c05830cc5)(new (0, $d5b33d7c30034067$export$967d831af31f69ce)(1, 1), $bc7831423112e56a$var$defaultMaterial);
    $bc7831423112e56a$var$getFlatRaycastMesh = ()=>mesh;
    return mesh;
};
let $bc7831423112e56a$var$getCurvedRaycastMesh = ()=>{
    const mesh = new (0, $d5b33d7c30034067$export$e176487c05830cc5)(new (0, $d5b33d7c30034067$export$967d831af31f69ce)(1, 1, 32, 1), $bc7831423112e56a$var$defaultMaterial);
    $bc7831423112e56a$var$getCurvedRaycastMesh = ()=>mesh;
    return mesh;
};
const $bc7831423112e56a$var$syncStartEvent = {
    type: 'syncstart'
};
const $bc7831423112e56a$var$syncCompleteEvent = {
    type: 'synccomplete'
};
const $bc7831423112e56a$var$SYNCABLE_PROPS = [
    'font',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'lang',
    'letterSpacing',
    'lineHeight',
    'maxWidth',
    'overflowWrap',
    'text',
    'direction',
    'textAlign',
    'textIndent',
    'whiteSpace',
    'anchorX',
    'anchorY',
    'colorRanges',
    'sdfGlyphSize'
];
const $bc7831423112e56a$var$COPYABLE_PROPS = $bc7831423112e56a$var$SYNCABLE_PROPS.concat('material', 'color', 'depthOffset', 'clipRect', 'curveRadius', 'orientation', 'glyphGeometryDetail');
/**
 * @class Text
 *
 * A ThreeJS Mesh that renders a string of text on a plane in 3D space using signed distance
 * fields (SDF).
 */ class $bc7831423112e56a$export$5f1af8db9871e1d6 extends (0, $d5b33d7c30034067$export$e176487c05830cc5) {
    constructor(){
        const geometry = new $bc7831423112e56a$export$16fe3b8f85ab6e35();
        super(geometry, null);
        // === Text layout properties: === //
        /**
     * @member {string} text
     * The string of text to be rendered.
     */ this.text = '';
        /**
     * @member {number|string} anchorX
     * Defines the horizontal position in the text block that should line up with the local origin.
     * Can be specified as a numeric x position in local units, a string percentage of the total
     * text block width e.g. `'25%'`, or one of the following keyword strings: 'left', 'center',
     * or 'right'.
     */ this.anchorX = 0;
        /**
     * @member {number|string} anchorY
     * Defines the vertical position in the text block that should line up with the local origin.
     * Can be specified as a numeric y position in local units (note: down is negative y), a string
     * percentage of the total text block height e.g. `'25%'`, or one of the following keyword strings:
     * 'top', 'top-baseline', 'top-cap', 'top-ex', 'middle', 'bottom-baseline', or 'bottom'.
     */ this.anchorY = 0;
        /**
     * @member {number} curveRadius
     * Defines a cylindrical radius along which the text's plane will be curved. Positive numbers put
     * the cylinder's centerline (oriented vertically) that distance in front of the text, for a concave
     * curvature, while negative numbers put it behind the text for a convex curvature. The centerline
     * will be aligned with the text's local origin; you can use `anchorX` to offset it.
     *
     * Since each glyph is by default rendered with a simple quad, each glyph remains a flat plane
     * internally. You can use `glyphGeometryDetail` to add more vertices for curvature inside glyphs.
     */ this.curveRadius = 0;
        /**
     * @member {string} direction
     * Sets the base direction for the text. The default value of "auto" will choose a direction based
     * on the text's content according to the bidi spec. A value of "ltr" or "rtl" will force the direction.
     */ this.direction = 'auto';
        /**
     * @member {string|null} font
     * URL of a custom font to be used. Font files can be in .ttf, .otf, or .woff (not .woff2) formats.
     * Defaults to Noto Sans.
     */ this.font = null; //will use default from TextBuilder
        this.unicodeFontsURL = null; //defaults to CDN
        /**
     * @member {number} fontSize
     * The size at which to render the font in local units; corresponds to the em-box height
     * of the chosen `font`.
     */ this.fontSize = 0.1;
        /**
     * @member {number|'normal'|'bold'}
     * The weight of the font. Currently only used for fallback Noto fonts.
     */ this.fontWeight = 'normal';
        /**
     * @member {'normal'|'italic'}
     * The style of the font. Currently only used for fallback Noto fonts.
     */ this.fontStyle = 'normal';
        /**
     * @member {string|null} lang
     * The language code of this text; can be used for explicitly selecting certain CJK fonts.
     */ this.lang = null;
        /**
     * @member {number} letterSpacing
     * Sets a uniform adjustment to spacing between letters after kerning is applied. Positive
     * numbers increase spacing and negative numbers decrease it.
     */ this.letterSpacing = 0;
        /**
     * @member {number|string} lineHeight
     * Sets the height of each line of text, as a multiple of the `fontSize`. Defaults to 'normal'
     * which chooses a reasonable height based on the chosen font's ascender/descender metrics.
     */ this.lineHeight = 'normal';
        /**
     * @member {number} maxWidth
     * The maximum width of the text block, above which text may start wrapping according to the
     * `whiteSpace` and `overflowWrap` properties.
     */ this.maxWidth = Infinity;
        /**
     * @member {string} overflowWrap
     * Defines how text wraps if the `whiteSpace` property is `normal`. Can be either `'normal'`
     * to break at whitespace characters, or `'break-word'` to allow breaking within words.
     * Defaults to `'normal'`.
     */ this.overflowWrap = 'normal';
        /**
     * @member {string} textAlign
     * The horizontal alignment of each line of text within the overall text bounding box.
     */ this.textAlign = 'left';
        /**
     * @member {number} textIndent
     * Indentation for the first character of a line; see CSS `text-indent`.
     */ this.textIndent = 0;
        /**
     * @member {string} whiteSpace
     * Defines whether text should wrap when a line reaches the `maxWidth`. Can
     * be either `'normal'` (the default), to allow wrapping according to the `overflowWrap` property,
     * or `'nowrap'` to prevent wrapping. Note that `'normal'` here honors newline characters to
     * manually break lines, making it behave more like `'pre-wrap'` does in CSS.
     */ this.whiteSpace = 'normal';
        // === Presentation properties: === //
        /**
     * @member {THREE.Material} material
     * Defines a _base_ material to be used when rendering the text. This material will be
     * automatically replaced with a material derived from it, that adds shader code to
     * decrease the alpha for each fragment (pixel) outside the text glyphs, with antialiasing.
     * By default it will derive from a simple white MeshBasicMaterial, but you can use any
     * of the other mesh materials to gain other features like lighting, texture maps, etc.
     *
     * Also see the `color` shortcut property.
     */ this.material = null;
        /**
     * @member {string|number|THREE.Color} color
     * This is a shortcut for setting the `color` of the text's material. You can use this
     * if you don't want to specify a whole custom `material`. Also, if you do use a custom
     * `material`, this color will only be used for this particuar Text instance, even if
     * that same material instance is shared across multiple Text objects.
     */ this.color = null;
        /**
     * @member {object|null} colorRanges
     * WARNING: This API is experimental and may change.
     * This allows more fine-grained control of colors for individual or ranges of characters,
     * taking precedence over the material's `color`. Its format is an Object whose keys each
     * define a starting character index for a range, and whose values are the color for each
     * range. The color value can be a numeric hex color value, a `THREE.Color` object, or
     * any of the strings accepted by `THREE.Color`.
     */ this.colorRanges = null;
        /**
     * @member {number|string} outlineWidth
     * WARNING: This API is experimental and may change.
     * The width of an outline/halo to be drawn around each text glyph using the `outlineColor` and `outlineOpacity`.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g.
     * `"12%"` which is treated as a percentage of the `fontSize`. Defaults to `0`, which means
     * no outline will be drawn unless an `outlineOffsetX/Y` or `outlineBlur` is set.
     */ this.outlineWidth = 0;
        /**
     * @member {string|number|THREE.Color} outlineColor
     * WARNING: This API is experimental and may change.
     * The color of the text outline, if `outlineWidth`/`outlineBlur`/`outlineOffsetX/Y` are set.
     * Defaults to black.
     */ this.outlineColor = 0x000000;
        /**
     * @member {number} outlineOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the outline, if `outlineWidth`/`outlineBlur`/`outlineOffsetX/Y` are set.
     * Defaults to `1`.
     */ this.outlineOpacity = 1;
        /**
     * @member {number|string} outlineBlur
     * WARNING: This API is experimental and may change.
     * A blur radius applied to the outer edge of the text's outline. If the `outlineWidth` is
     * zero, the blur will be applied at the glyph edge, like CSS's `text-shadow` blur radius.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g.
     * `"12%"` which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.outlineBlur = 0;
        /**
     * @member {number|string} outlineOffsetX
     * WARNING: This API is experimental and may change.
     * A horizontal offset for the text outline.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.outlineOffsetX = 0;
        /**
     * @member {number|string} outlineOffsetY
     * WARNING: This API is experimental and may change.
     * A vertical offset for the text outline.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.outlineOffsetY = 0;
        /**
     * @member {number|string} strokeWidth
     * WARNING: This API is experimental and may change.
     * The width of an inner stroke drawn inside each text glyph using the `strokeColor` and `strokeOpacity`.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.strokeWidth = 0;
        /**
     * @member {string|number|THREE.Color} strokeColor
     * WARNING: This API is experimental and may change.
     * The color of the text stroke, if `strokeWidth` is greater than zero. Defaults to gray.
     */ this.strokeColor = $bc7831423112e56a$var$defaultStrokeColor;
        /**
     * @member {number} strokeOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the stroke, if `strokeWidth` is greater than zero. Defaults to `1`.
     */ this.strokeOpacity = 1;
        /**
     * @member {number} fillOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the glyph's fill from 0 to 1. This behaves like the material's `opacity` but allows
     * giving the fill a different opacity than the `strokeOpacity`. A fillOpacity of `0` makes the
     * interior of the glyph invisible, leaving just the `strokeWidth`. Defaults to `1`.
     */ this.fillOpacity = 1;
        /**
     * @member {number} depthOffset
     * This is a shortcut for setting the material's `polygonOffset` and related properties,
     * which can be useful in preventing z-fighting when this text is laid on top of another
     * plane in the scene. Positive numbers are further from the camera, negatives closer.
     */ this.depthOffset = 0;
        /**
     * @member {Array<number>} clipRect
     * If specified, defines a `[minX, minY, maxX, maxY]` of a rectangle outside of which all
     * pixels will be discarded. This can be used for example to clip overflowing text when
     * `whiteSpace='nowrap'`.
     */ this.clipRect = null;
        /**
     * @member {string} orientation
     * Defines the axis plane on which the text should be laid out when the mesh has no extra
     * rotation transform. It is specified as a string with two axes: the horizontal axis with
     * positive pointing right, and the vertical axis with positive pointing up. By default this
     * is '+x+y', meaning the text sits on the xy plane with the text's top toward positive y
     * and facing positive z. A value of '+x-z' would place it on the xz plane with the text's
     * top toward negative z and facing positive y.
     */ this.orientation = $bc7831423112e56a$var$defaultOrient;
        /**
     * @member {number} glyphGeometryDetail
     * Controls number of vertical/horizontal segments that make up each glyph's rectangular
     * plane. Defaults to 1. This can be increased to provide more geometrical detail for custom
     * vertex shader effects, for example.
     */ this.glyphGeometryDetail = 1;
        /**
     * @member {number|null} sdfGlyphSize
     * The size of each glyph's SDF (signed distance field) used for rendering. This must be a
     * power-of-two number. Defaults to 64 which is generally a good balance of size and quality
     * for most fonts. Larger sizes can improve the quality of glyph rendering by increasing
     * the sharpness of corners and preventing loss of very thin lines, at the expense of
     * increased memory footprint and longer SDF generation time.
     */ this.sdfGlyphSize = null;
        /**
     * @member {boolean} gpuAccelerateSDF
     * When `true`, the SDF generation process will be GPU-accelerated with WebGL when possible,
     * making it much faster especially for complex glyphs, and falling back to a JavaScript version
     * executed in web workers when support isn't available. It should automatically detect support,
     * but it's still somewhat experimental, so you can set it to `false` to force it to use the JS
     * version if you encounter issues with it.
     */ this.gpuAccelerateSDF = true;
        this.debugSDF = false;
    }
    /**
   * Updates the text rendering according to the current text-related configuration properties.
   * This is an async process, so you can pass in a callback function to be executed when it
   * finishes.
   * @param {function} [callback]
   */ sync(callback) {
        if (this._needsSync) {
            this._needsSync = false;
            // If there's another sync still in progress, queue
            if (this._isSyncing) (this._queuedSyncs || (this._queuedSyncs = [])).push(callback);
            else {
                this._isSyncing = true;
                this.dispatchEvent($bc7831423112e56a$var$syncStartEvent);
                $bc7831423112e56a$export$8a83a1532cd0ce42({
                    text: this.text,
                    font: this.font,
                    lang: this.lang,
                    fontSize: this.fontSize || 0.1,
                    fontWeight: this.fontWeight || 'normal',
                    fontStyle: this.fontStyle || 'normal',
                    letterSpacing: this.letterSpacing || 0,
                    lineHeight: this.lineHeight || 'normal',
                    maxWidth: this.maxWidth,
                    direction: this.direction || 'auto',
                    textAlign: this.textAlign,
                    textIndent: this.textIndent,
                    whiteSpace: this.whiteSpace,
                    overflowWrap: this.overflowWrap,
                    anchorX: this.anchorX,
                    anchorY: this.anchorY,
                    colorRanges: this.colorRanges,
                    includeCaretPositions: true,
                    sdfGlyphSize: this.sdfGlyphSize,
                    gpuAccelerateSDF: this.gpuAccelerateSDF,
                    unicodeFontsURL: this.unicodeFontsURL
                }, (textRenderInfo)=>{
                    this._isSyncing = false;
                    // Save result for later use in onBeforeRender
                    this._textRenderInfo = textRenderInfo;
                    // Update the geometry attributes
                    this.geometry.updateGlyphs(textRenderInfo.glyphBounds, textRenderInfo.glyphAtlasIndices, textRenderInfo.blockBounds, textRenderInfo.chunkedBounds, textRenderInfo.glyphColors);
                    // If we had extra sync requests queued up, kick it off
                    const queued = this._queuedSyncs;
                    if (queued) {
                        this._queuedSyncs = null;
                        this._needsSync = true;
                        this.sync(()=>{
                            queued.forEach((fn)=>fn && fn());
                        });
                    }
                    this.dispatchEvent($bc7831423112e56a$var$syncCompleteEvent);
                    if (callback) callback();
                });
            }
        }
    }
    /**
   * Initiate a sync if needed - note it won't complete until next frame at the
   * earliest so if possible it's a good idea to call sync() manually as soon as
   * all the properties have been set.
   * @override
   */ onBeforeRender(renderer, scene, camera, geometry, material, group) {
        this.sync();
        // This may not always be a text material, e.g. if there's a scene.overrideMaterial present
        if (material.isTroikaTextMaterial) this._prepareForRender(material);
        // We need to force the material to FrontSide to avoid the double-draw-call performance hit
        // introduced in Three.js r130: https://github.com/mrdoob/three.js/pull/21967 - The sidedness
        // is instead applied via drawRange in the GlyphsGeometry.
        material._hadOwnSide = material.hasOwnProperty('side');
        this.geometry.setSide(material._actualSide = material.side);
        material.side = (0, $d5b33d7c30034067$export$2ede184fc2998901);
    }
    onAfterRender(renderer, scene, camera, geometry, material, group) {
        // Restore original material side
        if (material._hadOwnSide) material.side = material._actualSide;
        else delete material.side; // back to inheriting from base material
    }
    /**
   * Shortcut to dispose the geometry specific to this instance.
   * Note: we don't also dispose the derived material here because if anything else is
   * sharing the same base material it will result in a pause next frame as the program
   * is recompiled. Instead users can dispose the base material manually, like normal,
   * and we'll also dispose the derived material at that time.
   */ dispose() {
        this.geometry.dispose();
    }
    /**
   * @property {TroikaTextRenderInfo|null} textRenderInfo
   * @readonly
   * The current processed rendering data for this TextMesh, returned by the TextBuilder after
   * a `sync()` call. This will be `null` initially, and may be stale for a short period until
   * the asynchrous `sync()` process completes.
   */ get textRenderInfo() {
        return this._textRenderInfo || null;
    }
    // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
    // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
    get material() {
        let derivedMaterial = this._derivedMaterial;
        const baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $bc7831423112e56a$var$defaultMaterial.clone());
        if (!derivedMaterial || derivedMaterial.baseMaterial !== baseMaterial) {
            derivedMaterial = this._derivedMaterial = $bc7831423112e56a$export$ec8c2d2c0fe50886(baseMaterial);
            // dispose the derived material when its base material is disposed:
            baseMaterial.addEventListener('dispose', function onDispose() {
                baseMaterial.removeEventListener('dispose', onDispose);
                derivedMaterial.dispose();
            });
        }
        // If text outline is configured, render it as a preliminary draw using Three's multi-material
        // feature (see GlyphsGeometry which sets up `groups` for this purpose) Doing it with multi
        // materials ensures the layers are always rendered consecutively in a consistent order.
        // Each layer will trigger onBeforeRender with the appropriate material.
        if (this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY) {
            let outlineMaterial = derivedMaterial._outlineMtl;
            if (!outlineMaterial) {
                outlineMaterial = derivedMaterial._outlineMtl = Object.create(derivedMaterial, {
                    id: {
                        value: derivedMaterial.id + 0.1
                    }
                });
                outlineMaterial.isTextOutlineMaterial = true;
                outlineMaterial.depthWrite = false;
                outlineMaterial.map = null; //???
                derivedMaterial.addEventListener('dispose', function onDispose() {
                    derivedMaterial.removeEventListener('dispose', onDispose);
                    outlineMaterial.dispose();
                });
            }
            return [
                outlineMaterial,
                derivedMaterial
            ];
        } else return derivedMaterial;
    }
    set material(baseMaterial) {
        if (baseMaterial && baseMaterial.isTroikaTextMaterial) {
            this._derivedMaterial = baseMaterial;
            this._baseMaterial = baseMaterial.baseMaterial;
        } else this._baseMaterial = baseMaterial;
    }
    get glyphGeometryDetail() {
        return this.geometry.detail;
    }
    set glyphGeometryDetail(detail) {
        this.geometry.detail = detail;
    }
    get curveRadius() {
        return this.geometry.curveRadius;
    }
    set curveRadius(r) {
        this.geometry.curveRadius = r;
    }
    // Create and update material for shadows upon request:
    get customDepthMaterial() {
        return $bc7831423112e56a$var$first(this.material).getDepthMaterial();
    }
    get customDistanceMaterial() {
        return $bc7831423112e56a$var$first(this.material).getDistanceMaterial();
    }
    _prepareForRender(material) {
        const isOutline = material.isTextOutlineMaterial;
        const uniforms = material.uniforms;
        const textInfo = this.textRenderInfo;
        if (textInfo) {
            const { sdfTexture: sdfTexture, blockBounds: blockBounds } = textInfo;
            uniforms.uTroikaSDFTexture.value = sdfTexture;
            uniforms.uTroikaSDFTextureSize.value.set(sdfTexture.image.width, sdfTexture.image.height);
            uniforms.uTroikaSDFGlyphSize.value = textInfo.sdfGlyphSize;
            uniforms.uTroikaSDFExponent.value = textInfo.sdfExponent;
            uniforms.uTroikaTotalBounds.value.fromArray(blockBounds);
            uniforms.uTroikaUseGlyphColors.value = !isOutline && !!textInfo.glyphColors;
            let distanceOffset = 0;
            let blurRadius = 0;
            let strokeWidth = 0;
            let fillOpacity;
            let strokeOpacity;
            let strokeColor;
            let offsetX = 0;
            let offsetY = 0;
            if (isOutline) {
                let { outlineWidth: outlineWidth, outlineOffsetX: outlineOffsetX, outlineOffsetY: outlineOffsetY, outlineBlur: outlineBlur, outlineOpacity: outlineOpacity } = this;
                distanceOffset = this._parsePercent(outlineWidth) || 0;
                blurRadius = Math.max(0, this._parsePercent(outlineBlur) || 0);
                fillOpacity = outlineOpacity;
                offsetX = this._parsePercent(outlineOffsetX) || 0;
                offsetY = this._parsePercent(outlineOffsetY) || 0;
            } else {
                strokeWidth = Math.max(0, this._parsePercent(this.strokeWidth) || 0);
                if (strokeWidth) {
                    strokeColor = this.strokeColor;
                    uniforms.uTroikaStrokeColor.value.set(strokeColor == null ? $bc7831423112e56a$var$defaultStrokeColor : strokeColor);
                    strokeOpacity = this.strokeOpacity;
                    if (strokeOpacity == null) strokeOpacity = 1;
                }
                fillOpacity = this.fillOpacity;
            }
            uniforms.uTroikaDistanceOffset.value = distanceOffset;
            uniforms.uTroikaPositionOffset.value.set(offsetX, offsetY);
            uniforms.uTroikaBlurRadius.value = blurRadius;
            uniforms.uTroikaStrokeWidth.value = strokeWidth;
            uniforms.uTroikaStrokeOpacity.value = strokeOpacity;
            uniforms.uTroikaFillOpacity.value = fillOpacity == null ? 1 : fillOpacity;
            uniforms.uTroikaCurveRadius.value = this.curveRadius || 0;
            let clipRect = this.clipRect;
            if (clipRect && Array.isArray(clipRect) && clipRect.length === 4) uniforms.uTroikaClipRect.value.fromArray(clipRect);
            else {
                // no clipping - choose a finite rect that shouldn't ever be reached by overflowing glyphs or outlines
                const pad = (this.fontSize || 0.1) * 100;
                uniforms.uTroikaClipRect.value.set(blockBounds[0] - pad, blockBounds[1] - pad, blockBounds[2] + pad, blockBounds[3] + pad);
            }
            this.geometry.applyClipRect(uniforms.uTroikaClipRect.value);
        }
        uniforms.uTroikaSDFDebug.value = !!this.debugSDF;
        material.polygonOffset = !!this.depthOffset;
        material.polygonOffsetFactor = material.polygonOffsetUnits = this.depthOffset || 0;
        // Shortcut for setting material color via `color` prop on the mesh; this is
        // applied only to the derived material to avoid mutating a shared base material.
        const color = isOutline ? this.outlineColor || 0 : this.color;
        if (color == null) delete material.color; //inherit from base
        else {
            const colorObj = material.hasOwnProperty('color') ? material.color : material.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)();
            if (color !== colorObj._input || typeof color === 'object') colorObj.set(colorObj._input = color);
        }
        // base orientation
        let orient = this.orientation || $bc7831423112e56a$var$defaultOrient;
        if (orient !== material._orientation) {
            let rotMat = uniforms.uTroikaOrient.value;
            orient = orient.replace(/[^-+xyz]/g, '');
            let match = orient !== $bc7831423112e56a$var$defaultOrient && orient.match(/^([-+])([xyz])([-+])([xyz])$/);
            if (match) {
                let [, hSign, hAxis, vSign, vAxis] = match;
                $bc7831423112e56a$var$tempVec3a.set(0, 0, 0)[hAxis] = hSign === '-' ? 1 : -1;
                $bc7831423112e56a$var$tempVec3b.set(0, 0, 0)[vAxis] = vSign === '-' ? -1 : 1;
                $bc7831423112e56a$var$tempMat4.lookAt($bc7831423112e56a$var$origin, $bc7831423112e56a$var$tempVec3a.cross($bc7831423112e56a$var$tempVec3b), $bc7831423112e56a$var$tempVec3b);
                rotMat.setFromMatrix4($bc7831423112e56a$var$tempMat4);
            } else rotMat.identity();
            material._orientation = orient;
        }
    }
    _parsePercent(value) {
        if (typeof value === 'string') {
            let match = value.match(/^(-?[\d.]+)%$/);
            let pct = match ? parseFloat(match[1]) : NaN;
            value = (isNaN(pct) ? 0 : pct / 100) * this.fontSize;
        }
        return value;
    }
    /**
   * Translate a point in local space to an x/y in the text plane.
   */ localPositionToTextCoords(position, target = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)()) {
        target.copy(position); //simple non-curved case is 1:1
        const r = this.curveRadius;
        if (r) target.x = Math.atan2(position.x, Math.abs(r) - Math.abs(position.z)) * Math.abs(r);
        return target;
    }
    /**
   * Translate a point in world space to an x/y in the text plane.
   */ worldPositionToTextCoords(position, target = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)()) {
        $bc7831423112e56a$var$tempVec3a.copy(position);
        return this.localPositionToTextCoords(this.worldToLocal($bc7831423112e56a$var$tempVec3a), target);
    }
    /**
   * @override Custom raycasting to test against the whole text block's max rectangular bounds
   * TODO is there any reason to make this more granular, like within individual line or glyph rects?
   */ raycast(raycaster, intersects) {
        const { textRenderInfo: textRenderInfo, curveRadius: curveRadius } = this;
        if (textRenderInfo) {
            const bounds = textRenderInfo.blockBounds;
            const raycastMesh = curveRadius ? $bc7831423112e56a$var$getCurvedRaycastMesh() : $bc7831423112e56a$var$getFlatRaycastMesh();
            const geom = raycastMesh.geometry;
            const { position: position, uv: uv } = geom.attributes;
            for(let i = 0; i < uv.count; i++){
                let x = bounds[0] + uv.getX(i) * (bounds[2] - bounds[0]);
                const y = bounds[1] + uv.getY(i) * (bounds[3] - bounds[1]);
                let z = 0;
                if (curveRadius) {
                    z = curveRadius - Math.cos(x / curveRadius) * curveRadius;
                    x = Math.sin(x / curveRadius) * curveRadius;
                }
                position.setXYZ(i, x, y, z);
            }
            geom.boundingSphere = this.geometry.boundingSphere;
            geom.boundingBox = this.geometry.boundingBox;
            raycastMesh.matrixWorld = this.matrixWorld;
            raycastMesh.material.side = this.material.side;
            $bc7831423112e56a$var$tempArray.length = 0;
            raycastMesh.raycast(raycaster, $bc7831423112e56a$var$tempArray);
            for(let i = 0; i < $bc7831423112e56a$var$tempArray.length; i++){
                $bc7831423112e56a$var$tempArray[i].object = this;
                intersects.push($bc7831423112e56a$var$tempArray[i]);
            }
        }
    }
    copy(source) {
        // Prevent copying the geometry reference so we don't end up sharing attributes between instances
        const geom = this.geometry;
        super.copy(source);
        this.geometry = geom;
        $bc7831423112e56a$var$COPYABLE_PROPS.forEach((prop)=>{
            this[prop] = source[prop];
        });
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
// Create setters for properties that affect text layout:
$bc7831423112e56a$var$SYNCABLE_PROPS.forEach((prop)=>{
    const privateKey = '_private_' + prop;
    Object.defineProperty($bc7831423112e56a$export$5f1af8db9871e1d6.prototype, prop, {
        get () {
            return this[privateKey];
        },
        set (value) {
            if (value !== this[privateKey]) {
                this[privateKey] = value;
                this._needsSync = true;
            }
        }
    });
});
//=== Utility functions for dealing with carets and selection ranges ===//
/**
 * @typedef {object} TextCaret
 * @property {number} x - x position of the caret
 * @property {number} y - y position of the caret's bottom
 * @property {number} height - height of the caret
 * @property {number} charIndex - the index in the original input string of this caret's target
 *   character; the caret will be for the position _before_ that character.
 */ /**
 * Given a local x/y coordinate in the text block plane, find the nearest caret position.
 * @param {TroikaTextRenderInfo} textRenderInfo - a result object from TextBuilder#getTextRenderInfo
 * @param {number} x
 * @param {number} y
 * @return {TextCaret | null}
 */ function $bc7831423112e56a$export$c92621821fde77a5(textRenderInfo, x, y) {
    let closestCaret = null;
    const rows = $bc7831423112e56a$var$groupCaretsByRow(textRenderInfo);
    // Find nearest row by y first
    let closestRow = null;
    rows.forEach((row)=>{
        if (!closestRow || Math.abs(y - (row.top + row.bottom) / 2) < Math.abs(y - (closestRow.top + closestRow.bottom) / 2)) closestRow = row;
    });
    // Then find closest caret by x within that row
    closestRow.carets.forEach((caret)=>{
        if (!closestCaret || Math.abs(x - caret.x) < Math.abs(x - closestCaret.x)) closestCaret = caret;
    });
    return closestCaret;
}
const $bc7831423112e56a$var$_rectsCache = new WeakMap();
/**
 * Given start and end character indexes, return a list of rectangles covering all the
 * characters within that selection.
 * @param {TroikaTextRenderInfo} textRenderInfo
 * @param {number} start - index of the first char in the selection
 * @param {number} end - index of the first char after the selection
 * @return {Array<{left, top, right, bottom}> | null}
 */ function $bc7831423112e56a$export$2b95125f38323093(textRenderInfo, start, end) {
    let rects;
    if (textRenderInfo) {
        // Check cache - textRenderInfo is frozen so it's safe to cache based on it
        let prevResult = $bc7831423112e56a$var$_rectsCache.get(textRenderInfo);
        if (prevResult && prevResult.start === start && prevResult.end === end) return prevResult.rects;
        const { caretPositions: caretPositions } = textRenderInfo;
        // Normalize
        if (end < start) {
            const s = start;
            start = end;
            end = s;
        }
        start = Math.max(start, 0);
        end = Math.min(end, caretPositions.length + 1);
        // Build list of rects, expanding the current rect for all characters in a run and starting
        // a new rect whenever reaching a new line or a new bidi direction
        rects = [];
        let currentRect = null;
        for(let i = start; i < end; i++){
            const x1 = caretPositions[i * 4];
            const x2 = caretPositions[i * 4 + 1];
            const left = Math.min(x1, x2);
            const right = Math.max(x1, x2);
            const bottom = caretPositions[i * 4 + 2];
            const top = caretPositions[i * 4 + 3];
            if (!currentRect || bottom !== currentRect.bottom || top !== currentRect.top || left > currentRect.right || right < currentRect.left) {
                currentRect = {
                    left: Infinity,
                    right: -Infinity,
                    bottom: bottom,
                    top: top
                };
                rects.push(currentRect);
            }
            currentRect.left = Math.min(left, currentRect.left);
            currentRect.right = Math.max(right, currentRect.right);
        }
        // Merge any overlapping rects, e.g. those formed by adjacent bidi runs
        rects.sort((a, b)=>b.bottom - a.bottom || a.left - b.left);
        for(let i = rects.length - 1; i-- > 0;){
            const rectA = rects[i];
            const rectB = rects[i + 1];
            if (rectA.bottom === rectB.bottom && rectA.top === rectB.top && rectA.left <= rectB.right && rectA.right >= rectB.left) {
                rectB.left = Math.min(rectB.left, rectA.left);
                rectB.right = Math.max(rectB.right, rectA.right);
                rects.splice(i, 1);
            }
        }
        $bc7831423112e56a$var$_rectsCache.set(textRenderInfo, {
            start: start,
            end: end,
            rects: rects
        });
    }
    return rects;
}
const $bc7831423112e56a$var$_caretsByRowCache = new WeakMap();
/**
 * Group a set of carets by row of text, caching the result. A single row of text may contain carets of
 * differing positions/heights if it has multiple fonts, and they may overlap slightly across rows, so this
 * uses an assumption of "at least overlapping by half" to put them in the same row.
 * @return Array<{bottom: number, top: number, carets: TextCaret[]}>
 */ function $bc7831423112e56a$var$groupCaretsByRow(textRenderInfo) {
    // textRenderInfo is frozen so it's safe to cache based on it
    let rows = $bc7831423112e56a$var$_caretsByRowCache.get(textRenderInfo);
    if (!rows) {
        rows = [];
        const { caretPositions: caretPositions } = textRenderInfo;
        let curRow;
        const visitCaret = (x, bottom, top, charIndex)=>{
            // new row if not overlapping by at least half
            if (!curRow || top < (curRow.top + curRow.bottom) / 2) rows.push(curRow = {
                bottom: bottom,
                top: top,
                carets: []
            });
            // expand vertical limits if necessary
            if (top > curRow.top) curRow.top = top;
            if (bottom < curRow.bottom) curRow.bottom = bottom;
            curRow.carets.push({
                x: x,
                y: bottom,
                height: top - bottom,
                charIndex: charIndex
            });
        };
        let i = 0;
        for(; i < caretPositions.length; i += 4)visitCaret(caretPositions[i], caretPositions[i + 2], caretPositions[i + 3], i / 4);
        // Add one more caret after the final char
        visitCaret(caretPositions[i - 3], caretPositions[i - 2], caretPositions[i - 1], i / 4);
    }
    $bc7831423112e56a$var$_caretsByRowCache.set(textRenderInfo, rows);
    return rows;
}




// eslint-disable-next-line prettier/prettier
const $1bbf7428bce323b3$export$5f1af8db9871e1d6 = /* @__PURE__ */ $acw62.forwardRef(({ sdfGlyphSize: sdfGlyphSize = 64, anchorX: anchorX = 'center', anchorY: anchorY = 'middle', font: font, fontSize: fontSize = 1, children: children, characters: characters, onSync: onSync, ...props }, ref)=>{
    const invalidate = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)(({ invalidate: invalidate })=>invalidate);
    const [troikaMesh] = $acw62.useState(()=>new (0, $bc7831423112e56a$export$5f1af8db9871e1d6)());
    const [nodes, text] = $acw62.useMemo(()=>{
        const n = [];
        let t = '';
        $acw62.Children.forEach(children, (child)=>{
            if (typeof child === 'string' || typeof child === 'number') t += child;
            else n.push(child);
        });
        return [
            n,
            t
        ];
    }, [
        children
    ]);
    (0, $f681624d9766226e$export$a1428c8f7ba796e8)(()=>new Promise((res)=>(0, $bc7831423112e56a$export$8a6ffa2d67c47c6c)({
                font: font,
                characters: characters
            }, res)), [
        'troika-text',
        font,
        characters
    ]);
    $acw62.useLayoutEffect(()=>void troikaMesh.sync(()=>{
            invalidate();
            if (onSync) onSync(troikaMesh);
        }));
    $acw62.useEffect(()=>{
        return ()=>troikaMesh.dispose();
    }, [
        troikaMesh
    ]);
    return /*#__PURE__*/ $acw62.createElement("primitive", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        object: troikaMesh,
        ref: ref,
        font: font,
        text: text,
        anchorX: anchorX,
        anchorY: anchorY,
        fontSize: fontSize,
        sdfGlyphSize: sdfGlyphSize
    }, props), nodes);
});



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $6a6a8390e6c378cd$var$retarget(target, source, options = {}) {
    const pos = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(), quat = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)(), scale = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(), bindBoneMatrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)(), relativeMatrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)(), globalMatrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
    options.preserveMatrix = options.preserveMatrix !== void 0 ? options.preserveMatrix : true;
    options.preservePosition = options.preservePosition !== void 0 ? options.preservePosition : true;
    options.preserveHipPosition = options.preserveHipPosition !== void 0 ? options.preserveHipPosition : false;
    options.useTargetMatrix = options.useTargetMatrix !== void 0 ? options.useTargetMatrix : false;
    options.hip = options.hip !== void 0 ? options.hip : "hip";
    options.names = options.names || {};
    const sourceBones = source.isObject3D ? source.skeleton.bones : $6a6a8390e6c378cd$var$getBones(source), bones = target.isObject3D ? target.skeleton.bones : $6a6a8390e6c378cd$var$getBones(target);
    let bindBones, bone, name, boneTo, bonesPosition;
    if (target.isObject3D) target.skeleton.pose();
    else {
        options.useTargetMatrix = true;
        options.preserveMatrix = false;
    }
    if (options.preservePosition) {
        bonesPosition = [];
        for(let i = 0; i < bones.length; i++)bonesPosition.push(bones[i].position.clone());
    }
    if (options.preserveMatrix) {
        target.updateMatrixWorld();
        target.matrixWorld.identity();
        for(let i = 0; i < target.children.length; ++i)target.children[i].updateMatrixWorld(true);
    }
    if (options.offsets) {
        bindBones = [];
        for(let i = 0; i < bones.length; ++i){
            bone = bones[i];
            name = options.names[bone.name] || bone.name;
            if (options.offsets[name]) {
                bone.matrix.multiply(options.offsets[name]);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
                bone.updateMatrixWorld();
            }
            bindBones.push(bone.matrixWorld.clone());
        }
    }
    for(let i = 0; i < bones.length; ++i){
        bone = bones[i];
        name = options.names[bone.name] || bone.name;
        boneTo = $6a6a8390e6c378cd$var$getBoneByName(name, sourceBones);
        globalMatrix.copy(bone.matrixWorld);
        if (boneTo) {
            boneTo.updateMatrixWorld();
            if (options.useTargetMatrix) relativeMatrix.copy(boneTo.matrixWorld);
            else {
                relativeMatrix.copy(target.matrixWorld).invert();
                relativeMatrix.multiply(boneTo.matrixWorld);
            }
            scale.setFromMatrixScale(relativeMatrix);
            relativeMatrix.scale(scale.set(1 / scale.x, 1 / scale.y, 1 / scale.z));
            globalMatrix.makeRotationFromQuaternion(quat.setFromRotationMatrix(relativeMatrix));
            if (target.isObject3D) {
                const boneIndex = bones.indexOf(bone), wBindMatrix = bindBones ? bindBones[boneIndex] : bindBoneMatrix.copy(target.skeleton.boneInverses[boneIndex]).invert();
                globalMatrix.multiply(wBindMatrix);
            }
            globalMatrix.copyPosition(relativeMatrix);
        }
        if (bone.parent && bone.parent.isBone) {
            bone.matrix.copy(bone.parent.matrixWorld).invert();
            bone.matrix.multiply(globalMatrix);
        } else bone.matrix.copy(globalMatrix);
        if (options.preserveHipPosition && name === options.hip) bone.matrix.setPosition(pos.set(0, bone.position.y, 0));
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
        bone.updateMatrixWorld();
    }
    if (options.preservePosition) for(let i = 0; i < bones.length; ++i){
        bone = bones[i];
        name = options.names[bone.name] || bone.name;
        if (name !== options.hip) bone.position.copy(bonesPosition[i]);
    }
    if (options.preserveMatrix) target.updateMatrixWorld(true);
}
function $6a6a8390e6c378cd$var$retargetClip(target, source, clip, options = {}) {
    options.useFirstFramePosition = options.useFirstFramePosition !== void 0 ? options.useFirstFramePosition : false;
    options.fps = options.fps !== void 0 ? options.fps : 30;
    options.names = options.names || [];
    if (!source.isObject3D) source = $6a6a8390e6c378cd$var$getHelperFromSkeleton(source);
    const numFrames = Math.round(clip.duration * (options.fps / 1e3) * 1e3), delta = 1 / options.fps, convertedTracks = [], mixer = new (0, $d5b33d7c30034067$export$fbd77e5aefaa0102)(source), bones = $6a6a8390e6c378cd$var$getBones(target.skeleton), boneDatas = [];
    let positionOffset, bone, boneTo, boneData, name;
    mixer.clipAction(clip).play();
    mixer.update(0);
    source.updateMatrixWorld();
    for(let i = 0; i < numFrames; ++i){
        const time = i * delta;
        $6a6a8390e6c378cd$var$retarget(target, source, options);
        for(let j = 0; j < bones.length; ++j){
            name = options.names[bones[j].name] || bones[j].name;
            boneTo = $6a6a8390e6c378cd$var$getBoneByName(name, source.skeleton);
            if (boneTo) {
                bone = bones[j];
                boneData = boneDatas[j] = boneDatas[j] || {
                    bone: bone
                };
                if (options.hip === name) {
                    if (!boneData.pos) boneData.pos = {
                        times: new Float32Array(numFrames),
                        values: new Float32Array(numFrames * 3)
                    };
                    if (options.useFirstFramePosition) {
                        if (i === 0) positionOffset = bone.position.clone();
                        bone.position.sub(positionOffset);
                    }
                    boneData.pos.times[i] = time;
                    bone.position.toArray(boneData.pos.values, i * 3);
                }
                if (!boneData.quat) boneData.quat = {
                    times: new Float32Array(numFrames),
                    values: new Float32Array(numFrames * 4)
                };
                boneData.quat.times[i] = time;
                bone.quaternion.toArray(boneData.quat.values, i * 4);
            }
        }
        mixer.update(delta);
        source.updateMatrixWorld();
    }
    for(let i = 0; i < boneDatas.length; ++i){
        boneData = boneDatas[i];
        if (boneData) {
            if (boneData.pos) convertedTracks.push(new (0, $d5b33d7c30034067$export$5ce2dcb4cc9f2bff)(".bones[" + boneData.bone.name + "].position", boneData.pos.times, boneData.pos.values));
            convertedTracks.push(new (0, $d5b33d7c30034067$export$b8043f12b5aafbd7)(".bones[" + boneData.bone.name + "].quaternion", boneData.quat.times, boneData.quat.values));
        }
    }
    mixer.uncacheAction(clip);
    return new (0, $d5b33d7c30034067$export$d942c706bf23829c)(clip.name, -1, convertedTracks);
}
function $6a6a8390e6c378cd$var$clone(source) {
    const sourceLookup = /* @__PURE__ */ new Map();
    const cloneLookup = /* @__PURE__ */ new Map();
    const clone2 = source.clone();
    $6a6a8390e6c378cd$var$parallelTraverse(source, clone2, function(sourceNode, clonedNode) {
        sourceLookup.set(clonedNode, sourceNode);
        cloneLookup.set(sourceNode, clonedNode);
    });
    clone2.traverse(function(node) {
        if (!node.isSkinnedMesh) return;
        const clonedMesh = node;
        const sourceMesh = sourceLookup.get(node);
        const sourceBones = sourceMesh.skeleton.bones;
        clonedMesh.skeleton = sourceMesh.skeleton.clone();
        clonedMesh.bindMatrix.copy(sourceMesh.bindMatrix);
        clonedMesh.skeleton.bones = sourceBones.map(function(bone) {
            return cloneLookup.get(bone);
        });
        clonedMesh.bind(clonedMesh.skeleton, clonedMesh.bindMatrix);
    });
    return clone2;
}
function $6a6a8390e6c378cd$var$getBoneByName(name, skeleton) {
    for(let i = 0, bones = $6a6a8390e6c378cd$var$getBones(skeleton); i < bones.length; i++){
        if (name === bones[i].name) return bones[i];
    }
}
function $6a6a8390e6c378cd$var$getBones(skeleton) {
    return Array.isArray(skeleton) ? skeleton : skeleton.bones;
}
function $6a6a8390e6c378cd$var$getHelperFromSkeleton(skeleton) {
    const source = new (0, $d5b33d7c30034067$export$5277df3c9e732259)(skeleton.bones[0]);
    source.skeleton = skeleton;
    return source;
}
function $6a6a8390e6c378cd$var$parallelTraverse(a, b, callback) {
    callback(a, b);
    for(let i = 0; i < a.children.length; i++)$6a6a8390e6c378cd$var$parallelTraverse(a.children[i], b.children[i], callback);
}
const $6a6a8390e6c378cd$export$aba183359625134b = {
    retarget: $6a6a8390e6c378cd$var$retarget,
    retargetClip: $6a6a8390e6c378cd$var$retargetClip,
    clone: $6a6a8390e6c378cd$var$clone
};


function $a68050441c565260$var$createSpread(child, { keys: keys = [
    'near',
    'far',
    'color',
    'distance',
    'decay',
    'penumbra',
    'angle',
    'intensity',
    'skeleton',
    'visible',
    'castShadow',
    'receiveShadow',
    'morphTargetDictionary',
    'morphTargetInfluences',
    'name',
    'geometry',
    'material',
    'position',
    'rotation',
    'scale',
    'up',
    'userData',
    'bindMode',
    'bindMatrix',
    'bindMatrixInverse',
    'skeleton'
], deep: deep, inject: inject, castShadow: castShadow, receiveShadow: receiveShadow }) {
    let spread = {};
    for (const key of keys)spread[key] = child[key];
    if (deep) {
        if (spread.geometry && deep !== 'materialsOnly') spread.geometry = spread.geometry.clone();
        if (spread.material && deep !== 'geometriesOnly') spread.material = spread.material.clone();
    }
    if (inject) {
        if (typeof inject === 'function') spread = {
            ...spread,
            children: inject(child)
        };
        else if (/*#__PURE__*/ $acw62.isValidElement(inject)) spread = {
            ...spread,
            children: inject
        };
        else spread = {
            ...spread,
            ...inject
        };
    }
    if (child instanceof $d5b33d7c30034067$export$e176487c05830cc5) {
        if (castShadow) spread.castShadow = true;
        if (receiveShadow) spread.receiveShadow = true;
    }
    return spread;
}
const $a68050441c565260$export$b5d07669a5562b23 = /* @__PURE__ */ $acw62.forwardRef(({ isChild: isChild = false, object: object, children: children, deep: deep, castShadow: castShadow, receiveShadow: receiveShadow, inject: inject, keys: keys, ...props }, forwardRef)=>{
    const config = {
        keys: keys,
        deep: deep,
        inject: inject,
        castShadow: castShadow,
        receiveShadow: receiveShadow
    };
    object = $acw62.useMemo(()=>{
        if (isChild === false && !Array.isArray(object)) {
            let isSkinned = false;
            object.traverse((object)=>{
                if (object.isSkinnedMesh) isSkinned = true;
            });
            if (isSkinned) return (0, $6a6a8390e6c378cd$export$aba183359625134b).clone(object);
        }
        return object;
    }, [
        object,
        isChild
    ]);
    // Deal with arrayed clones
    if (Array.isArray(object)) return /*#__PURE__*/ $acw62.createElement("group", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardRef
    }), object.map((o)=>/*#__PURE__*/ $acw62.createElement($a68050441c565260$export$b5d07669a5562b23, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            key: o.uuid,
            object: o
        }, config))), children);
    // Singleton clones
    const { children: injectChildren, ...spread } = $a68050441c565260$var$createSpread(object, config);
    const Element = object.type[0].toLowerCase() + object.type.slice(1);
    return /*#__PURE__*/ $acw62.createElement(Element, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, spread, props, {
        ref: forwardRef
    }), object.children.map((child)=>{
        if (child.type === 'Bone') return /*#__PURE__*/ $acw62.createElement("primitive", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            key: child.uuid,
            object: child
        }, config));
        return /*#__PURE__*/ $acw62.createElement($a68050441c565260$export$b5d07669a5562b23, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            key: child.uuid,
            object: child
        }, config, {
            isChild: true
        }));
    }), children, injectChildren);
});



const $76ab0928a0395fd1$var$_taskCache = /* @__PURE__ */ new WeakMap();
class $76ab0928a0395fd1$export$45c25de53be259ac extends (0, $d5b33d7c30034067$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.decoderPath = "";
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = "";
        this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        };
        this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            const taskConfig = {
                attributeIDs: this.defaultAttributeIDs,
                attributeTypes: this.defaultAttributeTypes,
                useUniqueIDs: false
            };
            this.decodeGeometry(buffer, taskConfig).then(onLoad).catch(onError);
        }, onProgress, onError);
    }
    /** @deprecated Kept for backward-compatibility with previous DRACOLoader versions. */ decodeDracoFile(buffer, callback, attributeIDs, attributeTypes) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs
        };
        this.decodeGeometry(buffer, taskConfig).then(callback);
    }
    decodeGeometry(buffer, taskConfig) {
        for(const attribute in taskConfig.attributeTypes){
            const type = taskConfig.attributeTypes[attribute];
            if (type.BYTES_PER_ELEMENT !== void 0) taskConfig.attributeTypes[attribute] = type.name;
        }
        const taskKey = JSON.stringify(taskConfig);
        if ($76ab0928a0395fd1$var$_taskCache.has(buffer)) {
            const cachedTask = $76ab0928a0395fd1$var$_taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: "decode",
                    id: taskID,
                    taskConfig: taskConfig,
                    buffer: buffer
                }, [
                    buffer
                ]);
            });
        }).then((message)=>this._createGeometry(message.geometry));
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        $76ab0928a0395fd1$var$_taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
        if (geometryData.index) geometry.setIndex(new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const attribute = geometryData.attributes[i];
            const name = attribute.name;
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            geometry.setAttribute(name, new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize));
        }
        return geometry;
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, void 0, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
        else {
            librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
            librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = $76ab0928a0395fd1$var$DRACOWorker.toString();
            const body = [
                "/* draco decoder */",
                jsContent,
                "",
                "/* worker */",
                fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker2 = new Worker(this.workerSourceURL);
                worker2._callbacks = {};
                worker2._taskCosts = {};
                worker2._taskLoad = 0;
                worker2.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                });
                worker2.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case "decode":
                            worker2._callbacks[message.id].resolve(message);
                            break;
                        case "error":
                            worker2._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker2);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        return this;
    }
}
function $76ab0928a0395fd1$var$DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        resolve({
                            draco: draco
                        });
                    };
                    DracoDecoderModule(decoderConfig);
                });
                break;
            case "decode":
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    const decoderBuffer = new draco.DecoderBuffer();
                    decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
                    try {
                        const geometry = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: "decode",
                            id: message.id,
                            geometry: geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoderBuffer);
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
        } else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            geometry.attributes.push(decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute));
        }
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
        const numComponents = attribute.num_components();
        const numPoints = dracoGeometry.num_points();
        const numValues = numPoints * numComponents;
        const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
        const dataType = getDracoDataType(draco, attributeType);
        const ptr = draco._malloc(byteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
        const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
        draco._free(ptr);
        return {
            name: attributeName,
            array: array,
            itemSize: numComponents
        };
    }
    function getDracoDataType(draco, attributeType) {
        switch(attributeType){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}



const $a40b1f8c68dbf97f$export$e3a4ac9ee65ec343 = (obj, key)=>obj[key];


const $a986598ce43127c1$export$728c051ccdf8a702 = (geometries, useGroups)=>{
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
    let offset = 0;
    geometries.forEach((geom, i)=>{
        let attributesCount = 0;
        if (isIndexed !== (geom.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        for(let name in geom.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === void 0) attributes[name] = [];
            attributes[name].push(geom.attributes[name]);
            attributesCount++;
        }
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        if (morphTargetsRelative !== geom.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(let name in geom.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === void 0) morphAttributes[name] = [];
            morphAttributes[name].push(geom.morphAttributes[name]);
        }
        mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
        mergedGeometry.userData.mergedUserData.push(geom.userData);
        if (useGroups) {
            let count;
            if (geom.index) count = geom.index.count;
            else if (geom.attributes.position !== void 0) count = geom.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    });
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        geometries.forEach((geom)=>{
            const index = geom.index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geom.attributes.position.count;
        });
        mergedGeometry.setIndex(mergedIndex);
    }
    for(let name in attributes){
        const mergedAttribute = $a986598ce43127c1$export$c4eef4c1c9d34ea9(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    for(let name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $a986598ce43127c1$export$c4eef4c1c9d34ea9(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
};
const $a986598ce43127c1$export$c4eef4c1c9d34ea9 = (attributes)=>{
    let TypedArray = void 0;
    let itemSize = void 0;
    let normalized = void 0;
    let arrayLength = 0;
    attributes.forEach((attr)=>{
        if (TypedArray === void 0) TypedArray = attr.array.constructor;
        if (TypedArray !== attr.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === void 0) itemSize = attr.itemSize;
        if (itemSize !== attr.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === void 0) normalized = attr.normalized;
        if (normalized !== attr.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attr.array.length;
    });
    if (TypedArray && itemSize) {
        const array = new TypedArray(arrayLength);
        let offset = 0;
        attributes.forEach((attr)=>{
            array.set(attr.array, offset);
            offset += attr.array.length;
        });
        return new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
    }
};
const $a986598ce43127c1$export$308f9509e428a845 = (attributes)=>{
    let TypedArray = void 0;
    let arrayLength = 0;
    let stride = 0;
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === void 0) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    const interleavedBuffer = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++){
            const set = (0, $a40b1f8c68dbf97f$export$e3a4ac9ee65ec343)(iba, setters[k]);
            const get = (0, $a40b1f8c68dbf97f$export$e3a4ac9ee65ec343)(attribute, getters[k]);
            set(c, get(c));
        }
    }
    return res;
};
function $a986598ce43127c1$export$35bee7999e19754d(geometry) {
    let mem = 0;
    for(let name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
function $a986598ce43127c1$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    let nextIndex = 0;
    const attributeNames = Object.keys(geometry.attributes);
    const attrArrays = {};
    const morphAttrsArrays = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        attrArrays[name] = [];
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) morphAttrsArrays[name] = new Array(morphAttr.length).fill(0).map(()=>[]);
    }
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = attrArrays[name];
                const newMorphArrays = morphAttrsArrays[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    newarray.push(attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m].push(morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    const result = geometry.clone();
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const oldAttribute = geometry.getAttribute(name);
        const buffer = new oldAttribute.array.constructor(attrArrays[name]);
        const attribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer, oldAttribute.itemSize, oldAttribute.normalized);
        result.setAttribute(name, attribute);
        if (name in morphAttrsArrays) for(let j = 0; j < morphAttrsArrays[name].length; j++){
            const oldMorphAttribute = geometry.morphAttributes[name][j];
            const buffer2 = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j]);
            const morphAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer2, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
            result.morphAttributes[name][j] = morphAttribute;
        }
    }
    result.setIndex(newIndices);
    return result;
}
function $a986598ce43127c1$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $d5b33d7c30034067$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842) || drawMode === (0, $d5b33d7c30034067$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== void 0) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (index) {
            if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842)) for(let i = 1; i <= numberOfTriangles; i++){
                newIndices.push(index.getX(0));
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
            }
            else {
                for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                    newIndices.push(index.getX(i));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i + 2));
                } else {
                    newIndices.push(index.getX(i + 2));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i));
                }
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
function $a986598ce43127c1$export$29e54e2e4ab904e7(object) {
    if (object.geometry.isBufferGeometry !== true) {
        console.error("THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.");
        return null;
    }
    const _vA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object2, material2, attribute, morphAttribute, morphTargetsRelative2, a2, b2, c2, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a2);
        _vB.fromBufferAttribute(attribute, b2);
        _vC.fromBufferAttribute(attribute, c2);
        const morphInfluences = object2.morphTargetInfluences;
        if (// @ts-ignore
        material2.morphTargets && morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i2 = 0, il2 = morphAttribute.length; i2 < il2; i2++){
                const influence = morphInfluences[i2];
                const morph = morphAttribute[i2];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a2);
                _tempB.fromBufferAttribute(morph, b2);
                _tempC.fromBufferAttribute(morph, c2);
                if (morphTargetsRelative2) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object2.isSkinnedMesh) {
            object2.boneTransform(a2, _vA);
            object2.boneTransform(b2, _vB);
            object2.boneTransform(c2, _vC);
        }
        modifiedAttributeArray[a2 * 3 + 0] = _vA.x;
        modifiedAttributeArray[a2 * 3 + 1] = _vA.y;
        modifiedAttributeArray[a2 * 3 + 2] = _vA.z;
        modifiedAttributeArray[b2 * 3 + 0] = _vB.x;
        modifiedAttributeArray[b2 * 3 + 1] = _vB.y;
        modifiedAttributeArray[b2 * 3 + 2] = _vB.z;
        modifiedAttributeArray[c2 * 3 + 0] = _vC.x;
        modifiedAttributeArray[c2 * 3 + 1] = _vC.y;
        modifiedAttributeArray[c2 * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group, groupMaterial;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else if (positionAttribute !== void 0) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $a986598ce43127c1$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 100;
    const verts = [
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempVec2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        const normal = new (0, $d5b33d7c30034067$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}



function $17561890c7c2a665$export$ec5093c33bb05608(array) {
    if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
    let s = "";
    for(let i = 0, il = array.length; i < il; i++)s += String.fromCharCode(array[i]);
    try {
        return decodeURIComponent(escape(s));
    } catch (e) {
        return s;
    }
}


const $d85c731da4846b4e$var$SRGBColorSpace = "srgb";
const $d85c731da4846b4e$var$LinearSRGBColorSpace = "srgb-linear";
const $d85c731da4846b4e$var$sRGBEncoding = 3001;
const $d85c731da4846b4e$var$LinearEncoding = 3e3;
class $d85c731da4846b4e$export$aa93f11e7884f0f4 extends (0, $d5b33d7c30034067$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsDispersionExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMaterialsBumpExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $d85c731da4846b4e$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") {
            const relativeUrl = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).extractUrlBase(url);
            resourcePath = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(relativeUrl, this.path);
        } else resourcePath = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).extractUrlBase(url);
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = (0, $17561890c7c2a665$export$ec5093c33bb05608)(new Uint8Array(data.slice(0, 4)));
            if (magic === $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF] = new $d85c731da4846b4e$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse((0, $17561890c7c2a665$export$ec5093c33bb05608)(new Uint8Array(data)));
        } else json = data;
        if (json.asset === void 0 || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $d85c731da4846b4e$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            if (!plugin.name) console.error("THREE.GLTFLoader: Invalid plugin found: missing name");
            plugins[plugin.name] = plugin;
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFMaterialsUnlitExtension();
                    break;
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFTextureTransformExtension();
                    break;
                case $d85c731da4846b4e$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $d85c731da4846b4e$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
function $d85c731da4846b4e$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
const $d85c731da4846b4e$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_MATERIALS_BUMP: "EXT_materials_bump",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class $d85c731da4846b4e$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(16777215);
        if (lightDef.color !== void 0) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
        const range = lightDef.range !== void 0 ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $d5b33d7c30034067$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $d5b33d7c30034067$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $d5b33d7c30034067$export$81495cbb73897362)(color);
                lightNode.distance = range;
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $d85c731da4846b4e$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== void 0) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self2 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === void 0) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self2.cache, lightIndex, light);
        });
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $d5b33d7c30034067$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(1, 1, 1);
        materialParams.opacity = 1;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, $d85c731da4846b4e$var$SRGBColorSpace));
        }
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== void 0) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== void 0) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== void 0) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== void 0) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== void 0) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== void 0) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsDispersionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.dispersion = extension.dispersion !== void 0 ? extension.dispersion : 0;
        return Promise.resolve();
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== void 0) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== void 0) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== void 0) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === void 0) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== void 0) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== void 0) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== void 0) {
            const colorFactor = extension.sheenColorFactor;
            materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
        }
        if (extension.sheenRoughnessFactor !== void 0) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, $d85c731da4846b4e$var$SRGBColorSpace));
        if (extension.sheenRoughnessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== void 0) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== void 0) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().setRGB(colorArray[0], colorArray[1], colorArray[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
        if (extension.specularTexture !== void 0) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().setRGB(colorArray[0], colorArray[1], colorArray[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
        if (extension.specularColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, $d85c731da4846b4e$var$SRGBColorSpace));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsBumpExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.bumpScale = extension.bumpFactor !== void 0 ? extension.bumpFactor : 1;
        if (extension.bumpTexture !== void 0) pending.push(parser.assignTexture(materialParams, "bumpMap", extension.bumpTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== void 0) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== void 0) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== void 0) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
class $d85c731da4846b4e$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
class $d85c731da4846b4e$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
class $d85c731da4846b4e$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
class $d85c731da4846b4e$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res2) {
                    return res2.buffer;
                });
                else return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
class $d85c731da4846b4e$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === void 0) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== void 0) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count;
            const instancedMeshes = [];
            for (const mesh of meshes){
                const m = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                const p = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
                const q = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
                const s = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $d5b33d7c30034067$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                for(const attributeName in attributes){
                    if (attributeName === "_COLOR_0") {
                        const attr = attributes[attributeName];
                        instancedMesh.instanceColor = new (0, $d5b33d7c30034067$export$32ea87a8b54d744a)(attr.array, attr.itemSize, attr.normalized);
                    } else if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                }
                (0, $d5b33d7c30034067$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
const $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $d85c731da4846b4e$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 1313821514,
    BIN: 5130562
};
class $d85c731da4846b4e$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH);
        this.header = {
            magic: (0, $17561890c7c2a665$export$ec5093c33bb05608)(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $d85c731da4846b4e$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = (0, $17561890c7c2a665$export$ec5093c33bb05608)(contentArray);
            } else if (chunkType === $d85c731da4846b4e$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $d85c731da4846b4e$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
class $d85c731da4846b4e$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $d85c731da4846b4e$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $d85c731da4846b4e$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== void 0) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve, reject) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== void 0) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap, $d85c731da4846b4e$var$LinearSRGBColorSpace, reject);
            });
        });
    }
}
class $d85c731da4846b4e$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === void 0 || transform.texCoord === texture.channel) && transform.offset === void 0 && transform.rotation === void 0 && transform.scale === void 0) return texture;
        texture = texture.clone();
        if (transform.texCoord !== void 0) texture.channel = transform.texCoord;
        if (transform.offset !== void 0) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== void 0) texture.rotation = transform.rotation;
        if (transform.scale !== void 0) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
class $d85c731da4846b4e$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $d85c731da4846b4e$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
class $d85c731da4846b4e$var$GLTFCubicSplineInterpolant extends (0, $d5b33d7c30034067$export$b558baee9c0f72d3) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride];
            const m0 = values[offset0 + i + stride2] * td;
            const p1 = values[offset1 + i + stride];
            const m1 = values[offset1 + i] * td;
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $d85c731da4846b4e$var$_q = /* @__PURE__ */ new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
class $d85c731da4846b4e$var$GLTFCubicSplineQuaternionInterpolant extends $d85c731da4846b4e$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $d85c731da4846b4e$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
const $d85c731da4846b4e$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $d85c731da4846b4e$var$WEBGL_FILTERS = {
    9728: (0, $d5b33d7c30034067$export$727aa5ec3fe39bf0),
    9729: (0, $d5b33d7c30034067$export$8a72f490b25c56c8),
    9984: (0, $d5b33d7c30034067$export$d129e38cf6feaa8c),
    9985: (0, $d5b33d7c30034067$export$19a719f377145a13),
    9986: (0, $d5b33d7c30034067$export$d2327c1afe5bfdf2),
    9987: (0, $d5b33d7c30034067$export$5d8599b6a933fb1b)
};
const $d85c731da4846b4e$var$WEBGL_WRAPPINGS = {
    33071: (0, $d5b33d7c30034067$export$9d9334239a5a5e06),
    33648: (0, $d5b33d7c30034067$export$c7e7c00b14f51a4f),
    10497: (0, $d5b33d7c30034067$export$533346c8e8dac0f5)
};
const $d85c731da4846b4e$var$WEBGL_TYPE_SIZES = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};
const $d85c731da4846b4e$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    // uv => uv1, 4 uv channels
    // https://github.com/mrdoob/three.js/pull/25943
    // https://github.com/mrdoob/three.js/pull/25788
    ...(0, $11ba8c3812c85a5e$export$83d89fbfd8236492) >= 152 ? {
        TEXCOORD_0: "uv",
        TEXCOORD_1: "uv1",
        TEXCOORD_2: "uv2",
        TEXCOORD_3: "uv3"
    } : {
        TEXCOORD_0: "uv",
        TEXCOORD_1: "uv2"
    },
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $d85c731da4846b4e$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $d85c731da4846b4e$var$INTERPOLATION = {
    CUBICSPLINE: void 0,
    // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $d5b33d7c30034067$export$30fac1aace31cf4d),
    STEP: (0, $d5b33d7c30034067$export$995b32462a65e855)
};
const $d85c731da4846b4e$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
function $d85c731da4846b4e$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === void 0) cache["DefaultMaterial"] = new (0, $d5b33d7c30034067$export$f2980790215acccd)({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $d5b33d7c30034067$export$2ede184fc2998901)
    });
    return cache["DefaultMaterial"];
}
function $d85c731da4846b4e$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    for(const name in objectDef.extensions)if (knownExtensions[name] === void 0) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
function $d85c731da4846b4e$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== void 0) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
function $d85c731da4846b4e$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== void 0) hasMorphPosition = true;
        if (target.NORMAL !== void 0) hasMorphNormal = true;
        if (target.COLOR_0 !== void 0) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
function $d85c731da4846b4e$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== void 0) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $d85c731da4846b4e$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $d85c731da4846b4e$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $d85c731da4846b4e$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== void 0) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + $d85c731da4846b4e$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $d85c731da4846b4e$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $d85c731da4846b4e$var$getNormalizedComponentScale(constructor) {
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $d85c731da4846b4e$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $d85c731da4846b4e$var$_identityMatrix = /* @__PURE__ */ new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
class $d85c731da4846b4e$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        this.cache = new $d85c731da4846b4e$var$GLTFRegistry();
        this.associations = /* @__PURE__ */ new Map();
        this.primitiveCache = {};
        this.nodeCache = {};
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        this.nodeNamesUsed = {};
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $d5b33d7c30034067$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $d5b33d7c30034067$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        this.cache.removeAll();
        this.nodeCache = {};
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, result, json);
            $d85c731da4846b4e$var$assignExtrasToUserData(result, json);
            return Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                for (const scene of result.scenes)scene.updateMatrixWorld();
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
   * Marks the special nodes/meshes in json for efficient parse.
   */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== void 0) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                if (nodeDef.skin !== void 0) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== void 0) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */ _addNodeRef(cache, index) {
        if (index === void 0) return;
        if (cache.refs[index] === void 0) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        if (bufferDef.uri === void 0 && bufferIndex === 0) return Promise.resolve(this.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, void 0, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
            const itemSize = $d85c731da4846b4e$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== void 0) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== void 0) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $d85c731da4846b4e$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            if (byteStride && byteStride !== itemBytes) {
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    ib = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            if (accessorDef.sparse !== void 0) {
                const itemSizeIndices = $d85c731da4846b4e$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) bufferAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $d85c731da4846b4e$var$WEBGL_FILTERS[sampler.magFilter] || (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
            texture.minFilter = $d85c731da4846b4e$var$WEBGL_FILTERS[sampler.minFilter] || (0, $d5b33d7c30034067$export$5d8599b6a933fb1b);
            texture.wrapS = $d85c731da4846b4e$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $d5b33d7c30034067$export$533346c8e8dac0f5);
            texture.wrapT = $d85c731da4846b4e$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $d5b33d7c30034067$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== void 0) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== void 0) sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === void 0) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $d5b33d7c30034067$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
            });
        }).then(function(texture) {
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            $d85c731da4846b4e$var$assignExtrasToUserData(texture, sourceDef);
            texture.userData.mimeType = sourceDef.mimeType || $d85c731da4846b4e$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== void 0 && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== void 0 ? mapDef.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== void 0) {
                if (typeof colorSpace === "number") colorSpace = colorSpace === $d85c731da4846b4e$var$sRGBEncoding ? $d85c731da4846b4e$var$SRGBColorSpace : $d85c731da4846b4e$var$LinearSRGBColorSpace;
                if ("colorSpace" in texture) texture.colorSpace = colorSpace;
                else texture.encoding = colorSpace === $d85c731da4846b4e$var$SRGBColorSpace ? $d85c731da4846b4e$var$sRGBEncoding : $d85c731da4846b4e$var$LinearEncoding;
            }
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === void 0;
        const useVertexColors = geometry.attributes.color !== void 0;
        const useFlatShading = geometry.attributes.normal === void 0;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $d5b33d7c30034067$export$a178c45366ce5d6b)();
                (0, $d5b33d7c30034067$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false;
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $d5b33d7c30034067$export$fbaaa33907730a0c)();
                (0, $d5b33d7c30034067$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $d5b33d7c30034067$export$f2980790215acccd;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(1, 1, 1);
            materialParams.opacity = 1;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, $d85c731da4846b4e$var$SRGBColorSpace));
            materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
            materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
            if (metallicRoughness.metallicRoughnessTexture !== void 0) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $d5b33d7c30034067$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $d85c731da4846b4e$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $d85c731da4846b4e$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $d85c731da4846b4e$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== void 0) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== void 0) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            const emissiveFactor = materialDef.emissiveFactor;
            materialParams.emissive = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], $d85c731da4846b4e$var$LinearSRGBColorSpace);
        }
        if (materialDef.emissiveTexture !== void 0 && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, $d85c731da4846b4e$var$SRGBColorSpace));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $d85c731da4846b4e$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $d5b33d7c30034067$export$7bf70fcf9f891893).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $d85c731da4846b4e$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $d85c731da4846b4e$var$createPrimitiveKey(primitive);
            const cached = cache[cacheKey];
            if (cached) pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$d85c731da4846b4e$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) geometryPromise = createDracoPrimitive(primitive);
                else geometryPromise = $d85c731da4846b4e$var$addPrimitiveAttributes(new (0, $d5b33d7c30034067$export$b7be63a67df8959)(), primitive, parser);
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === void 0 ? $d85c731da4846b4e$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                let mesh;
                const material = materials[i];
                if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $d5b33d7c30034067$export$b303577035157ecf)(geometry, material) : new (0, $d5b33d7c30034067$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) mesh.normalizeSkinWeights();
                    if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $a986598ce43127c1$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $d5b33d7c30034067$export$b23a071aa286eb29));
                    else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $a986598ce43127c1$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $d5b33d7c30034067$export$f0d8293634f88842));
                } else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $d5b33d7c30034067$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $d5b33d7c30034067$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $d5b33d7c30034067$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $d85c731da4846b4e$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $d5b33d7c30034067$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $d85c731da4846b4e$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $d85c731da4846b4e$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
            if (meshDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $d5b33d7c30034067$export$74e4ae24825f68d7)((0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $d5b33d7c30034067$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $d85c731da4846b4e$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== void 0) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $d5b33d7c30034067$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === void 0) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === void 0) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $d5b33d7c30034067$export$d942c706bf23829c)(animationName, void 0, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === void 0) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            if (nodeDef.weights !== void 0) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === void 0 ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $d85c731da4846b4e$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        if (this.nodeCache[nodeIndex] !== void 0) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== void 0) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            if (nodeDef.isBone === true) node = new (0, $d5b33d7c30034067$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $d5b33d7c30034067$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $d85c731da4846b4e$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== void 0) {
                const matrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== void 0) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== void 0) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== void 0) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        const scene = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $d85c731da4846b4e$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $d85c731da4846b4e$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            const reduceAssociations = (node)=>{
                const reducedAssociations = /* @__PURE__ */ new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $d5b33d7c30034067$export$a2d8b23205c25948) || key instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node2)=>{
                    const mappings = parser.associations.get(node2);
                    if (mappings != null) reducedAssociations.set(node2, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($d85c731da4846b4e$var$PATH_PROPERTIES[target.path] === $d85c731da4846b4e$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($d85c731da4846b4e$var$PATH_PROPERTIES[target.path]){
            case $d85c731da4846b4e$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $d5b33d7c30034067$export$d45f0d1a4d9a9314);
                break;
            case $d85c731da4846b4e$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $d5b33d7c30034067$export$b8043f12b5aafbd7);
                break;
            case $d85c731da4846b4e$var$PATH_PROPERTIES.position:
            case $d85c731da4846b4e$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$d45f0d1a4d9a9314);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== void 0 ? $d85c731da4846b4e$var$INTERPOLATION[sampler.interpolation] : (0, $d5b33d7c30034067$export$30fac1aace31cf4d);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + "." + $d85c731da4846b4e$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            if (sampler.interpolation === "CUBICSPLINE") this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $d85c731da4846b4e$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            const interpolantType = this instanceof (0, $d5b33d7c30034067$export$b8043f12b5aafbd7) ? $d85c731da4846b4e$var$GLTFCubicSplineQuaternionInterpolant : $d85c731da4846b4e$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
function $d85c731da4846b4e$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== void 0) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        if (min !== void 0 && max !== void 0) {
            box.set(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $d5b33d7c30034067$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $d85c731da4846b4e$var$getNormalizedComponentScale($d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== void 0) {
        const maxDisplacement = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        const vector = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== void 0) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                if (min !== void 0 && max !== void 0) {
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $d85c731da4846b4e$var$getNormalizedComponentScale($d85c731da4846b4e$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $d5b33d7c30034067$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
function $d85c731da4846b4e$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $d85c731da4846b4e$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== void 0 && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
            geometry.setIndex(accessor2);
        });
        pending.push(accessor);
    }
    $d85c731da4846b4e$var$assignExtrasToUserData(geometry, primitiveDef);
    $d85c731da4846b4e$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== void 0 ? $d85c731da4846b4e$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}

let $3bf52461e9095b24$var$generated;
const $3bf52461e9095b24$export$1111800106ba519a = ()=>{
    if ($3bf52461e9095b24$var$generated) return $3bf52461e9095b24$var$generated;
    const wasm_base = "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";
    const wasm_simd = "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";
    const detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    const wasmpack = new Uint8Array([
        32,
        0,
        65,
        253,
        3,
        1,
        2,
        34,
        4,
        106,
        6,
        5,
        11,
        8,
        7,
        20,
        13,
        33,
        12,
        16,
        128,
        9,
        116,
        64,
        19,
        113,
        127,
        15,
        10,
        21,
        22,
        14,
        255,
        66,
        24,
        54,
        136,
        107,
        18,
        23,
        192,
        26,
        114,
        118,
        132,
        17,
        77,
        101,
        130,
        144,
        27,
        87,
        131,
        44,
        45,
        74,
        156,
        154,
        70,
        167
    ]);
    if (typeof WebAssembly !== "object") return {
        supported: false
    };
    let wasm = wasm_base;
    if (WebAssembly.validate(detector)) wasm = wasm_simd;
    let instance;
    const promise = WebAssembly.instantiate(unpack(wasm), {}).then((result)=>{
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        const result = new Uint8Array(data.length);
        for(let i = 0; i < data.length; ++i){
            const ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 71 : ch > 64 ? ch - 65 : ch > 47 ? ch + 4 : ch > 46 ? 63 : 62;
        }
        let write = 0;
        for(let i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(fun, target, count, size, source, filter) {
        const sbrk = instance.exports.sbrk;
        const count4 = count + 3 & -4;
        const tp = sbrk(count4 * size);
        const sp = sbrk(source.length);
        const heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        const res = fun(tp, count, size, sp, source.length);
        if (res === 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res !== 0) throw new Error(`Malformed buffer data: ${res}`);
    }
    const filters = {
        // legacy index-based enums for glTF
        0: "",
        1: "meshopt_decodeFilterOct",
        2: "meshopt_decodeFilterQuat",
        3: "meshopt_decodeFilterExp",
        // string-based enums for glTF
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    };
    const decoders = {
        // legacy index-based enums for glTF
        0: "meshopt_decodeVertexBuffer",
        1: "meshopt_decodeIndexBuffer",
        2: "meshopt_decodeIndexSequence",
        // string-based enums for glTF
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    };
    $3bf52461e9095b24$var$generated = {
        ready: promise,
        supported: true,
        decodeVertexBuffer (target, count, size, source, filter) {
            decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer (target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence (target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer (target, count, size, source, mode, filter) {
            decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        }
    };
    return $3bf52461e9095b24$var$generated;
};



let $d88227174eee7553$var$dracoLoader = null;
let $d88227174eee7553$var$decoderPath = 'https://www.gstatic.com/draco/versioned/decoders/1.5.5/';
function $d88227174eee7553$var$extensions(useDraco, useMeshopt, extendLoader) {
    return (loader)=>{
        if (extendLoader) extendLoader(loader);
        if (useDraco) {
            if (!$d88227174eee7553$var$dracoLoader) $d88227174eee7553$var$dracoLoader = new (0, $76ab0928a0395fd1$export$45c25de53be259ac)();
            $d88227174eee7553$var$dracoLoader.setDecoderPath(typeof useDraco === 'string' ? useDraco : $d88227174eee7553$var$decoderPath);
            loader.setDRACOLoader($d88227174eee7553$var$dracoLoader);
        }
        if (useMeshopt) loader.setMeshoptDecoder(typeof (0, $3bf52461e9095b24$export$1111800106ba519a) === 'function' ? (0, $3bf52461e9095b24$export$1111800106ba519a)() : (0, $3bf52461e9095b24$export$1111800106ba519a));
    };
}
function $d88227174eee7553$export$cf1b4e938a4da41b(path, useDraco = true, useMeshOpt = true, extendLoader) {
    return (0, $2ec6beadbaf9c031$export$d66501df72047452)((0, $d85c731da4846b4e$export$aa93f11e7884f0f4), path, $d88227174eee7553$var$extensions(useDraco, useMeshOpt, extendLoader));
}
$d88227174eee7553$export$cf1b4e938a4da41b.preload = (path, useDraco = true, useMeshOpt = true, extendLoader)=>(0, $2ec6beadbaf9c031$export$d66501df72047452).preload((0, $d85c731da4846b4e$export$aa93f11e7884f0f4), path, $d88227174eee7553$var$extensions(useDraco, useMeshOpt, extendLoader));
$d88227174eee7553$export$cf1b4e938a4da41b.clear = (input)=>(0, $2ec6beadbaf9c031$export$d66501df72047452).clear((0, $d85c731da4846b4e$export$aa93f11e7884f0f4), input);
$d88227174eee7553$export$cf1b4e938a4da41b.setDecoderPath = (path)=>{
    $d88227174eee7553$var$decoderPath = path;
};
//
const $d88227174eee7553$export$535c9224d68a21b5 = /* @__PURE__ */ $acw62.forwardRef(({ src: src, useDraco: useDraco, useMeshOpt: useMeshOpt, extendLoader: extendLoader, ...props }, ref)=>{
    const { scene: scene } = $d88227174eee7553$export$cf1b4e938a4da41b(src, useDraco, useMeshOpt, extendLoader);
    return /*#__PURE__*/ $acw62.createElement((0, $a68050441c565260$export$b5d07669a5562b23), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        object: scene
    }));
});


var $acw62 = parcelRequire("acw62");


const $5262a5eb989d2b7b$export$e64f6626d4e96cfb = (url)=>url === Object(url) && !Array.isArray(url) && typeof url !== 'function';
function $5262a5eb989d2b7b$export$5dd4f4a1dff269b2(input, onLoad) {
    const gl = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.gl);
    const textures = (0, $2ec6beadbaf9c031$export$d66501df72047452)((0, $d5b33d7c30034067$export$fd1bfc71f64c538c), $5262a5eb989d2b7b$export$e64f6626d4e96cfb(input) ? Object.values(input) : input);
    (0, $acw62.useLayoutEffect)(()=>{
        onLoad == null || onLoad(textures);
    }, [
        onLoad
    ]);
    // https://github.com/mrdoob/three.js/issues/22696
    // Upload the texture to the GPU immediately instead of waiting for the first render
    // NOTE: only available for WebGLRenderer
    (0, $acw62.useEffect)(()=>{
        if ('initTexture' in gl) {
            let textureArray = [];
            if (Array.isArray(textures)) textureArray = textures;
            else if (textures instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) textureArray = [
                textures
            ];
            else if ($5262a5eb989d2b7b$export$e64f6626d4e96cfb(textures)) textureArray = Object.values(textures);
            textureArray.forEach((texture)=>{
                if (texture instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) gl.initTexture(texture);
            });
        }
    }, [
        gl,
        textures
    ]);
    const mappedTextures = (0, $acw62.useMemo)(()=>{
        if ($5262a5eb989d2b7b$export$e64f6626d4e96cfb(input)) {
            const keyed = {};
            let i = 0;
            for(const key in input)keyed[key] = textures[i++];
            return keyed;
        } else return textures;
    }, [
        input,
        textures
    ]);
    return mappedTextures;
}
$5262a5eb989d2b7b$export$5dd4f4a1dff269b2.preload = (url)=>(0, $2ec6beadbaf9c031$export$d66501df72047452).preload((0, $d5b33d7c30034067$export$fd1bfc71f64c538c), url);
$5262a5eb989d2b7b$export$5dd4f4a1dff269b2.clear = (input)=>(0, $2ec6beadbaf9c031$export$d66501df72047452).clear((0, $d5b33d7c30034067$export$fd1bfc71f64c538c), input);
//
const $5262a5eb989d2b7b$export$5431306cf43de24a = ({ children: children, input: input, onLoad: onLoad })=>{
    const ret = $5262a5eb989d2b7b$export$5dd4f4a1dff269b2(input, onLoad);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, children == null ? void 0 : children(ret));
};



var $2LLMu = parcelRequire("2LLMu");


var $acw62 = parcelRequire("acw62");



const $58b973547927d544$export$e3a4ac9ee65ec343 = (obj, key)=>obj[key];


const $7567b49210ee5748$export$728c051ccdf8a702 = (geometries, useGroups)=>{
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
    let offset = 0;
    geometries.forEach((geom, i)=>{
        let attributesCount = 0;
        if (isIndexed !== (geom.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        for(let name in geom.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === void 0) attributes[name] = [];
            attributes[name].push(geom.attributes[name]);
            attributesCount++;
        }
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        if (morphTargetsRelative !== geom.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(let name in geom.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === void 0) morphAttributes[name] = [];
            morphAttributes[name].push(geom.morphAttributes[name]);
        }
        mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
        mergedGeometry.userData.mergedUserData.push(geom.userData);
        if (useGroups) {
            let count;
            if (geom.index) count = geom.index.count;
            else if (geom.attributes.position !== void 0) count = geom.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    });
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        geometries.forEach((geom)=>{
            const index = geom.index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geom.attributes.position.count;
        });
        mergedGeometry.setIndex(mergedIndex);
    }
    for(let name in attributes){
        const mergedAttribute = $7567b49210ee5748$export$c4eef4c1c9d34ea9(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    for(let name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $7567b49210ee5748$export$c4eef4c1c9d34ea9(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
};
const $7567b49210ee5748$export$c4eef4c1c9d34ea9 = (attributes)=>{
    let TypedArray = void 0;
    let itemSize = void 0;
    let normalized = void 0;
    let arrayLength = 0;
    attributes.forEach((attr)=>{
        if (TypedArray === void 0) TypedArray = attr.array.constructor;
        if (TypedArray !== attr.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === void 0) itemSize = attr.itemSize;
        if (itemSize !== attr.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === void 0) normalized = attr.normalized;
        if (normalized !== attr.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attr.array.length;
    });
    if (TypedArray && itemSize) {
        const array = new TypedArray(arrayLength);
        let offset = 0;
        attributes.forEach((attr)=>{
            array.set(attr.array, offset);
            offset += attr.array.length;
        });
        return new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
    }
};
const $7567b49210ee5748$export$308f9509e428a845 = (attributes)=>{
    let TypedArray = void 0;
    let arrayLength = 0;
    let stride = 0;
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === void 0) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    const interleavedBuffer = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++){
            const set = (0, $58b973547927d544$export$e3a4ac9ee65ec343)(iba, setters[k]);
            const get = (0, $58b973547927d544$export$e3a4ac9ee65ec343)(attribute, getters[k]);
            set(c, get(c));
        }
    }
    return res;
};
function $7567b49210ee5748$export$35bee7999e19754d(geometry) {
    let mem = 0;
    for(let name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
function $7567b49210ee5748$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    let nextIndex = 0;
    const attributeNames = Object.keys(geometry.attributes);
    const attrArrays = {};
    const morphAttrsArrays = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        attrArrays[name] = [];
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) morphAttrsArrays[name] = new Array(morphAttr.length).fill(0).map(()=>[]);
    }
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = attrArrays[name];
                const newMorphArrays = morphAttrsArrays[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    newarray.push(attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m].push(morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    const result = geometry.clone();
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const oldAttribute = geometry.getAttribute(name);
        const buffer = new oldAttribute.array.constructor(attrArrays[name]);
        const attribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer, oldAttribute.itemSize, oldAttribute.normalized);
        result.setAttribute(name, attribute);
        if (name in morphAttrsArrays) for(let j = 0; j < morphAttrsArrays[name].length; j++){
            const oldMorphAttribute = geometry.morphAttributes[name][j];
            const buffer2 = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j]);
            const morphAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffer2, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
            result.morphAttributes[name][j] = morphAttribute;
        }
    }
    result.setIndex(newIndices);
    return result;
}
function $7567b49210ee5748$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $d5b33d7c30034067$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842) || drawMode === (0, $d5b33d7c30034067$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== void 0) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (index) {
            if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842)) for(let i = 1; i <= numberOfTriangles; i++){
                newIndices.push(index.getX(0));
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
            }
            else {
                for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                    newIndices.push(index.getX(i));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i + 2));
                } else {
                    newIndices.push(index.getX(i + 2));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i));
                }
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
function $7567b49210ee5748$export$29e54e2e4ab904e7(object) {
    if (object.geometry.isBufferGeometry !== true) {
        console.error("THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.");
        return null;
    }
    const _vA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object2, material2, attribute, morphAttribute, morphTargetsRelative2, a2, b2, c2, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a2);
        _vB.fromBufferAttribute(attribute, b2);
        _vC.fromBufferAttribute(attribute, c2);
        const morphInfluences = object2.morphTargetInfluences;
        if (// @ts-ignore
        material2.morphTargets && morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i2 = 0, il2 = morphAttribute.length; i2 < il2; i2++){
                const influence = morphInfluences[i2];
                const morph = morphAttribute[i2];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a2);
                _tempB.fromBufferAttribute(morph, b2);
                _tempC.fromBufferAttribute(morph, c2);
                if (morphTargetsRelative2) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object2.isSkinnedMesh) {
            object2.boneTransform(a2, _vA);
            object2.boneTransform(b2, _vB);
            object2.boneTransform(c2, _vC);
        }
        modifiedAttributeArray[a2 * 3 + 0] = _vA.x;
        modifiedAttributeArray[a2 * 3 + 1] = _vA.y;
        modifiedAttributeArray[a2 * 3 + 2] = _vA.z;
        modifiedAttributeArray[b2 * 3 + 0] = _vB.x;
        modifiedAttributeArray[b2 * 3 + 1] = _vB.y;
        modifiedAttributeArray[b2 * 3 + 2] = _vB.z;
        modifiedAttributeArray[c2 * 3 + 0] = _vC.x;
        modifiedAttributeArray[c2 * 3 + 1] = _vC.y;
        modifiedAttributeArray[c2 * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group, groupMaterial;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else if (positionAttribute !== void 0) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $7567b49210ee5748$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 100;
    const verts = [
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempVec2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.toNonIndexed();
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        const normal = new (0, $d5b33d7c30034067$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}


function $4708f0499e113eb5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4708f0499e113eb5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4708f0499e113eb5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4708f0499e113eb5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4708f0499e113eb5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4708f0499e113eb5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const $4708f0499e113eb5$var$_quaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)();
const $4708f0499e113eb5$var$_vector3 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
new (0, $d5b33d7c30034067$export$e4dd07dff30cc924)();
const $4708f0499e113eb5$var$_matrix4 = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
const $4708f0499e113eb5$var$_position = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $4708f0499e113eb5$var$_rotation = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
const $4708f0499e113eb5$var$_scale = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $4708f0499e113eb5$var$vectorArrayToVector3 = (arr)=>{
    const [x, y, z] = arr;
    return new (0, $d5b33d7c30034067$export$64b5c384219d3699)(x, y, z);
};
const $4708f0499e113eb5$var$rapierQuaternionToQuaternion = ({ x: x, y: y, z: z, w: w })=>$4708f0499e113eb5$var$_quaternion.set(x, y, z, w);
const $4708f0499e113eb5$var$vector3ToRapierVector = (v)=>{
    if (Array.isArray(v)) return new (0, $2LLMu.Vector3)(v[0], v[1], v[2]);
    else if (typeof v === "number") return new (0, $2LLMu.Vector3)(v, v, v);
    else {
        const threeVector3 = v;
        return new (0, $2LLMu.Vector3)(threeVector3.x, threeVector3.y, threeVector3.z);
    }
};
const $4708f0499e113eb5$var$quaternionToRapierQuaternion = (v)=>{
    if (Array.isArray(v)) return new (0, $2LLMu.Quaternion)(v[0], v[1], v[2], v[3]);
    else return new (0, $2LLMu.Quaternion)(v.x, v.y, v.z, v.w);
};
const $4708f0499e113eb5$var$rigidBodyTypeMap = {
    fixed: 1,
    dynamic: 0,
    kinematicPosition: 2,
    kinematicVelocity: 3
};
const $4708f0499e113eb5$var$rigidBodyTypeFromString = (type)=>$4708f0499e113eb5$var$rigidBodyTypeMap[type];
const $4708f0499e113eb5$var$scaleVertices = (vertices, scale)=>{
    const scaledVerts = Array.from(vertices);
    for(let i = 0; i < vertices.length / 3; i++){
        scaledVerts[i * 3] *= scale.x;
        scaledVerts[i * 3 + 1] *= scale.y;
        scaledVerts[i * 3 + 2] *= scale.z;
    }
    return scaledVerts;
};
const $4708f0499e113eb5$var$vectorToTuple = (v)=>{
    if (!v) return [
        0
    ];
    if (v instanceof (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)) return [
        v.x,
        v.y,
        v.z,
        v.w
    ];
    if (v instanceof (0, $d5b33d7c30034067$export$64b5c384219d3699) || v instanceof (0, $d5b33d7c30034067$export$d93cc409a0768c5f)) return [
        v.x,
        v.y,
        v.z
    ];
    if (Array.isArray(v)) return v;
    return [
        v
    ];
};
function $4708f0499e113eb5$var$useConst(initialValue) {
    const ref = (0, $acw62.useRef)();
    if (ref.current === undefined) ref.current = {
        value: typeof initialValue === "function" ? initialValue() : initialValue
    };
    return ref.current.value;
}
const $4708f0499e113eb5$var$useRaf = (callback)=>{
    const cb = (0, $acw62.useRef)(callback);
    const raf = (0, $acw62.useRef)(0);
    const lastFrame = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        cb.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        const loop = ()=>{
            const now = performance.now();
            const delta = now - lastFrame.current;
            raf.current = requestAnimationFrame(loop);
            cb.current(delta / 1000);
            lastFrame.current = now;
        };
        raf.current = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(raf.current);
    }, []);
};
const $4708f0499e113eb5$var$UseFrameStepper = ({ onStep: onStep, updatePriority: updatePriority })=>{
    (0, $2ec6beadbaf9c031$export$e7094788287c5e9b)((_, dt)=>{
        onStep(dt);
    }, updatePriority);
    return null;
};
const $4708f0499e113eb5$var$RafStepper = ({ onStep: onStep })=>{
    $4708f0499e113eb5$var$useRaf((dt)=>{
        onStep(dt);
    });
    return null;
};
const $4708f0499e113eb5$var$FrameStepper = ({ onStep: onStep, type: type, updatePriority: updatePriority })=>{
    return type === "independent" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$RafStepper, {
        onStep: onStep
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$UseFrameStepper, {
        onStep: onStep,
        updatePriority: updatePriority
    });
};
var $4708f0499e113eb5$var$FrameStepper$1 = /*#__PURE__*/ (0, $acw62.memo)($4708f0499e113eb5$var$FrameStepper);
function $4708f0499e113eb5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4708f0499e113eb5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4708f0499e113eb5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $4708f0499e113eb5$var$_excluded$2 = [
    "mass",
    "linearDamping",
    "angularDamping",
    "type",
    "onCollisionEnter",
    "onCollisionExit",
    "onIntersectionEnter",
    "onIntersectionExit",
    "onContactForce",
    "children",
    "canSleep",
    "ccd",
    "gravityScale",
    "softCcdPrediction"
];
const $4708f0499e113eb5$var$scaleColliderArgs = (shape, args, scale)=>{
    const newArgs = args.slice(); // Heightfield uses a vector
    if (shape === "heightfield") {
        const s = newArgs[3];
        s.x *= scale.x;
        s.x *= scale.y;
        s.x *= scale.z;
        return newArgs;
    } // Trimesh and convex scale the vertices
    if (shape === "trimesh" || shape === "convexHull") {
        newArgs[0] = $4708f0499e113eb5$var$scaleVertices(newArgs[0], scale);
        return newArgs;
    } // Prepfill with some extra
    const scaleArray = [
        scale.x,
        scale.y,
        scale.z,
        scale.x,
        scale.x
    ];
    return newArgs.map((arg, index)=>scaleArray[index] * arg);
};
const $4708f0499e113eb5$var$createColliderFromOptions = (options, world, scale, getRigidBody)=>{
    const scaledArgs = $4708f0499e113eb5$var$scaleColliderArgs(options.shape, options.args, scale); // @ts-ignore
    const desc = (0, $2LLMu.ColliderDesc)[options.shape](...scaledArgs);
    return world.createCollider(desc, getRigidBody === null || getRigidBody === void 0 ? void 0 : getRigidBody());
};
const $4708f0499e113eb5$var$immutableColliderOptions = [
    "shape",
    "args"
];
const $4708f0499e113eb5$var$massPropertiesConflictError = "Please pick ONLY ONE of the `density`, `mass` and `massProperties` options.";
const $4708f0499e113eb5$var$setColliderMassOptions = (collider, options)=>{
    if (options.density !== undefined) {
        if (options.mass !== undefined || options.massProperties !== undefined) throw new Error($4708f0499e113eb5$var$massPropertiesConflictError);
        collider.setDensity(options.density);
        return;
    }
    if (options.mass !== undefined) {
        if (options.massProperties !== undefined) throw new Error($4708f0499e113eb5$var$massPropertiesConflictError);
        collider.setMass(options.mass);
        return;
    }
    if (options.massProperties !== undefined) collider.setMassProperties(options.massProperties.mass, options.massProperties.centerOfMass, options.massProperties.principalAngularInertia, options.massProperties.angularInertiaLocalFrame);
};
const $4708f0499e113eb5$var$mutableColliderOptions = {
    sensor: (collider, value)=>{
        collider.setSensor(value);
    },
    collisionGroups: (collider, value)=>{
        collider.setCollisionGroups(value);
    },
    solverGroups: (collider, value)=>{
        collider.setSolverGroups(value);
    },
    friction: (collider, value)=>{
        collider.setFriction(value);
    },
    frictionCombineRule: (collider, value)=>{
        collider.setFrictionCombineRule(value);
    },
    restitution: (collider, value)=>{
        collider.setRestitution(value);
    },
    restitutionCombineRule: (collider, value)=>{
        collider.setRestitutionCombineRule(value);
    },
    activeCollisionTypes: (collider, value)=>{
        collider.setActiveCollisionTypes(value);
    },
    contactSkin: (collider, value)=>{
        collider.setContactSkin(value);
    },
    // To make sure the options all mutable options are listed
    quaternion: ()=>{},
    position: ()=>{},
    rotation: ()=>{},
    scale: ()=>{}
};
const $4708f0499e113eb5$var$mutableColliderOptionKeys = Object.keys($4708f0499e113eb5$var$mutableColliderOptions);
const $4708f0499e113eb5$var$setColliderOptions = (collider, options, states)=>{
    const state = states.get(collider.handle);
    if (state) {
        var _state$worldParent;
        // Update collider position based on the object's position
        const parentWorldScale = state.object.parent.getWorldScale($4708f0499e113eb5$var$_vector3);
        const parentInvertedWorldMatrix = (_state$worldParent = state.worldParent) === null || _state$worldParent === void 0 ? void 0 : _state$worldParent.matrixWorld.clone().invert();
        state.object.updateWorldMatrix(true, false);
        $4708f0499e113eb5$var$_matrix4.copy(state.object.matrixWorld);
        if (parentInvertedWorldMatrix) $4708f0499e113eb5$var$_matrix4.premultiply(parentInvertedWorldMatrix);
        $4708f0499e113eb5$var$_matrix4.decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
        if (collider.parent()) {
            collider.setTranslationWrtParent({
                x: $4708f0499e113eb5$var$_position.x * parentWorldScale.x,
                y: $4708f0499e113eb5$var$_position.y * parentWorldScale.y,
                z: $4708f0499e113eb5$var$_position.z * parentWorldScale.z
            });
            collider.setRotationWrtParent($4708f0499e113eb5$var$_rotation);
        } else {
            collider.setTranslation({
                x: $4708f0499e113eb5$var$_position.x * parentWorldScale.x,
                y: $4708f0499e113eb5$var$_position.y * parentWorldScale.y,
                z: $4708f0499e113eb5$var$_position.z * parentWorldScale.z
            });
            collider.setRotation($4708f0499e113eb5$var$_rotation);
        }
        $4708f0499e113eb5$var$mutableColliderOptionKeys.forEach((key)=>{
            if (key in options) {
                const option = options[key];
                $4708f0499e113eb5$var$mutableColliderOptions[key](collider, option, options);
            }
        }); // handle mass separately, because the assignments
        // are exclusive.
        $4708f0499e113eb5$var$setColliderMassOptions(collider, options);
    }
};
const $4708f0499e113eb5$var$useUpdateColliderOptions = (getCollider, props, states)=>{
    // TODO: Improve this, split each prop into its own effect
    const mutablePropsAsFlatArray = (0, $acw62.useMemo)(()=>$4708f0499e113eb5$var$mutableColliderOptionKeys.flatMap((key)=>{
            return $4708f0499e113eb5$var$vectorToTuple(props[key]);
        }), [
        props
    ]);
    (0, $acw62.useEffect)(()=>{
        const collider = getCollider();
        $4708f0499e113eb5$var$setColliderOptions(collider, props, states);
    }, [
        ...mutablePropsAsFlatArray,
        getCollider
    ]);
};
const $4708f0499e113eb5$var$isChildOfMeshCollider = (child)=>{
    let flag = false;
    child.traverseAncestors((a)=>{
        if (a.userData.r3RapierType === "MeshCollider") flag = true;
    });
    return flag;
};
const $4708f0499e113eb5$var$createColliderState = (collider, object, rigidBodyObject)=>{
    return {
        collider: collider,
        worldParent: rigidBodyObject || undefined,
        object: object
    };
};
const $4708f0499e113eb5$var$autoColliderMap = {
    cuboid: "cuboid",
    ball: "ball",
    hull: "convexHull",
    trimesh: "trimesh"
};
const $4708f0499e113eb5$var$createColliderPropsFromChildren = ({ object: object, ignoreMeshColliders: _ignoreMeshColliders = true, options: options })=>{
    const childColliderProps = [];
    object.updateWorldMatrix(true, false);
    const invertedParentMatrixWorld = object.matrixWorld.clone().invert();
    const colliderFromChild = (child)=>{
        if ("isMesh" in child) {
            if (_ignoreMeshColliders && $4708f0499e113eb5$var$isChildOfMeshCollider(child)) return;
            const worldScale = child.getWorldScale($4708f0499e113eb5$var$_scale);
            const shape = $4708f0499e113eb5$var$autoColliderMap[options.colliders || "cuboid"];
            child.updateWorldMatrix(true, false);
            $4708f0499e113eb5$var$_matrix4.copy(child.matrixWorld).premultiply(invertedParentMatrixWorld).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
            const rotationEuler = new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)().setFromQuaternion($4708f0499e113eb5$var$_rotation, "XYZ");
            const { geometry: geometry } = child;
            const { args: args, offset: offset } = $4708f0499e113eb5$var$getColliderArgsFromGeometry(geometry, options.colliders || "cuboid");
            const colliderProps = $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, $4708f0499e113eb5$var$cleanRigidBodyPropsForCollider(options)), {}, {
                args: args,
                shape: shape,
                rotation: [
                    rotationEuler.x,
                    rotationEuler.y,
                    rotationEuler.z
                ],
                position: [
                    $4708f0499e113eb5$var$_position.x + offset.x * worldScale.x,
                    $4708f0499e113eb5$var$_position.y + offset.y * worldScale.y,
                    $4708f0499e113eb5$var$_position.z + offset.z * worldScale.z
                ],
                scale: [
                    worldScale.x,
                    worldScale.y,
                    worldScale.z
                ]
            });
            childColliderProps.push(colliderProps);
        }
    };
    if (options.includeInvisible) object.traverse(colliderFromChild);
    else object.traverseVisible(colliderFromChild);
    return childColliderProps;
};
const $4708f0499e113eb5$var$getColliderArgsFromGeometry = (geometry, colliders)=>{
    switch(colliders){
        case "cuboid":
            {
                geometry.computeBoundingBox();
                const { boundingBox: boundingBox } = geometry;
                const size = boundingBox.getSize(new (0, $d5b33d7c30034067$export$64b5c384219d3699)());
                return {
                    args: [
                        size.x / 2,
                        size.y / 2,
                        size.z / 2
                    ],
                    offset: boundingBox.getCenter(new (0, $d5b33d7c30034067$export$64b5c384219d3699)())
                };
            }
        case "ball":
            {
                geometry.computeBoundingSphere();
                const { boundingSphere: boundingSphere } = geometry;
                const radius = boundingSphere.radius;
                return {
                    args: [
                        radius
                    ],
                    offset: boundingSphere.center
                };
            }
        case "trimesh":
            {
                var _clonedGeometry$index;
                const clonedGeometry = geometry.index ? geometry.clone() : (0, $7567b49210ee5748$export$e36bb98c4c944f9)(geometry);
                return {
                    args: [
                        clonedGeometry.attributes.position.array,
                        (_clonedGeometry$index = clonedGeometry.index) === null || _clonedGeometry$index === void 0 ? void 0 : _clonedGeometry$index.array
                    ],
                    offset: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
                };
            }
        case "hull":
            {
                const g = geometry.clone();
                return {
                    args: [
                        g.attributes.position.array
                    ],
                    offset: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
                };
            }
    }
    return {
        args: [],
        offset: new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    };
};
const $4708f0499e113eb5$var$getActiveCollisionEventsFromProps = (props)=>{
    return {
        collision: !!(props !== null && props !== void 0 && props.onCollisionEnter || props !== null && props !== void 0 && props.onCollisionExit || props !== null && props !== void 0 && props.onIntersectionEnter || props !== null && props !== void 0 && props.onIntersectionExit),
        contactForce: !!(props !== null && props !== void 0 && props.onContactForce)
    };
};
const $4708f0499e113eb5$var$useColliderEvents = (getCollider, props, events, /**
 * The RigidBody can pass down active events to the collider without attaching the event listners
 */ activeEvents = {})=>{
    const { onCollisionEnter: onCollisionEnter, onCollisionExit: onCollisionExit, onIntersectionEnter: onIntersectionEnter, onIntersectionExit: onIntersectionExit, onContactForce: onContactForce } = props;
    (0, $acw62.useEffect)(()=>{
        const collider = getCollider();
        if (collider) {
            const { collision: collisionEventsActive, contactForce: contactForceEventsActive } = $4708f0499e113eb5$var$getActiveCollisionEventsFromProps(props);
            const hasCollisionEvent = collisionEventsActive || activeEvents.collision;
            const hasContactForceEvent = contactForceEventsActive || activeEvents.contactForce;
            if (hasCollisionEvent && hasContactForceEvent) collider.setActiveEvents((0, $2LLMu.ActiveEvents).COLLISION_EVENTS | (0, $2LLMu.ActiveEvents).CONTACT_FORCE_EVENTS);
            else if (hasCollisionEvent) collider.setActiveEvents((0, $2LLMu.ActiveEvents).COLLISION_EVENTS);
            else if (hasContactForceEvent) collider.setActiveEvents((0, $2LLMu.ActiveEvents).CONTACT_FORCE_EVENTS);
            events.set(collider.handle, {
                onCollisionEnter: onCollisionEnter,
                onCollisionExit: onCollisionExit,
                onIntersectionEnter: onIntersectionEnter,
                onIntersectionExit: onIntersectionExit,
                onContactForce: onContactForce
            });
        }
        return ()=>{
            if (collider) events.delete(collider.handle);
        };
    }, [
        onCollisionEnter,
        onCollisionExit,
        onIntersectionEnter,
        onIntersectionExit,
        onContactForce,
        activeEvents
    ]);
};
const $4708f0499e113eb5$var$cleanRigidBodyPropsForCollider = (props = {})=>{
    const rest = $4708f0499e113eb5$var$_objectWithoutProperties(props, $4708f0499e113eb5$var$_excluded$2);
    return rest;
};
const $4708f0499e113eb5$var$useMutableCallback = (fn)=>{
    const ref = (0, $acw62.useRef)(fn);
    (0, $acw62.useEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return ref;
}; // External hooks
/**
 * Exposes the Rapier context, and world
 * @category Hooks
 */ const $4708f0499e113eb5$export$8dc89b465b2c50d = ()=>{
    const rapier = (0, $acw62.useContext)($4708f0499e113eb5$var$rapierContext);
    if (!rapier) throw new Error("react-three-rapier: useRapier must be used within <Physics />!");
    return rapier;
};
/**
 * Registers a callback to be called before the physics step
 * @category Hooks
 */ const $4708f0499e113eb5$export$71d8a22eb566a518 = (callback)=>{
    const { beforeStepCallbacks: beforeStepCallbacks } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const ref = $4708f0499e113eb5$var$useMutableCallback(callback);
    (0, $acw62.useEffect)(()=>{
        beforeStepCallbacks.add(ref);
        return ()=>{
            beforeStepCallbacks.delete(ref);
        };
    }, []);
};
/**
 * Registers a callback to be called after the physics step
 * @category Hooks
 */ const $4708f0499e113eb5$export$80bbb447550971ab = (callback)=>{
    const { afterStepCallbacks: afterStepCallbacks } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const ref = $4708f0499e113eb5$var$useMutableCallback(callback);
    (0, $acw62.useEffect)(()=>{
        afterStepCallbacks.add(ref);
        return ()=>{
            afterStepCallbacks.delete(ref);
        };
    }, []);
}; // Internal hooks
/**
 * @internal
 */ const $4708f0499e113eb5$var$useChildColliderProps = (ref, options, ignoreMeshColliders = true)=>{
    const [colliderProps, setColliderProps] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const object = ref.current;
        if (object && options.colliders !== false) setColliderProps($4708f0499e113eb5$var$createColliderPropsFromChildren({
            object: ref.current,
            options: options,
            ignoreMeshColliders: ignoreMeshColliders
        }));
    }, [
        options.colliders
    ]);
    return colliderProps;
};
const $4708f0499e113eb5$var$Debug = /*#__PURE__*/ (0, $acw62.memo)(()=>{
    const { world: world } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const ref = (0, $acw62.useRef)(null);
    (0, $2ec6beadbaf9c031$export$e7094788287c5e9b)(()=>{
        const mesh = ref.current;
        if (!mesh) return;
        const buffers = world.debugRender();
        mesh.geometry.setAttribute("position", new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffers.vertices, 3));
        mesh.geometry.setAttribute("color", new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(buffers.colors, 4));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("group", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("lineSegments", {
        ref: ref,
        frustumCulled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("lineBasicMaterial", {
        color: 0xffffff,
        vertexColors: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("bufferGeometry", null)));
});
/**
 * Creates a proxy that will create a singleton instance of the given class
 * when a property is accessed, and not before.
 *
 * @returns A proxy and a reset function, so that the instance can created again
 */ const $4708f0499e113eb5$var$createSingletonProxy = (createInstance)=>{
    let instance;
    const handler = {
        get (target, prop) {
            if (!instance) instance = createInstance();
            return Reflect.get(instance, prop);
        },
        set (target, prop, value) {
            if (!instance) instance = createInstance();
            return Reflect.set(instance, prop, value);
        }
    };
    const proxy = new Proxy({}, handler);
    const reset = ()=>{
        instance = undefined;
    };
    const set = (newInstance)=>{
        instance = newInstance;
    };
    /**
   * Return the proxy and a reset function
   */ return {
        proxy: proxy,
        reset: reset,
        set: set
    };
};
const $4708f0499e113eb5$var$rapierContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $4708f0499e113eb5$var$getCollisionPayloadFromSource = (target, other)=>{
    var _target$collider$stat, _target$rigidBody$sta, _other$collider$state, _other$rigidBody$stat, _other$collider$state2, _other$rigidBody$stat2;
    return {
        target: {
            rigidBody: target.rigidBody.object,
            collider: target.collider.object,
            colliderObject: (_target$collider$stat = target.collider.state) === null || _target$collider$stat === void 0 ? void 0 : _target$collider$stat.object,
            rigidBodyObject: (_target$rigidBody$sta = target.rigidBody.state) === null || _target$rigidBody$sta === void 0 ? void 0 : _target$rigidBody$sta.object
        },
        other: {
            rigidBody: other.rigidBody.object,
            collider: other.collider.object,
            colliderObject: (_other$collider$state = other.collider.state) === null || _other$collider$state === void 0 ? void 0 : _other$collider$state.object,
            rigidBodyObject: (_other$rigidBody$stat = other.rigidBody.state) === null || _other$rigidBody$stat === void 0 ? void 0 : _other$rigidBody$stat.object
        },
        rigidBody: other.rigidBody.object,
        collider: other.collider.object,
        colliderObject: (_other$collider$state2 = other.collider.state) === null || _other$collider$state2 === void 0 ? void 0 : _other$collider$state2.object,
        rigidBodyObject: (_other$rigidBody$stat2 = other.rigidBody.state) === null || _other$rigidBody$stat2 === void 0 ? void 0 : _other$rigidBody$stat2.object
    };
};

const $4708f0499e113eb5$var$importRapier = async ()=>{
    let r = await Promise.resolve((parcelRequire("2LLMu")));
    await r.init();
    return r;
};
/**
 * The main physics component used to create a physics world.
 * @category Components
 */ const $4708f0499e113eb5$export$2f09efa5b67124a7 = (props)=>{
    const { colliders: colliders = "cuboid", children: children, timeStep: timeStep = 1 / 60, paused: paused = false, interpolate: interpolate = true, updatePriority: updatePriority, updateLoop: updateLoop = "follow", debug: debug = false, gravity: gravity = [
        0,
        -9.81,
        0
    ], allowedLinearError: allowedLinearError = 0.001, predictionDistance: predictionDistance = 0.002, numSolverIterations: numSolverIterations = 4, numAdditionalFrictionIterations: numAdditionalFrictionIterations = 4, numInternalPgsIterations: numInternalPgsIterations = 1, minIslandSize: minIslandSize = 128, maxCcdSubsteps: maxCcdSubsteps = 1, erp: erp = 0.8, lengthUnit: lengthUnit = 1 } = props;
    const rapier = (0, $f681624d9766226e$export$a1428c8f7ba796e8)($4708f0499e113eb5$var$importRapier, [
        "@react-thee/rapier",
        $4708f0499e113eb5$var$importRapier
    ]);
    const { invalidate: invalidate } = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)();
    const rigidBodyStates = $4708f0499e113eb5$var$useConst(()=>new Map());
    const colliderStates = $4708f0499e113eb5$var$useConst(()=>new Map());
    const rigidBodyEvents = $4708f0499e113eb5$var$useConst(()=>new Map());
    const colliderEvents = $4708f0499e113eb5$var$useConst(()=>new Map());
    const eventQueue = $4708f0499e113eb5$var$useConst(()=>new (0, $2LLMu.EventQueue)(false));
    const beforeStepCallbacks = $4708f0499e113eb5$var$useConst(()=>new Set());
    const afterStepCallbacks = $4708f0499e113eb5$var$useConst(()=>new Set());
    /**
   * Initiate the world
   * This creates a singleton proxy, so that the world is only created when
   * something within it is accessed.
   */ const { proxy: worldProxy, reset: resetWorldProxy, set: setWorldProxy } = $4708f0499e113eb5$var$useConst(()=>$4708f0499e113eb5$var$createSingletonProxy(()=>new rapier.World($4708f0499e113eb5$var$vectorArrayToVector3(gravity))));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            worldProxy.free();
            resetWorldProxy();
        };
    }, []); // Update mutable props
    (0, $acw62.useEffect)(()=>{
        worldProxy.gravity = $4708f0499e113eb5$var$vector3ToRapierVector(gravity);
        worldProxy.integrationParameters.numSolverIterations = numSolverIterations;
        worldProxy.integrationParameters.numAdditionalFrictionIterations = numAdditionalFrictionIterations;
        worldProxy.integrationParameters.numInternalPgsIterations = numInternalPgsIterations;
        worldProxy.integrationParameters.normalizedAllowedLinearError = allowedLinearError;
        worldProxy.integrationParameters.minIslandSize = minIslandSize;
        worldProxy.integrationParameters.maxCcdSubsteps = maxCcdSubsteps;
        worldProxy.integrationParameters.normalizedPredictionDistance = predictionDistance;
        worldProxy.integrationParameters.erp = erp;
        worldProxy.lengthUnit = lengthUnit;
    }, [
        worldProxy,
        ...gravity,
        numSolverIterations,
        numAdditionalFrictionIterations,
        numInternalPgsIterations,
        allowedLinearError,
        minIslandSize,
        maxCcdSubsteps,
        predictionDistance,
        erp,
        lengthUnit
    ]);
    const getSourceFromColliderHandle = (0, $acw62.useCallback)((handle)=>{
        var _collider$parent;
        const collider = worldProxy.getCollider(handle);
        const colEvents = colliderEvents.get(handle);
        const colliderState = colliderStates.get(handle);
        const rigidBodyHandle = collider === null || collider === void 0 ? void 0 : (_collider$parent = collider.parent()) === null || _collider$parent === void 0 ? void 0 : _collider$parent.handle;
        const rigidBody = rigidBodyHandle !== undefined ? worldProxy.getRigidBody(rigidBodyHandle) : undefined;
        const rbEvents = rigidBody && rigidBodyHandle !== undefined ? rigidBodyEvents.get(rigidBodyHandle) : undefined;
        const rigidBodyState = rigidBodyHandle !== undefined ? rigidBodyStates.get(rigidBodyHandle) : undefined;
        const source = {
            collider: {
                object: collider,
                events: colEvents,
                state: colliderState
            },
            rigidBody: {
                object: rigidBody,
                events: rbEvents,
                state: rigidBodyState
            }
        };
        return source;
    }, []);
    const [steppingState] = (0, $acw62.useState)({
        previousState: {},
        accumulator: 0
    });
    const step = (0, $acw62.useCallback)((dt)=>{
        const world = worldProxy;
        /* Check if the timestep is supposed to be variable. We'll do this here
      once so we don't have to string-check every frame. */ const timeStepVariable = timeStep === "vary";
        /**
     * Fixed timeStep simulation progression
     * @see https://gafferongames.com/post/fix_your_timestep/
     */ const clampedDelta = (0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).clamp(dt, 0, 0.5);
        const stepWorld = (delta)=>{
            // Trigger beforeStep callbacks
            beforeStepCallbacks.forEach((callback)=>{
                callback.current(world);
            });
            world.timestep = delta;
            world.step(eventQueue); // Trigger afterStep callbacks
            afterStepCallbacks.forEach((callback)=>{
                callback.current(world);
            });
        };
        if (timeStepVariable) stepWorld(clampedDelta);
        else {
            // don't step time forwards if paused
            // Increase accumulator
            steppingState.accumulator += clampedDelta;
            while(steppingState.accumulator >= timeStep){
                // Set up previous state
                // needed for accurate interpolations if the world steps more than once
                if (interpolate) {
                    steppingState.previousState = {};
                    world.forEachRigidBody((body)=>{
                        steppingState.previousState[body.handle] = {
                            position: body.translation(),
                            rotation: body.rotation()
                        };
                    });
                }
                stepWorld(timeStep);
                steppingState.accumulator -= timeStep;
            }
        }
        const interpolationAlpha = timeStepVariable || !interpolate || paused ? 1 : steppingState.accumulator / timeStep; // Update meshes
        rigidBodyStates.forEach((state, handle)=>{
            const rigidBody = world.getRigidBody(handle);
            const events = rigidBodyEvents.get(handle);
            if (events !== null && events !== void 0 && events.onSleep || events !== null && events !== void 0 && events.onWake) {
                if (rigidBody.isSleeping() && !state.isSleeping) {
                    var _events$onSleep;
                    events === null || events === void 0 || (_events$onSleep = events.onSleep) === null || _events$onSleep === void 0 || _events$onSleep.call(events);
                }
                if (!rigidBody.isSleeping() && state.isSleeping) {
                    var _events$onWake;
                    events === null || events === void 0 || (_events$onWake = events.onWake) === null || _events$onWake === void 0 || _events$onWake.call(events);
                }
                state.isSleeping = rigidBody.isSleeping();
            }
            if (!rigidBody || rigidBody.isSleeping() && !("isInstancedMesh" in state.object) || !state.setMatrix) return;
             // New states
            let t = rigidBody.translation();
            let r = rigidBody.rotation();
            let previousState = steppingState.previousState[handle];
            if (previousState) {
                // Get previous simulated world position
                $4708f0499e113eb5$var$_matrix4.compose(previousState.position, $4708f0499e113eb5$var$rapierQuaternionToQuaternion(previousState.rotation), state.scale).premultiply(state.invertedWorldMatrix).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale); // Apply previous tick position
                if (state.meshType == "mesh") {
                    state.object.position.copy($4708f0499e113eb5$var$_position);
                    state.object.quaternion.copy($4708f0499e113eb5$var$_rotation);
                }
            } // Get new position
            $4708f0499e113eb5$var$_matrix4.compose(t, $4708f0499e113eb5$var$rapierQuaternionToQuaternion(r), state.scale).premultiply(state.invertedWorldMatrix).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
            if (state.meshType == "instancedMesh") state.setMatrix($4708f0499e113eb5$var$_matrix4);
            else {
                // Interpolate to new position
                state.object.position.lerp($4708f0499e113eb5$var$_position, interpolationAlpha);
                state.object.quaternion.slerp($4708f0499e113eb5$var$_rotation, interpolationAlpha);
            }
        });
        eventQueue.drainCollisionEvents((handle1, handle2, started)=>{
            const source1 = getSourceFromColliderHandle(handle1);
            const source2 = getSourceFromColliderHandle(handle2); // Collision Events
            if (!(source1 !== null && source1 !== void 0 && source1.collider.object) || !(source2 !== null && source2 !== void 0 && source2.collider.object)) return;
            const collisionPayload1 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source1, source2);
            const collisionPayload2 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source2, source1);
            if (started) world.contactPair(source1.collider.object, source2.collider.object, (manifold, flipped)=>{
                var _source1$rigidBody$ev, _source1$rigidBody$ev2, _source2$rigidBody$ev, _source2$rigidBody$ev2, _source1$collider$eve, _source1$collider$eve2, _source2$collider$eve, _source2$collider$eve2;
                /* RigidBody events */ (_source1$rigidBody$ev = source1.rigidBody.events) === null || _source1$rigidBody$ev === void 0 || (_source1$rigidBody$ev2 = _source1$rigidBody$ev.onCollisionEnter) === null || _source1$rigidBody$ev2 === void 0 || _source1$rigidBody$ev2.call(_source1$rigidBody$ev, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
                (_source2$rigidBody$ev = source2.rigidBody.events) === null || _source2$rigidBody$ev === void 0 || (_source2$rigidBody$ev2 = _source2$rigidBody$ev.onCollisionEnter) === null || _source2$rigidBody$ev2 === void 0 || _source2$rigidBody$ev2.call(_source2$rigidBody$ev, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
                /* Collider events */ (_source1$collider$eve = source1.collider.events) === null || _source1$collider$eve === void 0 || (_source1$collider$eve2 = _source1$collider$eve.onCollisionEnter) === null || _source1$collider$eve2 === void 0 || _source1$collider$eve2.call(_source1$collider$eve, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
                (_source2$collider$eve = source2.collider.events) === null || _source2$collider$eve === void 0 || (_source2$collider$eve2 = _source2$collider$eve.onCollisionEnter) === null || _source2$collider$eve2 === void 0 || _source2$collider$eve2.call(_source2$collider$eve, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                    manifold: manifold,
                    flipped: flipped
                }));
            });
            else {
                var _source1$rigidBody$ev3, _source1$rigidBody$ev4, _source2$rigidBody$ev3, _source2$rigidBody$ev4, _source1$collider$eve3, _source1$collider$eve4, _source2$collider$eve3, _source2$collider$eve4;
                (_source1$rigidBody$ev3 = source1.rigidBody.events) === null || _source1$rigidBody$ev3 === void 0 || (_source1$rigidBody$ev4 = _source1$rigidBody$ev3.onCollisionExit) === null || _source1$rigidBody$ev4 === void 0 || _source1$rigidBody$ev4.call(_source1$rigidBody$ev3, collisionPayload1);
                (_source2$rigidBody$ev3 = source2.rigidBody.events) === null || _source2$rigidBody$ev3 === void 0 || (_source2$rigidBody$ev4 = _source2$rigidBody$ev3.onCollisionExit) === null || _source2$rigidBody$ev4 === void 0 || _source2$rigidBody$ev4.call(_source2$rigidBody$ev3, collisionPayload2);
                (_source1$collider$eve3 = source1.collider.events) === null || _source1$collider$eve3 === void 0 || (_source1$collider$eve4 = _source1$collider$eve3.onCollisionExit) === null || _source1$collider$eve4 === void 0 || _source1$collider$eve4.call(_source1$collider$eve3, collisionPayload1);
                (_source2$collider$eve3 = source2.collider.events) === null || _source2$collider$eve3 === void 0 || (_source2$collider$eve4 = _source2$collider$eve3.onCollisionExit) === null || _source2$collider$eve4 === void 0 || _source2$collider$eve4.call(_source2$collider$eve3, collisionPayload2);
            } // Sensor Intersections
            if (started) {
                if (world.intersectionPair(source1.collider.object, source2.collider.object)) {
                    var _source1$rigidBody$ev5, _source1$rigidBody$ev6, _source2$rigidBody$ev5, _source2$rigidBody$ev6, _source1$collider$eve5, _source1$collider$eve6, _source2$collider$eve5, _source2$collider$eve6;
                    (_source1$rigidBody$ev5 = source1.rigidBody.events) === null || _source1$rigidBody$ev5 === void 0 || (_source1$rigidBody$ev6 = _source1$rigidBody$ev5.onIntersectionEnter) === null || _source1$rigidBody$ev6 === void 0 || _source1$rigidBody$ev6.call(_source1$rigidBody$ev5, collisionPayload1);
                    (_source2$rigidBody$ev5 = source2.rigidBody.events) === null || _source2$rigidBody$ev5 === void 0 || (_source2$rigidBody$ev6 = _source2$rigidBody$ev5.onIntersectionEnter) === null || _source2$rigidBody$ev6 === void 0 || _source2$rigidBody$ev6.call(_source2$rigidBody$ev5, collisionPayload2);
                    (_source1$collider$eve5 = source1.collider.events) === null || _source1$collider$eve5 === void 0 || (_source1$collider$eve6 = _source1$collider$eve5.onIntersectionEnter) === null || _source1$collider$eve6 === void 0 || _source1$collider$eve6.call(_source1$collider$eve5, collisionPayload1);
                    (_source2$collider$eve5 = source2.collider.events) === null || _source2$collider$eve5 === void 0 || (_source2$collider$eve6 = _source2$collider$eve5.onIntersectionEnter) === null || _source2$collider$eve6 === void 0 || _source2$collider$eve6.call(_source2$collider$eve5, collisionPayload2);
                }
            } else {
                var _source1$rigidBody$ev7, _source1$rigidBody$ev8, _source2$rigidBody$ev7, _source2$rigidBody$ev8, _source1$collider$eve7, _source1$collider$eve8, _source2$collider$eve7, _source2$collider$eve8;
                (_source1$rigidBody$ev7 = source1.rigidBody.events) === null || _source1$rigidBody$ev7 === void 0 || (_source1$rigidBody$ev8 = _source1$rigidBody$ev7.onIntersectionExit) === null || _source1$rigidBody$ev8 === void 0 || _source1$rigidBody$ev8.call(_source1$rigidBody$ev7, collisionPayload1);
                (_source2$rigidBody$ev7 = source2.rigidBody.events) === null || _source2$rigidBody$ev7 === void 0 || (_source2$rigidBody$ev8 = _source2$rigidBody$ev7.onIntersectionExit) === null || _source2$rigidBody$ev8 === void 0 || _source2$rigidBody$ev8.call(_source2$rigidBody$ev7, collisionPayload2);
                (_source1$collider$eve7 = source1.collider.events) === null || _source1$collider$eve7 === void 0 || (_source1$collider$eve8 = _source1$collider$eve7.onIntersectionExit) === null || _source1$collider$eve8 === void 0 || _source1$collider$eve8.call(_source1$collider$eve7, collisionPayload1);
                (_source2$collider$eve7 = source2.collider.events) === null || _source2$collider$eve7 === void 0 || (_source2$collider$eve8 = _source2$collider$eve7.onIntersectionExit) === null || _source2$collider$eve8 === void 0 || _source2$collider$eve8.call(_source2$collider$eve7, collisionPayload2);
            }
        });
        eventQueue.drainContactForceEvents((event)=>{
            var _source1$rigidBody$ev9, _source1$rigidBody$ev10, _source2$rigidBody$ev9, _source2$rigidBody$ev10, _source1$collider$eve9, _source1$collider$eve10, _source2$collider$eve9, _source2$collider$eve10;
            const source1 = getSourceFromColliderHandle(event.collider1());
            const source2 = getSourceFromColliderHandle(event.collider2()); // Collision Events
            if (!(source1 !== null && source1 !== void 0 && source1.collider.object) || !(source2 !== null && source2 !== void 0 && source2.collider.object)) return;
            const collisionPayload1 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source1, source2);
            const collisionPayload2 = $4708f0499e113eb5$var$getCollisionPayloadFromSource(source2, source1);
            (_source1$rigidBody$ev9 = source1.rigidBody.events) === null || _source1$rigidBody$ev9 === void 0 || (_source1$rigidBody$ev10 = _source1$rigidBody$ev9.onContactForce) === null || _source1$rigidBody$ev10 === void 0 || _source1$rigidBody$ev10.call(_source1$rigidBody$ev9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
            (_source2$rigidBody$ev9 = source2.rigidBody.events) === null || _source2$rigidBody$ev9 === void 0 || (_source2$rigidBody$ev10 = _source2$rigidBody$ev9.onContactForce) === null || _source2$rigidBody$ev10 === void 0 || _source2$rigidBody$ev10.call(_source2$rigidBody$ev9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
            (_source1$collider$eve9 = source1.collider.events) === null || _source1$collider$eve9 === void 0 || (_source1$collider$eve10 = _source1$collider$eve9.onContactForce) === null || _source1$collider$eve10 === void 0 || _source1$collider$eve10.call(_source1$collider$eve9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload1), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
            (_source2$collider$eve9 = source2.collider.events) === null || _source2$collider$eve9 === void 0 || (_source2$collider$eve10 = _source2$collider$eve9.onContactForce) === null || _source2$collider$eve10 === void 0 || _source2$collider$eve10.call(_source2$collider$eve9, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, collisionPayload2), {}, {
                totalForce: event.totalForce(),
                totalForceMagnitude: event.totalForceMagnitude(),
                maxForceDirection: event.maxForceDirection(),
                maxForceMagnitude: event.maxForceMagnitude()
            }));
        });
        world.forEachActiveRigidBody(()=>{
            invalidate();
        });
    }, [
        paused,
        timeStep,
        interpolate,
        worldProxy
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            rapier: rapier,
            world: worldProxy,
            setWorld: (world)=>{
                setWorldProxy(world);
            },
            physicsOptions: {
                colliders: colliders,
                gravity: gravity
            },
            rigidBodyStates: rigidBodyStates,
            colliderStates: colliderStates,
            rigidBodyEvents: rigidBodyEvents,
            colliderEvents: colliderEvents,
            beforeStepCallbacks: beforeStepCallbacks,
            afterStepCallbacks: afterStepCallbacks,
            isPaused: paused,
            isDebug: debug,
            step: step
        }), [
        paused,
        step,
        debug,
        colliders,
        gravity
    ]);
    const stepCallback = (0, $acw62.useCallback)((delta)=>{
        if (!paused) step(delta);
    }, [
        paused,
        step
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$rapierContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$FrameStepper$1, {
        onStep: stepCallback,
        type: updateLoop,
        updatePriority: updatePriority
    }), debug && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$Debug, null), children);
};
function $4708f0499e113eb5$var$_extends() {
    $4708f0499e113eb5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4708f0499e113eb5$var$_extends.apply(this, arguments);
}
/**
 * Initiate an instance and return a safe getter
 */ const $4708f0499e113eb5$var$useImperativeInstance = (createFn, destroyFn, dependencyList)=>{
    const ref = (0, $acw62.useRef)();
    const getInstance = (0, $acw62.useCallback)(()=>{
        if (!ref.current) ref.current = createFn();
        return ref.current;
    }, dependencyList);
    (0, $acw62.useEffect)(()=>{
        // Save the destroy function and instance
        const instance = getInstance();
        const destroy = ()=>destroyFn(instance);
        return ()=>{
            destroy();
            ref.current = undefined;
        };
    }, [
        getInstance
    ]);
    return getInstance;
};
/**
 * Takes an object resembling a Vector3 and returs a Three.Vector3
 * @category Math helpers
 */ const $4708f0499e113eb5$export$9100789c9d999364 = ({ x: x, y: y, z: z } = {
    x: 0,
    y: 0,
    z: 0
})=>{
    return new (0, $d5b33d7c30034067$export$64b5c384219d3699)(x, y, z);
};
/**
 * Takes an object resembling a Quaternion and returs a Three.Quaternion
 * @category Math helpers
 */ const $4708f0499e113eb5$export$331177b0f99cd06 = ({ x: x, y: y, z: z, w: w } = {
    x: 0,
    y: 0,
    z: 0,
    w: 1
})=>{
    return new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)(x, y, z, w);
};
/**
 * Takes an object resembling an Euler and returs a Three.Euler
 * @category Math helpers
 */ const $4708f0499e113eb5$export$dc799133ea41435b = ({ x: x, y: y, z: z } = {
    x: 0,
    y: 0,
    z: 0
})=>{
    return new (0, $d5b33d7c30034067$export$d93cc409a0768c5f)(x, y, z);
};
const $4708f0499e113eb5$var$useForwardedRef = (forwardedRef, defaultValue = null)=>{
    const innerRef = (0, $acw62.useRef)(defaultValue); // Update the forwarded ref when the inner ref changes
    if (forwardedRef && typeof forwardedRef !== "function") {
        if (!forwardedRef.current) forwardedRef.current = innerRef.current;
        return forwardedRef;
    }
    return innerRef;
};
/**
 * A collider is a shape that can be attached to a rigid body to define its physical properties.
 * @internal
 */ const $4708f0499e113eb5$export$b624c47b0e3f44d = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, position: position, rotation: rotation, quaternion: quaternion, scale: scale, name: name } = props;
    const { world: world, colliderEvents: colliderEvents, colliderStates: colliderStates } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const rigidBodyContext = $4708f0499e113eb5$var$useRigidBodyContext();
    const colliderRef = $4708f0499e113eb5$var$useForwardedRef(forwardedRef);
    const objectRef = (0, $acw62.useRef)(null); // We spread the props out here to make sure that the ref is updated when the props change.
    const immutablePropArray = $4708f0499e113eb5$var$immutableColliderOptions.flatMap((key)=>Array.isArray(props[key]) ? [
            ...props[key]
        ] : props[key]);
    const getInstance = $4708f0499e113eb5$var$useImperativeInstance(()=>{
        const worldScale = objectRef.current.getWorldScale($4708f0499e113eb5$export$9100789c9d999364());
        const collider = $4708f0499e113eb5$var$createColliderFromOptions(props, world, worldScale, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.getRigidBody);
        if (typeof forwardedRef == "function") forwardedRef(collider);
        colliderRef.current = collider;
        return collider;
    }, (collider)=>{
        if (world.getCollider(collider.handle)) world.removeCollider(collider, true);
    }, [
        ...immutablePropArray,
        rigidBodyContext
    ]);
    (0, $acw62.useEffect)(()=>{
        const collider = getInstance();
        colliderStates.set(collider.handle, $4708f0499e113eb5$var$createColliderState(collider, objectRef.current, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.ref.current));
        return ()=>{
            colliderStates.delete(collider.handle);
        };
    }, [
        getInstance
    ]);
    const mergedProps = (0, $acw62.useMemo)(()=>{
        return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, $4708f0499e113eb5$var$cleanRigidBodyPropsForCollider(rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options)), props);
    }, [
        props,
        rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options
    ]);
    $4708f0499e113eb5$var$useUpdateColliderOptions(getInstance, mergedProps, colliderStates);
    $4708f0499e113eb5$var$useColliderEvents(getInstance, mergedProps, colliderEvents, $4708f0499e113eb5$var$getActiveCollisionEventsFromProps(rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", {
        position: position,
        rotation: rotation,
        quaternion: quaternion,
        scale: scale,
        ref: objectRef,
        name: name
    }, children);
}));
/**
 * A cuboid collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$4f9cc99de105c9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "cuboid",
        ref: ref
    }));
});
$4708f0499e113eb5$export$4f9cc99de105c9e.displayName = "CuboidCollider";
/**
 * A round cuboid collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$a2d07aed607bbf03 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "roundCuboid",
        ref: ref
    })));
$4708f0499e113eb5$export$a2d07aed607bbf03.displayName = "RoundCuboidCollider";
/**
 * A ball collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$4e29496cd9696853 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "ball",
        ref: ref
    })));
$4708f0499e113eb5$export$4e29496cd9696853.displayName = "BallCollider";
/**
 * A capsule collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$768a57ebe80015a2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "capsule",
        ref: ref
    })));
$4708f0499e113eb5$export$768a57ebe80015a2.displayName = "CapsuleCollider";
/**
 * A heightfield collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$8071a0186d9c89e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "heightfield",
        ref: ref
    })));
$4708f0499e113eb5$export$8071a0186d9c89e3.displayName = "HeightfieldCollider";
/**
 * A trimesh collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$411e457e9040e043 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "trimesh",
        ref: ref
    })));
$4708f0499e113eb5$export$411e457e9040e043.displayName = "TrimeshCollider";
/**
 * A cone collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$8ab1d7c353d2df8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "cone",
        ref: ref
    })));
$4708f0499e113eb5$export$8ab1d7c353d2df8b.displayName = "ConeCollider";
/**
 * A round cylinder collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$3ade71538cb07b90 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "roundCone",
        ref: ref
    })));
$4708f0499e113eb5$export$3ade71538cb07b90.displayName = "RoundConeCollider";
/**
 * A cylinder collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$d931dcfd959cbf5e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "cylinder",
        ref: ref
    })));
$4708f0499e113eb5$export$d931dcfd959cbf5e.displayName = "CylinderCollider";
/**
 * A round cylinder collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$5654157303bb0b18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "roundCylinder",
        ref: ref
    })));
$4708f0499e113eb5$export$d931dcfd959cbf5e.displayName = "RoundCylinderCollider";
/**
 * A convex hull collider shape
 * @category Colliders
 */ const $4708f0499e113eb5$export$7244a38c3d9c72f9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({}, props, {
        shape: "convexHull",
        ref: ref
    })));
$4708f0499e113eb5$export$7244a38c3d9c72f9.displayName = "ConvexHullCollider";
const $4708f0499e113eb5$var$rigidBodyDescFromOptions = (options)=>{
    var _options$canSleep;
    const type = $4708f0499e113eb5$var$rigidBodyTypeFromString((options === null || options === void 0 ? void 0 : options.type) || "dynamic");
    const desc = new (0, $2LLMu.RigidBodyDesc)(type); // Apply immutable options
    desc.canSleep = (_options$canSleep = options === null || options === void 0 ? void 0 : options.canSleep) !== null && _options$canSleep !== void 0 ? _options$canSleep : true;
    return desc;
};
const $4708f0499e113eb5$var$createRigidBodyState = ({ rigidBody: rigidBody, object: object, setMatrix: setMatrix, getMatrix: getMatrix, worldScale: worldScale, meshType: _meshType = "mesh" })=>{
    object.updateWorldMatrix(true, false);
    const invertedWorldMatrix = object.parent.matrixWorld.clone().invert();
    return {
        object: object,
        rigidBody: rigidBody,
        invertedWorldMatrix: invertedWorldMatrix,
        setMatrix: setMatrix ? setMatrix : (matrix)=>{
            object.matrix.copy(matrix);
        },
        getMatrix: getMatrix ? getMatrix : (matrix)=>matrix.copy(object.matrix),
        scale: worldScale || object.getWorldScale($4708f0499e113eb5$var$_scale).clone(),
        isSleeping: false,
        meshType: _meshType
    };
};
const $4708f0499e113eb5$var$immutableRigidBodyOptions = [
    "args",
    "colliders",
    "canSleep"
];
const $4708f0499e113eb5$var$mutableRigidBodyOptions = {
    gravityScale: (rb, value)=>{
        rb.setGravityScale(value, true);
    },
    additionalSolverIterations (rb, value) {
        rb.setAdditionalSolverIterations(value);
    },
    linearDamping: (rb, value)=>{
        rb.setLinearDamping(value);
    },
    angularDamping: (rb, value)=>{
        rb.setAngularDamping(value);
    },
    dominanceGroup: (rb, value)=>{
        rb.setDominanceGroup(value);
    },
    enabledRotations: (rb, [x, y, z])=>{
        rb.setEnabledRotations(x, y, z, true);
    },
    enabledTranslations: (rb, [x, y, z])=>{
        rb.setEnabledTranslations(x, y, z, true);
    },
    lockRotations: (rb, value)=>{
        rb.lockRotations(value, true);
    },
    lockTranslations: (rb, value)=>{
        rb.lockTranslations(value, true);
    },
    angularVelocity: (rb, [x, y, z])=>{
        rb.setAngvel({
            x: x,
            y: y,
            z: z
        }, true);
    },
    linearVelocity: (rb, [x, y, z])=>{
        rb.setLinvel({
            x: x,
            y: y,
            z: z
        }, true);
    },
    ccd: (rb, value)=>{
        rb.enableCcd(value);
    },
    softCcdPrediction: (rb, value)=>{
        rb.setSoftCcdPrediction(value);
    },
    userData: (rb, value)=>{
        rb.userData = value;
    },
    type (rb, value) {
        rb.setBodyType($4708f0499e113eb5$var$rigidBodyTypeFromString(value), true);
    },
    position: ()=>{},
    rotation: ()=>{},
    quaternion: ()=>{},
    scale: ()=>{}
};
const $4708f0499e113eb5$var$mutableRigidBodyOptionKeys = Object.keys($4708f0499e113eb5$var$mutableRigidBodyOptions);
const $4708f0499e113eb5$var$setRigidBodyOptions = (rigidBody, options, states, updateTranslations = true)=>{
    if (!rigidBody) return;
    const state = states.get(rigidBody.handle);
    if (state) {
        if (updateTranslations) {
            state.object.updateWorldMatrix(true, false);
            $4708f0499e113eb5$var$_matrix4.copy(state.object.matrixWorld).decompose($4708f0499e113eb5$var$_position, $4708f0499e113eb5$var$_rotation, $4708f0499e113eb5$var$_scale);
            rigidBody.setTranslation($4708f0499e113eb5$var$_position, false);
            rigidBody.setRotation($4708f0499e113eb5$var$_rotation, false);
        }
        $4708f0499e113eb5$var$mutableRigidBodyOptionKeys.forEach((key)=>{
            if (key in options) $4708f0499e113eb5$var$mutableRigidBodyOptions[key](rigidBody, options[key]);
        });
    }
};
const $4708f0499e113eb5$var$useUpdateRigidBodyOptions = (getRigidBody, props, states, updateTranslations = true)=>{
    // TODO: Improve this, split each prop into its own effect
    const mutablePropsAsFlatArray = (0, $acw62.useMemo)(()=>$4708f0499e113eb5$var$mutableRigidBodyOptionKeys.flatMap((key)=>{
            return $4708f0499e113eb5$var$vectorToTuple(props[key]);
        }), [
        props
    ]);
    (0, $acw62.useEffect)(()=>{
        const rigidBody = getRigidBody();
        $4708f0499e113eb5$var$setRigidBodyOptions(rigidBody, props, states, updateTranslations);
    }, mutablePropsAsFlatArray);
};
const $4708f0499e113eb5$var$useRigidBodyEvents = (getRigidBody, props, events)=>{
    const { onWake: onWake, onSleep: onSleep, onCollisionEnter: onCollisionEnter, onCollisionExit: onCollisionExit, onIntersectionEnter: onIntersectionEnter, onIntersectionExit: onIntersectionExit, onContactForce: onContactForce } = props;
    const eventHandlers = {
        onWake: onWake,
        onSleep: onSleep,
        onCollisionEnter: onCollisionEnter,
        onCollisionExit: onCollisionExit,
        onIntersectionEnter: onIntersectionEnter,
        onIntersectionExit: onIntersectionExit,
        onContactForce: onContactForce
    };
    (0, $acw62.useEffect)(()=>{
        const rigidBody = getRigidBody();
        events.set(rigidBody.handle, eventHandlers);
        return ()=>{
            events.delete(rigidBody.handle);
        };
    }, [
        onWake,
        onSleep,
        onCollisionEnter,
        onCollisionExit,
        onIntersectionEnter,
        onIntersectionExit,
        onContactForce
    ]);
};
const $4708f0499e113eb5$var$_excluded$1 = [
    "children",
    "type",
    "position",
    "rotation",
    "scale",
    "quaternion",
    "transformState"
];
const $4708f0499e113eb5$var$RigidBodyContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $4708f0499e113eb5$var$useRigidBodyContext = ()=>(0, $acw62.useContext)($4708f0499e113eb5$var$RigidBodyContext);
/**
 * A rigid body is a physical object that can be simulated by the physics engine.
 * @category Components
 */ const $4708f0499e113eb5$export$41c0a739a32ac4d = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, type: type, position: position, rotation: rotation, scale: scale, quaternion: quaternion, transformState: transformState } = props, objectProps = $4708f0499e113eb5$var$_objectWithoutProperties(props, $4708f0499e113eb5$var$_excluded$1);
    const objectRef = (0, $acw62.useRef)(null);
    const rigidBodyRef = $4708f0499e113eb5$var$useForwardedRef(forwardedRef);
    const { world: world, rigidBodyStates: rigidBodyStates, physicsOptions: physicsOptions, rigidBodyEvents: rigidBodyEvents } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const mergedOptions = (0, $acw62.useMemo)(()=>{
        return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, physicsOptions), props), {}, {
            children: undefined
        });
    }, [
        physicsOptions,
        props
    ]);
    const immutablePropArray = $4708f0499e113eb5$var$immutableRigidBodyOptions.flatMap((key)=>{
        return Array.isArray(mergedOptions[key]) ? [
            ...mergedOptions[key]
        ] : mergedOptions[key];
    });
    const childColliderProps = $4708f0499e113eb5$var$useChildColliderProps(objectRef, mergedOptions); // Provide a way to eagerly create rigidbody
    const getRigidBody = $4708f0499e113eb5$var$useImperativeInstance(()=>{
        const desc = $4708f0499e113eb5$var$rigidBodyDescFromOptions(mergedOptions);
        const rigidBody = world.createRigidBody(desc);
        if (typeof forwardedRef === "function") forwardedRef(rigidBody);
        rigidBodyRef.current = rigidBody;
        return rigidBody;
    }, (rigidBody)=>{
        if (world.getRigidBody(rigidBody.handle)) world.removeRigidBody(rigidBody);
    }, immutablePropArray); // Only provide a object state after the ref has been set
    (0, $acw62.useEffect)(()=>{
        const rigidBody = getRigidBody();
        const state = $4708f0499e113eb5$var$createRigidBodyState({
            rigidBody: rigidBody,
            object: objectRef.current
        });
        rigidBodyStates.set(rigidBody.handle, props.transformState ? props.transformState(state) : state);
        return ()=>{
            rigidBodyStates.delete(rigidBody.handle);
        };
    }, [
        getRigidBody
    ]);
    $4708f0499e113eb5$var$useUpdateRigidBodyOptions(getRigidBody, mergedOptions, rigidBodyStates);
    $4708f0499e113eb5$var$useRigidBodyEvents(getRigidBody, mergedOptions, rigidBodyEvents);
    const contextValue = (0, $acw62.useMemo)(()=>{
        return {
            ref: objectRef,
            getRigidBody: getRigidBody,
            options: mergedOptions
        };
    }, [
        getRigidBody
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$var$RigidBodyContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", $4708f0499e113eb5$var$_extends({
        ref: objectRef
    }, objectProps, {
        position: position,
        rotation: rotation,
        quaternion: quaternion,
        scale: scale
    }), children, childColliderProps.map((colliderProps, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({
            key: index
        }, colliderProps)))));
}));
$4708f0499e113eb5$export$41c0a739a32ac4d.displayName = "RigidBody";
/**
 * A mesh collider is a collider that is automatically generated from the geometry of the children.
 * @category Colliders
 */ const $4708f0499e113eb5$export$a20a2583fa01000f = /*#__PURE__*/ (0, $acw62.memo)((props)=>{
    const { children: children, type: type } = props;
    const { physicsOptions: physicsOptions } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const object = (0, $acw62.useRef)(null);
    const { options: options } = $4708f0499e113eb5$var$useRigidBodyContext();
    const mergedOptions = (0, $acw62.useMemo)(()=>{
        return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, physicsOptions), options), {}, {
            children: undefined,
            colliders: type
        });
    }, [
        physicsOptions,
        options
    ]);
    const childColliderProps = $4708f0499e113eb5$var$useChildColliderProps(object, mergedOptions, false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", {
        ref: object,
        userData: {
            r3RapierType: "MeshCollider"
        }
    }, children, childColliderProps.map((colliderProps, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({
            key: index
        }, colliderProps))));
});
$4708f0499e113eb5$export$a20a2583fa01000f.displayName = "MeshCollider";
const $4708f0499e113eb5$var$_excluded = [
    "children",
    "instances",
    "colliderNodes",
    "position",
    "rotation",
    "quaternion",
    "scale"
];
const $4708f0499e113eb5$export$b24ddbe47deafd22 = /*#__PURE__*/ (0, $acw62.memo)(/*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const rigidBodiesRef = $4708f0499e113eb5$var$useForwardedRef(forwardedRef, []);
    const objectRef = (0, $acw62.useRef)(null);
    const instanceWrapperRef = (0, $acw62.useRef)(null);
    const { children: // instanced props
    children, instances: instances, colliderNodes: colliderNodes = [], position: // wrapper object props
    position, rotation: rotation, quaternion: quaternion, scale: scale } = props, rigidBodyProps = $4708f0499e113eb5$var$_objectWithoutProperties(props, $4708f0499e113eb5$var$_excluded);
    const childColliderProps = $4708f0499e113eb5$var$useChildColliderProps(objectRef, $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, props), {}, {
        children: undefined
    }));
    const getInstancedMesh = ()=>{
        const firstChild = instanceWrapperRef.current.children[0];
        if (firstChild && "isInstancedMesh" in firstChild) return firstChild;
        return undefined;
    };
    (0, $acw62.useEffect)(()=>{
        const instancedMesh = getInstancedMesh();
        if (instancedMesh) instancedMesh.instanceMatrix.setUsage((0, $d5b33d7c30034067$export$8505d14ac8546ca));
        else console.warn("InstancedRigidBodies expects exactly one child, which must be an InstancedMesh");
    }, []); // Update the RigidBodyStates whenever the instances change
    const applyInstancedState = (state, index)=>{
        const instancedMesh = getInstancedMesh();
        if (instancedMesh) return $4708f0499e113eb5$var$_objectSpread2($4708f0499e113eb5$var$_objectSpread2({}, state), {}, {
            getMatrix: (matrix)=>{
                instancedMesh.getMatrixAt(index, matrix);
                return matrix;
            },
            setMatrix: (matrix)=>{
                instancedMesh.setMatrixAt(index, matrix);
                instancedMesh.instanceMatrix.needsUpdate = true;
            },
            meshType: "instancedMesh"
        });
        return state;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", $4708f0499e113eb5$var$_extends({
        ref: objectRef
    }, rigidBodyProps, {
        position: position,
        rotation: rotation,
        quaternion: quaternion,
        scale: scale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("object3D", {
        ref: instanceWrapperRef
    }, children), instances === null || instances === void 0 ? void 0 : instances.map((instance, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$41c0a739a32ac4d, $4708f0499e113eb5$var$_extends({}, rigidBodyProps, instance, {
            ref: (body)=>rigidBodiesRef.current[index] = body,
            transformState: (state)=>applyInstancedState(state, index)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, colliderNodes.map((node, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: index
            }, node)), childColliderProps.map((colliderProps, colliderIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4708f0499e113eb5$export$b624c47b0e3f44d, $4708f0499e113eb5$var$_extends({
                key: colliderIndex
            }, colliderProps)))))));
}));
$4708f0499e113eb5$export$b24ddbe47deafd22.displayName = "InstancedRigidBodies";
/**
 * @internal
 */ const $4708f0499e113eb5$export$cbae601798080e14 = (body1, body2, params)=>{
    const { world: world } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const jointRef = (0, $acw62.useRef)();
    $4708f0499e113eb5$var$useImperativeInstance(()=>{
        if (body1.current && body2.current) {
            const newJoint = world.createImpulseJoint(params, body1.current, body2.current, true);
            jointRef.current = newJoint;
            return newJoint;
        }
    }, (joint)=>{
        if (joint) {
            jointRef.current = undefined;
            if (world.getImpulseJoint(joint.handle)) world.removeImpulseJoint(joint, true);
        }
    }, []);
    return jointRef;
};
/**
 * A fixed joint ensures that two rigid-bodies don't move relative to each other.
 * Fixed joints are characterized by one local frame (represented by an isometry) on each rigid-body.
 * The fixed-joint makes these frames coincide in world-space.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$76ae4ac5d9a23dbb = (body1, body2, [body1Anchor, body1LocalFrame, body2Anchor, body2LocalFrame])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, rapier.JointData.fixed($4708f0499e113eb5$var$vector3ToRapierVector(body1Anchor), $4708f0499e113eb5$var$quaternionToRapierQuaternion(body1LocalFrame), $4708f0499e113eb5$var$vector3ToRapierVector(body2Anchor), $4708f0499e113eb5$var$quaternionToRapierQuaternion(body2LocalFrame)));
};
/**
 * The spherical joint ensures that two points on the local-spaces of two rigid-bodies always coincide (it prevents any relative
 * translational motion at this points). This is typically used to simulate ragdolls arms, pendulums, etc.
 * They are characterized by one local anchor on each rigid-body. Each anchor represents the location of the
 * points that need to coincide on the local-space of each rigid-body.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$c0fe3fee8fd7c4a = (body1, body2, [body1Anchor, body2Anchor])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, rapier.JointData.spherical($4708f0499e113eb5$var$vector3ToRapierVector(body1Anchor), $4708f0499e113eb5$var$vector3ToRapierVector(body2Anchor)));
};
/**
 * The revolute joint prevents any relative movement between two rigid-bodies, except for relative
 * rotations along one axis. This is typically used to simulate wheels, fans, etc.
 * They are characterized by one local anchor as well as one local axis on each rigid-body.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$7c70b7c87abc4d99 = (body1, body2, [body1Anchor, body2Anchor, axis, limits])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const params = rapier.JointData.revolute($4708f0499e113eb5$var$vector3ToRapierVector(body1Anchor), $4708f0499e113eb5$var$vector3ToRapierVector(body2Anchor), $4708f0499e113eb5$var$vector3ToRapierVector(axis));
    if (limits) {
        params.limitsEnabled = true;
        params.limits = limits;
    }
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, params);
};
/**
 * The prismatic joint prevents any relative movement between two rigid-bodies, except for relative translations along one axis.
 * It is characterized by one local anchor as well as one local axis on each rigid-body. In 3D, an optional
 * local tangent axis can be specified for each rigid-body.
 *
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$47d4981575a3525a = (body1, body2, [body1Anchor, body2Anchor, axis, limits])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const params = rapier.JointData.prismatic($4708f0499e113eb5$var$vector3ToRapierVector(body1Anchor), $4708f0499e113eb5$var$vector3ToRapierVector(body2Anchor), $4708f0499e113eb5$var$vector3ToRapierVector(axis));
    if (limits) {
        params.limitsEnabled = true;
        params.limits = limits;
    }
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, params);
};
/**
 * The rope joint limits the max distance between two bodies.
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$a7f267cdf91e2436 = (body1, body2, [body1Anchor, body2Anchor, length])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const vBody1Anchor = $4708f0499e113eb5$var$vector3ToRapierVector(body1Anchor);
    const vBody2Anchor = $4708f0499e113eb5$var$vector3ToRapierVector(body2Anchor);
    const params = rapier.JointData.rope(length, vBody1Anchor, vBody2Anchor);
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, params);
};
/**
 * The spring joint applies a force proportional to the distance between two objects.
 * @category Hooks - Joints
 */ const $4708f0499e113eb5$export$3b20d2764d8d48aa = (body1, body2, [body1Anchor, body2Anchor, restLength, stiffness, damping])=>{
    const { rapier: rapier } = $4708f0499e113eb5$export$8dc89b465b2c50d();
    const vBody1Anchor = $4708f0499e113eb5$var$vector3ToRapierVector(body1Anchor);
    const vBody2Anchor = $4708f0499e113eb5$var$vector3ToRapierVector(body2Anchor);
    const params = rapier.JointData.spring(restLength, stiffness, damping, vBody1Anchor, vBody2Anchor);
    return $4708f0499e113eb5$export$cbae601798080e14(body1, body2, params);
};
/**
 * Calculates an InteractionGroup bitmask for use in the `collisionGroups` or `solverGroups`
 * properties of RigidBody or Collider components. The first argument represents a list of
 * groups the entity is in (expressed as numbers from 0 to 15). The second argument is a list
 * of groups that will be filtered against. When it is omitted, all groups are filtered against.
 *
 * @example
 * A RigidBody that is member of group 0 and will collide with everything from groups 0 and 1:
 *
 * ```tsx
 * <RigidBody collisionGroups={interactionGroups([0], [0, 1])} />
 * ```
 *
 * A RigidBody that is member of groups 0 and 1 and will collide with everything else:
 *
 * ```tsx
 * <RigidBody collisionGroups={interactionGroups([0, 1])} />
 * ```
 *
 * A RigidBody that is member of groups 0 and 1 and will not collide with anything:
 *
 * ```tsx
 * <RigidBody collisionGroups={interactionGroups([0, 1], [])} />
 * ```
 *
 * Please note that Rapier needs interaction filters to evaluate to true between _both_ colliding
 * entities for collision events to trigger.
 *
 * @param memberships Groups the collider is a member of. (Values can range from 0 to 15.)
 * @param filters Groups the interaction group should filter against. (Values can range from 0 to 15.)
 * @returns An InteractionGroup bitmask.
 */ const $4708f0499e113eb5$export$81613e3b6ee37c2 = (memberships, filters)=>($4708f0499e113eb5$var$bitmask(memberships) << 16) + (filters !== undefined ? $4708f0499e113eb5$var$bitmask(filters) : 65535);
const $4708f0499e113eb5$var$bitmask = (groups)=>[
        groups
    ].flat().reduce((acc, layer)=>acc | 1 << layer, 0);



var $b7a334047b5a7de5$var$__defProp = Object.defineProperty;
var $b7a334047b5a7de5$var$__defNormalProp = (obj, key, value)=>key in obj ? $b7a334047b5a7de5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b7a334047b5a7de5$var$__publicField = (obj, key, value)=>{
    $b7a334047b5a7de5$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
function $b7a334047b5a7de5$var$memcpy(src, srcOffset, dst, dstOffset, length) {
    let i;
    src = src.subarray || src.slice ? src : src.buffer;
    dst = dst.subarray || dst.slice ? dst : dst.buffer;
    src = srcOffset ? src.subarray ? src.subarray(srcOffset, length && srcOffset + length) : src.slice(srcOffset, length && srcOffset + length) : src;
    if (dst.set) dst.set(src, dstOffset);
    else for(i = 0; i < src.length; i++)dst[i + dstOffset] = src[i];
    return dst;
}
function $b7a334047b5a7de5$var$convertPoints(points) {
    if (points instanceof Float32Array) return points;
    if (points instanceof $d5b33d7c30034067$export$b7be63a67df8959) return points.getAttribute("position").array;
    return points.map((p)=>{
        const isArray = Array.isArray(p);
        return p instanceof $d5b33d7c30034067$export$64b5c384219d3699 ? [
            p.x,
            p.y,
            p.z
        ] : p instanceof $d5b33d7c30034067$export$c977b3e384af9ae1 ? [
            p.x,
            p.y,
            0
        ] : isArray && p.length === 3 ? [
            p[0],
            p[1],
            p[2]
        ] : isArray && p.length === 2 ? [
            p[0],
            p[1],
            0
        ] : p;
    }).flat();
}
class $b7a334047b5a7de5$export$feb23cfe052cbcf3 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        $b7a334047b5a7de5$var$__publicField(this, "type", "MeshLine");
        $b7a334047b5a7de5$var$__publicField(this, "isMeshLine", true);
        $b7a334047b5a7de5$var$__publicField(this, "positions", []);
        $b7a334047b5a7de5$var$__publicField(this, "previous", []);
        $b7a334047b5a7de5$var$__publicField(this, "next", []);
        $b7a334047b5a7de5$var$__publicField(this, "side", []);
        $b7a334047b5a7de5$var$__publicField(this, "width", []);
        $b7a334047b5a7de5$var$__publicField(this, "indices_array", []);
        $b7a334047b5a7de5$var$__publicField(this, "uvs", []);
        $b7a334047b5a7de5$var$__publicField(this, "counters", []);
        $b7a334047b5a7de5$var$__publicField(this, "widthCallback", null);
        $b7a334047b5a7de5$var$__publicField(this, "_attributes");
        $b7a334047b5a7de5$var$__publicField(this, "_points", []);
        $b7a334047b5a7de5$var$__publicField(this, "points");
        $b7a334047b5a7de5$var$__publicField(this, "matrixWorld", new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        Object.defineProperties(this, {
            points: {
                enumerable: true,
                get () {
                    return this._points;
                },
                set (value) {
                    this.setPoints(value, this.widthCallback);
                }
            }
        });
    }
    setMatrixWorld(matrixWorld) {
        this.matrixWorld = matrixWorld;
    }
    setPoints(points, wcb) {
        points = $b7a334047b5a7de5$var$convertPoints(points);
        this._points = points;
        this.widthCallback = wcb != null ? wcb : null;
        this.positions = [];
        this.counters = [];
        if (points.length && points[0] instanceof $d5b33d7c30034067$export$64b5c384219d3699) for(let j = 0; j < points.length; j++){
            const p = points[j];
            const c = j / (points.length - 1);
            this.positions.push(p.x, p.y, p.z);
            this.positions.push(p.x, p.y, p.z);
            this.counters.push(c);
            this.counters.push(c);
        }
        else for(let j = 0; j < points.length; j += 3){
            const c = j / (points.length - 1);
            this.positions.push(points[j], points[j + 1], points[j + 2]);
            this.positions.push(points[j], points[j + 1], points[j + 2]);
            this.counters.push(c);
            this.counters.push(c);
        }
        this.process();
    }
    compareV3(a, b) {
        const aa = a * 6;
        const ab = b * 6;
        return this.positions[aa] === this.positions[ab] && this.positions[aa + 1] === this.positions[ab + 1] && this.positions[aa + 2] === this.positions[ab + 2];
    }
    copyV3(a) {
        const aa = a * 6;
        return [
            this.positions[aa],
            this.positions[aa + 1],
            this.positions[aa + 2]
        ];
    }
    process() {
        const l = this.positions.length / 6;
        this.previous = [];
        this.next = [];
        this.side = [];
        this.width = [];
        this.indices_array = [];
        this.uvs = [];
        let w;
        let v;
        if (this.compareV3(0, l - 1)) v = this.copyV3(l - 2);
        else v = this.copyV3(0);
        this.previous.push(v[0], v[1], v[2]);
        this.previous.push(v[0], v[1], v[2]);
        for(let j = 0; j < l; j++){
            this.side.push(1);
            this.side.push(-1);
            if (this.widthCallback) w = this.widthCallback(j / (l - 1));
            else w = 1;
            this.width.push(w);
            this.width.push(w);
            this.uvs.push(j / (l - 1), 0);
            this.uvs.push(j / (l - 1), 1);
            if (j < l - 1) {
                v = this.copyV3(j);
                this.previous.push(v[0], v[1], v[2]);
                this.previous.push(v[0], v[1], v[2]);
                const n = j * 2;
                this.indices_array.push(n, n + 1, n + 2);
                this.indices_array.push(n + 2, n + 1, n + 3);
            }
            if (j > 0) {
                v = this.copyV3(j);
                this.next.push(v[0], v[1], v[2]);
                this.next.push(v[0], v[1], v[2]);
            }
        }
        if (this.compareV3(l - 1, 0)) v = this.copyV3(1);
        else v = this.copyV3(l - 1);
        this.next.push(v[0], v[1], v[2]);
        this.next.push(v[0], v[1], v[2]);
        if (!this._attributes || this._attributes.position.count !== this.counters.length) this._attributes = {
            position: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.positions), 3),
            previous: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.previous), 3),
            next: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.next), 3),
            side: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.side), 1),
            width: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.width), 1),
            uv: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.uvs), 2),
            index: new $d5b33d7c30034067$export$8dea267bd6bde117(new Uint16Array(this.indices_array), 1),
            counters: new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(this.counters), 1)
        };
        else {
            this._attributes.position.copyArray(new Float32Array(this.positions));
            this._attributes.position.needsUpdate = true;
            this._attributes.previous.copyArray(new Float32Array(this.previous));
            this._attributes.previous.needsUpdate = true;
            this._attributes.next.copyArray(new Float32Array(this.next));
            this._attributes.next.needsUpdate = true;
            this._attributes.side.copyArray(new Float32Array(this.side));
            this._attributes.side.needsUpdate = true;
            this._attributes.width.copyArray(new Float32Array(this.width));
            this._attributes.width.needsUpdate = true;
            this._attributes.uv.copyArray(new Float32Array(this.uvs));
            this._attributes.uv.needsUpdate = true;
            this._attributes.index.copyArray(new Uint16Array(this.indices_array));
            this._attributes.index.needsUpdate = true;
        }
        this.setAttribute("position", this._attributes.position);
        this.setAttribute("previous", this._attributes.previous);
        this.setAttribute("next", this._attributes.next);
        this.setAttribute("side", this._attributes.side);
        this.setAttribute("width", this._attributes.width);
        this.setAttribute("uv", this._attributes.uv);
        this.setAttribute("counters", this._attributes.counters);
        this.setAttribute("position", this._attributes.position);
        this.setAttribute("previous", this._attributes.previous);
        this.setAttribute("next", this._attributes.next);
        this.setAttribute("side", this._attributes.side);
        this.setAttribute("width", this._attributes.width);
        this.setAttribute("uv", this._attributes.uv);
        this.setAttribute("counters", this._attributes.counters);
        this.setIndex(this._attributes.index);
        this.computeBoundingSphere();
        this.computeBoundingBox();
    }
    advance({ x: x, y: y, z: z }) {
        const positions = this._attributes.position.array;
        const previous = this._attributes.previous.array;
        const next = this._attributes.next.array;
        const l = positions.length;
        $b7a334047b5a7de5$var$memcpy(positions, 0, previous, 0, l);
        $b7a334047b5a7de5$var$memcpy(positions, 6, positions, 0, l - 6);
        positions[l - 6] = x;
        positions[l - 5] = y;
        positions[l - 4] = z;
        positions[l - 3] = x;
        positions[l - 2] = y;
        positions[l - 1] = z;
        $b7a334047b5a7de5$var$memcpy(positions, 6, next, 0, l - 6);
        next[l - 6] = x;
        next[l - 5] = y;
        next[l - 4] = z;
        next[l - 3] = x;
        next[l - 2] = y;
        next[l - 1] = z;
        this._attributes.position.needsUpdate = true;
        this._attributes.previous.needsUpdate = true;
        this._attributes.next.needsUpdate = true;
    }
}
const $b7a334047b5a7de5$var$vertexShader = `
  #include <common>
  #include <logdepthbuf_pars_vertex>
  #include <fog_pars_vertex>
  #include <clipping_planes_pars_vertex>

  attribute vec3 previous;
  attribute vec3 next;
  attribute float side;
  attribute float width;
  attribute float counters;
  
  uniform vec2 resolution;
  uniform float lineWidth;
  uniform vec3 color;
  uniform float opacity;
  uniform float sizeAttenuation;
  
  varying vec2 vUV;
  varying vec4 vColor;
  varying float vCounters;
  
  vec2 fix(vec4 i, float aspect) {
    vec2 res = i.xy / i.w;
    res.x *= aspect;
    return res;
  }
  
  void main() {
    float aspect = resolution.x / resolution.y;
    vColor = vec4(color, opacity);
    vUV = uv;
    vCounters = counters;
  
    mat4 m = projectionMatrix * modelViewMatrix;
    vec4 finalPosition = m * vec4(position, 1.0) * aspect;
    vec4 prevPos = m * vec4(previous, 1.0);
    vec4 nextPos = m * vec4(next, 1.0);
  
    vec2 currentP = fix(finalPosition, aspect);
    vec2 prevP = fix(prevPos, aspect);
    vec2 nextP = fix(nextPos, aspect);
  
    float w = lineWidth * width;
  
    vec2 dir;
    if (nextP == currentP) dir = normalize(currentP - prevP);
    else if (prevP == currentP) dir = normalize(nextP - currentP);
    else {
      vec2 dir1 = normalize(currentP - prevP);
      vec2 dir2 = normalize(nextP - currentP);
      dir = normalize(dir1 + dir2);
  
      vec2 perp = vec2(-dir1.y, dir1.x);
      vec2 miter = vec2(-dir.y, dir.x);
      //w = clamp(w / dot(miter, perp), 0., 4. * lineWidth * width);
    }
  
    //vec2 normal = (cross(vec3(dir, 0.), vec3(0., 0., 1.))).xy;
    vec4 normal = vec4(-dir.y, dir.x, 0., 1.);
    normal.xy *= .5 * w;
    //normal *= projectionMatrix;
    if (sizeAttenuation == 0.) {
      normal.xy *= finalPosition.w;
      normal.xy /= (vec4(resolution, 0., 1.) * projectionMatrix).xy * aspect;
    }
  
    finalPosition.xy += normal.xy * side;
    gl_Position = finalPosition;
    #include <logdepthbuf_vertex>
    #include <fog_vertex>
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    #include <clipping_planes_vertex>
    #include <fog_vertex>
  }
`;
const $b7a334047b5a7de5$var$version = /* @__PURE__ */ (()=>parseInt($d5b33d7c30034067$export$3545e07a80636437.replace(/\D+/g, "")))();
const $b7a334047b5a7de5$var$colorspace_fragment = $b7a334047b5a7de5$var$version >= 154 ? "colorspace_fragment" : "encodings_fragment";
const $b7a334047b5a7de5$var$fragmentShader = `
  #include <fog_pars_fragment>
  #include <logdepthbuf_pars_fragment>
  #include <clipping_planes_pars_fragment>
  
  uniform sampler2D map;
  uniform sampler2D alphaMap;
  uniform float useGradient;
  uniform float useMap;
  uniform float useAlphaMap;
  uniform float useDash;
  uniform float dashArray;
  uniform float dashOffset;
  uniform float dashRatio;
  uniform float visibility;
  uniform float alphaTest;
  uniform vec2 repeat;
  uniform vec3 gradient[2];
  
  varying vec2 vUV;
  varying vec4 vColor;
  varying float vCounters;
  
  void main() {
    #include <logdepthbuf_fragment>
    vec4 diffuseColor = vColor;
    if (useGradient == 1.) diffuseColor = vec4(mix(gradient[0], gradient[1], vCounters), 1.0);
    if (useMap == 1.) diffuseColor *= texture2D(map, vUV * repeat);
    if (useAlphaMap == 1.) diffuseColor.a *= texture2D(alphaMap, vUV * repeat).a;
    if (diffuseColor.a < alphaTest) discard;
    if (useDash == 1.) diffuseColor.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));
    diffuseColor.a *= step(vCounters, visibility);
    #include <clipping_planes_fragment>
    gl_FragColor = diffuseColor;     
    #include <fog_fragment>
    #include <tonemapping_fragment>
    #include <${$b7a334047b5a7de5$var$colorspace_fragment}>
  }
`;
class $b7a334047b5a7de5$export$d8abe26b06d5f5e4 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    constructor(parameters){
        super({
            uniforms: {
                ...$d5b33d7c30034067$export$6643083551874bf5.fog,
                lineWidth: {
                    value: 1
                },
                map: {
                    value: null
                },
                useMap: {
                    value: 0
                },
                alphaMap: {
                    value: null
                },
                useAlphaMap: {
                    value: 0
                },
                color: {
                    value: new $d5b33d7c30034067$export$892596cec99bc70e(16777215)
                },
                gradient: {
                    value: [
                        new $d5b33d7c30034067$export$892596cec99bc70e(16711680),
                        new $d5b33d7c30034067$export$892596cec99bc70e(65280)
                    ]
                },
                opacity: {
                    value: 1
                },
                resolution: {
                    value: new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
                },
                sizeAttenuation: {
                    value: 1
                },
                dashArray: {
                    value: 0
                },
                dashOffset: {
                    value: 0
                },
                dashRatio: {
                    value: 0.5
                },
                useDash: {
                    value: 0
                },
                useGradient: {
                    value: 0
                },
                visibility: {
                    value: 1
                },
                alphaTest: {
                    value: 0
                },
                repeat: {
                    value: new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
                }
            },
            vertexShader: $b7a334047b5a7de5$var$vertexShader,
            fragmentShader: $b7a334047b5a7de5$var$fragmentShader
        });
        $b7a334047b5a7de5$var$__publicField(this, "lineWidth");
        $b7a334047b5a7de5$var$__publicField(this, "map");
        $b7a334047b5a7de5$var$__publicField(this, "useMap");
        $b7a334047b5a7de5$var$__publicField(this, "alphaMap");
        $b7a334047b5a7de5$var$__publicField(this, "useAlphaMap");
        $b7a334047b5a7de5$var$__publicField(this, "color");
        $b7a334047b5a7de5$var$__publicField(this, "gradient");
        $b7a334047b5a7de5$var$__publicField(this, "resolution");
        $b7a334047b5a7de5$var$__publicField(this, "sizeAttenuation");
        $b7a334047b5a7de5$var$__publicField(this, "dashArray");
        $b7a334047b5a7de5$var$__publicField(this, "dashOffset");
        $b7a334047b5a7de5$var$__publicField(this, "dashRatio");
        $b7a334047b5a7de5$var$__publicField(this, "useDash");
        $b7a334047b5a7de5$var$__publicField(this, "useGradient");
        $b7a334047b5a7de5$var$__publicField(this, "visibility");
        $b7a334047b5a7de5$var$__publicField(this, "repeat");
        this.type = "MeshLineMaterial";
        Object.defineProperties(this, {
            lineWidth: {
                enumerable: true,
                get () {
                    return this.uniforms.lineWidth.value;
                },
                set (value) {
                    this.uniforms.lineWidth.value = value;
                }
            },
            map: {
                enumerable: true,
                get () {
                    return this.uniforms.map.value;
                },
                set (value) {
                    this.uniforms.map.value = value;
                }
            },
            useMap: {
                enumerable: true,
                get () {
                    return this.uniforms.useMap.value;
                },
                set (value) {
                    this.uniforms.useMap.value = value;
                }
            },
            alphaMap: {
                enumerable: true,
                get () {
                    return this.uniforms.alphaMap.value;
                },
                set (value) {
                    this.uniforms.alphaMap.value = value;
                }
            },
            useAlphaMap: {
                enumerable: true,
                get () {
                    return this.uniforms.useAlphaMap.value;
                },
                set (value) {
                    this.uniforms.useAlphaMap.value = value;
                }
            },
            color: {
                enumerable: true,
                get () {
                    return this.uniforms.color.value;
                },
                set (value) {
                    this.uniforms.color.value = value;
                }
            },
            gradient: {
                enumerable: true,
                get () {
                    return this.uniforms.gradient.value;
                },
                set (value) {
                    this.uniforms.gradient.value = value;
                }
            },
            opacity: {
                enumerable: true,
                get () {
                    return this.uniforms.opacity.value;
                },
                set (value) {
                    this.uniforms.opacity.value = value;
                }
            },
            resolution: {
                enumerable: true,
                get () {
                    return this.uniforms.resolution.value;
                },
                set (value) {
                    this.uniforms.resolution.value.copy(value);
                }
            },
            sizeAttenuation: {
                enumerable: true,
                get () {
                    return this.uniforms.sizeAttenuation.value;
                },
                set (value) {
                    this.uniforms.sizeAttenuation.value = value;
                }
            },
            dashArray: {
                enumerable: true,
                get () {
                    return this.uniforms.dashArray.value;
                },
                set (value) {
                    this.uniforms.dashArray.value = value;
                    this.useDash = value !== 0 ? 1 : 0;
                }
            },
            dashOffset: {
                enumerable: true,
                get () {
                    return this.uniforms.dashOffset.value;
                },
                set (value) {
                    this.uniforms.dashOffset.value = value;
                }
            },
            dashRatio: {
                enumerable: true,
                get () {
                    return this.uniforms.dashRatio.value;
                },
                set (value) {
                    this.uniforms.dashRatio.value = value;
                }
            },
            useDash: {
                enumerable: true,
                get () {
                    return this.uniforms.useDash.value;
                },
                set (value) {
                    this.uniforms.useDash.value = value;
                }
            },
            useGradient: {
                enumerable: true,
                get () {
                    return this.uniforms.useGradient.value;
                },
                set (value) {
                    this.uniforms.useGradient.value = value;
                }
            },
            visibility: {
                enumerable: true,
                get () {
                    return this.uniforms.visibility.value;
                },
                set (value) {
                    this.uniforms.visibility.value = value;
                }
            },
            alphaTest: {
                enumerable: true,
                get () {
                    return this.uniforms.alphaTest.value;
                },
                set (value) {
                    this.uniforms.alphaTest.value = value;
                }
            },
            repeat: {
                enumerable: true,
                get () {
                    return this.uniforms.repeat.value;
                },
                set (value) {
                    this.uniforms.repeat.value.copy(value);
                }
            }
        });
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.lineWidth = source.lineWidth;
        this.map = source.map;
        this.useMap = source.useMap;
        this.alphaMap = source.alphaMap;
        this.useAlphaMap = source.useAlphaMap;
        this.color.copy(source.color);
        this.gradient = source.gradient;
        this.opacity = source.opacity;
        this.resolution.copy(source.resolution);
        this.sizeAttenuation = source.sizeAttenuation;
        this.dashArray = source.dashArray;
        this.dashOffset = source.dashOffset;
        this.dashRatio = source.dashRatio;
        this.useDash = source.useDash;
        this.useGradient = source.useGradient;
        this.visibility = source.visibility;
        this.alphaTest = source.alphaTest;
        this.repeat.copy(source.repeat);
        return this;
    }
}
function $b7a334047b5a7de5$export$630e89aab3ddc1d6(raycaster, intersects) {
    const inverseMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const ray = new $d5b33d7c30034067$export$a186db52eed6d40e();
    const sphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
    const interRay = new $d5b33d7c30034067$export$64b5c384219d3699();
    const geometry = this.geometry;
    sphere.copy(geometry.boundingSphere);
    sphere.applyMatrix4(this.matrixWorld);
    if (!raycaster.ray.intersectSphere(sphere, interRay)) return;
    inverseMatrix.copy(this.matrixWorld).invert();
    ray.copy(raycaster.ray).applyMatrix4(inverseMatrix);
    const vStart = new $d5b33d7c30034067$export$64b5c384219d3699();
    const vEnd = new $d5b33d7c30034067$export$64b5c384219d3699();
    const interSegment = new $d5b33d7c30034067$export$64b5c384219d3699();
    const step = this instanceof $d5b33d7c30034067$export$ff1ed10fedfdd604 ? 2 : 1;
    const index = geometry.index;
    const attributes = geometry.attributes;
    if (index !== null) {
        const indices = index.array;
        const positions = attributes.position.array;
        const widths = attributes.width.array;
        for(let i = 0, l = indices.length - 1; i < l; i += step){
            const a = indices[i];
            const b = indices[i + 1];
            vStart.fromArray(positions, a * 3);
            vEnd.fromArray(positions, b * 3);
            const width = widths[Math.floor(i / 3)] != void 0 ? widths[Math.floor(i / 3)] : 1;
            const precision = raycaster.params.Line.threshold + this.material.lineWidth * width / 2;
            const precisionSq = precision * precision;
            const distSq = ray.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
            if (distSq > precisionSq) continue;
            interRay.applyMatrix4(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo(interRay);
            if (distance < raycaster.near || distance > raycaster.far) continue;
            intersects.push({
                distance: distance,
                point: interSegment.clone().applyMatrix4(this.matrixWorld),
                index: i,
                face: null,
                faceIndex: void 0,
                object: this
            });
            i = l;
        }
    }
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($06dbdeafb212d82f$export$43e446d32b3d21af(...refs), refs);
}


/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$2fad294522b5ed20$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $06dbdeafb212d82f$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $2fad294522b5ed20$export$d9f1ccf0bdb05d45;
}
function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $2fad294522b5ed20$export$be92b6f5f03c0fe9 = $2fad294522b5ed20$export$8c6ed5c666ac1360;


const $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$250ffa63cdc0d034 = $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $2fad294522b5ed20$export$8c6ed5c666ac1360) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $ffa305e20fe06c82$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $11492dca620dcaa5$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$be92b6f5f03c0fe9 = $ffa305e20fe06c82$export$250ffa63cdc0d034;


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $7e4e93e12e9bb800$var$$f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const $7e4e93e12e9bb800$export$602eac185826482c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($7e4e93e12e9bb800$export$602eac185826482c, {
    displayName: $7e4e93e12e9bb800$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $7e4e93e12e9bb800$export$be92b6f5f03c0fe9 = $7e4e93e12e9bb800$export$602eac185826482c;


var $37120ef32eee7a36$export$de8294bb3be0322f;
var $37120ef32eee7a36$var$has = Object.prototype.hasOwnProperty;
function $37120ef32eee7a36$var$dequal(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $37120ef32eee7a36$var$dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($37120ef32eee7a36$var$has.call(foo, ctor) && ++len && !$37120ef32eee7a36$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$37120ef32eee7a36$var$dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
$37120ef32eee7a36$export$de8294bb3be0322f = $37120ef32eee7a36$var$dequal;


var $af540f293314ba66$exports = {};
'use strict';
Object.defineProperty($af540f293314ba66$exports, '__esModule', {
    value: true
});
function $af540f293314ba66$var$shallow(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
$af540f293314ba66$exports["default"] = $af540f293314ba66$var$shallow;


var $ce56786d2aafac68$var$Rule = function Rule(name, fn, args, modifiers) {
    this.name = name;
    this.fn = fn;
    this.args = args;
    this.modifiers = modifiers;
};
$ce56786d2aafac68$var$Rule.prototype._test = function _test(value) {
    var fn = this.fn;
    try {
        $ce56786d2aafac68$var$testAux(this.modifiers.slice(), fn, this)(value);
    } catch (ex) {
        fn = function() {
            return false;
        };
    }
    try {
        return $ce56786d2aafac68$var$testAux(this.modifiers.slice(), fn, this)(value);
    } catch (ex$1) {
        return false;
    }
};
$ce56786d2aafac68$var$Rule.prototype._check = function _check(value) {
    try {
        $ce56786d2aafac68$var$testAux(this.modifiers.slice(), this.fn, this)(value);
    } catch (ex) {
        if ($ce56786d2aafac68$var$testAux(this.modifiers.slice(), function(it) {
            return it;
        }, this)(false)) return;
    }
    if (!$ce56786d2aafac68$var$testAux(this.modifiers.slice(), this.fn, this)(value)) throw null;
};
$ce56786d2aafac68$var$Rule.prototype._testAsync = function _testAsync(value) {
    var this$1 = this;
    return new Promise(function(resolve, reject) {
        $ce56786d2aafac68$var$testAsyncAux(this$1.modifiers.slice(), this$1.fn, this$1)(value).then(function(valid) {
            if (valid) resolve(value);
            else reject(null);
        }).catch(function(ex) {
            return reject(ex);
        });
    });
};
function $ce56786d2aafac68$var$pickFn(fn, variant) {
    if (variant === void 0) variant = 'simple';
    return typeof fn === 'object' ? fn[variant] : fn;
}
function $ce56786d2aafac68$var$testAux(modifiers, fn, rule) {
    if (modifiers.length) {
        var modifier = modifiers.shift();
        var nextFn = $ce56786d2aafac68$var$testAux(modifiers, fn, rule);
        return modifier.perform(nextFn, rule);
    } else return $ce56786d2aafac68$var$pickFn(fn);
}
function $ce56786d2aafac68$var$testAsyncAux(modifiers, fn, rule) {
    if (modifiers.length) {
        var modifier = modifiers.shift();
        var nextFn = $ce56786d2aafac68$var$testAsyncAux(modifiers, fn, rule);
        return modifier.performAsync(nextFn, rule);
    } else return function(value) {
        return Promise.resolve($ce56786d2aafac68$var$pickFn(fn, 'async')(value));
    };
}
var $ce56786d2aafac68$var$Modifier = function Modifier(name, perform, performAsync) {
    this.name = name;
    this.perform = perform;
    this.performAsync = performAsync;
};
var $ce56786d2aafac68$var$ValidationError = /*@__PURE__*/ function(Error1) {
    function ValidationError(rule, value, cause, target) {
        var remaining = [], len = arguments.length - 4;
        while(len-- > 0)remaining[len] = arguments[len + 4];
        Error1.call(this, remaining);
        if (Error1.captureStackTrace) Error1.captureStackTrace(this, ValidationError);
        this.rule = rule;
        this.value = value;
        this.cause = cause;
        this.target = target;
    }
    if (Error1) ValidationError.__proto__ = Error1;
    ValidationError.prototype = Object.create(Error1 && Error1.prototype);
    ValidationError.prototype.constructor = ValidationError;
    return ValidationError;
}(Error);
var $ce56786d2aafac68$var$Context = function Context(chain, nextRuleModifiers) {
    if (chain === void 0) chain = [];
    if (nextRuleModifiers === void 0) nextRuleModifiers = [];
    this.chain = chain;
    this.nextRuleModifiers = nextRuleModifiers;
};
$ce56786d2aafac68$var$Context.prototype._applyRule = function _applyRule(ruleFn, name) {
    var this$1 = this;
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        this$1.chain.push(new $ce56786d2aafac68$var$Rule(name, ruleFn.apply(this$1, args), args, this$1.nextRuleModifiers));
        this$1.nextRuleModifiers = [];
        return this$1;
    };
};
$ce56786d2aafac68$var$Context.prototype._applyModifier = function _applyModifier(modifier, name) {
    this.nextRuleModifiers.push(new $ce56786d2aafac68$var$Modifier(name, modifier.simple, modifier.async));
    return this;
};
$ce56786d2aafac68$var$Context.prototype._clone = function _clone() {
    return new $ce56786d2aafac68$var$Context(this.chain.slice(), this.nextRuleModifiers.slice());
};
$ce56786d2aafac68$var$Context.prototype.test = function test(value) {
    return this.chain.every(function(rule) {
        return rule._test(value);
    });
};
$ce56786d2aafac68$var$Context.prototype.testAll = function testAll(value) {
    var err = [];
    this.chain.forEach(function(rule) {
        try {
            rule._check(value);
        } catch (ex) {
            err.push(new $ce56786d2aafac68$var$ValidationError(rule, value, ex));
        }
    });
    return err;
};
$ce56786d2aafac68$var$Context.prototype.check = function check(value) {
    this.chain.forEach(function(rule) {
        try {
            rule._check(value);
        } catch (ex) {
            throw new $ce56786d2aafac68$var$ValidationError(rule, value, ex);
        }
    });
};
$ce56786d2aafac68$var$Context.prototype.testAsync = function testAsync(value) {
    var this$1 = this;
    return new Promise(function(resolve, reject) {
        $ce56786d2aafac68$var$executeAsyncRules(value, this$1.chain.slice(), resolve, reject);
    });
};
function $ce56786d2aafac68$var$executeAsyncRules(value, rules, resolve, reject) {
    if (rules.length) {
        var rule = rules.shift();
        rule._testAsync(value).then(function() {
            $ce56786d2aafac68$var$executeAsyncRules(value, rules, resolve, reject);
        }, function(cause) {
            reject(new $ce56786d2aafac68$var$ValidationError(rule, value, cause));
        });
    } else resolve(value);
}
var $ce56786d2aafac68$var$consideredEmpty = function(value, considerTrimmedEmptyString) {
    if (considerTrimmedEmptyString && typeof value === 'string' && value.trim().length === 0) return true;
    return value === undefined || value === null;
};
function $ce56786d2aafac68$var$optional(validation, considerTrimmedEmptyString) {
    if (considerTrimmedEmptyString === void 0) considerTrimmedEmptyString = false;
    return {
        simple: function(value) {
            return $ce56786d2aafac68$var$consideredEmpty(value, considerTrimmedEmptyString) || validation.check(value) === undefined;
        },
        async: function(value) {
            return $ce56786d2aafac68$var$consideredEmpty(value, considerTrimmedEmptyString) || validation.testAsync(value);
        }
    };
}
function $ce56786d2aafac68$var$v8n() {
    return typeof Proxy !== 'undefined' ? $ce56786d2aafac68$var$proxyContext(new $ce56786d2aafac68$var$Context()) : $ce56786d2aafac68$var$proxylessContext(new $ce56786d2aafac68$var$Context());
}
// Custom rules
var $ce56786d2aafac68$var$customRules = {};
$ce56786d2aafac68$var$v8n.extend = function(newRules) {
    Object.assign($ce56786d2aafac68$var$customRules, newRules);
};
$ce56786d2aafac68$var$v8n.clearCustomRules = function() {
    $ce56786d2aafac68$var$customRules = {};
};
function $ce56786d2aafac68$var$proxyContext(context) {
    return new Proxy(context, {
        get: function get(obj, prop) {
            if (prop in obj) return obj[prop];
            var newContext = $ce56786d2aafac68$var$proxyContext(context._clone());
            if (prop in $ce56786d2aafac68$var$availableModifiers) return newContext._applyModifier($ce56786d2aafac68$var$availableModifiers[prop], prop);
            if (prop in $ce56786d2aafac68$var$customRules) return newContext._applyRule($ce56786d2aafac68$var$customRules[prop], prop);
            if (prop in $ce56786d2aafac68$var$availableRules) return newContext._applyRule($ce56786d2aafac68$var$availableRules[prop], prop);
        }
    });
}
function $ce56786d2aafac68$var$proxylessContext(context) {
    var addRuleSet = function(ruleSet, targetContext) {
        Object.keys(ruleSet).forEach(function(prop) {
            targetContext[prop] = function() {
                var args = [], len = arguments.length;
                while(len--)args[len] = arguments[len];
                var newContext = $ce56786d2aafac68$var$proxylessContext(targetContext._clone());
                var contextWithRuleApplied = newContext._applyRule(ruleSet[prop], prop).apply(void 0, args);
                return contextWithRuleApplied;
            };
        });
        return targetContext;
    };
    var contextWithAvailableRules = addRuleSet($ce56786d2aafac68$var$availableRules, context);
    var contextWithAllRules = addRuleSet($ce56786d2aafac68$var$customRules, contextWithAvailableRules);
    Object.keys($ce56786d2aafac68$var$availableModifiers).forEach(function(prop) {
        Object.defineProperty(contextWithAllRules, prop, {
            get: function() {
                var newContext = $ce56786d2aafac68$var$proxylessContext(contextWithAllRules._clone());
                return newContext._applyModifier($ce56786d2aafac68$var$availableModifiers[prop], prop);
            }
        });
    });
    return contextWithAllRules;
}
var $ce56786d2aafac68$var$availableModifiers = {
    not: {
        simple: function(fn) {
            return function(value) {
                return !fn(value);
            };
        },
        async: function(fn) {
            return function(value) {
                return Promise.resolve(fn(value)).then(function(result) {
                    return !result;
                }).catch(function() {
                    return true;
                });
            };
        }
    },
    some: {
        simple: function(fn) {
            return function(value) {
                return $ce56786d2aafac68$var$split(value).some(function(item) {
                    try {
                        return fn(item);
                    } catch (ex) {
                        return false;
                    }
                });
            };
        },
        async: function(fn) {
            return function(value) {
                return Promise.all($ce56786d2aafac68$var$split(value).map(function(item) {
                    try {
                        return fn(item).catch(function() {
                            return false;
                        });
                    } catch (ex) {
                        return false;
                    }
                })).then(function(result) {
                    return result.some(Boolean);
                });
            };
        }
    },
    every: {
        simple: function(fn) {
            return function(value) {
                return value !== false && $ce56786d2aafac68$var$split(value).every(fn);
            };
        },
        async: function(fn) {
            return function(value) {
                return Promise.all($ce56786d2aafac68$var$split(value).map(fn)).then(function(result) {
                    return result.every(Boolean);
                });
            };
        }
    },
    strict: {
        simple: function(fn, rule) {
            return function(value) {
                if ($ce56786d2aafac68$var$isSchemaRule(rule) && value && typeof value === 'object') return Object.keys(rule.args[0]).length === Object.keys(value).length && fn(value);
                return fn(value);
            };
        },
        async: function(fn, rule) {
            return function(value) {
                return Promise.resolve(fn(value)).then(function(result) {
                    if ($ce56786d2aafac68$var$isSchemaRule(rule) && value && typeof value === 'object') return Object.keys(rule.args[0]).length === Object.keys(value).length && result;
                    return result;
                }).catch(function() {
                    return false;
                });
            };
        }
    }
};
function $ce56786d2aafac68$var$isSchemaRule(rule) {
    return rule && rule.name === 'schema' && rule.args.length > 0 && typeof rule.args[0] === 'object';
}
function $ce56786d2aafac68$var$split(value) {
    if (typeof value === 'string') return value.split('');
    return value;
}
var $ce56786d2aafac68$var$availableRules = {
    // Value
    equal: function(expected) {
        return function(value) {
            return value == expected;
        };
    },
    exact: function(expected) {
        return function(value) {
            return value === expected;
        };
    },
    // Types
    number: function(allowInfinite) {
        if (allowInfinite === void 0) allowInfinite = true;
        return function(value) {
            return typeof value === 'number' && (allowInfinite || isFinite(value));
        };
    },
    integer: function() {
        return function(value) {
            var isInteger = Number.isInteger || $ce56786d2aafac68$var$isIntegerPolyfill;
            return isInteger(value);
        };
    },
    numeric: function() {
        return function(value) {
            return !isNaN(parseFloat(value)) && isFinite(value);
        };
    },
    string: function() {
        return $ce56786d2aafac68$var$testType('string');
    },
    boolean: function() {
        return $ce56786d2aafac68$var$testType('boolean');
    },
    undefined: function() {
        return $ce56786d2aafac68$var$testType('undefined');
    },
    null: function() {
        return $ce56786d2aafac68$var$testType('null');
    },
    array: function() {
        return $ce56786d2aafac68$var$testType('array');
    },
    object: function() {
        return $ce56786d2aafac68$var$testType('object');
    },
    instanceOf: function(instance) {
        return function(value) {
            return value instanceof instance;
        };
    },
    // Pattern
    pattern: function(expected) {
        return function(value) {
            return expected.test(value);
        };
    },
    lowercase: function() {
        return function(value) {
            return typeof value === 'boolean' || value === value.toLowerCase() && value.trim() !== '';
        };
    },
    uppercase: function() {
        return function(value) {
            return value === value.toUpperCase() && value.trim() !== '';
        };
    },
    vowel: function() {
        return function(value) {
            return /^[aeiou]+$/i.test(value);
        };
    },
    consonant: function() {
        return function(value) {
            return /^(?=[^aeiou])([a-z]+)$/i.test(value);
        };
    },
    // Value at
    first: function(expected) {
        return function(value) {
            return value[0] == expected;
        };
    },
    last: function(expected) {
        return function(value) {
            return value[value.length - 1] == expected;
        };
    },
    // Length
    empty: function() {
        return function(value) {
            return value.length === 0;
        };
    },
    length: function(min, max) {
        return function(value) {
            return value.length >= min && value.length <= (max || min);
        };
    },
    minLength: function(min) {
        return function(value) {
            return value.length >= min;
        };
    },
    maxLength: function(max) {
        return function(value) {
            return value.length <= max;
        };
    },
    // Range
    negative: function() {
        return function(value) {
            return value < 0;
        };
    },
    positive: function() {
        return function(value) {
            return value >= 0;
        };
    },
    between: function(a, b) {
        return function(value) {
            return value >= a && value <= b;
        };
    },
    range: function(a, b) {
        return function(value) {
            return value >= a && value <= b;
        };
    },
    lessThan: function(n) {
        return function(value) {
            return value < n;
        };
    },
    lessThanOrEqual: function(n) {
        return function(value) {
            return value <= n;
        };
    },
    greaterThan: function(n) {
        return function(value) {
            return value > n;
        };
    },
    greaterThanOrEqual: function(n) {
        return function(value) {
            return value >= n;
        };
    },
    // Divisible
    even: function() {
        return function(value) {
            return value % 2 === 0;
        };
    },
    odd: function() {
        return function(value) {
            return value % 2 !== 0;
        };
    },
    includes: function(expected) {
        return function(value) {
            return ~value.indexOf(expected);
        };
    },
    schema: function(schema) {
        return $ce56786d2aafac68$var$testSchema(schema);
    },
    // branching
    passesAnyOf: function() {
        var validations = [], len = arguments.length;
        while(len--)validations[len] = arguments[len];
        return function(value) {
            return validations.some(function(validation) {
                return validation.test(value);
            });
        };
    },
    optional: $ce56786d2aafac68$var$optional
};
function $ce56786d2aafac68$var$testType(expected) {
    return function(value) {
        return Array.isArray(value) && expected === 'array' || value === null && expected === 'null' || typeof value === expected;
    };
}
function $ce56786d2aafac68$var$isIntegerPolyfill(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function $ce56786d2aafac68$var$testSchema(schema) {
    return {
        simple: function(value) {
            var causes = [];
            Object.keys(schema).forEach(function(key) {
                var nestedValidation = schema[key];
                try {
                    nestedValidation.check((value || {})[key]);
                } catch (ex) {
                    ex.target = key;
                    causes.push(ex);
                }
            });
            if (causes.length > 0) throw causes;
            return true;
        },
        async: function(value) {
            var causes = [];
            var nested = Object.keys(schema).map(function(key) {
                var nestedValidation = schema[key];
                return nestedValidation.testAsync((value || {})[key]).catch(function(ex) {
                    ex.target = key;
                    causes.push(ex);
                });
            });
            return Promise.all(nested).then(function() {
                if (causes.length > 0) throw causes;
                return true;
            });
        }
    };
}
var $ce56786d2aafac68$export$2e2bcd8739ae039 = $ce56786d2aafac68$var$v8n;



var $acw62 = parcelRequire("acw62");
var $4dd86a99225dce20$var$e = "colors", $4dd86a99225dce20$var$t = "sizes", $4dd86a99225dce20$var$r = "space", $4dd86a99225dce20$export$22deaee80f3d7c38 = {
    gap: $4dd86a99225dce20$var$r,
    gridGap: $4dd86a99225dce20$var$r,
    columnGap: $4dd86a99225dce20$var$r,
    gridColumnGap: $4dd86a99225dce20$var$r,
    rowGap: $4dd86a99225dce20$var$r,
    gridRowGap: $4dd86a99225dce20$var$r,
    inset: $4dd86a99225dce20$var$r,
    insetBlock: $4dd86a99225dce20$var$r,
    insetBlockEnd: $4dd86a99225dce20$var$r,
    insetBlockStart: $4dd86a99225dce20$var$r,
    insetInline: $4dd86a99225dce20$var$r,
    insetInlineEnd: $4dd86a99225dce20$var$r,
    insetInlineStart: $4dd86a99225dce20$var$r,
    margin: $4dd86a99225dce20$var$r,
    marginTop: $4dd86a99225dce20$var$r,
    marginRight: $4dd86a99225dce20$var$r,
    marginBottom: $4dd86a99225dce20$var$r,
    marginLeft: $4dd86a99225dce20$var$r,
    marginBlock: $4dd86a99225dce20$var$r,
    marginBlockEnd: $4dd86a99225dce20$var$r,
    marginBlockStart: $4dd86a99225dce20$var$r,
    marginInline: $4dd86a99225dce20$var$r,
    marginInlineEnd: $4dd86a99225dce20$var$r,
    marginInlineStart: $4dd86a99225dce20$var$r,
    padding: $4dd86a99225dce20$var$r,
    paddingTop: $4dd86a99225dce20$var$r,
    paddingRight: $4dd86a99225dce20$var$r,
    paddingBottom: $4dd86a99225dce20$var$r,
    paddingLeft: $4dd86a99225dce20$var$r,
    paddingBlock: $4dd86a99225dce20$var$r,
    paddingBlockEnd: $4dd86a99225dce20$var$r,
    paddingBlockStart: $4dd86a99225dce20$var$r,
    paddingInline: $4dd86a99225dce20$var$r,
    paddingInlineEnd: $4dd86a99225dce20$var$r,
    paddingInlineStart: $4dd86a99225dce20$var$r,
    top: $4dd86a99225dce20$var$r,
    right: $4dd86a99225dce20$var$r,
    bottom: $4dd86a99225dce20$var$r,
    left: $4dd86a99225dce20$var$r,
    scrollMargin: $4dd86a99225dce20$var$r,
    scrollMarginTop: $4dd86a99225dce20$var$r,
    scrollMarginRight: $4dd86a99225dce20$var$r,
    scrollMarginBottom: $4dd86a99225dce20$var$r,
    scrollMarginLeft: $4dd86a99225dce20$var$r,
    scrollMarginX: $4dd86a99225dce20$var$r,
    scrollMarginY: $4dd86a99225dce20$var$r,
    scrollMarginBlock: $4dd86a99225dce20$var$r,
    scrollMarginBlockEnd: $4dd86a99225dce20$var$r,
    scrollMarginBlockStart: $4dd86a99225dce20$var$r,
    scrollMarginInline: $4dd86a99225dce20$var$r,
    scrollMarginInlineEnd: $4dd86a99225dce20$var$r,
    scrollMarginInlineStart: $4dd86a99225dce20$var$r,
    scrollPadding: $4dd86a99225dce20$var$r,
    scrollPaddingTop: $4dd86a99225dce20$var$r,
    scrollPaddingRight: $4dd86a99225dce20$var$r,
    scrollPaddingBottom: $4dd86a99225dce20$var$r,
    scrollPaddingLeft: $4dd86a99225dce20$var$r,
    scrollPaddingX: $4dd86a99225dce20$var$r,
    scrollPaddingY: $4dd86a99225dce20$var$r,
    scrollPaddingBlock: $4dd86a99225dce20$var$r,
    scrollPaddingBlockEnd: $4dd86a99225dce20$var$r,
    scrollPaddingBlockStart: $4dd86a99225dce20$var$r,
    scrollPaddingInline: $4dd86a99225dce20$var$r,
    scrollPaddingInlineEnd: $4dd86a99225dce20$var$r,
    scrollPaddingInlineStart: $4dd86a99225dce20$var$r,
    fontSize: "fontSizes",
    background: $4dd86a99225dce20$var$e,
    backgroundColor: $4dd86a99225dce20$var$e,
    backgroundImage: $4dd86a99225dce20$var$e,
    borderImage: $4dd86a99225dce20$var$e,
    border: $4dd86a99225dce20$var$e,
    borderBlock: $4dd86a99225dce20$var$e,
    borderBlockEnd: $4dd86a99225dce20$var$e,
    borderBlockStart: $4dd86a99225dce20$var$e,
    borderBottom: $4dd86a99225dce20$var$e,
    borderBottomColor: $4dd86a99225dce20$var$e,
    borderColor: $4dd86a99225dce20$var$e,
    borderInline: $4dd86a99225dce20$var$e,
    borderInlineEnd: $4dd86a99225dce20$var$e,
    borderInlineStart: $4dd86a99225dce20$var$e,
    borderLeft: $4dd86a99225dce20$var$e,
    borderLeftColor: $4dd86a99225dce20$var$e,
    borderRight: $4dd86a99225dce20$var$e,
    borderRightColor: $4dd86a99225dce20$var$e,
    borderTop: $4dd86a99225dce20$var$e,
    borderTopColor: $4dd86a99225dce20$var$e,
    caretColor: $4dd86a99225dce20$var$e,
    color: $4dd86a99225dce20$var$e,
    columnRuleColor: $4dd86a99225dce20$var$e,
    fill: $4dd86a99225dce20$var$e,
    outline: $4dd86a99225dce20$var$e,
    outlineColor: $4dd86a99225dce20$var$e,
    stroke: $4dd86a99225dce20$var$e,
    textDecorationColor: $4dd86a99225dce20$var$e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $4dd86a99225dce20$var$t,
    minBlockSize: $4dd86a99225dce20$var$t,
    maxBlockSize: $4dd86a99225dce20$var$t,
    inlineSize: $4dd86a99225dce20$var$t,
    minInlineSize: $4dd86a99225dce20$var$t,
    maxInlineSize: $4dd86a99225dce20$var$t,
    width: $4dd86a99225dce20$var$t,
    minWidth: $4dd86a99225dce20$var$t,
    maxWidth: $4dd86a99225dce20$var$t,
    height: $4dd86a99225dce20$var$t,
    minHeight: $4dd86a99225dce20$var$t,
    maxHeight: $4dd86a99225dce20$var$t,
    flexBasis: $4dd86a99225dce20$var$t,
    gridTemplateColumns: $4dd86a99225dce20$var$t,
    gridTemplateRows: $4dd86a99225dce20$var$t,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $4dd86a99225dce20$var$i = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $4dd86a99225dce20$var$o = ()=>{
    const e = Object.create(null);
    return (t, r, ...n)=>{
        const o = ((e)=>JSON.stringify(e, $4dd86a99225dce20$var$i))(t);
        return o in e ? e[o] : e[o] = r(t, ...n);
    };
}, $4dd86a99225dce20$var$l = Symbol.for("sxs.internal"), $4dd86a99225dce20$var$s = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $4dd86a99225dce20$var$a = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $4dd86a99225dce20$var$c } = Object.prototype, $4dd86a99225dce20$var$d = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $4dd86a99225dce20$var$g = /\s+(?![^()]*\))/, $4dd86a99225dce20$var$p = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($4dd86a99225dce20$var$g) : [
            t
        ]), $4dd86a99225dce20$var$u = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $4dd86a99225dce20$var$p((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $4dd86a99225dce20$var$p((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $4dd86a99225dce20$var$p((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $4dd86a99225dce20$var$p((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $4dd86a99225dce20$var$p((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $4dd86a99225dce20$var$p((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $4dd86a99225dce20$var$h = /([\d.]+)([^]*)/, $4dd86a99225dce20$var$f = (e, t)=>e.length ? e.reduce((e, r)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? `:is(${r})` : r) : r + " " + e)), e), []) : t, $4dd86a99225dce20$var$m = (e, t)=>e in $4dd86a99225dce20$var$b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, r, n, i)=>r + ("stretch" === n ? `-moz-available${i};${$4dd86a99225dce20$var$d(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${$4dd86a99225dce20$var$d(e)}:${r}fit-content`) + i) : String(t), $4dd86a99225dce20$var$b = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $4dd86a99225dce20$var$S = (e)=>e ? e + "-" : "", $4dd86a99225dce20$var$k = (e, t, r)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, n, i, o, l)=>"$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $4dd86a99225dce20$var$S(t) + (l.includes("$") ? "" : $4dd86a99225dce20$var$S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "")), $4dd86a99225dce20$var$y = /\s*,\s*(?![^()]*\))/, $4dd86a99225dce20$var$B = Object.prototype.toString, $4dd86a99225dce20$var$$ = (e, t, r, n, i)=>{
    let o, l, s;
    const a = (e, t, r)=>{
        let c, g;
        const p = (e)=>{
            for(c in e){
                const R = 64 === c.charCodeAt(0), z = R && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (g of z){
                    const e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof g && g && g.toString === $4dd86a99225dce20$var$B && (!n.utils[e] || !t.length);
                    if (e in n.utils && !z) {
                        const t = n.utils[e];
                        if (t !== l) {
                            l = t, p(t(g)), l = null;
                            continue;
                        }
                    } else if (e in $4dd86a99225dce20$var$u) {
                        const t = $4dd86a99225dce20$var$u[e];
                        if (t !== s) {
                            s = t, p(t(g)), s = null;
                            continue;
                        }
                    }
                    if (R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, r, n, i, o)=>{
                        const l = $4dd86a99225dce20$var$h.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            n,
                            t
                        ] : [
                            t,
                            n
                        ];
                        return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace($4dd86a99225dce20$var$h, (e, t, n)=>Number(t) + s * (">" === r ? 1 : -1) + n) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($4dd86a99225dce20$var$h, (e, t, r)=>Number(t) + s * (">" === i ? -1 : 1) + r) : o) : "") + ")";
                    })), z) {
                        const e = R ? r.concat(c) : [
                            ...r
                        ], n = R ? [
                            ...t
                        ] : $4dd86a99225dce20$var$f(t, c.split($4dd86a99225dce20$var$y));
                        void 0 !== o && i($4dd86a99225dce20$var$x(...o)), o = void 0, a(g, n, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        r
                    ]), c = R || 36 !== c.charCodeAt(0) ? c : `--${$4dd86a99225dce20$var$S(n.prefix)}${c.slice(1).replace(/\$/g, "-")}`, g = z ? g : "number" == typeof g ? g && e in $4dd86a99225dce20$var$I ? String(g) + "px" : String(g) : $4dd86a99225dce20$var$k($4dd86a99225dce20$var$m(e, null == g ? "" : g), n.prefix, n.themeMap[e]), o[0].push(`${R ? `${c} ` : `${$4dd86a99225dce20$var$d(c)}:`}${g}`);
                }
            }
            var b, $;
        };
        p(e), void 0 !== o && i($4dd86a99225dce20$var$x(...o)), o = void 0;
    };
    a(e, t, r);
}, $4dd86a99225dce20$var$x = (e, t, r)=>`${r.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, $4dd86a99225dce20$var$I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $4dd86a99225dce20$var$R = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $4dd86a99225dce20$var$z = (e)=>((e)=>{
        let t, r = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)r = $4dd86a99225dce20$var$R(t % 52) + r;
        return $4dd86a99225dce20$var$R(t % 52) + r;
    })(((e, t)=>{
        let r = t.length;
        for(; r;)e = 33 * e ^ t.charCodeAt(--r);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $4dd86a99225dce20$var$W = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $4dd86a99225dce20$var$j = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $4dd86a99225dce20$var$E = (e)=>{
    let t;
    const r = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (r, n)=>{
            const { cssText: i } = r;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
                if (!r.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === r) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return r.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, n = ()=>{
        if (t) {
            const { rules: e, sheet: r } = t;
            if (!r.deleteRule) {
                for(; 3 === Object(Object(r.cssRules)[0]).type;)r.cssRules.splice(0, 1);
                r.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($4dd86a99225dce20$var$j(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $4dd86a99225dce20$var$W[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: n,
                    rules: {},
                    toString: r
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: n,
                toString: r
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $4dd86a99225dce20$var$W.length - 1; e >= 0; --e){
            const t = $4dd86a99225dce20$var$W[e];
            if (!l[t]) {
                const r = $4dd86a99225dce20$var$W[e + 1], n = l[r] ? l[r].index : o.cssRules.length;
                o.insertRule("@media{}", n), o.insertRule(`--sxs{--sxs:${e}}`, n), l[t] = {
                    group: o.cssRules[n + 1],
                    index: n,
                    cache: new Set([
                        e
                    ])
                };
            }
            $4dd86a99225dce20$var$v(l[t]);
        }
    };
    return n(), t;
}, $4dd86a99225dce20$var$v = (e)=>{
    const t = e.group;
    let r = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, r), ++r;
        } catch (e) {}
    };
}, $4dd86a99225dce20$var$T = Symbol(), $4dd86a99225dce20$var$w = $4dd86a99225dce20$var$o(), $4dd86a99225dce20$var$M = (e, t)=>$4dd86a99225dce20$var$w(e, ()=>(...r)=>{
            let n = {
                type: null,
                composers: new Set
            };
            for (const t of r)if (null != t) {
                if (t[$4dd86a99225dce20$var$l]) {
                    null == n.type && (n.type = t[$4dd86a99225dce20$var$l].type);
                    for (const e of t[$4dd86a99225dce20$var$l].composers)n.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == n.type && (n.type = t) : n.composers.add($4dd86a99225dce20$var$C(t, e));
            }
            return null == n.type && (n.type = "span"), n.composers.size || n.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $4dd86a99225dce20$var$P(e, n, t);
        }), $4dd86a99225dce20$var$C = ({ variants: e, compoundVariants: t, defaultVariants: r, ...n }, i)=>{
    const o = `${$4dd86a99225dce20$var$S(i.prefix)}c-${$4dd86a99225dce20$var$z(n)}`, l = [], s = [], d = Object.create(null), g = [];
    for(const e in r)d[e] = String(r[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = d, u = t, $4dd86a99225dce20$var$c.call(p, u) || (d[t] = "undefined");
        const r = e[t];
        for(const e in r){
            const n = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = r[e], o = [
                n,
                i,
                !$4dd86a99225dce20$var$a(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...r } = e;
        t = "object" == typeof t && t || {};
        for(const e in r)r[e] = String(r[e]);
        const n = [
            r,
            t,
            !$4dd86a99225dce20$var$a(t)
        ];
        s.push(n);
    }
    return [
        o,
        n,
        l,
        s,
        d,
        g
    ];
}, $4dd86a99225dce20$var$P = (e, t, r)=>{
    const [n, i, o, a] = $4dd86a99225dce20$var$L(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let r = 0; r < t[$4dd86a99225dce20$var$T].length; r++){
                const [n, i] = t[$4dd86a99225dce20$var$T][r];
                e.rules[n].apply(i);
            }
            return t[$4dd86a99225dce20$var$T] = [], null;
        }
        return t[$4dd86a99225dce20$var$T] = [], t.rules = {}, $4dd86a99225dce20$var$W.forEach((e)=>t.rules[e] = {
                apply: (r)=>t[$4dd86a99225dce20$var$T].push([
                        e,
                        r
                    ])
            }), t;
    })(r) : null, d = (c || r).rules, g = `.${n}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (l)=>{
        l = "object" == typeof l && l || $4dd86a99225dce20$var$A;
        const { css: s, ...p } = l, u = {};
        for(const e in o)if (delete p[e], e in l) {
            let t = l[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || a.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [n, i, o, l] of t.composers){
            r.rules.styled.cache.has(n) || (r.rules.styled.cache.add(n), $4dd86a99225dce20$var$$(i, [
                `.${n}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $4dd86a99225dce20$var$O(o, u, e.media), s = $4dd86a99225dce20$var$O(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${n}-${$4dd86a99225dce20$var$z(o)}-${t}`;
                h.add(i);
                const s = (l ? r.rules.resonevar : r.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $4dd86a99225dce20$var$$(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${n}-${$4dd86a99225dce20$var$z(o)}-${i}`;
                h.add(t), r.rules.allvar.cache.has(t) || (r.rules.allvar.cache.add(t), $4dd86a99225dce20$var$$(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof s && s) {
            const t = `${n}-i${$4dd86a99225dce20$var$z(s)}-css`;
            h.add(t), r.rules.inline.cache.has(t) || (r.rules.inline.cache.add(t), $4dd86a99225dce20$var$$(s, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(l.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $4dd86a99225dce20$var$s(p, {
        className: n,
        selector: g,
        [$4dd86a99225dce20$var$l]: t,
        toString: ()=>(r.rules.styled.cache.has(n) || p(), n)
    });
}, $4dd86a99225dce20$var$L = (e)=>{
    let t = "";
    const r = [], n = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), r.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === n[e] || "undefined" !== t || s.includes(t)) && (n[e] = t);
        }
    }
    return [
        t,
        r,
        n,
        new Set(i)
    ];
}, $4dd86a99225dce20$var$O = (e, t, r, n)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const n = o[e];
            let i = t[e];
            if (i !== n) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (n === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in r ? r[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            n ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $4dd86a99225dce20$var$A = {}, $4dd86a99225dce20$var$N = $4dd86a99225dce20$var$o(), $4dd86a99225dce20$var$D = (e, t)=>$4dd86a99225dce20$var$N(e, ()=>(...r)=>{
            const n = ()=>{
                for (let n of r){
                    n = "object" == typeof n && n || {};
                    let r = $4dd86a99225dce20$var$z(n);
                    if (!t.rules.global.cache.has(r)) {
                        if (t.rules.global.cache.add(r), "@import" in n) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let r of [].concat(n["@import"]))r = r.includes('"') || r.includes("'") ? r : `"${r}"`, t.sheet.insertRule(`@import ${r};`, e++);
                            delete n["@import"];
                        }
                        $4dd86a99225dce20$var$$(n, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $4dd86a99225dce20$var$s(n, {
                toString: n
            });
        }), $4dd86a99225dce20$var$H = $4dd86a99225dce20$var$o(), $4dd86a99225dce20$var$V = (e, t)=>$4dd86a99225dce20$var$H(e, ()=>(r)=>{
            const n = `${$4dd86a99225dce20$var$S(e.prefix)}k-${$4dd86a99225dce20$var$z(r)}`, i = ()=>{
                if (!t.rules.global.cache.has(n)) {
                    t.rules.global.cache.add(n);
                    const i = [];
                    $4dd86a99225dce20$var$$(r, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${n}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return n;
            };
            return $4dd86a99225dce20$var$s(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $4dd86a99225dce20$var$G = class {
    constructor(e, t, r, n){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $4dd86a99225dce20$var$S(this.prefix) + $4dd86a99225dce20$var$S(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $4dd86a99225dce20$var$F = $4dd86a99225dce20$var$o(), $4dd86a99225dce20$var$J = (e, t)=>$4dd86a99225dce20$var$F(e, ()=>(r, n)=>{
            n = "object" == typeof r && r || Object(n);
            const i = `.${r = (r = "string" == typeof r ? r : "") || `${$4dd86a99225dce20$var$S(e.prefix)}t-${$4dd86a99225dce20$var$z(n)}`}`, o = {}, l = [];
            for(const t in n){
                o[t] = {};
                for(const r in n[t]){
                    const i = `--${$4dd86a99225dce20$var$S(e.prefix)}${t}-${r}`, s = $4dd86a99225dce20$var$k(String(n[t][r]), e.prefix, t);
                    o[t][r] = new $4dd86a99225dce20$var$G(r, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(r)) {
                    t.rules.themed.cache.add(r);
                    const i = `${n === e.theme ? ":root," : ""}.${r}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return r;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $4dd86a99225dce20$var$U = $4dd86a99225dce20$var$o();
var $4dd86a99225dce20$var$X, $4dd86a99225dce20$var$Y = $4dd86a99225dce20$var$o(), $4dd86a99225dce20$export$3c6706659c99b84e = (e)=>{
    const t = ((e)=>{
        let t = !1;
        const r = $4dd86a99225dce20$var$U(e, (e)=>{
            t = !0;
            const r = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", i = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
                prefix: r,
                media: i,
                theme: l,
                themeMap: "object" == typeof e.themeMap && e.themeMap || {
                    ...$4dd86a99225dce20$export$22deaee80f3d7c38
                },
                utils: "object" == typeof e.utils && e.utils || {}
            }, a = $4dd86a99225dce20$var$E(o), c = {
                css: $4dd86a99225dce20$var$M(s, a),
                globalCss: $4dd86a99225dce20$var$D(s, a),
                keyframes: $4dd86a99225dce20$var$V(s, a),
                createTheme: $4dd86a99225dce20$var$J(s, a),
                reset () {
                    a.reset(), c.theme.toString();
                },
                theme: {},
                sheet: a,
                config: s,
                prefix: r,
                getCssText: a.toString,
                toString: a.toString
            };
            return String(c.theme = c.createTheme(l)), c;
        });
        return t || r.reset(), r;
    })(e);
    return t.styled = (({ config: e, sheet: t })=>$4dd86a99225dce20$var$Y(e, ()=>{
            const r = $4dd86a99225dce20$var$M(e, t);
            return (...e)=>{
                const t = r(...e), n = t[$4dd86a99225dce20$var$l].type, i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((e, r)=>{
                    const i = e && e.as || n, { props: o, deferredInjector: l } = t(e);
                    return delete o.as, o.ref = r, l ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(i, o), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(l, null)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(i, o);
                });
                return i.className = t.className, i.displayName = `Styled.${n.displayName || n.name || n}`, i.selector = t.selector, i.toString = ()=>t.selector, i[$4dd86a99225dce20$var$l] = t[$4dd86a99225dce20$var$l], i;
            };
        }))(t), t;
}, $4dd86a99225dce20$var$K = ()=>$4dd86a99225dce20$var$X || ($4dd86a99225dce20$var$X = $4dd86a99225dce20$export$3c6706659c99b84e()), $4dd86a99225dce20$export$25d302a5b900a763 = (...e)=>$4dd86a99225dce20$var$K().createTheme(...e), $4dd86a99225dce20$export$db53682eef82cc11 = (...e)=>$4dd86a99225dce20$var$K().globalCss(...e), $4dd86a99225dce20$export$d25ddfdf17c3ad3e = (...e)=>$4dd86a99225dce20$var$K().keyframes(...e), $4dd86a99225dce20$export$dbf350e5966cf602 = (...e)=>$4dd86a99225dce20$var$K().css(...e), $4dd86a99225dce20$export$3817b7a54a07cec7 = (...e)=>$4dd86a99225dce20$var$K().styled(...e);
 //# sourceMappingUrl=index.map


function $fb3aa19ac7312631$var$clamp(v, min, max) {
    return Math.max(min, Math.min(v, max));
}
const $fb3aa19ac7312631$export$e7c866399fa523f5 = {
    toVector (v, fallback) {
        if (v === undefined) v = fallback;
        return Array.isArray(v) ? v : [
            v,
            v
        ];
    },
    add (v1, v2) {
        return [
            v1[0] + v2[0],
            v1[1] + v2[1]
        ];
    },
    sub (v1, v2) {
        return [
            v1[0] - v2[0],
            v1[1] - v2[1]
        ];
    },
    addTo (v1, v2) {
        v1[0] += v2[0];
        v1[1] += v2[1];
    },
    subTo (v1, v2) {
        v1[0] -= v2[0];
        v1[1] -= v2[1];
    }
};
function $fb3aa19ac7312631$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $fb3aa19ac7312631$export$43caf9889c228507(position, min, max, constant = 0.15) {
    if (constant === 0) return $fb3aa19ac7312631$var$clamp(position, min, max);
    if (position < min) return -$fb3aa19ac7312631$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$fb3aa19ac7312631$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $fb3aa19ac7312631$export$db3b6bfb95261072(bounds, [Vx, Vy], [Rx, Ry]) {
    const [[X0, X1], [Y0, Y1]] = bounds;
    return [
        $fb3aa19ac7312631$export$43caf9889c228507(Vx, X0, X1, Rx),
        $fb3aa19ac7312631$export$43caf9889c228507(Vy, Y0, Y1, Ry)
    ];
}


function $697141435cef9d98$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $697141435cef9d98$var$_toPropertyKey(arg) {
    var key = $697141435cef9d98$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $697141435cef9d98$export$407448d2b89b1813(obj, key, value) {
    key = $697141435cef9d98$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $697141435cef9d98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $697141435cef9d98$export$71511d61b312f219(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $697141435cef9d98$var$ownKeys(Object(t), !0).forEach(function(r) {
            $697141435cef9d98$export$407448d2b89b1813(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $697141435cef9d98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $697141435cef9d98$var$EVENT_TYPE_MAP = {
    pointer: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    mouse: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    touch: {
        start: 'start',
        change: 'move',
        end: 'end'
    },
    gesture: {
        start: 'start',
        change: 'change',
        end: 'end'
    }
};
function $697141435cef9d98$var$capitalize(string) {
    if (!string) return '';
    return string[0].toUpperCase() + string.slice(1);
}
const $697141435cef9d98$var$actionsWithoutCaptureSupported = [
    'enter',
    'leave'
];
function $697141435cef9d98$var$hasCapture(capture = false, actionKey) {
    return capture && !$697141435cef9d98$var$actionsWithoutCaptureSupported.includes(actionKey);
}
function $697141435cef9d98$export$4368d992c4eafac0(device, action = '', capture = false) {
    const deviceProps = $697141435cef9d98$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return 'on' + $697141435cef9d98$var$capitalize(device) + $697141435cef9d98$var$capitalize(actionKey) + ($697141435cef9d98$var$hasCapture(capture, actionKey) ? 'Capture' : '');
}
const $697141435cef9d98$var$pointerCaptureEvents = [
    'gotpointercapture',
    'lostpointercapture'
];
function $697141435cef9d98$export$ffb5f4729a158638(prop) {
    let eventKey = prop.substring(2).toLowerCase();
    const passive = !!~eventKey.indexOf('passive');
    if (passive) eventKey = eventKey.replace('passive', '');
    const captureKey = $697141435cef9d98$var$pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
    const capture = !!~eventKey.indexOf(captureKey);
    if (capture) eventKey = eventKey.replace('capture', '');
    return {
        device: eventKey,
        capture: capture,
        passive: passive
    };
}
function $697141435cef9d98$export$625550452a3fa3ec(device, action = '') {
    const deviceProps = $697141435cef9d98$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return device + actionKey;
}
function $697141435cef9d98$export$23f2a1d2818174ef(event) {
    return 'touches' in event;
}
function $697141435cef9d98$var$getPointerType(event) {
    if ($697141435cef9d98$export$23f2a1d2818174ef(event)) return 'touch';
    if ('pointerType' in event) return event.pointerType;
    return 'mouse';
}
function $697141435cef9d98$var$getCurrentTargetTouchList(event) {
    return Array.from(event.touches).filter((e)=>{
        var _event$currentTarget, _event$currentTarget$;
        return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
    });
}
function $697141435cef9d98$var$getTouchList(event) {
    return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}
function $697141435cef9d98$var$getValueEvent(event) {
    return $697141435cef9d98$export$23f2a1d2818174ef(event) ? $697141435cef9d98$var$getTouchList(event)[0] : event;
}
function $697141435cef9d98$var$distanceAngle(P1, P2) {
    try {
        const dx = P2.clientX - P1.clientX;
        const dy = P2.clientY - P1.clientY;
        const cx = (P2.clientX + P1.clientX) / 2;
        const cy = (P2.clientY + P1.clientY) / 2;
        const distance = Math.hypot(dx, dy);
        const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
        const origin = [
            cx,
            cy
        ];
        return {
            angle: angle,
            distance: distance,
            origin: origin
        };
    } catch (_unused) {}
    return null;
}
function $697141435cef9d98$export$8b22cf2602fb60ce(event) {
    return $697141435cef9d98$var$getCurrentTargetTouchList(event).map((touch)=>touch.identifier);
}
function $697141435cef9d98$var$touchDistanceAngle(event, ids) {
    const [P1, P2] = Array.from(event.touches).filter((touch)=>ids.includes(touch.identifier));
    return $697141435cef9d98$var$distanceAngle(P1, P2);
}
function $697141435cef9d98$var$pointerId(event) {
    const valueEvent = $697141435cef9d98$var$getValueEvent(event);
    return $697141435cef9d98$export$23f2a1d2818174ef(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function $697141435cef9d98$var$pointerValues(event) {
    const valueEvent = $697141435cef9d98$var$getValueEvent(event);
    return [
        valueEvent.clientX,
        valueEvent.clientY
    ];
}
const $697141435cef9d98$var$LINE_HEIGHT = 40;
const $697141435cef9d98$var$PAGE_HEIGHT = 800;
function $697141435cef9d98$var$wheelValues(event) {
    let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
    if (deltaMode === 1) {
        deltaX *= $697141435cef9d98$var$LINE_HEIGHT;
        deltaY *= $697141435cef9d98$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $697141435cef9d98$var$PAGE_HEIGHT;
        deltaY *= $697141435cef9d98$var$PAGE_HEIGHT;
    }
    return [
        deltaX,
        deltaY
    ];
}
function $697141435cef9d98$var$scrollValues(event) {
    var _ref, _ref2;
    const { scrollX: scrollX, scrollY: scrollY, scrollLeft: scrollLeft, scrollTop: scrollTop } = event.currentTarget;
    return [
        (_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0,
        (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0
    ];
}
function $697141435cef9d98$var$getEventDetails(event) {
    const payload = {};
    if ('buttons' in event) payload.buttons = event.buttons;
    if ('shiftKey' in event) {
        const { shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, ctrlKey: ctrlKey } = event;
        Object.assign(payload, {
            shiftKey: shiftKey,
            altKey: altKey,
            metaKey: metaKey,
            ctrlKey: ctrlKey
        });
    }
    return payload;
}
function $697141435cef9d98$var$call(v, ...args) {
    if (typeof v === 'function') return v(...args);
    else return v;
}
function $697141435cef9d98$var$noop() {}
function $697141435cef9d98$export$db3b6bfb95261072(...fns) {
    if (fns.length === 0) return $697141435cef9d98$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        let result;
        for (const fn of fns)result = fn.apply(this, arguments) || result;
        return result;
    };
}
function $697141435cef9d98$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
const $697141435cef9d98$var$BEFORE_LAST_KINEMATICS_DELAY = 32;
class $697141435cef9d98$var$Engine {
    constructor(ctrl, args, key){
        this.ctrl = ctrl;
        this.args = args;
        this.key = key;
        if (!this.state) {
            this.state = {};
            this.computeValues([
                0,
                0
            ]);
            this.computeInitial();
            if (this.init) this.init();
            this.reset();
        }
    }
    get state() {
        return this.ctrl.state[this.key];
    }
    set state(state) {
        this.ctrl.state[this.key] = state;
    }
    get shared() {
        return this.ctrl.state.shared;
    }
    get eventStore() {
        return this.ctrl.gestureEventStores[this.key];
    }
    get timeoutStore() {
        return this.ctrl.gestureTimeoutStores[this.key];
    }
    get config() {
        return this.ctrl.config[this.key];
    }
    get sharedConfig() {
        return this.ctrl.config.shared;
    }
    get handler() {
        return this.ctrl.handlers[this.key];
    }
    reset() {
        const { state: state, shared: shared, ingKey: ingKey, args: args } = this;
        shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
        state._step = [
            false,
            false
        ];
        state.intentional = false;
        state._movement = [
            0,
            0
        ];
        state._distance = [
            0,
            0
        ];
        state._direction = [
            0,
            0
        ];
        state._delta = [
            0,
            0
        ];
        state._bounds = [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ];
        state.args = args;
        state.axis = undefined;
        state.memo = undefined;
        state.elapsedTime = state.timeDelta = 0;
        state.direction = [
            0,
            0
        ];
        state.distance = [
            0,
            0
        ];
        state.overflow = [
            0,
            0
        ];
        state._movementBound = [
            false,
            false
        ];
        state.velocity = [
            0,
            0
        ];
        state.movement = [
            0,
            0
        ];
        state.delta = [
            0,
            0
        ];
        state.timeStamp = 0;
    }
    start(event) {
        const state = this.state;
        const config = this.config;
        if (!state._active) {
            this.reset();
            this.computeInitial();
            state._active = true;
            state.target = event.target;
            state.currentTarget = event.currentTarget;
            state.lastOffset = config.from ? $697141435cef9d98$var$call(config.from, state) : state.offset;
            state.offset = state.lastOffset;
            state.startTime = state.timeStamp = event.timeStamp;
        }
    }
    computeValues(values) {
        const state = this.state;
        state._values = values;
        state.values = this.config.transform(values);
    }
    computeInitial() {
        const state = this.state;
        state._initial = state._values;
        state.initial = state.values;
    }
    compute(event) {
        const { state: state, config: config, shared: shared } = this;
        state.args = this.args;
        let dt = 0;
        if (event) {
            state.event = event;
            if (config.preventDefault && event.cancelable) state.event.preventDefault();
            state.type = event.type;
            shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
            shared.locked = !!document.pointerLockElement;
            Object.assign(shared, $697141435cef9d98$var$getEventDetails(event));
            shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
            dt = event.timeStamp - state.timeStamp;
            state.timeStamp = event.timeStamp;
            state.elapsedTime = state.timeStamp - state.startTime;
        }
        if (state._active) {
            const _absoluteDelta = state._delta.map(Math.abs);
            (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._distance, _absoluteDelta);
        }
        if (this.axisIntent) this.axisIntent(event);
        const [_m0, _m1] = state._movement;
        const [t0, t1] = config.threshold;
        const { _step: _step, values: values } = state;
        if (config.hasCustomTransform) {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
        } else {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
        }
        state.intentional = _step[0] !== false || _step[1] !== false;
        if (!state.intentional) return;
        const movement = [
            0,
            0
        ];
        if (config.hasCustomTransform) {
            const [v0, v1] = values;
            movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
        } else {
            movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
        }
        if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
        const previousOffset = state.offset;
        const gestureIsActive = state._active && !state._blocked || state.active;
        if (gestureIsActive) {
            state.first = state._active && !state.active;
            state.last = !state._active && state.active;
            state.active = shared[this.ingKey] = state._active;
            if (event) {
                if (state.first) {
                    if ('bounds' in config) state._bounds = $697141435cef9d98$var$call(config.bounds, state);
                    if (this.setup) this.setup();
                }
                state.movement = movement;
                this.computeOffset();
            }
        }
        const [ox, oy] = state.offset;
        const [[x0, x1], [y0, y1]] = state._bounds;
        state.overflow = [
            ox < x0 ? -1 : ox > x1 ? 1 : 0,
            oy < y0 ? -1 : oy > y1 ? 1 : 0
        ];
        state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
        state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
        const rubberband = state._active ? config.rubberband || [
            0,
            0
        ] : [
            0,
            0
        ];
        state.offset = (0, $fb3aa19ac7312631$export$db3b6bfb95261072)(state._bounds, state.offset, rubberband);
        state.delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(state.offset, previousOffset);
        this.computeMovement();
        if (gestureIsActive && (!state.last || dt > $697141435cef9d98$var$BEFORE_LAST_KINEMATICS_DELAY)) {
            state.delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(state.offset, previousOffset);
            const absoluteDelta = state.delta.map(Math.abs);
            (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);
            if (!state.first && dt > 0) {
                state.velocity = [
                    absoluteDelta[0] / dt,
                    absoluteDelta[1] / dt
                ];
                state.timeDelta = dt;
            }
        }
    }
    emit() {
        const state = this.state;
        const shared = this.shared;
        const config = this.config;
        if (!state._active) this.clean();
        if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
        const memo = this.handler($697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, shared), state), {}, {
            [this.aliasKey]: state.values
        }));
        if (memo !== undefined) state.memo = memo;
    }
    clean() {
        this.eventStore.clean();
        this.timeoutStore.clean();
    }
}
function $697141435cef9d98$var$selectAxis([dx, dy], threshold) {
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);
    if (absDx > absDy && absDx > threshold) return 'x';
    if (absDy > absDx && absDy > threshold) return 'y';
    return undefined;
}
class $697141435cef9d98$var$CoordinatesEngine extends $697141435cef9d98$var$Engine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "aliasKey", 'xy');
    }
    reset() {
        super.reset();
        this.state.axis = undefined;
    }
    init() {
        this.state.offset = [
            0,
            0
        ];
        this.state.lastOffset = [
            0,
            0
        ];
    }
    computeOffset() {
        this.state.offset = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).add(this.state.lastOffset, this.state.movement);
    }
    computeMovement() {
        this.state.movement = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(this.state.offset, this.state.lastOffset);
    }
    axisIntent(event) {
        const state = this.state;
        const config = this.config;
        if (!state.axis && event) {
            const threshold = typeof config.axisThreshold === 'object' ? config.axisThreshold[$697141435cef9d98$var$getPointerType(event)] : config.axisThreshold;
            state.axis = $697141435cef9d98$var$selectAxis(state._movement, threshold);
        }
        state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
    restrictToAxis(v) {
        if (this.config.axis || this.config.lockDirection) switch(this.state.axis){
            case 'x':
                v[1] = 0;
                break;
            case 'y':
                v[0] = 0;
                break;
        }
    }
}
const $697141435cef9d98$var$identity = (v)=>v;
const $697141435cef9d98$var$DEFAULT_RUBBERBAND = 0.15;
const $697141435cef9d98$var$commonConfigResolver = {
    enabled (value = true) {
        return value;
    },
    eventOptions (value, _k, config) {
        return $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, config.shared.eventOptions), value);
    },
    preventDefault (value = false) {
        return value;
    },
    triggerAllEvents (value = false) {
        return value;
    },
    rubberband (value = 0) {
        switch(value){
            case true:
                return [
                    $697141435cef9d98$var$DEFAULT_RUBBERBAND,
                    $697141435cef9d98$var$DEFAULT_RUBBERBAND
                ];
            case false:
                return [
                    0,
                    0
                ];
            default:
                return (0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(value);
        }
    },
    from (value) {
        if (typeof value === 'function') return value;
        if (value != null) return (0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(value);
    },
    transform (value, _k, config) {
        const transform = value || config.shared.transform;
        this.hasCustomTransform = !!transform;
        var v;
        return transform || $697141435cef9d98$var$identity;
    },
    threshold (value) {
        return (0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(value, 0);
    }
};
var $697141435cef9d98$var$value, $697141435cef9d98$var$value1, $697141435cef9d98$var$value2;
const $697141435cef9d98$var$DEFAULT_AXIS_THRESHOLD = 0;
const $697141435cef9d98$var$coordinatesConfigResolver = $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, $697141435cef9d98$var$commonConfigResolver), {}, {
    axis (_v, _k, { axis: axis }) {
        this.lockDirection = axis === 'lock';
        if (!this.lockDirection) return axis;
    },
    axisThreshold (value = $697141435cef9d98$var$DEFAULT_AXIS_THRESHOLD) {
        return value;
    },
    bounds (value = {}) {
        if (typeof value === 'function') return (state)=>$697141435cef9d98$var$coordinatesConfigResolver.bounds(value(state));
        if ('current' in value) return ()=>value.current;
        if (typeof HTMLElement === 'function' && value instanceof HTMLElement) return value;
        const { left: left = -Infinity, right: right = Infinity, top: top = -Infinity, bottom: bottom = Infinity } = value;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
const $697141435cef9d98$var$KEYS_DELTA_MAP = {
    ArrowRight: (displacement, factor = 1)=>[
            displacement * factor,
            0
        ],
    ArrowLeft: (displacement, factor = 1)=>[
            -1 * displacement * factor,
            0
        ],
    ArrowUp: (displacement, factor = 1)=>[
            0,
            -1 * displacement * factor
        ],
    ArrowDown: (displacement, factor = 1)=>[
            0,
            displacement * factor
        ]
};
class $697141435cef9d98$var$DragEngine extends $697141435cef9d98$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "ingKey", 'dragging');
    }
    reset() {
        super.reset();
        const state = this.state;
        state._pointerId = undefined;
        state._pointerActive = false;
        state._keyboardActive = false;
        state._preventScroll = false;
        state._delayed = false;
        state.swipe = [
            0,
            0
        ];
        state.tap = false;
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
    }
    setup() {
        const state = this.state;
        if (state._bounds instanceof HTMLElement) {
            const boundRect = state._bounds.getBoundingClientRect();
            const targetRect = state.currentTarget.getBoundingClientRect();
            const _bounds = {
                left: boundRect.left - targetRect.left + state.offset[0],
                right: boundRect.right - targetRect.right + state.offset[0],
                top: boundRect.top - targetRect.top + state.offset[1],
                bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
            };
            state._bounds = $697141435cef9d98$var$coordinatesConfigResolver.bounds(_bounds);
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        state.canceled = true;
        state._active = false;
        setTimeout(()=>{
            this.compute();
            this.emit();
        }, 0);
    }
    setActive() {
        this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
    clean() {
        this.pointerClean();
        this.state._pointerActive = false;
        this.state._keyboardActive = false;
        super.clean();
    }
    pointerDown(event) {
        const config = this.config;
        const state = this.state;
        if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
        const ctrlIds = this.ctrl.setEventIds(event);
        if (config.pointerCapture) event.target.setPointerCapture(event.pointerId);
        if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
        this.start(event);
        this.setupPointer(event);
        state._pointerId = $697141435cef9d98$var$pointerId(event);
        state._pointerActive = true;
        this.computeValues($697141435cef9d98$var$pointerValues(event));
        this.computeInitial();
        if (config.preventScrollAxis && $697141435cef9d98$var$getPointerType(event) !== 'mouse') {
            state._active = false;
            this.setupScrollPrevention(event);
        } else if (config.delay > 0) {
            this.setupDelayTrigger(event);
            if (config.triggerAllEvents) {
                this.compute(event);
                this.emit();
            }
        } else this.startPointerDrag(event);
    }
    startPointerDrag(event) {
        const state = this.state;
        state._active = true;
        state._preventScroll = true;
        state._delayed = false;
        this.compute(event);
        this.emit();
    }
    pointerMove(event) {
        const state = this.state;
        const config = this.config;
        if (!state._pointerActive) return;
        const id = $697141435cef9d98$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        const _values = $697141435cef9d98$var$pointerValues(event);
        if (document.pointerLockElement === event.target) state._delta = [
            event.movementX,
            event.movementY
        ];
        else {
            state._delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(_values, state._values);
            this.computeValues(_values);
        }
        (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.compute(event);
        if (state._delayed && state.intentional) {
            this.timeoutStore.remove('dragDelay');
            state.active = false;
            this.startPointerDrag(event);
            return;
        }
        if (config.preventScrollAxis && !state._preventScroll) {
            if (state.axis) {
                if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
                    state._active = false;
                    this.clean();
                    return;
                } else {
                    this.timeoutStore.remove('startPointerDrag');
                    this.startPointerDrag(event);
                    return;
                }
            } else return;
        }
        this.emit();
    }
    pointerUp(event) {
        this.ctrl.setEventIds(event);
        try {
            if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        const state = this.state;
        const config = this.config;
        if (!state._active || !state._pointerActive) return;
        const id = $697141435cef9d98$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        this.state._pointerActive = false;
        this.setActive();
        this.compute(event);
        const [dx, dy] = state._distance;
        state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
        if (state.tap && config.filterTaps) state._force = true;
        else {
            const [_dx, _dy] = state._delta;
            const [_mx, _my] = state._movement;
            const [svx, svy] = config.swipe.velocity;
            const [sx, sy] = config.swipe.distance;
            const sdt = config.swipe.duration;
            if (state.elapsedTime < sdt) {
                const _vx = Math.abs(_dx / state.timeDelta);
                const _vy = Math.abs(_dy / state.timeDelta);
                if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
                if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
            }
        }
        this.emit();
    }
    pointerClick(event) {
        if (!this.state.tap && event.detail > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    setupPointer(event) {
        const config = this.config;
        const device = config.device;
        var _unused2;
        if (config.pointerLock) event.currentTarget.requestPointerLock();
        if (!config.pointerCapture) {
            this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
        }
    }
    pointerClean() {
        if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) document.exitPointerLock();
    }
    preventScroll(event) {
        if (this.state._preventScroll && event.cancelable) event.preventDefault();
    }
    setupScrollPrevention(event) {
        this.state._preventScroll = false;
        $697141435cef9d98$var$persistEvent(event);
        const remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
            passive: false
        });
        this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
        this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
        this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
    setupDelayTrigger(event) {
        this.state._delayed = true;
        this.timeoutStore.add('dragDelay', ()=>{
            this.state._step = [
                0,
                0
            ];
            this.startPointerDrag(event);
        }, this.config.delay);
    }
    keyDown(event) {
        const deltaFn = $697141435cef9d98$var$KEYS_DELTA_MAP[event.key];
        if (deltaFn) {
            const state = this.state;
            const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
            this.start(event);
            state._delta = deltaFn(this.config.keyboardDisplacement, factor);
            state._keyboardActive = true;
            (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._movement, state._delta);
            this.compute(event);
            this.emit();
        }
    }
    keyUp(event) {
        if (!(event.key in $697141435cef9d98$var$KEYS_DELTA_MAP)) return;
        this.state._keyboardActive = false;
        this.setActive();
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        bindFunction(device, 'start', this.pointerDown.bind(this));
        if (this.config.pointerCapture) {
            bindFunction(device, 'change', this.pointerMove.bind(this));
            bindFunction(device, 'end', this.pointerUp.bind(this));
            bindFunction(device, 'cancel', this.pointerUp.bind(this));
            bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
        }
        if (this.config.keys) {
            bindFunction('key', 'down', this.keyDown.bind(this));
            bindFunction('key', 'up', this.keyUp.bind(this));
        }
        if (this.config.filterTaps) bindFunction('click', '', this.pointerClick.bind(this), {
            capture: true,
            passive: false
        });
    }
}
function $697141435cef9d98$var$persistEvent(event) {
    'persist' in event && typeof event.persist === 'function' && event.persist();
}
const $697141435cef9d98$var$isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
function $697141435cef9d98$var$supportsTouchEvents() {
    return $697141435cef9d98$var$isBrowser && 'ontouchstart' in window;
}
function $697141435cef9d98$var$isTouchScreen() {
    return $697141435cef9d98$var$supportsTouchEvents() || $697141435cef9d98$var$isBrowser && window.navigator.maxTouchPoints > 1;
}
function $697141435cef9d98$var$supportsPointerEvents() {
    return $697141435cef9d98$var$isBrowser && 'onpointerdown' in window;
}
function $697141435cef9d98$var$supportsPointerLock() {
    return $697141435cef9d98$var$isBrowser && 'exitPointerLock' in window.document;
}
function $697141435cef9d98$var$supportsGestureEvents() {
    try {
        return 'constructor' in GestureEvent;
    } catch (e) {
        return false;
    }
}
const $697141435cef9d98$export$25ce5a424b770e84 = {
    isBrowser: $697141435cef9d98$var$isBrowser,
    gesture: $697141435cef9d98$var$supportsGestureEvents(),
    touch: $697141435cef9d98$var$supportsTouchEvents(),
    touchscreen: $697141435cef9d98$var$isTouchScreen(),
    pointer: $697141435cef9d98$var$supportsPointerEvents(),
    pointerLock: $697141435cef9d98$var$supportsPointerLock()
};
const $697141435cef9d98$var$DEFAULT_PREVENT_SCROLL_DELAY = 250;
const $697141435cef9d98$var$DEFAULT_DRAG_DELAY = 180;
const $697141435cef9d98$var$DEFAULT_SWIPE_VELOCITY = 0.5;
const $697141435cef9d98$var$DEFAULT_SWIPE_DISTANCE = 50;
const $697141435cef9d98$var$DEFAULT_SWIPE_DURATION = 250;
const $697141435cef9d98$var$DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const $697141435cef9d98$var$DEFAULT_DRAG_AXIS_THRESHOLD = {
    mouse: 0,
    touch: 0,
    pen: 8
};
const $697141435cef9d98$var$dragConfigResolver = $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, $697141435cef9d98$var$coordinatesConfigResolver), {}, {
    device (_v, _k, { pointer: { touch: touch = false, lock: lock = false, mouse: mouse = false } = {} }) {
        this.pointerLock = lock && $697141435cef9d98$export$25ce5a424b770e84.pointerLock;
        if ($697141435cef9d98$export$25ce5a424b770e84.touch && touch) return 'touch';
        if (this.pointerLock) return 'mouse';
        if ($697141435cef9d98$export$25ce5a424b770e84.pointer && !mouse) return 'pointer';
        if ($697141435cef9d98$export$25ce5a424b770e84.touch) return 'touch';
        return 'mouse';
    },
    preventScrollAxis (value, _k, { preventScroll: preventScroll }) {
        this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? $697141435cef9d98$var$DEFAULT_PREVENT_SCROLL_DELAY : undefined;
        if (!$697141435cef9d98$export$25ce5a424b770e84.touchscreen || preventScroll === false) return undefined;
        return value ? value : preventScroll !== undefined ? 'y' : undefined;
    },
    pointerCapture (_v, _k, { pointer: { capture: capture = true, buttons: buttons = 1, keys: keys = true } = {} }) {
        this.pointerButtons = buttons;
        this.keys = keys;
        return !this.pointerLock && this.device === 'pointer' && capture;
    },
    threshold (value, _k, { filterTaps: filterTaps = false, tapsThreshold: tapsThreshold = 3, axis: axis }) {
        const threshold = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        this.tapsThreshold = tapsThreshold;
        return threshold;
    },
    swipe ({ velocity: velocity = $697141435cef9d98$var$DEFAULT_SWIPE_VELOCITY, distance: distance = $697141435cef9d98$var$DEFAULT_SWIPE_DISTANCE, duration: duration = $697141435cef9d98$var$DEFAULT_SWIPE_DURATION } = {}) {
        return {
            velocity: this.transform((0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(velocity)),
            distance: this.transform((0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(distance)),
            duration: duration
        };
    },
    delay (value = 0) {
        switch(value){
            case true:
                return $697141435cef9d98$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    },
    axisThreshold (value) {
        if (!value) return $697141435cef9d98$var$DEFAULT_DRAG_AXIS_THRESHOLD;
        return $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, $697141435cef9d98$var$DEFAULT_DRAG_AXIS_THRESHOLD), value);
    },
    keyboardDisplacement (value = $697141435cef9d98$var$DEFAULT_KEYBOARD_DISPLACEMENT) {
        return value;
    }
});
var $697141435cef9d98$var$value3, $697141435cef9d98$var$value4, $697141435cef9d98$var$value5, $697141435cef9d98$var$value6, $697141435cef9d98$var$value7;
function $697141435cef9d98$var$clampStateInternalMovementToBounds(state) {
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;
    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) state._movement[0] = state._movementBound[0];
    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) state._movement[1] = state._movementBound[1];
}
const $697141435cef9d98$var$SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const $697141435cef9d98$var$PINCH_WHEEL_RATIO = 100;
class $697141435cef9d98$var$PinchEngine extends $697141435cef9d98$var$Engine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "ingKey", 'pinching');
        $697141435cef9d98$export$407448d2b89b1813(this, "aliasKey", 'da');
    }
    init() {
        this.state.offset = [
            1,
            0
        ];
        this.state.lastOffset = [
            1,
            0
        ];
        this.state._pointerEvents = new Map();
    }
    reset() {
        super.reset();
        const state = this.state;
        state._touchIds = [];
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
        state.turns = 0;
    }
    computeOffset() {
        const { type: type, movement: movement, lastOffset: lastOffset } = this.state;
        if (type === 'wheel') this.state.offset = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).add(movement, lastOffset);
        else this.state.offset = [
            (1 + movement[0]) * lastOffset[0],
            movement[1] + lastOffset[1]
        ];
    }
    computeMovement() {
        const { offset: offset, lastOffset: lastOffset } = this.state;
        this.state.movement = [
            offset[0] / lastOffset[0],
            offset[1] - lastOffset[1]
        ];
    }
    axisIntent() {
        const state = this.state;
        const [_m0, _m1] = state._movement;
        if (!state.axis) {
            const axisMovementDifference = Math.abs(_m0) * $697141435cef9d98$var$SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
            if (axisMovementDifference < 0) state.axis = 'angle';
            else if (axisMovementDifference > 0) state.axis = 'scale';
        }
    }
    restrictToAxis(v) {
        if (this.config.lockDirection) {
            if (this.state.axis === 'scale') v[1] = 0;
            else if (this.state.axis === 'angle') v[0] = 0;
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        setTimeout(()=>{
            state.canceled = true;
            state._active = false;
            this.compute();
            this.emit();
        }, 0);
    }
    touchStart(event) {
        this.ctrl.setEventIds(event);
        const state = this.state;
        const ctrlTouchIds = this.ctrl.touchIds;
        if (state._active) {
            if (state._touchIds.every((id)=>ctrlTouchIds.has(id))) return;
        }
        if (ctrlTouchIds.size < 2) return;
        this.start(event);
        state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
        const payload = $697141435cef9d98$var$touchDistanceAngle(event, state._touchIds);
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pointerStart(event) {
        if (event.buttons != null && event.buttons % 2 !== 1) return;
        this.ctrl.setEventIds(event);
        event.target.setPointerCapture(event.pointerId);
        const state = this.state;
        const _pointerEvents = state._pointerEvents;
        const ctrlPointerIds = this.ctrl.pointerIds;
        if (state._active) {
            if (Array.from(_pointerEvents.keys()).every((id)=>ctrlPointerIds.has(id))) return;
        }
        if (_pointerEvents.size < 2) _pointerEvents.set(event.pointerId, event);
        if (state._pointerEvents.size < 2) return;
        this.start(event);
        const payload = $697141435cef9d98$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pinchStart(event, payload) {
        const state = this.state;
        state.origin = payload.origin;
        this.computeValues([
            payload.distance,
            payload.angle
        ]);
        this.computeInitial();
        this.compute(event);
        this.emit();
    }
    touchMove(event) {
        if (!this.state._active) return;
        const payload = $697141435cef9d98$var$touchDistanceAngle(event, this.state._touchIds);
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pointerMove(event) {
        const _pointerEvents = this.state._pointerEvents;
        if (_pointerEvents.has(event.pointerId)) _pointerEvents.set(event.pointerId, event);
        if (!this.state._active) return;
        const payload = $697141435cef9d98$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pinchMove(event, payload) {
        const state = this.state;
        const prev_a = state._values[1];
        const delta_a = payload.angle - prev_a;
        let delta_turns = 0;
        if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
        this.computeValues([
            payload.distance,
            payload.angle - 360 * delta_turns
        ]);
        state.origin = payload.origin;
        state.turns = delta_turns;
        state._movement = [
            state._values[0] / state._initial[0] - 1,
            state._values[1] - state._initial[1]
        ];
        this.compute(event);
        this.emit();
    }
    touchEnd(event) {
        this.ctrl.setEventIds(event);
        if (!this.state._active) return;
        if (this.state._touchIds.some((id)=>!this.ctrl.touchIds.has(id))) {
            this.state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    pointerEnd(event) {
        const state = this.state;
        this.ctrl.setEventIds(event);
        try {
            event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        if (state._pointerEvents.has(event.pointerId)) state._pointerEvents.delete(event.pointerId);
        if (!state._active) return;
        if (state._pointerEvents.size < 2) {
            state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    gestureStart(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        if (state._active) return;
        this.start(event);
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    gestureMove(event) {
        if (event.cancelable) event.preventDefault();
        if (!this.state._active) return;
        const state = this.state;
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        const _previousMovement = state._movement;
        state._movement = [
            event.scale - 1,
            event.rotation
        ];
        state._delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(state._movement, _previousMovement);
        this.compute(event);
        this.emit();
    }
    gestureEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    wheel(event) {
        const modifierKey = this.config.modifierKey;
        if (modifierKey && (Array.isArray(modifierKey) ? !modifierKey.find((k)=>event[k]) : !event[modifierKey])) return;
        if (!this.state._active) this.wheelStart(event);
        else this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelStart(event) {
        this.start(event);
        this.wheelChange(event);
    }
    wheelChange(event) {
        const isR3f = 'uv' in event;
        if (!isR3f) {
            if (event.cancelable) event.preventDefault();
        }
        const state = this.state;
        state._delta = [
            -$697141435cef9d98$var$wheelValues(event)[1] / $697141435cef9d98$var$PINCH_WHEEL_RATIO * state.offset[0],
            0
        ];
        (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $697141435cef9d98$var$clampStateInternalMovementToBounds(state);
        this.state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        if (!!device) {
            bindFunction(device, 'start', this[device + 'Start'].bind(this));
            bindFunction(device, 'change', this[device + 'Move'].bind(this));
            bindFunction(device, 'end', this[device + 'End'].bind(this));
            bindFunction(device, 'cancel', this[device + 'End'].bind(this));
            bindFunction('lostPointerCapture', '', this[device + 'End'].bind(this));
        }
        if (this.config.pinchOnWheel) bindFunction('wheel', '', this.wheel.bind(this), {
            passive: false
        });
    }
}
const $697141435cef9d98$var$pinchConfigResolver = $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, $697141435cef9d98$var$commonConfigResolver), {}, {
    device (_v, _k, { shared: shared, pointer: { touch: touch = false } = {} }) {
        const sharedConfig = shared;
        if (sharedConfig.target && !$697141435cef9d98$export$25ce5a424b770e84.touch && $697141435cef9d98$export$25ce5a424b770e84.gesture) return 'gesture';
        if ($697141435cef9d98$export$25ce5a424b770e84.touch && touch) return 'touch';
        if ($697141435cef9d98$export$25ce5a424b770e84.touchscreen) {
            if ($697141435cef9d98$export$25ce5a424b770e84.pointer) return 'pointer';
            if ($697141435cef9d98$export$25ce5a424b770e84.touch) return 'touch';
        }
    },
    bounds (_v, _k, { scaleBounds: scaleBounds = {}, angleBounds: angleBounds = {} }) {
        const _scaleBounds = (state)=>{
            const D = $697141435cef9d98$var$assignDefault($697141435cef9d98$var$call(scaleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        const _angleBounds = (state)=>{
            const A = $697141435cef9d98$var$assignDefault($697141435cef9d98$var$call(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [
            _scaleBounds(),
            _angleBounds()
        ];
        return (state)=>[
                _scaleBounds(state),
                _angleBounds(state)
            ];
    },
    threshold (value, _k, config) {
        this.lockDirection = config.axis === 'lock';
        const threshold = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).toVector(value, this.lockDirection ? [
            0.1,
            3
        ] : 0);
        return threshold;
    },
    modifierKey (value) {
        if (value === undefined) return 'ctrlKey';
        return value;
    },
    pinchOnWheel (value = true) {
        return value;
    }
});
class $697141435cef9d98$var$MoveEngine extends $697141435cef9d98$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "ingKey", 'moving');
    }
    move(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        if (!this.state._active) this.moveStart(event);
        else this.moveChange(event);
        this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
    }
    moveStart(event) {
        this.start(event);
        this.computeValues($697141435cef9d98$var$pointerValues(event));
        this.compute(event);
        this.computeInitial();
        this.emit();
    }
    moveChange(event) {
        if (!this.state._active) return;
        const values = $697141435cef9d98$var$pointerValues(event);
        const state = this.state;
        state._delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(values, state._values);
        (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    moveEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'change', this.move.bind(this));
        bindFunction('pointer', 'leave', this.moveEnd.bind(this));
    }
}
const $697141435cef9d98$var$moveConfigResolver = $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, $697141435cef9d98$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
class $697141435cef9d98$var$ScrollEngine extends $697141435cef9d98$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "ingKey", 'scrolling');
    }
    scroll(event) {
        if (!this.state._active) this.start(event);
        this.scrollChange(event);
        this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
    }
    scrollChange(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        const values = $697141435cef9d98$var$scrollValues(event);
        state._delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(values, state._values);
        (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    scrollEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('scroll', '', this.scroll.bind(this));
    }
}
const $697141435cef9d98$var$scrollConfigResolver = $697141435cef9d98$var$coordinatesConfigResolver;
class $697141435cef9d98$var$WheelEngine extends $697141435cef9d98$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "ingKey", 'wheeling');
    }
    wheel(event) {
        if (!this.state._active) this.start(event);
        this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelChange(event) {
        const state = this.state;
        state._delta = $697141435cef9d98$var$wheelValues(event);
        (0, $fb3aa19ac7312631$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $697141435cef9d98$var$clampStateInternalMovementToBounds(state);
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('wheel', '', this.wheel.bind(this));
    }
}
const $697141435cef9d98$var$wheelConfigResolver = $697141435cef9d98$var$coordinatesConfigResolver;
class $697141435cef9d98$var$HoverEngine extends $697141435cef9d98$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $697141435cef9d98$export$407448d2b89b1813(this, "ingKey", 'hovering');
    }
    enter(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        this.start(event);
        this.computeValues($697141435cef9d98$var$pointerValues(event));
        this.compute(event);
        this.emit();
    }
    leave(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        const state = this.state;
        if (!state._active) return;
        state._active = false;
        const values = $697141435cef9d98$var$pointerValues(event);
        state._movement = state._delta = (0, $fb3aa19ac7312631$export$e7c866399fa523f5).sub(values, state._values);
        this.computeValues(values);
        this.compute(event);
        state.delta = state.movement;
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'enter', this.enter.bind(this));
        bindFunction('pointer', 'leave', this.leave.bind(this));
    }
}
const $697141435cef9d98$var$hoverConfigResolver = $697141435cef9d98$export$71511d61b312f219($697141435cef9d98$export$71511d61b312f219({}, $697141435cef9d98$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
const $697141435cef9d98$export$a9c23c6ac3fc3eca = new Map();
const $697141435cef9d98$export$e7094788287c5e9b = new Map();
function $697141435cef9d98$export$43caf9889c228507(action) {
    $697141435cef9d98$export$a9c23c6ac3fc3eca.set(action.key, action.engine);
    $697141435cef9d98$export$e7094788287c5e9b.set(action.key, action.resolver);
}
const $697141435cef9d98$export$f1e1789686576879 = {
    key: 'drag',
    engine: $697141435cef9d98$var$DragEngine,
    resolver: $697141435cef9d98$var$dragConfigResolver
};
const $697141435cef9d98$export$dda1d9f60106f0e9 = {
    key: 'hover',
    engine: $697141435cef9d98$var$HoverEngine,
    resolver: $697141435cef9d98$var$hoverConfigResolver
};
const $697141435cef9d98$export$953cecd6e717a553 = {
    key: 'move',
    engine: $697141435cef9d98$var$MoveEngine,
    resolver: $697141435cef9d98$var$moveConfigResolver
};
const $697141435cef9d98$export$2d1720544b23b823 = {
    key: 'pinch',
    engine: $697141435cef9d98$var$PinchEngine,
    resolver: $697141435cef9d98$var$pinchConfigResolver
};
const $697141435cef9d98$export$2408f22a0fab9ae5 = {
    key: 'scroll',
    engine: $697141435cef9d98$var$ScrollEngine,
    resolver: $697141435cef9d98$var$scrollConfigResolver
};
const $697141435cef9d98$export$efccba1c4a2ef57b = {
    key: 'wheel',
    engine: $697141435cef9d98$var$WheelEngine,
    resolver: $697141435cef9d98$var$wheelConfigResolver
};






var $acw62 = parcelRequire("acw62");


function $9e098876932d0f74$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9e098876932d0f74$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9e098876932d0f74$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $9e098876932d0f74$var$sharedConfigResolver = {
    target (value) {
        if (value) return ()=>'current' in value ? value.current : value;
        return undefined;
    },
    enabled (value = true) {
        return value;
    },
    window (value = (0, $697141435cef9d98$export$25ce5a424b770e84).isBrowser ? window : undefined) {
        return value;
    },
    eventOptions ({ passive: passive = true, capture: capture = false } = {}) {
        return {
            passive: passive,
            capture: capture
        };
    },
    transform (value) {
        return value;
    }
};
const $9e098876932d0f74$var$_excluded = [
    "target",
    "eventOptions",
    "window",
    "enabled",
    "transform"
];
function $9e098876932d0f74$var$resolveWith(config = {}, resolvers) {
    const result = {};
    for (const [key, resolver] of Object.entries(resolvers))switch(typeof resolver){
        case 'function':
            result[key] = resolver.call(result, config[key], key, config);
            break;
        case 'object':
            result[key] = $9e098876932d0f74$var$resolveWith(config[key], resolver);
            break;
        case 'boolean':
            if (resolver) result[key] = config[key];
            break;
    }
    return result;
}
function $9e098876932d0f74$var$parse(newConfig, gestureKey, _config = {}) {
    const _ref = newConfig, { target: target, eventOptions: eventOptions, window: window1, enabled: enabled, transform: transform } = _ref, rest = $9e098876932d0f74$var$_objectWithoutProperties(_ref, $9e098876932d0f74$var$_excluded);
    _config.shared = $9e098876932d0f74$var$resolveWith({
        target: target,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled,
        transform: transform
    }, $9e098876932d0f74$var$sharedConfigResolver);
    if (gestureKey) {
        const resolver = (0, $697141435cef9d98$export$e7094788287c5e9b).get(gestureKey);
        _config[gestureKey] = $9e098876932d0f74$var$resolveWith((0, $697141435cef9d98$export$71511d61b312f219)({
            shared: _config.shared
        }, rest), resolver);
    } else for(const key in rest){
        const resolver = (0, $697141435cef9d98$export$e7094788287c5e9b).get(key);
        if (resolver) _config[key] = $9e098876932d0f74$var$resolveWith((0, $697141435cef9d98$export$71511d61b312f219)({
            shared: _config.shared
        }, rest[key]), resolver);
    }
    return _config;
}
class $9e098876932d0f74$var$EventStore {
    constructor(ctrl, gestureKey){
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "_listeners", new Set());
        this._ctrl = ctrl;
        this._gestureKey = gestureKey;
    }
    add(element, device, action, handler, options) {
        const listeners = this._listeners;
        const type = (0, $697141435cef9d98$export$625550452a3fa3ec)(device, action);
        const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
        const eventOptions = (0, $697141435cef9d98$export$71511d61b312f219)((0, $697141435cef9d98$export$71511d61b312f219)({}, _options), options);
        element.addEventListener(type, handler, eventOptions);
        const remove = ()=>{
            element.removeEventListener(type, handler, eventOptions);
            listeners.delete(remove);
        };
        listeners.add(remove);
        return remove;
    }
    clean() {
        this._listeners.forEach((remove)=>remove());
        this._listeners.clear();
    }
}
class $9e098876932d0f74$var$TimeoutStore {
    constructor(){
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "_timeouts", new Map());
    }
    add(key, callback, ms = 140, ...args) {
        this.remove(key);
        this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
    }
    remove(key) {
        const timeout = this._timeouts.get(key);
        if (timeout) window.clearTimeout(timeout);
    }
    clean() {
        this._timeouts.forEach((timeout)=>void window.clearTimeout(timeout));
        this._timeouts.clear();
    }
}
class $9e098876932d0f74$export$bd0bf19f25da8474 {
    constructor(handlers){
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "gestures", new Set());
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "_targetEventStore", new $9e098876932d0f74$var$EventStore(this));
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "gestureEventStores", {});
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "gestureTimeoutStores", {});
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "handlers", {});
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "config", {});
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "pointerIds", new Set());
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "touchIds", new Set());
        (0, $697141435cef9d98$export$407448d2b89b1813)(this, "state", {
            shared: {
                shiftKey: false,
                metaKey: false,
                ctrlKey: false,
                altKey: false
            }
        });
        $9e098876932d0f74$var$resolveGestures(this, handlers);
    }
    setEventIds(event) {
        if ((0, $697141435cef9d98$export$23f2a1d2818174ef)(event)) {
            this.touchIds = new Set((0, $697141435cef9d98$export$8b22cf2602fb60ce)(event));
            return this.touchIds;
        } else if ('pointerId' in event) {
            if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);
            else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
            return this.pointerIds;
        }
    }
    applyHandlers(handlers, nativeHandlers) {
        this.handlers = handlers;
        this.nativeHandlers = nativeHandlers;
    }
    applyConfig(config, gestureKey) {
        this.config = $9e098876932d0f74$var$parse(config, gestureKey, this.config);
    }
    clean() {
        this._targetEventStore.clean();
        for (const key of this.gestures){
            this.gestureEventStores[key].clean();
            this.gestureTimeoutStores[key].clean();
        }
    }
    effect() {
        if (this.config.shared.target) this.bind();
        return ()=>this._targetEventStore.clean();
    }
    bind(...args) {
        const sharedConfig = this.config.shared;
        const props = {};
        let target;
        if (sharedConfig.target) {
            target = sharedConfig.target();
            if (!target) return;
        }
        if (sharedConfig.enabled) {
            for (const gestureKey of this.gestures){
                const gestureConfig = this.config[gestureKey];
                const bindFunction = $9e098876932d0f74$var$bindToProps(props, gestureConfig.eventOptions, !!target);
                if (gestureConfig.enabled) {
                    const Engine = (0, $697141435cef9d98$export$a9c23c6ac3fc3eca).get(gestureKey);
                    new Engine(this, args, gestureKey).bind(bindFunction);
                }
            }
            const nativeBindFunction = $9e098876932d0f74$var$bindToProps(props, sharedConfig.eventOptions, !!target);
            for(const eventKey in this.nativeHandlers)nativeBindFunction(eventKey, '', (event)=>this.nativeHandlers[eventKey]((0, $697141435cef9d98$export$71511d61b312f219)((0, $697141435cef9d98$export$71511d61b312f219)({}, this.state.shared), {}, {
                    event: event,
                    args: args
                })), undefined, true);
        }
        for(const handlerProp in props)props[handlerProp] = (0, $697141435cef9d98$export$db3b6bfb95261072)(...props[handlerProp]);
        if (!target) return props;
        for(const handlerProp in props){
            const { device: device, capture: capture, passive: passive } = (0, $697141435cef9d98$export$ffb5f4729a158638)(handlerProp);
            this._targetEventStore.add(target, device, '', props[handlerProp], {
                capture: capture,
                passive: passive
            });
        }
    }
}
function $9e098876932d0f74$var$setupGesture(ctrl, gestureKey) {
    ctrl.gestures.add(gestureKey);
    ctrl.gestureEventStores[gestureKey] = new $9e098876932d0f74$var$EventStore(ctrl, gestureKey);
    ctrl.gestureTimeoutStores[gestureKey] = new $9e098876932d0f74$var$TimeoutStore();
}
function $9e098876932d0f74$var$resolveGestures(ctrl, internalHandlers) {
    if (internalHandlers.drag) $9e098876932d0f74$var$setupGesture(ctrl, 'drag');
    if (internalHandlers.wheel) $9e098876932d0f74$var$setupGesture(ctrl, 'wheel');
    if (internalHandlers.scroll) $9e098876932d0f74$var$setupGesture(ctrl, 'scroll');
    if (internalHandlers.move) $9e098876932d0f74$var$setupGesture(ctrl, 'move');
    if (internalHandlers.pinch) $9e098876932d0f74$var$setupGesture(ctrl, 'pinch');
    if (internalHandlers.hover) $9e098876932d0f74$var$setupGesture(ctrl, 'hover');
}
const $9e098876932d0f74$var$bindToProps = (props, eventOptions, withPassiveOption)=>(device, action, handler, options = {}, isNative = false)=>{
        var _options$capture, _options$passive;
        const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
        const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
        let handlerProp = isNative ? device : (0, $697141435cef9d98$export$4368d992c4eafac0)(device, action, capture);
        if (withPassiveOption && passive) handlerProp += 'Passive';
        props[handlerProp] = props[handlerProp] || [];
        props[handlerProp].push(handler);
    };
const $9e098876932d0f74$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $9e098876932d0f74$var$sortHandlers(_handlers) {
    const native = {};
    const handlers = {};
    const actions = new Set();
    for(let key in _handlers)if ($9e098876932d0f74$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handlers[key] = _handlers[key];
    } else native[key] = _handlers[key];
    return [
        handlers,
        native,
        actions
    ];
}
function $9e098876932d0f74$var$registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
    if (!actions.has(handlerKey)) return;
    if (!(0, $697141435cef9d98$export$a9c23c6ac3fc3eca).has(key)) return;
    const startKey = handlerKey + 'Start';
    const endKey = handlerKey + 'End';
    const fn = (state)=>{
        let memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    internalHandlers[key] = fn;
    config[key] = config[key] || {};
}
function $9e098876932d0f74$export$c14d3c7045c4485d(mergedHandlers, mergedConfig) {
    const [handlers, nativeHandlers, actions] = $9e098876932d0f74$var$sortHandlers(mergedHandlers);
    const internalHandlers = {};
    $9e098876932d0f74$var$registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
    $9e098876932d0f74$var$registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
    $9e098876932d0f74$var$registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
    $9e098876932d0f74$var$registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
    $9e098876932d0f74$var$registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
    $9e098876932d0f74$var$registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
    return {
        handlers: internalHandlers,
        config: mergedConfig,
        nativeHandlers: nativeHandlers
    };
}







function $248db369fc8d2642$var$useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
    const ctrl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new (0, $9e098876932d0f74$export$bd0bf19f25da8474)(handlers), []);
    ctrl.applyHandlers(handlers, nativeHandlers);
    ctrl.applyConfig(config, gestureKey);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(ctrl.effect.bind(ctrl));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        return ctrl.clean.bind(ctrl);
    }, []);
    if (config.target === undefined) return ctrl.bind.bind(ctrl);
    return undefined;
}
function $248db369fc8d2642$export$7941f8aafa4b6021(handler, config) {
    (0, $697141435cef9d98$export$43caf9889c228507)((0, $697141435cef9d98$export$f1e1789686576879));
    return $248db369fc8d2642$var$useRecognizers({
        drag: handler
    }, config || {}, 'drag');
}
function $248db369fc8d2642$export$ccc26886ea7dba8f(handler, config) {
    (0, $697141435cef9d98$export$43caf9889c228507)((0, $697141435cef9d98$export$2d1720544b23b823));
    return $248db369fc8d2642$var$useRecognizers({
        pinch: handler
    }, config || {}, 'pinch');
}
function $248db369fc8d2642$export$43260e1b277d5f62(handler, config) {
    (0, $697141435cef9d98$export$43caf9889c228507)((0, $697141435cef9d98$export$efccba1c4a2ef57b));
    return $248db369fc8d2642$var$useRecognizers({
        wheel: handler
    }, config || {}, 'wheel');
}
function $248db369fc8d2642$export$d928051c8cd740b(handler, config) {
    (0, $697141435cef9d98$export$43caf9889c228507)((0, $697141435cef9d98$export$2408f22a0fab9ae5));
    return $248db369fc8d2642$var$useRecognizers({
        scroll: handler
    }, config || {}, 'scroll');
}
function $248db369fc8d2642$export$36da96379f79f245(handler, config) {
    (0, $697141435cef9d98$export$43caf9889c228507)((0, $697141435cef9d98$export$953cecd6e717a553));
    return $248db369fc8d2642$var$useRecognizers({
        move: handler
    }, config || {}, 'move');
}
function $248db369fc8d2642$export$ae780daf29e6d456(handler, config) {
    (0, $697141435cef9d98$export$43caf9889c228507)((0, $697141435cef9d98$export$dda1d9f60106f0e9));
    return $248db369fc8d2642$var$useRecognizers({
        hover: handler
    }, config || {}, 'hover');
}
function $248db369fc8d2642$export$ee99e1f7df2b9180(actions) {
    actions.forEach((0, $697141435cef9d98$export$43caf9889c228507));
    return function useGesture(_handlers, _config) {
        const { handlers: handlers, nativeHandlers: nativeHandlers, config: config } = (0, $9e098876932d0f74$export$c14d3c7045c4485d)(_handlers, _config || {});
        return $248db369fc8d2642$var$useRecognizers(handlers, config, undefined, nativeHandlers);
    };
}
function $248db369fc8d2642$export$ece84446a783717(handlers, config) {
    const hook = $248db369fc8d2642$export$ee99e1f7df2b9180([
        (0, $697141435cef9d98$export$f1e1789686576879),
        (0, $697141435cef9d98$export$2d1720544b23b823),
        (0, $697141435cef9d98$export$2408f22a0fab9ae5),
        (0, $697141435cef9d98$export$efccba1c4a2ef57b),
        (0, $697141435cef9d98$export$953cecd6e717a553),
        (0, $697141435cef9d98$export$dda1d9f60106f0e9)
    ]);
    return hook(handlers, config || {});
}




var $acw62 = parcelRequire("acw62");
function $e0f75533c8da79e2$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}




var $acw62 = parcelRequire("acw62");
function $a27e3b74a1e4b413$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $6421c5b6e6501f6d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $acw62 = parcelRequire("acw62");

/**
 * Listens for when the escape key is down
 */ function $c502a0c80a589ede$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $934b33b1070542f6$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const $934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $934b33b1070542f6$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $934b33b1070542f6$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $934b33b1070542f6$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $934b33b1070542f6$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $acw62.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $934b33b1070542f6$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $acw62.useContext)($934b33b1070542f6$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $acw62.useState)({});
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $934b33b1070542f6$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $934b33b1070542f6$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $c502a0c80a589ede$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $acw62.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $934b33b1070542f6$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $934b33b1070542f6$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $934b33b1070542f6$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $934b33b1070542f6$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($934b33b1070542f6$export$177fb62ff3ec1f22, {
    displayName: $934b33b1070542f6$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $934b33b1070542f6$var$$5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const $934b33b1070542f6$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = (0, $acw62.useContext)($934b33b1070542f6$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($934b33b1070542f6$export$4d5eb2109db14228, {
    displayName: $934b33b1070542f6$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $934b33b1070542f6$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $acw62.useRef)(false);
    const handleClickRef = (0, $acw62.useRef)(()=>{});
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $934b33b1070542f6$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($934b33b1070542f6$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $934b33b1070542f6$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $934b33b1070542f6$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($934b33b1070542f6$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $934b33b1070542f6$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $934b33b1070542f6$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $ffa305e20fe06c82$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $934b33b1070542f6$export$be92b6f5f03c0fe9 = $934b33b1070542f6$export$177fb62ff3ec1f22;
const $934b33b1070542f6$export$aecb2ddcb55c95be = $934b33b1070542f6$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b37fe3d39d956993$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};


const $f3afa084f31a11ef$var$$1746a345f3d73bb7$var$useReactId = $acw62['useId'.toString()] || (()=>undefined);
let $f3afa084f31a11ef$var$$1746a345f3d73bb7$var$count = 0;
function $f3afa084f31a11ef$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($f3afa084f31a11ef$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($f3afa084f31a11ef$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}




var $acw62 = parcelRequire("acw62");
function $973e4da43f2a375d$var$getSide(placement) {
    return placement.split('-')[0];
}
function $973e4da43f2a375d$var$getAlignment(placement) {
    return placement.split('-')[1];
}
function $973e4da43f2a375d$var$getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].includes($973e4da43f2a375d$var$getSide(placement)) ? 'x' : 'y';
}
function $973e4da43f2a375d$var$getLengthFromAxis(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
    const length = $973e4da43f2a375d$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $973e4da43f2a375d$var$getSide(placement);
    const isVertical = mainAxis === 'x';
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($973e4da43f2a375d$var$getAlignment(placement)){
        case 'start':
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    var _ref;
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < middleware.length; i++){
        const { name: name, fn: fn } = middleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $973e4da43f2a375d$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $973e4da43f2a375d$var$getSideObjectFromPadding(padding) {
    return typeof padding !== 'number' ? $973e4da43f2a375d$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $973e4da43f2a375d$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = middlewareArguments;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = options;
    const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $973e4da43f2a375d$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const elementClientRect = $973e4da43f2a375d$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: elementContext === 'floating' ? {
            ...rects.floating,
            x: x,
            y: y
        } : rects.reference,
        offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
        strategy: strategy
    }) : rects[elementContext]);
    return {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
}
const $973e4da43f2a375d$var$min = Math.min;
const $973e4da43f2a375d$var$max = Math.max;
function $973e4da43f2a375d$var$within(min$1, value, max$1) {
    return $973e4da43f2a375d$var$max(min$1, $973e4da43f2a375d$var$min(value, max$1));
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (middlewareArguments) {
            // Since `element` is required, we don't Partial<> the type
            const { element: element, padding: padding = 0 } = options != null ? options : {};
            const { x: x, y: y, placement: placement, rects: rects, platform: platform } = middlewareArguments;
            if (element == null) return {};
            const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const alignment = $973e4da43f2a375d$var$getAlignment(placement);
            const length = $973e4da43f2a375d$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const minProp = axis === 'y' ? 'top' : 'left';
            const maxProp = axis === 'y' ? 'bottom' : 'right';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
            if (clientSize === 0) clientSize = rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $973e4da43f2a375d$var$within(min, center, max); // Make sure that arrow points at the reference
            const alignmentPadding = alignment === 'start' ? paddingObject[minProp] : paddingObject[maxProp];
            const shouldAddOffset = alignmentPadding > 0 && center !== offset && rects.reference[length] <= rects.floating[length];
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $973e4da43f2a375d$var$hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $973e4da43f2a375d$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (matched)=>$973e4da43f2a375d$var$hash$1[matched]);
}
function $973e4da43f2a375d$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
    const length = $973e4da43f2a375d$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $973e4da43f2a375d$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $973e4da43f2a375d$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $973e4da43f2a375d$var$hash = {
    start: 'end',
    end: 'start'
};
function $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (matched)=>$973e4da43f2a375d$var$hash[matched]);
}
const $973e4da43f2a375d$var$sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const $973e4da43f2a375d$var$allPlacements = /*#__PURE__*/ $973e4da43f2a375d$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $973e4da43f2a375d$var$getAlignment(placement) === alignment || (autoAlignment ? $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Automatically chooses the `placement` which has the most space available.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$autoP, _middlewareData$autoP2, _middlewareData$autoP3, _middlewareData$autoP4, _placementsSortedByLe;
            const { x: x, y: y, rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = middlewareArguments;
            const { alignment: alignment = null, allowedPlacements: allowedPlacements = $973e4da43f2a375d$var$allPlacements, autoAlignment: autoAlignment = true, ...detectOverflowOptions } = options;
            const placements = $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const currentIndex = (_middlewareData$autoP = (_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.index) != null ? _middlewareData$autoP : 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main, cross: cross } = $973e4da43f2a375d$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))); // Make `computeCoords` start from the right place
            if (placement !== currentPlacement) return {
                x: x,
                y: y,
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$973e4da43f2a375d$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...(_middlewareData$autoP3 = (_middlewareData$autoP4 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP4.overflows) != null ? _middlewareData$autoP3 : [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1]; // There are more placements to check
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByLeastOverflow = allOverflows.slice().sort((a, b)=>a.overflows[0] - b.overflows[0]);
            const placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find((_ref)=>{
                let { overflows: overflows } = _ref;
                return overflows.every((overflow)=>overflow <= 0);
            })) == null ? void 0 : _placementsSortedByLe.placement;
            const resetPlacement = placementThatFitsOnAllSides != null ? placementThatFitsOnAllSides : placementsSortedByLeastOverflow[0].placement;
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getExpandedPlacements(placement) {
    const oppositePlacement = $973e4da43f2a375d$var$getOppositePlacement(placement);
    return [
        $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $973e4da43f2a375d$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = options;
            const side = $973e4da43f2a375d$var$getSide(placement);
            const isBasePlacement = side === initialPlacement;
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $973e4da43f2a375d$var$getOppositePlacement(initialPlacement)
            ] : $973e4da43f2a375d$var$getExpandedPlacements(initialPlacement));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main, cross: cross } = $973e4da43f2a375d$var$getAlignmentSides(placement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ]; // One or more sides is overflowing
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip$, _middlewareData$flip2;
                const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = 'bottom';
                switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return $973e4da43f2a375d$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(_temp) {
    let { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = _temp === void 0 ? {} : _temp;
    return {
        name: 'hide',
        async fn (middlewareArguments) {
            const { rects: rects } = middlewareArguments;
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
async function $973e4da43f2a375d$var$convertValueToCoords(middlewareArguments, value) {
    const { placement: placement, platform: platform, elements: elements } = middlewareArguments;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $973e4da43f2a375d$var$getSide(placement);
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    const isVertical = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement) === 'x';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === 'function' ? value(middlewareArguments) : value; // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: 'offset',
        options: value,
        async fn (middlewareArguments) {
            const { x: x, y: y } = middlewareArguments;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(middlewareArguments, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $973e4da43f2a375d$var$getCrossAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (middlewareArguments) {
            const { x: x, y: y, placement: placement } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement($973e4da43f2a375d$var$getSide(placement));
            const crossAxis = $973e4da43f2a375d$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $973e4da43f2a375d$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $973e4da43f2a375d$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...middlewareArguments,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (middlewareArguments) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = middlewareArguments;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const crossAxis = $973e4da43f2a375d$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === 'function' ? offset({
                ...rects,
                placement: placement
            }) : offset;
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes($973e4da43f2a375d$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = middlewareArguments;
            const { apply: apply, ...detectOverflowOptions } = options;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const side = $973e4da43f2a375d$var$getSide(placement);
            const alignment = $973e4da43f2a375d$var$getAlignment(placement);
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const xMin = $973e4da43f2a375d$var$max(overflow.left, 0);
            const xMax = $973e4da43f2a375d$var$max(overflow.right, 0);
            const yMin = $973e4da43f2a375d$var$max(overflow.top, 0);
            const yMax = $973e4da43f2a375d$var$max(overflow.bottom, 0);
            const dimensions = {
                availableHeight: rects.floating.height - ([
                    'left',
                    'right'
                ].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $973e4da43f2a375d$var$max(overflow.top, overflow.bottom)) : overflow[heightSide]),
                availableWidth: rects.floating.width - ([
                    'top',
                    'bottom'
                ].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $973e4da43f2a375d$var$max(overflow.left, overflow.right)) : overflow[widthSide])
            };
            const prevDimensions = await platform.getDimensions(elements.floating);
            apply == null || apply({
                ...middlewareArguments,
                ...dimensions
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (prevDimensions.width !== nextDimensions.width || prevDimensions.height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (middlewareArguments) {
            var _await$platform$getCl;
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = middlewareArguments; // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = options;
            const fallback = $973e4da43f2a375d$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                rect: rects.reference,
                offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
                strategy: strategy
            }) : rects.reference);
            const clientRects = (_await$platform$getCl = await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) != null ? _await$platform$getCl : [];
            const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
                    var _clientRects$find;
                    // Find the first rect in which the point is fully inside
                    return (_clientRects$find = clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom)) != null ? _clientRects$find : fallback;
                } // There are 2 or more connected rects
                if (clientRects.length >= 2) {
                    if ($973e4da43f2a375d$var$getMainAxisFromPlacement(placement) === 'x') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $973e4da43f2a375d$var$getSide(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $973e4da43f2a375d$var$getSide(placement) === 'left';
                    const maxRight = $973e4da43f2a375d$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $973e4da43f2a375d$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};


function $461947879dcdbcd4$var$isWindow(value) {
    return value && value.document && value.location && value.alert && value.setInterval;
}
function $461947879dcdbcd4$var$getWindow(node) {
    if (node == null) return window;
    if (!$461947879dcdbcd4$var$isWindow(node)) {
        const ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}
function $461947879dcdbcd4$var$getComputedStyle$1(element) {
    return $461947879dcdbcd4$var$getWindow(element).getComputedStyle(element);
}
function $461947879dcdbcd4$var$getNodeName(node) {
    return $461947879dcdbcd4$var$isWindow(node) ? '' : node ? (node.nodeName || '').toLowerCase() : '';
}
function $461947879dcdbcd4$var$getUAString() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map((item)=>item.brand + "/" + item.version).join(' ');
    return navigator.userAgent;
}
function $461947879dcdbcd4$var$isHTMLElement(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).HTMLElement;
}
function $461947879dcdbcd4$var$isElement(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).Element;
}
function $461947879dcdbcd4$var$isNode(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).Node;
}
function $461947879dcdbcd4$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === 'undefined') return false;
    const OwnElement = $461947879dcdbcd4$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $461947879dcdbcd4$var$isOverflowElement(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = $461947879dcdbcd4$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $461947879dcdbcd4$var$isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($461947879dcdbcd4$var$getNodeName(element));
}
function $461947879dcdbcd4$var$isContainingBlock(element) {
    // TODO: Try and use feature detection here instead
    const isFirefox = /firefox/i.test($461947879dcdbcd4$var$getUAString());
    const css = $461947879dcdbcd4$var$getComputedStyle$1(element); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || // @ts-ignore (TS 4.1 compat)
    css.contain === 'paint' || [
        'transform',
        'perspective'
    ].includes(css.willChange) || isFirefox && css.willChange === 'filter' || isFirefox && (css.filter ? css.filter !== 'none' : false);
}
function $461947879dcdbcd4$var$isLayoutViewport() {
    // Not Safari
    return !/^((?!chrome|android).)*safari/i.test($461947879dcdbcd4$var$getUAString()); // Feature detection for this fails in various ways
// • Always-visible scrollbar or not
// • Width of <html>, etc.
// const vV = win.visualViewport;
// return vV ? Math.abs(win.innerWidth / vV.scale - vV.width) < 0.5 : true;
}
const $461947879dcdbcd4$var$min = Math.min;
const $461947879dcdbcd4$var$max = Math.max;
const $461947879dcdbcd4$var$round = Math.round;
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy) {
    var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    let scaleX = 1;
    let scaleY = 1;
    if (includeScale && $461947879dcdbcd4$var$isHTMLElement(element)) {
        scaleX = element.offsetWidth > 0 ? $461947879dcdbcd4$var$round(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? $461947879dcdbcd4$var$round(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    const win = $461947879dcdbcd4$var$isElement(element) ? $461947879dcdbcd4$var$getWindow(element) : window;
    const addVisualOffsets = !$461947879dcdbcd4$var$isLayoutViewport() && isFixedStrategy;
    const x = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
    const y = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
    const width = clientRect.width / scaleX;
    const height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getDocumentElement(node) {
    return (($461947879dcdbcd4$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $461947879dcdbcd4$var$getNodeScroll(element) {
    if ($461947879dcdbcd4$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect($461947879dcdbcd4$var$getDocumentElement(element)).left + $461947879dcdbcd4$var$getNodeScroll(element).scrollLeft;
}
function $461947879dcdbcd4$var$isScaled(element) {
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element);
    return $461947879dcdbcd4$var$round(rect.width) !== element.offsetWidth || $461947879dcdbcd4$var$round(rect.height) !== element.offsetHeight;
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $461947879dcdbcd4$var$isHTMLElement(offsetParent);
    const documentElement = $461947879dcdbcd4$var$getDocumentElement(offsetParent);
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, isOffsetParentAnElement && $461947879dcdbcd4$var$isScaled(offsetParent), strategy === 'fixed');
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if ($461947879dcdbcd4$var$getNodeName(offsetParent) !== 'body' || $461947879dcdbcd4$var$isOverflowElement(documentElement)) scroll = $461947879dcdbcd4$var$getNodeScroll(offsetParent);
        if ($461947879dcdbcd4$var$isHTMLElement(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$getParentNode(node) {
    if ($461947879dcdbcd4$var$getNodeName(node) === 'html') return node;
    return(// @ts-ignore
    node.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    node.parentNode || ($461947879dcdbcd4$var$isShadowRoot(node) ? node.host : null) || // ShadowRoot detected
    $461947879dcdbcd4$var$getDocumentElement(node) // fallback
    );
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element) {
    if (!$461947879dcdbcd4$var$isHTMLElement(element) || getComputedStyle(element).position === 'fixed') return null;
    return element.offsetParent;
}
function $461947879dcdbcd4$var$getContainingBlock(element) {
    let currentNode = $461947879dcdbcd4$var$getParentNode(element);
    if ($461947879dcdbcd4$var$isShadowRoot(currentNode)) currentNode = currentNode.host;
    while($461947879dcdbcd4$var$isHTMLElement(currentNode) && ![
        'html',
        'body'
    ].includes($461947879dcdbcd4$var$getNodeName(currentNode))){
        if ($461947879dcdbcd4$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element) {
    const window1 = $461947879dcdbcd4$var$getWindow(element);
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element);
    while(offsetParent && $461947879dcdbcd4$var$isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static')offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($461947879dcdbcd4$var$getNodeName(offsetParent) === 'html' || $461947879dcdbcd4$var$getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static' && !$461947879dcdbcd4$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $461947879dcdbcd4$var$getContainingBlock(element) || window1;
}
function $461947879dcdbcd4$var$getDimensions(element) {
    if ($461947879dcdbcd4$var$isHTMLElement(element)) return {
        width: element.offsetWidth,
        height: element.offsetHeight
    };
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element);
    return {
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $461947879dcdbcd4$var$isHTMLElement(offsetParent);
    const documentElement = $461947879dcdbcd4$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if ($461947879dcdbcd4$var$getNodeName(offsetParent) !== 'body' || $461947879dcdbcd4$var$isOverflowElement(documentElement)) scroll = $461947879dcdbcd4$var$getNodeScroll(offsetParent);
        if ($461947879dcdbcd4$var$isHTMLElement(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } // This doesn't appear to be need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }
    }
    return {
        ...rect,
        x: rect.x - scroll.scrollLeft + offsets.x,
        y: rect.y - scroll.scrollTop + offsets.y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = $461947879dcdbcd4$var$getWindow(element);
    const html = $461947879dcdbcd4$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const layoutViewport = $461947879dcdbcd4$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function $461947879dcdbcd4$var$getDocumentRect(element) {
    var _element$ownerDocumen;
    const html = $461947879dcdbcd4$var$getDocumentElement(element);
    const scroll = $461947879dcdbcd4$var$getNodeScroll(element);
    const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    const width = $461947879dcdbcd4$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    const height = $461947879dcdbcd4$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($461947879dcdbcd4$var$getComputedStyle$1(body || html).direction === 'rtl') x += $461947879dcdbcd4$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getNearestOverflowAncestor(node) {
    const parentNode = $461947879dcdbcd4$var$getParentNode(node);
    if ([
        'html',
        'body',
        '#document'
    ].includes($461947879dcdbcd4$var$getNodeName(parentNode))) // @ts-ignore assume body is always available
    return node.ownerDocument.body;
    if ($461947879dcdbcd4$var$isHTMLElement(parentNode) && $461947879dcdbcd4$var$isOverflowElement(parentNode)) return parentNode;
    return $461947879dcdbcd4$var$getNearestOverflowAncestor(parentNode);
}
function $461947879dcdbcd4$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $461947879dcdbcd4$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $461947879dcdbcd4$var$getWindow(scrollableAncestor);
    const target = isBody ? [
        win
    ].concat(win.visualViewport || [], $461947879dcdbcd4$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
    const updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($461947879dcdbcd4$export$3b57c1601291186b(target));
}
function $461947879dcdbcd4$var$contains(parent, child) {
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && $461947879dcdbcd4$var$isShadowRoot(rootNode)) {
        let next = child;
        do {
            // use `===` replace node.isSameNode()
            if (next && parent === next) return true;
             // @ts-ignore: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    }
    return false;
}
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, false, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    return {
        top: top,
        left: left,
        x: left,
        y: top,
        right: left + element.clientWidth,
        bottom: top + element.clientHeight,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingParent, strategy) {
    if (clippingParent === 'viewport') return (0, $973e4da43f2a375d$export$ee05aea0aeecbad4)($461947879dcdbcd4$var$getViewportRect(element, strategy));
    if ($461947879dcdbcd4$var$isElement(clippingParent)) return $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingParent, strategy);
    return (0, $973e4da43f2a375d$export$ee05aea0aeecbad4)($461947879dcdbcd4$var$getDocumentRect($461947879dcdbcd4$var$getDocumentElement(element)));
} // A "clipping ancestor" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $461947879dcdbcd4$var$getClippingAncestors(element) {
    const clippingAncestors = $461947879dcdbcd4$export$3b57c1601291186b(element);
    const canEscapeClipping = [
        'absolute',
        'fixed'
    ].includes($461947879dcdbcd4$var$getComputedStyle$1(element).position);
    const clipperElement = canEscapeClipping && $461947879dcdbcd4$var$isHTMLElement(element) ? $461947879dcdbcd4$var$getOffsetParent(element) : element;
    if (!$461947879dcdbcd4$var$isElement(clipperElement)) return [];
     // @ts-ignore isElement check ensures we return Array<Element>
    return clippingAncestors.filter((clippingAncestors)=>$461947879dcdbcd4$var$isElement(clippingAncestors) && $461947879dcdbcd4$var$contains(clippingAncestors, clipperElement) && $461947879dcdbcd4$var$getNodeName(clippingAncestors) !== 'body');
} // Gets the maximum area that the element is visible in due to any number of
// clipping ancestors
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const mainClippingAncestors = boundary === 'clippingAncestors' ? $461947879dcdbcd4$var$getClippingAncestors(element) : [].concat(boundary);
    const clippingAncestors = [
        ...mainClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $461947879dcdbcd4$var$max(rect.top, accRect.top);
        accRect.right = $461947879dcdbcd4$var$min(rect.right, accRect.right);
        accRect.bottom = $461947879dcdbcd4$var$min(rect.bottom, accRect.bottom);
        accRect.left = $461947879dcdbcd4$var$max(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
const $461947879dcdbcd4$var$platform = {
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $461947879dcdbcd4$var$isElement,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getDocumentElement: $461947879dcdbcd4$var$getDocumentElement,
    getElementRects: (_ref)=>{
        let { reference: reference, floating: floating, strategy: strategy } = _ref;
        return {
            reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(reference, $461947879dcdbcd4$var$getOffsetParent(floating), strategy),
            floating: {
                ...$461947879dcdbcd4$var$getDimensions(floating),
                x: 0,
                y: 0
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$461947879dcdbcd4$var$getComputedStyle$1(element).direction === 'rtl'
};
/**
 * Automatically updates the position of the floating element when necessary.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: _ancestorScroll = true, ancestorResize: _ancestorResize = true, elementResize: elementResize = true, animationFrame: animationFrame = false } = options;
    const ancestorScroll = _ancestorScroll && !animationFrame;
    const ancestorResize = _ancestorResize && !animationFrame;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$461947879dcdbcd4$var$isElement(reference) ? $461947879dcdbcd4$export$3b57c1601291186b(reference) : [],
        ...$461947879dcdbcd4$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    let observer = null;
    if (elementResize) {
        let initialUpdate = true;
        observer = new ResizeObserver(()=>{
            if (!initialUpdate) update();
            initialUpdate = false;
        });
        $461947879dcdbcd4$var$isElement(reference) && !animationFrame && observer.observe(reference);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>(0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        platform: $461947879dcdbcd4$var$platform,
        ...options
    });



var $acw62 = parcelRequire("acw62");

var $23a8f689f1d4c3be$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(_temp) {
    let { middleware: middleware, placement: placement = 'bottom', strategy: strategy = 'absolute', whileElementsMounted: whileElementsMounted } = _temp === void 0 ? {} : _temp;
    const reference = $acw62.useRef(null);
    const floating = $acw62.useRef(null);
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const cleanupRef = $acw62.useRef(null);
    const [data, setData] = $acw62.useState({
        // Setting these to `null` will allow the consumer to determine if
        // `computePosition()` has run yet
        x: null,
        y: null,
        strategy: strategy,
        placement: placement,
        middlewareData: {}
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware == null ? void 0 : latestMiddleware.map((_ref)=>{
        let { options: options } = _ref;
        return options;
    }), middleware == null ? void 0 : middleware.map((_ref2)=>{
        let { options: options } = _ref2;
        return options;
    }))) setLatestMiddleware(middleware);
    const update = $acw62.useCallback(()=>{
        if (!reference.current || !floating.current) return;
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(reference.current, floating.current, {
            middleware: latestMiddleware,
            placement: placement,
            strategy: strategy
        }).then((data)=>{
            if (isMountedRef.current) $11492dca620dcaa5$exports.flushSync(()=>{
                setData(data);
            });
        });
    }, [
        latestMiddleware,
        placement,
        strategy
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        // Skip first update
        if (isMountedRef.current) update();
    }, [
        update
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const runElementMountCallback = $acw62.useCallback(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (reference.current && floating.current) {
            if (whileElementsMountedRef.current) {
                const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
                cleanupRef.current = cleanupFn;
            } else update();
        }
    }, [
        update,
        whileElementsMountedRef
    ]);
    const setReference = $acw62.useCallback((node)=>{
        reference.current = node;
        runElementMountCallback();
    }, [
        runElementMountCallback
    ]);
    const setFloating = $acw62.useCallback((node)=>{
        floating.current = node;
        runElementMountCallback();
    }, [
        runElementMountCallback
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: reference,
            floating: floating
        }), []);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            reference: setReference,
            floating: setFloating
        }), [
        data,
        update,
        refs,
        setReference,
        setFloating
    ]);
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options)=>{
    const { element: element, padding: padding } = options;
    function isRef(value) {
        return Object.prototype.hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (args) {
            if (isRef(element)) {
                if (element.current != null) return (0, $973e4da43f2a375d$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(args);
                return {};
            } else if (element) return (0, $973e4da43f2a375d$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(args);
            return {};
        }
    };
};




var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $8f56a07a0f827cef$var$$7e8f5cd07187803e$var$NAME = 'Arrow';
const $8f56a07a0f827cef$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $acw62.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($8f56a07a0f827cef$export$21b07c8f274aebd5, {
    displayName: $8f56a07a0f827cef$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $8f56a07a0f827cef$export$be92b6f5f03c0fe9 = $8f56a07a0f827cef$export$21b07c8f274aebd5;








var $acw62 = parcelRequire("acw62");

function $cb5e472331db9c97$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $acw62.useState)(undefined);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $b44af8157e52e192$export$36f0086da09c4b9f = [
    'top',
    'right',
    'bottom',
    'left'
];
const $b44af8157e52e192$export$3671ffab7b302fc9 = [
    'start',
    'center',
    'end'
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext, $b44af8157e52e192$export$722aac194ae923] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperProvider, $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $b44af8157e52e192$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $acw62.createElement)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$badac9ada3a0bdf9, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
const $b44af8157e52e192$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$ecd4e1ccab6ed6d, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$useContentContext] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PositionContextProvider, $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePositionContext] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, {
    hasParent: false,
    positionUpdateFns: new Set()
});
const $b44af8157e52e192$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
    const { __scopePopper: __scopePopper, side: side = 'bottom', sideOffset: sideOffset = 0, align: align = 'center', alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = 'partial', hideWhenDetached: hideWhenDetached = false, avoidCollisions: avoidCollisions = true, onPlaced: onPlaced, ...contentProps } = props;
    const context = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $acw62.useState)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $acw62.useState)(null);
    const arrowSize = (0, $cb5e472331db9c97$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { reference: reference, floating: floating, strategy: strategy, x: x, y: y, placement: placement, middlewareData: middlewareData, update: update } = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: (0, $461947879dcdbcd4$export$deee3a793edee05f),
        middleware: [
            $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$anchorCssProperties(),
            (0, $973e4da43f2a375d$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions ? (0, $973e4da43f2a375d$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }) : undefined,
            arrow ? (0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }) : undefined,
            avoidCollisions ? (0, $973e4da43f2a375d$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }) : undefined,
            (0, $973e4da43f2a375d$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, availableWidth: width, availableHeight: height })=>{
                    elements.floating.style.setProperty('--radix-popper-available-width', `${width}px`);
                    elements.floating.style.setProperty('--radix-popper-available-height', `${height}px`);
                }
            }),
            $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached ? (0, $973e4da43f2a375d$export$fe8985bb6374093c)({
                strategy: 'referenceHidden'
            }) : undefined
        ].filter($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isDefined)
    }); // assign the reference dynamically once `Content` has mounted so we can collocate the logic
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        reference(context.anchor);
    }, [
        reference,
        context.anchor
    ]);
    const isPlaced = x !== null && y !== null;
    const [placedSide, placedAlign] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onPlaced);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (isPlaced) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPlaced,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $acw62.useState)();
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const { hasParent: hasParent, positionUpdateFns: positionUpdateFns } = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePositionContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const isRoot = !hasParent;
    (0, $acw62.useLayoutEffect)(()=>{
        if (!isRoot) {
            positionUpdateFns.add(update);
            return ()=>{
                positionUpdateFns.delete(update);
            };
        }
    }, [
        isRoot,
        positionUpdateFns,
        update
    ]); // when nested contents are rendered in portals, they are appended out of order causing
    // children to be positioned incorrectly if initially open.
    // we need to re-compute the positioning once the parent has finally been placed.
    // https://github.com/floating-ui/floating-ui/issues/1531
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach((fn)=>requestAnimationFrame(fn));
    }, [
        isRoot,
        isPlaced,
        positionUpdateFns
    ]);
    const commonProps = {
        'data-side': placedSide,
        'data-align': placedAlign,
        ...contentProps,
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    };
    return /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: floating,
        "data-radix-popper-content-wrapper": "",
        style: {
            position: strategy,
            left: 0,
            top: 0,
            transform: isPlaced ? `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)` : 'translate3d(0, -200%, 0)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $acw62.createElement)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, isRoot ? /*#__PURE__*/ (0, $acw62.createElement)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PositionContextProvider, {
        scope: __scopePopper,
        hasParent: true,
        positionUpdateFns: positionUpdateFns
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, commonProps)) : /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, commonProps)));
});
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$bc4ae5855d3c4fc, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = 'PopperArrow';
const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
};
const $b44af8157e52e192$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $acw62.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$useContentContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $acw62.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: 'absolute',
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: '',
                right: '0 0',
                bottom: 'center 0',
                left: '100% 0'
            }[contentContext.placedSide],
            transform: {
                top: 'translateY(100%)',
                right: 'translateY(50%) rotate(90deg) translateX(-50%)',
                bottom: `rotate(180deg)`,
                left: 'translateY(50%) rotate(-90deg) translateX(50%)'
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? 'hidden' : undefined
        }
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $8f56a07a0f827cef$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: 'block'
        }
    }))));
});
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$79d62cd4e10a3fd0, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isDefined(value) {
    return value !== undefined;
}
function $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$anchorCssProperties = ()=>({
        name: 'anchorCssProperties',
        fn (data) {
            const { rects: rects, elements: elements } = data;
            const { width: width, height: height } = rects.reference;
            elements.floating.style.setProperty('--radix-popper-anchor-width', `${width}px`);
            elements.floating.style.setProperty('--radix-popper-anchor-height', `${height}px`);
            return {};
        }
    });
const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $b44af8157e52e192$export$be92b6f5f03c0fe9 = $b44af8157e52e192$export$badac9ada3a0bdf9;
const $b44af8157e52e192$export$b688253958b8dfe7 = $b44af8157e52e192$export$ecd4e1ccab6ed6d;
const $b44af8157e52e192$export$7c6e2c02157bb7d2 = $b44af8157e52e192$export$bc4ae5855d3c4fc;
const $b44af8157e52e192$export$21b07c8f274aebd5 = $b44af8157e52e192$export$79d62cd4e10a3fd0;




var $acw62 = parcelRequire("acw62");



function $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $33a5aa769cc85be3$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$33a5aa769cc85be3$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $11492dca620dcaa5$exports.flushSync)(()=>send('ANIMATION_END'));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





var $acw62 = parcelRequire("acw62");

function $206b7034d5d190d4$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $206b7034d5d190d4$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $acw62.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $206b7034d5d190d4$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $acw62.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $acw62.useRef)(value);
    const handleChange = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onChange);
    (0, $acw62.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $f0cd20cd077f7c4e$var$$ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const $f0cd20cd077f7c4e$export$439d29a4e110a164 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($f0cd20cd077f7c4e$export$439d29a4e110a164, {
    displayName: $f0cd20cd077f7c4e$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $f0cd20cd077f7c4e$export$be92b6f5f03c0fe9 = $f0cd20cd077f7c4e$export$439d29a4e110a164;


const [$48cf56b316245546$var$$a093c7e1ec25a057$var$createTooltipContext, $48cf56b316245546$export$1c540a2224f0d865] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)('Tooltip', [
    (0, $b44af8157e52e192$export$722aac194ae923)
]);
const $48cf56b316245546$var$$a093c7e1ec25a057$var$usePopperScope = (0, $b44af8157e52e192$export$722aac194ae923)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $48cf56b316245546$var$$a093c7e1ec25a057$var$PROVIDER_NAME = 'TooltipProvider';
const $48cf56b316245546$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN = 'tooltip.open';
const [$48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipProviderContext] = $48cf56b316245546$var$$a093c7e1ec25a057$var$createTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$PROVIDER_NAME);
const $48cf56b316245546$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $48cf56b316245546$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0, $acw62.useState)(true);
    const isPointerInTransitRef = (0, $acw62.useRef)(false);
    const skipDelayTimerRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0, $acw62.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0, $acw62.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0, $acw62.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($48cf56b316245546$export$f78649fb9ca566b8, {
    displayName: $48cf56b316245546$var$$a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_NAME = 'Tooltip';
const [$48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContextProvider, $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipContext] = $48cf56b316245546$var$$a093c7e1ec25a057$var$createTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_NAME);
const $48cf56b316245546$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipProviderContext($48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $48cf56b316245546$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0, $acw62.useState)(null);
    const contentId = (0, $f3afa084f31a11ef$export$f680877a34711e37)();
    const openTimerRef = (0, $acw62.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0, $acw62.useRef)(false);
    const [open1 = false, setOpen] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0, $acw62.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? 'delayed-open' : 'instant-open' : 'closed';
    }, [
        open1
    ]);
    const handleOpen = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0, $acw62.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0, $acw62.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($48cf56b316245546$export$28c660c63b792dea, {
    displayName: $48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $48cf56b316245546$var$$a093c7e1ec25a057$var$TRIGGER_NAME = 'TooltipTrigger';
const $48cf56b316245546$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipProviderContext($48cf56b316245546$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $48cf56b316245546$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0, $acw62.useRef)(false);
    const hasPointerMoveOpenedRef = (0, $acw62.useRef)(false);
    const handlePointerUp = (0, $acw62.useCallback)(()=>isPointerDownRef.current = false, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>document.removeEventListener('pointerup', handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (event.pointerType === 'touch') return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener('pointerup', handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
        onClick: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($48cf56b316245546$export$8c610744efcf8a1d, {
    displayName: $48cf56b316245546$var$$a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $48cf56b316245546$var$$a093c7e1ec25a057$var$PORTAL_NAME = 'TooltipPortal';
const [$48cf56b316245546$var$$a093c7e1ec25a057$var$PortalProvider, $48cf56b316245546$var$$a093c7e1ec25a057$var$usePortalContext] = $48cf56b316245546$var$$a093c7e1ec25a057$var$createTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $48cf56b316245546$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $33a5aa769cc85be3$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $7e4e93e12e9bb800$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($48cf56b316245546$export$7b36b8f925ab7497, {
    displayName: $48cf56b316245546$var$$a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME = 'TooltipContent';
const $48cf56b316245546$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $48cf56b316245546$var$$a093c7e1ec25a057$var$usePortalContext($48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = 'top', ...contentProps } = props;
    const context = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $33a5aa769cc85be3$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContentHoverable, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipProviderContext($48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0, $acw62.useState)(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = (0, $acw62.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0, $acw62.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $48cf56b316245546$var$$a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const bleed = exitSide === 'right' || exitSide === 'bottom' ? -5 : 5;
        const isXAxis = exitSide === 'right' || exitSide === 'left';
        const startPoint = isXAxis ? {
            x: event.clientX + bleed,
            y: event.clientY
        } : {
            x: event.clientX,
            y: event.clientY + bleed
        };
        const hoverTargetPoints = $48cf56b316245546$var$$a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $48cf56b316245546$var$$a093c7e1ec25a057$var$getHull([
            startPoint,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    (0, $acw62.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener('pointerleave', handleTriggerLeave);
            content.addEventListener('pointerleave', handleContentLeave);
            return ()=>{
                trigger.removeEventListener('pointerleave', handleTriggerLeave);
                content.removeEventListener('pointerleave', handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0, $acw62.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$48cf56b316245546$var$$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener('pointermove', handleTrackPointerGrace);
            return ()=>document.removeEventListener('pointermove', handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
const [$48cf56b316245546$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $48cf56b316245546$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $48cf56b316245546$var$$a093c7e1ec25a057$var$createTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $48cf56b316245546$var$$a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, 'aria-label': ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $48cf56b316245546$var$$a093c7e1ec25a057$var$useTooltipContext($48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $48cf56b316245546$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context; // Close this tooltip if another one opens
    (0, $acw62.useEffect)(()=>{
        document.addEventListener($48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($48cf56b316245546$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0, $acw62.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener('scroll', handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener('scroll', handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $934b33b1070542f6$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$7c6e2c02157bb7d2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            '--radix-tooltip-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-tooltip-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-tooltip-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-tooltip-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-tooltip-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $2fad294522b5ed20$export$d9f1ccf0bdb05d45), null, children), /*#__PURE__*/ (0, $acw62.createElement)($48cf56b316245546$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $f0cd20cd077f7c4e$export$be92b6f5f03c0fe9), {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($48cf56b316245546$export$e9003e2be37ec060, {
    displayName: $48cf56b316245546$var$$a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $48cf56b316245546$var$$a093c7e1ec25a057$var$ARROW_NAME = 'TooltipArrow';
const $48cf56b316245546$export$c27ee0ad710f7559 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $48cf56b316245546$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $48cf56b316245546$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext($48cf56b316245546$var$$a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($48cf56b316245546$export$c27ee0ad710f7559, {
    displayName: $48cf56b316245546$var$$a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $48cf56b316245546$var$$a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return 'left';
        case right:
            return 'right';
        case top:
            return 'top';
        case bottom:
            return 'bottom';
        default:
            return null;
    }
}
function $48cf56b316245546$var$$a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $48cf56b316245546$var$$a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $48cf56b316245546$var$$a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $48cf56b316245546$var$$a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $48cf56b316245546$var$$a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $48cf56b316245546$export$2881499e37b75b9a = $48cf56b316245546$export$f78649fb9ca566b8;
const $48cf56b316245546$export$be92b6f5f03c0fe9 = $48cf56b316245546$export$28c660c63b792dea;
const $48cf56b316245546$export$41fb9f06171c75f4 = $48cf56b316245546$export$8c610744efcf8a1d;
const $48cf56b316245546$export$602eac185826482c = $48cf56b316245546$export$7b36b8f925ab7497;
const $48cf56b316245546$export$7c6e2c02157bb7d2 = $48cf56b316245546$export$e9003e2be37ec060;
const $48cf56b316245546$export$21b07c8f274aebd5 = $48cf56b316245546$export$c27ee0ad710f7559;


function $831d64f343d74c7e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $831d64f343d74c7e$export$23f2a1d2818174ef(source, excluded) {
    if (source == null) return {};
    var target = $831d64f343d74c7e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
let $831d64f343d74c7e$export$d141bba7fdc215a3;
(function(LevaErrors) {
    LevaErrors[LevaErrors["UNSUPPORTED_INPUT"] = 0] = "UNSUPPORTED_INPUT";
    LevaErrors[LevaErrors["NO_COMPONENT_FOR_TYPE"] = 1] = "NO_COMPONENT_FOR_TYPE";
    LevaErrors[LevaErrors["UNKNOWN_INPUT"] = 2] = "UNKNOWN_INPUT";
    LevaErrors[LevaErrors["DUPLICATE_KEYS"] = 3] = "DUPLICATE_KEYS";
    LevaErrors[LevaErrors["ALREADY_REGISTERED_TYPE"] = 4] = "ALREADY_REGISTERED_TYPE";
    LevaErrors[LevaErrors["CLIPBOARD_ERROR"] = 5] = "CLIPBOARD_ERROR";
    LevaErrors[LevaErrors["THEME_ERROR"] = 6] = "THEME_ERROR";
    LevaErrors[LevaErrors["PATH_DOESNT_EXIST"] = 7] = "PATH_DOESNT_EXIST";
    LevaErrors[LevaErrors["INPUT_TYPE_OVERRIDE"] = 8] = "INPUT_TYPE_OVERRIDE";
    LevaErrors[LevaErrors["EMPTY_KEY"] = 9] = "EMPTY_KEY";
})($831d64f343d74c7e$export$d141bba7fdc215a3 || ($831d64f343d74c7e$export$d141bba7fdc215a3 = {}));
const $831d64f343d74c7e$var$ErrorList = {
    [$831d64f343d74c7e$export$d141bba7fdc215a3.UNSUPPORTED_INPUT]: (type, path)=>[
            `An input with type \`${type}\` input was found at path \`${path}\` but it's not supported yet.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.NO_COMPONENT_FOR_TYPE]: (type, path)=>[
            `Type \`${type}\` found at path \`${path}\` can't be displayed in panel because no component supports it yet.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.UNKNOWN_INPUT]: (path, value)=>[
            `input at path \`${path}\` is not recognized.`,
            value
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.DUPLICATE_KEYS]: (key, path, prevPath)=>[
            `Key \`${key}\` of path \`${path}\` already exists at path \`${prevPath}\`. Even nested keys need to be unique. Rename one of the keys.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.ALREADY_REGISTERED_TYPE]: (type)=>[
            `Type ${type} has already been registered. You can't register a component with the same type.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.CLIPBOARD_ERROR]: (value)=>[
            `Error copying the value`,
            value
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.THEME_ERROR]: (category, key)=>[
            `Error accessing the theme \`${category}.${key}\` value.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.PATH_DOESNT_EXIST]: (path)=>[
            `Error getting the value at path \`${path}\`. There is probably an error in your \`render\` function.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.PATH_DOESNT_EXIST]: (path)=>[
            `Error accessing the value at path \`${path}\``
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.INPUT_TYPE_OVERRIDE]: (path, type, wrongType)=>[
            `Input at path \`${path}\` already exists with type: \`${type}\`. Its type cannot be overridden with type \`${wrongType}\`.`
        ],
    [$831d64f343d74c7e$export$d141bba7fdc215a3.EMPTY_KEY]: ()=>[
            'Keys can not be empty, if you want to hide a label use whitespace.'
        ]
};
function $831d64f343d74c7e$var$_log(fn, errorType, ...args) {
    const [message, ...rest] = $831d64f343d74c7e$var$ErrorList[errorType](...args);
    console[fn]('LEVA: ' + message, ...rest);
}
const $831d64f343d74c7e$export$efccba1c4a2ef57b = $831d64f343d74c7e$var$_log.bind(null, 'warn');
const $831d64f343d74c7e$export$7f8ddf7c7c20b3cd = $831d64f343d74c7e$var$_log.bind(null, 'log');
const $831d64f343d74c7e$var$_excluded$a = [
    "value"
], $831d64f343d74c7e$var$_excluded2$4 = [
    "schema"
], $831d64f343d74c7e$var$_excluded3$1 = [
    "value"
];
const $831d64f343d74c7e$var$Schemas = [];
const $831d64f343d74c7e$export$ef35774e6d314e91 = {};
function $831d64f343d74c7e$var$getValueType(_ref) {
    let { value: value } = _ref, settings = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$a);
    for (let checker of $831d64f343d74c7e$var$Schemas){
        const type = checker(value, settings);
        if (type) return type;
    }
    return undefined;
}
function $831d64f343d74c7e$export$34aec0b863436764(type, _ref2) {
    let { schema: schema } = _ref2, plugin = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref2, $831d64f343d74c7e$var$_excluded2$4);
    if (type in $831d64f343d74c7e$export$ef35774e6d314e91) {
        $831d64f343d74c7e$export$efccba1c4a2ef57b($831d64f343d74c7e$export$d141bba7fdc215a3.ALREADY_REGISTERED_TYPE, type);
        return;
    }
    $831d64f343d74c7e$var$Schemas.push((value, settings)=>schema(value, settings) && type);
    $831d64f343d74c7e$export$ef35774e6d314e91[type] = plugin;
}
const $831d64f343d74c7e$var$getUniqueType = ()=>'__CUSTOM__PLUGIN__' + Math.random().toString(36).substr(2, 9);
function $831d64f343d74c7e$export$db3b6bfb95261072(plugin) {
    return plugin;
}
function $831d64f343d74c7e$export$f787f51d84a910ad(plugin) {
    const type = $831d64f343d74c7e$var$getUniqueType();
    $831d64f343d74c7e$export$ef35774e6d314e91[type] = plugin;
    return (input)=>{
        return {
            type: type,
            __customInput: input
        };
    };
}
function $831d64f343d74c7e$var$normalize$3(type, input, path, data) {
    const { normalize: _normalize } = $831d64f343d74c7e$export$ef35774e6d314e91[type];
    if (_normalize) return _normalize(input, path, data);
    if (typeof input !== 'object' || !('value' in input)) return {
        value: input
    };
    const { value: value } = input, settings = $831d64f343d74c7e$export$23f2a1d2818174ef(input, $831d64f343d74c7e$var$_excluded3$1);
    return {
        value: value,
        settings: settings
    };
}
function $831d64f343d74c7e$var$sanitize$4(type, value, settings, prevValue, path, store) {
    const { sanitize: sanitize } = $831d64f343d74c7e$export$ef35774e6d314e91[type];
    if (sanitize) return sanitize(value, settings, prevValue, path, store);
    return value;
}
function $831d64f343d74c7e$var$format$2(type, value, settings) {
    const { format: format } = $831d64f343d74c7e$export$ef35774e6d314e91[type];
    if (format) return format(value, settings);
    return value;
}
function $831d64f343d74c7e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $831d64f343d74c7e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $831d64f343d74c7e$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $831d64f343d74c7e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $831d64f343d74c7e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $831d64f343d74c7e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const $831d64f343d74c7e$export$dda1d9f60106f0e9 = (x, min, max)=>x > max ? max : x < min ? min : x;
const $831d64f343d74c7e$export$2219238a014317b0 = (x, pad)=>String(x).padStart(pad, '0');
const $831d64f343d74c7e$var$parseNumber = (v)=>{
    if (v === '' || typeof v === 'number') return v;
    try {
        const _v = $831d64f343d74c7e$export$4c3d22f3d993c33f(v);
        if (!isNaN(_v)) return _v;
    } catch (_unused) {}
    return parseFloat(v);
};
const $831d64f343d74c7e$var$log10 = Math.log(10);
function $831d64f343d74c7e$var$getStep(number) {
    let n = Math.abs(+String(number).replace('.', ''));
    if (n === 0) return 0.01;
    while(n !== 0 && n % 10 === 0)n /= 10;
    const significantDigits = Math.floor(Math.log(n) / $831d64f343d74c7e$var$log10) + 1;
    const numberLog = Math.floor(Math.log10(Math.abs(number)));
    const step = Math.pow(10, numberLog - significantDigits);
    return Math.max(step, 0.001);
}
const $831d64f343d74c7e$export$43caf9889c228507 = (v, min, max)=>{
    if (max === min) return 0;
    const _v = $831d64f343d74c7e$export$dda1d9f60106f0e9(v, min, max);
    return (_v - min) / (max - min);
};
const $831d64f343d74c7e$export$35e795649ee09318 = (p, min, max)=>p * (max - min) + min;
const $831d64f343d74c7e$export$625550452a3fa3ec = ()=>'_' + Math.random().toString(36).substr(2, 9);
const $831d64f343d74c7e$var$parens = /\(([0-9+\-*/^ .]+)\)/;
const $831d64f343d74c7e$var$exp = /(\d+(?:\.\d+)?) ?\^ ?(\d+(?:\.\d+)?)/;
const $831d64f343d74c7e$var$mul = /(\d+(?:\.\d+)?) ?\* ?(\d+(?:\.\d+)?)/;
const $831d64f343d74c7e$var$div = /(\d+(?:\.\d+)?) ?\/ ?(\d+(?:\.\d+)?)/;
const $831d64f343d74c7e$var$add = /(\d+(?:\.\d+)?) ?\+ ?(\d+(?:\.\d+)?)/;
const $831d64f343d74c7e$var$sub = /(\d+(?:\.\d+)?) ?- ?(\d+(?:\.\d+)?)/;
function $831d64f343d74c7e$export$4c3d22f3d993c33f(expr) {
    if (isNaN(Number(expr))) {
        if ($831d64f343d74c7e$var$parens.test(expr)) {
            const newExpr = expr.replace($831d64f343d74c7e$var$parens, (match, subExpr)=>String($831d64f343d74c7e$export$4c3d22f3d993c33f(subExpr)));
            return $831d64f343d74c7e$export$4c3d22f3d993c33f(newExpr);
        } else if ($831d64f343d74c7e$var$exp.test(expr)) {
            const newExpr = expr.replace($831d64f343d74c7e$var$exp, (match, base, pow)=>String(Math.pow(Number(base), Number(pow))));
            return $831d64f343d74c7e$export$4c3d22f3d993c33f(newExpr);
        } else if ($831d64f343d74c7e$var$mul.test(expr)) {
            const newExpr = expr.replace($831d64f343d74c7e$var$mul, (match, a, b)=>String(Number(a) * Number(b)));
            return $831d64f343d74c7e$export$4c3d22f3d993c33f(newExpr);
        } else if ($831d64f343d74c7e$var$div.test(expr)) {
            const newExpr = expr.replace($831d64f343d74c7e$var$div, (match, a, b)=>{
                if (b != 0) return String(Number(a) / Number(b));
                else throw new Error('Division by zero');
            });
            return $831d64f343d74c7e$export$4c3d22f3d993c33f(newExpr);
        } else if ($831d64f343d74c7e$var$add.test(expr)) {
            const newExpr = expr.replace($831d64f343d74c7e$var$add, (match, a, b)=>String(Number(a) + Number(b)));
            return $831d64f343d74c7e$export$4c3d22f3d993c33f(newExpr);
        } else if ($831d64f343d74c7e$var$sub.test(expr)) {
            const newExpr = expr.replace($831d64f343d74c7e$var$sub, (match, a, b)=>String(Number(a) - Number(b)));
            return $831d64f343d74c7e$export$4c3d22f3d993c33f(newExpr);
        } else return Number(expr);
    }
    return Number(expr);
}
function $831d64f343d74c7e$export$ffb5f4729a158638(object, keys) {
    return keys.reduce((obj, key)=>{
        if (!!object && object.hasOwnProperty(key)) obj[key] = object[key];
        return obj;
    }, {});
}
function $831d64f343d74c7e$export$ae1af26003f05816(object, keys) {
    const obj = $831d64f343d74c7e$export$71511d61b312f219({}, object);
    keys.forEach((k)=>k in object && delete obj[k]);
    return obj;
}
function $831d64f343d74c7e$var$mapArrayToKeys(value, keys) {
    return value.reduce((acc, v, i)=>Object.assign(acc, {
            [keys[i]]: v
        }), {});
}
function $831d64f343d74c7e$var$isObject(variable) {
    return Object.prototype.toString.call(variable) === '[object Object]';
}
const $831d64f343d74c7e$var$isEmptyObject = (obj)=>$831d64f343d74c7e$var$isObject(obj) && Object.keys(obj).length === 0;
let $831d64f343d74c7e$export$90a7f3efeed30595;
(function(SpecialInputs) {
    SpecialInputs["BUTTON"] = "BUTTON";
    SpecialInputs["BUTTON_GROUP"] = "BUTTON_GROUP";
    SpecialInputs["MONITOR"] = "MONITOR";
    SpecialInputs["FOLDER"] = "FOLDER";
})($831d64f343d74c7e$export$90a7f3efeed30595 || ($831d64f343d74c7e$export$90a7f3efeed30595 = {}));
let $831d64f343d74c7e$export$3c2fa207a37baaea;
(function(LevaInputs) {
    LevaInputs["SELECT"] = "SELECT";
    LevaInputs["IMAGE"] = "IMAGE";
    LevaInputs["NUMBER"] = "NUMBER";
    LevaInputs["COLOR"] = "COLOR";
    LevaInputs["STRING"] = "STRING";
    LevaInputs["BOOLEAN"] = "BOOLEAN";
    LevaInputs["INTERVAL"] = "INTERVAL";
    LevaInputs["VECTOR3D"] = "VECTOR3D";
    LevaInputs["VECTOR2D"] = "VECTOR2D";
})($831d64f343d74c7e$export$3c2fa207a37baaea || ($831d64f343d74c7e$export$3c2fa207a37baaea = {}));
const $831d64f343d74c7e$var$_excluded$9 = [
    "type",
    "__customInput"
], $831d64f343d74c7e$var$_excluded2$3 = [
    "render",
    "label",
    "optional",
    "order",
    "disabled",
    "hint",
    "onChange",
    "onEditStart",
    "onEditEnd",
    "transient"
], $831d64f343d74c7e$var$_excluded3 = [
    "type"
];
function $831d64f343d74c7e$var$parseOptions(_input, key, mergedOptions = {}, customType) {
    var _commonOptions$option, _commonOptions$disabl;
    if (typeof _input !== 'object' || Array.isArray(_input)) return {
        type: customType,
        input: _input,
        options: $831d64f343d74c7e$export$71511d61b312f219({
            key: key,
            label: key,
            optional: false,
            disabled: false,
            order: 0
        }, mergedOptions)
    };
    if ('__customInput' in _input) {
        const { type: _type, __customInput: __customInput } = _input, options = $831d64f343d74c7e$export$23f2a1d2818174ef(_input, $831d64f343d74c7e$var$_excluded$9);
        return $831d64f343d74c7e$var$parseOptions(__customInput, key, options, _type);
    }
    const { render: render, label: label, optional: optional, order: order = 0, disabled: disabled, hint: hint, onChange: onChange, onEditStart: onEditStart, onEditEnd: onEditEnd, transient: transient } = _input, inputWithType = $831d64f343d74c7e$export$23f2a1d2818174ef(_input, $831d64f343d74c7e$var$_excluded2$3);
    const commonOptions = $831d64f343d74c7e$export$71511d61b312f219({
        render: render,
        key: key,
        label: label !== null && label !== void 0 ? label : key,
        hint: hint,
        transient: transient !== null && transient !== void 0 ? transient : !!onChange,
        onEditStart: onEditStart,
        onEditEnd: onEditEnd,
        disabled: disabled,
        optional: optional,
        order: order
    }, mergedOptions);
    let { type: type } = inputWithType, input = $831d64f343d74c7e$export$23f2a1d2818174ef(inputWithType, $831d64f343d74c7e$var$_excluded3);
    type = customType !== null && customType !== void 0 ? customType : type;
    if (type in $831d64f343d74c7e$export$90a7f3efeed30595) return {
        type: type,
        input: input,
        options: commonOptions
    };
    let computedInput;
    if (customType && $831d64f343d74c7e$var$isObject(input) && 'value' in input) computedInput = input.value;
    else computedInput = $831d64f343d74c7e$var$isEmptyObject(input) ? undefined : input;
    return {
        type: type,
        input: computedInput,
        options: $831d64f343d74c7e$export$71511d61b312f219($831d64f343d74c7e$export$71511d61b312f219({}, commonOptions), {}, {
            onChange: onChange,
            optional: (_commonOptions$option = commonOptions.optional) !== null && _commonOptions$option !== void 0 ? _commonOptions$option : false,
            disabled: (_commonOptions$disabl = commonOptions.disabled) !== null && _commonOptions$disabl !== void 0 ? _commonOptions$disabl : false
        })
    };
}
function $831d64f343d74c7e$export$df995fae86a55f06(_input, key, path, data) {
    const parsedInputAndOptions = $831d64f343d74c7e$var$parseOptions(_input, key);
    const { type: type, input: parsedInput, options: options } = parsedInputAndOptions;
    if (type) {
        if (type in $831d64f343d74c7e$export$90a7f3efeed30595) return parsedInputAndOptions;
        return {
            type: type,
            input: $831d64f343d74c7e$var$normalize$3(type, parsedInput, path, data),
            options: options
        };
    }
    let inputType = $831d64f343d74c7e$var$getValueType(parsedInput);
    if (inputType) return {
        type: inputType,
        input: $831d64f343d74c7e$var$normalize$3(inputType, parsedInput, path, data),
        options: options
    };
    inputType = $831d64f343d74c7e$var$getValueType({
        value: parsedInput
    });
    if (inputType) return {
        type: inputType,
        input: $831d64f343d74c7e$var$normalize$3(inputType, {
            value: parsedInput
        }, path, data),
        options: options
    };
    return false;
}
function $831d64f343d74c7e$export$4a5767248b18ef41(input, newValue, path, store, fromPanel) {
    const { value: value, type: type, settings: settings } = input;
    input.value = $831d64f343d74c7e$var$sanitizeValue({
        type: type,
        value: value,
        settings: settings
    }, newValue, path, store);
    input.fromPanel = fromPanel;
}
const $831d64f343d74c7e$var$ValueError = function ValueError(message, value, error) {
    this.type = 'LEVA_ERROR';
    this.message = 'LEVA: ' + message;
    this.previousValue = value;
    this.error = error;
};
function $831d64f343d74c7e$var$sanitizeValue({ type: type, value: value, settings: settings }, newValue, path, store) {
    const _newValue = type !== 'SELECT' && typeof newValue === 'function' ? newValue(value) : newValue;
    let sanitizedNewValue;
    try {
        sanitizedNewValue = $831d64f343d74c7e$var$sanitize$4(type, _newValue, settings, value, path, store);
    } catch (e) {
        throw new $831d64f343d74c7e$var$ValueError(`The value \`${newValue}\` did not result in a correct value.`, value, e);
    }
    if ((0, $37120ef32eee7a36$export$de8294bb3be0322f)(sanitizedNewValue, value)) return value;
    return sanitizedNewValue;
}
const $831d64f343d74c7e$export$3a6d5c9ae78a2c08 = (callback, wait, immediate = false)=>{
    let timeout = 0;
    return function() {
        const args = arguments;
        const callNow = immediate && !timeout;
        const next = ()=>callback.apply(this, args);
        window.clearTimeout(timeout);
        timeout = window.setTimeout(next, wait);
        if (callNow) next();
    };
};
const $831d64f343d74c7e$export$953cecd6e717a553 = (event)=>event.shiftKey ? 5 : event.altKey ? 0.2 : 1;
const $831d64f343d74c7e$var$_excluded$8 = [
    "value"
], $831d64f343d74c7e$var$_excluded2$2 = [
    "min",
    "max"
];
const $831d64f343d74c7e$var$schema$3 = (v)=>{
    if (typeof v === 'number') return true;
    if (typeof v === 'string') {
        const _v = parseFloat(v);
        if (isNaN(_v)) return false;
        const suffix = v.substring(('' + _v).length).trim();
        return suffix.length < 4;
    }
    return false;
};
const $831d64f343d74c7e$var$sanitize$3 = (v, { min: _min = -Infinity, max: _max = Infinity, suffix: suffix })=>{
    const _v = parseFloat(v);
    if (v === '' || isNaN(_v)) throw Error('Invalid number');
    const f = $831d64f343d74c7e$export$dda1d9f60106f0e9(_v, _min, _max);
    return suffix ? f + suffix : f;
};
const $831d64f343d74c7e$var$format$1 = (v, { pad: _pad = 0, suffix: suffix })=>{
    const f = parseFloat(v).toFixed(_pad);
    return suffix ? f + suffix : f;
};
const $831d64f343d74c7e$var$normalize$2 = (_ref)=>{
    let { value: value } = _ref, settings = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$8);
    const { min: min = -Infinity, max: max = Infinity } = settings, _settings = $831d64f343d74c7e$export$23f2a1d2818174ef(settings, $831d64f343d74c7e$var$_excluded2$2);
    let _value = parseFloat(value);
    const suffix = typeof value === 'string' ? value.substring(('' + _value).length) : undefined;
    _value = $831d64f343d74c7e$export$dda1d9f60106f0e9(_value, min, max);
    let step = settings.step;
    if (!step) {
        if (Number.isFinite(min)) {
            if (Number.isFinite(max)) step = +(Math.abs(max - min) / 100).toPrecision(1);
            else step = +(Math.abs(_value - min) / 100).toPrecision(1);
        } else if (Number.isFinite(max)) step = +(Math.abs(max - _value) / 100).toPrecision(1);
    }
    const padStep = step ? $831d64f343d74c7e$var$getStep(step) * 10 : $831d64f343d74c7e$var$getStep(_value);
    step = step || padStep / 10;
    const pad = Math.round($831d64f343d74c7e$export$dda1d9f60106f0e9(Math.log10(1 / padStep), 0, 2));
    return {
        value: suffix ? _value + suffix : _value,
        settings: $831d64f343d74c7e$export$71511d61b312f219({
            initialValue: _value,
            step: step,
            pad: pad,
            min: min,
            max: max,
            suffix: suffix
        }, _settings)
    };
};
const $831d64f343d74c7e$var$sanitizeStep$1 = (v, { step: step, initialValue: initialValue })=>{
    const steps = Math.round((v - initialValue) / step);
    return initialValue + steps * step;
};
var $831d64f343d74c7e$var$props$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    schema: $831d64f343d74c7e$var$schema$3,
    sanitize: $831d64f343d74c7e$var$sanitize$3,
    format: $831d64f343d74c7e$var$format$1,
    normalize: $831d64f343d74c7e$var$normalize$2,
    sanitizeStep: $831d64f343d74c7e$var$sanitizeStep$1
});
function $831d64f343d74c7e$export$2d1720544b23b823() {
    $831d64f343d74c7e$export$2d1720544b23b823 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $831d64f343d74c7e$export$2d1720544b23b823.apply(this, arguments);
}
const $831d64f343d74c7e$export$e7094788287c5e9b = (0, $acw62.createContext)({});
function $831d64f343d74c7e$export$3b14a55fb2447963() {
    return (0, $acw62.useContext)($831d64f343d74c7e$export$e7094788287c5e9b);
}
const $831d64f343d74c7e$export$3d8c2f653ac9d0b9 = (0, $acw62.createContext)(null);
const $831d64f343d74c7e$export$8743009a87fcb00f = (0, $acw62.createContext)(null);
const $831d64f343d74c7e$export$78acf4525d8a74c4 = (0, $acw62.createContext)(null);
function $831d64f343d74c7e$export$a9c23c6ac3fc3eca() {
    return (0, $acw62.useContext)($831d64f343d74c7e$export$8743009a87fcb00f);
}
function $831d64f343d74c7e$var$usePanelSettingsContext() {
    return (0, $acw62.useContext)($831d64f343d74c7e$export$78acf4525d8a74c4);
}
function $831d64f343d74c7e$export$2e2af4578d910ddf({ children: children, store: store }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$8743009a87fcb00f.Provider, {
        value: store
    }, children);
}
const $831d64f343d74c7e$var$getDefaultTheme = ()=>({
        colors: {
            elevation1: '#292d39',
            elevation2: '#181c20',
            elevation3: '#373c4b',
            accent1: '#0066dc',
            accent2: '#007bff',
            accent3: '#3c93ff',
            highlight1: '#535760',
            highlight2: '#8c92a4',
            highlight3: '#fefefe',
            vivid1: '#ffcc00',
            folderWidgetColor: '$highlight2',
            folderTextColor: '$highlight3',
            toolTipBackground: '$highlight3',
            toolTipText: '$elevation2'
        },
        radii: {
            xs: '2px',
            sm: '3px',
            lg: '10px'
        },
        space: {
            xs: '3px',
            sm: '6px',
            md: '10px',
            rowGap: '7px',
            colGap: '7px'
        },
        fonts: {
            mono: `ui-monospace, SFMono-Regular, Menlo, 'Roboto Mono', monospace`,
            sans: `system-ui, sans-serif`
        },
        fontSizes: {
            root: '11px',
            toolTip: '$root'
        },
        sizes: {
            rootWidth: '280px',
            controlWidth: '160px',
            numberInputMinWidth: '38px',
            scrubberWidth: '8px',
            scrubberHeight: '16px',
            rowHeight: '24px',
            folderTitleHeight: '20px',
            checkboxSize: '16px',
            joystickWidth: '100px',
            joystickHeight: '100px',
            colorPickerWidth: '$controlWidth',
            colorPickerHeight: '100px',
            imagePreviewWidth: '$controlWidth',
            imagePreviewHeight: '100px',
            monitorHeight: '60px',
            titleBarHeight: '39px'
        },
        shadows: {
            level1: '0 0 9px 0 #00000088',
            level2: '0 4px 14px #00000033'
        },
        borderWidths: {
            root: '0px',
            input: '1px',
            focus: '1px',
            hover: '1px',
            active: '1px',
            folder: '1px'
        },
        fontWeights: {
            label: 'normal',
            folder: 'normal',
            button: 'normal'
        }
    });
function $831d64f343d74c7e$var$createStateClass(value, options) {
    const [borderColor, bgColor] = value.split(' ');
    const css = {};
    if (borderColor !== 'none') css.boxShadow = `${options.inset ? 'inset ' : ''}0 0 0 $borderWidths${[
        options.key
    ]} $colors${borderColor !== 'default' && borderColor || options.borderColor}`;
    if (bgColor) css.backgroundColor = bgColor;
    return css;
}
const $831d64f343d74c7e$var$utils = {
    $inputStyle: ()=>(value)=>$831d64f343d74c7e$var$createStateClass(value, {
                key: '$input',
                borderColor: '$highlight1',
                inset: true
            }),
    $focusStyle: ()=>(value)=>$831d64f343d74c7e$var$createStateClass(value, {
                key: '$focus',
                borderColor: '$accent2'
            }),
    $hoverStyle: ()=>(value)=>$831d64f343d74c7e$var$createStateClass(value, {
                key: '$hover',
                borderColor: '$accent1',
                inset: true
            }),
    $activeStyle: ()=>(value)=>$831d64f343d74c7e$var$createStateClass(value, {
                key: '$active',
                borderColor: '$accent1',
                inset: true
            })
};
const { styled: $831d64f343d74c7e$export$2408f22a0fab9ae5, css: $831d64f343d74c7e$var$css, createTheme: $831d64f343d74c7e$var$createTheme, globalCss: $831d64f343d74c7e$var$globalCss, keyframes: $831d64f343d74c7e$export$c9170ad7d4cd7e57 } = (0, $4dd86a99225dce20$export$3c6706659c99b84e)({
    prefix: 'leva',
    theme: $831d64f343d74c7e$var$getDefaultTheme(),
    utils: $831d64f343d74c7e$export$71511d61b312f219($831d64f343d74c7e$export$71511d61b312f219({}, $831d64f343d74c7e$var$utils), {}, {
        $flex: ()=>({
                display: 'flex',
                alignItems: 'center'
            }),
        $flexCenter: ()=>({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
        $reset: ()=>({
                outline: 'none',
                fontSize: 'inherit',
                fontWeight: 'inherit',
                color: 'inherit',
                fontFamily: 'inherit',
                border: 'none',
                backgroundColor: 'transparent',
                appearance: 'none'
            }),
        $draggable: ()=>({
                touchAction: 'none',
                WebkitUserDrag: 'none',
                userSelect: 'none'
            }),
        $focus: (value)=>({
                '&:focus': $831d64f343d74c7e$var$utils.$focusStyle()(value)
            }),
        $focusWithin: (value)=>({
                '&:focus-within': $831d64f343d74c7e$var$utils.$focusStyle()(value)
            }),
        $hover: (value)=>({
                '&:hover': $831d64f343d74c7e$var$utils.$hoverStyle()(value)
            }),
        $active: (value)=>({
                '&:active': $831d64f343d74c7e$var$utils.$activeStyle()(value)
            })
    })
});
const $831d64f343d74c7e$export$71cec2538cb2c617 = $831d64f343d74c7e$var$globalCss({
    '.leva__panel__dragged': {
        WebkitUserDrag: 'none',
        userSelect: 'none',
        input: {
            userSelect: 'none'
        },
        '*': {
            cursor: 'ew-resize !important'
        }
    }
});
function $831d64f343d74c7e$export$dc98b0b04f4c7758(newTheme) {
    const defaultTheme = $831d64f343d74c7e$var$getDefaultTheme();
    if (!newTheme) return {
        theme: defaultTheme,
        className: ''
    };
    Object.keys(newTheme).forEach((key)=>{
        Object.assign(defaultTheme[key], newTheme[key]);
    });
    const customTheme = $831d64f343d74c7e$var$createTheme(defaultTheme);
    return {
        theme: defaultTheme,
        className: customTheme.className
    };
}
function $831d64f343d74c7e$export$4368d992c4eafac0(category, key) {
    const { theme: theme } = (0, $acw62.useContext)($831d64f343d74c7e$export$3d8c2f653ac9d0b9);
    if (!(category in theme) || !(key in theme[category])) {
        $831d64f343d74c7e$export$efccba1c4a2ef57b($831d64f343d74c7e$export$d141bba7fdc215a3.THEME_ERROR, category, key);
        return '';
    }
    let _key = key;
    while(true){
        let value = theme[category][_key];
        if (typeof value === 'string' && value.charAt(0) === '$') _key = value.substr(1);
        else return value;
    }
}
const $831d64f343d74c7e$var$StyledInput = $831d64f343d74c7e$export$2408f22a0fab9ae5('input', {
    $reset: '',
    padding: '0 $sm',
    width: 0,
    minWidth: 0,
    flex: 1,
    height: '100%',
    variants: {
        levaType: {
            number: {
                textAlign: 'right'
            }
        },
        as: {
            textarea: {
                padding: '$sm'
            }
        }
    }
});
const $831d64f343d74c7e$export$555508cbc6add439 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    $draggable: '',
    height: '100%',
    $flexCenter: '',
    position: 'relative',
    padding: '0 $xs',
    fontSize: '0.8em',
    opacity: 0.8,
    cursor: 'default',
    touchAction: 'none',
    [`& + ${$831d64f343d74c7e$var$StyledInput}`]: {
        paddingLeft: 0
    }
});
const $831d64f343d74c7e$var$InnerNumberLabel = $831d64f343d74c7e$export$2408f22a0fab9ae5($831d64f343d74c7e$export$555508cbc6add439, {
    cursor: 'ew-resize',
    marginRight: '-$xs',
    textTransform: 'uppercase',
    opacity: 0.3,
    '&:hover': {
        opacity: 1
    },
    variants: {
        dragging: {
            true: {
                backgroundColor: '$accent2',
                opacity: 1
            }
        }
    }
});
const $831d64f343d74c7e$var$InputContainer = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    $flex: '',
    position: 'relative',
    borderRadius: '$sm',
    overflow: 'hidden',
    color: 'inherit',
    height: '$rowHeight',
    backgroundColor: '$elevation3',
    $inputStyle: '$elevation1',
    $hover: '',
    $focusWithin: '',
    variants: {
        textArea: {
            true: {
                height: 'auto'
            }
        }
    }
});
const $831d64f343d74c7e$var$_excluded$7 = [
    "innerLabel",
    "value",
    "onUpdate",
    "onChange",
    "onKeyDown",
    "type",
    "id",
    "inputType",
    "rows"
], $831d64f343d74c7e$var$_excluded2$1 = [
    "onUpdate"
];
function $831d64f343d74c7e$export$e7c866399fa523f5(_ref) {
    let { innerLabel: innerLabel, value: value, onUpdate: onUpdate, onChange: onChange, onKeyDown: onKeyDown, type: type, id: id, inputType: inputType = 'text', rows: rows = 0 } = _ref, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$7);
    const { id: _id, emitOnEditStart: emitOnEditStart, emitOnEditEnd: emitOnEditEnd, disabled: disabled } = $831d64f343d74c7e$export$3b14a55fb2447963();
    const inputId = id || _id;
    const inputRef = (0, $acw62.useRef)(null);
    const isTextArea = rows > 0;
    const asType = isTextArea ? 'textarea' : 'input';
    const update = (0, $acw62.useCallback)((fn)=>(event)=>{
            const _value = event.currentTarget.value;
            fn(_value);
        }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const ref = inputRef.current;
        const _onUpdate = update((value)=>{
            onUpdate(value);
            emitOnEditEnd();
        });
        ref === null || ref === void 0 || ref.addEventListener('blur', _onUpdate);
        return ()=>ref === null || ref === void 0 ? void 0 : ref.removeEventListener('blur', _onUpdate);
    }, [
        update,
        onUpdate,
        emitOnEditEnd
    ]);
    const onKeyPress = (0, $acw62.useCallback)((event)=>{
        if (event.key === 'Enter') update(onUpdate)(event);
    }, [
        update,
        onUpdate
    ]);
    const inputProps = Object.assign({
        as: asType
    }, isTextArea ? {
        rows: rows
    } : {}, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$InputContainer, {
        textArea: isTextArea
    }, innerLabel && typeof innerLabel === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$555508cbc6add439, null, innerLabel) : innerLabel, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledInput, $831d64f343d74c7e$export$2d1720544b23b823({
        levaType: type,
        ref: inputRef,
        id: inputId,
        type: inputType,
        autoComplete: "off",
        spellCheck: "false",
        value: value,
        onChange: update(onChange),
        onFocus: ()=>emitOnEditStart(),
        onKeyPress: onKeyPress,
        onKeyDown: onKeyDown,
        disabled: disabled
    }, inputProps)));
}
function $831d64f343d74c7e$var$NumberInput(_ref2) {
    let { onUpdate: onUpdate } = _ref2, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref2, $831d64f343d74c7e$var$_excluded2$1);
    const _onUpdate = (0, $acw62.useCallback)((v)=>onUpdate($831d64f343d74c7e$var$parseNumber(v)), [
        onUpdate
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const dir = event.key === 'ArrowUp' ? 1 : event.key === 'ArrowDown' ? -1 : 0;
        if (dir) {
            event.preventDefault();
            const step = event.altKey ? 0.1 : event.shiftKey ? 10 : 1;
            onUpdate((v)=>parseFloat(v) + dir * step);
        }
    }, [
        onUpdate
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$e7c866399fa523f5, $831d64f343d74c7e$export$2d1720544b23b823({}, props, {
        onUpdate: _onUpdate,
        onKeyDown: onKeyDown,
        type: "number"
    }));
}
const $831d64f343d74c7e$export$3722cfe417b6ed86 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {});
const $831d64f343d74c7e$export$3a1a48c8f6ef640e = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'relative',
    background: '$elevation2',
    transition: 'height 300ms ease',
    variants: {
        fill: {
            true: {},
            false: {}
        },
        flat: {
            false: {},
            true: {}
        },
        isRoot: {
            true: {},
            false: {
                paddingLeft: '$md',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '$borderWidths$folder',
                    height: '100%',
                    backgroundColor: '$folderWidgetColor',
                    opacity: 0.4,
                    transform: 'translateX(-50%)'
                }
            }
        }
    },
    compoundVariants: [
        {
            isRoot: true,
            fill: false,
            css: {
                overflowY: 'auto',
                maxHeight: 'calc(100vh - 20px - $$titleBarHeight)'
            }
        },
        {
            isRoot: true,
            flat: false,
            css: {
                borderRadius: '$lg'
            }
        }
    ]
});
const $831d64f343d74c7e$export$b4171a6734a65d42 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    $flex: '',
    color: '$folderTextColor',
    userSelect: 'none',
    cursor: 'pointer',
    height: '$folderTitleHeight',
    fontWeight: '$folder',
    '> svg': {
        marginLeft: -4,
        marginRight: 4,
        cursor: 'pointer',
        fill: '$folderWidgetColor',
        opacity: 0.6
    },
    '&:hover > svg': {
        fill: '$folderWidgetColor'
    },
    [`&:hover + ${$831d64f343d74c7e$export$3a1a48c8f6ef640e}::after`]: {
        opacity: 0.6
    },
    [`${$831d64f343d74c7e$export$3722cfe417b6ed86}:hover > & + ${$831d64f343d74c7e$export$3a1a48c8f6ef640e}::after`]: {
        opacity: 0.6
    },
    [`${$831d64f343d74c7e$export$3722cfe417b6ed86}:hover > & > svg`]: {
        opacity: 1
    }
});
const $831d64f343d74c7e$export$a07804094c3ecf2d = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '100%',
    rowGap: '$rowGap',
    transition: 'opacity 250ms ease',
    variants: {
        toggled: {
            true: {
                opacity: 1,
                transitionDelay: '250ms'
            },
            false: {
                opacity: 0,
                transitionDelay: '0ms',
                pointerEvents: 'none'
            }
        },
        isRoot: {
            true: {
                '& > div': {
                    paddingLeft: '$md',
                    paddingRight: '$md'
                },
                '& > div:first-of-type': {
                    paddingTop: '$sm'
                },
                '& > div:last-of-type': {
                    paddingBottom: '$sm'
                },
                [`> ${$831d64f343d74c7e$export$3722cfe417b6ed86}:not(:first-of-type)`]: {
                    paddingTop: '$sm',
                    marginTop: '$md',
                    borderTop: '$borderWidths$folder solid $colors$elevation1'
                }
            }
        }
    }
});
const $831d64f343d74c7e$var$StyledRow = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'relative',
    zIndex: 100,
    display: 'grid',
    rowGap: '$rowGap',
    gridTemplateRows: 'minmax($sizes$rowHeight, max-content)',
    alignItems: 'center',
    color: '$highlight2',
    [`${$831d64f343d74c7e$export$a07804094c3ecf2d} > &`]: {
        '&:first-of-type': {
            marginTop: '$rowGap'
        },
        '&:last-of-type': {
            marginBottom: '$rowGap'
        }
    },
    variants: {
        disabled: {
            true: {
                pointerEvents: 'none'
            },
            false: {
                '&:hover,&:focus-within': {
                    color: '$highlight3'
                }
            }
        }
    }
});
const $831d64f343d74c7e$export$971d5caa766a69d7 = $831d64f343d74c7e$export$2408f22a0fab9ae5($831d64f343d74c7e$var$StyledRow, {
    gridTemplateColumns: 'auto $sizes$controlWidth',
    columnGap: '$colGap'
});
const $831d64f343d74c7e$var$CopyLabelContainer = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    $flex: '',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    '& > div': {
        marginLeft: '$colGap',
        padding: '0 $xs',
        opacity: 0.4
    },
    '& > div:hover': {
        opacity: 0.8
    },
    '& > div > svg': {
        display: 'none',
        cursor: 'pointer',
        width: 13,
        minWidth: 13,
        height: 13,
        backgroundColor: '$elevation2'
    },
    '&:hover > div > svg': {
        display: 'block'
    },
    variants: {
        align: {
            top: {
                height: '100%',
                alignItems: 'flex-start',
                paddingTop: '$sm'
            }
        }
    }
});
const $831d64f343d74c7e$var$StyledOptionalToggle = $831d64f343d74c7e$export$2408f22a0fab9ae5('input', {
    $reset: '',
    height: 0,
    width: 0,
    opacity: 0,
    margin: 0,
    '& + label': {
        position: 'relative',
        $flexCenter: '',
        height: '100%',
        userSelect: 'none',
        cursor: 'pointer',
        paddingLeft: 2,
        paddingRight: '$sm',
        pointerEvents: 'auto'
    },
    '& + label:after': {
        content: '""',
        width: 6,
        height: 6,
        backgroundColor: '$elevation3',
        borderRadius: '50%',
        $activeStyle: ''
    },
    '&:focus + label:after': {
        $focusStyle: ''
    },
    '& + label:active:after': {
        backgroundColor: '$accent1',
        $focusStyle: ''
    },
    '&:checked + label:after': {
        backgroundColor: '$accent1'
    }
});
const $831d64f343d74c7e$var$StyledLabel = $831d64f343d74c7e$export$2408f22a0fab9ae5('label', {
    fontWeight: '$label',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& > svg': {
        display: 'block'
    }
});
const $831d64f343d74c7e$export$96f57966bedc81b4 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    opacity: 1,
    variants: {
        disabled: {
            true: {
                opacity: 0.6,
                pointerEvents: 'none',
                [`& ${$831d64f343d74c7e$var$StyledLabel}`]: {
                    pointerEvents: 'auto'
                }
            }
        }
    }
});
const $831d64f343d74c7e$export$c4ce752e73470fba = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1000,
    userSelect: 'none'
});
const $831d64f343d74c7e$var$StyledToolTipContent = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    background: '$toolTipBackground',
    fontFamily: '$sans',
    fontSize: '$toolTip',
    padding: '$xs $sm',
    color: '$toolTipText',
    borderRadius: '$xs',
    boxShadow: '$level2',
    maxWidth: 260
});
const $831d64f343d74c7e$var$ToolTipArrow = $831d64f343d74c7e$export$2408f22a0fab9ae5((0, $48cf56b316245546$export$21b07c8f274aebd5), {
    fill: '$toolTipBackground'
});
function $831d64f343d74c7e$export$56c0d5a1e737357d({ children: children }) {
    const { className: className } = (0, $acw62.useContext)($831d64f343d74c7e$export$3d8c2f653ac9d0b9);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e4e93e12e9bb800$export$be92b6f5f03c0fe9, {
        className: className
    }, children);
}
const $831d64f343d74c7e$var$_excluded$6 = [
    "align"
];
function $831d64f343d74c7e$var$OptionalToggle() {
    const { id: id, disable: disable, disabled: disabled } = $831d64f343d74c7e$export$3b14a55fb2447963();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledOptionalToggle, {
        id: id + '__disable',
        type: "checkbox",
        checked: !disabled,
        onChange: ()=>disable(!disabled)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: id + '__disable'
    }));
}
function $831d64f343d74c7e$var$RawLabel(props) {
    const { id: id, optional: optional, hint: hint } = $831d64f343d74c7e$export$3b14a55fb2447963();
    const htmlFor = props.htmlFor || (id ? {
        htmlFor: id
    } : null);
    const title = !hint && typeof props.children === 'string' ? {
        title: props.children
    } : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, optional && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$OptionalToggle, null), hint !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($48cf56b316245546$export$be92b6f5f03c0fe9, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($48cf56b316245546$export$41fb9f06171c75f4, {
        asChild: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledLabel, $831d64f343d74c7e$export$2d1720544b23b823({}, htmlFor, props))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($48cf56b316245546$export$7c6e2c02157bb7d2, {
        side: "top",
        sideOffset: 2
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledToolTipContent, null, hint, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$ToolTipArrow, null)))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledLabel, $831d64f343d74c7e$export$2d1720544b23b823({}, htmlFor, title, props)));
}
function $831d64f343d74c7e$export$61196ced6d74a310(_ref) {
    let { align: align } = _ref, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$6);
    const { value: value, label: label, key: key, disabled: disabled } = $831d64f343d74c7e$export$3b14a55fb2447963();
    const { hideCopyButton: hideCopyButton } = $831d64f343d74c7e$var$usePanelSettingsContext();
    const copyEnabled = !hideCopyButton && key !== undefined;
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const handleClick = async ()=>{
        try {
            await navigator.clipboard.writeText(JSON.stringify({
                [key]: value !== null && value !== void 0 ? value : ''
            }));
            setCopied(true);
        } catch (_unused) {
            $831d64f343d74c7e$export$efccba1c4a2ef57b($831d64f343d74c7e$export$d141bba7fdc215a3.CLIPBOARD_ERROR, {
                [key]: value
            });
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$CopyLabelContainer, {
        align: align,
        onPointerLeave: ()=>setCopied(false)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$RawLabel, props), copyEnabled && !disabled && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        title: `Click to copy ${typeof label === 'string' ? label : key} value`
    }, !copied ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        onClick: handleClick,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }))));
}
const $831d64f343d74c7e$var$_excluded$5 = [
    "toggled"
];
const $831d64f343d74c7e$var$Svg = $831d64f343d74c7e$export$2408f22a0fab9ae5('svg', {
    fill: 'currentColor',
    transition: 'transform 350ms ease, fill 250ms ease'
});
function $831d64f343d74c7e$export$3466f893ebf79586(_ref) {
    let { toggled: toggled } = _ref, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$5);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$Svg, $831d64f343d74c7e$export$2d1720544b23b823({
        width: "9",
        height: "5",
        viewBox: "0 0 9 5",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            transform: `rotate(${toggled ? 0 : -90}deg)`
        }
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.8 4.4c.4.3 1 .3 1.4 0L8 1.7A1 1 0 007.4 0H1.6a1 1 0 00-.7 1.7l3 2.7z"
    }));
}
const $831d64f343d74c7e$var$_excluded$4 = [
    "input"
];
function $831d64f343d74c7e$export$db202ddc8be9136(_ref) {
    let { input: input } = _ref, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$4);
    if (input) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$971d5caa766a69d7, props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledRow, props);
}
function $831d64f343d74c7e$export$ebd11618f299a286({ value: value, type: type, settings: settings, setValue: setValue }) {
    const [displayValue, setDisplayValue] = (0, $acw62.useState)($831d64f343d74c7e$var$format$2(type, value, settings));
    const previousValueRef = (0, $acw62.useRef)(value);
    const settingsRef = (0, $acw62.useRef)(settings);
    settingsRef.current = settings;
    const setFormat = (0, $acw62.useCallback)((v)=>setDisplayValue($831d64f343d74c7e$var$format$2(type, v, settingsRef.current)), [
        type
    ]);
    const onUpdate = (0, $acw62.useCallback)((updatedValue)=>{
        try {
            setValue(updatedValue);
        } catch (error) {
            const { type: type, previousValue: previousValue } = error;
            if (type !== 'LEVA_ERROR') throw error;
            setFormat(previousValue);
        }
    }, [
        setFormat,
        setValue
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!(0, $37120ef32eee7a36$export$de8294bb3be0322f)(value, previousValueRef.current)) setFormat(value);
        previousValueRef.current = value;
    }, [
        value,
        setFormat
    ]);
    return {
        displayValue: displayValue,
        onChange: setDisplayValue,
        onUpdate: onUpdate
    };
}
function $831d64f343d74c7e$export$f1e1789686576879(handler, config) {
    const { emitOnEditStart: emitOnEditStart, emitOnEditEnd: emitOnEditEnd } = $831d64f343d74c7e$export$3b14a55fb2447963();
    return (0, $248db369fc8d2642$export$7941f8aafa4b6021)((state)=>{
        if (state.first) {
            document.body.classList.add('leva__panel__dragged');
            emitOnEditStart === null || emitOnEditStart === void 0 || emitOnEditStart();
        }
        const result = handler(state);
        if (state.last) {
            document.body.classList.remove('leva__panel__dragged');
            emitOnEditEnd === null || emitOnEditEnd === void 0 || emitOnEditEnd();
        }
        return result;
    }, config);
}
function $831d64f343d74c7e$export$d66501df72047452(fn) {
    const canvas = (0, $acw62.useRef)(null);
    const ctx = (0, $acw62.useRef)(null);
    const hasFired = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleCanvas = $831d64f343d74c7e$export$3a6d5c9ae78a2c08(()=>{
            canvas.current.width = canvas.current.offsetWidth * window.devicePixelRatio;
            canvas.current.height = canvas.current.offsetHeight * window.devicePixelRatio;
            fn(canvas.current, ctx.current);
        }, 250);
        window.addEventListener('resize', handleCanvas);
        if (!hasFired.current) {
            handleCanvas();
            hasFired.current = true;
        }
        return ()=>window.removeEventListener('resize', handleCanvas);
    }, [
        fn
    ]);
    (0, $acw62.useEffect)(()=>{
        ctx.current = canvas.current.getContext('2d');
    }, []);
    return [
        canvas,
        ctx
    ];
}
function $831d64f343d74c7e$export$8b22cf2602fb60ce() {
    const ref = (0, $acw62.useRef)(null);
    const local = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const set = (0, $acw62.useCallback)((point)=>{
        Object.assign(local.current, point);
        if (ref.current) ref.current.style.transform = `translate3d(${local.current.x}px, ${local.current.y}px, 0)`;
    }, []);
    return [
        ref,
        set
    ];
}
const $831d64f343d74c7e$var$_excluded$3 = [
    "__refCount"
];
const $831d64f343d74c7e$var$getInputAtPath = (data, path)=>{
    if (!data[path]) return null;
    const _data$path = data[path], input = $831d64f343d74c7e$export$23f2a1d2818174ef(_data$path, $831d64f343d74c7e$var$_excluded$3);
    return input;
};
function $831d64f343d74c7e$export$2329c99376c9d0a4(path) {
    const store = $831d64f343d74c7e$export$a9c23c6ac3fc3eca();
    const [state, setState] = (0, $acw62.useState)($831d64f343d74c7e$var$getInputAtPath(store.getData(), path));
    const set = (0, $acw62.useCallback)((value)=>store.setValueAtPath(path, value, true), [
        path,
        store
    ]);
    const setSettings = (0, $acw62.useCallback)((settings)=>store.setSettingsAtPath(path, settings), [
        path,
        store
    ]);
    const disable = (0, $acw62.useCallback)((flag)=>store.disableInputAtPath(path, flag), [
        path,
        store
    ]);
    const emitOnEditStart = (0, $acw62.useCallback)(()=>store.emitOnEditStart(path), [
        path,
        store
    ]);
    const emitOnEditEnd = (0, $acw62.useCallback)(()=>store.emitOnEditEnd(path), [
        path,
        store
    ]);
    (0, $acw62.useEffect)(()=>{
        setState($831d64f343d74c7e$var$getInputAtPath(store.getData(), path));
        const unsub = store.useStore.subscribe((s)=>$831d64f343d74c7e$var$getInputAtPath(s.data, path), setState, {
            equalityFn: (0, (/*@__PURE__*/$parcel$interopDefault($af540f293314ba66$exports)))
        });
        return ()=>unsub();
    }, [
        store,
        path
    ]);
    return [
        state,
        {
            set: set,
            setSettings: setSettings,
            disable: disable,
            storeId: store.storeId,
            emitOnEditStart: emitOnEditStart,
            emitOnEditEnd: emitOnEditEnd
        }
    ];
}
const $831d64f343d74c7e$var$RangeGrid = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    variants: {
        hasRange: {
            true: {
                position: 'relative',
                display: 'grid',
                gridTemplateColumns: 'auto $sizes$numberInputMinWidth',
                columnGap: '$colGap',
                alignItems: 'center'
            }
        }
    }
});
const $831d64f343d74c7e$export$9e5f44173e64f162 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'relative',
    width: '100%',
    height: 2,
    borderRadius: '$xs',
    backgroundColor: '$elevation1'
});
const $831d64f343d74c7e$export$25ce5a424b770e84 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'absolute',
    width: '$scrubberWidth',
    height: '$scrubberHeight',
    borderRadius: '$xs',
    boxShadow: '0 0 0 2px $colors$elevation2',
    backgroundColor: '$accent2',
    cursor: 'pointer',
    $active: 'none $accent1',
    $hover: 'none $accent3',
    variants: {
        position: {
            left: {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                transform: 'translateX(calc(-0.5 * ($sizes$scrubberWidth + 4px)))'
            },
            right: {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                transform: 'translateX(calc(0.5 * ($sizes$scrubberWidth + 4px)))'
            }
        }
    }
});
const $831d64f343d74c7e$export$882b5998b3b9117c = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'relative',
    $flex: '',
    height: '100%',
    cursor: 'pointer',
    touchAction: 'none'
});
const $831d64f343d74c7e$export$9bb611d729802a56 = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'absolute',
    height: '100%',
    backgroundColor: '$accent2'
});
function $831d64f343d74c7e$var$RangeSlider({ value: value, min: min, max: max, onDrag: onDrag, step: step, initialValue: initialValue }) {
    const ref = (0, $acw62.useRef)(null);
    const scrubberRef = (0, $acw62.useRef)(null);
    const rangeWidth = (0, $acw62.useRef)(0);
    const scrubberWidth = $831d64f343d74c7e$export$4368d992c4eafac0('sizes', 'scrubberWidth');
    const bind = $831d64f343d74c7e$export$f1e1789686576879(({ event: event, first: first, xy: [x], movement: [mx], memo: memo })=>{
        if (first) {
            const { width: width, left: left } = ref.current.getBoundingClientRect();
            rangeWidth.current = width - parseFloat(scrubberWidth);
            const targetIsScrub = (event === null || event === void 0 ? void 0 : event.target) === scrubberRef.current;
            memo = targetIsScrub ? value : $831d64f343d74c7e$export$35e795649ee09318((x - left) / width, min, max);
        }
        const newValue = memo + $831d64f343d74c7e$export$35e795649ee09318(mx / rangeWidth.current, 0, max - min);
        onDrag($831d64f343d74c7e$var$sanitizeStep$1(newValue, {
            step: step,
            initialValue: initialValue
        }));
        return memo;
    });
    const pos = $831d64f343d74c7e$export$43caf9889c228507(value, min, max);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$882b5998b3b9117c, $831d64f343d74c7e$export$2d1720544b23b823({
        ref: ref
    }, bind()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$9e5f44173e64f162, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$9bb611d729802a56, {
        style: {
            left: 0,
            right: `${(1 - pos) * 100}%`
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$25ce5a424b770e84, {
        ref: scrubberRef,
        style: {
            left: `calc(${pos} * (100% - ${scrubberWidth}))`
        }
    }));
}
const $831d64f343d74c7e$var$DraggableLabel = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ label: label, onUpdate: onUpdate, step: step, innerLabelTrim: innerLabelTrim })=>{
    const [dragging, setDragging] = (0, $acw62.useState)(false);
    const bind = $831d64f343d74c7e$export$f1e1789686576879(({ active: active, delta: [dx], event: event, memo: _memo = 0, first: first, last: last, target: target })=>{
        if (first) {
            const label = target;
            label.requestPointerLock();
        }
        if (last) document.exitPointerLock();
        setDragging(active);
        _memo += dx / 2;
        if (Math.abs(_memo) >= 1) {
            onUpdate((v)=>parseFloat(v) + Math.floor(_memo) * step * $831d64f343d74c7e$export$953cecd6e717a553(event));
            _memo = 0;
        }
        return _memo;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$InnerNumberLabel, $831d64f343d74c7e$export$2d1720544b23b823({
        dragging: dragging,
        title: label.length > 1 ? label : ''
    }, bind()), label.slice(0, innerLabelTrim));
});
function $831d64f343d74c7e$export$c3950d9923825c02({ label: label, id: id, displayValue: displayValue, onUpdate: onUpdate, onChange: onChange, settings: settings, innerLabelTrim: innerLabelTrim = 1 }) {
    const InnerLabel = innerLabelTrim > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$DraggableLabel, {
        label: label,
        step: settings.step,
        onUpdate: onUpdate,
        innerLabelTrim: innerLabelTrim
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$NumberInput, {
        id: id,
        value: String(displayValue),
        onUpdate: onUpdate,
        onChange: onChange,
        innerLabel: InnerLabel
    });
}
function $831d64f343d74c7e$var$NumberComponent() {
    const props = $831d64f343d74c7e$export$3b14a55fb2447963();
    const { label: label, value: value, onUpdate: onUpdate, settings: settings, id: id } = props;
    const { min: min, max: max } = settings;
    const hasRange = max !== Infinity && min !== -Infinity;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$db202ddc8be9136, {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$61196ced6d74a310, null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$RangeGrid, {
        hasRange: hasRange
    }, hasRange && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$RangeSlider, $831d64f343d74c7e$export$2d1720544b23b823({
        value: parseFloat(value),
        onDrag: onUpdate
    }, settings)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$c3950d9923825c02, $831d64f343d74c7e$export$2d1720544b23b823({}, props, {
        id: id,
        label: "value",
        innerLabelTrim: hasRange ? 0 : 1
    }))));
}
const { sanitizeStep: $831d64f343d74c7e$export$342063e11d6c3cad } = $831d64f343d74c7e$var$props$3, $831d64f343d74c7e$var$rest = $831d64f343d74c7e$export$23f2a1d2818174ef($831d64f343d74c7e$var$props$3, [
    "sanitizeStep"
]);
var $831d64f343d74c7e$export$6559d589eb85fbb6 = $831d64f343d74c7e$export$db3b6bfb95261072($831d64f343d74c7e$export$71511d61b312f219({
    component: $831d64f343d74c7e$var$NumberComponent
}, $831d64f343d74c7e$var$rest));
const $831d64f343d74c7e$var$schema$2 = (_o, s)=>(0, $ce56786d2aafac68$export$2e2bcd8739ae039)().schema({
        options: (0, $ce56786d2aafac68$export$2e2bcd8739ae039)().passesAnyOf((0, $ce56786d2aafac68$export$2e2bcd8739ae039)().object(), (0, $ce56786d2aafac68$export$2e2bcd8739ae039)().array())
    }).test(s);
const $831d64f343d74c7e$var$sanitize$2 = (value, { values: values })=>{
    if (values.indexOf(value) < 0) throw Error(`Selected value doesn't match Select options`);
    return value;
};
const $831d64f343d74c7e$var$format = (value, { values: values })=>{
    return values.indexOf(value);
};
const $831d64f343d74c7e$var$normalize$1 = (input)=>{
    let { value: value, options: options } = input;
    let keys;
    let values;
    if (Array.isArray(options)) {
        values = options;
        keys = options.map((o)=>String(o));
    } else {
        values = Object.values(options);
        keys = Object.keys(options);
    }
    if (!('value' in input)) value = values[0];
    else if (!values.includes(value)) {
        keys.unshift(String(value));
        values.unshift(value);
    }
    if (!Object.values(options).includes(value)) options[String(value)] = value;
    return {
        value: value,
        settings: {
            keys: keys,
            values: values
        }
    };
};
var $831d64f343d74c7e$var$props$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    schema: $831d64f343d74c7e$var$schema$2,
    sanitize: $831d64f343d74c7e$var$sanitize$2,
    format: $831d64f343d74c7e$var$format,
    normalize: $831d64f343d74c7e$var$normalize$1
});
const $831d64f343d74c7e$var$SelectContainer = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    $flexCenter: '',
    position: 'relative',
    '> svg': {
        pointerEvents: 'none',
        position: 'absolute',
        right: '$md'
    }
});
const $831d64f343d74c7e$var$NativeSelect = $831d64f343d74c7e$export$2408f22a0fab9ae5('select', {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0
});
const $831d64f343d74c7e$var$PresentationalSelect = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '$rowHeight',
    backgroundColor: '$elevation3',
    borderRadius: '$sm',
    padding: '0 $sm',
    cursor: 'pointer',
    [`${$831d64f343d74c7e$var$NativeSelect}:focus + &`]: {
        $focusStyle: ''
    },
    [`${$831d64f343d74c7e$var$NativeSelect}:hover + &`]: {
        $hoverStyle: ''
    }
});
function $831d64f343d74c7e$export$7910e0436ed8d1de({ displayValue: displayValue, value: value, onUpdate: onUpdate, id: id, settings: settings, disabled: disabled }) {
    const { keys: keys, values: values } = settings;
    const lastDisplayedValue = (0, $acw62.useRef)();
    if (value === values[displayValue]) lastDisplayedValue.current = keys[displayValue];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$SelectContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$NativeSelect, {
        id: id,
        value: displayValue,
        onChange: (e)=>onUpdate(values[Number(e.currentTarget.value)]),
        disabled: disabled
    }, keys.map((key, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: key,
            value: index
        }, key))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$PresentationalSelect, null, lastDisplayedValue.current), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$3466f893ebf79586, {
        toggled: true
    }));
}
function $831d64f343d74c7e$var$SelectComponent() {
    const { label: label, value: value, displayValue: displayValue, onUpdate: onUpdate, id: id, disabled: disabled, settings: settings } = $831d64f343d74c7e$export$3b14a55fb2447963();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$db202ddc8be9136, {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$61196ced6d74a310, null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$7910e0436ed8d1de, {
        id: id,
        value: value,
        displayValue: displayValue,
        onUpdate: onUpdate,
        settings: settings,
        disabled: disabled
    }));
}
var $831d64f343d74c7e$export$ce26c07117d59d6a = $831d64f343d74c7e$export$db3b6bfb95261072($831d64f343d74c7e$export$71511d61b312f219({
    component: $831d64f343d74c7e$var$SelectComponent
}, $831d64f343d74c7e$var$props$2));
const $831d64f343d74c7e$var$schema$1 = (o)=>(0, $ce56786d2aafac68$export$2e2bcd8739ae039)().string().test(o);
const $831d64f343d74c7e$var$sanitize$1 = (v)=>{
    if (typeof v !== 'string') throw Error(`Invalid string`);
    return v;
};
const $831d64f343d74c7e$var$normalize = ({ value: value, editable: _editable = true, rows: _rows = false })=>{
    return {
        value: value,
        settings: {
            editable: _editable,
            rows: typeof _rows === 'number' ? _rows : _rows ? 5 : 0
        }
    };
};
var $831d64f343d74c7e$var$props$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    schema: $831d64f343d74c7e$var$schema$1,
    sanitize: $831d64f343d74c7e$var$sanitize$1,
    normalize: $831d64f343d74c7e$var$normalize
});
const $831d64f343d74c7e$var$_excluded$2 = [
    "displayValue",
    "onUpdate",
    "onChange",
    "editable"
];
const $831d64f343d74c7e$var$NonEditableString = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    whiteSpace: 'pre-wrap'
});
function $831d64f343d74c7e$export$a93c5207d687da10(_ref) {
    let { displayValue: displayValue, onUpdate: onUpdate, onChange: onChange, editable: editable = true } = _ref, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$2);
    if (editable) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$e7c866399fa523f5, $831d64f343d74c7e$export$2d1720544b23b823({
        value: displayValue,
        onUpdate: onUpdate,
        onChange: onChange
    }, props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$NonEditableString, null, displayValue);
}
function $831d64f343d74c7e$var$StringComponent() {
    const { label: label, settings: settings, displayValue: displayValue, onUpdate: onUpdate, onChange: onChange } = $831d64f343d74c7e$export$3b14a55fb2447963();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$db202ddc8be9136, {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$61196ced6d74a310, null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$a93c5207d687da10, $831d64f343d74c7e$export$2d1720544b23b823({
        displayValue: displayValue,
        onUpdate: onUpdate,
        onChange: onChange
    }, settings)));
}
var $831d64f343d74c7e$export$efca4cbe5dd06740 = $831d64f343d74c7e$export$db3b6bfb95261072($831d64f343d74c7e$export$71511d61b312f219({
    component: $831d64f343d74c7e$var$StringComponent
}, $831d64f343d74c7e$var$props$1));
const $831d64f343d74c7e$var$schema = (o)=>(0, $ce56786d2aafac68$export$2e2bcd8739ae039)().boolean().test(o);
const $831d64f343d74c7e$var$sanitize = (v)=>{
    if (typeof v !== 'boolean') throw Error('Invalid boolean');
    return v;
};
var $831d64f343d74c7e$var$props = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    schema: $831d64f343d74c7e$var$schema,
    sanitize: $831d64f343d74c7e$var$sanitize
});
const $831d64f343d74c7e$var$StyledInputWrapper = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    position: 'relative',
    $flex: '',
    height: '$rowHeight',
    input: {
        $reset: '',
        height: 0,
        width: 0,
        opacity: 0,
        margin: 0
    },
    label: {
        position: 'relative',
        $flexCenter: '',
        userSelect: 'none',
        cursor: 'pointer',
        height: '$checkboxSize',
        width: '$checkboxSize',
        backgroundColor: '$elevation3',
        borderRadius: '$sm',
        $hover: ''
    },
    'input:focus + label': {
        $focusStyle: ''
    },
    'input:focus:checked + label, input:checked + label:hover': {
        $hoverStyle: '$accent3'
    },
    'input + label:active': {
        backgroundColor: '$accent1'
    },
    'input:checked + label:active': {
        backgroundColor: '$accent1'
    },
    'label > svg': {
        display: 'none',
        width: '90%',
        height: '90%',
        stroke: '$highlight3'
    },
    'input:checked + label': {
        backgroundColor: '$accent2'
    },
    'input:checked + label > svg': {
        display: 'block'
    }
});
function $831d64f343d74c7e$export$a9c996f45e5784d0({ value: value, onUpdate: onUpdate, id: id, disabled: disabled }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$StyledInputWrapper, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: id,
        type: "checkbox",
        checked: value,
        onChange: (e)=>onUpdate(e.currentTarget.checked),
        disabled: disabled
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 13l4 4L19 7"
    }))));
}
function $831d64f343d74c7e$var$BooleanComponent() {
    const { label: label, value: value, onUpdate: onUpdate, disabled: disabled, id: id } = $831d64f343d74c7e$export$3b14a55fb2447963();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$db202ddc8be9136, {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$61196ced6d74a310, null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$a9c996f45e5784d0, {
        value: value,
        onUpdate: onUpdate,
        id: id,
        disabled: disabled
    }));
}
var $831d64f343d74c7e$export$a8550f7dbe79f93a = $831d64f343d74c7e$export$db3b6bfb95261072($831d64f343d74c7e$export$71511d61b312f219({
    component: $831d64f343d74c7e$var$BooleanComponent
}, $831d64f343d74c7e$var$props));
const $831d64f343d74c7e$var$_excluded$1 = [
    "locked"
];
function $831d64f343d74c7e$var$Coordinate({ value: value, id: id, valueKey: valueKey, settings: settings, onUpdate: onUpdate, innerLabelTrim: innerLabelTrim }) {
    const valueRef = (0, $acw62.useRef)(value[valueKey]);
    valueRef.current = value[valueKey];
    const setValue = (0, $acw62.useCallback)((newValue)=>onUpdate({
            [valueKey]: $831d64f343d74c7e$var$sanitizeValue({
                type: 'NUMBER',
                value: valueRef.current,
                settings: settings
            }, newValue)
        }), [
        onUpdate,
        settings,
        valueKey
    ]);
    const number = $831d64f343d74c7e$export$ebd11618f299a286({
        type: 'NUMBER',
        value: value[valueKey],
        settings: settings,
        setValue: setValue
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$export$c3950d9923825c02, {
        id: id,
        label: valueKey,
        value: value[valueKey],
        displayValue: number.displayValue,
        onUpdate: number.onUpdate,
        onChange: number.onChange,
        settings: settings,
        innerLabelTrim: innerLabelTrim
    });
}
const $831d64f343d74c7e$var$Container = $831d64f343d74c7e$export$2408f22a0fab9ae5('div', {
    display: 'grid',
    columnGap: '$colGap',
    gridAutoFlow: 'column dense',
    alignItems: 'center',
    variants: {
        withLock: {
            true: {
                gridTemplateColumns: '10px auto',
                '> svg': {
                    cursor: 'pointer'
                }
            }
        }
    }
});
function $831d64f343d74c7e$var$Lock(_ref) {
    let { locked: locked } = _ref, props = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded$1);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $831d64f343d74c7e$export$2d1720544b23b823({
        width: "10",
        height: "10",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), locked ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}
function $831d64f343d74c7e$export$407448d2b89b1813({ value: value, onUpdate: onUpdate, settings: settings, innerLabelTrim: innerLabelTrim }) {
    const { id: id, setSettings: setSettings } = $831d64f343d74c7e$export$3b14a55fb2447963();
    const { lock: lock, locked: locked } = settings;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$Container, {
        withLock: lock
    }, lock && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$Lock, {
        locked: locked,
        onClick: ()=>setSettings({
                locked: !locked
            })
    }), Object.keys(value).map((key, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($831d64f343d74c7e$var$Coordinate, {
            id: i === 0 ? id : `${id}.${key}`,
            key: key,
            valueKey: key,
            value: value,
            settings: settings[key],
            onUpdate: onUpdate,
            innerLabelTrim: innerLabelTrim
        })));
}
const $831d64f343d74c7e$export$7ccc53e8f1e7dfc5 = (value, settings)=>{
    const _settings = {};
    let maxStep = 0;
    let minPad = Infinity;
    Object.entries(value).forEach(([key, v])=>{
        _settings[key] = $831d64f343d74c7e$var$normalize$2($831d64f343d74c7e$export$71511d61b312f219({
            value: v
        }, settings[key])).settings;
        maxStep = Math.max(maxStep, _settings[key].step);
        minPad = Math.min(minPad, _settings[key].pad);
    });
    for(let key in _settings){
        const { step: step, min: min, max: max } = settings[key] || {};
        if (!isFinite(step) && (!isFinite(min) || !isFinite(max))) {
            _settings[key].step = maxStep;
            _settings[key].pad = minPad;
        }
    }
    return _settings;
};
const $831d64f343d74c7e$var$_excluded = [
    "lock"
], $831d64f343d74c7e$var$_excluded2 = [
    "value"
];
function $831d64f343d74c7e$export$ee7c8ad385a60b7b(dimension) {
    const isVectorArray = (0, $ce56786d2aafac68$export$2e2bcd8739ae039)().array().length(dimension).every.number();
    const isVectorObject = (o)=>{
        if (!o || typeof o !== 'object') return false;
        const values = Object.values(o);
        return values.length === dimension && values.every((v)=>isFinite(v));
    };
    return (o)=>{
        return isVectorArray.test(o) || isVectorObject(o);
    };
}
function $831d64f343d74c7e$export$995eb9fca571757(value) {
    return Array.isArray(value) ? 'array' : 'object';
}
function $831d64f343d74c7e$var$convert(value, format, keys) {
    if ($831d64f343d74c7e$export$995eb9fca571757(value) === format) return value;
    return format === 'array' ? Object.values(value) : $831d64f343d74c7e$var$mapArrayToKeys(value, keys);
}
const $831d64f343d74c7e$export$f38c853ae54ed474 = (value, settings, previousValue)=>{
    const _value = $831d64f343d74c7e$var$convert(value, 'object', settings.keys);
    for(let key in _value)_value[key] = $831d64f343d74c7e$var$sanitize$3(_value[key], settings[key]);
    const _valueKeys = Object.keys(_value);
    let newValue = {};
    if (_valueKeys.length === settings.keys.length) newValue = _value;
    else {
        const _previousValue = $831d64f343d74c7e$var$convert(previousValue, 'object', settings.keys);
        if (_valueKeys.length === 1 && settings.locked) {
            const lockedKey = _valueKeys[0];
            const lockedCoordinate = _value[lockedKey];
            const previousLockedCoordinate = _previousValue[lockedKey];
            const ratio = previousLockedCoordinate !== 0 ? lockedCoordinate / previousLockedCoordinate : 1;
            for(let key in _previousValue)if (key === lockedKey) newValue[lockedKey] = lockedCoordinate;
            else newValue[key] = _previousValue[key] * ratio;
        } else newValue = $831d64f343d74c7e$export$71511d61b312f219($831d64f343d74c7e$export$71511d61b312f219({}, _previousValue), _value);
    }
    return $831d64f343d74c7e$var$convert(newValue, settings.format, settings.keys);
};
const $831d64f343d74c7e$export$3b513254972cfc9c = (value, settings)=>$831d64f343d74c7e$var$convert(value, 'object', settings.keys);
const $831d64f343d74c7e$var$isNumberSettings = (o)=>!!o && ('step' in o || 'min' in o || 'max' in o);
function $831d64f343d74c7e$export$21579262ef46735b(value, settings, defaultKeys = []) {
    const { lock: lock = false } = settings, _settings = $831d64f343d74c7e$export$23f2a1d2818174ef(settings, $831d64f343d74c7e$var$_excluded);
    const format = Array.isArray(value) ? 'array' : 'object';
    const keys = format === 'object' ? Object.keys(value) : defaultKeys;
    const _value = $831d64f343d74c7e$var$convert(value, 'object', keys);
    const mergedSettings = $831d64f343d74c7e$var$isNumberSettings(_settings) ? keys.reduce((acc, k)=>Object.assign(acc, {
            [k]: _settings
        }), {}) : _settings;
    const numberSettings = $831d64f343d74c7e$export$7ccc53e8f1e7dfc5(_value, mergedSettings);
    return {
        value: format === 'array' ? value : _value,
        settings: $831d64f343d74c7e$export$71511d61b312f219($831d64f343d74c7e$export$71511d61b312f219({}, numberSettings), {}, {
            format: format,
            keys: keys,
            lock: lock,
            locked: false
        })
    };
}
function $831d64f343d74c7e$export$39b482c5e57630a8(defaultKeys) {
    return {
        schema: $831d64f343d74c7e$export$ee7c8ad385a60b7b(defaultKeys.length),
        normalize: (_ref)=>{
            let { value: value } = _ref, settings = $831d64f343d74c7e$export$23f2a1d2818174ef(_ref, $831d64f343d74c7e$var$_excluded2);
            return $831d64f343d74c7e$export$21579262ef46735b(value, settings, defaultKeys);
        },
        format: (value, settings)=>$831d64f343d74c7e$export$3b513254972cfc9c(value, settings),
        sanitize: (value, settings, prevValue)=>$831d64f343d74c7e$export$f38c853ae54ed474(value, settings, prevValue)
    };
}



var $00fdc0fdfd66324b$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $00fdc0fdfd66324b$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $00fdc0fdfd66324b$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $00fdc0fdfd66324b$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $00fdc0fdfd66324b$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $00fdc0fdfd66324b$var$a = function(r) {
    return {
        r: $00fdc0fdfd66324b$var$e(r.r, 0, 255),
        g: $00fdc0fdfd66324b$var$e(r.g, 0, 255),
        b: $00fdc0fdfd66324b$var$e(r.b, 0, 255),
        a: $00fdc0fdfd66324b$var$e(r.a)
    };
}, $00fdc0fdfd66324b$var$o = function(r) {
    return {
        r: $00fdc0fdfd66324b$var$n(r.r),
        g: $00fdc0fdfd66324b$var$n(r.g),
        b: $00fdc0fdfd66324b$var$n(r.b),
        a: $00fdc0fdfd66324b$var$n(r.a, 3)
    };
}, $00fdc0fdfd66324b$var$i = /^#([0-9a-f]{3,8})$/i, $00fdc0fdfd66324b$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $00fdc0fdfd66324b$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $00fdc0fdfd66324b$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $00fdc0fdfd66324b$var$g = function(r) {
    return {
        h: $00fdc0fdfd66324b$var$u(r.h),
        s: $00fdc0fdfd66324b$var$e(r.s, 0, 100),
        l: $00fdc0fdfd66324b$var$e(r.l, 0, 100),
        a: $00fdc0fdfd66324b$var$e(r.a)
    };
}, $00fdc0fdfd66324b$var$d = function(r) {
    return {
        h: $00fdc0fdfd66324b$var$n(r.h),
        s: $00fdc0fdfd66324b$var$n(r.s),
        l: $00fdc0fdfd66324b$var$n(r.l),
        a: $00fdc0fdfd66324b$var$n(r.a, 3)
    };
}, $00fdc0fdfd66324b$var$f = function(r) {
    var t, n, e;
    return $00fdc0fdfd66324b$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $00fdc0fdfd66324b$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $00fdc0fdfd66324b$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $00fdc0fdfd66324b$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$y = {
    string: [
        [
            function(r) {
                var t = $00fdc0fdfd66324b$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $00fdc0fdfd66324b$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $00fdc0fdfd66324b$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $00fdc0fdfd66324b$var$v.exec(r) || $00fdc0fdfd66324b$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $00fdc0fdfd66324b$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $00fdc0fdfd66324b$var$l.exec(t) || $00fdc0fdfd66324b$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $00fdc0fdfd66324b$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($00fdc0fdfd66324b$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $00fdc0fdfd66324b$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $00fdc0fdfd66324b$var$t(n) && $00fdc0fdfd66324b$var$t(e) && $00fdc0fdfd66324b$var$t(u) ? $00fdc0fdfd66324b$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$00fdc0fdfd66324b$var$t(n) || !$00fdc0fdfd66324b$var$t(e) || !$00fdc0fdfd66324b$var$t(u)) return null;
                var i = $00fdc0fdfd66324b$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $00fdc0fdfd66324b$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$00fdc0fdfd66324b$var$t(n) || !$00fdc0fdfd66324b$var$t(a) || !$00fdc0fdfd66324b$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $00fdc0fdfd66324b$var$u(r.h),
                        s: $00fdc0fdfd66324b$var$e(r.s, 0, 100),
                        v: $00fdc0fdfd66324b$var$e(r.v, 0, 100),
                        a: $00fdc0fdfd66324b$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $00fdc0fdfd66324b$var$b(h);
            },
            "hsv"
        ]
    ]
}, $00fdc0fdfd66324b$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $00fdc0fdfd66324b$var$x = function(r) {
    return "string" == typeof r ? $00fdc0fdfd66324b$var$N(r.trim(), $00fdc0fdfd66324b$var$y.string) : "object" == typeof r && null !== r ? $00fdc0fdfd66324b$var$N(r, $00fdc0fdfd66324b$var$y.object) : [
        null,
        void 0
    ];
}, $00fdc0fdfd66324b$export$f61ac8b6f1f46202 = function(r) {
    return $00fdc0fdfd66324b$var$x(r)[1];
}, $00fdc0fdfd66324b$var$M = function(r, t) {
    var n = $00fdc0fdfd66324b$var$c(r);
    return {
        h: n.h,
        s: $00fdc0fdfd66324b$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $00fdc0fdfd66324b$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $00fdc0fdfd66324b$var$$ = function(r, t) {
    var n = $00fdc0fdfd66324b$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $00fdc0fdfd66324b$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $00fdc0fdfd66324b$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $00fdc0fdfd66324b$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $00fdc0fdfd66324b$var$n($00fdc0fdfd66324b$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $00fdc0fdfd66324b$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $00fdc0fdfd66324b$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $00fdc0fdfd66324b$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $00fdc0fdfd66324b$var$s($00fdc0fdfd66324b$var$n(255 * a)) : "", "#" + $00fdc0fdfd66324b$var$s(t) + $00fdc0fdfd66324b$var$s(e) + $00fdc0fdfd66324b$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $00fdc0fdfd66324b$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $00fdc0fdfd66324b$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $00fdc0fdfd66324b$var$d($00fdc0fdfd66324b$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $00fdc0fdfd66324b$var$d($00fdc0fdfd66324b$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $00fdc0fdfd66324b$var$h(this.rgba), {
            h: $00fdc0fdfd66324b$var$n(r.h),
            s: $00fdc0fdfd66324b$var$n(r.s),
            v: $00fdc0fdfd66324b$var$n(r.v),
            a: $00fdc0fdfd66324b$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $00fdc0fdfd66324b$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $00fdc0fdfd66324b$var$c(this.rgba);
        return "number" == typeof r ? $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $00fdc0fdfd66324b$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $00fdc0fdfd66324b$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $00fdc0fdfd66324b$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $00fdc0fdfd66324b$export$4d30ed660ff08d0 ? r : new $00fdc0fdfd66324b$export$4d30ed660ff08d0(r);
}, $00fdc0fdfd66324b$var$S = [], $00fdc0fdfd66324b$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $00fdc0fdfd66324b$var$S.indexOf(r) < 0 && (r($00fdc0fdfd66324b$export$4d30ed660ff08d0, $00fdc0fdfd66324b$var$y), $00fdc0fdfd66324b$var$S.push(r));
    });
}, $00fdc0fdfd66324b$export$4385e60b38654f68 = function() {
    return new $00fdc0fdfd66324b$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};


var $4d140387fb4c3902$exports = {};
$4d140387fb4c3902$exports = function(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, o = r[this.toHex()];
        if (o) return o;
        if (null == f ? void 0 : f.closest) {
            var n = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = n, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $498ba2dab0ae91e7$var$u() {
    return ($498ba2dab0ae91e7$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $498ba2dab0ae91e7$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $498ba2dab0ae91e7$var$i(e) {
    var t = (0, $acw62.useRef)(e), n = (0, $acw62.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $498ba2dab0ae91e7$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $498ba2dab0ae91e7$var$f = function(e) {
    return "touches" in e;
}, $498ba2dab0ae91e7$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $498ba2dab0ae91e7$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $498ba2dab0ae91e7$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $498ba2dab0ae91e7$var$s((o.pageX - (n.left + $498ba2dab0ae91e7$var$v(e).pageXOffset)) / n.width),
        top: $498ba2dab0ae91e7$var$s((o.pageY - (n.top + $498ba2dab0ae91e7$var$v(e).pageYOffset)) / n.height)
    };
}, $498ba2dab0ae91e7$var$h = function(e) {
    !$498ba2dab0ae91e7$var$f(e) && e.preventDefault();
}, $498ba2dab0ae91e7$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $498ba2dab0ae91e7$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $acw62.useRef)(null), g = $498ba2dab0ae91e7$var$i(a), p = $498ba2dab0ae91e7$var$i(l), b = (0, $acw62.useRef)(null), _ = (0, $acw62.useRef)(!1), x = (0, $acw62.useMemo)(function() {
        var e = function(e) {
            $498ba2dab0ae91e7$var$h(e), ($498ba2dab0ae91e7$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($498ba2dab0ae91e7$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $498ba2dab0ae91e7$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($498ba2dab0ae91e7$var$h(r), !function(e, r) {
                    return r && !$498ba2dab0ae91e7$var$f(e);
                }(r, _.current) && n)) {
                    if ($498ba2dab0ae91e7$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($498ba2dab0ae91e7$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $acw62.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $498ba2dab0ae91e7$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $498ba2dab0ae91e7$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $498ba2dab0ae91e7$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $498ba2dab0ae91e7$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $498ba2dab0ae91e7$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $498ba2dab0ae91e7$var$x = function(e) {
    return $498ba2dab0ae91e7$var$L($498ba2dab0ae91e7$var$C(e));
}, $498ba2dab0ae91e7$var$C = function(e) {
    return "#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? $498ba2dab0ae91e7$var$b(parseInt(e[3] + e[3], 16) / 255, 2) : 1
    } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? $498ba2dab0ae91e7$var$b(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
    };
}, $498ba2dab0ae91e7$var$E = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($498ba2dab0ae91e7$var$_[r] || 1);
}, $498ba2dab0ae91e7$var$H = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$N({
        h: $498ba2dab0ae91e7$var$E(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$M = $498ba2dab0ae91e7$var$H, $498ba2dab0ae91e7$var$N = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $498ba2dab0ae91e7$var$w = function(e) {
    return $498ba2dab0ae91e7$var$K($498ba2dab0ae91e7$var$I(e));
}, $498ba2dab0ae91e7$var$y = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $498ba2dab0ae91e7$var$b(e.h),
        s: $498ba2dab0ae91e7$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $498ba2dab0ae91e7$var$b(o / 2),
        a: $498ba2dab0ae91e7$var$b(n, 2)
    };
}, $498ba2dab0ae91e7$var$q = function(e) {
    var r = $498ba2dab0ae91e7$var$y(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $498ba2dab0ae91e7$var$k = function(e) {
    var r = $498ba2dab0ae91e7$var$y(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $498ba2dab0ae91e7$var$I = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $498ba2dab0ae91e7$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $498ba2dab0ae91e7$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $498ba2dab0ae91e7$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $498ba2dab0ae91e7$var$b(o, 2)
    };
}, $498ba2dab0ae91e7$var$O = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$A({
        h: $498ba2dab0ae91e7$var$E(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$j = $498ba2dab0ae91e7$var$O, $498ba2dab0ae91e7$var$z = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$L({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$B = $498ba2dab0ae91e7$var$z, $498ba2dab0ae91e7$var$D = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $498ba2dab0ae91e7$var$K = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = o < 1 ? $498ba2dab0ae91e7$var$D($498ba2dab0ae91e7$var$b(255 * o)) : "";
    return "#" + $498ba2dab0ae91e7$var$D(r) + $498ba2dab0ae91e7$var$D(t) + $498ba2dab0ae91e7$var$D(n) + a;
}, $498ba2dab0ae91e7$var$L = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $498ba2dab0ae91e7$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $498ba2dab0ae91e7$var$b(a ? l / a * 100 : 0),
        v: $498ba2dab0ae91e7$var$b(a / 255 * 100),
        a: o
    };
}, $498ba2dab0ae91e7$var$A = function(e) {
    return {
        h: $498ba2dab0ae91e7$var$b(e.h),
        s: $498ba2dab0ae91e7$var$b(e.s),
        v: $498ba2dab0ae91e7$var$b(e.v),
        a: $498ba2dab0ae91e7$var$b(e.a, 2)
    };
}, $498ba2dab0ae91e7$var$S = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $498ba2dab0ae91e7$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $498ba2dab0ae91e7$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuenow": $498ba2dab0ae91e7$var$b(t),
        "aria-valuemax": "360",
        "aria-valuemin": "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $498ba2dab0ae91e7$var$q({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $498ba2dab0ae91e7$var$T = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $498ba2dab0ae91e7$var$q({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $498ba2dab0ae91e7$var$s(t.s + 100 * e.left, 0, 100),
                v: $498ba2dab0ae91e7$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $498ba2dab0ae91e7$var$b(t.s) + "%, Brightness " + $498ba2dab0ae91e7$var$b(t.v) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $498ba2dab0ae91e7$var$q(t)
    })));
}), $498ba2dab0ae91e7$var$F = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $498ba2dab0ae91e7$var$P = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
}, $498ba2dab0ae91e7$var$X = function(e, r) {
    return e.toLowerCase() === r.toLowerCase() || $498ba2dab0ae91e7$var$F($498ba2dab0ae91e7$var$C(e), $498ba2dab0ae91e7$var$C(r));
};
function $498ba2dab0ae91e7$var$Y(e, t, l) {
    var u = $498ba2dab0ae91e7$var$i(l), c = (0, $acw62.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $acw62.useRef)({
        color: t,
        hsva: s
    });
    (0, $acw62.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $acw62.useEffect)(function() {
        var r;
        $498ba2dab0ae91e7$var$F(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $acw62.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $498ba2dab0ae91e7$var$R, $498ba2dab0ae91e7$var$V = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $498ba2dab0ae91e7$var$$ = function() {
    return $498ba2dab0ae91e7$var$R || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $498ba2dab0ae91e7$export$c5f670b24c0ae95a = function(e) {
    $498ba2dab0ae91e7$var$R = e;
}, $498ba2dab0ae91e7$var$J = new Map, $498ba2dab0ae91e7$var$Q = function(e) {
    $498ba2dab0ae91e7$var$V(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$498ba2dab0ae91e7$var$J.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $498ba2dab0ae91e7$var$J.set(r, t);
            var n = $498ba2dab0ae91e7$var$$();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $498ba2dab0ae91e7$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $498ba2dab0ae91e7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $498ba2dab0ae91e7$var$Q(f);
    var v = $498ba2dab0ae91e7$var$Y(o, l, i), d = v[0], h = v[1], m = $498ba2dab0ae91e7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$S, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $498ba2dab0ae91e7$var$W = {
    defaultColor: "000",
    toHsva: $498ba2dab0ae91e7$var$x,
    fromHsva: function(e) {
        return $498ba2dab0ae91e7$var$w({
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        });
    },
    equal: $498ba2dab0ae91e7$var$X
}, $498ba2dab0ae91e7$export$a3bc3c32746e9f3a = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$W
    }));
}, $498ba2dab0ae91e7$var$ee = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $498ba2dab0ae91e7$var$k(Object.assign({}, n, {
            a: 0
        })) + ", " + $498ba2dab0ae91e7$var$k(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $498ba2dab0ae91e7$var$g([
        "react-colorful__alpha",
        t
    ]), u = $498ba2dab0ae91e7$var$b(100 * n.a);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $498ba2dab0ae91e7$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": u + "%",
        "aria-valuenow": u,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $498ba2dab0ae91e7$var$k(n)
    })));
}, $498ba2dab0ae91e7$var$re = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $498ba2dab0ae91e7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $498ba2dab0ae91e7$var$Q(f);
    var v = $498ba2dab0ae91e7$var$Y(o, l, i), d = v[0], h = v[1], m = $498ba2dab0ae91e7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$S, {
        hue: d.h,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$ee, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $498ba2dab0ae91e7$var$te = {
    defaultColor: "0001",
    toHsva: $498ba2dab0ae91e7$var$x,
    fromHsva: $498ba2dab0ae91e7$var$w,
    equal: $498ba2dab0ae91e7$var$X
}, $498ba2dab0ae91e7$export$ac2f77823341da45 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$te
    }));
}, $498ba2dab0ae91e7$var$oe = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $498ba2dab0ae91e7$var$N,
    fromHsva: $498ba2dab0ae91e7$var$y,
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$ee0b0fc8d408da1d = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$oe
    }));
}, $498ba2dab0ae91e7$var$le = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $498ba2dab0ae91e7$var$H,
    fromHsva: $498ba2dab0ae91e7$var$k,
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$989f0248ad966033 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$le
    }));
}, $498ba2dab0ae91e7$var$ce = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$N({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $498ba2dab0ae91e7$var$y(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$c737d6c85aab3af7 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ce
    }));
}, $498ba2dab0ae91e7$var$se = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $498ba2dab0ae91e7$var$M,
    fromHsva: $498ba2dab0ae91e7$var$q,
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$f4f988c96ece960 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$se
    }));
}, $498ba2dab0ae91e7$var$ve = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $498ba2dab0ae91e7$var$A,
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$a2298f22bee4c5fd = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ve
    }));
}, $498ba2dab0ae91e7$var$he = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $498ba2dab0ae91e7$var$O,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$A(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$b2c7d62665b7ee26 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$he
    }));
}, $498ba2dab0ae91e7$var$ge = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$A(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$580e7249020ee39f = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ge
    }));
}, $498ba2dab0ae91e7$var$be = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $498ba2dab0ae91e7$var$j,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$A(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$ef09412d0ef04fda = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$be
    }));
}, $498ba2dab0ae91e7$var$xe = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $498ba2dab0ae91e7$var$L,
    fromHsva: $498ba2dab0ae91e7$var$I,
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$e9c07ef2be187cb1 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$xe
    }));
}, $498ba2dab0ae91e7$var$Ee = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $498ba2dab0ae91e7$var$z,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$I(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$be07dcc7abc11a36 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$Ee
    }));
}, $498ba2dab0ae91e7$var$Me = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$L({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $498ba2dab0ae91e7$var$I(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$5ac2ba36722d4bd2 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$Me
    }));
}, $498ba2dab0ae91e7$var$we = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $498ba2dab0ae91e7$var$B,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$I(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$9d70f030bf44a214 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$we
    }));
}, $498ba2dab0ae91e7$var$qe = /^#?([0-9A-F]{3,8})$/i, $498ba2dab0ae91e7$var$ke = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $498ba2dab0ae91e7$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $acw62.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $498ba2dab0ae91e7$var$i(s), C = $498ba2dab0ae91e7$var$i(f), E = (0, $acw62.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $acw62.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $acw62.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $498ba2dab0ae91e7$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $498ba2dab0ae91e7$var$Ie = function(e) {
    return "#" + e;
}, $498ba2dab0ae91e7$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $498ba2dab0ae91e7$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $acw62.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $acw62.useCallback)(function(e) {
        return function(e, r) {
            var t = $498ba2dab0ae91e7$var$qe.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$ke, $498ba2dab0ae91e7$var$u({}, o, {
        escape: l,
        format: t ? $498ba2dab0ae91e7$var$Ie : void 0,
        process: $498ba2dab0ae91e7$var$Ie,
        validate: i
    }));
};







var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        'aac',
        'audio/aac'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'ico',
        'image/vnd.microsoft.icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'js',
        'text/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mjs',
        'text/javascript'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'opus',
        'audio/opus'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'ppt',
        'application/vnd.ms-powerpoint'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'rar',
        'application/vnd.rar'
    ],
    [
        'rtf',
        'application/rtf'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'wav',
        'audio/wav'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    // Others
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            if ($7ac450b547cb7da9$var$isObject(evt) && $7ac450b547cb7da9$var$isDataTransfer(evt)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($7ac450b547cb7da9$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return 'getFile' in item && typeof item.getFile === 'function';
            })) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDataTransfer(value) {
    return $7ac450b547cb7da9$var$isObject(value.dataTransfer);
}
function $7ac450b547cb7da9$var$isChangeEvt(value) {
    return $7ac450b547cb7da9$var$isObject(value) && $7ac450b547cb7da9$var$isObject(value.target);
}
function $7ac450b547cb7da9$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    return $7ac450b547cb7da9$var$fromList(evt.target.files).map(function(file) {
        return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $7ac450b547cb7da9$var$getFsHandleFiles(handles) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (dt === null) return [
                        2 /*return*/ ,
                        []
                    ];
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === 'file';
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $5c96a02c592fcff1$export$afc72e2116322959)(acc, Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $dac22b55eb23ffcc$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
}; // File Errors
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $000a86df99a95c54$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        return accepted && sizeMatch;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$918e231928a33e68(accept) {
    accept = typeof accept === "string" ? accept.split(",") : accept;
    return [
        {
            description: "everything",
            // TODO: Need to handle filtering more elegantly than this!
            accept: Array.isArray(accept) ? // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
            accept.filter(function(item) {
                return item === "audio/*" || item === "video/*" || item === "image/*" || item === "text/*" || /\w+\/[-+.\w]+/g.test(item);
            }).reduce(function(a, b) {
                return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, a), {}, $aaac53b849ab07d4$var$_defineProperty({}, b, []));
            }, {}) : {}
        }
    ];
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}



var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $7ac450b547cb7da9$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$options = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), options), accept = _defaultProps$options.accept, disabled = _defaultProps$options.disabled, getFilesFromEvent = _defaultProps$options.getFilesFromEvent, maxSize = _defaultProps$options.maxSize, minSize = _defaultProps$options.minSize, multiple = _defaultProps$options.multiple, maxFiles = _defaultProps$options.maxFiles, onDragEnter = _defaultProps$options.onDragEnter, onDragLeave = _defaultProps$options.onDragLeave, onDragOver = _defaultProps$options.onDragOver, onDrop = _defaultProps$options.onDrop, onDropAccepted = _defaultProps$options.onDropAccepted, onDropRejected = _defaultProps$options.onDropRejected, onFileDialogCancel = _defaultProps$options.onFileDialogCancel, onFileDialogOpen = _defaultProps$options.onFileDialogOpen, useFsAccessApi = _defaultProps$options.useFsAccessApi, preventDropOnDocument = _defaultProps$options.preventDropOnDocument, noClick = _defaultProps$options.noClick, noKeyboard = _defaultProps$options.noKeyboard, noDrag = _defaultProps$options.noDrag, noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling, validator = _defaultProps$options.validator;
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $aaac53b849ab07d4$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: "setDraggedFiles",
            draggedFiles: []
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, accept), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        accept,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: (0, $aaac53b849ab07d4$export$918e231928a33e68)(accept)
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $aaac53b849ab07d4$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $aaac53b849ab07d4$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    }
                }
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        accept,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "button"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple,
        maxFiles: maxFiles
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}



var $5ec635760157368f$exports = {};
'use strict';
Object.defineProperty($5ec635760157368f$exports, '__esModule', {
    value: true
});
function $5ec635760157368f$var$_extends() {
    $5ec635760157368f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ec635760157368f$var$_extends.apply(this, arguments);
}
var $5ec635760157368f$var$redux = function redux(reducer, initial) {
    return function(set, get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $5ec635760157368f$var$_extends({
            dispatch: function dispatch() {
                return api.dispatch.apply(api, arguments);
            }
        }, initial);
    };
};
function $5ec635760157368f$var$devtools(fn, options) {
    return function(set, get, api) {
        var _serialize;
        var didWarnAboutNameDeprecation = false;
        if (typeof options === 'string' && !didWarnAboutNameDeprecation) {
            console.warn("[zustand devtools middleware]: passing `name` as directly will be not allowed in next majorpass the `name` in an object `{ name: ... }` instead");
            didWarnAboutNameDeprecation = true;
        }
        var devtoolsOptions = options === undefined ? {
            name: undefined,
            anonymousActionType: undefined
        } : typeof options === 'string' ? {
            name: options
        } : options;
        if (typeof (devtoolsOptions == null ? void 0 : (_serialize = devtoolsOptions.serialize) == null ? void 0 : _serialize.options) !== 'undefined') console.warn('[zustand devtools middleware]: `serialize.options` is deprecated, just use `serialize`');
        var extensionConnector;
        try {
            extensionConnector = window.__REDUX_DEVTOOLS_EXTENSION__ || window.top.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_unused) {}
        if (!extensionConnector) return fn(set, get, api);
        var extension = Object.create(extensionConnector.connect(devtoolsOptions));
        var didWarnAboutDevtools = false;
        Object.defineProperty(api, 'devtools', {
            get: function get() {
                if (!didWarnAboutDevtools) {
                    console.warn("[zustand devtools middleware] `devtools` property on the store is deprecated it will be removed in the next major.\nYou shouldn't interact with the extension directly. But in case you still want to you can patch `window.__REDUX_DEVTOOLS_EXTENSION__` directly");
                    didWarnAboutDevtools = true;
                }
                return extension;
            },
            set: function set(value) {
                if (!didWarnAboutDevtools) {
                    console.warn("[zustand devtools middleware] `api.devtools` is deprecated, it will be removed in the next major.\nYou shouldn't interact with the extension directly. But in case you still want to you can patch `window.__REDUX_DEVTOOLS_EXTENSION__` directly");
                    didWarnAboutDevtools = true;
                }
                extension = value;
            }
        });
        var didWarnAboutPrefix = false;
        Object.defineProperty(extension, 'prefix', {
            get: function get() {
                if (!didWarnAboutPrefix) {
                    console.warn((devtoolsOptions.name, ', because the `name` option already creates a separate instance of devtools for each store.'));
                    didWarnAboutPrefix = true;
                }
                return '';
            },
            set: function set() {
                if (!didWarnAboutPrefix) {
                    console.warn((devtoolsOptions.name, ', because the `name` option already creates a separate instance of devtools for each store.'));
                    didWarnAboutPrefix = true;
                }
            }
        });
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            set(state, replace);
            if (!isRecording) return;
            extension.send(nameOrAction === undefined ? {
                type: devtoolsOptions.anonymousActionType || 'anonymous'
            } : typeof nameOrAction === 'string' ? {
                type: nameOrAction
            } : nameOrAction, get());
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        extension.init(initialState);
        if (api.dispatchFromDevtools && typeof api.dispatch === 'function') {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                if (a[0].type === '__setState' && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch.apply(void 0, a);
            };
        }
        extension.subscribe(function(message) {
            switch(message.type){
                case 'ACTION':
                    if (typeof message.payload !== 'string') {
                        console.error('[zustand devtools middleware] Unsupported action format');
                        return;
                    }
                    return $5ec635760157368f$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === '__setState') {
                            setStateFromDevtools(action.state);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== 'function') return;
                        api.dispatch(action);
                    });
                case 'DISPATCH':
                    switch(message.payload.type){
                        case 'RESET':
                            setStateFromDevtools(initialState);
                            return extension.init(api.getState());
                        case 'COMMIT':
                            return extension.init(api.getState());
                        case 'ROLLBACK':
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                setStateFromDevtools(state);
                                extension.init(api.getState());
                            });
                        case 'JUMP_TO_STATE':
                        case 'JUMP_TO_ACTION':
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                setStateFromDevtools(state);
                            });
                        case 'IMPORT_STATE':
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            setStateFromDevtools(lastComputedState);
                            extension.send(null, nextLiftedState);
                            return;
                        case 'PAUSE_RECORDING':
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
}
var $5ec635760157368f$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error('[zustand devtools middleware] Could not parse the received json', e);
    }
    if (parsed !== undefined) f(parsed);
};
var $5ec635760157368f$var$subscribeWithSelector = function subscribeWithSelector(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $5ec635760157368f$var$combine = function combine(initialState, create) {
    return function(set, get, api) {
        return Object.assign({}, initialState, create(set, get, api));
    };
};
var $5ec635760157368f$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $5ec635760157368f$var$persist = function persist(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        if (options.blacklist || options.whitelist) console.warn("The " + (options.blacklist ? 'blacklist' : 'whitelist') + " option is deprecated and will be removed in the next version. Please use the 'partialize' option instead.");
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        else if (!storage.removeItem) console.warn("[zustand persist middleware] The given storage for item '" + options.name + "' does not contain a 'removeItem' method, which will be required in v4.");
        var thenableSerialize = $5ec635760157368f$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            if (options.whitelist) Object.keys(state).forEach(function(key) {
                var _options$whitelist;
                !((_options$whitelist = options.whitelist) != null && _options$whitelist.includes(key)) && delete state[key];
            });
            if (options.blacklist) options.blacklist.forEach(function(key) {
                return delete state[key];
            });
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $5ec635760157368f$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem == null || _storage.removeItem(options.name);
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
$5ec635760157368f$exports.combine = $5ec635760157368f$var$combine;
$5ec635760157368f$exports.devtools = $5ec635760157368f$var$devtools;
$5ec635760157368f$exports.persist = $5ec635760157368f$var$persist;
$5ec635760157368f$exports.redux = $5ec635760157368f$var$redux;
$5ec635760157368f$exports.subscribeWithSelector = $5ec635760157368f$var$subscribeWithSelector;



var $4641125ee45a47cb$exports = {};
'use strict';
var $f22f23063f43412f$exports = {};
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
var $fc211f3d944510b3$exports = {};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
var $9aeedbfcea60166c$exports = {};
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
$9aeedbfcea60166c$exports = function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


function $fc211f3d944510b3$var$isObjectObject(o) {
    return $9aeedbfcea60166c$exports(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
$fc211f3d944510b3$exports = function isPlainObject(o) {
    var ctor, prot;
    if ($fc211f3d944510b3$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    prot = ctor.prototype;
    if ($fc211f3d944510b3$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
};


$f22f23063f43412f$exports = function isExtendable(val) {
    return $fc211f3d944510b3$exports(val) || typeof val === 'function' || Array.isArray(val);
};


var $604fec391964d6db$exports = {};
'use strict';

var $4642bed929a3b5b0$exports = {};
/*!
 * for-in <https://github.com/jonschlinkert/for-in>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
$4642bed929a3b5b0$exports = function forIn(obj, fn, thisArg) {
    for(var key in obj){
        if (fn.call(thisArg, obj[key], key, obj) === false) break;
    }
};


function $604fec391964d6db$var$mixinDeep(target, objects) {
    var len = arguments.length, i = 0;
    while(++i < len){
        var obj = arguments[i];
        if ($604fec391964d6db$var$isObject(obj)) $4642bed929a3b5b0$exports(obj, $604fec391964d6db$var$copy, target);
    }
    return target;
}
/**
 * Copy properties from the source object to the
 * target object.
 *
 * @param  {*} `val`
 * @param  {String} `key`
 */ function $604fec391964d6db$var$copy(val, key) {
    if (!$604fec391964d6db$var$isValidKey(key)) return;
    var obj = this[key];
    if ($604fec391964d6db$var$isObject(val) && $604fec391964d6db$var$isObject(obj)) $604fec391964d6db$var$mixinDeep(obj, val);
    else this[key] = val;
}
/**
 * Returns true if `val` is an object or function.
 *
 * @param  {any} val
 * @return {Boolean}
 */ function $604fec391964d6db$var$isObject(val) {
    return $f22f23063f43412f$exports(val) && !Array.isArray(val);
}
/**
 * Returns true if `key` is a valid key to use when extending objects.
 *
 * @param  {String} `key`
 * @return {Boolean}
 */ function $604fec391964d6db$var$isValidKey(key) {
    return key !== '__proto__' && key !== 'constructor' && key !== 'prototype';
}
/**
 * Expose `mixinDeep`
 */ $604fec391964d6db$exports = $604fec391964d6db$var$mixinDeep;


var $1a3e35f52705a2da$exports = {};
/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ $1a3e35f52705a2da$exports = function(obj, prop, a, b, c) {
    if (!$1a3e35f52705a2da$var$isObject(obj) || !prop) return obj;
    prop = $1a3e35f52705a2da$var$toString(prop);
    // allowing for multiple properties to be passed as
    // a string or array, but much faster (3-4x) than doing
    // `[].slice.call(arguments)`
    if (a) prop += '.' + $1a3e35f52705a2da$var$toString(a);
    if (b) prop += '.' + $1a3e35f52705a2da$var$toString(b);
    if (c) prop += '.' + $1a3e35f52705a2da$var$toString(c);
    if (prop in obj) return obj[prop];
    var segs = prop.split('.');
    var len = segs.length;
    var i = -1;
    while(obj && ++i < len){
        var key = segs[i];
        while(key[key.length - 1] === '\\')key = key.slice(0, -1) + '.' + segs[++i];
        obj = obj[key];
    }
    return obj;
};
function $1a3e35f52705a2da$var$isObject(val) {
    return val !== null && (typeof val === 'object' || typeof val === 'function');
}
function $1a3e35f52705a2da$var$toString(val) {
    if (!val) return '';
    if (Array.isArray(val)) return val.join('.');
    return val;
}


var $0077f8bdcd039d42$exports = {};
/*!
 * set-value <https://github.com/jonschlinkert/set-value>
 *
 * Copyright (c) 2014-2015, 2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
var $5e84a10027ab8c18$exports = {};
/*!
 * split-string <https://github.com/jonschlinkert/split-string>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
var $efe0c3e987deb30d$exports = {};
'use strict';

var $50a5402159be1144$exports = {};
/*!
 * assign-symbols <https://github.com/jonschlinkert/assign-symbols>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ 'use strict';
$50a5402159be1144$exports = function(receiver, objects) {
    if (receiver === null || typeof receiver === 'undefined') throw new TypeError('expected first argument to be an object.');
    if (typeof objects === 'undefined' || typeof Symbol === 'undefined') return receiver;
    if (typeof Object.getOwnPropertySymbols !== 'function') return receiver;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var target = Object(receiver);
    var len = arguments.length, i = 0;
    while(++i < len){
        var provider = Object(arguments[i]);
        var names = Object.getOwnPropertySymbols(provider);
        for(var j = 0; j < names.length; j++){
            var key = names[j];
            if (isEnumerable.call(provider, key)) target[key] = provider[key];
        }
    }
    return target;
};


$efe0c3e987deb30d$exports = Object.assign || function(obj /*, objects*/ ) {
    if (obj === null || typeof obj === 'undefined') throw new TypeError('Cannot convert undefined or null to object');
    if (!$efe0c3e987deb30d$var$isObject(obj)) obj = {};
    for(var i = 1; i < arguments.length; i++){
        var val = arguments[i];
        if ($efe0c3e987deb30d$var$isString(val)) val = $efe0c3e987deb30d$var$toObject(val);
        if ($efe0c3e987deb30d$var$isObject(val)) {
            $efe0c3e987deb30d$var$assign(obj, val);
            $50a5402159be1144$exports(obj, val);
        }
    }
    return obj;
};
function $efe0c3e987deb30d$var$assign(a, b) {
    for(var key in b)if ($efe0c3e987deb30d$var$hasOwn(b, key)) a[key] = b[key];
}
function $efe0c3e987deb30d$var$isString(val) {
    return val && typeof val === 'string';
}
function $efe0c3e987deb30d$var$toObject(str) {
    var obj = {};
    for(var i in str)obj[i] = str[i];
    return obj;
}
function $efe0c3e987deb30d$var$isObject(val) {
    return val && typeof val === 'object' || $f22f23063f43412f$exports(val);
}
/**
 * Returns true if the given `key` is an own property of `obj`.
 */ function $efe0c3e987deb30d$var$hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $efe0c3e987deb30d$var$isEnum(obj, key) {
    return Object.prototype.propertyIsEnumerable.call(obj, key);
}


$5e84a10027ab8c18$exports = function(str, options, fn) {
    if (typeof str !== 'string') throw new TypeError('expected a string');
    if (typeof options === 'function') {
        fn = options;
        options = null;
    }
    // allow separator to be defined as a string
    if (typeof options === 'string') options = {
        sep: options
    };
    var opts = $efe0c3e987deb30d$exports({
        sep: '.'
    }, options);
    var quotes = opts.quotes || [
        '"',
        "'",
        '`'
    ];
    var brackets;
    if (opts.brackets === true) brackets = {
        '<': '>',
        '(': ')',
        '[': ']',
        '{': '}'
    };
    else if (opts.brackets) brackets = opts.brackets;
    var tokens = [];
    var stack = [];
    var arr = [
        ''
    ];
    var sep = opts.sep;
    var len = str.length;
    var idx = -1;
    var closeIdx;
    function expected() {
        if (brackets && stack.length) return brackets[stack[stack.length - 1]];
    }
    while(++idx < len){
        var ch = str[idx];
        var next = str[idx + 1];
        var tok = {
            val: ch,
            idx: idx,
            arr: arr,
            str: str
        };
        tokens.push(tok);
        if (ch === '\\') {
            tok.val = $5e84a10027ab8c18$var$keepEscaping(opts, str, idx) === true ? ch + next : next;
            tok.escaped = true;
            if (typeof fn === 'function') fn(tok);
            arr[arr.length - 1] += tok.val;
            idx++;
            continue;
        }
        if (brackets && brackets[ch]) {
            stack.push(ch);
            var e = expected();
            var i = idx + 1;
            if (str.indexOf(e, i + 1) !== -1) while(stack.length && i < len){
                var s = str[++i];
                if (s === '\\') {
                    s++;
                    continue;
                }
                if (quotes.indexOf(s) !== -1) {
                    i = $5e84a10027ab8c18$var$getClosingQuote(str, s, i + 1);
                    continue;
                }
                e = expected();
                if (stack.length && str.indexOf(e, i + 1) === -1) break;
                if (brackets[s]) {
                    stack.push(s);
                    continue;
                }
                if (e === s) stack.pop();
            }
            closeIdx = i;
            if (closeIdx === -1) {
                arr[arr.length - 1] += ch;
                continue;
            }
            ch = str.slice(idx, closeIdx + 1);
            tok.val = ch;
            tok.idx = idx = closeIdx;
        }
        if (quotes.indexOf(ch) !== -1) {
            closeIdx = $5e84a10027ab8c18$var$getClosingQuote(str, ch, idx + 1);
            if (closeIdx === -1) {
                arr[arr.length - 1] += ch;
                continue;
            }
            if ($5e84a10027ab8c18$var$keepQuotes(ch, opts) === true) ch = str.slice(idx, closeIdx + 1);
            else ch = str.slice(idx + 1, closeIdx);
            tok.val = ch;
            tok.idx = idx = closeIdx;
        }
        if (typeof fn === 'function') {
            fn(tok, tokens);
            ch = tok.val;
            idx = tok.idx;
        }
        if (tok.val === sep && tok.split !== false) {
            arr.push('');
            continue;
        }
        arr[arr.length - 1] += tok.val;
    }
    return arr;
};
function $5e84a10027ab8c18$var$getClosingQuote(str, ch, i, brackets) {
    var idx = str.indexOf(ch, i);
    if (str.charAt(idx - 1) === '\\') return $5e84a10027ab8c18$var$getClosingQuote(str, ch, idx + 1);
    return idx;
}
function $5e84a10027ab8c18$var$keepQuotes(ch, opts) {
    if (opts.keepDoubleQuotes === true && ch === '"') return true;
    if (opts.keepSingleQuotes === true && ch === "'") return true;
    return opts.keepQuotes;
}
function $5e84a10027ab8c18$var$keepEscaping(opts, str, idx) {
    if (typeof opts.keepEscaping === 'function') return opts.keepEscaping(str, idx);
    return opts.keepEscaping === true || str[idx + 1] === '\\';
}


var $b407412e0f7a479a$exports = {};
'use strict';
var $e3f0f02ae2299847$exports = {};
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ 'use strict';
$e3f0f02ae2299847$exports = function isExtendable(val) {
    return typeof val !== 'undefined' && val !== null && (typeof val === 'object' || typeof val === 'function');
};


$b407412e0f7a479a$exports = function extend(o /*, objects*/ ) {
    if (!$e3f0f02ae2299847$exports(o)) o = {};
    var len = arguments.length;
    for(var i = 1; i < len; i++){
        var obj = arguments[i];
        if ($e3f0f02ae2299847$exports(obj)) $b407412e0f7a479a$var$assign(o, obj);
    }
    return o;
};
function $b407412e0f7a479a$var$assign(a, b) {
    for(var key in b)if ($b407412e0f7a479a$var$hasOwn(b, key)) a[key] = b[key];
}
/**
 * Returns true if the given `key` is an own property of `obj`.
 */ function $b407412e0f7a479a$var$hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}



var $cacec6c54f0ff1d2$exports = {};
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ 'use strict';
$cacec6c54f0ff1d2$exports = function isExtendable(val) {
    return typeof val !== 'undefined' && val !== null && (typeof val === 'object' || typeof val === 'function');
};


$0077f8bdcd039d42$exports = function(obj, prop, val) {
    if (!$cacec6c54f0ff1d2$exports(obj)) return obj;
    if (Array.isArray(prop)) prop = [].concat.apply([], prop).join('.');
    if (typeof prop !== 'string') return obj;
    var keys = $5e84a10027ab8c18$exports(prop, {
        sep: '.',
        brackets: true
    }).filter($0077f8bdcd039d42$var$isValidKey);
    var len = keys.length;
    var idx = -1;
    var current = obj;
    while(++idx < len){
        var key = keys[idx];
        if (idx !== len - 1) {
            if (!$cacec6c54f0ff1d2$exports(current[key])) current[key] = {};
            current = current[key];
            continue;
        }
        if ($fc211f3d944510b3$exports(current[key]) && $fc211f3d944510b3$exports(val)) current[key] = $b407412e0f7a479a$exports({}, current[key], val);
        else current[key] = val;
    }
    return obj;
};
function $0077f8bdcd039d42$var$isValidKey(key) {
    return key !== '__proto__' && key !== 'constructor' && key !== 'prototype';
}


$4641125ee45a47cb$exports = function mergeValue(obj, prop, value) {
    if (!$f22f23063f43412f$exports(obj)) throw new TypeError('expected an object');
    if (typeof prop !== 'string' || value == null) return $604fec391964d6db$exports.apply(null, arguments);
    if (typeof value === 'string') {
        $0077f8bdcd039d42$exports(obj, prop, value);
        return obj;
    }
    var current = $1a3e35f52705a2da$exports(obj, prop);
    if ($f22f23063f43412f$exports(value) && $f22f23063f43412f$exports(current)) value = $604fec391964d6db$exports({}, current, value);
    $0077f8bdcd039d42$exports(obj, prop, value);
    return obj;
};



const $0a1f391ff5b244cb$var$join = (...args)=>args.filter(Boolean).join('.');
function $0a1f391ff5b244cb$var$getKeyPath(path) {
    const dir = path.split('.');
    return [
        dir.pop(),
        dir.join('.') || undefined
    ];
}
function $0a1f391ff5b244cb$var$getValuesForPaths(data, paths) {
    return Object.entries((0, $831d64f343d74c7e$export$ffb5f4729a158638)(data, paths)).reduce((acc, [, { value: value, disabled: disabled, key: key }])=>{
        acc[key] = disabled ? undefined : value;
        return acc;
    }, {});
}
function $0a1f391ff5b244cb$var$useCompareMemoize(value, deep) {
    const ref = (0, $acw62.useRef)();
    const compare = deep ? (0, $37120ef32eee7a36$export$de8294bb3be0322f) : (0, (/*@__PURE__*/$parcel$interopDefault($af540f293314ba66$exports)));
    if (!compare(value, ref.current)) ref.current = value;
    return ref.current;
}
function $0a1f391ff5b244cb$var$useDeepMemo(fn, deps) {
    return (0, $acw62.useMemo)(fn, $0a1f391ff5b244cb$var$useCompareMemoize(deps, true));
}
function $0a1f391ff5b244cb$var$useToggle(toggled) {
    const wrapperRef = (0, $acw62.useRef)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const firstRender = (0, $acw62.useRef)(true);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!toggled) {
            wrapperRef.current.style.height = '0px';
            wrapperRef.current.style.overflow = 'hidden';
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        let timeout;
        const ref = wrapperRef.current;
        const fixHeight = ()=>{
            if (toggled) {
                ref.style.removeProperty('height');
                ref.style.removeProperty('overflow');
                contentRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            }
        };
        ref.addEventListener('transitionend', fixHeight, {
            once: true
        });
        const { height: height } = contentRef.current.getBoundingClientRect();
        ref.style.height = height + 'px';
        if (!toggled) {
            ref.style.overflow = 'hidden';
            timeout = window.setTimeout(()=>ref.style.height = '0px', 50);
        }
        return ()=>{
            ref.removeEventListener('transitionend', fixHeight);
            clearTimeout(timeout);
        };
    }, [
        toggled
    ]);
    return {
        wrapperRef: wrapperRef,
        contentRef: contentRef
    };
}
const $0a1f391ff5b244cb$var$useVisiblePaths = (store)=>{
    const [paths, setPaths] = (0, $acw62.useState)(store.getVisiblePaths());
    (0, $acw62.useEffect)(()=>{
        setPaths(store.getVisiblePaths());
        const unsub = store.useStore.subscribe(store.getVisiblePaths, setPaths, {
            equalityFn: (0, (/*@__PURE__*/$parcel$interopDefault($af540f293314ba66$exports)))
        });
        return ()=>unsub();
    }, [
        store
    ]);
    return paths;
};
function $0a1f391ff5b244cb$var$useValuesForPath(store, paths, initialData) {
    const valuesForPath = store.useStore((s)=>{
        const data = (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, initialData), s.data);
        return $0a1f391ff5b244cb$var$getValuesForPaths(data, paths);
    }, (0, (/*@__PURE__*/$parcel$interopDefault($af540f293314ba66$exports))));
    return valuesForPath;
}
function $0a1f391ff5b244cb$var$usePopin(margin = 3) {
    const popinRef = (0, $acw62.useRef)(null);
    const wrapperRef = (0, $acw62.useRef)(null);
    const [shown, setShow] = (0, $acw62.useState)(false);
    const show = (0, $acw62.useCallback)(()=>setShow(true), []);
    const hide = (0, $acw62.useCallback)(()=>setShow(false), []);
    (0, $acw62.useLayoutEffect)(()=>{
        if (shown) {
            const { bottom: bottom, top: top, left: left } = popinRef.current.getBoundingClientRect();
            const { height: height } = wrapperRef.current.getBoundingClientRect();
            const direction = bottom + height > window.innerHeight - 40 ? 'up' : 'down';
            wrapperRef.current.style.position = 'fixed';
            wrapperRef.current.style.zIndex = '10000';
            wrapperRef.current.style.left = left + 'px';
            if (direction === 'down') wrapperRef.current.style.top = bottom + margin + 'px';
            else wrapperRef.current.style.bottom = window.innerHeight - top + margin + 'px';
        }
    }, [
        margin,
        shown
    ]);
    return {
        popinRef: popinRef,
        wrapperRef: wrapperRef,
        shown: shown,
        show: show,
        hide: hide
    };
}
(0, $00fdc0fdfd66324b$export$8b58be045bf06082)([
    (0, (/*@__PURE__*/$parcel$interopDefault($4d140387fb4c3902$exports)))
]);
const $0a1f391ff5b244cb$var$convertMap = {
    rgb: 'toRgb',
    hsl: 'toHsl',
    hsv: 'toHsv',
    hex: 'toHex'
};
(0, $ce56786d2aafac68$export$2e2bcd8739ae039).extend({
    color: ()=>(value)=>(0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(value).isValid()
});
const $0a1f391ff5b244cb$var$schema$2 = (o)=>(0, $ce56786d2aafac68$export$2e2bcd8739ae039)().color().test(o);
function $0a1f391ff5b244cb$var$convert(color, { format: format, hasAlpha: hasAlpha, isString: isString }) {
    const convertFn = $0a1f391ff5b244cb$var$convertMap[format] + (isString && format !== 'hex' ? 'String' : '');
    const result = color[convertFn]();
    return typeof result === 'object' && !hasAlpha ? (0, $831d64f343d74c7e$export$ae1af26003f05816)(result, [
        'a'
    ]) : result;
}
const $0a1f391ff5b244cb$var$sanitize$2 = (v, settings)=>{
    const color = (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(v);
    if (!color.isValid()) throw Error('Invalid color');
    return $0a1f391ff5b244cb$var$convert(color, settings);
};
const $0a1f391ff5b244cb$var$format$1 = (v, settings)=>{
    return $0a1f391ff5b244cb$var$convert((0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(v), (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, settings), {}, {
        isString: true,
        format: 'hex'
    }));
};
const $0a1f391ff5b244cb$var$normalize$3 = ({ value: value })=>{
    const _f = (0, $00fdc0fdfd66324b$export$f61ac8b6f1f46202)(value);
    const format = _f === 'name' ? 'hex' : _f;
    const hasAlpha = typeof value === 'object' ? 'a' in value : _f === 'hex' && value.length === 8 || /^(rgba)|(hsla)|(hsva)/.test(value);
    const settings = {
        format: format,
        hasAlpha: hasAlpha,
        isString: typeof value === 'string'
    };
    return {
        value: $0a1f391ff5b244cb$var$sanitize$2(value, settings),
        settings: settings
    };
};
var $0a1f391ff5b244cb$var$props$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    schema: $0a1f391ff5b244cb$var$schema$2,
    sanitize: $0a1f391ff5b244cb$var$sanitize$2,
    format: $0a1f391ff5b244cb$var$format$1,
    normalize: $0a1f391ff5b244cb$var$normalize$3
});
const $0a1f391ff5b244cb$var$ColorPreview = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    position: 'relative',
    boxSizing: 'border-box',
    borderRadius: '$sm',
    overflow: 'hidden',
    cursor: 'pointer',
    height: '$rowHeight',
    width: '$rowHeight',
    backgroundColor: '#fff',
    backgroundImage: `url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')`,
    $inputStyle: '',
    $hover: '',
    zIndex: 1,
    variants: {
        active: {
            true: {
                $inputStyle: '$accent1'
            }
        }
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'currentColor',
        zIndex: 1
    }
});
const $0a1f391ff5b244cb$var$PickerContainer = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '$sizes$rowHeight auto',
    columnGap: '$colGap',
    alignItems: 'center'
});
const $0a1f391ff5b244cb$var$PickerWrapper = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    width: '$colorPickerWidth',
    height: '$colorPickerHeight',
    '.react-colorful': {
        width: '100%',
        height: '100%',
        boxShadow: '$level2',
        cursor: 'crosshair'
    },
    '.react-colorful__saturation': {
        borderRadius: '$sm $sm 0 0'
    },
    '.react-colorful__alpha, .react-colorful__hue': {
        height: 10
    },
    '.react-colorful__last-control': {
        borderRadius: '0 0 $sm $sm'
    },
    '.react-colorful__pointer': {
        height: 12,
        width: 12
    }
});
function $0a1f391ff5b244cb$var$convertToRgb(value, format) {
    return format !== 'rgb' ? (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(value).toRgb() : value;
}
function $0a1f391ff5b244cb$var$Color({ value: value, displayValue: displayValue, settings: settings, onUpdate: onUpdate }) {
    const { emitOnEditStart: emitOnEditStart, emitOnEditEnd: emitOnEditEnd } = (0, $831d64f343d74c7e$export$3b14a55fb2447963)();
    const { format: format, hasAlpha: hasAlpha } = settings;
    const { popinRef: popinRef, wrapperRef: wrapperRef, shown: shown, show: show, hide: hide } = $0a1f391ff5b244cb$var$usePopin();
    const timer = (0, $acw62.useRef)(0);
    const [initialRgb, setInitialRgb] = (0, $acw62.useState)(()=>$0a1f391ff5b244cb$var$convertToRgb(value, format));
    const ColorPicker = hasAlpha ? (0, $498ba2dab0ae91e7$export$e9c07ef2be187cb1) : (0, $498ba2dab0ae91e7$export$5ac2ba36722d4bd2);
    const showPicker = ()=>{
        setInitialRgb($0a1f391ff5b244cb$var$convertToRgb(value, format));
        show();
        emitOnEditStart();
    };
    const hidePicker = ()=>{
        hide();
        emitOnEditEnd();
        window.clearTimeout(timer.current);
    };
    const hideAfterDelay = ()=>{
        timer.current = window.setTimeout(hidePicker, 500);
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>window.clearTimeout(timer.current);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$ColorPreview, {
        ref: popinRef,
        active: shown,
        onClick: ()=>showPicker(),
        style: {
            color: displayValue
        }
    }), shown && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$56c0d5a1e737357d), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$c4ce752e73470fba), {
        onPointerUp: hidePicker
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$PickerWrapper, {
        ref: wrapperRef,
        onMouseEnter: ()=>window.clearTimeout(timer.current),
        onMouseLeave: (e)=>e.buttons === 0 && hideAfterDelay()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ColorPicker, {
        color: initialRgb,
        onChange: onUpdate
    }))));
}
function $0a1f391ff5b244cb$var$ColorComponent() {
    const { value: value, displayValue: displayValue, label: label, onChange: onChange, onUpdate: onUpdate, settings: settings } = (0, $831d64f343d74c7e$export$3b14a55fb2447963)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$PickerContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Color, {
        value: value,
        displayValue: displayValue,
        onChange: onChange,
        onUpdate: onUpdate,
        settings: settings
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$e7c866399fa523f5), {
        value: displayValue,
        onChange: onChange,
        onUpdate: onUpdate
    })));
}
var $0a1f391ff5b244cb$var$color = (0, $831d64f343d74c7e$export$db3b6bfb95261072)((0, $831d64f343d74c7e$export$71511d61b312f219)({
    component: $0a1f391ff5b244cb$var$ColorComponent
}, $0a1f391ff5b244cb$var$props$2));
function $0a1f391ff5b244cb$var$Vector3dComponent() {
    const { label: label, displayValue: displayValue, onUpdate: onUpdate, settings: settings } = (0, $831d64f343d74c7e$export$3b14a55fb2447963)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$407448d2b89b1813), {
        value: displayValue,
        settings: settings,
        onUpdate: onUpdate
    }));
}
var $0a1f391ff5b244cb$var$vector3d = (0, $831d64f343d74c7e$export$db3b6bfb95261072)((0, $831d64f343d74c7e$export$71511d61b312f219)({
    component: $0a1f391ff5b244cb$var$Vector3dComponent
}, (0, $831d64f343d74c7e$export$39b482c5e57630a8)([
    'x',
    'y',
    'z'
])));
const $0a1f391ff5b244cb$var$JoystickTrigger = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flexCenter: '',
    position: 'relative',
    backgroundColor: '$elevation3',
    borderRadius: '$sm',
    cursor: 'pointer',
    height: '$rowHeight',
    width: '$rowHeight',
    touchAction: 'none',
    $draggable: '',
    $hover: '',
    '&:active': {
        cursor: 'none'
    },
    '&::after': {
        content: '""',
        backgroundColor: '$accent2',
        height: 4,
        width: 4,
        borderRadius: 2
    }
});
const $0a1f391ff5b244cb$var$JoystickPlayground = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flexCenter: '',
    width: '$joystickWidth',
    height: '$joystickHeight',
    borderRadius: '$sm',
    boxShadow: '$level2',
    position: 'fixed',
    zIndex: 10000,
    overflow: 'hidden',
    $draggable: '',
    transform: 'translate(-50%, -50%)',
    variants: {
        isOutOfBounds: {
            true: {
                backgroundColor: '$elevation1'
            },
            false: {
                backgroundColor: '$elevation3'
            }
        }
    },
    '> div': {
        position: 'absolute',
        $flexCenter: '',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '$highlight1',
        backgroundColor: '$elevation3',
        width: '80%',
        height: '80%',
        '&::after,&::before': {
            content: '""',
            position: 'absolute',
            zindex: 10,
            backgroundColor: '$highlight1'
        },
        '&::before': {
            width: '100%',
            height: 1
        },
        '&::after': {
            height: '100%',
            width: 1
        }
    },
    '> span': {
        position: 'relative',
        zindex: 100,
        width: 10,
        height: 10,
        backgroundColor: '$accent2',
        borderRadius: '50%'
    }
});
function $0a1f391ff5b244cb$var$Joystick({ value: value, settings: settings, onUpdate: onUpdate }) {
    const timeout = (0, $acw62.useRef)();
    const outOfBoundsX = (0, $acw62.useRef)(0);
    const outOfBoundsY = (0, $acw62.useRef)(0);
    const stepMultiplier = (0, $acw62.useRef)(1);
    const [joystickShown, setShowJoystick] = (0, $acw62.useState)(false);
    const [isOutOfBounds, setIsOutOfBounds] = (0, $acw62.useState)(false);
    const [spanRef, set] = (0, $831d64f343d74c7e$export$8b22cf2602fb60ce)();
    const joystickeRef = (0, $acw62.useRef)(null);
    const playgroundRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (joystickShown) {
            const { top: top, left: left, width: width, height: height } = joystickeRef.current.getBoundingClientRect();
            playgroundRef.current.style.left = left + width / 2 + 'px';
            playgroundRef.current.style.top = top + height / 2 + 'px';
        }
    }, [
        joystickShown
    ]);
    const { keys: [v1, v2], joystick: joystick } = settings;
    const yFactor = joystick === 'invertY' ? 1 : -1;
    const { [v1]: { step: stepV1 }, [v2]: { step: stepV2 } } = settings;
    const wpx = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('sizes', 'joystickWidth');
    const hpx = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('sizes', 'joystickHeight');
    const w = parseFloat(wpx) * 0.8 / 2;
    const h = parseFloat(hpx) * 0.8 / 2;
    const startOutOfBounds = (0, $acw62.useCallback)(()=>{
        if (timeout.current) return;
        setIsOutOfBounds(true);
        if (outOfBoundsX.current) set({
            x: outOfBoundsX.current * w
        });
        if (outOfBoundsY.current) set({
            y: outOfBoundsY.current * -h
        });
        timeout.current = window.setInterval(()=>{
            onUpdate((v)=>{
                const incX = stepV1 * outOfBoundsX.current * stepMultiplier.current;
                const incY = yFactor * stepV2 * outOfBoundsY.current * stepMultiplier.current;
                return Array.isArray(v) ? {
                    [v1]: v[0] + incX,
                    [v2]: v[1] + incY
                } : {
                    [v1]: v[v1] + incX,
                    [v2]: v[v2] + incY
                };
            });
        }, 16);
    }, [
        w,
        h,
        onUpdate,
        set,
        stepV1,
        stepV2,
        v1,
        v2,
        yFactor
    ]);
    const endOutOfBounds = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(timeout.current);
        timeout.current = undefined;
        setIsOutOfBounds(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        function setStepMultiplier(event) {
            stepMultiplier.current = (0, $831d64f343d74c7e$export$953cecd6e717a553)(event);
        }
        window.addEventListener('keydown', setStepMultiplier);
        window.addEventListener('keyup', setStepMultiplier);
        return ()=>{
            window.clearTimeout(timeout.current);
            window.removeEventListener('keydown', setStepMultiplier);
            window.removeEventListener('keyup', setStepMultiplier);
        };
    }, []);
    const bind = (0, $831d64f343d74c7e$export$f1e1789686576879)(({ first: first, active: active, delta: [dx, dy], movement: [mx, my] })=>{
        if (first) setShowJoystick(true);
        const _x = (0, $831d64f343d74c7e$export$dda1d9f60106f0e9)(mx, -w, w);
        const _y = (0, $831d64f343d74c7e$export$dda1d9f60106f0e9)(my, -h, h);
        outOfBoundsX.current = Math.abs(mx) > Math.abs(_x) ? Math.sign(mx - _x) : 0;
        outOfBoundsY.current = Math.abs(my) > Math.abs(_y) ? Math.sign(_y - my) : 0;
        let newX = value[v1];
        let newY = value[v2];
        if (active) {
            if (!outOfBoundsX.current) {
                newX += dx * stepV1 * stepMultiplier.current;
                set({
                    x: _x
                });
            }
            if (!outOfBoundsY.current) {
                newY -= yFactor * dy * stepV2 * stepMultiplier.current;
                set({
                    y: _y
                });
            }
            if (outOfBoundsX.current || outOfBoundsY.current) startOutOfBounds();
            else endOutOfBounds();
            onUpdate({
                [v1]: newX,
                [v2]: newY
            });
        } else {
            setShowJoystick(false);
            outOfBoundsX.current = 0;
            outOfBoundsY.current = 0;
            set({
                x: 0,
                y: 0
            });
            endOutOfBounds();
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$JoystickTrigger, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        ref: joystickeRef
    }, bind()), joystickShown && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$56c0d5a1e737357d), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$JoystickPlayground, {
        ref: playgroundRef,
        isOutOfBounds: isOutOfBounds
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: spanRef
    }))));
}
const $0a1f391ff5b244cb$var$Container$1 = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    display: 'grid',
    columnGap: '$colGap',
    variants: {
        withJoystick: {
            true: {
                gridTemplateColumns: '$sizes$rowHeight auto'
            },
            false: {
                gridTemplateColumns: 'auto'
            }
        }
    }
});
function $0a1f391ff5b244cb$var$Vector2dComponent() {
    const { label: label, displayValue: displayValue, onUpdate: onUpdate, settings: settings } = (0, $831d64f343d74c7e$export$3b14a55fb2447963)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Container$1, {
        withJoystick: !!settings.joystick
    }, settings.joystick && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Joystick, {
        value: displayValue,
        settings: settings,
        onUpdate: onUpdate
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$407448d2b89b1813), {
        value: displayValue,
        settings: settings,
        onUpdate: onUpdate
    })));
}
const $0a1f391ff5b244cb$var$_excluded$7 = [
    "joystick"
];
const $0a1f391ff5b244cb$var$plugin = (0, $831d64f343d74c7e$export$39b482c5e57630a8)([
    'x',
    'y'
]);
const $0a1f391ff5b244cb$var$normalize$2 = (_ref)=>{
    let { joystick: joystick = true } = _ref, input = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(_ref, $0a1f391ff5b244cb$var$_excluded$7);
    const { value: value, settings: settings } = $0a1f391ff5b244cb$var$plugin.normalize(input);
    return {
        value: value,
        settings: (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, settings), {}, {
            joystick: joystick
        })
    };
};
var $0a1f391ff5b244cb$var$vector2d = (0, $831d64f343d74c7e$export$db3b6bfb95261072)((0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({
    component: $0a1f391ff5b244cb$var$Vector2dComponent
}, $0a1f391ff5b244cb$var$plugin), {}, {
    normalize: $0a1f391ff5b244cb$var$normalize$2
}));
const $0a1f391ff5b244cb$var$sanitize$1 = (v)=>{
    if (v === undefined) return undefined;
    if (v instanceof File) try {
        return URL.createObjectURL(v);
    } catch (e) {
        return undefined;
    }
    if (typeof v === 'string' && v.indexOf('blob:') === 0) return v;
    throw Error(`Invalid image format [undefined | blob |\xa0File].`);
};
const $0a1f391ff5b244cb$var$schema$1 = (_o, s)=>typeof s === 'object' && 'image' in s;
const $0a1f391ff5b244cb$var$normalize$1 = ({ image: image })=>{
    return {
        value: image
    };
};
var $0a1f391ff5b244cb$var$props$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    sanitize: $0a1f391ff5b244cb$var$sanitize$1,
    schema: $0a1f391ff5b244cb$var$schema$1,
    normalize: $0a1f391ff5b244cb$var$normalize$1
});
const $0a1f391ff5b244cb$var$ImageContainer = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '$sizes$rowHeight auto 20px',
    columnGap: '$colGap',
    alignItems: 'center'
});
const $0a1f391ff5b244cb$var$DropZone = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flexCenter: '',
    overflow: 'hidden',
    height: '$rowHeight',
    background: '$elevation3',
    textAlign: 'center',
    color: 'inherit',
    borderRadius: '$sm',
    outline: 'none',
    userSelect: 'none',
    cursor: 'pointer',
    $inputStyle: '',
    $hover: '',
    $focusWithin: '',
    $active: '$accent1 $elevation1',
    variants: {
        isDragAccept: {
            true: {
                $inputStyle: '$accent1',
                backgroundColor: '$elevation1'
            }
        }
    }
});
const $0a1f391ff5b244cb$var$ImagePreview = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    boxSizing: 'border-box',
    borderRadius: '$sm',
    height: '$rowHeight',
    width: '$rowHeight',
    $inputStyle: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    variants: {
        hasImage: {
            true: {
                cursor: 'pointer',
                $hover: '',
                $active: ''
            }
        }
    }
});
const $0a1f391ff5b244cb$var$ImageLargePreview = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flexCenter: '',
    width: '$imagePreviewWidth',
    height: '$imagePreviewHeight',
    borderRadius: '$sm',
    boxShadow: '$level2',
    pointerEvents: 'none',
    $inputStyle: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
});
const $0a1f391ff5b244cb$var$Instructions = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    fontSize: '0.8em',
    height: '100%',
    padding: '$rowGap $md'
});
const $0a1f391ff5b244cb$var$Remove = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flexCenter: '',
    top: '0',
    right: '0',
    marginRight: '$sm',
    height: '100%',
    cursor: 'pointer',
    variants: {
        disabled: {
            true: {
                color: '$elevation3',
                cursor: 'default'
            }
        }
    },
    '&::after,&::before': {
        content: '""',
        position: 'absolute',
        height: 2,
        width: 10,
        borderRadius: 1,
        backgroundColor: 'currentColor'
    },
    '&::after': {
        transform: 'rotate(45deg)'
    },
    '&::before': {
        transform: 'rotate(-45deg)'
    }
});
function $0a1f391ff5b244cb$var$ImageComponent() {
    const { label: label, value: value, onUpdate: onUpdate, disabled: disabled } = (0, $831d64f343d74c7e$export$3b14a55fb2447963)();
    const { popinRef: popinRef, wrapperRef: wrapperRef, shown: shown, show: show, hide: hide } = $0a1f391ff5b244cb$var$usePopin();
    const onDrop = (0, $acw62.useCallback)((acceptedFiles)=>{
        if (acceptedFiles.length) onUpdate(acceptedFiles[0]);
    }, [
        onUpdate
    ]);
    const clear = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        onUpdate(undefined);
    }, [
        onUpdate
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragAccept: isDragAccept } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        maxFiles: 1,
        accept: 'image/*',
        onDrop: onDrop,
        disabled: disabled
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$ImageContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$ImagePreview, {
        ref: popinRef,
        hasImage: !!value,
        onPointerDown: ()=>!!value && show(),
        onPointerUp: hide,
        style: {
            backgroundImage: value ? `url(${value})` : 'none'
        }
    }), shown && !!value && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$56c0d5a1e737357d), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$c4ce752e73470fba), {
        onPointerUp: hide,
        style: {
            cursor: 'pointer'
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$ImageLargePreview, {
        ref: wrapperRef,
        style: {
            backgroundImage: `url(${value})`
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$DropZone, getRootProps({
        isDragAccept: isDragAccept
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", getInputProps()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Instructions, null, isDragAccept ? 'drop image' : 'click or drop')), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Remove, {
        onClick: clear,
        disabled: !value
    })));
}
var $0a1f391ff5b244cb$var$image = (0, $831d64f343d74c7e$export$db3b6bfb95261072)((0, $831d64f343d74c7e$export$71511d61b312f219)({
    component: $0a1f391ff5b244cb$var$ImageComponent
}, $0a1f391ff5b244cb$var$props$1));
const $0a1f391ff5b244cb$var$number = (0, $ce56786d2aafac68$export$2e2bcd8739ae039)().number();
const $0a1f391ff5b244cb$var$schema = (o, s)=>(0, $ce56786d2aafac68$export$2e2bcd8739ae039)().array().length(2).every.number().test(o) && (0, $ce56786d2aafac68$export$2e2bcd8739ae039)().schema({
        min: $0a1f391ff5b244cb$var$number,
        max: $0a1f391ff5b244cb$var$number
    }).test(s);
const $0a1f391ff5b244cb$var$format = (v)=>({
        min: v[0],
        max: v[1]
    });
const $0a1f391ff5b244cb$var$sanitize = (value, { bounds: [MIN, MAX] }, prevValue)=>{
    const _value = Array.isArray(value) ? $0a1f391ff5b244cb$var$format(value) : value;
    const _newValue = {
        min: prevValue[0],
        max: prevValue[1]
    };
    const { min: min, max: max } = (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, _newValue), _value);
    return [
        (0, $831d64f343d74c7e$export$dda1d9f60106f0e9)(Number(min), MIN, Math.max(MIN, max)),
        (0, $831d64f343d74c7e$export$dda1d9f60106f0e9)(Number(max), Math.min(MAX, min), MAX)
    ];
};
const $0a1f391ff5b244cb$var$normalize = ({ value: value, min: min, max: max })=>{
    const boundsSettings = {
        min: min,
        max: max
    };
    const _settings = (0, $831d64f343d74c7e$export$7ccc53e8f1e7dfc5)($0a1f391ff5b244cb$var$format(value), {
        min: boundsSettings,
        max: boundsSettings
    });
    const bounds = [
        min,
        max
    ];
    const settings = (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, _settings), {}, {
        bounds: bounds
    });
    const _value = $0a1f391ff5b244cb$var$sanitize($0a1f391ff5b244cb$var$format(value), settings, value);
    return {
        value: _value,
        settings: settings
    };
};
var $0a1f391ff5b244cb$var$props = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    schema: $0a1f391ff5b244cb$var$schema,
    format: $0a1f391ff5b244cb$var$format,
    sanitize: $0a1f391ff5b244cb$var$sanitize,
    normalize: $0a1f391ff5b244cb$var$normalize
});
const $0a1f391ff5b244cb$var$_excluded$6 = [
    "value",
    "bounds",
    "onDrag"
], $0a1f391ff5b244cb$var$_excluded2$1 = [
    "bounds"
];
const $0a1f391ff5b244cb$var$Container = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    display: 'grid',
    columnGap: '$colGap',
    gridTemplateColumns: 'auto calc($sizes$numberInputMinWidth * 2 + $space$rowGap)'
});
function $0a1f391ff5b244cb$var$IntervalSlider(_ref) {
    let { value: value, bounds: [min, max], onDrag: onDrag } = _ref, settings = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(_ref, $0a1f391ff5b244cb$var$_excluded$6);
    const ref = (0, $acw62.useRef)(null);
    const minScrubberRef = (0, $acw62.useRef)(null);
    const maxScrubberRef = (0, $acw62.useRef)(null);
    const rangeWidth = (0, $acw62.useRef)(0);
    const scrubberWidth = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('sizes', 'scrubberWidth');
    const bind = (0, $831d64f343d74c7e$export$f1e1789686576879)(({ event: event, first: first, xy: [x], movement: [mx], memo: _memo = {} })=>{
        if (first) {
            const { width: width, left: left } = ref.current.getBoundingClientRect();
            rangeWidth.current = width - parseFloat(scrubberWidth);
            const targetIsScrub = (event === null || event === void 0 ? void 0 : event.target) === minScrubberRef.current || (event === null || event === void 0 ? void 0 : event.target) === maxScrubberRef.current;
            _memo.pos = (0, $831d64f343d74c7e$export$35e795649ee09318)((x - left) / width, min, max);
            const delta = Math.abs(_memo.pos - value.min) - Math.abs(_memo.pos - value.max);
            _memo.key = delta < 0 || delta === 0 && _memo.pos <= value.min ? 'min' : 'max';
            if (targetIsScrub) _memo.pos = value[_memo.key];
        }
        const newValue = _memo.pos + (0, $831d64f343d74c7e$export$35e795649ee09318)(mx / rangeWidth.current, 0, max - min);
        onDrag({
            [_memo.key]: (0, $831d64f343d74c7e$export$342063e11d6c3cad)(newValue, settings[_memo.key])
        });
        return _memo;
    });
    const minStyle = `calc(${(0, $831d64f343d74c7e$export$43caf9889c228507)(value.min, min, max)} * (100% - ${scrubberWidth} - 8px) + 4px)`;
    const maxStyle = `calc(${1 - (0, $831d64f343d74c7e$export$43caf9889c228507)(value.max, min, max)} * (100% - ${scrubberWidth} - 8px) + 4px)`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$882b5998b3b9117c), (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        ref: ref
    }, bind()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$9e5f44173e64f162), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$9bb611d729802a56), {
        style: {
            left: minStyle,
            right: maxStyle
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$25ce5a424b770e84), {
        position: "left",
        ref: minScrubberRef,
        style: {
            left: minStyle
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$25ce5a424b770e84), {
        position: "right",
        ref: maxScrubberRef,
        style: {
            right: maxStyle
        }
    }));
}
function $0a1f391ff5b244cb$var$IntervalComponent() {
    const { label: label, displayValue: displayValue, onUpdate: onUpdate, settings: settings } = (0, $831d64f343d74c7e$export$3b14a55fb2447963)();
    const _settings = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(settings, $0a1f391ff5b244cb$var$_excluded2$1);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Container, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$IntervalSlider, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        value: displayValue
    }, settings, {
        onDrag: onUpdate
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$407448d2b89b1813), {
        value: displayValue,
        settings: _settings,
        onUpdate: onUpdate,
        innerLabelTrim: 0
    }))));
}
var $0a1f391ff5b244cb$var$interval = (0, $831d64f343d74c7e$export$db3b6bfb95261072)((0, $831d64f343d74c7e$export$71511d61b312f219)({
    component: $0a1f391ff5b244cb$var$IntervalComponent
}, $0a1f391ff5b244cb$var$props));
const $0a1f391ff5b244cb$var$createEventEmitter = ()=>{
    const listenerMapping = new Map();
    return {
        on: (topic, listener)=>{
            let listeners = listenerMapping.get(topic);
            if (listeners === undefined) {
                listeners = new Set();
                listenerMapping.set(topic, listeners);
            }
            listeners.add(listener);
        },
        off: (topic, listener)=>{
            const listeners = listenerMapping.get(topic);
            if (listeners === undefined) return;
            listeners.delete(listener);
            if (listeners.size === 0) listenerMapping.delete(topic);
        },
        emit: (topic, ...args)=>{
            const listeners = listenerMapping.get(topic);
            if (listeners === undefined) return;
            for (const listener of listeners)listener(...args);
        }
    };
};
const $0a1f391ff5b244cb$var$_excluded$5 = [
    "type",
    "value"
], $0a1f391ff5b244cb$var$_excluded2 = [
    "onChange",
    "transient",
    "onEditStart",
    "onEditEnd"
];
const $0a1f391ff5b244cb$var$Store = function Store() {
    const store = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((0, $5ec635760157368f$exports.subscribeWithSelector)(()=>({
            data: {}
        })));
    const eventEmitter = $0a1f391ff5b244cb$var$createEventEmitter();
    this.storeId = (0, $831d64f343d74c7e$export$625550452a3fa3ec)();
    this.useStore = store;
    const folders = {};
    const orderedPaths = new Set();
    this.getVisiblePaths = ()=>{
        const data = this.getData();
        const paths = Object.keys(data);
        const hiddenFolders = [];
        Object.entries(folders).forEach(([path, settings])=>{
            if (settings.render && paths.some((p)=>p.indexOf(path) === 0) && !settings.render(this.get)) hiddenFolders.push(path + '.');
        });
        const visiblePaths = [];
        orderedPaths.forEach((path)=>{
            if (path in data && data[path].__refCount > 0 && hiddenFolders.every((p)=>path.indexOf(p) === -1) && (!data[path].render || data[path].render(this.get))) visiblePaths.push(path);
        });
        return visiblePaths;
    };
    this.setOrderedPaths = (newPaths)=>{
        newPaths.forEach((p)=>orderedPaths.add(p));
    };
    this.orderPaths = (paths)=>{
        this.setOrderedPaths(paths);
        return paths;
    };
    this.disposePaths = (paths)=>{
        store.setState((s)=>{
            const data = s.data;
            paths.forEach((path)=>{
                if (path in data) {
                    const input = data[path];
                    input.__refCount--;
                    if (input.__refCount === 0 && input.type in (0, $831d64f343d74c7e$export$90a7f3efeed30595)) delete data[path];
                }
            });
            return {
                data: data
            };
        });
    };
    this.dispose = ()=>{
        store.setState(()=>{
            return {
                data: {}
            };
        });
    };
    this.getFolderSettings = (path)=>{
        return folders[path] || {};
    };
    this.getData = ()=>{
        return store.getState().data;
    };
    this.addData = (newData, override)=>{
        store.setState((s)=>{
            const data = s.data;
            Object.entries(newData).forEach(([path, newInputData])=>{
                let input = data[path];
                if (!!input) {
                    const { type: type, value: value } = newInputData, rest = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(newInputData, $0a1f391ff5b244cb$var$_excluded$5);
                    if (type !== input.type) (0, $831d64f343d74c7e$export$efccba1c4a2ef57b)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).INPUT_TYPE_OVERRIDE, type);
                    else {
                        if (input.__refCount === 0 || override) Object.assign(input, rest);
                        input.__refCount++;
                    }
                } else data[path] = (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, newInputData), {}, {
                    __refCount: 1
                });
            });
            return {
                data: data
            };
        });
    };
    this.setValueAtPath = (path, value, fromPanel)=>{
        store.setState((s)=>{
            const data = s.data;
            (0, $831d64f343d74c7e$export$4a5767248b18ef41)(data[path], value, path, this, fromPanel);
            return {
                data: data
            };
        });
    };
    this.setSettingsAtPath = (path, settings)=>{
        store.setState((s)=>{
            const data = s.data;
            data[path].settings = (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, data[path].settings), settings);
            return {
                data: data
            };
        });
    };
    this.disableInputAtPath = (path, flag)=>{
        store.setState((s)=>{
            const data = s.data;
            data[path].disabled = flag;
            return {
                data: data
            };
        });
    };
    this.set = (values, fromPanel)=>{
        store.setState((s)=>{
            const data = s.data;
            Object.entries(values).forEach(([path, value])=>{
                try {
                    (0, $831d64f343d74c7e$export$4a5767248b18ef41)(data[path], value, undefined, undefined, fromPanel);
                } catch (e) {}
            });
            return {
                data: data
            };
        });
    };
    this.getInput = (path)=>{
        try {
            return this.getData()[path];
        } catch (e) {
            (0, $831d64f343d74c7e$export$efccba1c4a2ef57b)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).PATH_DOESNT_EXIST, path);
        }
    };
    this.get = (path)=>{
        var _this$getInput;
        return (_this$getInput = this.getInput(path)) === null || _this$getInput === void 0 ? void 0 : _this$getInput.value;
    };
    this.emitOnEditStart = (path)=>{
        eventEmitter.emit(`onEditStart:${path}`, this.get(path), path, (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, this.getInput(path)), {}, {
            get: this.get
        }));
    };
    this.emitOnEditEnd = (path)=>{
        eventEmitter.emit(`onEditEnd:${path}`, this.get(path), path, (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, this.getInput(path)), {}, {
            get: this.get
        }));
    };
    this.subscribeToEditStart = (path, listener)=>{
        const _path = `onEditStart:${path}`;
        eventEmitter.on(_path, listener);
        return ()=>eventEmitter.off(_path, listener);
    };
    this.subscribeToEditEnd = (path, listener)=>{
        const _path = `onEditEnd:${path}`;
        eventEmitter.on(_path, listener);
        return ()=>eventEmitter.off(_path, listener);
    };
    const _getDataFromSchema = (schema, rootPath, mappedPaths)=>{
        const data = {};
        Object.entries(schema).forEach(([key, rawInput])=>{
            if (key === '') return (0, $831d64f343d74c7e$export$efccba1c4a2ef57b)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).EMPTY_KEY);
            let newPath = $0a1f391ff5b244cb$var$join(rootPath, key);
            if (rawInput.type === (0, $831d64f343d74c7e$export$90a7f3efeed30595).FOLDER) {
                const newData = _getDataFromSchema(rawInput.schema, newPath, mappedPaths);
                Object.assign(data, newData);
                if (!(newPath in folders)) folders[newPath] = rawInput.settings;
            } else if (key in mappedPaths) (0, $831d64f343d74c7e$export$efccba1c4a2ef57b)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).DUPLICATE_KEYS, key, newPath, mappedPaths[key].path);
            else {
                const normalizedInput = (0, $831d64f343d74c7e$export$df995fae86a55f06)(rawInput, key, newPath, data);
                if (normalizedInput) {
                    const { type: type, options: options, input: input } = normalizedInput;
                    const { onChange: onChange, transient: transient, onEditStart: onEditStart, onEditEnd: onEditEnd } = options, _options = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(options, $0a1f391ff5b244cb$var$_excluded2);
                    data[newPath] = (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({
                        type: type
                    }, _options), input), {}, {
                        fromPanel: true
                    });
                    mappedPaths[key] = {
                        path: newPath,
                        onChange: onChange,
                        transient: transient,
                        onEditStart: onEditStart,
                        onEditEnd: onEditEnd
                    };
                } else (0, $831d64f343d74c7e$export$efccba1c4a2ef57b)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).UNKNOWN_INPUT, newPath, rawInput);
            }
        });
        return data;
    };
    this.getDataFromSchema = (schema)=>{
        const mappedPaths = {};
        const data = _getDataFromSchema(schema, '', mappedPaths);
        return [
            data,
            mappedPaths
        ];
    };
};
const $0a1f391ff5b244cb$export$5db3dddc38dade5b = new $0a1f391ff5b244cb$var$Store();
function $0a1f391ff5b244cb$export$3cefd400e876a0cf() {
    return (0, $acw62.useMemo)(()=>new $0a1f391ff5b244cb$var$Store(), []);
}
const $0a1f391ff5b244cb$var$defaultSettings$2 = {
    collapsed: false
};
function $0a1f391ff5b244cb$export$e00584a723d0ee75(schema, settings) {
    return {
        type: (0, $831d64f343d74c7e$export$90a7f3efeed30595).FOLDER,
        schema: schema,
        settings: (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, $0a1f391ff5b244cb$var$defaultSettings$2), settings)
    };
}
const $0a1f391ff5b244cb$var$defaultSettings$1 = {
    disabled: false
};
function $0a1f391ff5b244cb$export$2ba01fb71ed41cb6(onClick, settings) {
    return {
        type: (0, $831d64f343d74c7e$export$90a7f3efeed30595).BUTTON,
        onClick: onClick,
        settings: (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, $0a1f391ff5b244cb$var$defaultSettings$1), settings)
    };
}
function $0a1f391ff5b244cb$export$9c686a975407e95c(opts) {
    return {
        type: (0, $831d64f343d74c7e$export$90a7f3efeed30595).BUTTON_GROUP,
        opts: opts
    };
}
const $0a1f391ff5b244cb$var$defaultSettings = {
    graph: false,
    interval: 100
};
function $0a1f391ff5b244cb$export$ec5b303098bc4b7f(objectOrFn, settings) {
    return {
        type: (0, $831d64f343d74c7e$export$90a7f3efeed30595).MONITOR,
        objectOrFn: objectOrFn,
        settings: (0, $831d64f343d74c7e$export$71511d61b312f219)((0, $831d64f343d74c7e$export$71511d61b312f219)({}, $0a1f391ff5b244cb$var$defaultSettings), settings)
    };
}
const $0a1f391ff5b244cb$var$isInput = (v)=>'__levaInput' in v;
const $0a1f391ff5b244cb$var$buildTree = (paths, filter)=>{
    const tree = {};
    const _filter = filter ? filter.toLowerCase() : null;
    paths.forEach((path)=>{
        const [valueKey, folderPath] = $0a1f391ff5b244cb$var$getKeyPath(path);
        if (!_filter || valueKey.toLowerCase().indexOf(_filter) > -1) (0, (/*@__PURE__*/$parcel$interopDefault($4641125ee45a47cb$exports)))(tree, folderPath, {
            [valueKey]: {
                __levaInput: true,
                path: path
            }
        });
    });
    return tree;
};
const $0a1f391ff5b244cb$var$_excluded$4 = [
    "type",
    "label",
    "path",
    "valueKey",
    "value",
    "settings",
    "setValue",
    "disabled"
];
function $0a1f391ff5b244cb$var$ControlInput(_ref) {
    let { type: type, label: label, path: path, valueKey: valueKey, value: value, settings: settings, setValue: setValue, disabled: disabled } = _ref, rest = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(_ref, $0a1f391ff5b244cb$var$_excluded$4);
    const { displayValue: displayValue, onChange: onChange, onUpdate: onUpdate } = (0, $831d64f343d74c7e$export$ebd11618f299a286)({
        type: type,
        value: value,
        settings: settings,
        setValue: setValue
    });
    const Input = (0, $831d64f343d74c7e$export$ef35774e6d314e91)[type].component;
    if (!Input) {
        (0, $831d64f343d74c7e$export$efccba1c4a2ef57b)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).NO_COMPONENT_FOR_TYPE, type, path);
        return null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$e7094788287c5e9b).Provider, {
        value: (0, $831d64f343d74c7e$export$71511d61b312f219)({
            key: valueKey,
            path: path,
            id: '' + path,
            label: label,
            displayValue: displayValue,
            value: value,
            onChange: onChange,
            onUpdate: onUpdate,
            settings: settings,
            setValue: setValue,
            disabled: disabled
        }, rest)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$96f57966bedc81b4), {
        disabled: disabled
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, null)));
}
const $0a1f391ff5b244cb$var$StyledButton = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('button', {
    display: 'block',
    $reset: '',
    fontWeight: '$button',
    height: '$rowHeight',
    borderStyle: 'none',
    borderRadius: '$sm',
    backgroundColor: '$elevation1',
    color: '$highlight1',
    '&:not(:disabled)': {
        color: '$highlight3',
        backgroundColor: '$accent2',
        cursor: 'pointer',
        $hover: '$accent3',
        $active: '$accent3 $accent1',
        $focus: ''
    }
});
function $0a1f391ff5b244cb$var$Button({ onClick: onClick, settings: settings, label: label }) {
    const store = (0, $831d64f343d74c7e$export$a9c23c6ac3fc3eca)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$StyledButton, {
        disabled: settings.disabled,
        onClick: ()=>onClick(store.get)
    }, label));
}
const $0a1f391ff5b244cb$var$StyledButtonGroup = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flex: '',
    justifyContent: 'flex-end',
    gap: '$colGap'
});
const $0a1f391ff5b244cb$var$StyledButtonGroupButton = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('button', {
    $reset: '',
    cursor: 'pointer',
    borderRadius: '$xs',
    '&:hover': {
        backgroundColor: '$elevation3'
    }
});
const $0a1f391ff5b244cb$var$getOpts = ({ label: _label, opts: _opts })=>{
    let label = typeof _label === 'string' ? _label.trim() === '' ? null : _label : _label;
    let opts = _opts;
    if (typeof _opts.opts === 'object') {
        if (opts.label !== undefined) label = _opts.label;
        opts = _opts.opts;
    }
    return {
        label: label,
        opts: opts
    };
};
function $0a1f391ff5b244cb$var$ButtonGroup(props) {
    const { label: label, opts: opts } = $0a1f391ff5b244cb$var$getOpts(props);
    const store = (0, $831d64f343d74c7e$export$a9c23c6ac3fc3eca)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: !!label
    }, label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), null, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$StyledButtonGroup, null, Object.entries(opts).map(([label, onClick])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$StyledButtonGroupButton, {
            key: label,
            onClick: ()=>onClick(store.get)
        }, label))));
}
const $0a1f391ff5b244cb$var$Canvas = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('canvas', {
    height: '$monitorHeight',
    width: '100%',
    display: 'block',
    borderRadius: '$sm'
});
const $0a1f391ff5b244cb$var$POINTS = 100;
function $0a1f391ff5b244cb$var$push(arr, val) {
    arr.push(val);
    if (arr.length > $0a1f391ff5b244cb$var$POINTS) arr.shift();
}
const $0a1f391ff5b244cb$var$MonitorCanvas = (0, $acw62.forwardRef)(function({ initialValue: initialValue }, ref) {
    const accentColor = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('colors', 'highlight3');
    const backgroundColor = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('colors', 'elevation2');
    const fillColor = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('colors', 'highlight1');
    const [gradientTop, gradientBottom] = (0, $acw62.useMemo)(()=>{
        return [
            (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(fillColor).alpha(0.4).toRgbString(),
            (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(fillColor).alpha(0.1).toRgbString()
        ];
    }, [
        fillColor
    ]);
    const points = (0, $acw62.useRef)([
        initialValue
    ]);
    const min = (0, $acw62.useRef)(initialValue);
    const max = (0, $acw62.useRef)(initialValue);
    const raf = (0, $acw62.useRef)();
    const drawPlot = (0, $acw62.useCallback)((_canvas, _ctx)=>{
        if (!_canvas) return;
        const { width: width, height: height } = _canvas;
        const path = new Path2D();
        const interval = width / $0a1f391ff5b244cb$var$POINTS;
        const verticalPadding = height * 0.05;
        for(let i = 0; i < points.current.length; i++){
            const p = (0, $831d64f343d74c7e$export$43caf9889c228507)(points.current[i], min.current, max.current);
            const x = interval * i;
            const y = height - p * (height - verticalPadding * 2) - verticalPadding;
            path.lineTo(x, y);
        }
        _ctx.clearRect(0, 0, width, height);
        const gradientPath = new Path2D(path);
        gradientPath.lineTo(interval * (points.current.length + 1), height);
        gradientPath.lineTo(0, height);
        gradientPath.lineTo(0, 0);
        const gradient = _ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0.0, gradientTop);
        gradient.addColorStop(1.0, gradientBottom);
        _ctx.fillStyle = gradient;
        _ctx.fill(gradientPath);
        _ctx.strokeStyle = backgroundColor;
        _ctx.lineJoin = 'round';
        _ctx.lineWidth = 14;
        _ctx.stroke(path);
        _ctx.strokeStyle = accentColor;
        _ctx.lineWidth = 2;
        _ctx.stroke(path);
    }, [
        accentColor,
        backgroundColor,
        gradientTop,
        gradientBottom
    ]);
    const [canvas, ctx] = (0, $831d64f343d74c7e$export$d66501df72047452)(drawPlot);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            frame: (val)=>{
                if (min.current === undefined || val < min.current) min.current = val;
                if (max.current === undefined || val > max.current) max.current = val;
                $0a1f391ff5b244cb$var$push(points.current, val);
                raf.current = requestAnimationFrame(()=>drawPlot(canvas.current, ctx.current));
            }
        }), [
        canvas,
        ctx,
        drawPlot
    ]);
    (0, $acw62.useEffect)(()=>()=>cancelAnimationFrame(raf.current), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Canvas, {
        ref: canvas
    });
});
const $0a1f391ff5b244cb$var$parse = (val)=>Number.isFinite(val) ? val.toPrecision(2) : val.toString();
const $0a1f391ff5b244cb$var$MonitorLog = (0, $acw62.forwardRef)(function({ initialValue: initialValue }, ref) {
    const [val, set] = (0, $acw62.useState)($0a1f391ff5b244cb$var$parse(initialValue));
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            frame: (v)=>set($0a1f391ff5b244cb$var$parse(v))
        }), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, val);
});
function $0a1f391ff5b244cb$var$getValue(o) {
    return typeof o === 'function' ? o() : o.current;
}
function $0a1f391ff5b244cb$var$Monitor({ label: label, objectOrFn: objectOrFn, settings: settings }) {
    const ref = (0, $acw62.useRef)();
    const initialValue = (0, $acw62.useRef)($0a1f391ff5b244cb$var$getValue(objectOrFn));
    (0, $acw62.useEffect)(()=>{
        const timeout = window.setInterval(()=>{
            var _ref$current;
            if (document.hidden) return;
            (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.frame($0a1f391ff5b244cb$var$getValue(objectOrFn));
        }, settings.interval);
        return ()=>window.clearInterval(timeout);
    }, [
        objectOrFn,
        settings.interval
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$db202ddc8be9136), {
        input: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$61196ced6d74a310), {
        align: "top"
    }, label), settings.graph ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$MonitorCanvas, {
        ref: ref,
        initialValue: initialValue.current
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$MonitorLog, {
        ref: ref,
        initialValue: initialValue.current
    }));
}
const $0a1f391ff5b244cb$var$_excluded$3 = [
    "type",
    "label",
    "key"
];
const $0a1f391ff5b244cb$var$specialComponents = {
    [(0, $831d64f343d74c7e$export$90a7f3efeed30595).BUTTON]: $0a1f391ff5b244cb$var$Button,
    [(0, $831d64f343d74c7e$export$90a7f3efeed30595).BUTTON_GROUP]: $0a1f391ff5b244cb$var$ButtonGroup,
    [(0, $831d64f343d74c7e$export$90a7f3efeed30595).MONITOR]: $0a1f391ff5b244cb$var$Monitor
};
const $0a1f391ff5b244cb$var$Control = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ path: path })=>{
    const [input, { set: set, setSettings: setSettings, disable: disable, storeId: storeId, emitOnEditStart: emitOnEditStart, emitOnEditEnd: emitOnEditEnd }] = (0, $831d64f343d74c7e$export$2329c99376c9d0a4)(path);
    if (!input) return null;
    const { type: type, label: label, key: key } = input, inputProps = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(input, $0a1f391ff5b244cb$var$_excluded$3);
    if (type in (0, $831d64f343d74c7e$export$90a7f3efeed30595)) {
        const SpecialInputForType = $0a1f391ff5b244cb$var$specialComponents[type];
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SpecialInputForType, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
            label: label,
            path: path
        }, inputProps));
    }
    if (!(type in (0, $831d64f343d74c7e$export$ef35774e6d314e91))) {
        (0, $831d64f343d74c7e$export$7f8ddf7c7c20b3cd)((0, $831d64f343d74c7e$export$d141bba7fdc215a3).UNSUPPORTED_INPUT, type, path);
        return null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$ControlInput, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        key: storeId + path,
        type: type,
        label: label,
        storeId: storeId,
        path: path,
        valueKey: key,
        setValue: set,
        setSettings: setSettings,
        disable: disable,
        emitOnEditStart: emitOnEditStart,
        emitOnEditEnd: emitOnEditEnd
    }, inputProps));
});
function $0a1f391ff5b244cb$var$FolderTitle({ toggle: toggle, toggled: toggled, name: name }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$b4171a6734a65d42), {
        onClick: ()=>toggle()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$3466f893ebf79586), {
        toggled: toggled
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, name));
}
const $0a1f391ff5b244cb$var$Folder = ({ name: name, path: path, tree: tree })=>{
    const store = (0, $831d64f343d74c7e$export$a9c23c6ac3fc3eca)();
    const newPath = $0a1f391ff5b244cb$var$join(path, name);
    const { collapsed: collapsed, color: color } = store.getFolderSettings(newPath);
    const [toggled, setToggle] = (0, $acw62.useState)(!collapsed);
    const folderRef = (0, $acw62.useRef)(null);
    const widgetColor = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('colors', 'folderWidgetColor');
    const textColor = (0, $831d64f343d74c7e$export$4368d992c4eafac0)('colors', 'folderTextColor');
    (0, $acw62.useLayoutEffect)(()=>{
        folderRef.current.style.setProperty('--leva-colors-folderWidgetColor', color || widgetColor);
        folderRef.current.style.setProperty('--leva-colors-folderTextColor', color || textColor);
    }, [
        color,
        widgetColor,
        textColor
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$3722cfe417b6ed86), {
        ref: folderRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$FolderTitle, {
        name: name,
        toggled: toggled,
        toggle: ()=>setToggle((t)=>!t)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$TreeWrapper, {
        parent: newPath,
        tree: tree,
        toggled: toggled
    }));
};
const $0a1f391ff5b244cb$var$TreeWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ isRoot: _isRoot = false, fill: _fill = false, flat: _flat = false, parent: parent, tree: tree, toggled: toggled })=>{
    const { wrapperRef: wrapperRef, contentRef: contentRef } = $0a1f391ff5b244cb$var$useToggle(toggled);
    const store = (0, $831d64f343d74c7e$export$a9c23c6ac3fc3eca)();
    const getOrder = ([key, o])=>{
        var _store$getInput;
        const order = $0a1f391ff5b244cb$var$isInput(o) ? (_store$getInput = store.getInput(o.path)) === null || _store$getInput === void 0 ? void 0 : _store$getInput.order : store.getFolderSettings($0a1f391ff5b244cb$var$join(parent, key)).order;
        return order || 0;
    };
    const entries = Object.entries(tree).sort((a, b)=>getOrder(a) - getOrder(b));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$3a1a48c8f6ef640e), {
        ref: wrapperRef,
        isRoot: _isRoot,
        fill: _fill,
        flat: _flat
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$a07804094c3ecf2d), {
        ref: contentRef,
        isRoot: _isRoot,
        toggled: toggled
    }, entries.map(([key, value])=>$0a1f391ff5b244cb$var$isInput(value) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Control, {
            key: value.path,
            valueKey: value.valueKey,
            path: value.path
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Folder, {
            key: key,
            name: key,
            path: parent,
            tree: value
        }))));
});
const $0a1f391ff5b244cb$var$StyledRoot = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    position: 'relative',
    fontFamily: '$mono',
    fontSize: '$root',
    color: '$rootText',
    backgroundColor: '$elevation1',
    variants: {
        fill: {
            false: {
                position: 'fixed',
                top: '10px',
                right: '10px',
                zIndex: 1000,
                width: '$rootWidth'
            },
            true: {
                position: 'relative',
                width: '100%'
            }
        },
        flat: {
            false: {
                borderRadius: '$lg',
                boxShadow: '$level1'
            }
        },
        oneLineLabels: {
            true: {
                [`${0, $831d64f343d74c7e$export$971d5caa766a69d7}`]: {
                    gridTemplateColumns: 'auto',
                    gridAutoColumns: 'minmax(max-content, 1fr)',
                    gridAutoRows: 'minmax($sizes$rowHeight), auto)',
                    rowGap: 0,
                    columnGap: 0,
                    marginTop: '$rowGap'
                }
            }
        },
        hideTitleBar: {
            true: {
                $$titleBarHeight: '0px'
            },
            false: {
                $$titleBarHeight: '$sizes$titleBarHeight'
            }
        }
    },
    '&,*,*:after,*:before': {
        boxSizing: 'border-box'
    },
    '*::selection': {
        backgroundColor: '$accent2'
    }
});
const $0a1f391ff5b244cb$var$iconWidth = 40;
const $0a1f391ff5b244cb$var$Icon = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('i', {
    $flexCenter: '',
    width: $0a1f391ff5b244cb$var$iconWidth,
    userSelect: 'none',
    cursor: 'pointer',
    '> svg': {
        fill: '$highlight1',
        transition: 'transform 350ms ease, fill 250ms ease'
    },
    '&:hover > svg': {
        fill: '$highlight3'
    },
    variants: {
        active: {
            true: {
                '> svg': {
                    fill: '$highlight2'
                }
            }
        }
    }
});
const $0a1f391ff5b244cb$var$StyledTitleWithFilter = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    height: '$titleBarHeight',
    variants: {
        mode: {
            drag: {
                cursor: 'grab'
            }
        }
    }
});
const $0a1f391ff5b244cb$var$FilterWrapper = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    $flex: '',
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    transition: 'height 250ms ease',
    color: '$highlight3',
    paddingLeft: '$md',
    [`> ${$0a1f391ff5b244cb$var$Icon}`]: {
        height: 30
    },
    variants: {
        toggled: {
            true: {
                height: 30
            },
            false: {
                height: 0
            }
        }
    }
});
const $0a1f391ff5b244cb$var$StyledFilterInput = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('input', {
    $reset: '',
    flex: 1,
    position: 'relative',
    height: 30,
    width: '100%',
    backgroundColor: 'transparent',
    fontSize: '10px',
    borderRadius: '$root',
    '&:focus': {},
    '&::placeholder': {
        color: '$highlight2'
    }
});
const $0a1f391ff5b244cb$var$TitleContainer = (0, $831d64f343d74c7e$export$2408f22a0fab9ae5)('div', {
    touchAction: 'none',
    $flexCenter: '',
    flex: 1,
    '> svg': {
        fill: '$highlight1'
    },
    color: '$highlight1',
    variants: {
        drag: {
            true: {
                $draggable: '',
                '> svg': {
                    transition: 'fill 250ms ease'
                },
                '&:hover': {
                    color: '$highlight3'
                },
                '&:hover > svg': {
                    fill: '$highlight3'
                }
            }
        },
        filterEnabled: {
            false: {
                paddingRight: $0a1f391ff5b244cb$var$iconWidth
            }
        }
    }
});
const $0a1f391ff5b244cb$var$FilterInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ setFilter: setFilter, toggle: toggle }, ref)=>{
    const [value, set] = (0, $acw62.useState)('');
    const debouncedOnChange = (0, $acw62.useMemo)(()=>(0, $831d64f343d74c7e$export$3a6d5c9ae78a2c08)(setFilter, 250), [
        setFilter
    ]);
    const clear = ()=>{
        setFilter('');
        set('');
    };
    const _onChange = (e)=>{
        const v = e.currentTarget.value;
        toggle(true);
        set(v);
    };
    (0, $acw62.useEffect)(()=>{
        debouncedOnChange(value);
    }, [
        value,
        debouncedOnChange
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$StyledFilterInput, {
        ref: ref,
        value: value,
        placeholder: "[Open filter with CMD+SHIFT+L]",
        onPointerDown: (e)=>e.stopPropagation(),
        onChange: _onChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Icon, {
        onClick: ()=>clear(),
        style: {
            visibility: value ? 'visible' : 'hidden'
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "14",
        width: "14",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
        clipRule: "evenodd"
    }))));
});
function $0a1f391ff5b244cb$var$TitleWithFilter({ setFilter: setFilter, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, toggle: toggle, toggled: toggled, title: title, drag: drag, filterEnabled: filterEnabled, from: from }) {
    const [filterShown, setShowFilter] = (0, $acw62.useState)(false);
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _inputRef$current, _inputRef$current2;
        if (filterShown) (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
        else (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
    }, [
        filterShown
    ]);
    const bind = (0, $831d64f343d74c7e$export$f1e1789686576879)(({ offset: [x, y], first: first, last: last })=>{
        onDrag({
            x: x,
            y: y
        });
        if (first) onDragStart({
            x: x,
            y: y
        });
        if (last) onDragEnd({
            x: x,
            y: y
        });
    }, {
        filterTaps: true,
        from: ({ offset: [x, y] })=>[
                (from === null || from === void 0 ? void 0 : from.x) || x,
                (from === null || from === void 0 ? void 0 : from.y) || y
            ]
    });
    (0, $acw62.useEffect)(()=>{
        const handleShortcut = (event)=>{
            if (event.key === 'L' && event.shiftKey && event.metaKey) setShowFilter((f)=>!f);
        };
        window.addEventListener('keydown', handleShortcut);
        return ()=>window.removeEventListener('keydown', handleShortcut);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$StyledTitleWithFilter, {
        mode: drag ? 'drag' : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Icon, {
        active: !toggled,
        onClick: ()=>toggle()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$3466f893ebf79586), {
        toggled: toggled,
        width: 12,
        height: 8
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$TitleContainer, (0, $831d64f343d74c7e$export$2d1720544b23b823)({}, drag ? bind() : {}, {
        drag: drag,
        filterEnabled: filterEnabled
    }), title === undefined && drag ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "20",
        height: "10",
        viewBox: "0 0 28 14",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "2",
        cy: "2",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "14",
        cy: "2",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "26",
        cy: "2",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "2",
        cy: "12",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "14",
        cy: "12",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "26",
        cy: "12",
        r: "2"
    })) : title), filterEnabled && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$Icon, {
        active: filterShown,
        onClick: ()=>setShowFilter((f)=>!f)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "20",
        viewBox: "0 0 20 20"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 9a2 2 0 114 0 2 2 0 01-4 0z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z",
        clipRule: "evenodd"
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$FilterWrapper, {
        toggled: filterShown
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$FilterInput, {
        ref: inputRef,
        setFilter: setFilter,
        toggle: toggle
    })));
}
const $0a1f391ff5b244cb$var$_excluded$2 = [
    "store",
    "hidden",
    "theme",
    "collapsed"
];
function $0a1f391ff5b244cb$var$LevaRoot(_ref) {
    let { store: store, hidden: hidden = false, theme: theme, collapsed: collapsed = false } = _ref, props = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(_ref, $0a1f391ff5b244cb$var$_excluded$2);
    const themeContext = $0a1f391ff5b244cb$var$useDeepMemo(()=>(0, $831d64f343d74c7e$export$dc98b0b04f4c7758)(theme), [
        theme
    ]);
    const [toggled, setToggle] = (0, $acw62.useState)(!collapsed);
    const computedToggled = typeof collapsed === 'object' ? !collapsed.collapsed : toggled;
    const computedSetToggle = (0, $acw62.useMemo)(()=>{
        if (typeof collapsed === 'object') return (value)=>{
            if (typeof value === 'function') collapsed.onChange(!value(!collapsed.collapsed));
            else collapsed.onChange(!value);
        };
        return setToggle;
    }, [
        collapsed
    ]);
    if (!store || hidden) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$3d8c2f653ac9d0b9).Provider, {
        value: themeContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$LevaCore, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        store: store
    }, props, {
        toggled: computedToggled,
        setToggle: computedSetToggle,
        rootClass: themeContext.className
    })));
}
const $0a1f391ff5b244cb$var$LevaCore = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ store: store, rootClass: rootClass, fill: _fill = false, flat: _flat = false, neverHide: _neverHide = false, oneLineLabels: _oneLineLabels = false, titleBar: _titleBar = {
    title: undefined,
    drag: true,
    filter: true,
    position: undefined,
    onDrag: undefined,
    onDragStart: undefined,
    onDragEnd: undefined
}, hideCopyButton: _hideCopyButton = false, toggled: toggled, setToggle: setToggle })=>{
    var _titleBar$drag, _titleBar$filter;
    const paths = $0a1f391ff5b244cb$var$useVisiblePaths(store);
    const [filter, setFilter] = (0, $acw62.useState)('');
    const tree = (0, $acw62.useMemo)(()=>$0a1f391ff5b244cb$var$buildTree(paths, filter), [
        paths,
        filter
    ]);
    const [rootRef, set] = (0, $831d64f343d74c7e$export$8b22cf2602fb60ce)();
    const shouldShow = _neverHide || paths.length > 0;
    const title = typeof _titleBar === 'object' ? _titleBar.title || undefined : undefined;
    const drag = typeof _titleBar === 'object' ? (_titleBar$drag = _titleBar.drag) !== null && _titleBar$drag !== void 0 ? _titleBar$drag : true : true;
    const filterEnabled = typeof _titleBar === 'object' ? (_titleBar$filter = _titleBar.filter) !== null && _titleBar$filter !== void 0 ? _titleBar$filter : true : true;
    const position = typeof _titleBar === 'object' ? _titleBar.position || undefined : undefined;
    const onDrag = typeof _titleBar === 'object' ? _titleBar.onDrag || undefined : undefined;
    const onDragStart = typeof _titleBar === 'object' ? _titleBar.onDragStart || undefined : undefined;
    const onDragEnd = typeof _titleBar === 'object' ? _titleBar.onDragEnd || undefined : undefined;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        set({
            x: position === null || position === void 0 ? void 0 : position.x,
            y: position === null || position === void 0 ? void 0 : position.y
        });
    }, [
        position,
        set
    ]);
    (0, $831d64f343d74c7e$export$71cec2538cb2c617)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$78acf4525d8a74c4).Provider, {
        value: {
            hideCopyButton: _hideCopyButton
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$StyledRoot, {
        ref: rootRef,
        className: rootClass,
        fill: _fill,
        flat: _flat,
        oneLineLabels: _oneLineLabels,
        hideTitleBar: !_titleBar,
        style: {
            display: shouldShow ? 'block' : 'none'
        }
    }, _titleBar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$TitleWithFilter, {
        onDrag: (point)=>{
            set(point);
            onDrag === null || onDrag === void 0 || onDrag(point);
        },
        onDragStart: (point)=>onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(point),
        onDragEnd: (point)=>onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(point),
        setFilter: setFilter,
        toggle: (flag)=>setToggle((t)=>flag !== null && flag !== void 0 ? flag : !t),
        toggled: toggled,
        title: title,
        drag: drag,
        filterEnabled: filterEnabled,
        from: position
    }), shouldShow && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $831d64f343d74c7e$export$8743009a87fcb00f).Provider, {
        value: store
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$TreeWrapper, {
        isRoot: true,
        fill: _fill,
        flat: _flat,
        tree: tree,
        toggled: toggled
    }))));
});
const $0a1f391ff5b244cb$var$_excluded$1 = [
    "isRoot"
];
let $0a1f391ff5b244cb$var$rootInitialized = false;
let $0a1f391ff5b244cb$var$rootEl = null;
function $0a1f391ff5b244cb$export$f9be4b97f6760c12(_ref) {
    let { isRoot: isRoot = false } = _ref, props = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(_ref, $0a1f391ff5b244cb$var$_excluded$1);
    (0, $acw62.useEffect)(()=>{
        $0a1f391ff5b244cb$var$rootInitialized = true;
        if (!isRoot && $0a1f391ff5b244cb$var$rootEl) {
            $0a1f391ff5b244cb$var$rootEl.remove();
            $0a1f391ff5b244cb$var$rootEl = null;
        }
        return ()=>{
            if (!isRoot) $0a1f391ff5b244cb$var$rootInitialized = false;
        };
    }, [
        isRoot
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$LevaRoot, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        store: $0a1f391ff5b244cb$export$5db3dddc38dade5b
    }, props));
}
function $0a1f391ff5b244cb$var$useRenderRoot(isGlobalPanel) {
    (0, $acw62.useEffect)(()=>{
        if (isGlobalPanel && !$0a1f391ff5b244cb$var$rootInitialized) {
            if (!$0a1f391ff5b244cb$var$rootEl) {
                $0a1f391ff5b244cb$var$rootEl = document.getElementById('leva__root') || Object.assign(document.createElement('div'), {
                    id: 'leva__root'
                });
                if (document.body) {
                    document.body.appendChild($0a1f391ff5b244cb$var$rootEl);
                    (0, $7e96a608cb33bf79$export$882461b6382ed46c)($0a1f391ff5b244cb$var$rootEl).render((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$export$f9be4b97f6760c12, {
                        isRoot: true
                    }));
                }
            }
            $0a1f391ff5b244cb$var$rootInitialized = true;
        }
    }, [
        isGlobalPanel
    ]);
}
const $0a1f391ff5b244cb$var$_excluded = [
    "store"
];
function $0a1f391ff5b244cb$export$848e2f358cb758ab(_ref) {
    let { store: store } = _ref, props = (0, $831d64f343d74c7e$export$23f2a1d2818174ef)(_ref, $0a1f391ff5b244cb$var$_excluded);
    const parentStore = (0, $831d64f343d74c7e$export$a9c23c6ac3fc3eca)();
    const _store = store === undefined ? parentStore : store;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0a1f391ff5b244cb$var$LevaRoot, (0, $831d64f343d74c7e$export$2d1720544b23b823)({
        store: _store
    }, props));
}
function $0a1f391ff5b244cb$var$parseArgs(schemaOrFolderName, settingsOrDepsOrSchema, depsOrSettingsOrFolderSettings, depsOrSettings, depsOrUndefined) {
    let schema;
    let folderName = undefined;
    let folderSettings;
    let hookSettings;
    let deps;
    if (typeof schemaOrFolderName === 'string') {
        folderName = schemaOrFolderName;
        schema = settingsOrDepsOrSchema;
        if (Array.isArray(depsOrSettingsOrFolderSettings)) deps = depsOrSettingsOrFolderSettings;
        else if (depsOrSettingsOrFolderSettings) {
            if ('store' in depsOrSettingsOrFolderSettings) {
                hookSettings = depsOrSettingsOrFolderSettings;
                deps = depsOrSettings;
            } else {
                folderSettings = depsOrSettingsOrFolderSettings;
                if (Array.isArray(depsOrSettings)) deps = depsOrSettings;
                else {
                    hookSettings = depsOrSettings;
                    deps = depsOrUndefined;
                }
            }
        }
    } else {
        schema = schemaOrFolderName;
        if (Array.isArray(settingsOrDepsOrSchema)) deps = settingsOrDepsOrSchema;
        else {
            hookSettings = settingsOrDepsOrSchema;
            deps = depsOrSettingsOrFolderSettings;
        }
    }
    return {
        schema: schema,
        folderName: folderName,
        folderSettings: folderSettings,
        hookSettings: hookSettings,
        deps: deps || []
    };
}
function $0a1f391ff5b244cb$export$8a75c83865bcf9dd(schemaOrFolderName, settingsOrDepsOrSchema, depsOrSettingsOrFolderSettings, depsOrSettings, depsOrUndefined) {
    const { folderName: folderName, schema: schema, folderSettings: folderSettings, hookSettings: hookSettings, deps: deps } = $0a1f391ff5b244cb$var$parseArgs(schemaOrFolderName, settingsOrDepsOrSchema, depsOrSettingsOrFolderSettings, depsOrSettings, depsOrUndefined);
    const schemaIsFunction = typeof schema === 'function';
    const depsChanged = (0, $acw62.useRef)(false);
    const firstRender = (0, $acw62.useRef)(true);
    const _schema = $0a1f391ff5b244cb$var$useDeepMemo(()=>{
        depsChanged.current = true;
        const s = typeof schema === 'function' ? schema() : schema;
        return folderName ? {
            [folderName]: $0a1f391ff5b244cb$export$e00584a723d0ee75(s, folderSettings)
        } : s;
    }, deps);
    const isGlobalPanel = !(hookSettings !== null && hookSettings !== void 0 && hookSettings.store);
    $0a1f391ff5b244cb$var$useRenderRoot(isGlobalPanel);
    const [store] = (0, $acw62.useState)(()=>(hookSettings === null || hookSettings === void 0 ? void 0 : hookSettings.store) || $0a1f391ff5b244cb$export$5db3dddc38dade5b);
    const [initialData, mappedPaths] = (0, $acw62.useMemo)(()=>store.getDataFromSchema(_schema), [
        store,
        _schema
    ]);
    const [allPaths, renderPaths, onChangePaths, onEditStartPaths, onEditEndPaths] = (0, $acw62.useMemo)(()=>{
        const allPaths = [];
        const renderPaths = [];
        const onChangePaths = {};
        const onEditStartPaths = {};
        const onEditEndPaths = {};
        Object.values(mappedPaths).forEach(({ path: path, onChange: onChange, onEditStart: onEditStart, onEditEnd: onEditEnd, transient: transient })=>{
            allPaths.push(path);
            if (!!onChange) {
                onChangePaths[path] = onChange;
                if (!transient) renderPaths.push(path);
            } else renderPaths.push(path);
            if (onEditStart) onEditStartPaths[path] = onEditStart;
            if (onEditEnd) onEditEndPaths[path] = onEditEnd;
        });
        return [
            allPaths,
            renderPaths,
            onChangePaths,
            onEditStartPaths,
            onEditEndPaths
        ];
    }, [
        mappedPaths
    ]);
    const paths = (0, $acw62.useMemo)(()=>store.orderPaths(allPaths), [
        allPaths,
        store
    ]);
    const values = $0a1f391ff5b244cb$var$useValuesForPath(store, renderPaths, initialData);
    const set = (0, $acw62.useCallback)((values)=>{
        const _values = Object.entries(values).reduce((acc, [p, v])=>Object.assign(acc, {
                [mappedPaths[p].path]: v
            }), {});
        store.set(_values, false);
    }, [
        store,
        mappedPaths
    ]);
    const get = (0, $acw62.useCallback)((path)=>store.get(mappedPaths[path].path), [
        store,
        mappedPaths
    ]);
    (0, $acw62.useEffect)(()=>{
        const shouldOverrideSettings = !firstRender.current && depsChanged.current;
        store.addData(initialData, shouldOverrideSettings);
        firstRender.current = false;
        depsChanged.current = false;
        return ()=>store.disposePaths(paths);
    }, [
        store,
        paths,
        initialData
    ]);
    (0, $acw62.useEffect)(()=>{
        const unsubscriptions = [];
        Object.entries(onChangePaths).forEach(([path, onChange])=>{
            onChange(store.get(path), path, (0, $831d64f343d74c7e$export$71511d61b312f219)({
                initial: true,
                get: store.get
            }, store.getInput(path)));
            const unsub = store.useStore.subscribe((s)=>{
                const input = s.data[path];
                const value = input.disabled ? undefined : input.value;
                return [
                    value,
                    input
                ];
            }, ([value, input])=>onChange(value, path, (0, $831d64f343d74c7e$export$71511d61b312f219)({
                    initial: false,
                    get: store.get
                }, input)), {
                equalityFn: (0, (/*@__PURE__*/$parcel$interopDefault($af540f293314ba66$exports)))
            });
            unsubscriptions.push(unsub);
        });
        return ()=>unsubscriptions.forEach((unsub)=>unsub());
    }, [
        store,
        onChangePaths
    ]);
    (0, $acw62.useEffect)(()=>{
        const unsubscriptions = [];
        Object.entries(onEditStartPaths).forEach(([path, onEditStart])=>unsubscriptions.push(store.subscribeToEditStart(path, onEditStart)));
        Object.entries(onEditEndPaths).forEach(([path, onEditEnd])=>unsubscriptions.push(store.subscribeToEditEnd(path, onEditEnd)));
        return ()=>unsubscriptions.forEach((unsub)=>unsub());
    }, [
        onEditStartPaths,
        onEditEndPaths,
        store
    ]);
    if (schemaIsFunction) return [
        values,
        set,
        get
    ];
    return values;
}
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).SELECT, (0, $831d64f343d74c7e$export$ce26c07117d59d6a));
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).IMAGE, $0a1f391ff5b244cb$var$image);
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).NUMBER, (0, $831d64f343d74c7e$export$6559d589eb85fbb6));
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).COLOR, $0a1f391ff5b244cb$var$color);
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).STRING, (0, $831d64f343d74c7e$export$efca4cbe5dd06740));
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).BOOLEAN, (0, $831d64f343d74c7e$export$a8550f7dbe79f93a));
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).INTERVAL, $0a1f391ff5b244cb$var$interval);
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).VECTOR3D, $0a1f391ff5b244cb$var$vector3d);
(0, $831d64f343d74c7e$export$34aec0b863436764)((0, $831d64f343d74c7e$export$3c2fa207a37baaea).VECTOR2D, $0a1f391ff5b244cb$var$vector2d);



(0, $2ec6beadbaf9c031$export$f1e1789686576879)({
    MeshLineGeometry: $b7a334047b5a7de5$export$feb23cfe052cbcf3,
    MeshLineMaterial: $b7a334047b5a7de5$export$d8abe26b06d5f5e4
});
(0, $d88227174eee7553$export$cf1b4e938a4da41b).preload('https://assets.vercel.com/image/upload/contentful/image/e5382hct74si/5huRVDzcoDwnbgrKUo1Lzs/53b6dd7d6b4ffcdbd338fa60265949e1/tag.glb');
var $a70b5a34635ca12a$exports = {};
$a70b5a34635ca12a$exports = import.meta.resolve("7QOUk");


(0, $5262a5eb989d2b7b$export$5dd4f4a1dff269b2).preload(new URL($a70b5a34635ca12a$exports).href);
(0, $5262a5eb989d2b7b$export$5dd4f4a1dff269b2).preload('/joker.jpg');
function $39e04050ac32e6dc$export$2e2bcd8739ae039() {
    const { debug: debug } = (0, $0a1f391ff5b244cb$export$8a75c83865bcf9dd)({
        debug: false
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f24fded2ba3df096$export$8d01c972ee8b14a9), {
            camera: {
                position: [
                    0,
                    0,
                    13
                ],
                fov: 25
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ambientLight", {
                    intensity: Math.PI
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$2f09efa5b67124a7), {
                    debug: debug,
                    interpolate: true,
                    gravity: [
                        0,
                        -40,
                        0
                    ],
                    timeStep: 1 / 60,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e04050ac32e6dc$var$Band, {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $78b36dbdd2fd5ec5$export$7dc6752a22ab011a), {
                    background: true,
                    blur: 0.75,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("color", {
                            attach: "background",
                            args: [
                                'black'
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3bae46eafcab220$export$9ae1655cef674212), {
                            intensity: 2,
                            color: "white",
                            position: [
                                0,
                                -1,
                                5
                            ],
                            rotation: [
                                0,
                                0,
                                Math.PI / 3
                            ],
                            scale: [
                                100,
                                0.1,
                                1
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3bae46eafcab220$export$9ae1655cef674212), {
                            intensity: 3,
                            color: "white",
                            position: [
                                -1,
                                -1,
                                1
                            ],
                            rotation: [
                                0,
                                0,
                                Math.PI / 3
                            ],
                            scale: [
                                100,
                                0.1,
                                1
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3bae46eafcab220$export$9ae1655cef674212), {
                            intensity: 3,
                            color: "white",
                            position: [
                                1,
                                1,
                                1
                            ],
                            rotation: [
                                0,
                                0,
                                Math.PI / 3
                            ],
                            scale: [
                                100,
                                0.1,
                                1
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3bae46eafcab220$export$9ae1655cef674212), {
                            intensity: 10,
                            color: "white",
                            position: [
                                -10,
                                0,
                                14
                            ],
                            rotation: [
                                0,
                                Math.PI / 2,
                                Math.PI / 3
                            ],
                            scale: [
                                100,
                                10,
                                1
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1bbf7428bce323b3$export$5f1af8db9871e1d6), {
                    position: [
                        0,
                        0,
                        -3
                    ],
                    fontSize: 2.5,
                    color: "rgb(255, 0, 0)",
                    anchorX: "center",
                    anchorY: "middle",
                    outlineWidth: 0.05,
                    outlineColor: "black",
                    fontfamily: "/Orbitron/Orbitron-VariableFont_wght.ttf",
                    fontWeight: 2000,
                    letterSpacing: -0.1,
                    children: "LOWDEV"
                })
            ]
        })
    });
}

var $ec0665e6195b113c$exports = {};
$ec0665e6195b113c$exports = import.meta.resolve("2tZcK");


function $39e04050ac32e6dc$var$Band({ maxSpeed: maxSpeed = 50, minSpeed: minSpeed = 10 }) {
    const band = (0, $acw62.useRef)(), fixed = (0, $acw62.useRef)(), j1 = (0, $acw62.useRef)(), j2 = (0, $acw62.useRef)(), j3 = (0, $acw62.useRef)(), card = (0, $acw62.useRef)() // prettier-ignore
    ;
    const vec = new $d5b33d7c30034067$export$64b5c384219d3699(), ang = new $d5b33d7c30034067$export$64b5c384219d3699(), rot = new $d5b33d7c30034067$export$64b5c384219d3699(), dir = new $d5b33d7c30034067$export$64b5c384219d3699() // prettier-ignore
    ;
    const segmentProps = {
        type: 'dynamic',
        canSleep: true,
        colliders: false,
        angularDamping: 2,
        linearDamping: 2
    };
    const { nodes: nodes, materials: materials } = (0, $d88227174eee7553$export$cf1b4e938a4da41b)('https://assets.vercel.com/image/upload/contentful/image/e5382hct74si/5huRVDzcoDwnbgrKUo1Lzs/53b6dd7d6b4ffcdbd338fa60265949e1/tag.glb');
    const texture = (0, $5262a5eb989d2b7b$export$5dd4f4a1dff269b2)(new URL($a70b5a34635ca12a$exports).href);
    const cardImage = (0, $5262a5eb989d2b7b$export$5dd4f4a1dff269b2)(new URL($ec0665e6195b113c$exports).href);
    cardImage.flipY = false;
    cardImage.colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
    cardImage.anisotropy = 16;
    const { width: width, height: height } = (0, $2ec6beadbaf9c031$export$ebd11618f299a286)((state)=>state.size);
    const [curve] = (0, $acw62.useState)(()=>new $d5b33d7c30034067$export$b9146b27c24b744c([
            new $d5b33d7c30034067$export$64b5c384219d3699(),
            new $d5b33d7c30034067$export$64b5c384219d3699(),
            new $d5b33d7c30034067$export$64b5c384219d3699(),
            new $d5b33d7c30034067$export$64b5c384219d3699()
        ]));
    const [dragged, drag] = (0, $acw62.useState)(false);
    const [hovered, hover] = (0, $acw62.useState)(false);
    (0, $4708f0499e113eb5$export$a7f267cdf91e2436)(fixed, j1, [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        1
    ]) // prettier-ignore
    ;
    (0, $4708f0499e113eb5$export$a7f267cdf91e2436)(j1, j2, [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        1
    ]) // prettier-ignore
    ;
    (0, $4708f0499e113eb5$export$a7f267cdf91e2436)(j2, j3, [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        1
    ]) // prettier-ignore
    ;
    (0, $4708f0499e113eb5$export$c0fe3fee8fd7c4a)(j3, card, [
        [
            0,
            0,
            0
        ],
        [
            0,
            1.45,
            0
        ]
    ]) // prettier-ignore
    ;
    (0, $acw62.useEffect)(()=>{
        if (hovered) {
            document.body.style.cursor = dragged ? 'grabbing' : 'grab';
            return ()=>void (document.body.style.cursor = 'auto');
        }
    }, [
        hovered,
        dragged
    ]);
    (0, $2ec6beadbaf9c031$export$e7094788287c5e9b)((state, delta)=>{
        if (dragged) {
            vec.set(state.pointer.x, state.pointer.y, 0.5).unproject(state.camera);
            dir.copy(vec).sub(state.camera.position).normalize();
            vec.add(dir.multiplyScalar(state.camera.position.length()));
            [
                card,
                j1,
                j2,
                j3,
                fixed
            ].forEach((ref)=>ref.current?.wakeUp());
            card.current?.setNextKinematicTranslation({
                x: vec.x - dragged.x,
                y: vec.y - dragged.y,
                z: vec.z - dragged.z
            });
        }
        if (fixed.current) {
            [
                j1,
                j2
            ].forEach((ref)=>{
                if (!ref.current.lerped) ref.current.lerped = new $d5b33d7c30034067$export$64b5c384219d3699().copy(ref.current.translation());
                const clampedDistance = Math.max(0.1, Math.min(1, ref.current.lerped.distanceTo(ref.current.translation())));
                ref.current.lerped.lerp(ref.current.translation(), delta * (minSpeed + clampedDistance * (maxSpeed - minSpeed)));
            });
            // Calculate catmul curve
            curve.points[0].copy(j3.current.translation());
            curve.points[1].copy(j2.current.lerped);
            curve.points[2].copy(j1.current.lerped);
            curve.points[3].copy(fixed.current.translation());
            band.current.geometry.setPoints(curve.getPoints(32));
            // Tilt it back towards the screen
            ang.copy(card.current.angvel());
            rot.copy(card.current.rotation());
            card.current.setAngvel({
                x: ang.x,
                y: ang.y - rot.y * 0.25,
                z: ang.z
            });
        }
    });
    curve.curveType = 'chordal';
    texture.wrapS = texture.wrapT = $d5b33d7c30034067$export$533346c8e8dac0f5;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("group", {
                position: [
                    0,
                    4,
                    0
                ],
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$41c0a739a32ac4d), {
                        ref: fixed,
                        ...segmentProps,
                        type: "fixed"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$41c0a739a32ac4d), {
                        position: [
                            0.5,
                            0,
                            0
                        ],
                        ref: j1,
                        ...segmentProps,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$4e29496cd9696853), {
                            args: [
                                0.1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$41c0a739a32ac4d), {
                        position: [
                            1,
                            0,
                            0
                        ],
                        ref: j2,
                        ...segmentProps,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$4e29496cd9696853), {
                            args: [
                                0.1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$41c0a739a32ac4d), {
                        position: [
                            1.5,
                            0,
                            0
                        ],
                        ref: j3,
                        ...segmentProps,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$4e29496cd9696853), {
                            args: [
                                0.1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4708f0499e113eb5$export$41c0a739a32ac4d), {
                        position: [
                            2,
                            0,
                            0
                        ],
                        ref: card,
                        ...segmentProps,
                        type: dragged ? 'kinematicPosition' : 'dynamic',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4708f0499e113eb5$export$4f9cc99de105c9e), {
                                args: [
                                    0.8,
                                    1.125,
                                    0.01
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("group", {
                                scale: 2.25,
                                position: [
                                    0,
                                    -1.2,
                                    -0.05
                                ],
                                onPointerOver: ()=>hover(true),
                                onPointerOut: ()=>hover(false),
                                onPointerUp: (e)=>(e.target.releasePointerCapture(e.pointerId), drag(false)),
                                onPointerDown: (e)=>(e.target.setPointerCapture(e.pointerId), drag(new $d5b33d7c30034067$export$64b5c384219d3699().copy(e.point).sub(vec.copy(card.current.translation())))),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mesh", {
                                        geometry: nodes.card.geometry,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meshPhysicalMaterial", {
                                            map: cardImage,
                                            "map-anisotropy": 16,
                                            clearcoat: 1,
                                            clearcoatRoughness: 0.15,
                                            roughness: 0.3,
                                            metalness: 0.5
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mesh", {
                                        geometry: nodes.clip.geometry,
                                        material: materials.metal,
                                        "material-roughness": 0.3
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mesh", {
                                        geometry: nodes.clamp.geometry,
                                        material: materials.metal
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("mesh", {
                ref: band,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meshLineGeometry", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("meshLineMaterial", {
                        color: "white",
                        depthTest: false,
                        resolution: [
                            width,
                            height
                        ],
                        useMap: true,
                        map: texture,
                        repeat: [
                            -3,
                            1
                        ],
                        lineWidth: 1
                    })
                ]
            })
        ]
    });
}


(0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById('root')).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39e04050ac32e6dc$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=public.0fbc3a5a.js.map
